(function () {
  'use strict';

  var app = angular.module('app', ['ngMaterial', 'ngMessages', 'ui.router', 'ngSanitize', 'ngAnimate', 'angularMoment', 'ngMaterialDatePicker', 'chart.js', 'textAngular']);
})();


(function () {
  "use strict";

  angular.module("app").component("talentSearch", {
    controller: TalentSearchController,
    controllerAs: "vm",
    templateUrl: "app/components/sales/talentSearch/talentSearch.component.html"
  });

  function TalentSearchController($scope, dataService, $http, $timeout, $location, $mdToast, $mdDialog, $element, $q) {
    var vm = this;
    var highlightText;
    $scope.AS = {};
    $scope.AS.distanceUnit = "miles";
    vm.tokenData = JSON.parse(localStorage.getItem("tokenData"));
    $scope.addedSkill = [];
    $timeout(function () {
      $("body").css("overflow", "hidden");
    });
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $location.path("/");
      }
    };
    var heightCanBe = window.innerHeight - 70 + "px";
    $(".searchResults").css("height", heightCanBe);
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 70 + "px";
      $(".searchResults").css("height", heightCanBe);
    });
    $(".closeLeftBarClose").click(function () {
      $(".searchLeftSidebar").css("left", "-478px");
      $(this).css("visibility", "hidden");
      $(".closeLeftBarOpen").css("visibility", "visible");
    });
    $(".closeLeftBarOpen").click(function () {
      $(".searchLeftSidebar").css("left", "0px");
      $(this).css("visibility", "hidden");
      $(".closeLeftBarClose").css("visibility", "visible");
    });

    function initData($q) {
      return $q.all([dataService.GetDiceIds(), dataService.GetDiceHitCount({
        loginid: vm.tokenData.loginid
      }), dataService.getAccsTok()]);
    }
    $scope.DiceIds = [];
    dataService.newToken().then(function (response) {
      initData($q).then(function (response) {
        $scope.workAuthTypes = response[0].data;
        $scope.DiceIds = response[0].data;
        $scope.diceCount = response[1].data;
        $scope.topLoader = true;
        $scope.accsTok = response[2].data;
        $scope.profileSearchErr = false;
        $scope.profileData = [];
        $scope.advSearch = false;
        $scope.profilesready = false;
        $scope.sortBy = "relevancy";

        $(".backdrop i").click(function () {
          $scope.profileDetails = "";
          $("#profileDataContainerWrap").hide();
          $(".profileDataContainer").hide();
          $("body").removeClass("tops");
        });
      });
    }).catch(CatchError);

    $scope.addedSkill = [];
    $scope.addSkill = function (s, e) {
      $scope.addedSkill.push(s + " | " + e);
    };

    $scope.removeAddedSkill = function (index) {
      $scope.addedSkill.splice(index, 1);
    };
    $scope.basicSearchSubmit = function (searchtext, workPermits, sortBy, n) {
      $scope.profileData = [];
      $scope.topLoader = false;
      if (searchtext !== null) {
        highlightText = searchtext.q;
        var reqURL = "page=1&pageSize=20";
        if (searchtext !== undefined) {
          var keys = Object.keys(searchtext);
          for (var index = 0; index < keys.length; index++) {
            var element = keys[index];
            if (searchtext[element] !== (undefined || null || "")) {
              if (element !== "distanceUnit" && searchtext["location"] !== (undefined || null || "")) reqURL += "&" + element + "=" + searchtext[element];
            }
          }
        }
        if ($scope.addedSkill.length > 0) {
          var addSkill = $scope.addedSkill;
          if ($scope.addedSkill.length > 0) {
            reqURL += "&skillYearsOfExperience=" + JSON.stringify(addSkill);
          }
        }
        reqURL += "&sortBy=" + sortBy;
        if (workPermits) {
          var workPermitskeys = Object.keys(workPermits);
          if (workPermitskeys.length > 0) {
            var wPerms = [];
            if (workPermits[0] !== undefined && workPermits[0].USCitizenship) wPerms.push("US Citizenship");
            if (workPermits[1] !== undefined && workPermits[1].EmploymentAuthDocument) wPerms.push("Employment Auth Document");
            if (workPermits[2] !== undefined && workPermits[2].GreenCard) wPerms.push("Green Card");
            if (workPermits[3] !== undefined && workPermits[3].HaveH1) wPerms.push("Have H1");
            if (workPermits[4] !== undefined && workPermits[4].NeedH1) wPerms.push("Need H1");
            if (workPermits[5] !== undefined && workPermits[5].TnPermitHolder) wPerms.push("Tn Permit Holder");
            var parsedwPerms = JSON.stringify(wPerms).replace("[", "").replace("]", "").replace(/"/gi, "");
            reqURL += "&workPermit=" + parsedwPerms;
          }
        }
        reqURL += "&excludeRecruiters=true&excludeThirdParty=true&profileSource=resumes&searchType=Resume&sortByDirection=desc";
        var reqObj = {
          Token: $scope.accsTok.access_token,
          Skill: reqURL
        };
      } else {
        var searchedStr = JSON.parse(localStorage.getItem("diceSearchStr"));
        var splitData = searchedStr.Skill.split("&");
        splitData.splice(0, 1, "page=" + n).join("&");
        searchedStr.Skill = splitData.join("&");
        var reqObj = {
          Token: searchedStr.Token,
          Skill: searchedStr.Skill
        };
      }
      dataService.newToken().then(function (response) {
        dataService.GetDiceProfiles(reqObj).then(function (response) {
          localStorage.setItem("diceSearchStr", JSON.stringify(reqObj));
          $scope.topLoader = true;
          $scope.parsedData = JSON.parse(response.data);
          $scope.pages = Math.ceil($scope.parsedData.meta.totalCount / $scope.parsedData.meta.pageSize);

          for (var _index = 0; _index < $scope.parsedData.data.length; _index++) {
            var element = $scope.parsedData.data[_index];
            if ($scope.DiceIds.indexOf(element.id) !== -1) {
              element.isPulled = true;
            } else {
              element.isPulled = false;
            }
            $scope.profileData.push(element);
            // if(element.newonly){
            //   $scope.profileData.push(element);
            // }else{
            //   $scope.profileData.push(element);
            // }
          }
          $timeout(function () {
            $(".dicePagination ul li").click(function () {
              $(".dicePagination ul li").removeClass("active");
              $(this).addClass("active");
            });
            var instance = new Mark(document.querySelector(".profilesList"));
            instance.mark(highlightText);
          });
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.topLoader = false;
    $scope.pullDiceProf = function (id, ind) {
      $scope.profileDetails = [];
      $scope.topLoader = false;
      $("#profileDataContainerWrap").fadeToggle(200);
      $("html, body").animate({
        scrollTop: 0
      }, "fast");
      $timeout(function () {
        $(".profileDataContainer").show(200);
        $("body").addClass("tops");
      }, 150);
      var req = {
        Token: "Bearer " + $scope.accsTok.access_token,
        Id: id,
        RecruiterId: vm.tokenData.loginid,
        Email: vm.tokenData.email
      };
      dataService.newToken().then(function (response) {
        dataService.GetProfileById(req).then(function (response) {
          if (!response.data.Error) {
            $scope.topLoader = true;
            $scope.DiceIds.push(response.data.id);
            if (ind) $scope.profileData[ind].isPulled = true;
            $scope.profilesready = true;
            response.data.email = JSON.parse(response.data.email);
            response.data.resume = JSON.parse(response.data.resume);
            response.data.Phone = JSON.parse(response.data.Phone);
            $scope.profileDetails = response.data;
            if ($scope.profileDetails.resume.resumeData !== undefined && $scope.profileDetails.resume.resumeData !== null) {
              var ext = $scope.profileDetails.resume.filename.substring($scope.profileDetails.resume.filename.lastIndexOf('.') + 1);
              var base64 = $scope.profileDetails.resume.resumeData;
              var anchor = $("<a/>");
              anchor.attr({
                href: "data:application/octet-stream; base64," + base64,
                download: $scope.profileDetails.firstName + "_" + $scope.profileDetails.lastName + "@" + $scope.profileDetails.currentJobTitle + "(" + $scope.profileDetails.YearsOfExp + ")." + ext
              })[0].click();
            }
          } else {
            var toast = $mdToast.simple().content("Oops Something went wrong. Please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $scope.topLoader = true;
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.closeviewProf = function () {
      $scope.viewProf = false;
    };
    $scope.GetConslByDiceId = function (profile) {
      $scope.viewProf = true;
      console.log($scope.profileData);
      dataService.newToken().then(function (response) {
        dataService.GetConslByDiceId({
          DiceId: profile.id
        }).then(function (response) {
          $scope.profileDataViewed = profile;
          response.data.CurrentLocation = JSON.parse(response.data.CurrentLocation);
          response.data.Email = JSON.parse(response.data.Email);
          response.data.PhoneNumber = JSON.parse(response.data.PhoneNumber);
          response.data.WorkPermit = JSON.parse(response.data.WorkPermit);
          response.data.WorkPreferences = JSON.parse(response.data.WorkPreferences);
          response.data.Skillset = JSON.parse(response.data.Skillset);
          response.data.PrefLocation = JSON.parse(response.data.PrefLocation);
          response.data.SocailProfiles = JSON.parse(response.data.SocailProfiles);
          response.data.DesiredJobTitles = JSON.parse(response.data.DesiredJobTitles);
          response.data.Experience = JSON.parse(response.data.Experience);
          $scope.profileDetails = response.data;
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.DownloadViewedProfile = function (data) {
      var req = {
        conslid: data.ConslId,
        FileUrl: data.ResumeURL
      };
      var ext = data.ResumeURL.substring(data.ResumeURL.lastIndexOf('.') + 1);
      dataService.newToken().then(function (response) {
        dataService.diceProfileDownload(req).then(function (response) {
          var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
            return data + String.fromCharCode(byte);
          }, ''));
          var anchor = $('<a/>');
          anchor.attr({
            href: 'data:application/pdf; base64,' + base64,
            target: '_blank',
            download: data.ResumeURL
          })[0].click();
        });
      }).catch(CatchError);
    };
    $scope.downloadResume = function () {
      var base64 = $scope.profileDetails.resume.resumeData;
      var anchor = $("<a/>");
      anchor.attr({
        href: "data:application/octet-stream; base64," + base64,
        target: "_blank",
        download: $scope.profileDetails.firstName + "_" + $scope.profileDetails.lastName + "@" + $scope.profileDetails.currentJobTitle + "(" + $scope.profileDetails.YearsOfExp + ").pdf"
      })[0].click();
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('submissions', {
    controller: SubmissionDashboardController,
    controllerAs: 'vm',
    templateUrl: 'app/components/sales/submissionDashboard/submissionDashboard.component.html'
  });

  function SubmissionDashboardController($scope, dataService, $http, $timeout, $mdToast, $location, $mdDialog, $rootScope, $state) {
    var vm = this;
    vm.tokenData = angular.fromJson(localStorage.getItem('tokenData'));

    $scope.go = function (path) {
      $state.go(path);
    };
    $scope.deactivate = false;
    $scope.activate = false;
    vm.subs = [];

    if (vm.tokenData.newRole == 'Marketer') {
      getConsultants();
    } else {
      getAdmSubs();
    }
    // $scope.getConsultants = function () {
    //     getConsultants();
    // }
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    $scope.EditSubDashboard = function (data) {
      $mdDialog.show({
        controller: editSubController,
        templateUrl: 'app/components/sales/submissionDashboard/editsubmissionDialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          editData: data
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function editSubController($scope, $mdDialog, editData) {
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.InterviewModes = [{
        id: '1',
        mode: 'Phone-F2F'
      }, {
        id: '2',
        mode: 'Phone-Skype'
      }, {
        id: '3',
        mode: 'Phone'
      }, {
        id: '4',
        mode: 'F2F'
      }];
      $scope.statuses = [{
        id: '1',
        status: 'Confirmed'
      }, {
        id: '2',
        status: 'Rejected'
      }, {
        id: '3',
        status: 'Hold'
      }, {
        id: '4',
        status: 'Waiting For Interview'
      }];

      function setStatusId() {
        if (editData.Status == 'Confirmed') {
          return '1';
        } else if (editData.Status == 'Rejected') {
          return '2';
        } else if (editData.Status == 'Hold') {
          return '3';
        } else if (editData.Status == 'Waiting For Interview') {
          return '4';
        }
      }

      function interviewMode() {
        if (editData.InterviewText == 'Phone-F2F') {
          return '1';
        } else if (editData.InterviewText == 'Phone-Skype') {
          return '2';
        } else if (editData.InterviewText == 'Phone') {
          return '3';
        } else if (editData.InterviewText == 'F2F') {
          return '4';
        }
      }
      $scope.sub = {
        StatusId: setStatusId(),
        InterviewDate: editData.InterviewDate,
        ModeOfInterview: interviewMode(),
        Comments: null,
        InterviewConfirmed: angular.toJson(editData.InterviewConfirmed),
        MidVendorCalled: angular.toJson(editData.MidVendorCalled),
        PrimeVendorCalled: angular.toJson(editData.PrimeVendorCalled),
        Rate: editData.Rate,
        SubLocation: editData.SubLocation,
        TrackerId: editData.TrackerId,
        loginid: vm.tokenData.loginid
      };
      $scope.editSubSubmit = function (data) {
        $scope.sub.InterviewConfirmed = angular.fromJson($scope.sub.InterviewConfirmed);
        $scope.sub.MidVendorCalled = angular.fromJson($scope.sub.MidVendorCalled);
        $scope.sub.PrimeVendorCalled = angular.fromJson($scope.sub.PrimeVendorCalled);
        $scope.sub.Comments = data.Comments;
        dataService.newToken().then(function (response) {
          dataService.updateSub($scope.sub).then(function (response) {
            if (response.statusText == 'OK') {
              $rootScope.$broadcast('subs', response.data);
              $mdDialog.cancel();
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }
    $scope.$on('subs', function (evt, data) {
      vm.subs = data;
    });

    function getConsultants() {
      $scope.allConsultants = '';
      dataService.newToken().then(function (response) {
        dataService.getSubmissions({
          loginid: vm.tokenData.loginid
        }).then(function (response) {
          vm.subs = response.data;
          // $scope.consutants = response.data;
          $timeout(function () {
            var uTable = $('.consultants').DataTable({
              lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, 'All']],
              scrollX: '100%'
            });
            uTable.on('order.dt search.dt', function () {
              uTable.column(0, {
                search: 'applied',
                order: 'applied'
              }).nodes().each(function (cell, i) {
                cell.innerHTML = i + 1;
              });
            }).draw();
          });
        }).catch(CatchError);
      }).catch(CatchError);
    }

    function getAdmSubs() {
      $scope.allConsultants = '';
      dataService.newToken().then(function (response) {
        dataService.getsubforadmin({
          loginid: vm.tokenData.loginid
        }).then(function (response) {
          for (var i = 0; i < response.data.length; i++) {
            vm.subs.push(response.data[i].lstmrktersub);
          }

          // $scope.consutants = response.data;
          $timeout(function () {
            var uTable2 = $('.consultants').DataTable({
              lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, 'All']],
              scrollX: '100%'
            });
            uTable2.on('order.dt search.dt', function () {
              uTable2.column(0, {
                search: 'applied',
                order: 'applied'
              }).nodes().each(function (cell, i) {
                cell.innerHTML = i + 1;
              });
            }).draw();
          });
        }).catch(CatchError);
      }).catch(CatchError);
    }
  }
})();


(function () {
  'use strict';

  angular.module('app').component('addSubmission', {
    controller: AddSubmissionController,
    controllerAs: 'vm',
    templateUrl: 'app/components/sales/submissionAdd/submissionAdd.component.html'
  });

  function AddSubmissionController($scope, dataService, $http, $timeout, $mdDialog, $location, $mdSelect, $rootScope, moment, $state) {
    var vm = this;
    vm.tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.newSubmissionData = {
      SubmittedDate: moment()
    };
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    dataService.newToken().then(function (response) {
      dataService.GetConsls().then(function (response) {
        $scope.consultants = response.data;
      }).catch(CatchError);
    }).catch(CatchError);
    $scope.InterviewModes = [{
      id: '1',
      mode: 'Phone-F2F'
    }, {
      id: '2',
      mode: 'Phone-Skype'
    }, {
      id: '3',
      mode: 'Phone'
    }, {
      id: '4',
      mode: 'F2F'
    }];
    $scope.statuses = [{
      id: '1',
      status: 'Confirmed'
    }, {
      id: '2',
      status: 'Rejected'
    }, {
      id: '3',
      status: 'Hold'
    }, {
      id: '4',
      status: 'Waiting For Interview'
    }];
    dataService.newToken().then(function (response) {
      dataService.GetConsls().then(function (response) {
        $scope.consultants = response.data;
      }).catch(CatchError);
    }).catch(CatchError);
    dataService.newToken().then(function (response) {
      dataService.GetMrkterLookUp().then(function (response) {
        $scope.skills = response.data.ListSDD;
      }).catch(CatchError);
    }).catch(CatchError);

    $scope.newSkill = function () {
      $mdSelect.hide();
      $mdDialog.show({
        controller: addSkillDialogController,
        templateUrl: 'app/components/sales/newResources/addSkill.Dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function addSkillDialogController($scope) {
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.addSkillData = function (data) {
        dataService.newToken().then(function (response) {
          dataService.AddSkillSet({
            Skill: data
          }).then(function (response) {
            if (response.statusText == 'OK') {
              $rootScope.$broadcast('skills', response.data);
              $mdDialog.cancel();
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }
    $scope.$on('skills', function (evt, data) {
      $scope.skills = data;
    });

    $scope.newSubmissionFormSubmit = function (data) {
      $scope.submitLoader = true;
      data.loginid = vm.tokenData.loginid;
      var objArr = [];
      objArr.push(data);
      dataService.newToken().then(function (response) {
        dataService.addSubmissions(objArr).then(function (response) {
          // if (response.data == "Submission Added Successfully...") {
          $state.go('submissions');
          // } else {
          //     $mdDialog.show(
          //         $mdDialog.alert()
          //         .parent(angular.element(document.querySelector('#addSubm')))
          //         .clickOutsideToClose(true)
          //         .title('OOPS.,')
          //         .textContent('Failed to add Submission, Try Again. If problem repeats contact Administrator.')
          //         .ariaLabel('Alert ')
          //         .ok('Got it!')
          //     );
          // }
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.go = function (path) {
      $state.go(path);
    };
  }
})();


(function () {
      'use strict';

      angular.module('app').component('placements', {
            controller: PlacementsController,
            controllerAs: 'vm',
            templateUrl: 'app/components/sales/placements/placements.component.html'
      });

      function PlacementsController($scope, dataService, $http, $timeout, $mdToast, $location, $mdDialog, $rootScope, $mdSelect, $q, $window, $state) {
            // var placedCons,
            //   vm = this
            // vm.tokenData = angular.fromJson(localStorage.getItem('tokenData'))
            // $scope.go = function (path) {
            //   $state.go(path)
            // }
            // var heightCanBe = window.innerHeight - 80 + 'px'
            // $(window).resize(function () {
            //   heightCanBe = window.innerHeight - 80 + 'px'
            //   placedCons.setHeight(heightCanBe)
            //   placedCons.redraw()
            // })
            // $scope.deactivate = false
            // $scope.activate = false
            // $scope.addNewPlacement = false
            // $scope.addTitleShow = false

            // var CatchError = function (error) {
            //   if (error.statusText == 'Unauthorized') {
            //     var message = 'Your Session is Expired, Please login again'
            //     $scope.authenticated = false
            //     var toast = $mdToast
            //       .simple()
            //       .content(message)
            //       .action('OK')
            //       .highlightAction(false)
            //       .position('top center')
            //       .hideDelay(3000)
            //     $mdToast.show(toast)
            //     localStorage.clear()
            //     $state.go('signin')
            //   }
            // }

            // $scope.addNewPlacementLoader = false
            // $scope.addPlacement = function (data) {
            //   $scope.addNewPlacementLoader = true
            //   if (data === undefined) {
            //     dataService.newToken().then(function (response) {
            //       dataService
            //         .updateConsultant({
            //           ConslId: $scope.selectedConsultant.ConslId,
            //           Status: false
            //         })
            //         .then(function (response) {
            //           dataService.newToken().then(function (response) {
            //             dataService
            //               .GetConsls()
            //               .then(function (response) {
            //                 $('#content-wrapper').removeClass('overflowHidden')
            //                 $scope.addNewPlacement = false
            //                 $scope.deactivate = false
            //                 $scope.allConsultants = ''
            //                 $scope.allConsultants = response.data
            //                 $scope.hotlist = []
            //                 $scope.benchConsultants = []
            //                 for (var i = 0; i < response.data.length; i++) {
            //                   if (response.data[i].Active === true) {
            //                     $scope.hotlist.push(response.data[i])
            //                   } else if (response.data[i].Active === false) {
            //                     $scope.benchConsultants.push(response.data[i])
            //                   }
            //                 }
            //               }).catch(CatchError)
            //           })
            //         })
            //         .catch(CatchError)
            //     })
            //   } else {
            //     data.CreateId = vm.tokenData.loginid
            //     data.ConslId = $scope.selectedConsultant.ConslId
            //     dataService.newToken().then(function (response) {
            //       dataService
            //         .updateConsultant({
            //           ConslId: $scope.selectedConsultant.ConslId,
            //           Status: false
            //         })
            //         .then(function (response) {
            //           dataService.newToken().then(function (response) {
            //             dataService
            //               .IMrkplonboard(data)
            //               .then(function (response) {
            //                 $scope.msg = response.data
            //                 dataService.newToken().then(function (response) {
            //                   dataService
            //                     .GetConsls()
            //                     .then(function (response) {
            //                       $scope.addNewPlacement = false
            //                       $scope.deactivate = false
            //                       $scope.allConsultants = ''
            //                       $scope.allConsultants = response.data
            //                       $scope.hotlist = []
            //                       $scope.benchConsultants = []
            //                       for (var i = 0; i < response.data.length; i++) {
            //                         if (response.data[i].Active === true) {
            //                           $scope.hotlist.push(response.data[i])
            //                         } else if (response.data[i].Active === false) {
            //                           $scope.benchConsultants.push(response.data[i])
            //                         }
            //                       }
            //                     })
            //                     .catch(CatchError)
            //                 })
            //               }).catch(CatchError)
            //           })
            //         }).catch(CatchError);
            //     });
            //   }
            // }

            // $scope.ViewConsDocs = function (data) {
            //   $mdDialog
            //     .show({
            //       controller: ViewConsDocsController,
            //       templateUrl: 'app/components/sales/placements/viewDocDialog.html',
            //       parent: angular.element(document.body),
            //       clickOutsideToClose: true,
            //       locals: {
            //         consData: data
            //       },
            //       fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            //     })
            //     .then(
            //       function (answer) {
            //         $scope.status = 'You said the information was "' + answer + '".'
            //       },
            //       function () {
            //         $scope.status = 'You cancelled the dialog.'
            //       }
            //     )
            // }

            // function ViewConsDocsController($scope, $mdDialog, consData) {
            //   $scope.cancel = function () {
            //     $mdDialog.cancel()
            //   }

            //   $scope.editeditHotlSubmitLoader = false
            //   $scope.ConData = consData
            //   $scope.conDocs = consData.LstDocUrls

            //   var obj = {
            //     loginid: vm.tokenData.loginid,
            //     conslid: consData.ConslId
            //   }

            //   $scope.getFile = function (data, furl) {
            //     var re = /(?:\.([^.]+))?$/
            //     var obj = {
            //       loginid: vm.tokenData.loginid,
            //       conslid: data.ConslId,
            //       FileUrl: furl,
            //       FileExt: re.exec(furl)[1]
            //     }
            //     dataService.newToken().then(function (response) {
            //       dataService
            //         .Getfileurl(obj)
            //         .then(function (response) {
            //           $scope.file = response.data
            //           // var fileType = ""
            //           var file = btoa(
            //             new Uint8Array(response.data).reduce(function (data, byte) {
            //               return data + String.fromCharCode(byte)
            //             }, '')
            //           )

            //           var isChrome = !!window.chrome && !!window.chrome.app
            //           var isIE = /* @cc_on!@ */ false || !!document.documentMode
            //           var isEdge = !isIE && !!window.StyleMedia

            //           if (isChrome) {
            //             var url = window.URL || window.webkitURL

            //             var downloadLink = angular.element('<a></a>')
            //             downloadLink.attr(
            //               'href',
            //               'data:application/octet-stream; base64,' + file
            //             )
            //             downloadLink.attr('target', '_self')
            //             downloadLink.attr('download', furl)
            //             downloadLink[0].click()
            //           } else if (isEdge || isIE) {
            //             window.navigator.msSaveOrOpenBlob(file, furl)
            //           } else {
            //             var fileURL = URL.createObjectURL(file)
            //             window.open(fileURL)
            //           }
            //         }).catch(CatchError)
            //     })
            //   }

            //   // New Doc Add
            //   $scope.viewDocAdd = false $scope.addDoc = function () {
            //     $mdSelect.hide()
            //     $scope.viewDocAdd = true
            //     $scope.viewDocAddClose = function () {
            //       $scope.viewDocAdd = false
            //     }

            //     $scope.addDocData = function (data) {
            //       dataService.newToken().then(function (response) {
            //         dataService
            //           .InsertDocDD({
            //             DocName: data
            //           })
            //           .then(function (response) {
            //             $scope.docDDs = response.data
            //             $scope.viewDocAdd = false
            //           })
            //           .catch(CatchError)
            //       })
            //     }
            //   }
            //   dataService.newToken().then(function (response) {
            //     dataService
            //       .GetDocDD()
            //       .then(function (response) {
            //         $scope.docDDs = response.data
            //       })
            //       .catch(CatchError)
            //   })
            //   $scope.uploadFile = function (data) {
            //     $scope.files = data
            //   }
            //   $scope.getFileDetails = function (e) {
            //     $scope.upFiles = e
            //     $scope.files = []
            //     $scope.$apply(function () {
            //       // STORE THE FILE OBJECT IN AN ARRAY.
            //       for (var i = 0; i < e.files.length; i++) {
            //         $scope.files.push(e.files[i])
            //       }
            //     })
            //   }

            //   // NOW UPLOAD THE FILES.
            //   $scope.uploadActivated = false
            //   $scope.uploadFiles = function (docId) {
            //     $scope.uploadActivated = true
            //     // FILL FormData WITH FILE DETAILS.
            //     var data = new FormData()
            //     for (var i in $scope.files) {
            //       data.append('uploadedFile', $scope.files[i])
            //     }
            //     // ADD LISTENERS.
            //     var objXhr = new XMLHttpRequest()
            //     objXhr.addEventListener('progress', updateProgress, false)
            //     objXhr.addEventListener('load', transferComplete, false)
            //     // SEND FILE DETAILS TO THE API.
            //     // objXhr.open("POST", "/api/fileupload/");
            //     // objXhr.send(data);
            //     data.append('docId', docId)
            //     data.append('loginid', vm.tokenData.loginid)
            //     data.append('conslid', consData.ConslId)
            //     dataService.newToken().then(function (response) {
            //       dataService
            //         .UploadDocument(data)
            //         .then(function (response) {
            //           var toast = $mdToast
            //             .simple()
            //             .content(response.data.Message)
            //             .action('OK')
            //             .highlightAction(false)
            //             .position('top center')
            //             .hideDelay(3000)
            //           $mdToast.show(toast)
            //           dataService.newToken().then(function (response) {
            //             dataService
            //               .GetConsls()
            //               .then(function (response) {
            //                 $rootScope.$broadcast('allCons', response.data)
            //                 for (var index = 0; index < response.data.length; index++) {
            //                   if (consData.ConslId === response.data[index].ConslId) {
            //                     $scope.conDocs = response.data[index].ListDocUrls
            //                     break
            //                   }
            //                 }
            //               })
            //               .catch(CatchError)
            //           })
            //           $scope.selDocId = null
            //           document.getElementById('file').value = ''
            //           $scope.uploadActivated = false
            //         })
            //         .catch(CatchError)
            //     })
            //   }
            //   // UPDATE PROGRESS BAR.
            //   function updateProgress(e) {
            //     if (e.lengthComputable) {
            //       document.getElementById('pro').setAttribute('value', e.loaded)
            //       document.getElementById('pro').setAttribute('max', e.total)
            //     }
            //   }
            //   // CONFIRMATION.
            //   function transferComplete(e) {
            //     alert('Files uploaded successfully.')
            //   }
            // }
            // $scope.placementsLoader = true
            // if (vm.tokenData.newRole == 'Marketer') {
            //   dataService.newToken().then(function (response) {
            //     dataService
            //       .GetPlacmentDetailsById({
            //         loginid: vm.tokenData.loginid
            //       })
            //       .then(function (response) {
            //         $scope.placementsLoader = false
            //         $scope.placements = response.data
            //         var ViewIcon = function (cell, formatterParams, onRendered) {
            //           return "<i class='material-icons pointer zoom' style='font-size: 18px;'>remove_red_eye</i>"
            //         }
            //         var showByRole = false
            //         if (vm.tokenData.role !== 'Marketer') {
            //           showByRole = true
            //         }
            //         placedCons = new Tabulator('#placedCons', {
            //           data: $scope.placements,
            //           height: heightCanBe,
            //           layout: 'fitDataFill',
            //           pagination: 'local',
            //           paginationSize: 20,
            //           paginationSizeSelector: [20, 30, 40, 50],
            //           groupBy: '',
            //           groupStartOpen: false,
            //           groupToggleElement: 'header',
            //           selectable: false,
            //           clipboard: true,
            //           clipboardCopyStyled: false,
            //           persistence: {
            //             sort: true,
            //             filter: true,
            //             columns: true,
            //           },
            //           tooltips: true,
            //           tooltipsHeader: true,
            //           persistenceID: "placedConstablepersistenceID",
            //           tooltips: function (cell) {
            //             return cell.getColumn().getField() + ' - ' + cell.getValue()
            //           },
            //           tooltipGenerationMode: 'hover',
            //           columns: [{
            //               formatter: 'rownum',
            //               align: 'center',
            //               width: 40,
            //               sorter: false
            //             },
            //             {
            //               title: 'Name',
            //               field: 'EmployeeName'
            //             },
            //             {
            //               title: 'Title',
            //               field: 'TitleName'
            //             },
            //             {
            //               title: 'Rate',
            //               field: 'Rate'
            //             },
            //             {
            //               title: 'Project Start Date',
            //               field: 'PStartDate',
            //               formatter: 'datetime',
            //               formatterParams: {
            //                 inputFormat: 'YYYY-MM-DD',
            //                 outputFormat: 'MM/DD/YY',
            //                 invalidPlaceholder: '(n/a)'
            //               }
            //             },
            //             {
            //               title: 'Client',
            //               field: 'ClientName'
            //             },
            //             {
            //               title: 'Prime Vendor',
            //               field: 'PrimeVendorName'
            //             },
            //             {
            //               title: 'Mid Vendor',
            //               field: 'MidVendorName'
            //             },
            //             {
            //               title: 'Marketer',
            //               field: 'MarkterName'
            //             },
            //             {
            //               title: 'Comments',
            //               field: 'Comments'
            //             },
            //             {
            //               formatter: ViewIcon,
            //               title: 'View',
            //               cellClick: function (e, cell) {
            //                 var data = cell.getRow()
            //                 $scope.ViewConsDocs(data._row.data)
            //               }
            //             }
            //           ]
            //         })
            //       })
            //       .catch(CatchError)
            //     })
            //   } else {
            //     dataService.newToken().then(function (response) {
            //         dataService
            //           .GetallPlacDetails({
            //             loginid: vm.tokenData.loginid
            //           })
            //           .then(function (response) {
            //             $scope.placementsLoader = false
            //             $scope.placements = response.data
            //             var ViewIcon = function (cell, formatterParams, onRendered) {
            //               return "<i class='material-icons pointer zoom' style='font-size: 18px;'>remove_red_eye</i>"
            //             }
            //             var showByRole = false
            //             if (vm.tokenData.role !== 'Marketer') {
            //               showByRole = true
            //             }
            //             placedCons = new Tabulator('#placedCons', {
            //               data: $scope.placements,
            //               height: heightCanBe,
            //               layout: 'fitDataFill',
            //               pagination: 'local',
            //               paginationSize: 20,
            //               paginationSizeSelector: [20, 30, 40, 50],
            //               groupBy: '',
            //               groupStartOpen: false,
            //               groupToggleElement: 'header',
            //               selectable: false,
            //               clipboard: true,
            //               clipboardCopyStyled: false,
            //               persistence: {
            //                 sort: true,
            //                 filter: true,
            //                 columns: true,
            //               },
            //               tooltips: true,
            //               tooltipsHeader: true,
            //               persistenceID: "placedConspersistenceID",
            //               tooltipGenerationMode: 'hover',
            //               columns: [{
            //                   formatter: 'rownum',
            //                   align: 'center',
            //                   width: 40,
            //                   sorter: false
            //                 },
            //                 {
            //                   title: 'Name',
            //                   field: 'EmployeeName'
            //                 },
            //                 {
            //                   title: 'Title',
            //                   field: 'TitleName'
            //                 },
            //                 {
            //                   title: 'Rate',
            //                   field: 'Rate'
            //                 },
            //                 {
            //                   title: 'Project Start Date',
            //                   field: 'PStartDate',
            //                   formatter: 'datetime',
            //                   formatterParams: {
            //                     inputFormat: 'YYYY-MM-DD',
            //                     outputFormat: 'MM/DD/YY',
            //                     invalidPlaceholder: '(n/a)'
            //                   }
            //                 },
            //                 {
            //                   title: 'Client',
            //                   field: 'ClientName'
            //                 },
            //                 {
            //                   title: 'Prime Vendor',
            //                   field: 'PrimeVendorName'
            //                 },
            //                 {
            //                   title: 'Mid Vendor',
            //                   field: 'MidVendorName'
            //                 },
            //                 {
            //                   title: 'Marketer',
            //                   field: 'MarkterName'
            //                 },
            //                 {
            //                   title: 'Comments',
            //                   field: 'Comments'
            //                 },
            //                 {
            //                   formatter: ViewIcon,
            //                   title: 'View',
            //                   cellClick: function (e, cell) {
            //                     var data = cell.getRow()
            //                     $scope.ViewConsDocs(data._row.data)
            //                   }
            //                 }
            //               ]
            //             })
            //           })
            //           .catch(CatchError)
            //       }
      }
})();


(function () {
  'use strict';

  angular.module('app').component('newResources', {
    controller: NewResourcesController,
    controllerAs: 'vm',
    templateUrl: 'app/components/sales/newResources/newResources.component.html'
  });

  function NewResourcesController($scope, dataService, $http, $rootScope, $q, $mdDialog, $mdSelect, $mdToast, moment, $state) {
    var vm = this;
    vm.tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.submitLoader = false;
    $scope.addConsLoader = false;
    $scope.Edus = ['Bachelors', 'Masters', 'Phd'];
    $scope.workAuthTypes = {
      H1B: 'H1B',
      CPT: 'CPT',
      'OPT-STEM': 'OPT-STEM',
      OPT: 'OPT',
      GC: 'GC',
      USC: 'USC',
      'GC-EAD': 'GC-EAD',
      T1: 'T1'
    };
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    $scope.emails = [];
    function loadData($q) {
      return $q.all([dataService.GetStatesList(), dataService.GetMrkterLookUp(), dataService.GetMarketerInfoMrkter(), dataService.GetDocDD()]);
    }
    dataService.newToken().then(function (response) {
      loadData($q).then(function (response) {
        $scope.states = response[0].data;
        $scope.visaStatus = response[1].data.ListVDD;
        $scope.skills = response[1].data.ListSDD;
        $scope.marketers = response[2].data;
        $scope.docDDs = response[3].data;

        new GetConsls();
      });
    }).catch(CatchError);

    function GetConsls() {
      dataService.GetConslsEmails().then(function (response) {
        $scope.emails = response.data;
      }).catch(CatchError);
    }
    $scope.checkEmail = function (email) {
      if (email !== undefined && email !== '') {
        email = email.toLowerCase();
        for (var i = 0; i < $scope.emails.length; i++) {
          if ($scope.emails[i] === email) {
            $scope.userExists = true;
            $scope.existedUser = 'User Already Exists';
            break;
          } else {
            $scope.userExists = false;
          }
        }
      }
    };

    $scope.newConsultantData = {
      Recuriterid: vm.tokenData.loginid,
      relocate: undefined,
      ListOfEdu: []
    };

    $scope.Priorities = [{
      id: 1,
      value: 'High'
    }, {
      id: 2,
      value: 'Medium'
    }, {
      id: 3,
      value: 'Low'
    }];
    $scope.newSkill = function () {
      $mdSelect.hide();
      $mdDialog.show({
        controller: addSkillDialogController,
        templateUrl: 'app/components/sales/newResources/addSkill.Dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function addSkillDialogController($scope) {
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.addSkillData = function (data) {
        dataService.newToken().then(function (response) {
          dataService.AddSkillSet({
            Skill: data
          }).then(function (response) {
            if (response.statusText == 'OK') {
              $rootScope.$broadcast('skills', response.data);
              $mdDialog.cancel();
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }
    $scope.$on('skills', function (evt, data) {
      $scope.skills = data;
      var toast = $mdToast.simple().content("Skill added successfully").action('OK').highlightAction(false).position('top center').hideDelay(3000);
      $mdToast.show(toast);
    });

    // New Doc Add
    $scope.addDoc = function () {
      $mdSelect.hide();
      $mdDialog.show({
        controller: addDocDialogController,
        templateUrl: 'app/components/sales/newResources/addDoc.Dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function addDocDialogController($scope) {
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.addDocData = function (data) {
        dataService.newToken().then(function (response) {
          dataService.InsertDocDD({
            DocName: data
          }).then(function (response) {
            if (response.statusText == 'OK') {
              $rootScope.$broadcast('DocDDs', response.data);
              $mdDialog.cancel();
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }
    $scope.$on('DocDDs', function (evt, data) {
      $scope.docDDs = data;
    });
    $scope.uploadFile = function (data) {
      $scope.files = data;
    };
    $scope.getFileDetails = function (e) {
      $scope.files = [];
      $scope.$apply(function () {
        // STORE THE FILE OBJECT IN AN ARRAY.
        for (var i = 0; i < e.files.length; i++) {
          $scope.files.push(e.files[i]);
        }
      });
    };

    $scope.uploadFiles = function (selDocId) {
      var data = new FormData();
      for (var i in $scope.files) {
        data.append('uploadedFile', $scope.files[i]);
      }
      var objXhr = new XMLHttpRequest();
      objXhr.addEventListener('progress', updateProgress, true);
      objXhr.addEventListener('load', transferComplete, false);
      data.append('docId', selDocId);
      data.append('loginid', vm.tokenData.loginid);
      data.append('conslid', $scope.createdConsultantData.ConslId);
      dataService.newToken().then(function (response) {
        dataService.UploadDocument(data).then(function (response) {
          var toast = $mdToast.simple().content(response.data.Message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
          $mdToast.show(toast);
          $state.go('myResources');
        }).catch(CatchError);
      }).catch(CatchError);
    };
    // UPDATE PROGRESS BAR.
    function updateProgress(e) {
      if (e.lengthComputable) {
        document.getElementById('pro').setAttribute('value', e.loaded);
        document.getElementById('pro').setAttribute('max', e.total);
      }
    }
    // CONFIRMATION.
    function transferComplete(e) {
      alert('Files uploaded successfully.');
    }
    $scope.newConsultantData = {
      Email: '',
      FirstName: '',
      MiddleName: '',
      LastName: '',
      DOB: '',
      SSN: '',
      PhoneNumber: '',
      OtherPhoneNumber: '',
      SkypeId: '',
      SkillId: '',
      ExpectedRate: '',
      ListOfEdu: [],
      AddrInfo: {},
      priority: '',
      VisaStatus: '',
      PassportNumber: '',
      Exp: '',
      GK: '',
      GKMoveInDate: '',
      relocate: '',
      Recuriterid: vm.tokenData.loginid
    };
    vm.stage0 = true;
    // Navigation functions
    $scope.formIsValid = false;
    $scope.consultantMaxDOB = new Date(moment().subtract(22, 'years').format('MM/DD/YYYY'));
    $scope.newConsultantDataCloned = angular.fromJson(angular.toJson($scope.newConsultantData));
    $scope.createConsutant = function (data) {
      $scope.addConsLoader = true;
      $scope.showForm = true;
      var reqData = [];
      data.DOB = moment(data.DOB).format('MM/DD/YYYY');
      if (data.GKMoveInDate !== '') {
        data.GKMoveInDate = moment(data.GKMoveInDate).format('MM/DD/YYYY');
      } else {
        delete data.GKMoveInDate;
      }
      if (data.ListOfEdu[0] === undefined || data.ListOfEdu[0] === null || data.ListOfEdu[0].Type === '') {
        data.ListOfEdu.splice(0, 1);
      } else if (data.ListOfEdu[1] === undefined || data.ListOfEdu[1] === null || data.ListOfEdu[1].Type === '') {
        data.ListOfEdu.splice(1, 1);
      }
      data.ListOfEdu = data.ListOfEdu.filter(function (el) {
        return el;
      });

      data.SkillId = data.SkillId.toString();
      data.GK = angular.fromJson(data.GK);
      data.Active = true;
      data.StreetAddress = '';
      data.PrefLocation = data.relocate;
      delete data.relocate;
      reqData.push(data);
      dataService.newToken().then(function (response) {
        dataService.addConsl(reqData).then(function (consCreatedRes) {
          if (consCreatedRes.data == 'Conslutant Added Succesfully..') {
            dataService.newToken().then(function (response) {
              dataService.GetConsls().then(function (response) {
                for (var index = 0; index < response.data.length; index++) {
                  if (data.Email == response.data[index].Email) {
                    $scope.createdConsultantData = response.data[index];
                    // $scope.addConsLoader = false
                    $("#success").show();
                    $scope.newConsultantData = $scope.newConsultantDataCloned;
                    $scope.addConsLoader = false;
                    break;
                  }
                }
              }).catch(CatchError);
            }).catch(CatchError);
          } else {
            $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#bulkEmailWrap'))).clickOutsideToClose(true).title('OOPS.,').textContent('Failed to add Consultant, Try Again. If problem repeats contact Administrator.').ariaLabel('Alert ').ok('Got it!').targetEvent(ev));
            $scope.showForm = false;
            $scope.addConsLoader = false;
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.addnewConsultantForm = function () {
      $scope.showForm = false;
      $scope.newConsultantForm.$pristine = false;
      $scope.newConsultantForm.$submitted = false;
      $scope.newConsultantForm.$invalid = false;
    };

    $scope.go = function (path) {
      $state.go(path);
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("myResources", {
    controller: MyResourcesController,
    controllerAs: "vm",
    templateUrl: "app/components/sales/myResources/myResources.component.html"
  });

  function MyResourcesController($scope, dataService, $http, $timeout, $mdToast, $location, $mdDialog, $rootScope, $mdSelect, $q, $window, $state) {
    var vm = this;
    vm.tokenData = angular.fromJson(localStorage.getItem("tokenData"));
    $scope.go = function (path) {
      $state.go(path);
    };
    $scope.deactivate = false;
    $scope.activate = false;
    $("#addNewPlacement").modal("hide");

    $scope.addTitleShow = false;
    $scope.topLoader = true;
    $scope.showTable = false;
    var hotlisttable, allConsTable;
    var heightCanBe = window.innerHeight - 180 + "px";
    $scope.addClientShow = false;
    $scope.addClientAddrShow = false;
    $scope.addVendorShow = false;
    $scope.addVendorAddressShow = false;
    $scope.addMidVendorAddressShow = false;
    $scope.addNewPlacementLoader = false;
    $scope.hotListDataReady = false;
    $scope.loadHotListData = false;
    $scope.preloader = false;

    $(window).resize(function () {
      heightCanBe = window.innerHeight - 180 + "px";
      if (hotlisttable) {
        hotlisttable.setHeight(heightCanBe);
        hotlisttable.redraw();
      }
    });
    function inactivateConsultant(data) {
      $scope.addNewPlacementLoader = false;
      $(".fixSidebarChangePlcement-wrap").removeClass("ng-hide");
      $("#addNewPlacement").modal("show");

      $scope.projectConfirmed = false;
      $("#content-wrapper").addClass("overflowHidden");
      $scope.chaninConData = {};
      $scope.addNewInterview.$setUntouched();
      $scope.addNewInterview.$setPristine();
      $scope.addTitleShow = false;
      $scope.addClientShow = false;
      $scope.addClientAddrShow = false;
      $scope.addVendorShow = false;
      $scope.addVendorAddressShow = false;
      $scope.deactivate = true;
      $scope.selectedConsultant = data;
    }
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };
    function loadData($q) {
      var promiseClients = dataService.GetClientsInfoMrkter();
      var promiseVendors = dataService.GetVendorInfoMrkter();
      var promiseTitles = dataService.GetTitleDDMrkter();
      var GetMrkterLookUp = dataService.GetMrkterLookUp();

      return $q.all([promiseClients, promiseVendors, promiseTitles, GetMrkterLookUp]
      //dataService.Interviewlookup()
      );
    }
    dataService.newToken().then(function (response) {
      loadData($q).then(function (resp) {
        $scope.Clients = resp[0].data;
        $scope.Vendors = resp[1].data;
        $scope.MidVendors = resp[1].data;
        $scope.titles = resp[2].data;
        $scope.visaStatus = resp[3].data.ListVDD;
        $scope.skills = resp[3].data.ListSDD;
        $scope.topLoader = false;
      }).catch(CatchError);
    }).catch(CatchError);
    $scope.selectedClientAddr = function (id) {
      for (var g = 0; g < $scope.Clients.length; g++) {
        if ($scope.Clients[g].ClientId === id) {
          $scope.selectedClientAddresses = $scope.Clients[g].ClientAddress;
        }
      }
    };
    $scope.newClient = function newClient(flag) {
      $mdSelect.hide();
      $scope.addClientShow = true;
    };
    $scope.addClientData = function (clientData) {
      $mdSelect.hide();

      $scope.notifier = true;
      $scope.afterAddedClient = false;
      dataService.newToken().then(function (response) {
        dataService.AddClientMrkter(clientData).then(function (response) {
          if (response.statusText == "OK") {
            dataService.newToken().then(function (response) {
              dataService.GetClientsInfoMrkter().then(function (response) {
                $scope.selectedClient = undefined;
                $scope.Clients = response.data;
                $scope.afterAddedClient = true;
                $timeout(function () {
                  $scope.addClientShow = false;
                  $scope.notifier = false;
                  $scope.afterAddedClient = false;
                }, 500);
              }).catch(CatchError);
            }).catch(CatchError);
          } else {
            var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $scope.addClientShow = false;
            $scope.notifier = false;
            $scope.afterAddedClient = false;
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.newClientAddress = function newClientAddress(selectedClient) {
      $mdSelect.hide();
      $scope.addClientAddrShow = true;
      $scope.selectedClient = selectedClient;
    };
    $scope.addClientAddrsData = function (data) {
      $scope.notifier = true;

      var obj = {
        ClientId: $scope.selectedClient,
        ClientAddress: [{
          Address: data.ClientAddress
        }]
      };
      dataService.newToken().then(function (response) {
        dataService.AddClientAddressMrkter(obj).then(function (res) {
          if (res.statusText == "OK") {
            $scope.Clients = res.data;
            for (var b = 0; b < res.data.length; b++) {
              if (res.data[b].ClientId === $scope.selectedClient) {
                // $scope.selectedClient = res.data[b].ClientId;
                $scope.selectedClientAddresses = res.data[b].ClientAddress;
                break;
              }
            }
            dataService.newToken().then(function (response) {
              dataService.GetClientsInfoMrkter().then(function (response) {
                $scope.endClients = response.data;
                $scope.afterAddedClientAddr = true;
                $timeout(function () {
                  $scope.addClientAddrShow = false;
                  $scope.notifier = false;
                  $scope.afterAddedClientAddr = false;
                }, 1500);
              }).catch(CatchError);
            }).catch(CatchError);
          } else {
            var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $mdDialog.cancel();
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.newvendor = function newvendor() {
      $mdSelect.hide();
      $scope.addVendorShow = true;
    };
    $scope.addVendorData = function (vendorData) {
      $scope.notifier = true;
      dataService.newToken().then(function (response) {
        dataService.AddVendorMrkter(vendorData).then(function (response) {
          if (response.statusText == "OK") {
            dataService.newToken().then(function (response) {
              dataService.GetVendorInfoMrkter().then(function (response) {
                $scope.selectedVendor = undefined;
                $scope.Vendors = response.data;
                $scope.afterAddedVendor = true;
                $timeout(function () {
                  $scope.addVendorShow = false;
                  $scope.notifier = false;
                  $scope.afterAddedVendor = false;
                }, 1500);
              }).catch(CatchError);
            }).catch(CatchError);
          } else {
            var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $mdDialog.cancel();
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.selectedVendorAddr = function (id) {
      for (var g = 0; g < $scope.Vendors.length; g++) {
        if ($scope.Vendors[g].VendorId === id) {
          $scope.selectedVendorAddresses = $scope.Vendors[g].VendorAddress;
        }
      }
    };
    $scope.selectedMidVendor = function (id) {
      for (var b = 0; b < $scope.MidVendors.length; b++) {
        if ($scope.MidVendors[b].VendorId === id) {
          $scope.selectedMidVendorAddresses = $scope.MidVendors[b].VendorAddress;
        }
      }
    };
    $scope.newVendorAddress = function newVendorAddress(flag, selectedVendor) {
      $mdSelect.hide();
      $scope.addVendorAddressShow = true;
      $scope.selectedVendor = selectedVendor;
    };
    $scope.addVendorAddrsData = function (data) {
      $scope.notifier = true;

      var obj = {
        VendorId: $scope.selectedVendor,
        VendorAddress: [{
          Address: data.VendorAddress
        }]
      };
      dataService.newToken().then(function (response) {
        dataService.AddVendorAddressMrkter(obj).then(function (res) {
          for (var k = 0; k < res.data.length; k++) {
            if (res.data[k].VendorId == $scope.selectedVendor) {
              $scope.selectedVendorAddresses = res.data[k].VendorAddress;
            }
          }
          if (res.statusText == "OK") {
            dataService.newToken().then(function (response) {
              dataService.GetVendorInfoMrkter().then(function (response) {
                $scope.Vendors = response.data;
                $scope.afterAddedVendorAddr = true;
                $timeout(function () {
                  $scope.addVendorAddressShow = false;
                  $scope.notifier = false;
                  $scope.afterAddedVendorAddr = false;
                }, 1500);
              }).catch(CatchError);
            }).catch(CatchError);
          } else {
            var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $mdDialog.cancel();
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.newMidVendorAddress = function newMidVendorAddress(flag, selectedMidVendor) {
      $mdSelect.hide();
      $scope.addMidVendorAddressShow = true;
      $scope.selectedMidVendor = selectedMidVendor;
      $scope.vendorAddrs.VendorMidAddress = undefined;
    };
    $scope.addMidVendorAddrsData = function (data) {
      $scope.notifier = true;
      var obj = {
        VendorId: $scope.selectedMidVendor,
        VendorAddress: [{
          Address: data.VendorMidAddress
        }]
      };
      dataService.newToken().then(function (response) {
        dataService.AddVendorAddressMrkter(obj).then(function (res) {
          for (var k = 0; k < res.data.length; k++) {
            if (res.data[k].VendorId == $scope.selectedMidVendor) {
              $scope.selectedMidVendorAddresses = res.data[k].VendorAddress;
            }
          }
          if (res.statusText == "OK") {
            dataService.newToken().then(function (response) {
              dataService.GetVendorInfoMrkter().then(function (response) {
                $scope.Vendors = response.data;
                $scope.afterAddedMidVendorAddr = true;
                $timeout(function () {
                  $scope.addMidVendorAddressShow = false;
                  $scope.notifier = false;
                  $scope.afterAddedMidVendorAddr = false;
                }, 1500);
              }).catch(CatchError);
            }).catch(CatchError);
          } else {
            var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $mdDialog.cancel();
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.closeRight = function () {
      $(".fixSidebarChangePlcement-wrap").addClass("ng-hide");
      $("#content-wrapper").removeClass("overflowHidden");

      $("#addNewPlacement").modal("hide");
    };
    $scope.cancel = function () {
      $scope.addTitleShow = false;
      $scope.addClientShow = false;
      $scope.addVendorShow = false;
      $scope.addVendorAddressShow = false;
      $scope.addMidVendorAddressShow = false;
    };
    $scope.addTitle = function () {
      $mdSelect.hide();
      $scope.addTitleShow = true;
      $scope.addTitleSubmit = function (data) {
        $scope.notifier = true;
        dataService.newToken().then(function (response) {
          dataService.AddTitleMrkter(data).then(function (response) {
            if (response.data == "Title Added Sucessfully!.") {
              dataService.newToken().then(function (response) {
                dataService.GetTitleDDMrkter().then(function (response) {
                  $scope.titles = response.data;
                  $scope.addTitleShow = false;
                  $scope.notifier = false;
                }).catch(CatchError);
              }).catch(CatchError);
            } else {
              var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
              $mdToast.show(toast);
              $scope.addTitleShow = false;
              $scope.notifier = false;
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    };
    $scope.addPlacement = function (data) {
      $scope.addNewPlacementLoader = true;
      if (data === undefined) {
        dataService.newToken().then(function (response) {
          dataService.updateConsultant({
            ConslId: $scope.selectedConsultant.ConslId,
            Status: false
          }).then(function (response) {
            dataService.newToken().then(function (response) {
              dataService.GetConsls().then(function (response) {
                $("#content-wrapper").removeClass("overflowHidden");
                $("#addNewPlacement").modal("hide");

                $scope.deactivate = false;
                $scope.allConsultants = "";
                // $scope.allConsultants = response.data;
                $scope.allConsultants = _.sortBy(response.data, ["FirstName"]);
                $scope.hotlist = [];
                $scope.benchConsultants = [];
                for (var i = 0; i < $scope.allConsultants.length; i++) {
                  var element = $scope.allConsultants[i];
                  if (element.FirstName !== "") {
                    element.FullName = element.FirstName + " " + element.LastName;
                    if (element.Recuriterid !== null) {
                      // var marketerData = _.filter($scope.marketers, function(v) {
                      //   return _.includes([element.Recuriterid], v.loginid);
                      // });
                      var marketerData = _.filter($scope.marketers, function (v) {
                        var found = _.includes([element.Recuriterid], v.loginid);
                        if (found) {
                          return _.includes([element.Recuriterid], v.loginid);
                        } else {
                          return "n/a";
                        }
                      });
                      element.RecruiterName = marketerData[0].MarkterName;
                    } else {
                      element.RecruiterName = "Not Assigned";
                    }
                    if ($scope.allConsultants[i].Active === true) {
                      $scope.hotlist.push($scope.allConsultants[i]);
                    }
                  }
                }
                $rootScope.$broadcast("hotlistData", $scope.hotlist);
                $scope.addNewPlacementLoader = false;
              }).catch(CatchError);
            }).catch(CatchError);
          }).catch(CatchError);
        }).catch(CatchError);
      } else {
        data.CreateId = vm.tokenData.loginid;
        data.ConslId = $scope.selectedConsultant.ConslId;
        dataService.newToken().then(function (response) {
          dataService.updateConsultant({
            ConslId: $scope.selectedConsultant.ConslId,
            Status: false
          }).then(function (response) {
            dataService.newToken().then(function (response) {
              dataService.IMrkplonboard(data).then(function (response) {
                $scope.msg = response.data;
                dataService.newToken().then(function (response) {
                  dataService.GetConsls().then(function (response) {
                    $("#addNewPlacement").modal("hide");

                    $scope.deactivate = false;
                    $scope.allConsultants = "";
                    $scope.allConsultants = _.sortBy(response.data, ["FirstName"]);
                    $scope.hotlist = [];
                    $scope.benchConsultants = [];
                    for (var i = 0; i < $scope.allConsultants.length; i++) {
                      var element = $scope.allConsultants[i];
                      if (element.FirstName !== "") {
                        element.FullName = element.FirstName + " " + element.LastName;
                        if (element.Recuriterid !== null) {
                          var marketerData = _.filter($scope.marketers, function (v) {
                            return _.includes([element.Recuriterid], v.loginid);
                          });
                          element.RecruiterName = marketerData[0].MarkterName;
                        } else {
                          element.RecruiterName = "Not Assigned";
                        }
                        if ($scope.allConsultants[i].Active === true) {
                          $scope.hotlist.push($scope.allConsultants[i]);
                        }
                      }
                    }
                    $rootScope.$broadcast("hotlistData", $scope.hotlist);
                    $scope.addNewPlacementLoader = false;
                  }).catch(CatchError);
                }).catch(CatchError);
              }).catch(CatchError);
            }).catch(CatchError);
          }).catch(CatchError);
        }).catch(CatchError);
      }
    };
    $scope.activateConsultant = function (data) {
      $scope.activate = true;
      var confirm = $mdDialog.confirm().title(data.FullName + "(" + data.Email + ")").textContent("You are about to move above consultant to Hot List").ariaLabel("HotList").ok("Please do it!").cancel("Nope., Changed my Mind.");

      $mdDialog.show(confirm).then(function () {
        dataService.newToken().then(function (response) {
          dataService.updateConsultant({
            ConslId: data.ConslId,
            Status: true
          }).then(function (response) {
            dataService.newToken().then(function (response) {
              dataService.GetConsls().then(function (response) {
                $scope.allConsultants = "";
                $scope.activate = false;
                $scope.allConsultants = _.sortBy(response.data, ["FirstName"]);
                $scope.hotlist = [];
                $scope.benchConsultants = [];
                for (var i = 0; i < response.data.length; i++) {
                  var element = $scope.allConsultants[i];
                  if (element.FirstName !== "") {
                    element.FullName = element.FirstName + " " + element.LastName;
                    if (element.Recuriterid !== null) {
                      var marketerData = _.filter($scope.marketers, function (v) {
                        return _.includes([element.Recuriterid], v.loginid);
                      });
                      element.RecruiterName = marketerData[0].MarkterName;
                    } else {
                      element.RecruiterName = "Not Assigned";
                    }
                    if ($scope.allConsultants[i].Active === true) {
                      $scope.hotlist.push($scope.allConsultants[i]);
                    }
                  }
                }
                $rootScope.$broadcast("activateConData", $scope.hotlist, $scope.allConsultants);
              }).catch(CatchError);
            }).catch(CatchError);
          }).catch(CatchError);
        }).catch(CatchError);
      }, function () {
        $scope.status = "You decided to keep your debt.";
      });
    };
    $scope.EditHotListItem = function (data, from) {
      // if (vm.tokenData.newRole == "MarketerAdmin") {
      var scopeskills = $scope.skills;
      var scopevisaStatus = $scope.visaStatus;
      var marketers = $scope.marketers;
      $mdDialog.show({
        controller: EditHotListItemController,
        templateUrl: "app/components/sales/myResources/editHotListDialog.html",
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          editData: data,
          from: from,
          skills: scopeskills,
          visaStatus: scopevisaStatus,
          marketers: marketers
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = "You cancelled the dialog.";
      });
      // } else {

      // }
    };
    function EditHotListItemController($scope, $mdDialog, editData, from, skills, visaStatus, marketers) {
      $scope.editeditHotlSubmitLoader = false;

      $scope.cancel = function () {
        $mdDialog.cancel();
      };

      dataService.newToken().then(function (response) {
        dataService.GetConslsEmails().then(function (response) {
          $scope.emails = response.data;
        }).catch(CatchError);
      }).catch(CatchError);
      $scope.checkEmail = function (email) {
        if (email !== undefined && email !== "") {
          email = email.toLowerCase();
          for (var i = 0; i < $scope.emails.length; i++) {
            if ($scope.emails[i] === email) {
              $scope.userExists = true;
              $scope.existedUser = "User Already Exists";
              break;
            } else {
              $scope.userExists = false;
            }
          }
        }
      };
      $scope.marketers = marketers;
      $scope.visaStatus = visaStatus;
      $scope.skills = skills;
      for (var i = 0; i < visaStatus.length; i++) {
        if (visaStatus[i].Visa == editData.VisaType) {
          editData.VisaStatus = visaStatus[i].VisaId;
        }
      }
      for (var h = 0; h < skills.length; h++) {
        if (skills[h].Skill == editData.Skillset) {
          editData.Skillset = skills[h].Skill;
        }
      }
      $scope.viewSkillAdd = false;

      $scope.newSkill = function () {
        $mdSelect.hide();
        $scope.viewSkillAdd = true;
        $scope.viewSkillAddClose = function () {
          $scope.viewSkillAdd = false;
        };
        $scope.addSkillData = function (data) {
          dataService.newToken().then(function (response) {
            dataService.AddSkillSet({
              Skill: data
            }).then(function (response) {
              $scope.skills = response.data;
              $scope.viewSkillAdd = false;
            }).catch(CatchError);
          }).catch(CatchError);
        };
      };

      var Selskill = _.filter(skills, function (v) {
        return _.includes([editData.Skillset], v.Skill);
      });

      $timeout(function () {
        $scope.hotLuData = {
          Email: editData.Email,
          DOB: editData.DOB,
          VisaStatus: editData.VisaStatus,
          Skillset: Selskill.length > 0 ? Selskill[0].SkillId : undefined,
          GK: angular.toJson(editData.GK),
          Exp: angular.toJson(editData.Exp),
          PhoneNumber: editData.PhoneNumber,
          ExpectedRate: editData.ExpectedRate,
          PrefLocation: editData.PrefLocation,
          marketer: editData.Recuriterid,
          USEntryDate: editData.USEntryDate
        };
      });

      $scope.editeditHotlSubmit = function (newData) {
        $scope.editeditHotlSubmitLoader = true;
        var reqData = {
          Email: newData.Email,
          DOB: newData.DOB,
          VisaStatus: newData.VisaStatus,
          SkillId: newData.Skillset,
          PrefLocation: newData.PrefLocation,
          GK: angular.fromJson(newData.GK),
          Exp: angular.fromJson(newData.Exp),
          PhoneNumber: newData.PhoneNumber,
          Recuriterid: newData.marketer,
          ExpectedRate: newData.ExpectedRate,
          USEntryDate: newData.USEntryDate
        };
        reqData.loginid = vm.tokenData.loginid;
        reqData.ConslId = editData.ConslId;
        dataService.newToken().then(function (response) {
          dataService.updateConslsHotList(reqData).then(function () {
            dataService.newToken().then(function (response) {
              if (from !== "hotlist") {
                dataService.GetConsls().then(function (response) {
                  parseResData(response, true);
                }).catch(CatchError);
              } else {
                dataService.GetHotListConsl().then(function (response) {
                  parseResData(response, false);
                }).catch(CatchError);
              }
              function parseResData(response, is) {
                if (response.statusText == "OK") {
                  $scope.editeditHotlSubmitLoader = false;
                  $scope.allConsultants = response.data;
                  if (is) {
                    response.data = _.sortBy(response.data, ["FirstName"]);
                  }
                  $mdDialog.cancel();
                  $scope.hotlist = [];
                  for (var i = 0; i < response.data.length; i++) {
                    var element = response.data[i];
                    if (is && element.Source === "Dice") {
                      console.log("is");
                      if (element.PrefLocation !== null) {
                        try {
                          element.PrefLocation = JSON.parse(element.PrefLocation)[0]["text"];
                        } catch (e) {}
                      }
                      if (element.CurrentLocation !== null) {
                        try {
                          element.CurrentLocation = JSON.parse(element.CurrentLocation)[0]["text"];
                        } catch (e) {}
                      }
                      if (element.WorkPermit !== null) {
                        try {
                          element.WorkPermit = JSON.parse(element.WorkPermit)[0];
                        } catch (e) {}
                      }
                      if (element.WorkPermitLocations !== null) {
                        try {
                          element.WorkPermitLocations = JSON.parse(element.WorkPermitLocations)[0];
                        } catch (e) {}
                      }
                      if (element.WorkPreferences !== null) {
                        try {
                          element.WorkPreferences = JSON.parse(element.WorkPreferences)[0];
                        } catch (e) {}
                      }
                      if (element.Skillset !== null) {
                        try {
                          element.Skillset = JSON.parse(element.Skillset)[0];
                        } catch (e) {}
                      }
                      if (element.Email !== null) {
                        try {
                          element.Email = JSON.parse(element.Email)[0];
                        } catch (e) {}
                      }
                      if (element.PhoneNumber !== null) {
                        try {
                          element.PhoneNumber = JSON.parse(element.PhoneNumber)[0];
                        } catch (e) {}
                      }
                      if (element.DesiredJobTitles !== null) {
                        try {
                          element.DesiredJobTitles = JSON.parse(element.DesiredJobTitles)[0];
                        } catch (e) {}
                      }
                      if (element.Experience !== null) {
                        try {
                          element.Experience = JSON.parse(element.Experience).history[0].title;
                        } catch (e) {}
                      }
                      if (element.DateLastActive !== null) {
                        try {
                          element.DateLastActive = JSON.stringify(moment(element.DateLastActive).format("MM/DD/YYYY"));
                        } catch (e) {}
                      }
                    }
                    if (element.FirstName !== "") {
                      element.FullName = element.FirstName + " " + element.LastName;
                      if (element.Recuriterid !== null) {
                        var marketerData = _.filter($scope.marketers, function (v) {
                          return _.includes([element.Recuriterid], v.loginid);
                        });
                        if (marketerData.length > 0) {
                          element.RecruiterName = marketerData[0].MarkterName;
                        } else {
                          element.RecruiterName = "Not Assigned";
                        }
                      } else {
                        element.RecruiterName = "Not Assigned";
                      }
                      if (response.data[i].Active === true) {
                        $scope.hotlist.push(response.data[i]);
                      }
                    }
                  }
                  if (!is) {
                    $rootScope.$broadcast("hotlistEditedData", $scope.hotlist);
                  } else {
                    $rootScope.$broadcast("allConsultantsEditedData", response.data);
                  }
                  $mdDialog.cancel();
                }
              }
            }).catch(CatchError);
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }
    $scope.$on("hotlistEditedData", function (evt, data) {
      $scope.hotlist = data;
    });
    $scope.$on("allConsultantsEditedData", function (evt, data) {

      allConsTable.setData(data);
      // $scope.allConsultants = data;
    });
    $scope.$on("allConsultants", function (evt, data) {
      $scope.skills = data;
    });
    $scope.$on("skills", function (evt, data) {
      $scope.skills = data;
    });
    $scope.ViewConsDocs = function (data) {
      $mdDialog.show({
        controller: ViewConsDocsController,
        templateUrl: "app/components/sales/myResources/viewDocDialog.html",
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          consData: data
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = "You cancelled the dialog.";
      });
    };
    function ViewConsDocsController($scope, $mdDialog, consData) {
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.GetconsldocsLoader = true;
      var fileUrlsReq = {
        conslid: consData.ConslId
      };
      dataService.newToken().then(function (response) {
        dataService.Getconsldocs(fileUrlsReq).then(function (response) {
          $scope.GetconsldocsLoader = false;
          $scope.conDocs = response.data;
        }).catch(CatchError);
      }).catch(CatchError);
      $scope.editeditHotlSubmitLoader = false;
      $scope.ConData = consData;
      var obj = {
        loginid: vm.tokenData.loginid,
        conslid: consData.ConslId
      };
      // $scope.conDocs = consData.ListDocUrls;

      $scope.getFile = function (data, furl) {
        var re = /(?:\.([^.]+))?$/;
        obj = {
          loginid: vm.tokenData.loginid,
          conslid: data.ConslId,
          FileUrl: furl,
          FileExt: re.exec(furl)[1]
        };
        dataService.newToken().then(function (response) {
          dataService.Getfileurl(obj).then(function (response) {
            $scope.file = response.data;
            // var fileType = ""
            var file = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, ""));

            var isChrome = !!window.chrome && !!window.chrome.app;
            var isIE = /*@cc_on!@*/false || !!document.documentMode;
            var isEdge = !isIE && !!window.StyleMedia;

            if (isChrome) {
              var url = window.URL || window.webkitURL;

              var downloadLink = angular.element("<a></a>");
              downloadLink.attr("href", "data:application/octet-stream; base64," + file);
              downloadLink.attr("target", "_self");
              downloadLink.attr("download", furl);
              downloadLink[0].click();
            } else if (isEdge || isIE) {
              window.navigator.msSaveOrOpenBlob(file, furl);
            } else {
              var fileURL = URL.createObjectURL(file);
              window.open(fileURL);
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };

      // New Doc Add
      $scope.viewDocAdd = false;
      $scope.addDoc = function () {
        $mdSelect.hide();
        $scope.viewDocAdd = true;
        $scope.viewDocAddClose = function () {
          $scope.viewDocAdd = false;
        };

        $scope.addDocData = function (data) {
          dataService.newToken().then(function (response) {
            dataService.InsertDocDD({
              DocName: data
            }).then(function (response) {
              $scope.docDDs = response.data;
              $scope.viewDocAdd = false;
            }).catch(CatchError);
          }).catch(CatchError);
        };
      };
      dataService.newToken().then(function (response) {
        dataService.GetDocDD().then(function (response) {
          $scope.docDDs = response.data;
        }).catch(CatchError);
      }).catch(CatchError);
      $scope.uploadFile = function (data) {
        $scope.files = data;
      };
      $scope.getFileDetails = function (e) {
        $scope.upFiles = e;
        $scope.files = [];
        $scope.$apply(function () {
          for (var i = 0; i < e.files.length; i++) {
            $scope.files.push(e.files[i]);
          }
        });
      };

      // NOW UPLOAD THE FILES.
      $scope.uploadActivated = false;
      $scope.uploadFiles = function (docId) {
        $scope.uploadActivated = true;
        //FILL FormData WITH FILE DETAILS.
        var data = new FormData();
        for (var i in $scope.files) {
          data.append("uploadedFile", $scope.files[i]);
        }
        // ADD LISTENERS.
        var objXhr = new XMLHttpRequest();
        objXhr.addEventListener("progress", updateProgress, false);
        objXhr.addEventListener("load", transferComplete, false);
        // SEND FILE DETAILS TO THE API.
        //objXhr.open("POST", "/api/fileupload/");
        //objXhr.send(data);
        data.append("docId", docId);
        data.append("loginid", vm.tokenData.loginid);
        data.append("conslid", consData.ConslId);
        dataService.newToken().then(function (response) {
          dataService.UploadDocument(data).then(function (response) {
            var toast = $mdToast.simple().content(response.data.Message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $scope.GetconsldocsLoader = true;
            var fileUrlsReq = {
              conslid: consData.ConslId
            };
            dataService.newToken().then(function (response) {
              dataService.Getconsldocs(fileUrlsReq).then(function (response) {
                $scope.GetconsldocsLoader = false;
                $scope.conDocs = response.data;
                $scope.selDocId = null;
                document.getElementById("file").value = "";
                $scope.uploadActivated = false;
              }).catch(CatchError);
            }).catch(CatchError);
          }).catch(CatchError);
        }).catch(CatchError);
      };
      // UPDATE PROGRESS BAR.
      function updateProgress(e) {
        if (e.lengthComputable) {
          document.getElementById("pro").setAttribute("value", e.loaded);
          document.getElementById("pro").setAttribute("max", e.total);
        }
      }
      // CONFIRMATION.
      function transferComplete(e) {
        alert("Files uploaded successfully.");
      }
    }
    $scope.$on("allCons", function (ev, data) {
      $scope.allConsultants = data;
      $timeout(function () {
        if (vm.tokenData.newRole == "MarketerAdmin") {
          $(".allconsultants").DataTable().destroy();
          var uTable13 = $(".allconsultants").DataTable({
            lengthMenu: [[12, 10, 25, 50, -1], [12, 10, 25, 50, "All"]],
            dom: "lBfrtip",
            buttons: function buttons() {
              return ["excelHtml5"];
            }
          });
          uTable13.on("order.dt search.dt", function () {
            uTable13.column(0, {
              search: "applied",
              order: "applied"
            }).nodes().each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
          }).draw();
        } else {
          $(".allconsultants").DataTable().destroy();
          var uTable14 = $(".allconsultants").DataTable({
            lengthMenu: [[12, 10, 25, 50, -1], [12, 10, 25, 50, "All"]]
          });
          uTable14.on("order.dt search.dt", function () {
            uTable14.column(0, {
              search: "applied",
              order: "applied"
            }).nodes().each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
          }).draw();
        }
      });
    });
    $scope.$on("hotlistData", function (evt, data) {
      $scope.hotlist = [];
      for (var i = 0; i < data.length; i++) {
        if (data[i].Active === true) {
          $scope.hotlist.push(data[i]);
        }
      }
      $(".allconsultants").DataTable().destroy();
      $(".hotConsultants").DataTable().destroy();
      $timeout(function () {
        if (vm.tokenData.newRole == "MarketerAdmin") {
          var uTable15 = $(".allconsultants").DataTable({
            lengthMenu: [[12, 10, 25, 50, -1], [12, 10, 25, 50, "All"]],
            dom: "lBfrtip",
            buttons: function buttons() {
              return ["excelHtml5"];
            }
          });
          uTable15.on("order.dt search.dt", function () {
            uTable15.column(0, {
              search: "applied",
              order: "applied"
            }).nodes().each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
          }).draw();
          var uTable16 = $(".hotConsultants").DataTable({
            lengthMenu: [[12, 10, 25, 50, -1], [12, 10, 25, 50, "All"]],
            dom: "lBfrtip",
            buttons: function buttons() {
              return ["excelHtml5"];
            }
          });
          uTable16.on("order.dt search.dt", function () {
            uTable16.column(0, {
              search: "applied",
              order: "applied"
            }).nodes().each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
          }).draw();
        } else {
          var uTable17 = $(".allconsultants").DataTable({
            lengthMenu: [[12, 10, 25, 50, -1], [12, 10, 25, 50, "All"]]
          });
          uTable17.on("order.dt search.dt", function () {
            uTable17.column(0, {
              search: "applied",
              order: "applied"
            }).nodes().each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
          }).draw();
          var uTable18 = $(".hotConsultants").DataTable({
            lengthMenu: [[12, 10, 25, 50, -1], [12, 10, 25, 50, "All"]]
          });
          uTable18.on("order.dt search.dt", function () {
            uTable18.column(0, {
              search: "applied",
              order: "applied"
            }).nodes().each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
          }).draw();
        }
      });
    });
    $scope.loadHotListDataqry = function (data) {
      $scope.loadHotListData = true;
      $scope.hotlistData = data;
    };
    $scope.groupByObj = [{
      name: "None",
      value: ""
    }, {
      name: "Skill",
      value: "Skillset"
    }, {
      name: "Visa Status",
      value: "VisaType"
    }, {
      name: "Recruiter",
      value: "RecruiterName"
    }];
    $scope.getHotList = function () {
      $scope.preloader = true;
      dataService.newToken().then(function (response) {
        dataService.GetHotListConsl().then(function (response) {

          $scope.preloader = false;

          $scope.hotlist = [];
          $scope.benchConsultants = [];
          dataService.newToken().then(function (res) {
            dataService.GetMarketerInfoMrkter().then(function (r) {
              $scope.marketers = r.data;
              for (var i = 0; i < response.data.length; i++) {
                var element = response.data[i];

                if (element.Source === "Dice") {
                  if (element.PrefLocation !== null) {
                    try {
                      element.PrefLocation = JSON.parse(element.PrefLocation)[0]["text"];
                    } catch (e) {}
                  }
                  if (element.CurrentLocation !== null) {
                    try {
                      element.CurrentLocation = JSON.parse(element.CurrentLocation)[0]["text"];
                    } catch (e) {}
                  }
                  if (element.WorkPermit !== null) {
                    try {
                      element.WorkPermit = JSON.parse(element.WorkPermit)[0];
                    } catch (e) {}
                  }
                  if (element.WorkPermitLocations !== null) {
                    try {
                      element.WorkPermitLocations = JSON.parse(element.WorkPermitLocations)[0];
                    } catch (e) {}
                  }
                  if (element.WorkPreferences !== null) {
                    try {
                      element.WorkPreferences = JSON.parse(element.WorkPreferences)[0];
                    } catch (e) {}
                  }
                  if (element.Skillset !== null) {
                    try {
                      element.Skillset = JSON.parse(element.Skillset)[0];
                    } catch (e) {}
                  }
                  if (element.Email !== null) {
                    try {
                      element.Email = JSON.parse(element.Email)[0];
                    } catch (e) {}
                  }
                  if (element.PhoneNumber !== null) {
                    try {
                      element.PhoneNumber = JSON.parse(element.PhoneNumber)[0];
                    } catch (e) {}
                  }
                  if (element.DesiredJobTitles !== null) {
                    try {
                      element.DesiredJobTitles = JSON.parse(element.DesiredJobTitles)[0];
                    } catch (e) {}
                  }
                  if (element.Experience !== null) {
                    try {
                      element.Experience = JSON.parse(element.Experience).history[0].title;
                    } catch (e) {}
                  }
                  if (element.DateLastActive !== null) {
                    try {
                      element.DateLastActive = JSON.stringify(moment(element.DateLastActive).format("MM/DD/YYYY"));
                    } catch (e) {}
                  }
                } else {
                  if (element.Source === null) {
                    element.Source = "teXperts";
                  }
                  element.PrefLocation = "n/a";
                }
                if (element.FirstName !== "") {
                  element.FullName = element.FirstName + " " + element.LastName;
                  if (element.Recuriterid !== null) {
                    if ($scope.marketer === undefined) {
                      for (var _r = 0; _r < $scope.marketers.length; _r++) {
                        var marketer = $scope.marketers[_r];
                        if (marketer.loginid == element.Recuriterid) {
                          element.RecruiterName = marketer.MarkterName;
                        } else if (_r === $scope.marketers.length) {
                          element.RecruiterName = "n/a";
                        }
                      }
                    } else {
                      for (var _r2 = 0; _r2 < $scope.marketers.length; _r2++) {
                        var _marketer = $scope.marketers[_r2];
                        if (_marketer.loginid == element.Recuriterid) {
                          element.RecruiterName = _marketer.MarkterName;
                        } else if (_r2 === $scope.marketers.length) {
                          element.RecruiterName = "n/a";
                        }
                      }
                    }
                  }
                }
              }
              $scope.hotlist = response.data;
              $scope.hotListDataReady = true;

              var EditIcon = function EditIcon(cell, formatterParams, onRendered) {
                //plain text value
                return "<i class='material-icons pointer zoom' style='font-size: 18px;'>edit</i>";
              };
              var ViewIcon = function ViewIcon(cell, formatterParams, onRendered) {
                return "<i class='material-icons pointer zoom' style='font-size: 18px;'>remove_red_eye</i>";
              };

              var ActionIcon = function ActionIcon(cell, formatterParams, onRendered) {
                return "<i class='material-icons remove-btn pointer zoom' style='font-size: 20px;font-weight: bolder;'>swap_horiz</i>";
              };
              var AllConsActionIcon = function AllConsActionIcon(cell, formatterParams, onRendered) {
                var data = cell.getRow();
                if (data._row.data.Active) {
                  return "<span class='hotlisted'>HotListed</span>";
                } else {
                  return "<i class='material-icons remove-btn pointer zoom' style='font-size: 20px;font-weight: bolder;'>swap_horiz</i>";
                }
              };
              var showByRole = false;
              if (vm.tokenData.role !== "Marketer") {
                showByRole = true;
              }
              hotlisttable = new Tabulator("#hoList-table", {
                data: $scope.hotlist,
                height: heightCanBe,
                layout: "fitData",
                pagination: "local",
                paginationSize: 20,
                paginationSizeSelector: [20, 30, 40, 50],
                groupBy: "",
                groupStartOpen: false,
                groupToggleElement: "header",
                selectable: false,
                tooltips: true,
                tooltipsHeader: true,
                columns: [{
                  formatter: "rownum",
                  align: "center",
                  width: 40,
                  sorter: false
                }, {
                  title: "Name",
                  field: "FullName",
                  width: 210
                }, {
                  title: "Skill",
                  field: "Skillset",
                  width: 120
                }, {
                  title: "Email",
                  field: "Email",
                  width: 210
                }, {
                  title: "Recruiter",
                  field: "RecruiterName"
                }, {
                  title: "PhoneNumber",
                  field: "PhoneNumber"
                }, {
                  title: "DOB",
                  field: "DOB",
                  formatter: "datetime",
                  formatterParams: {
                    inputFormat: "YYYY-MM-DD",
                    outputFormat: "MM/DD/YY",
                    invalidPlaceholder: "n/a"
                  }
                }, {
                  title: "Visa Status",
                  field: "VisaType"
                }, {
                  title: "US Entry Date",
                  field: "USEntryDate",
                  formatter: "datetime",
                  formatterParams: {
                    inputFormat: "YYYY-MM-DD",
                    outputFormat: "MM/DD/YY",
                    invalidPlaceholder: "n/a"
                  }
                }, {
                  title: "Min Pay Rate",
                  field: "ExpectedRate"
                }, {
                  title: "GH",
                  field: "GK",
                  formatter: "tickCross",
                  formatterParams: {
                    allowEmpty: true,
                    allowTruthy: true,
                    tickElement: "<i class='fa fa-check'></i>",
                    crossElement: "<i class='fa fa-times'></i>"
                  }
                }, {
                  title: "Prefer Location",
                  field: "PrefLocation",
                  width: 100
                }, {
                  title: "Exp",
                  field: "Exp"
                }, {
                  title: "SSN",
                  field: "SSN",
                  width: 100
                }, {
                  title: "Skype ID",
                  field: "SkypeId",
                  formatter: function formatter(cell, formatterParams, onRendered) {
                    var val = cell.getValue();
                    if (val) {
                      return val;
                    } else {
                      return "n/a";
                    }
                  }
                }, {
                  title: "Source",
                  field: "Source",
                  width: 100
                }, {
                  formatter: ActionIcon,
                  title: "Action",
                  cellClick: function cellClick(e, cell) {
                    var data = cell.getRow();
                    inactivateConsultant(data._row.data);
                    $scope.$on("hotlistData", function (evt, data) {
                      hotlisttable.replaceData(data);
                    });
                  },
                  visible: showByRole
                }, {
                  formatter: EditIcon,
                  title: "Edit",
                  cellClick: function cellClick(e, cell) {
                    var data = cell.getRow();
                    $scope.EditHotListItem(data._row.data, "hotlist");
                    // hotlisttable.updateData(data);
                    $scope.$on("hotlistEditedData", function (evt, data) {
                      hotlisttable.replaceData(data);
                    });
                  }
                }, {
                  formatter: ViewIcon,
                  title: "Activity",
                  cellClick: function cellClick(e, cell) {
                    var data = cell.getRow();
                    $scope.activity(null, null, data._row.data);
                  }
                }]
              });

              var res = $(".ssn").text(),
                  len = res.length,
                  stars = len > 0 ? len > 1 ? len > 2 ? len > 3 ? len > 4 ? "XXX-XX-" : "XXX-X" : "XXX-" : "XX" : "X" : "",
                  result = stars + res.substring(5);
              $("#ssn").text(result);
            });
          }).catch(CatchError);
        });
      }).catch(CatchError);
      $scope.hotListDownload = function () {
        hotlisttable.download("csv", "data.csv");
      };
      $scope.allConsDownload = function () {
        // $("#allCons-table").tabulator("redraw", true);
        hotlisttable.redraw(true);
        allConsTable.download("xlsx", "data.xlsx", {
          sheetName: "MyData"
        });
      };
      $scope.allConsGroupBy = function (value) {
        allConsTable.setGroupBy(value);
        allConsTable.tabulator("redraw", true);
      };
      $scope.hotListGroupBy = function (value) {
        hotlisttable.setGroupBy(value);
        hotlisttable.tabulator("redraw", true);
      };

      function matchAny(data, filterParams) {
        var match = false;
        for (var key in data) {
          if (key == "FullName" || key == "Email" || key == "Skillset" || key == "VisaType") {
            var keyData = data[key];
            if (keyData !== null && keyData !== undefined) {
              keyData = keyData.toLowerCase();
              var param = filterParams.value.toLowerCase();
              if (JSON.stringify(keyData).search(param) != -1) {
                match = true;
              }
            }
          }
        }
        return match;
      }
      $scope.allConsSearch = function (data) {
        allConsTable.setFilter(matchAny, {
          value: data
        });
      };
      $scope.allhotListSearch = function (data) {
        hotlisttable.setFilter(matchAny, {
          value: data
        });
      };
      $scope.activity = function (jbId, SkId, ConId) {
        $mdDialog.show({
          controller: viewActivityController,
          templateUrl: "app/components/sales/jobpostings/viewActivity.html",
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          locals: {
            ConId: ConId,
            marketers: $scope.marketers,
            vendors: $scope.Vendors,
            clients: $scope.Clients
          }
        });
      };

      function viewActivityController(ConId, marketers, vendors, clients, $scope, $sce) {
        $scope.dataLoader = true;
        dataService.newToken().then(function (response) {
          dataService.Interviewlookup().then(function (resp) {
            vm.InterviewModes = resp.data.LstImode;
            vm.InterviewLevels = resp.data.LstILevel;
            vm.Statuses = resp.data.LstInvStatus;
            $scope.ConActivity = [];
            var req = {
              ConslId: ConId.ConslId
            };
            dataService.newToken().then(function (response) {
              dataService.GetInvActivityByConslid(req).then(function (response) {
                for (var index = 0; index < response.data.length; index++) {
                  var InnerList = response.data[index].listofEventDetails;
                  for (var ingo = 0; ingo < InnerList.length; ingo++) {
                    var element = InnerList[ingo];
                    if (element.EventStatus === 0) {
                      element.EventStatus = 3;
                    }
                    var client = _.filter(clients, function (v) {
                      return _.includes([element.ClientId], v.ClientId);
                    });
                    var vendor = _.filter(vendors, function (v) {
                      return _.includes([element.VendorId], v.vendorModel.VendorId);
                    });
                    var Imode = _.filter(vm.InterviewModes, function (v) {
                      return _.includes([element.IntMode.IKey], v.IKey);
                    });
                    var Ilvel = _.filter(vm.InterviewLevels, function (v) {
                      return _.includes([element.IntLevel.IKey], v.IKey);
                    });
                    var status = _.filter(vm.Statuses, function (v) {
                      return _.includes([element.EventStatus], v.IKey);
                    });
                    var marketer = _.filter(marketers, function (v) {
                      return _.includes([element.MarketerId], v.loginid);
                    });
                    var obj = {
                      id: element.EventId,
                      title: element.FirstName,
                      start: element.StartDate,
                      marketer: marketer[0].MarkterName,
                      MarkterId: element.MarketerId,
                      url: element.MeetingUrl,
                      modeOfInterview: Imode[0].IValue,
                      levelOfInterview: Ilvel[0].IValue,
                      IntMode: element.IntMode.IKey,
                      IntLevel: element.IntLevel.IKey,
                      comments: element.EventComments,
                      end: element.EndDate,
                      allDay: false,
                      status: status[0].IValue,
                      Client: client[0].ClientName,
                      VendorId: vendor[0].VendorName,
                      CreateDate: element.CreateDate,
                      InterviewId: element.InterviewId,
                      ConslId: element.ConslId,
                      FinalStatus: element.FinalStatus,
                      cid: element.ClientId,
                      vid: element.VendorId,
                      DocUrl: element.DocUrl
                    };
                    $scope.ConActivity.push(obj);
                  }
                }
                $scope.ConActivity = _.chain($scope.ConActivity).groupBy("Client").map(function (value, key) {
                  return {
                    Client: key,
                    title: value[0].title,
                    Invs: _.chain(value).groupBy("InterviewId").map(function (value, key) {
                      return {
                        InterviewId: key,
                        InvDetails: value
                      };
                    }).value()
                  };
                }).value();

                $timeout(function () {
                  var toggler = document.getElementsByClassName("caret");
                  var i;

                  for (i = 0; i < toggler.length; i++) {
                    toggler[i].addEventListener("click", function () {
                      this.parentElement.querySelector(".nested").classList.toggle("active");
                      this.classList.toggle("caret-down");
                    });
                  }
                });
                $scope.dataLoader = false;
              });
            }).catch(CatchError);
          });
        }).catch(CatchError);
        $scope.downloadResumLoader = false;

        $scope.downloadResum = function (id, url) {
          $scope.downloadResumLoader = true;
          var obj = {
            InterviewId: id,
            FileUrl: url
          };
          dataService.newToken().then(function (response) {
            dataService.DownloadResume(obj).then(function (response) {
              var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
                return data + String.fromCharCode(byte);
              }, ""));
              var anchor = $("<a/>");
              anchor.attr({
                href: "data:application/octet-stream; base64," + base64,
                target: "_blank",
                download: url
              })[0].click();
              $scope.downloadResumLoader = false;
            }).catch(CatchError);
          }).catch(CatchError);
        };
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
        $scope.moreConInfo = function (con) {
          $scope.SelectedCon = con;
        };
      }
      $scope.$on("hotlistData", function (evt, data) {
        hotlisttable.replaceData(data);
      });
    };
    $scope.getConsultants = function () {
      $scope.topLoader = true;
      dataService.newToken().then(function (response) {
        dataService.GetConsls().then(function (response) {

          $scope.topLoader = false;
          for (var i = 0; i < response.data.length; i++) {
            var element = response.data[i];
            if (element.Source === "Dice") {
              if (element.PrefLocation !== null) {
                try {
                  element.PrefLocation = JSON.parse(element.PrefLocation)[0]["text"];
                } catch (e) {}
              }
              if (element.CurrentLocation !== null) {
                try {
                  element.CurrentLocation = JSON.parse(element.CurrentLocation)[0]["text"];
                } catch (e) {}
              }
              if (element.WorkPermit !== null) {
                try {
                  element.WorkPermit = JSON.parse(element.WorkPermit)[0];
                } catch (e) {}
              }
              if (element.WorkPermitLocations !== null) {
                try {
                  element.WorkPermitLocations = JSON.parse(element.WorkPermitLocations)[0];
                } catch (e) {}
              }
              if (element.WorkPreferences !== null) {
                try {
                  element.WorkPreferences = JSON.parse(element.WorkPreferences)[0];
                } catch (e) {}
              }
              if (element.Skillset !== null) {
                try {
                  element.Skillset = JSON.parse(element.Skillset)[0];
                } catch (e) {}
              }
              if (element.Email !== null) {
                try {
                  element.Email = JSON.parse(element.Email)[0];
                } catch (e) {}
              }
              if (element.PhoneNumber !== null) {
                try {
                  element.PhoneNumber = JSON.parse(element.PhoneNumber)[0];
                } catch (e) {}
              }
              if (element.DesiredJobTitles !== null) {
                try {
                  element.DesiredJobTitles = JSON.parse(element.DesiredJobTitles)[0];
                } catch (e) {}
              }
              if (element.Experience !== null) {
                try {
                  element.Experience = JSON.parse(element.Experience).history[0].title;
                } catch (e) {}
              }
              if (element.DateLastActive !== null) {
                try {
                  element.DateLastActive = JSON.stringify(moment(element.DateLastActive).format("MM/DD/YYYY"));
                } catch (e) {}
              }
            }
            if (element.FirstName !== "") {
              element.FullName = element.FirstName + " " + element.LastName;
              if (element.Recuriterid !== null) {
                for (var r = 0; r < $scope.marketers.length; r++) {
                  var rele = $scope.marketers[r];
                  if (rele.loginid == element.Recuriterid) {
                    element.RecruiterName = rele.MarkterName;
                    break;
                  } else {
                    element.RecruiterName = "Not Assigned";
                  }
                }
              }
            }
          }

          $scope.allConsultants = "";
          $scope.allConsultants = _.sortBy(response.data, ["FirstName"]);
          var EditIcon = function EditIcon(cell, formatterParams, onRendered) {
            //plain text value
            return "<i class='material-icons pointer zoom' style='font-size: 18px;'>edit</i>";
          };
          var ViewIcon = function ViewIcon(cell, formatterParams, onRendered) {
            return "<i class='material-icons pointer zoom' style='font-size: 18px;'>remove_red_eye</i>";
          };

          var ActionIcon = function ActionIcon(cell, formatterParams, onRendered) {
            return "<i class='material-icons remove-btn pointer zoom' style='font-size: 20px;font-weight: bolder;'>swap_horiz</i>";
          };
          var AllConsActionIcon = function AllConsActionIcon(cell, formatterParams, onRendered) {
            var data = cell.getRow();
            if (data._row.data.Active) {
              return "<span class='hotlisted'>HotListed</span>";
            } else {
              return "<i class='material-icons remove-btn pointer zoom' style='font-size: 20px;font-weight: bolder;'>swap_horiz</i>";
            }
          };
          var showByRole = false;

          if (vm.tokenData.role !== "Marketer") {
            showByRole = true;
          }
          allConsTable = new Tabulator("#allCons-table", {
            height: heightCanBe,
            layout: "fitData",
            pagination: "local",
            paginationSize: 20,
            paginationSizeSelector: [20, 30, 40, 50],
            groupBy: "",
            groupStartOpen: false,
            groupToggleElement: "header",
            selectable: false,
            clipboard: true,
            clipboardCopyStyled: false,
            persistence: {
              sort: true,
              filter: true
            },
            tooltips: true,
            tooltipsHeader: true,
            persistenceID: "allCons-tablepersistenceID",
            columns: [{
              formatter: "rownum",
              align: "center",
              width: 40,
              sorter: false
            }, {
              title: "FullName",
              field: "FullName",
              width: 200
            }, {
              title: "Skill",
              field: "Skillset"
            }, {
              title: "Email",
              field: "Email",
              width: 200
            }, {
              title: "Recruiter",
              field: "RecruiterName"
            }, {
              title: "PhoneNumber",
              field: "PhoneNumber"
            }, {
              title: "DOB",
              field: "DOB",
              formatter: "datetime",
              formatterParams: {
                inputFormat: "YYYY-MM-DD",
                outputFormat: "MM/DD/YY",
                invalidPlaceholder: "n/a"
              }
            }, {
              title: "VisaStatus",
              field: "VisaType"
            }, {
              title: "US Entry Date",
              field: "USEntryDate",
              formatter: "datetime",
              formatterParams: {
                inputFormat: "YYYY-MM-DD",
                outputFormat: "MM/DD/YY",
                invalidPlaceholder: "n/a"
              }
            }, {
              title: "GH",
              field: "GK",
              formatter: "tickCross",
              formatterParams: {
                allowEmpty: true,
                allowTruthy: true,
                tickElement: "<i class='fa fa-check'></i>",
                crossElement: "<i class='fa fa-times'></i>"
              }
            }, {
              title: "GH Moved Date",
              field: "GKMoveInDate",
              formatter: "datetime",
              formatterParams: {
                inputFormat: "YYYY-MM-DD",
                outputFormat: "MM/DD/YY",
                invalidPlaceholder: "n/a"
              }
            }, {
              title: "Prefer Location",
              field: "PrefLocation"
            }, {
              title: "Exp",
              field: "Exp"
            }, {
              title: "SSN",
              field: "SSN",
              width: 100
            }, {
              title: "Source",
              field: "Source",
              width: 100
            }, {
              formatter: AllConsActionIcon,
              title: "Action",
              align: "center",
              cellClick: function cellClick(e, cell) {
                var data = cell.getRow();
                if (!data._row.data.Active) {
                  $scope.activateConsultant(data._row.data);
                }
                $scope.$on("activateConData", function (evt, data, allcons) {
                  allConsTable.replaceData(allcons);
                });
              },
              visible: showByRole
            }, {
              formatter: EditIcon,
              title: "Edit",
              cellClick: function cellClick(e, cell) {
                var data = cell.getRow();
                $scope.EditHotListItem(data._row.data, "allcons");
                // hotlisttable.updateData(data);
                $scope.$on("hotlistEditedData", function (evt, data, allcons) {
                  allConsTable.replaceData(allcons);
                });
              }
            }, {
              formatter: ViewIcon,
              title: "Docs",
              cellClick: function cellClick(e, cell) {
                var data = cell.getRow();
                $scope.ViewConsDocs(data._row.data);
              }
            }, {
              formatter: ViewIcon,
              title: "Activity",
              cellClick: function cellClick(e, cell) {
                var data = cell.getRow();
                $scope.activity(null, null, data._row.data.ConslId);
              }
            }]
          });
          allConsTable.setData($scope.allConsultants);

          var res = $(".ssn").text(),
              len = res.length,
              stars = len > 0 ? len > 1 ? len > 2 ? len > 3 ? len > 4 ? "XXX-XX-" : "XXX-X" : "XXX-" : "XX" : "X" : "",
              result = stars + res.substring(5);
          $("#ssn").text(result);

          $scope.activity = function (jbId, SkId, ConId) {
            $mdDialog.show({
              controller: viewActivityController,
              templateUrl: "app/components/sales/jobpostings/viewActivity.html",
              parent: angular.element(document.body),
              clickOutsideToClose: false,
              locals: {
                ConId: ConId,
                marketers: $scope.marketers,
                vendors: $scope.Vendors,
                clients: $scope.Clients,
                allConsultants: $scope.allConsultants
              }
            });
          };

          function viewActivityController(ConId, marketers, vendors, clients, allConsultants, $scope, $sce) {
            $scope.dataLoader = true;
            dataService.newToken().then(function (response) {
              dataService.Interviewlookup().then(function (resp) {
                vm.InterviewModes = resp.data.LstImode;
                vm.InterviewLevels = resp.data.LstILevel;
                vm.Statuses = resp.data.LstInvStatus;
                $scope.ConActivity = [];
                var req = {
                  ConslId: ConId
                };
                dataService.newToken().then(function (response) {
                  dataService.GetInvActivityByConslid(req).then(function (response) {
                    for (var index = 0; index < response.data.length; index++) {
                      var InnerList = response.data[index].listofEventDetails;
                      for (var ingo = 0; ingo < InnerList.length; ingo++) {
                        var element = InnerList[ingo];
                        if (element.EventStatus === 0) {
                          element.EventStatus = 3;
                        }
                        var client = _.filter(clients, function (v) {
                          return _.includes([element.ClientId], v.ClientId);
                        });
                        var vendor = _.filter(vendors, function (v) {
                          return _.includes([element.VendorId], v.vendorModel.VendorId);
                        });
                        var consultant = _.filter(allConsultants, function (v) {
                          return _.includes([element.ConslId], v.ConslId);
                        });
                        var Imode = _.filter(vm.InterviewModes, function (v) {
                          return _.includes([element.IntMode.IKey], v.IKey);
                        });
                        var Ilvel = _.filter(vm.InterviewLevels, function (v) {
                          return _.includes([element.IntLevel.IKey], v.IKey);
                        });
                        var status = _.filter(vm.Statuses, function (v) {
                          return _.includes([element.EventStatus], v.IKey);
                        });
                        var marketer = _.filter(marketers, function (v) {
                          return _.includes([element.MarketerId], v.loginid);
                        });
                        var obj = {
                          id: element.EventId,
                          title: consultant[0].FirstName + " " + consultant[0].LastName,
                          start: element.StartDate,
                          marketer: marketer[0].MarkterName,
                          MarkterId: element.MarketerId,
                          url: element.MeetingUrl,
                          modeOfInterview: Imode[0].IValue,
                          levelOfInterview: Ilvel[0].IValue,
                          IntMode: element.IntMode.IKey,
                          IntLevel: element.IntLevel.IKey,
                          comments: element.EventComments,
                          end: element.EndDate,
                          allDay: false,
                          status: status[0].IValue,
                          Client: client[0].ClientName,
                          VendorId: vendor[0].VendorName,
                          CreateDate: element.CreateDate,
                          InterviewId: element.InterviewId,
                          ConslId: element.ConslId,
                          FinalStatus: element.FinalStatus,
                          cid: element.ClientId,
                          vid: element.VendorId,
                          DocUrl: element.DocUrl
                        };
                        $scope.ConActivity.push(obj);
                      }
                    }
                    $scope.ConActivity = _.chain($scope.ConActivity).groupBy("Client").map(function (value, key) {
                      return {
                        Client: key,
                        title: value[0].title,
                        Invs: _.chain(value).groupBy("InterviewId").map(function (value, key) {
                          return {
                            InterviewId: key,
                            InvDetails: value
                          };
                        }).value()
                      };
                    }).value();

                    $timeout(function () {
                      var toggler = document.getElementsByClassName("caret");
                      var i;

                      for (i = 0; i < toggler.length; i++) {
                        toggler[i].addEventListener("click", function () {
                          this.parentElement.querySelector(".nested").classList.toggle("active");
                          this.classList.toggle("caret-down");
                        });
                      }
                      $scope.dataLoader = false;
                    });
                  });
                }).catch(CatchError);
                $scope.downloadResum = function (id, url) {
                  $scope.downloadResumLoader = true;
                  var obj = {
                    InterviewId: id,
                    FileUrl: url
                  };
                  dataService.newToken().then(function (response) {
                    dataService.DownloadResume(obj).then(function (response) {
                      var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
                        return data + String.fromCharCode(byte);
                      }, ""));
                      var anchor = $("<a/>");
                      anchor.attr({
                        href: "data:application/octet-stream; base64," + base64,
                        target: "_blank",
                        download: url
                      })[0].click();
                      $scope.downloadResumLoader = false;
                    }).catch(CatchError);
                  }).catch(CatchError);
                };
                $scope.cancel = function () {
                  $mdDialog.cancel();
                };
                $scope.moreConInfo = function (con) {
                  $scope.SelectedCon = con;
                };
              }).catch(CatchError);
            }).catch(CatchError);
          }
        }).catch(CatchError);
      }).catch(CatchError);
      $scope.allConsDownload = function () {
        // $("#allCons-table").tabulator("redraw", true);
        allConsTable.download("xlsx", "data.xlsx", {
          sheetName: "MyData"
        });
      };
      $scope.allConsGroupBy = function (value) {
        allConsTable.setGroupBy(value);
        allConsTable.tabulator("redraw", true);
      };

      function matchAny(data, filterParams) {
        var match = false;
        for (var key in data) {
          if (key == "FullName" || key == "Email" || key == "Skillset" || key == "VisaType") {
            var keyData = data[key];
            if (keyData !== null && keyData !== undefined) {
              keyData = keyData.toLowerCase();
              var param = filterParams.value.toLowerCase();
              if (JSON.stringify(keyData).search(param) != -1) {
                match = true;
              }
            }
          }
        }
        return match;
      }
      $scope.allConsSearch = function (data) {
        allConsTable.setFilter(matchAny, {
          value: data
        });
      };
    };
  }
})();


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  angular.module('app').component('myInterviews', {
    controller: MyInterviewsController,
    controllerAs: 'vm',
    templateUrl: 'app/components/sales/myInterviewStats/myInterviewStats.component.html'
  });

  function MyInterviewsController($scope, dataService, $http, $timeout, $location, moment, $state) {
    var vm = this;
    vm.tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.go = function (path) {
      $state.go(path);
    };
    var interviewsTable;
    $scope.deactivate = false;
    $scope.activate = false;
    $scope.addNewPlacement = false;
    $scope.addTitleShow = false;
    $scope.showTable = false;
    $scope.showAllInterviews = true;
    $scope.confirmed = [];
    $scope.Rejected = [];
    $scope.New = [];
    $scope.Placed = [];
    $scope.topLoader = false;

    var heightCanBe = window.innerHeight - 180 + 'px';
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 180 + 'px';
      interviewsTable.setHeight(heightCanBe);
      interviewsTable.redraw();
    });
    $scope.SelectedYear = moment().format('YYYY');
    $scope.getinterviewdetails = function (year) {
      $scope.topLoader = true;
      var reqdata = {
        MarketerId: angular.fromJson(vm.tokenData.loginid),
        Year: year
      };
      $scope.allplacedint = '';
      dataService.newToken().then(function (response) {
        dataService.GetAllPlacedIntviewDetailsByMarketerId(reqdata).then(function (response) {
          for (var index = 0; index < response.data.length; index++) {
            var element = response.data[index];
            if (element.InvMode == 1) {
              element.InvModeValue = 'Zoom';
            } else if (element.InvMode == 2) {
              element.InvModeValue = 'WebEx';
            } else if (element.InvMode == 3) {
              element.InvModeValue = 'Skype';
            } else if (element.InvMode == 4) {
              element.InvModeValue = 'Skype For Business';
            } else if (element.InvMode == 5) {
              element.InvModeValue = 'Phone';
            } else if (element.InvMode == 6) {
              element.InvModeValue = 'F2F';
            } else if (element.InvMode == 7) {
              element.InvModeValue = 'BlueJeans';
            }
            if (element.Status == 1) {
              element.StatusValue = 'Confirmed';
              $scope.confirmed.push(element);
            } else if (element.Status == 2) {
              element.StatusValue = 'Rejected';
              $scope.Rejected.push(element);
            } else if (element.Status == 3) {
              element.StatusValue = 'New';
              $scope.New.push(element);
            } else if (element.Status == 4) {
              element.StatusValue = 'Placed';
              $scope.Placed.push(element);
            } else if (element.Status === 0) {
              element.Status = 3;
              element.StatusValue = 'New';
              $scope.New.push(element);
            }
          }
          $scope.topLoader = false;
          $scope.individualInterviews = response.data;
          $timeout(function () {
            var _ref;

            interviewsTable = new Tabulator('#byMarketerId', (_ref = {
              height: heightCanBe,
              layout: 'fitDataFill',
              pagination: 'local',
              paginationSize: 20,
              paginationSizeSelector: [20, 30, 40, 50],
              groupBy: '',
              groupStartOpen: false,
              groupToggleElement: 'header',
              selectable: false,
              clipboard: true,
              clipboardCopyStyled: false,
              data: $scope.individualInterviews,
              tooltips: true,
              tooltipsHeader: true
            }, _defineProperty(_ref, 'tooltips', function tooltips(cell) {
              return cell.getColumn().getField() + ' - ' + cell.getValue();
            }), _defineProperty(_ref, 'tooltipGenerationMode', 'hover'), _defineProperty(_ref, 'columns', [{
              formatter: 'rownum',
              align: 'center',
              width: 40,
              sorter: false
            }, { title: 'Name', field: 'ConslFirstName', width: 210 }, {
              title: 'MarketerFirstName',
              field: 'MarketerFirstName',
              width: 120
            }, {
              title: 'ClientName',
              field: 'ClientName',
              width: 210
            }, {
              title: 'VendorName',
              field: 'VendorName'
            }, {
              title: 'StartDate',
              field: 'StartDate',
              formatter: 'datetime',
              formatterParams: {
                inputFormat: 'YYYY-MM-DD',
                outputFormat: 'MM/DD/YY',
                invalidPlaceholder: 'n/a'
              }
            }, {
              title: 'InvModeValue',
              field: 'InvModeValue'
            }, {
              title: 'StatusValue',
              field: 'StatusValue'
            }, {
              title: 'CreateDate',
              field: 'CreateDate',
              formatter: 'datetime',
              formatterParams: {
                inputFormat: 'YYYY-MM-DD',
                outputFormat: 'MM/DD/YY',
                invalidPlaceholder: 'n/a'
              }
            }, {
              title: 'Comments',
              field: 'Comments',
              width: 100
            }]), _ref));

            // var ctx = document.getElementById('myChart').getContext('2d');
            // var chart = new Chart(ctx, {
            //   type: 'bar',
            //   data: {
            //     labels: ['Rejected', 'InProgress', 'Placed'],
            //     datasets: [
            //       {
            //         backgroundColor: ['#853a41', '#124b8d', '#2c673a'],
            //         data: [
            //           $scope.Rejected.length,
            //           $scope.New.length,
            //           $scope.Placed.length
            //         ]
            //       }
            //     ]
            //   },
            //   options: {
            //     legend: false,
            //     tooltips: true,
            //     responsive: true,
            //     maintainAspectRatio: false
            //   }
            // });
          });
        });
      }).catch(CatchError);
    };
    $scope.getinterviewdetails(angular.fromJson($scope.SelectedYear));

    $scope.InterviewStatuses = [{
      id: 1,
      value: 'Confirmed'
    }, {
      id: 2,
      value: 'Rejected'
    }, {
      id: 3,
      value: 'New'
    }, {
      id: 4,
      value: 'Placed'
    }];
  }
})();


(function () {
  "use strict";

  angular.module("app").component("massMail", {
    controller: MassMailController,
    controllerAs: "vm",
    templateUrl: "app/components/sales/massMail/massMail.component.html"
  });

  function MassMailController($scope, dataService, $http, $timeout, $mdDialog, $mdToast, $q, $state) {
    var vm = this;
    $scope.tokenData = angular.fromJson(localStorage.getItem("tokenData"));
    $scope.mailer = {
      Sender: $scope.tokenData.email,
      Body: "<p>Hello @@DisplayName</p>"
    };
    $scope.mailer.lstRecpEmail = [];
    vm.countInfoReady = false;
    vm.gridOptions = {};
    $scope.validEmails = [];
    $scope.topLoader = true;
    var contactsTable;
    var heightCanBe = window.innerHeight - 120 + "px";
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 120 + "px";
      if (contactsTable !== undefined) {
        contactsTable.setHeight(heightCanBe);
        contactsTable.redraw();
      }
    });
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };
    $scope.topLoader = true;

    function loadData($q) {
      var promiseGetEmailCountDetails = dataService.GetEmailCountDetails({
        Loginid: $scope.tokenData.loginid
      });
      var GetContactsListvar = dataService.GetContactsList({
        Loginid: $scope.tokenData.loginid
      });

      return $q.all([promiseGetEmailCountDetails, GetContactsListvar]);
    }
    dataService.newToken().then(function (response) {
      loadData($q).then(function (resp) {
        vm.UserLimits = resp[0].data;
        $scope.UserLimits = resp[0].data;
        if (vm.UserLimits.EmailsUsed >= vm.UserLimits.LimitPerMonth) {
          $scope.hasLimit = false;
        } else {
          $scope.hasLimit = true;
        }
        $scope.ContactsList = resp[1].data;
        $scope.topLoader = false;
      }).catch(function (error) {
        if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
          var message = "Your Session is Expired, Please login again";
          $scope.authenticated = false;
          var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
          $mdToast.show(toast);
          localStorage.clear();
          $state.go("signin");
        }
      });
    }).catch(CatchError);

    $scope.getFileDetails = function (e) {
      $scope.upFiles = e;
      $scope.files = [];
      $scope.$apply(function () {
        for (var i = 0; i < e.files.length; i++) {
          $scope.files.push(e.files[i]);
        }
      });
    };
    $scope.viewList = function () {
      $scope.viewContactListView = false;
    };
    $scope.addList = function () {
      $scope.viewContactListView = true;
      $scope.ListUploadingView = true;
    };
    $scope.cancelUploading = function () {
      $scope.viewContactListView = false;
      $scope.ListUploadingView = false;
    };
    $scope.viewContactList = function (id) {
      $scope.topLoader = true;
      $scope.ListUploadingView = false;
      dataService.newToken().then(function (response) {
        dataService.GetContactListData({
          McontactId: id
        }).then(function (response) {
          $scope.topLoader = false;
          $scope.viewContactListView = true;
          $timeout(function () {
            contactsTable = new Tabulator("#contacts-table", {
              height: heightCanBe,
              layout: "fitColumns",
              pagination: "local",
              paginationSize: 20,
              paginationSizeSelector: [100, 200, 300, 400, 500],
              groupToggleElement: "header",
              persistence: {
                sort: true,
                filter: true,
                columns: true
              },
              tooltips: true,
              tooltipsHeader: true,
              persistenceID: "byMarketerIdpersistenceID",
              columns: [{
                formatter: "rowSelection",
                titleFormatter: "rowSelection",
                align: "center",
                width: 5,
                headerSort: false,
                cellClick: function cellClick(e, cell) {
                  cell.getRow().toggleSelect();
                }
              }, {
                formatter: "rownum",
                align: "center",
                headerSort: false,
                width: 5
              }, {
                title: "First Name",
                field: "FirstName",
                downloadTitle: "FirstName"
              }, {
                title: "Last Name",
                field: "LastName",
                downloadTitle: "LastName"
              }, {
                title: "Email",
                field: "Email",
                downloadTitle: "Email"
              }]
            });
            contactsTable.setData(response.data);
          });
          // $scope.ListData = response.data;
        });
      }).catch(CatchError);
    };$scope.download = function () {
      contactsTable.download("csv", "data.csv", {
        bom: true
      });
    };
    $scope.contactListAddFS = function (data) {
      vm.stopSpinner = true;
      $scope.topLoader = true;
      var formData = new FormData();
      formData.append("loginid", $scope.tokenData.loginid);
      formData.append("file", $scope.files[0]);
      dataService.newToken().then(function (response) {
        dataService.UploadContactsList(formData).then(function (response) {
          vm.stopSpinner = false;
          $scope.topLoader = false;
          $scope.viewContactListView = true;
          $scope.ListUploadingView = false;
          $timeout(function () {
            contactsTable = new Tabulator("#contacts-table", {
              height: heightCanBe,
              layout: "fitColumns",
              pagination: "local",
              paginationSize: 20,
              paginationSizeSelector: [100, 200, 300, 400, 500],
              groupToggleElement: "header",
              persistence: {
                sort: true,
                filter: true,
                columns: true
              },
              tooltips: true,
              tooltipsHeader: true,
              persistenceID: "contactstablepersistenceID",
              columns: [{
                formatter: "rowSelection",
                titleFormatter: "rowSelection",
                align: "center",
                width: 5,
                headerSort: false,
                cellClick: function cellClick(e, cell) {
                  cell.getRow().toggleSelect();
                }
              }, {
                formatter: "rownum",
                align: "center",
                headerSort: false,
                width: 5
              }, {
                title: "First Name",
                field: "FirstName"
              }, {
                title: "Last Name",
                field: "LastName"
              }, {
                title: "Email",
                field: "Email"
              }]
            });
            contactsTable.setData(response.data);
          });
        });
      }).catch(CatchError);
    };$scope.addToToList = function () {
      $scope.ToList = contactsTable.getSelectedData();
      // $scope.$broadcast('xlxJson', $scope.ToList);
      var emailsLeft = vm.UserLimits.LimitPerMonth - vm.UserLimits.EmailsUsed;
      if ($scope.ToList.length > emailsLeft) {
        $scope.hasLimit = false;
      } else {
        $scope.mailer.lstRecpEmail = $scope.ToList;
      }
    };

    $scope.prevent = function (event) {
      event.preventDefault();
    };$scope.newEmailAc = {};$scope.newEmailAcMethod = function (data) {
      data.loginid = $scope.tokenData.loginid;
      $scope.mailer.lstRecpEmail.push(data);
      $scope.newEmailAc = {
        FirstName: null,
        LastName: null,
        Email: null
      };
    };vm.removeEmail = function (index) {
      $scope.mailer.lstRecpEmail.splice(index, 1);
    };$scope.delSheetLoader = false;$scope.delContSheet = function (d, i) {
      $scope.d = d;
      $scope.i = i;
      $("#delContSheetConfirm").modal("show");
    };
    $scope.delContSheetSubmit = function () {
      $scope.d.delSheetLoader = true;
      dataService.newToken().then(function (response) {
        dataService.DelContactList({
          "McontactId": $scope.d.McontactId
        }).then(function () {
          $scope.d.delSheetLoader = false;
          $scope.ContactsList.splice($scope.i, 1);
          $("#delContSheetConfirm").modal("hide");
        });
      }).catch(CatchError);
    };

    // $scope.$on('xlxJson', function(evt, data) {
    //   var emailCountBefore =
    //     vm.UserLimits.EmailsUsed + $scope.mailer.lstRecpEmail.length;
    //   if (emailCountBefore >= vm.UserLimits.LimitPerMonth) {
    //     var extraEmails = emailCountBefore - vm.UserLimits.LimitPerMonth;
    //     var inLimitEmails = $scope.mailer.lstRecpEmail.length - extraEmails;
    //     $scope.mailer.lstRecpEmail.length = inLimitEmails;
    //   } else {
    //     $scope.hasLimit = true;
    //   }
    // });

    // function extractEmails(text) {
    //   for (var i = 0; i < text.length; i++) {
    //     var email = text[i].Email;
    //     return email.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
    //   }
    // }
    vm.sendingInProcess = false;vm.stopSpinner = false;vm.showNotif = false;$scope.bulkEmailSubmit = function (data, ev) {
      data.Body = $scope.mailer.Body;
      if (data.Body === "<p>Hello @@DisplayName</p>") {
        vm.sendingInProcess = false;
        vm.stopSpinner = false;
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector("#bulkEmailWrap"))).clickOutsideToClose(true).title("OOPS.,").textContent("Email Message should not be empty.").ariaLabel("Alert ").ok("Got it!").targetEvent(ev));
      } else {
        vm.sendingInProcess = true;
        vm.stopSpinner = true;
        data.lstbulkemails = data.lstRecpEmail;
        $scope.validEmails = [];
        $scope.InvalidEmails = [];
        delete data.lstRecpEmail;
        var count = JSON.parse(JSON.stringify(data.lstbulkemails.length));
        data.loginid = $scope.tokenData.loginid;
        data.EmailCount = data.lstbulkemails.length;
        dataService.newToken().then(function (response) {
          dataService.MassEmail(data).then(function (response) {
            vm.stopSpinner = false;
            vm.showNotif = true;
            $scope.res = response.data;
            $scope.viewContactListView = true;
            if (contactsTable !== undefined) {
              contactsTable.setData(response.data);
            }
            $timeout(function () {
              vm.showNotif = false;
              vm.sendingInProcess = false;
              $scope.mailer = {};
              $scope.mailer = {
                Sender: angular.fromJson(localStorage.getItem("tokenData")).email,
                Body: "",
                lstRecpEmail: []
              };
            }, 500);
            vm.UserLimits = vm.UserLimits.EmailsUsed - count;
            // vm.UserLimits.LimitPerMonth = 72;
            if (vm.UserLimits.EmailsUsed >= vm.UserLimits.LimitPerMonth) {
              $scope.hasLimit = false;
            } else {
              $scope.hasLimit = true;
            }
            $scope.UserLimits = resp.data;
          }).catch(CatchError);
        }).catch(CatchError);
      }
    };
  }
})();


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  'use strict';

  angular.module('app').component('marketerInterviews', {
    controller: MarketerInterviewsController,
    controllerAs: 'vm',
    templateUrl: 'app/components/sales/marketerInterviews/marketerInterviews.component.html'
  });

  function MarketerInterviewsController($scope, dataService, $http, $timeout, $mdToast, $location, $mdDialog, $rootScope, $mdSelect, $q, $window, moment, $state) {
    var vm = this;
    vm.tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.go = function (path) {
      $state.go(path);
    };
    $scope.deactivate = false;
    $scope.activate = false;
    $scope.addNewPlacement = false;
    $scope.addTitleShow = false;
    $scope.showTable = false;
    $scope.showAllInterviews = true;
    $scope.newDate = new Date();
    $scope.pageLoaded = true;
    $scope.marketerDataLoaded = false;
    $scope.topLoader = false;
    $scope.yearUpdate = false;
    var obj = {
      RequestDate: new Date(),
      loginid: vm.tokenData.loginid
    };
    var interviewsTable;
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        $mdDialog.hide();
        localStorage.clear();
        $state.go('signin');
      }
    };

    $scope.getinterviewdetails = function (year) {
      $scope.SelectedYear = year;
      var Month = moment().format('MM');
      var Year = year;
      var reqdata = {
        Year: parseInt(Year),
        Month: parseInt(Month)
      };
      dataService.newToken().then(function (response) {
        dataService.GetPlacedIntviewDetails(reqdata).then(function (response) {
          for (var index = 0; index < response.data.length; index++) {
            var element = response.data[index];
            element.marketerFullName = element.MarketerFirstName + ' ' + element.MarketerLastName;
            element.month = moment(element.StartDate).format('MM');
            if (element.InvMode == 1) {
              element.InvModeValue = 'Zoom';
            } else if (element.InvMode == 2) {
              element.InvModeValue = 'WebEx';
            } else if (element.InvMode == 3) {
              element.InvModeValue = 'Skype';
            } else if (element.InvMode == 4) {
              element.InvModeValue = 'Skype For Business';
            } else if (element.InvMode == 5) {
              element.InvModeValue = 'Phone';
            } else if (element.InvMode == 6) {
              element.InvModeValue = 'F2F';
            } else if (element.InvMode == 7) {
              element.InvModeValue = 'BlueJeans';
            }
            if (element.Status == 1) {
              element.Status = 3;
              element.StatusValue = 'In Progress';
            } else if (element.Status == 2) {
              element.StatusValue = 'Rejected';
            } else if (element.Status == 3) {
              element.StatusValue = 'In Progress';
            } else if (element.Status == 4) {
              element.StatusValue = 'Placed';
            } else if (element.Status === 0) {
              element.Status = 3;
              element.StatusValue = 'In Progress';
            }
          }
          // $scope.individualInterviews = response.data;
          $scope.individualInterviews = _.chain(response.data).groupBy('marketerFullName').map(function (value, key) {
            return {
              marketerFullName: key,
              Interviews: _.chain(value).groupBy('month').map(function (value, key) {
                return {
                  Month: key,
                  byMonths: _.chain(value).groupBy('Status').map(function (value, key) {
                    return { Status: key, byStatus: value };
                  }).value()
                };
              }).value()
            };
          }).value();

          $scope.marketerInterviewsByStatusYear = _.chain(response.data).groupBy('marketerFullName').map(function (value, key) {
            return {
              marketerFullName: key,
              Interviews: value
            };
          }).value();

          for (var x = 0; x < $scope.individualInterviews.length; x++) {
            var mInts = $scope.individualInterviews[x];
            for (var b = 0; b < mInts.Interviews.length; b++) {
              var Interviews = mInts.Interviews[b];
              Interviews.statusData = [0, 0, 0];
              Interviews.MonthName = moment(Interviews.Month, 'MM').format('MMMM');
              for (var w = 0; w < Interviews.byMonths.length; w++) {
                var status = Interviews.byMonths[w];
                for (var i = 1; i < 5; i++) {
                  if (parseInt(status.Status) === 2) {
                    Interviews.statusData.splice(0, 1, status.byStatus.length);
                  } else if (parseInt(status.Status) === 3) {
                    Interviews.statusData.splice(1, 1, status.byStatus.length);
                  } else if (parseInt(status.Status) === 4) {
                    Interviews.statusData.splice(2, 1, status.byStatus.length);
                  }
                }
              }
            }
          }

          $scope.labels = ['Rejected', 'In Progress', 'Placed'];
          $scope.options = {
            responsive: true,
            legend: {
              display: false
            },
            scales: {
              yAxes: [{
                ticks: {
                  max: 20,
                  min: 0,
                  stepSize: 4
                }
              }]
            }
          };
          $scope.type = 'bar';
          $scope.yearUpdate = false;
          $scope.selectedMarketer(0, $scope.individualInterviews[0]);
          $scope.selected = 0;
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.getinterviewdetails(moment().format('YYYY'));
    $scope.viewMarketerInterviews = function (data) {
      $scope.showTable = true;
      var MarketerinterviewsofMonth = [];
      for (var index = 0; index < data.byMonths.length; index++) {
        var element = data.byMonths[index];
        for (var h = 0; h < element.byStatus.length; h++) {
          var statusEach = element.byStatus[h];
          if (statusEach.Status == 1) {
            statusEach.StatusValue = 'Confirmed';
          } else if (element.Status == 2) {
            statusEach.StatusValue = 'Rejected';
          } else if (element.Status == 3) {
            statusEach.StatusValue = 'In Progress';
          } else if (element.Status == 4) {
            statusEach.StatusValue = 'Placed';
          } else if (element.Status === 0) {
            element.Status = 4;
            statusEach.StatusValue = 'In Progress';
          }
          MarketerinterviewsofMonth.push(statusEach);
        }
      }
      $scope.MarketerinterviewsofMonth = MarketerinterviewsofMonth;
      $timeout(function () {
        var _ref;

        interviewsTable = new Tabulator('#byMarketerId', (_ref = {
          layout: 'fitDataFill',
          pagination: 'local',
          paginationSize: 5,
          paginationSizeSelector: [5, 10, 20, 30, 40, 50],
          groupBy: '',
          groupStartOpen: false,
          groupToggleElement: 'header',
          selectable: false,
          clipboard: true,
          clipboardCopyStyled: false,
          data: $scope.MarketerinterviewsofMonth,
          persistence: {
            sort: true,
            filter: true,
            columns: true
          },
          tooltips: true,
          tooltipsHeader: true,
          persistenceID: "byMarketerIdpersistenceID"
        }, _defineProperty(_ref, 'tooltips', function tooltips(cell) {
          return cell.getColumn().getField() + ' - ' + cell.getValue();
        }), _defineProperty(_ref, 'tooltipGenerationMode', 'hover'), _defineProperty(_ref, 'columns', [{
          formatter: 'rownum',
          align: 'center',
          width: 40,
          sorter: false
        }, { title: 'Name', field: 'ConslFirstName', width: 210 }, {
          title: 'MarketerFirstName',
          field: 'MarketerFirstName',
          width: 120
        }, {
          title: 'ClientName',
          field: 'ClientName',
          width: 210
        }, {
          title: 'VendorName',
          field: 'VendorName'
        }, {
          title: 'StartDate',
          field: 'StartDate',
          formatter: 'datetime',
          formatterParams: {
            inputFormat: 'YYYY-MM-DD',
            outputFormat: 'MM/DD/YY',
            invalidPlaceholder: 'n/a'
          }
        }, {
          title: 'InvModeValue',
          field: 'InvModeValue'
        }, {
          title: 'StatusValue',
          field: 'StatusValue'
        }, {
          title: 'CreateDate',
          field: 'CreateDate',
          formatter: 'datetime',
          formatterParams: {
            inputFormat: 'YYYY-MM-DD',
            outputFormat: 'MM/DD/YY',
            invalidPlaceholder: 'n/a'
          }
        }, {
          title: 'Comments',
          field: 'Comments',
          width: 100
        }]), _ref));
      });
      // mTable.data(MarketerinterviewsofMonth).draw();
      // $scope.MarketerinterviewsofMonth = _.concat(
      //   MarketerinterviewsofMonth[0],
      //   MarketerinterviewsofMonth[1],
      //   MarketerinterviewsofMonth[2]
      // );
    };
    $scope.Rejected = [];
    $scope.InProgress = [];
    $scope.Placed = [];
    $scope.selectedMarketer = function (index, data) {
      $scope.Rejected = [];
      $scope.InProgress = [];
      $scope.Placed = [];
      $scope.marketerDataLoaded = false;

      $scope.showTable = false;
      $scope.selected = index;
      for (index = 0; index < $scope.marketerInterviewsByStatusYear.length; index++) {
        var element = $scope.marketerInterviewsByStatusYear[index];
        if (element.marketerFullName == data.marketerFullName) {
          for (var intv = 0; intv < element.Interviews.length; intv++) {
            var interview = element.Interviews[intv];
            if (interview.Status === 2) {
              $scope.Rejected.push(element);
            } else if (interview.Status === 3) {
              $scope.InProgress.push(element);
            } else if (interview.Status === 4) {
              $scope.Placed.push(element);
            }
          }
        }
      }
      $scope.yearUpdate = false;
      $scope.selectedMarketerData = data.Interviews;
      $scope.pageLoaded = true;
      $timeout(function () {
        $scope.marketerDataLoaded = true;
      });
    };

    $scope.InterviewStatuses = [{
      id: 1,
      value: 'Confirmed'
    }, {
      id: 2,
      value: 'Rejected'
    }, {
      id: 3,
      value: 'New'
    }, {
      id: 4,
      value: 'Placed'
    }];

    $scope.changeYear = function () {
      $scope.SelectedYear = null;
      $scope.yearUpdate = true;
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("marketer", {
    controller: MarketerController,
    controllerAs: "vm",
    templateUrl: "app/components/sales/Marketer/Marketer.component.html"
  });

  function MarketerController($scope, dataService, $http, $location, $mdToast, $rootScope, $mdDialog, $timeout, $q, $mdSelect, moment, $state) {
    var vm = this;
    var tokenData = JSON.parse(localStorage.getItem("tokenData"));
    vm.tokenData = tokenData;
    vm.sendingInProcess = false;
    $scope.marketerEditView = false;
    $scope.topLoader = true;
    $("#addNewInterview").modal("hide");
    $scope.comments = [];
    $scope.hotlist = [];
    vm.conslDetails = "";
    var calendarEl;
    $scope.todaysEvents = [];
    $scope.todayDate = moment().format("MM/DD/YYYY");
    var AllMarketers;
    $scope.EnableBtn = false;
    $scope.addClientShow = false;
    $scope.addVendorShow = false;
    $scope.notifier = false;
    $scope.afterAddedClient = true;
    $scope.afterAddedClient = false;
    $scope.addClient = {};
    $scope.addVendor = {};
    $scope.addVendor.VendorAddressInfo = [];
    $scope.updateInterViewLoader = false;
    $scope.addConLoader = false;
    vm.simulateQuery = false;
    vm.isDisabled = false;
    $scope.matched = false;
    vm.updatePreviousStatus = false;
    vm.sameMarketer = null;
    var calendar2;
    var hotListTable;
    var heightCanBe = window.innerHeight - 140 + "px";
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 140 + "px";
      if (hotListTable) {
        hotListTable.setHeight(heightCanBe);
        hotListTable.redraw();
      }
    });
    calendarEl = document.getElementById("calendar");
    calendarEl.setAttribute("style", "min-height:" + heightCanBe + ";");
    $scope.user = {
      marketer: tokenData.displayname
    };
    function showToast(msg, time, cb) {
      var toast = $mdToast.simple().content(msg).highlightAction(false).position("top center").hideDelay(time);
      $mdToast.show(toast);
      cb();
    }
    var CatchError = function CatchError(error) {
      debugger;
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        $mdDialog.hide();
        localStorage.clear();
        $state.go("signin");
      }
    };
    function matchAny(data, filterParams) {
      var match = false;
      for (var key in data) {
        if (key == "FirstName" || key == "MiddleName" || key == "LastName" || key == "VisaType", key == "CurrentLocation" || key == "EducationLevel" || key == "Email" || key == "PhoneNumber" || key == "Skillset" || key == "DOB" || key == "SSN" || key == "PassportNumber" || key == "SkypeId") {
          var keyData = data[key];
          if (keyData !== null && keyData !== undefined) {
            if (keyData !== null) {
              if (typeof keyData !== "number") {
                keyData = keyData.toLowerCase();
              }
            }
            var param = filterParams.value.toLowerCase();
            if (JSON.stringify(keyData).search(param) != -1) {
              match = true;
            }
          }
        }
      }
      return match;
    }
    $scope.allhotListSearch = function (data) {
      hotListTable.setFilter(matchAny, {
        value: data
      });
    };
    function conDets(data) {
      $scope.conslDetails = data;
      // $scope.$apply();
    }
    function parseGetConsApi(response) {
      $scope.groupedConsByIntId = _.chain(vm.events).groupBy("ConslId").map(function (value, key) {
        return {
          conId: key,
          Interviews: value
        };
      }).value();
      for (var index = 0; index < response.length; index++) {
        for (var k = 0; k < $scope.groupedConsByIntId.length; k++) {
          var element = $scope.groupedConsByIntId[k];
          if (JSON.parse(element.conId) === response[index].ConslId) {
            response[index].IntCount = element.Interviews.length;
            break;
          }
          if ($scope.groupedConsByIntId.length - 1 == k) {
            response[index].IntCount = 0;
          }
        }

        response[index].FullName = response[index].FirstName + " " + response[index].LastName;
        if (response[index].priority === null || response[index].priority === 3) {
          response[index].priorityName = "Low";
        } else if (response[index].priority === 2) {
          response[index].priorityName = "Medium";
        } else {
          response[index].priorityName = "High";
        }
        if (response[index].Recuriterid !== null) {
          for (var r = 0; r < $scope.marketers.length; r++) {
            var rele = $scope.marketers[r];
            if (rele.loginid == response[index].Recuriterid) {
              response[index].RecruiterName = rele.MarkterName;
              break;
            } else {
              response[index].RecruiterName = "Not Assigned";
            }
          }
        }
        $scope.hotlist.push(response[index]);
      }
      $scope.cons = response;
      var EditIcon = function EditIcon(cell, formatterParams, onRendered) {
        //plain text value
        return "<i class='material-icons pointer zoom' style='font-size: 18px;'>edit</i>";
      };
      var ViewIcon = function ViewIcon(cell, formatterParams, onRendered) {
        return "<i class='material-icons pointer zoom text-primary' style='font-size: 18px;'>remove_red_eye</i>";
      };

      var ActionIcon = function ActionIcon(cell, formatterParams, onRendered) {
        return "<i class='material-icons remove-btn pointer zoom' style='font-size: 20px;font-weight: bolder;'>swap_horiz</i>";
      };
      var AllConsActionIcon = function AllConsActionIcon(cell, formatterParams, onRendered) {
        var data = cell.getRow();
        if (data._row.data.Active) {
          return "<span class='hotlisted'>HotListed</span>";
        } else {
          return "<i class='material-icons remove-btn pointer zoom' style='font-size: 20px;font-weight: bolder;'>swap_horiz</i>";
        }
      };
      var dateEditor = function dateEditor(cell, onRendered, success, cancel, editorParams) {};
      var showByRole = false;
      if (vm.tokenData.newRole === "MarketerAdmin") {
        showByRole = true;
      }
      hotListTable = new Tabulator("#hotListTable", {
        height: heightCanBe,
        data: $scope.hotlist,
        pagination: "local",
        paginationSize: 20,
        paginationSizeSelector: [20, 30, 40, 60],
        layout: "fitData",
        groupStartOpen: true,
        groupToggleElement: "header",
        persistence: {
          sort: true,
          filter: true
        },
        tooltips: true,
        tooltipsHeader: true,
        persistenceID: "hotListTablepersistenceID",
        groupBy: "priorityName",
        initialSort: [{
          column: "priorityName",
          dir: "asc"
        }],
        selectable: false,
        responsiveLayoutCollapseFormatter: function responsiveLayoutCollapseFormatter(data) {
          //data - an array of objects containing the column title and value for each cell
          var list = document.createElement("div");
          list.className = "d-flex flex-row flex-wrap expandedHLView";
          data.forEach(function (col) {
            var item = document.createElement("div");
            item.className = "col-lg-4 col-sm-12 col-md-6 item";
            item.innerHTML = "<strong>" + col.title + "</strong> - " + col.value;
            list.appendChild(item);
          });

          return Object.keys(data).length ? list : "";
        },
        cellEdited: function cellEdited(cell) {
          var val = cell.getValue();
          if (val == "1") {
            cell.setValue("High", true);
          } else if (val == "2") {
            cell.setValue("Medium", true);
          } else if (val == "3") {
            cell.setValue("Low", true);
          }
          var cellOldValue = cell.getOldValue();

          var rowData = cell.getRow().getData();

          dataService.newToken().then(function (response) {
            dataService.UpdatePriority({
              priority: JSON.parse(cellOldValue),
              ConslId: rowData.ConslId
            }).then(function (response) {
              hotListTable.setSort([{
                column: "priorityName",
                dir: "asc"
              }]);
            }).catch(CatchError);
          }).catch(CatchError);
        },
        columns: [{
          width: 40,
          formatter: ViewIcon,
          cellClick: function cellClick(e, cell) {
            var data = cell.getRow();
            // $("#consDetails").modal("show");

            $scope.conslDetails = data;
            // $scope.$apply(); 
            $mdDialog.show({
              controller: ViewConsDocsController,
              templateUrl: "app/components/sales/myResources/viewDocDialog.html",
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              locals: {
                consData: data._row.data
              },
              fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
            });
          }
        }, {
          formatter: "rownum",
          align: "center",
          width: 40,
          sorter: false,
          responsive: 0
        }, {
          title: "priority",
          field: "priorityName",
          width: 90,
          editor: "select",
          editorParams: {
            values: {
              1: "High",
              2: "Medium",
              3: "Low"
            }
          },
          responsive: 0,
          visible: showByRole
        }, {
          title: "priority",
          field: "priorityName",
          width: 90,
          responsive: 0,
          visible: !showByRole
        }, {
          title: "Name",
          field: "FullName",
          width: 260,
          responsive: 0,
          formatter: function formatter(cell) {
            var rowData = cell.getRow().getData();
            return "<span class='IntCount'>" + rowData.IntCount + "</span> " + rowData.FullName;
          }
        }, {
          title: "Skill",
          field: "Skillset",
          width: 120,
          responsive: 0
        }, {
          title: "Email",
          field: "Email",
          width: 220,
          responsive: 0
        }, {
          title: "PhoneNumber",
          field: "PhoneNumber",
          responsive: 2,
          width: 170
        }, {
          title: "Recruiter",
          field: "RecruiterName",
          responsive: 5
        }, {
          title: "DOB",
          field: "DOB",
          formatter: "datetime",
          formatterParams: {
            inputFormat: "YYYY-MM-DD",
            outputFormat: "MM/DD/YY",
            invalidPlaceholder: "n/a"
          },
          responsive: 5
        }, {
          title: "VisaStatus",
          field: "VisaType",
          responsive: 2
        }, {
          title: "GH",
          field: "GK",
          formatter: "tickCross",
          formatterParams: {
            allowEmpty: true,
            allowTruthy: true,
            tickElement: "<i class='fa fa-check'></i>",
            crossElement: "<i class='fa fa-times'></i>"
          },
          responsive: 2
        }, {
          title: "Prefer Location",
          field: "PrefLocation",
          responsive: 2
        }, {
          title: "Exp",
          field: "Exp",
          responsive: 2,
          formatter: function formatter(cell) {
            var value;
            if (cell._cell !== undefined) {
              value = cell._cell.value;
            } else {
              value = cell.value;
            }
            if (value) {
              return "Yes";
            } else {
              return "No";
            }
          }
        }, {
          title: "SSN",
          field: "SSN",
          width: 100,
          responsive: 2
        }, {
          title: "Expected Rate",
          field: "ExpectedRate",
          width: 100,
          responsive: 2
        }, {
          title: "US Entry Date",
          field: "USEntryDate",
          formatter: "datetime",
          formatterParams: {
            inputFormat: "YYYY-MM-DD",
            outputFormat: "MM/DD/YY",
            invalidPlaceholder: "n/a"
          },
          responsive: 5
        }]
      });
    }
    function ViewConsDocsController($scope, $mdDialog, consData) {
      dataService.GetConslByConslId({ ConslId: consData.ConslId }).then(function (response) {
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
        $scope.GetconsldocsLoader = true;
        var fileUrlsReq = {
          conslid: consData.ConslId
        };
        dataService.newToken().then(function (response) {
          dataService.Getconsldocs(fileUrlsReq).then(function (response) {
            $scope.GetconsldocsLoader = false;
            $scope.conDocs = response.data;
          }).catch(CatchError);
        }).catch(CatchError);
        $scope.editeditHotlSubmitLoader = false;
        $scope.ConData = response.data;
        var obj = {
          loginid: vm.tokenData.loginid,
          conslid: consData.ConslId
        };
        // $scope.conDocs = consData.ListDocUrls;

        $scope.getFile = function (data, furl) {
          var re = /(?:\.([^.]+))?$/;
          obj = {
            loginid: vm.tokenData.loginid,
            conslid: data.ConslId,
            FileUrl: furl,
            FileExt: re.exec(furl)[1]
          };
          dataService.newToken().then(function (response) {
            dataService.Getfileurl(obj).then(function (response) {
              $scope.file = response.data;
              // var fileType = ""
              var file = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
                return data + String.fromCharCode(byte);
              }, ""));

              var isChrome = !!window.chrome && !!window.chrome.app;
              var isIE = /*@cc_on!@*/false || !!document.documentMode;
              var isEdge = !isIE && !!window.StyleMedia;

              if (isChrome) {
                var url = window.URL || window.webkitURL;

                var downloadLink = angular.element("<a></a>");
                downloadLink.attr("href", "data:application/octet-stream; base64," + file);
                downloadLink.attr("target", "_self");
                downloadLink.attr("download", furl);
                downloadLink[0].click();
              } else if (isEdge || isIE) {
                window.navigator.msSaveOrOpenBlob(file, furl);
              } else {
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
              }
            }).catch(CatchError);
          }).catch(CatchError);
        };

        // New Doc Add
        $scope.viewDocAdd = false;
        $scope.addDoc = function () {
          $mdSelect.hide();
          $scope.viewDocAdd = true;
          $scope.viewDocAddClose = function () {
            $scope.viewDocAdd = false;
          };

          $scope.addDocData = function (data) {
            dataService.newToken().then(function (response) {
              dataService.InsertDocDD({
                DocName: data
              }).then(function (response) {
                $scope.docDDs = response.data;
                $scope.viewDocAdd = false;
              }).catch(CatchError);
            }).catch(CatchError);
          };
        };
        dataService.newToken().then(function (response) {
          dataService.GetDocDD().then(function (response) {
            $scope.docDDs = response.data;
          }).catch(CatchError);
        }).catch(CatchError);
        $scope.uploadFile = function (data) {
          $scope.files = data;
        };
        $scope.getFileDetails = function (e) {
          $scope.upFiles = e;
          $scope.files = [];
          $scope.$apply(function () {
            for (var i = 0; i < e.files.length; i++) {
              $scope.files.push(e.files[i]);
            }
          });
        };

        // NOW UPLOAD THE FILES.
        $scope.uploadActivated = false;
        $scope.uploadFiles = function (docId) {
          $scope.uploadActivated = true;
          //FILL FormData WITH FILE DETAILS.
          var data = new FormData();
          for (var i in $scope.files) {
            data.append("uploadedFile", $scope.files[i]);
          }
          // ADD LISTENERS.
          var objXhr = new XMLHttpRequest();
          objXhr.addEventListener("progress", updateProgress, false);
          objXhr.addEventListener("load", transferComplete, false);
          // SEND FILE DETAILS TO THE API.
          //objXhr.open("POST", "/api/fileupload/");
          //objXhr.send(data);
          data.append("docId", docId);
          data.append("loginid", vm.tokenData.loginid);
          data.append("conslid", consData.ConslId);
          dataService.newToken().then(function (response) {
            dataService.UploadDocument(data).then(function (response) {
              var toast = $mdToast.simple().content(response.data.Message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
              $mdToast.show(toast);
              $scope.GetconsldocsLoader = true;
              var fileUrlsReq = {
                conslid: consData.ConslId
              };
              dataService.newToken().then(function (response) {
                dataService.Getconsldocs(fileUrlsReq).then(function (response) {
                  $scope.GetconsldocsLoader = false;
                  $scope.conDocs = response.data;
                  $scope.selDocId = null;
                  document.getElementById("file").value = "";
                  $scope.uploadActivated = false;
                }).catch(CatchError);
              }).catch(CatchError);
            }).catch(CatchError);
          }).catch(CatchError);
        };
        // UPDATE PROGRESS BAR.
        function updateProgress(e) {
          if (e.lengthComputable) {
            document.getElementById("pro").setAttribute("value", e.loaded);
            document.getElementById("pro").setAttribute("max", e.total);
          }
        }
        // CONFIRMATION.
        function transferComplete(e) {
          alert("Files uploaded successfully.");
        }
      }).catch(CatchError);
    }
    var res = $("#ssn").text(),
        len = res.length,
        stars = len > 0 ? len > 1 ? len > 2 ? len > 3 ? len > 4 ? "XXX-XX-" : "XXX-X" : "XXX-" : "XX" : "X" : "",
        result = stars + res.substring(5);
    $("#ssn").text(result);
    $(".hotConsultants tbody").on("click", "td.expandHotList", function () {
      $("#consDetails").modal("show");
      $scope.conslDetails = row.data();
    });
    function loadData($q) {
      return $q.all([dataService.Interviewlookup(), dataService.GetHotListConsl(), dataService.GetMrkterLookUp(), dataService.GetMarketerInfoMrkter()]);
    }
    function loadAddNewInterviewAssets($q) {
      return $q.all([dataService.GetClientsInfoMrkter(), dataService.GetVendorInfoMrkter(), dataService.GetTitleDDMrkter(), dataService.GetMrkterLookUp()]);
    }
    function InterviewTypes($q) {
      return $q.all([dataService.GetClientsInfoMrkter(), dataService.GetVendorInfoMrkter(), dataService.GetTitleDDMrkter(), dataService.GetMrkterLookUp()]);
    }
    $scope.closeRight = function () {
      // $scope.addNewInt erview = false;
      $scope.user.con = null;
      $("#addNewInterview").modal("hide");
      $("body").removeAttr("style");
      $scope.recurringInterview = null;
      $scope.files = [];
      $scope.EnableBtn = false;
    };
    function calInitialize(height, DynDate) {
      return new Promise(function (resolve, reject) {
        if (DynDate === undefined) {
          DynDate = new Date();
        }
        calendar2 = new FullCalendar.Calendar(calendarEl, {
          plugins: ["interaction", "dayGrid", "timeGrid", "list"],
          defaultDate: DynDate,
          defaultView: "listMonth",
          customButtons: {
            myCustomButton: {
              text: "Schedule Interview!",
              click: function click() {
                $scope.files = [];
                $scope.topLoader = true;
                $scope.EnableBtn = false;
                $scope.user.con = null;
                vm.updatePreviousStatus = false;
                loadAddNewInterviewAssets($q).then(function (resp) {
                  $scope.Clients = _.orderBy(resp[0].data, ["ClientName"], ["asc"]);
                  $scope.Vendors = resp[1].data;
                  $scope.MidVendors = resp[1].data;
                  $scope.titles = resp[2].data;
                  $scope.MarketerStats = resp[3].data;
                  $scope.skills = resp[3].data.ListSDD;
                  $scope.topLoader = false;
                  $("#addNewInterview").modal("show");
                  $("body").css("overflow", "hidden");
                });
              }
            },
            nextBtn: {
              icon: "fc-icon-chevron-right",
              click: function click() {
                var view = calendar2.view;
                if (view.type == "listWeek" || view.type == "listDay") {
                  calendar2.next();
                } else {
                  var date = calendar2.getDate();
                  var nextMon = new Date(date.setMonth(date.getMonth() + 1));
                  new GetIcalendar($scope.Clients, nextMon);
                  calendar2.gotoDate(new Date(nextMon));
                }
              }
            },
            prevBtn: {
              icon: "fc-icon-chevron-left",
              click: function click() {
                var view = calendar2.view;
                if (view.type == "listWeek" || view.type == "listDay") {
                  calendar2.prev();
                } else {
                  var date = calendar2.getDate();
                  var nextMon = new Date(date.setMonth(date.getMonth() - 1));
                  new GetIcalendar($scope.Clients, nextMon);
                  calendar2.gotoDate(new Date(nextMon));
                }
              }
            }
          },
          views: {
            listDay: {
              buttonText: "Day"
            },
            listWeek: {
              buttonText: "Week"
            },
            listMonth: {
              buttonText: "Month"
            }
          },
          width: 200,
          height: height - 71,
          editable: true,
          header: {
            left: "title",
            center: "myCustomButton",
            right: "listDay,listWeek,listMonth,prevBtn,nextBtn"
          },
          eventClick: $scope.alertOnEventClick,
          events: vm.events,
          eventOverlap: false,
          eventRender: function eventRender(info) {
            // var tooltip = new Tooltip(info.el, {
            //     title: 'Marketed By: ' + info.event.extendedProps.marketer,
            //     placement: 'top',
            //     trigger: 'hover',
            //     container: 'body'
            // });
            // var eventObj = info.event;

            // if (eventObj.url) {
            //     window.open(eventObj.url);
            //     info.jsEvent.preventDefault(); // prevents browser from following link in current tab.
            // }
            var statu, className;
            if (info.event.extendedProps.status !== undefined) {
              statu = info.event.extendedProps.status;
              if (statu == "Confirmed") {
                className = "bg-info";
              } else if (statu == "Placed") {
                className = "bg-primary";
              } else if (statu == "New") {
                className = "bg-success";
              } else {
                className = "bg-danger";
              }
            } else {
              statu = "";
            }
            jQuery(info.el).find(".fc-list-item-title").after("<td>" + statu + "</td>").after("<td>" + info.event.extendedProps.marketer + "</td>").after("<td>" + info.event.extendedProps.levelOfInterview + "</td>").after("<td>" + info.event.extendedProps.SkillName + "</td>");
            jQuery(info.el).find(".fc-list-item-marker span").addClass(className);
            setTimeout(function () {
              jQuery(info.el).parent().find("tr td.fc-widget-header").attr("colspan", "2");
              var parentTR = jQuery(info.el).parent().find(".fc-list-heading");
              if (!parentTR.hasClass("appended")) {
                jQuery(info.el).parent().find(".fc-list-heading").append("<td>Consultant</td>");
                jQuery(info.el).parent().find(".fc-list-heading").append("<td>Position</td>");
                jQuery(info.el).parent().find(".fc-list-heading").append("<td>Interview Level</td>");
                jQuery(info.el).parent().find(".fc-list-heading").append("<td>Marketer</td>");
                jQuery(info.el).parent().find(".fc-list-heading").append("<td>Status</td>");
                parentTR.addClass("appended");
              }
            });
          },
          viewRender: function viewRender(view, element) {
            //alert("did it");
          }
        });
        resolve("success");
      });
    }
    function findAny(obj, filterParams) {
      for (var key in obj) {
        // if (
        //   (key == "title")
        // ) {
        var keyData = obj[key];
        var param = filterParams;
        if (typeof keyData !== "number" && keyData !== null && keyData !== false && keyData !== true && key !== "comments") {
          keyData = keyData.toLowerCase();
          param = filterParams.toLowerCase();
        }
        if (JSON.stringify(keyData).search(param) != -1) {
          return obj;
        }
        // }
      }
    }
    $scope.interviewFilter = function (search) {
      if (search !== "" && search) {
        $scope.filteredInterviews = [];
        vm.events.forEach(function (event) {
          var iteEve = findAny(event, search);
          if (iteEve) {
            $scope.filteredInterviews.push(iteEve);
          }
        });
        calendar2.changeView("listYear");
        calendar2.setOption("height", window.innerHeight - 400 + "px");
        var eventSource = calendar2.getEventSources();
        eventSource[0].remove();
        calendar2.addEventSource($scope.filteredInterviews);
        // calendar2.addEventSource($scope.filteredInterviews);
      }
    };
    $scope.clearFilter = function (str, search) {
      $scope.search = '';
      $scope.filteredInterviews = [];
      vm.events.forEach(function (event) {
        var iteEve = findAny(event, search);
        if (iteEve) {
          $scope.filteredInterviews.push(iteEve);
        }
      });
      calendar2.changeView("listMonth");
      var eventSource = calendar2.getEventSources();
      eventSource[0].remove();
      calendar2.addEventSource($scope.filteredInterviews);
      calendar2.setOption("height", window.innerHeight - 72 + "px");
      // calendar2.addEventSource($scope.filteredInterviews);
    };
    function triggerCallInitFunc(DynDate) {
      var height = document.getElementById("main-container").offsetHeight;

      calendarEl = document.getElementById("calendar");

      if (calendar2 === undefined) {
        calInitialize(height, DynDate);
        calendar2.render();

        parseGetConsApi(vm.cons);
      } else {
        calendar2.destroy();
        calInitialize(height, DynDate);
        calendar2.render();

        parseGetConsApi(vm.cons);
      }
    }
    function GetIcalendar(clients, date) {
      vm.events = [];
      var ReqDate;
      if (date !== undefined) {
        ReqDate = new Date(date);
      } else {
        ReqDate = new Date();
      }
      var obj = {
        RequestDate: ReqDate
      };
      dataService.newToken().then(function (response) {
        dataService.GetInterviews(obj).then(function (response) {
          for (var index = 0; index < response.data.length; index++) {
            var InnerList = response.data[index].listofEventDetails;
            for (var ingo = 0; ingo < InnerList.length; ingo++) {
              var element = InnerList[ingo];
              if (element.EventStatus === 0) {
                element.EventStatus = 3;
              }
              var client = _.filter(clients, function (v) {
                return _.includes([element.ClientId], v.ClientId);
              });
              var vendor = _.filter($scope.Vendors, function (v) {
                return _.includes([element.VendorId], v.vendorModel.VendorId);
              });
              var consultant = _.filter(vm.cons, function (v) {
                return _.includes([element.ConslId], v.ConslId);
              });
              var Imode = _.filter(vm.InterviewModes, function (v) {
                return _.includes([element.IntMode.IKey], v.IKey);
              });
              var Ilvel = _.filter(vm.InterviewLevels, function (v) {
                return _.includes([element.IntLevel.IKey], v.IKey);
              });
              var status = _.filter(vm.Statuses, function (v) {
                return _.includes([element.EventStatus], v.IKey);
              });
              var marketer = _.filter($scope.marketers, function (v) {
                return _.includes([element.MarketerId], v.loginid);
              });
              var skill = _.filter($scope.skills, function (v) {
                return _.includes([element.SkillId], v.SkillId);
              });
              AllMarketers = $scope.marketers;
              element.DisplayName.replace(",", " ");
              var obj = {
                id: element.EventId,
                title: element.DisplayName,
                start: element.StartDate,
                marketer: marketer.length > 0 ? marketer[0].MarkterName : "n/a",
                MarkterId: element.MarketerId,
                url: element.MeetingUrl,
                modeOfInterview: Imode.length > 0 ? Imode[0].IValue : "n/a",
                levelOfInterview: Ilvel.length > 0 ? Ilvel[0].IValue : "n/a",
                IntMode: element.IntMode.IKey,
                IntLevel: element.IntLevel.IKey,
                comments: element.EventComments,
                end: element.EndDate,
                allDay: false,
                status: status.length > 0 ? status[0].IValue : "n/a",
                Client: client.length > 0 ? client[0].ClientName : "n/a",
                VendorId: vendor.length > 0 ? vendor[0].vendorModel.VendorName : "n/a",
                CreateDate: element.CreateDate,
                InterviewId: element.InterviewId,
                ConslId: element.ConslId,
                FinalStatus: element.FinalStatus,
                cid: element.ClientId,
                vid: element.VendorId,
                DocUrl: element.DocUrl,
                SkillId: element.SkillId,
                SkillName: skill.length > 0 ? skill[0].Skill : ""
              };
              vm.events.push(obj);
            }
          }
          triggerCallInitFunc(date);
          $scope.LoadDashboard = true;
        }).catch(CatchError);
      }).catch(CatchError);
    }
    dataService.newToken().then(function (response) {
      loadData($q).then(function (resp) {
        $scope.topLoader = false;
        vm.InterviewModes = resp[0].data.LstImode;
        vm.InterviewLevels = resp[0].data.LstILevel;
        vm.Statuses = resp[0].data.LstInvStatus;
        vm.cons = _.sortBy(resp[1].data, ["FirstName"]);
        $scope.skills = resp[2].data.ListSDD;
        $scope.marketers = resp[3].data;
        $timeout(function () {
          new GetIcalendar($scope.Clients);
        }, 200);
      }).catch(CatchError);
    }).catch(CatchError);
    $scope.updatePriority = function (priority, ConslId) {
      var req = {
        priority: priority,
        ConslId: ConslId
      };

      dataService.newToken().then(function (response) {
        dataService.UpdatePriority(req).then(function (response) {
          for (var index = 0; index < $scope.hotlist.length; index++) {
            var element = $scope.hotlist[index];
            if (element.ConslId == ConslId) {
              element.priority = priority;
              $(".hotConsultants").DataTable().draw();
              break;
            }
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.newSkill = function () {
      $mdSelect.hide();
      $scope.newSkillName = undefined;
      $("#addSkillModal").modal({
        backdrop: "static"
      });
    };
    $scope.addSkillData = function (data) {
      dataService.newToken().then(function (response) {
        dataService.AddSkillSet({
          Skill: data
        }).then(function (response) {
          if (response.statusText == "OK") {
            $scope.skills = response.data;
            var toast = $mdToast.simple().content("Skill addedd successfully.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $("#addSkillModal").modal("hide");
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.changeIntType = function () {
      $scope.files = [];
      $scope.EnableBtn = false;
      if ($scope.recurringInterview == "no") {
        if ($scope.files.length > 0) {
          $scope.EnableBtn = true;
        }
      }
      if ($scope.recurringInterview == "yes") {
        $scope.EnableBtn = true;
      }

      $scope.user = {};

      $scope.user = {
        marketer: tokenData.displayname
      };
      vm.sameMarketer = false;
      vm.updatePreviousStatus = false;
    };
    $scope.newClient = function () {
      $mdSelect.hide();
      $scope.addClient = {
        ClientName: undefined
      };
      $scope.addClientShow = true;
    };
    $scope.CanceladdClientShow = function () {
      $scope.addClientShow = false;
    };
    $scope.addClientData = function (clientData) {
      $mdSelect.hide();
      $scope.notifier = true;
      $scope.afterAddedClient = false;
      dataService.newToken().then(function (response) {
        dataService.AddClientAddressMrkter(clientData).then(function (response) {
          if (response.statusText == "OK") {
            dataService.newToken().then(function (response) {
              dataService.GetClientsInfoMrkter().then(function (response) {
                $scope.selectedClient = undefined;
                $scope.Clients = _.orderBy(response.data, ["ClientName"], ["asc"]);
                $scope.afterAddedClient = true;
                $timeout(function () {
                  $scope.addClientShow = false;
                  $scope.notifier = false;
                  $scope.afterAddedClient = false;
                }, 1500);
              }).catch(CatchError);
            }).catch(CatchError);
          } else {
            var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $mdDialog.cancel();
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.newVendor = function () {
      $mdSelect.hide();
      $scope.addVendor = {
        VendorName: undefined
      };
      $scope.addVendorShow = true;
    };
    $scope.addVendorData = function (vendorData) {
      $scope.notifier = true;
      dataService.newToken().then(function (response) {
        dataService.AddVendorAddressMrkter(vendorData).then(function (response) {
          if (response.data.StatusCode == 0) {
            dataService.newToken().then(function (response) {
              dataService.GetVendorInfoMrkter().then(function (response) {
                $scope.selectedVendor = undefined;
                $scope.Vendors = response.data;
                $scope.addVendorShow = false;
                $scope.notifier = false;
                $scope.afterAddedVendor = true;
                var toast = $mdToast.simple().content("Vendor addedd Successfully").action("OK").highlightAction(false).position("top center").hideDelay(3000);
                $mdToast.show(toast);
              }).catch(CatchError);
            }).catch(CatchError);
          } else {
            var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $mdDialog.cancel();
            $scope.notifier = false;
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.CanceladdVendorShow = function () {
      $scope.addVendorShow = false;
    };
    $scope.alertOnEventClick = function (cevs) {
      cevs.events = vm.events;
      cevs.jsEvent.preventDefault();
      $mdDialog.show({
        controller: interviewDetailsDialogController,
        templateUrl: "app/components/sales/Marketer/interviewDetails.html",
        parent: angular.element(document.body),
        locals: {
          InvModes: vm.InterviewModes,
          InvLevels: vm.InterviewLevels,
          cevs: cevs,
          marketers: $scope.marketers,
          tokenData: vm.tokenData
        },
        targetEvent: cevs.jsEvent,
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen,
        panelClass: "fullscreen-dialog"
      });

      function interviewDetailsDialogController($scope, $mdDialog, InvModes, InvLevels, cevs, marketers, tokenData) {
        $scope.interviewDetailsLoader = true;
        dataService.newToken().then(function (response) {
          loadAddNewInterviewAssets($q).then(function (resp) {
            $scope.Clients = _.orderBy(resp[0].data, ["ClientName"], ["asc"]);
            $scope.Vendors = resp[1].data;
            $scope.MidVendors = resp[1].data;
            $scope.titles = resp[2].data;
            $scope.MarketerStats = resp[3].data;
            $scope.skills = resp[3].data.ListSDD;
          }).then(function () {
            $scope.interviewDetailsLoader = false;

            $scope.tokenData = tokenData;
            $scope.marketerEditView = false;
            $scope.marketers = marketers;

            $scope.InterviewModes = InvModes;
            $scope.InterviewLevels = InvLevels;
            $scope.todayDate = moment().format("MM/DD/YYYY");

            $scope.hide = function () {
              $mdDialog.hide();
            };
            $scope.editMode = false;
            $scope.cancelEdit = function () {
              $scope.editMode = false;
            };

            $scope.marketerEdit = function () {
              $scope.marketerEditView = true;
            };
            $scope.CancelMarketerEdit = function () {
              $scope.marketerEditView = false;
            };
            $scope.UpdateMarketerEdit = function (marId, IntId, selInteviw) {
              var reqObj = {
                InterviewId: IntId,
                MarkterId: marId
              };
              dataService.newToken().then(function (response) {
                dataService.UpdateMarkIdForInvid(reqObj).then(function (response) {
                  if (response.data == "Status Updated Successfully..") {
                    for (var index = 0; index < $scope.marketers.length; index++) {
                      var element = $scope.marketers[index];
                      if (element.loginid === marId) {
                        $scope.choosedMarketer = element;
                      }
                    }
                    $scope.selInteviw.marketer = $scope.choosedMarketer.MarkterName;
                    var IntData = {
                      EventId: selInteviw.id,
                      marketer: $scope.choosedMarketer.MarkterName,
                      marketerId: $scope.choosedMarketer.loginid
                    };
                    $rootScope.$broadcast("updateMarketer", IntData);
                    $scope.marketerEditView = false;
                  }
                }).catch(CatchError);
              }).catch(CatchError);
            };

            $scope.editEvent = function (data) {
              $scope.editable = {
                StartDate: moment(data.start).format("MM/DD/YYYY, hh:mm a"),
                EndDate: moment(data.end).format("MM/DD/YYYY, hh:mm a"),
                start: moment(data.start).format("MM/DD/YYYY, hh:mm a"),
                end: moment(data.end).format("MM/DD/YYYY, hh:mm a"),
                modeOfInterviewname: data.modeOfInterview,
                levelOfInterviewname: data.levelOfInterview,
                url: data.url,
                InterviewId: data.InterviewId,
                ClientId: data.cid,
                Status: 3,
                VendorId: data.vid,
                ConslId: data.ConslId,
                MarkterId: data.MarkterId,
                MeetingUrl: data.url,
                EventId: data.id,
                Comments: data.comments,
                InvMode: data.IntMode,
                InvLevel: data.IntLevel,
                modeOfInterview: data.IntMode,
                levelOfInterview: data.IntLevel
              };
              if ($scope.selInteviw.edit === undefined) {
                $scope.selInteviw.edit = true;
              }
              $scope.editMode = true;
            };

            $scope.addCommentLoader = false;

            $scope.addComment = function (comment, userdata) {
              $scope.addCommentLoader = true;
              if (userdata.comments === null) {
                userdata.comments = [];
              }
              var commentConstrt = {
                comment: comment,
                author: JSON.parse(localStorage.getItem("tokenData")).displayname,
                time: new Date()
              };
              userdata.comments.push(commentConstrt);
              var reqObj = {
                InterviewId: userdata.InterviewId,
                ClientId: userdata.cid,
                VendorId: userdata.vid,
                Comments: userdata.comments,
                StartDate: userdata.start,
                EndDate: userdata.end,
                ConslId: userdata.ConslId,
                MarkterId: userdata.MarkterId,
                DocUrl: userdata.DocUrl,
                EventId: userdata.id,
                InvMode: userdata.IntMode,
                InvLevel: userdata.IntLevel,
                Editable: true
              };
              dataService.newToken().then(function (response) {
                dataService.addInterview(reqObj).then(function (response) {
                  var item = calendar2.getEventById(userdata.id);
                  item.setExtendedProp("comments", userdata.comments);
                  $scope.data = item;
                  $scope.addCommentLoader = false;
                  $("#newComment").val("");
                  $scope.newComment = null;
                }).catch(CatchError);
              }).catch(CatchError);
            };
            $scope.statusUpdate = function (status, uData, selInteviw) {
              var confirm = $mdDialog.prompt().title("Please add comments before you update Status.").placeholder("Comments").ariaLabel("Comments").initialValue("").required(true).ok("Update").cancel("Cancel");

              // $mdDialog.show(confirm).then(
              //   function(result) {
              //     $scope.addComment(result, $scope.selInteviw);
              //   },
              //   function() {}
              // );
              var request = {
                Status: JSON.parse(status),
                EventId: uData.id
              };
              dataService.newToken().then(function (response) {
                dataService.UpdateInterviewStatus(request).then(function (response) {
                  // if (JSON.parse(status) === 2 || JSON.parse(status) === 4) {
                  var request = {
                    Status: JSON.parse(status),
                    InterviewId: uData.InterviewId
                  };
                  dataService.newToken().then(function (response) {
                    dataService.UpdateFinalInterviewStatus(request).then(function (response) {
                      for (var index = 0; index < $scope.mergedInterviews.length; index++) {
                        var FinalStatusUpdate = function FinalStatusUpdate(status) {
                          var items = calendar2.getEvents();
                          for (var index = 0; index < items.length; index++) {
                            var element = items[index];
                            if (element.extendedProps.InterviewId == uData.InterviewId) {
                              element.setExtendedProp("FinalStatus", status);
                            }
                          }
                        };
                        // var obj = {
                        //     id: uData.id,
                        //     status: status
                        // }
                        // $rootScope.$broadcast("updaCalen", obj);


                        var element = $scope.mergedInterviews[index];
                        if (element.id === uData.id) {
                          if (status == "1") {
                            element.status = "Confirmed";
                          } else if (status == "2") {
                            element.status = "Rejected";
                            element.FinalStatus = "2";
                          } else if (status == "4") {
                            element.status = "Placed";
                            element.FinalStatus = "4";
                          } else if (status == "6") {
                            element.status = "No Show Up";
                            element.FinalStatus = "6";
                          }
                        }

                        var item = calendar2.getEventById(uData.id);
                        if (status === "1") {
                          _.filter(vm.events, function (v) {
                            return _.includes([JSON.parse(uData.id)], v.id);
                          })[0].status = "Confirmed";
                          item.setExtendedProp("status", "Confirmed");
                          item.setExtendedProp("FinalStatus", status);
                          $scope.canEdit = false;
                          // new FinalStatusUpdate(status);
                          showToast("Status Update Successfully.", 5000, function () {
                            vm.updatePreviousStatus = false;
                          });
                        } else if (status === "2") {
                          _.filter(vm.events, function (v) {
                            return _.includes([JSON.parse(uData.id)], v.id);
                          })[0].status = "Rejected";
                          item.setExtendedProp("status", "Rejected");
                          item.setExtendedProp("FinalStatus", "2");
                          new FinalStatusUpdate(status);
                          $scope.canEdit = false;
                          showToast("Interview is rejected Successfully.", 5000, function () {
                            vm.updatePreviousStatus = false;
                            $scope.user = null;
                            $scope.recurringInterview = undefined;
                            $scope.files = [];
                            $scope.EnableBtn = false;
                            $("#addNewInterview").modal("hide");
                          });
                        } else if (status === "4") {
                          _.filter(vm.events, function (v) {
                            return _.includes([JSON.parse(uData.id)], v.id);
                          })[0].status = "Placed";
                          $scope.canEdit = false;
                          item.setExtendedProp("status", "Placed");
                          item.setExtendedProp("FinalStatus", 4);
                          new FinalStatusUpdate(status);
                          showToast("Congratulations., Consultant Placed Successfully.", 5000, function () {
                            vm.updatePreviousStatus = false;
                            $scope.user = null;
                            $scope.EnableBtn = false;
                            $scope.files = [];
                            $scope.recurringInterview = undefined;
                            $("#addNewInterview").modal("hide");
                          });
                        } else if (status === "6") {
                          _.filter(vm.events, function (v) {
                            return _.includes([JSON.parse(uData.id)], v.id);
                          })[0].status = "No Show Up";
                          $scope.canEdit = false;
                          item.setExtendedProp("status", "No Show Up");
                          item.setExtendedProp("FinalStatus", 6);
                          new FinalStatusUpdate(status);
                          showToast("Interview status updated Successfully.", 5000, function () {
                            vm.updatePreviousStatus = false;
                            $scope.user = null;
                            $scope.EnableBtn = false;
                            $scope.files = [];
                            $scope.recurringInterview = undefined;
                            $("#addNewInterview").modal("hide");
                          });
                        }
                      }
                      calendar2.render();
                    }).catch(CatchError);
                  }).catch(CatchError);
                  // }
                }).catch(CatchError);
              }).catch(CatchError);
            };
            $timeout(function () {
              var h = $(".comments-wrap").height();
              $(".comments-wrap").animate({
                scrollTop: h
              }, 200);
            });
            $scope.cancel = function () {
              $mdDialog.cancel();
            };

            $scope.mergedInterviews = [];
            for (var index = 0; index < cevs.events.length; index++) {
              var element = cevs.events[index];

              if (cevs.event._def.extendedProps.InterviewId === element.InterviewId) {
                var client = _.filter($scope.Clients, function (v) {
                  return _.includes([element.cid], v.ClientId);
                });
                var vendor = _.filter($scope.Vendors, function (v) {
                  return _.includes([element.vid], v.vendorModel.VendorId);
                });
                var marketer = _.filter($scope.marketers, function (v) {
                  return _.includes([element.MarkterId], v.loginid);
                });
                element.marketer = marketer.length > 0 ? marketer[0].MarkterName : "n/a", element.Client = client.length > 0 ? client[0].ClientName : "n/a", element.VendorId = vendor.length > 0 ? vendor[0].vendorModel.VendorName : "n/a", $scope.mergedInterviews.push(element);
              }
              if (cevs.event.id == element.id) {
                $scope.selInteviw = element;
              }
            }
            $scope.selectedInterview = cevs.events.length;
            $scope.interviewLvlSelected = function (interview) {
              $scope.ResumeUrl = interview.DocUrl;
              $scope.selInteviw = interview;
              if (interview.status == "New" || vm.tokenData.newRole === "MarketerAdmin") {
                $scope.canEdit = true;
              } else {
                $scope.canEdit = false;
              }
            };
            $scope.downloadResum = function (id, url) {
              var obj = {
                InterviewId: id,
                FileUrl: url
              };
              dataService.newToken().then(function (response) {
                dataService.DownloadResume(obj).then(function (response, status, headers) {
                  var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
                    return data + String.fromCharCode(byte);
                  }, ""));
                  var anchor = $("<a/>");
                  anchor.attr({
                    href: "data:application/octet-stream; base64," + base64,
                    target: "_blank",
                    download: url
                  })[0].click();
                }).catch(CatchError);
              }).catch(CatchError);
            };

            $scope.$on("removeDialog", function (ev) {
              $mdDialog.cancel();
            });

            $scope.remove = function (data) {
              $rootScope.$broadcast("evData", data);
            };
            $scope.DellAll = function (data) {
              $rootScope.$broadcast("dellALL", data);
            };
            $scope.updateInterview = function (uData) {
              $scope.updateInterViewLoader = true;
              var request = {
                InterviewId: uData.InterviewId,
                ClientId: uData.ClientId,
                Status: 3,
                VendorId: uData.VendorId,
                ConslId: uData.ConslId,
                MarkterId: uData.MarkterId,
                MeetingUrl: uData.url,
                EventId: uData.EventId,
                InvMode: uData.modeOfInterview,
                InvLevel: uData.levelOfInterview,
                Comments: uData.Comments,
                Editable: true,
                StartDate: moment(uData.StartDate).format("MM/DD/YYYY, hh:mm a"),
                EndDate: moment(uData.EndDate).format("MM/DD/YYYY, hh:mm a")
              };
              dataService.newToken().then(function (response) {
                dataService.addInterview(request).then(function (response) {
                  $rootScope.$broadcast("updateEv", uData);
                  var Imode = _.filter(vm.InterviewModes, function (v) {
                    return _.includes([uData.modeOfInterview], v.IKey);
                  });
                  var Ilvel = _.filter(vm.InterviewLevels, function (v) {
                    return _.includes([uData.levelOfInterview], v.IKey);
                  });
                  _.filter($scope.mergedInterviews, function (v) {
                    return _.includes([uData.EventId], v.id);
                  })[0].levelOfInterview = Ilvel[0].IValue;
                  _.filter($scope.mergedInterviews, function (v) {
                    return _.includes([uData.EventId], v.id);
                  })[0].modeOfInterview = Imode[0].IValue;
                  _.filter($scope.mergedInterviews, function (v) {
                    return _.includes([uData.EventId], v.id);
                  })[0].start = moment(uData.StartDate).format("MM/DD/YYYY, hh:mm a");
                  _.filter($scope.mergedInterviews, function (v) {
                    return _.includes([uData.EventId], v.id);
                  })[0].end = moment(uData.EndDate).format("MM/DD/YYYY, hh:mm a");
                  _.filter($scope.mergedInterviews, function (v) {
                    return _.includes([uData.EventId], v.id);
                  })[0].url = uData.url;
                  showToast("Interview Updated Successfully.", 5000, function () {
                    $scope.editMode = false;
                  });
                  $scope.updateInterViewLoader = false;
                }).catch(CatchError);
              }.catch(CatchError));
            };
          }).catch(CatchError);
        }).catch(CatchError);
      }
    };
    $scope.$on("updateMarketer", function (ev, IntData) {
      var item = calendar2.getEventById(IntData.EventId);
      item.setExtendedProp("MarkterId", IntData.marketerId);
      item.setExtendedProp("marketer", IntData.marketer);
    });
    $scope.$on("updateEv", function (ev, uData) {
      var Imode = _.filter(vm.InterviewModes, function (v) {
        return _.includes([uData.modeOfInterview], v.IKey);
      });
      var Ilvel = _.filter(vm.InterviewLevels, function (v) {
        return _.includes([uData.levelOfInterview], v.IKey);
      });
      var item = calendar2.getEventById(uData.EventId);
      item.setExtendedProp("levelOfInterview", Ilvel[0].IValue);
      item.setExtendedProp("modeOfInterview", Imode[0].IValue);
      item.setExtendedProp("IntLevel", Ilvel[0].IKey);
      item.setExtendedProp("IntMode", Imode[0].IKey);
      item.setProp("start", moment(uData.StartDate).format("MM/DD/YYYY, hh:mm a"));
      item.setProp("end", moment(uData.EndDate).format("MM/DD/YYYY, hh:mm a"));
      item.setProp("url", uData.url);
      new GetIcalendar($scope.Clients);
    });
    vm.querySearch = function (searchText) {
      // if (searchText !== "") {
      var deferred = $q.defer();
      var events = calendar2.getEvents();
      $timeout(function () {
        var newstates = events.filter(function (state) {
          $scope.EventOwner = _.filter($scope.marketers, function (v) {
            return _.includes([state.extendedProps.MarkterId], v.MarketerId);
          })[0];
          if (tokenData.newRole == "MarketerAdmin") {
            if (JSON.parse(state.extendedProps.FinalStatus) !== 4 && JSON.parse(state.extendedProps.FinalStatus) !== 2) {
              return state.title.toUpperCase().indexOf(searchText.toUpperCase()) !== -1;
            }
          } else {
            if (JSON.parse(state.extendedProps.FinalStatus) !== 4 && JSON.parse(state.extendedProps.FinalStatus) !== 2 && tokenData.loginid == state.extendedProps.MarkterId) {
              return state.title.toUpperCase().indexOf(searchText.toUpperCase()) !== -1;
            }
          }
        });
        deferred.resolve(newstates);
      });

      return deferred.promise;
      // }
    };
    vm.queryCliS = function (searchText) {
      var deferred = $q.defer();
      var clients = $scope.Clients;
      $timeout(function () {
        var states = clients.filter(function (state) {
          return state.ClientName.toUpperCase().indexOf(searchText.toUpperCase()) !== -1;
        });
        deferred.resolve(states);
      });
      return deferred.promise;
    };
    $scope.clientDupCheck = function (client) {
      var cliChkInArr;
      if (client.ClientId !== undefined) {
        cliChkInArr = _.find($scope.Clients, {
          ClientId: client.ClientId
        });
        if (cliChkInArr !== undefined) {
          $scope.matched = true;
        } else {
          $scope.matched = false;
        }
      } else {
        $scope.matched = false;
        cliChkInArr = _.find($scope.Clients, {
          ClientName: client
        });
        if (cliChkInArr !== undefined) {
          $scope.matched = true;
        } else {
          $scope.matched = false;
        }
      }
    };
    vm.qryhotlist = function (searchText) {
      var deferred = $q.defer();
      $timeout(function () {
        var states = $scope.hotlist.filter(function (state) {
          return state.FirstName.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.LastName.toUpperCase().indexOf(searchText.toUpperCase()) !== -1 || state.Email.toUpperCase().indexOf(searchText.toUpperCase()) !== -1;
        });
        deferred.resolve(states);
      });
      return deferred.promise;
    };
    vm.selectedInterviewType = function (item) {
      if (item.con !== null) {
        var evs = calendar2.getEvents();
        var element = _.filter(evs, function (v) {
          return _.includes([item.con.extendedProps.InterviewId], v.extendedProps.InterviewId);
        })[0];
        $scope.EventOwner = _.filter($scope.marketers, function (v) {
          return _.includes([element.extendedProps.MarkterId], v.MarketerId);
        })[0];
        if (element.extendedProps.status == "New") {
          vm.previousIntData = element;
          vm.updatePreviousStatus = true;
        } else {
          vm.updatePreviousStatus = false;
        }
      }
    };
    vm.newIntChange = function (params) {
      vm.updatePreviousStatus = false;
      vm.sameMarketer = true;
    };
    vm.UpdateStatus = function (status, uData) {
      var request = {
        Status: JSON.parse(status),
        EventId: uData.id
      };
      dataService.newToken().then(function (response) {
        dataService.UpdateInterviewStatus(request).then(function (response) {
          if (JSON.parse(status) === 2 || JSON.parse(status) === 4) {
            var request = {
              Status: JSON.parse(status),
              InterviewId: uData.InterviewId
            };
            dataService.newToken().then(function (response) {
              dataService.UpdateFinalInterviewStatus(request).then(function (response) {}).catch(CatchError);
            }).catch(CatchError);
          }
          var item = calendar2.getEventById(uData.id);
          var items = calendar2.getEvents();

          function FinalStatusUpdate(status) {
            for (var index = 0; index < items.length; index++) {
              var element = items[index];
              if (element.extendedProps.InterviewId == uData.InterviewId) {
                element.setExtendedProp("FinalStatus", status);
              }
            }
          }
          if (status === "1") {
            _.filter(vm.events, function (v) {
              return _.includes([JSON.parse(uData.id)], v.id);
            })[0].status = "Confirmed";
            item.setExtendedProp("status", "Confirmed");
            $scope.canEdit = false;
            showToast("Status Update Successfully.", 5000, function () {
              vm.updatePreviousStatus = false;
            });
          } else if (status === "2") {
            _.filter(vm.events, function (v) {
              return _.includes([JSON.parse(uData.id)], v.id);
            })[0].status = "Rejected";
            item.setExtendedProp("status", "Rejected");
            item.setExtendedProp("FinalStatus", "2");
            new FinalStatusUpdate(2);
            $scope.canEdit = false;
            showToast("Status Update Successfully. As Interview is rejected another round cannot be created.", 5000, function () {
              vm.updatePreviousStatus = false;
              $scope.user.con = null;
              $scope.EnableBtn = false;
              $scope.files = [];
              $scope.recurringInterview = undefined;
              $("#addNewInterview").modal("hide");
            });
          } else if (status === "4") {
            _.filter(vm.events, function (v) {
              return _.includes([JSON.parse(uData.id)], v.id);
            })[0].status = "Placed";
            $scope.canEdit = false;
            item.setExtendedProp("status", "Placed");
            new FinalStatusUpdate(2);
            showToast("Congratulations., Consultant Placed Successfully.", 5000, function () {
              vm.updatePreviousStatus = false;
              $scope.user.con = null;
              $scope.EnableBtn = false;
              $scope.files = [];
              $scope.recurringInterview = undefined;
              $("#addNewInterview").modal("hide");
            });
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.addEvent = function (data) {
      $scope.addConLoader = true;
      var id = Math.floor(10000000 + Math.random() * 90000000);
      var consultantId;
      var newInteviu = {
        EventId: id,
        StartDate: moment(data.startDate).format("MM/DD/YYYY, hh:mm a"),
        MeetingUrl: data.url,
        InvMode: data.modeOfInterview,
        InvLevel: data.levelOfInterview,
        EndDate: moment(data.endDate).format("MM/DD/YYYY, hh:mm a"),
        CreateDate: moment(new Date()),
        MarkterId: data.marketer,
        FinalStatus: "",
        SkillId: data.SkillId
      };
      if (data.ClientId === undefined) {
        newInteviu.ClientId = data.con.extendedProps.cid;
      } else {
        newInteviu.ClientId = data.ClientId;
      }
      if (data.PVId === undefined) {
        newInteviu.VendorId = data.con.extendedProps.vid;
      } else {
        newInteviu.VendorId = data.PVId;
      }
      if (data.con.extendedProps !== undefined) {
        newInteviu.InterviewId = data.con.extendedProps.InterviewId;
        newInteviu.ConslId = data.con.extendedProps.ConslId;
        newInteviu.Status = 3;
      } else {
        newInteviu.InterviewId = 0;
        newInteviu.ConslId = data.con.ConslId;
        newInteviu.Status = 3;
      }

      if (data.con.FullName === undefined) {
        newInteviu.TitleName = data.con.title;
      } else {
        newInteviu.TitleName = data.con.FullName;
      }
      if (data.comments !== undefined) {
        newInteviu.Comments = [{
          comment: data.comments,
          author: tokenData.displayname,
          time: new Date()
        }];
      } else {
        newInteviu.Comments = [];
      }

      dataService.newToken().then(function (response) {
        dataService.addInterview(newInteviu).then(function (response) {
          if (response.data !== -1) {
            var uploadResObj = new FormData();
            uploadResObj.append("file", $scope.files[0]);
            uploadResObj.append("InterviewId", response.data);
            dataService.newToken().then(function (response) {
              dataService.UploadResume(uploadResObj).then(function (response) {
                new GetIcalendar($scope.Clients);
                $("#addNewInterview").modal("hide");
                $("body").removeAttr("style");
                $scope.user = {
                  title: undefined,
                  startDate: undefined,
                  url: undefined,
                  modeOfInterview: undefined,
                  levelOfInterview: undefined,
                  comments: undefined,
                  endDate: undefined,
                  con: null
                };
                $scope.recurringInterview = null;
                vm.updatePreviousStatus = true;
                $scope.addNewInterview.$setUntouched();
                $scope.addNewInterview.$setPristine();
                $scope.addConLoader = false;
              }).catch(CatchError);
            }).catch(CatchError);
          } else {
            showToast("OOPs.., Failed to create Interview. Please try again.", 5000, function () {
              $("#addNewInterview").modal("hide");
              $("body").removeAttr("style");
              $scope.user = {
                title: undefined,
                startDate: undefined,
                url: undefined,
                modeOfInterview: undefined,
                levelOfInterview: undefined,
                comments: undefined,
                endDate: undefined
              };
              vm.updatePreviousStatus = false;
              $scope.recurringInterview = null;
              $scope.addNewInterview.$setUntouched();
              $scope.addNewInterview.$setPristine();
              $scope.addConLoader = false;
            });
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.$on("evData", function (ev, data) {
      for (var index = 0; index < vm.events.length; index++) {
        if (data.id == vm.events[index].id) {
          var reqObj = {
            DelIndInt: true,
            EventId: data.id
          };
          dataService.newToken().then(function (response) {
            dataService.addInterview(reqObj).then(function (response) {
              if (response.data !== -1) {
                vm.events.splice(index, 1);
                var event = calendar2.getEventById(data.id);
                event.remove();
                $rootScope.$broadcast("removeDialog");
              }
            }).catch(CatchError);
          }).catch(CatchError);
          break;
        }
      }
    });
    $scope.$on("dellALL", function (ev, data) {
      for (var index = 0; index < vm.events.length; index++) {
        if (data.id == vm.events[index].id) {
          var reqObj = {
            DelAllInt: true,
            InterviewId: data.InterviewId
          };
          dataService.newToken().then(function (response) {
            dataService.addInterview(reqObj).then(function (response) {
              if (response.data !== -1) {
                vm.events.splice(index, 1);
                var event = calendar2.getEventById(data.id);
                event.remove();
                new GetIcalendar($scope.Clients);
                $rootScope.$broadcast("removeDialog");
              }
            }).catch(CatchError);
          }).catch(CatchError);
          break;
        }
      }
    });
    $scope.eventRender = function (info) {
      var tooltip = new Tooltip(info.el, {
        title: info.event.extendedProps.marketer,
        placement: "top",
        trigger: "hover",
        container: "body"
      });
    };
    $scope.removeFile = function (element) {
      $scope.files = [];
      $scope.EnableBtn = false;
    };
    $scope.setFiles = function (element) {
      $scope.$apply(function (scope) {
        $scope.AttachStatus = "";
        $scope.files = [];
        for (var i = 0; i < element.files.length; i++) {
          $scope.files.push(element.files[i]);
        }
        if ($scope.files.length > 0) {
          $scope.EnableBtn = true;
        }
        $scope.progressVisible = false;
      });
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('jobposting', {
    controller: JobPostingsController,
    controllerAs: 'vm',
    templateUrl: 'app/components/sales/jobpostings/JobPostings.tpl.html'
  });

  function JobPostingsController($scope, $location, $mdSidenav, dataService, $mdToast, $mdSelect, $mdDialog, $rootScope, $timeout, $q, moment, $state) {
    var vm = this;

    function loadjscssfile(filename, filetype) {
      if (filetype == 'js') {
        //if filename is a external JavaScript file
        var fileref = document.createElement('script');
        fileref.setAttribute('type', 'text/javascript');
        fileref.setAttribute('src', filename);
      } else if (filetype == 'css') {
        //if filename is an external CSS file
        var fileref = document.createElement('link');
        fileref.setAttribute('rel', 'stylesheet');
        fileref.setAttribute('type', 'text/css');
        fileref.setAttribute('href', filename);
      }
      if (typeof fileref != 'undefined') document.getElementsByTagName('head')[0].appendChild(fileref);
    }
    loadjscssfile('https://cdn.datatables.net/v/dt/dt-1.10.20/b-1.6.1/b-flash-1.6.1/b-html5-1.6.1/fc-3.3.0/fh-3.1.6/datatables.min.js', 'js');
    loadjscssfile('https://unpkg.com/tippy.js@5', 'js');
    loadjscssfile('https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css', 'css');
    $scope.postingDetailsShow = false;
    $scope.addPosting = false;
    $scope.jobPostingBtnEnable = false;
    var JPtable;
    $scope.topLoader = true;
    $scope.tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.isjobPostingsOpen = false;
    // tippy('button', {
    //   content(reference) {
    //     var id = reference.getAttribute('data-template');
    //     var template = document.getElementById(id);
    //     return template.innerHTML;
    //   },
    // });
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };

    $scope.ExpiredJobs = [];
    $scope.ActiveJobs = [];

    function loadData($q) {
      return $q.all([dataService.GetClientsInfoMrkter(), dataService.GetVendorInfoMrkter(), dataService.GetTitleDDMrkter(), dataService.Interviewlookup(), dataService.GetHotListConsl(), dataService.GetMrkterLookUp(), dataService.GetMarketerInfoMrkter(), dataService.GetJobs()]);
    }
    dataService.newToken().then(function (response) {
      loadData($q).then(function (resp) {
        $scope.Clients = _.orderBy(resp[0].data, ['ClientName'], ['asc']);
        $scope.Vendors = _.orderBy(resp[1].data, ['VendorName'], ['asc']);
        $scope.MidVendors = resp[1].data;
        $scope.titles = resp[2].data;
        vm.InterviewModes = resp[3].data.LstImode;
        $scope.InterviewModes = vm.InterviewModes;
        vm.InterviewLevels = resp[3].data.LstILevel;
        $scope.InterviewLevels = vm.InterviewLevels;

        vm.Statuses = resp[3].data.LstInvStatus;
        $scope.Statuses = vm.Statuses;

        vm.cons = _.sortBy(resp[4].data, ['FirstName']);
        $scope.consultantsJP = resp[4].data;
        $scope.MarketerStats = resp[5].data;
        $scope.skills = resp[5].data.ListSDD;
        $scope.marketers = resp[6].data;
        $scope.jobs = resp[7].data;
      }).then(function () {
        $scope.topLoader = false;
        for (var W = 0; W < $scope.jobs.length; W++) {
          var jobObj = $scope.jobs[W];

          jobObj.CreateDate = moment(jobObj.CreateDate).format('MM/DD/YYYY');
          for (var index = 0; index < $scope.marketers.length; index++) {
            var element = $scope.marketers[index];
            if (jobObj.JIDModel.CreatorId === element.loginid) {
              jobObj.Marketer = element;
            }
          }
          for (var index = 0; index < $scope.skills.length; index++) {
            var skillsObj = $scope.skills[index];
            if (jobObj.Position === skillsObj.SkillId) {
              jobObj.skill = skillsObj;
            }
          }
          for (var index = 0; index < $scope.Clients.length; index++) {
            var clientsObj = $scope.Clients[index];
            if (jobObj.JIDModel.ClientId === clientsObj.ClientId) {
              jobObj.client = clientsObj;
            }
          }
          for (var index = 0; index < vm.InterviewModes.length; index++) {
            var InterviewModesObj = vm.InterviewModes[index];
            if (jobObj.JIDModel.InvModeId === InterviewModesObj.IKey) {
              jobObj.InterviewMode = InterviewModesObj;
            }
          }
          if (jobObj.JStatus === 0) {
            $scope.ExpiredJobs.push(jobObj);
          } else {
            $scope.ActiveJobs.push(jobObj);
          }
        }
        $timeout(function () {
          // var table = new Tabulator('#ActiveJobs', {});

          JPtable = $('#ActiveJobs').DataTable({
            lengthMenu: [15, 25, 50, 75, 100],
            order: [],
            columnDefs: [{
              targets: 0,
              orderable: false
            }]
          });
          tippy('.tippyButton', {
            theme: 'light-border',
            placement: 'top',
            content: function content(reference) {
              var id = reference.getAttribute('data-template');
              var template = document.getElementById(id);
              if (template !== null) {
                return template.innerHTML;
              }
            }
          });
        });
        $scope.jobPostingBtnEnable = true;
      }).catch(CatchError);
    }).catch(CatchError);
    $scope.newSkill = function () {
      $mdSelect.hide();
      $mdDialog.show({
        controller: addSkillDialogController,
        templateUrl: 'app/components/sales/newResources/addSkill.Dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function addSkillDialogController($scope) {
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.addSkillData = function (data) {
        dataService.newToken().then(function (response) {
          dataService.AddSkillSet({
            Skill: data
          }).then(function (response) {
            if (response.statusText == 'OK') {
              $rootScope.$broadcast('skills', response.data);
              $mdDialog.cancel();
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }
    $scope.$on('skills', function (evt, data) {
      $scope.skills = data;
    });

    $scope.newVendor = function () {
      $mdSelect.hide();
      $mdDialog.show({
        controller: addVendorDialogController,
        templateUrl: 'app/components/hr/createUser/addVendorDialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function addVendorDialogController($scope, $mdDialog) {
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.addVendorData = function (vendorData) {
        $scope.notifier = true;
        dataService.newToken().then(function (response) {
          dataService.AddVendorMrkter(vendorData).then(function (response) {
            if (response.statusText == 'OK') {
              dataService.newToken().then(function (response) {
                dataService.GetVendorInfoMrkter().then(function (response) {
                  $rootScope.$broadcast('VendorInfo', response.data);
                  var toast = $mdToast.simple().content('Vendor added successfully.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                  $mdToast.show(toast);
                  $mdDialog.cancel();
                }).catch(CatchError);
              }).catch(CatchError);
            } else {
              var toast = $mdToast.simple().content('oops !, Something went wrong please try again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
              $mdDialog.cancel();
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }

    $scope.newClient = function () {
      $mdSelect.hide();
      $mdDialog.show({
        controller: addclientDialogController,
        templateUrl: 'app/components/hr/createUser/createUserDialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function addclientDialogController($scope, $mdDialog) {
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.addClientData = function (clientData) {
        $scope.notifier = true;
        dataService.newToken().then(function (response) {
          dataService.AddClientMrkter(clientData).then(function (response) {
            if (response.statusText == 'OK') {
              dataService.newToken().then(function (response) {
                dataService.GetClientsInfoMrkter().then(function (response) {
                  $rootScope.$broadcast('endClients', response.data);
                  var toast = $mdToast.simple().content('Client added successfully.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                  $mdToast.show(toast);
                  $mdDialog.cancel();
                }).catch(CatchError);
              }).catch(CatchError);
            } else {
              var toast = $mdToast.simple().content('oops !, Something went wrong please try again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
              $mdDialog.cancel();
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }
    $scope.selection = [];
    $scope.toggleSelection = function (fruitName) {
      var idx = $scope.selection.indexOf(fruitName);
      if (idx > -1) {
        $scope.selection.splice(idx, 1);
      } else {
        $scope.selection.push(fruitName);
      }
    };
    $scope.$on('VendorInfo', function (evt, data) {
      $scope.VendorInfo = data;
    });
    $scope.$on('endClients', function (evt, data) {
      $scope.Clients = data;
    });

    $scope.go = function (path) {
      $state.go(path);
    };

    $scope.cancelViewPosting = function () {
      $scope.postingDetailsShow = false;
    };
    $scope.cancelAddPosting = function () {
      $scope.addPosting = false;
    };
    $scope.applyConsultantView = false;
    $scope.postingDetailsToggle = function (data, index) {
      $scope.selectedJobId = data.JIDModel.JobId;
      $scope.selectedJob = data;
      $scope.selectedJob.index = index;
      $scope.addPosting = false;
      $scope.postingDetailsShow = false;
      $scope.addConsultantView = false;
      $scope.applyConsultantView = true;
      angular.element("input[type='file']").val(null);
    };
    $scope.addConsultantToggle = function () {
      $scope.addPosting = false;
      $scope.applyConsultantView = false;
      $scope.postingDetailsShow = false;
      $scope.addConsultantView = true;
    };

    $scope.newJobPostingFormSub = function (data) {
      // $scope.newJobPosting.Description = "";
      data.JApplyModel = {};
      data.JApplyModel.Comments = [{
        comment: data.Comments,
        author: $scope.tokenData.displayname,
        time: new Date()
      }];
      data.JStatus = 1;
      dataService.newToken().then(function (response) {
        dataService.JobPosting(data).then(function (response) {
          $scope.NewJobPostedRes = response.data;
          $scope.ExpiredJobs = [];
          $scope.ActiveJobs = [];
          dataService.newToken().then(function (response) {
            dataService.GetJobs().then(function (jobsresponse) {
              for (var W = 0; W < jobsresponse.data.length; W++) {
                var jobObj = jobsresponse.data[W];
                jobObj.CreateDate = moment(jobObj.CreateDate).format('MM/DD/YYYY');
                for (var index = 0; index < $scope.marketers.length; index++) {
                  var element = $scope.marketers[index];
                  if (jobObj.JIDModel.CreatorId === element.loginid) {
                    jobObj.Marketer = element;
                  }
                }
                for (var index = 0; index < $scope.skills.length; index++) {
                  var skillsObj = $scope.skills[index];
                  if (jobObj.Position === skillsObj.SkillId) {
                    jobObj.skill = skillsObj;
                  }
                }
                for (var index = 0; index < $scope.Clients.length; index++) {
                  var clientsObj = $scope.Clients[index];
                  if (jobObj.JIDModel.ClientId === clientsObj.ClientId) {
                    jobObj.client = clientsObj;
                  }
                }
                for (var index = 0; index < vm.InterviewModes.length; index++) {
                  var InterviewModesObj = vm.InterviewModes[index];
                  if (jobObj.JIDModel.InvModeId === InterviewModesObj.IKey) {
                    jobObj.InterviewMode = InterviewModesObj;
                  }
                }

                if (jobObj.JStatus === 0) {
                  $scope.ExpiredJobs.push(jobObj);
                } else {
                  $scope.ActiveJobs.push(jobObj);
                }
              }
              $timeout(function () {
                // JPtable = $(".JPtable").DataTable({
                //   select: true,
                //   dom: "tlrip",
                //   lengthMenu: [15, 25, 50, 75, 100],
                //   order: [],
                //   columnDefs: [
                //     {
                //       targets: 0,
                //       orderable: false
                //     }
                //   ]
                // });
                tippy('.tippyButton', {
                  theme: 'light-border',
                  placement: 'right',
                  content: function content(reference) {
                    var id = reference.getAttribute('data-template');
                    var template = document.getElementById(id);
                    if (template !== null) {
                      return template.innerHTML;
                    }
                  }
                });
                // tippy(".tippy", {
                //   theme: "light-border",
                //   placement: "top"
                // });
              });

              $scope.jobs = jobsresponse.data;
              // $timeout(function() {
              //   JPtable.draw();
              // });

              $scope.newJobPosting = {};
              $scope.newJobPostingname.$setPristine();
              $scope.newJobPostingname.$setUntouched();
              $scope.addPosting = false;
              $scope.data = {};
            });
          }).catch(CatchError);
        });
      }).catch(CatchError);
    };
    $scope.getFileDetails = function (e) {
      $scope.upFiles = e;
      $scope.files = [];
      $scope.$apply(function () {
        for (var i = 0; i < e.files.length; i++) {
          $scope.files.push(e.files[i]);
        }
      });
    };
    $scope.applyJobSubProcessing = false;
    $scope.applyJobSub = function (jobId, conData) {
      $scope.applyJobSubProcessing = true;
      var data = new FormData();
      data.append('JobId', jobId);
      data.append('ConslId', conData.ConslId);
      data.append('Comments', conData.Comments);
      data.append('CreatorId', conData.CreatorId);
      for (var i in $scope.files) {
        data.append('file', $scope.files[i]);
      }
      dataService.newToken().then(function (response) {
        dataService.applyJob(data).then(function (response) {
          $scope.response = response.data;
          $scope.ActiveJobs[$scope.selectedJob.index].AppCount = $scope.ActiveJobs[$scope.selectedJob.index].AppCount + 1;
          $scope.applyJobSubProcessing = false;
          $scope.applyConsultantView = false;
          // $scope.addPosting = !$scope.addPosting;
          $scope.applyJob = {};
          $scope.applyJobForm.$setPristine();
          $scope.applyJobForm.$setUntouched();
          $scope.files = [];
          $mdToast.show($mdToast.simple().textContent('Applicant Added Successfully!').hideDelay(3000));
        });
      }).catch(CatchError);
    };

    $scope.viewJobApplys = function (jobData) {};
    $scope.jobView = function (jobData, index) {
      $scope.selectedJob = jobData;
      $scope.selectedJob.index = index;
      $scope.addConsultantView = false;
      $scope.applyConsultantView = false;
      $scope.postingDetailsShow = true;
      var request = {
        JidModel: {
          JobId: jobData.JIDModel.JobId
        }
      };
      dataService.newToken().then(function (response) {
        dataService.AppliedConsByJobId(request).then(function (response) {
          if (response.data.gjpmodel !== null) {
            for (var i = 0; i < response.data.gjpmodel.lstJPModel.length; i++) {
              var CBJID = response.data.gjpmodel.lstJPModel[i];
              CBJID.CreateDate = moment(CBJID.CreateDate).format('MM/DD/YYYY');
              for (var index = 0; index < $scope.consultantsJP.length; index++) {
                var element = $scope.consultantsJP[index];
                if (CBJID.JApplyModel.ConslId === element.ConslId) {
                  CBJID.consl = element;
                }
              }
              for (var w = 0; w < $scope.marketers.length; w++) {
                var marketerObj = $scope.marketers[w];
                if (CBJID.JIDModel.CreatorId === marketerObj.loginid) {
                  CBJID.marketer = marketerObj;
                }
              }
            }
            $scope.jobApplications = response.data;
            $timeout(function () {
              tippy('.applicantsTippy', {
                theme: 'light-border',
                placement: 'right',
                content: function content(reference) {
                  var id = reference.getAttribute('data-template');
                  var template = document.getElementById(id);
                  if (template !== null) {
                    return template.innerHTML;
                  }
                }
              });
            });
          } else {
            $scope.jobApplications = [];
          }
        });
      }).catch(CatchError);
    };

    $scope.activity = function (jbId, SkId, ConId) {
      $mdDialog.show({
        controller: viewActivityController,
        templateUrl: 'app/components/sales/jobpostings/viewActivity.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          ConId: ConId,
          marketers: $scope.marketers,
          vendors: $scope.Vendors,
          clients: $scope.Clients
        }
      });
    };

    function viewActivityController(ConId, marketers, vendors, clients, $scope, $sce) {
      $scope.ConActivity = [];
      var req = {
        ConslId: ConId
      };
      dataService.newToken().then(function (response) {
        dataService.GetInvActivityByConslid(req).then(function (response) {
          for (var index = 0; index < response.data.length; index++) {
            var InnerList = response.data[index].listofEventDetails;
            for (var ingo = 0; ingo < InnerList.length; ingo++) {
              var element = InnerList[ingo];
              if (element.EventStatus === 0) {
                element.EventStatus = 3;
              }
              var client = _.filter(clients, function (v) {
                return _.includes([element.ClientId], v.ClientId);
              });
              var vendor = _.filter(vendors, function (v) {
                return _.includes([element.VendorId], v.VendorId);
              });
              var consultant = _.filter(vm.cons, function (v) {
                return _.includes([element.ConslId], v.ConslId);
              });
              var Imode = _.filter(vm.InterviewModes, function (v) {
                return _.includes([element.IntMode.IKey], v.IKey);
              });
              var Ilvel = _.filter(vm.InterviewLevels, function (v) {
                return _.includes([element.IntLevel.IKey], v.IKey);
              });
              var status = _.filter(vm.Statuses, function (v) {
                return _.includes([element.EventStatus], v.IKey);
              });
              var marketer = _.filter(marketers, function (v) {
                return _.includes([element.MarketerId], v.loginid);
              });
              var obj = {
                id: element.EventId,
                title: consultant[0].FirstName + ' ' + consultant[0].LastName,
                start: element.StartDate,
                marketer: marketer[0].MarkterName,
                MarkterId: element.MarketerId,
                url: element.MeetingUrl,
                modeOfInterview: Imode[0].IValue,
                levelOfInterview: Ilvel[0].IValue,
                IntMode: element.IntMode.IKey,
                IntLevel: element.IntLevel.IKey,
                comments: element.EventComments,
                end: element.EndDate,
                allDay: false,
                status: status[0].IValue,
                Client: client[0].ClientName,
                VendorId: vendor[0].VendorName,
                CreateDate: element.CreateDate,
                InterviewId: element.InterviewId,
                ConslId: element.ConslId,
                FinalStatus: element.FinalStatus,
                cid: element.ClientId,
                vid: element.VendorId,
                DocUrl: element.DocUrl
              };
              $scope.ConActivity.push(obj);
            }
          }
          $scope.ConActivity = _.chain($scope.ConActivity).groupBy('Client').map(function (value, key) {
            return {
              Client: key,
              title: value[0].title,
              Invs: _.chain(value).groupBy('InterviewId').map(function (value, key) {
                return {
                  InterviewId: key,
                  InvDetails: value
                };
              }).value()
            };
          }).value();

          $timeout(function () {
            var toggler = document.getElementsByClassName('caret');
            var i;

            for (i = 0; i < toggler.length; i++) {
              toggler[i].addEventListener('click', function () {
                this.parentElement.querySelector('.nested').classList.toggle('active');
                this.classList.toggle('caret-down');
              });
            }
          });
        });
      }).catch(CatchError);
      $scope.downloadResum = function (id, url) {
        var obj = {
          InterviewId: id,
          FileUrl: url
        };
        dataService.newToken().then(function (response) {
          dataService.DownloadResume(obj).then(function (response, status, headers) {
            var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, ''));
            var anchor = $('<a/>');
            anchor.attr({
              href: 'data:application/octet-stream; base64,' + base64,
              target: '_blank',
              download: url
            })[0].click();
          }).catch(CatchError);
        }).catch(CatchError);
      };
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.moreConInfo = function (con) {
        $scope.SelectedCon = con;
      };
    }
    $scope.downloadResum = function (id, url, selectedJob) {
      var obj = {
        conslid: id,
        FileUrl: url
      };
      dataService.newToken().then(function (response) {
        dataService.JPDownloadResume(obj).then(function (response, status, headers) {
          var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
            return data + String.fromCharCode(byte);
          }, ''));
          var FileName = url.replace(/\s/g, '');
          FileName = FileName.split('~#')[2];
          var req = {
            value: base64,
            FileName: FileName
          };
          //dataService.newToken().then(function(response){
          dataService.cres(req).then(function (response) {
            // if (response.data.status === "000") {
            //   $mdDialog
            //     .show({
            //       controller: viewDocController,
            //       templateUrl: "components/layout/jobpostings/viewDoc.html",
            //       parent: angular.element(document.body),
            //       clickOutsideToClose: false,
            //       locals: {
            //         data: response.data
            //       }
            //     })
            //     .then(
            //       function(answer) {
            //         $scope.status =
            //           'You said the information was "' + answer + '".';
            //       },
            //       function() {
            //         $scope.status = "You cancelled the dialog.";
            //       }
            //     );
            //   function viewDocController(data, $scope, $sce) {
            //     // $scope.url =
            //     //   "https://docs.google.com/gview?url=https://hrm-dev.azurewebsites.net/docs/" +
            //     //   data.FileName +
            //     //   "?&embedded=true";
            //     $scope.url = $sce.trustAsResourceUrl(
            //       "https://docs.google.com/gview?url=https://hrm-dev.azurewebsites.net/docs/sk.docx?&embedded=true"
            //     );
            //     $scope.FinishViewingRes = function() {};
            //   }
            // }
            //});
            var anchor = $('<a/>');
            anchor.attr({
              href: 'data:application/msword; base64,' + base64,
              target: '_blank',
              download: selectedJob.consl.FirstName + '_' + selectedJob.consl.LastName + '_' + selectedJob.consl.Skillset + '.' + url.match(/\.([^\./\?]+)($|\?)/)[1]
            })[0].click();
          }).catch(CatchError);
        });
      }).catch(CatchError);
    };$scope.removeJApplication = function (data, index) {
      var req = {
        JIDModel: {
          JobPostId: data.JIDModel.JobPostId
        }
      };
      dataService.newToken().then(function (response) {
        dataService.removeJA(req).then(function (response) {
          var res = response.data;
          if (res === 0) {
            $scope.jobApplications.gjpmodel.lstJPModel.splice(index, 1);
            $scope.ActiveJobs[$scope.selectedJob.index].AppCount = $scope.ActiveJobs[$scope.selectedJob.index].AppCount - 1;
          }
        });
      }).catch(CatchError);
    };$scope.removeJPosting = function (data, index) {
      var confirm = $mdDialog.confirm().title('Are you sure, you want to delete Job Posting?').textContent('You cannot undo this action.').ariaLabel('Remove Job Status').ok('Please do it!').cancel('Cancel');

      $mdDialog.show(confirm).then(function () {
        var req = {
          JIDModel: {
            JobId: data.JIDModel.JobId
          }
        };
        dataService.newToken().then(function (response) {
          dataService.removeJP(req).then(function (response) {
            if (response.data === 0) {
              $scope.ActiveJobs.splice(index, 1);
              $scope.postingDetailsShow = false;
            }
          });
        }).catch(CatchError);
      });
    };$scope.updateJobStatus = function (job, data, index) {
      var title, textContent;
      if (data === 1) {
        title = 'Would you like to activate your Job Posting?';
        textContent = "You can revert back in 'active Jobs'";
      } else {
        title = 'Would you like to deactivate your Job Posting?';
        textContent = "You can revert back in 'expired Jobs'";
      }
      var confirm = $mdDialog.confirm().title(title).textContent(textContent).ariaLabel('Update Job Status').ok('Please do it!').cancel('Cancel');

      $mdDialog.show(confirm).then(function () {
        var req = {
          JStatus: data,
          JIDModel: {
            JobId: job.JIDModel.JobId
          }
        };
        dataService.newToken().then(function (response) {
          dataService.updateJStatus(req).then(function (response) {
            var res = response.data;
            if (res === 0) {
              if (data === 0) {
                $scope.ExpiredJobs.push($scope.ActiveJobs[index]);
                $scope.ActiveJobs.splice(index, 1);
              } else {
                //$scope.ExpiredJobs.push($scope.ActiveJobs[index]);
                $scope.ExpiredJobs.splice(index, 1);
                $scope.ActiveJobs.splice(0, 0, job);
                $scope.JPSelectedTab = 0;
              }
            }
          });
        }).catch(CatchError);
      }, function () {
        $scope.status = 'You decided to keep your debt.';
      });
    };$scope.addJAComment = function (data, type) {
      data.type = type;
      $mdDialog.show({
        controller: AddCommentsController,
        templateUrl: 'app/components/sales/jobpostings/addCommentsDialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        openFrom: '#left',
        closeTo: angular.element(document.querySelector('#right')),
        locals: {
          data: data
        }
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function AddCommentsController(data, $scope) {
      var tokenData = angular.fromJson(localStorage.getItem('tokenData'));
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.addComments = function (c, t) {
        var comObj = {
          comment: c,
          author: tokenData.displayname,
          time: new Date()
        };
        if (data.JApplyModel.Comments === null) {
          data.JApplyModel.Comments = [];
        }
        data.JApplyModel.Comments.push(comObj);
        var req = {
          JApplyModel: {
            Comments: data.JApplyModel.Comments
          }
        };
        if (data.type == 'jappid') {
          req.JIDModel = {
            JobPostId: data.JIDModel.JobPostId
          };
        } else {
          req.JIDModel = {
            JobId: data.JIDModel.JobId
          };
        }
        dataService.newToken().then(function (response) {
          dataService.updateComments(req).then(function (response) {
            var res = response.data;
            if (response.data === 0) {
              $mdDialog.cancel();
            } else {
              var toast = $mdToast.simple().content('oops., Something went wrong please try again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
            }
          });
        }).catch(CatchError);
      };
    }

    $scope.states = [{
      name: 'Alabama',
      abbreviation: 'AL'
    }, {
      name: 'Alaska',
      abbreviation: 'AK'
    }, {
      name: 'American Samoa',
      abbreviation: 'AS'
    }, {
      name: 'Arizona',
      abbreviation: 'AZ'
    }, {
      name: 'Arkansas',
      abbreviation: 'AR'
    }, {
      name: 'California',
      abbreviation: 'CA'
    }, {
      name: 'Colorado',
      abbreviation: 'CO'
    }, {
      name: 'Connecticut',
      abbreviation: 'CT'
    }, {
      name: 'Delaware',
      abbreviation: 'DE'
    }, {
      name: 'District Of Columbia',
      abbreviation: 'DC'
    }, {
      name: 'Federated States Of Micronesia',
      abbreviation: 'FM'
    }, {
      name: 'Florida',
      abbreviation: 'FL'
    }, {
      name: 'Georgia',
      abbreviation: 'GA'
    }, {
      name: 'Guam Gu',
      abbreviation: 'GU'
    }, {
      name: 'Hawaii',
      abbreviation: 'HI'
    }, {
      name: 'Idaho',
      abbreviation: 'ID'
    }, {
      name: 'Illinois',
      abbreviation: 'IL'
    }, {
      name: 'Indiana',
      abbreviation: 'IN'
    }, {
      name: 'Iowa',
      abbreviation: 'IA'
    }, {
      name: 'Kansas',
      abbreviation: 'KS'
    }, {
      name: 'Kentucky',
      abbreviation: 'KY'
    }, {
      name: 'Louisiana',
      abbreviation: 'LA'
    }, {
      name: 'Maine',
      abbreviation: 'ME'
    }, {
      name: 'Marshall Islands',
      abbreviation: 'MH'
    }, {
      name: 'Maryland',
      abbreviation: 'MD'
    }, {
      name: 'Massachusetts',
      abbreviation: 'MA'
    }, {
      name: 'Michigan',
      abbreviation: 'MI'
    }, {
      name: 'Minnesota',
      abbreviation: 'MN'
    }, {
      name: 'Mississippi',
      abbreviation: 'MS'
    }, {
      name: 'Missouri',
      abbreviation: 'MO'
    }, {
      name: 'Montana',
      abbreviation: 'MT'
    }, {
      name: 'Nebraska',
      abbreviation: 'NE'
    }, {
      name: 'Nevada',
      abbreviation: 'NV'
    }, {
      name: 'New Hampshire',
      abbreviation: 'NH'
    }, {
      name: 'New Jersey',
      abbreviation: 'NJ'
    }, {
      name: 'New Mexico',
      abbreviation: 'NM'
    }, {
      name: 'New York',
      abbreviation: 'NY'
    }, {
      name: 'North Carolina',
      abbreviation: 'NC'
    }, {
      name: 'North Dakota',
      abbreviation: 'ND'
    }, {
      name: 'Northern Mariana Islands',
      abbreviation: 'MP'
    }, {
      name: 'Ohio',
      abbreviation: 'OH'
    }, {
      name: 'Oklahoma',
      abbreviation: 'OK'
    }, {
      name: 'Oregon',
      abbreviation: 'OR'
    }, {
      name: 'Palau',
      abbreviation: 'PW'
    }, {
      name: 'Pennsylvania',
      abbreviation: 'PA'
    }, {
      name: 'Puerto Rico',
      abbreviation: 'PR'
    }, {
      name: 'Rhode Island',
      abbreviation: 'RI'
    }, {
      name: 'South Carolina',
      abbreviation: 'SC'
    }, {
      name: 'South Dakota',
      abbreviation: 'SD'
    }, {
      name: 'Tennessee',
      abbreviation: 'TN'
    }, {
      name: 'Texas',
      abbreviation: 'TX'
    }, {
      name: 'Utah',
      abbreviation: 'UT'
    }, {
      name: 'Vermont',
      abbreviation: 'VT'
    }, {
      name: 'Virgin Islands',
      abbreviation: 'VI'
    }, {
      name: 'Virginia',
      abbreviation: 'VA'
    }, {
      name: 'Washington',
      abbreviation: 'WA'
    }, {
      name: 'West Virginia',
      abbreviation: 'WV'
    }, {
      name: 'Wisconsin',
      abbreviation: 'WI'
    }, {
      name: 'Wyoming',
      abbreviation: 'WY'
    }];
  }
})();


(function () {
  'use strict';

  angular.module('app').component('tsSubmit', {
    controller: TsSubmitCtrl,
    controllerAs: 'vm',
    templateUrl: 'app/components/consultant/tsSubmit/tsSubmit.html'
  });

  function TsSubmitCtrl($scope, $rootScope, dataService, $location, $http, $timeout, $mdToast, moment, $state) {
    window.isMobile = /iphone|ipod|ipad|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(navigator.userAgent.toLowerCase());
    $scope.isMobile = window.isMobile;
    $scope.ShowTimeTracker = true;
    $scope.ShowDocuments = true;
    $scope.ShowSubmittedTs = true;
    $scope.showSubmittedTsloader = true;
    $scope.showSubmittedTsExport = true;
    var loginmodel = localStorage.getItem('userAuthData');
    var tokenData = JSON.parse(localStorage.getItem('tokenData'));
    $scope.tokenData = tokenData;
    $scope.notMon = false;
    $scope.showsubmit = false;
    var reqLid = {};
    reqLid.loginid = parseInt(tokenData.loginid);
    $scope.userDataLoaded = false;
    $scope.uploadNeeded = true;
    $scope.loginLoader = false;
    $scope.SubmittedRanges = [];
    $scope.PortalSubmittedRanges = [];

    $scope.submittedTimesheetLoader = false;

    $scope.ctsUploadLoader = false;
    $scope.readyUpload = false;
    $scope.clientPendingTs = false;
    $scope.clientTsSubmisson = true;
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    var tsDates;
    if (localStorage.getItem('tTrackerDates') == undefined) {
      $state.go('dashboard');
    } else {
      tsDates = JSON.parse(localStorage.getItem('tTrackerDates'));
    }

    dataService.newToken().then(function (response) {
      dataService.GetClients(reqLid).then(function (response) {
        // $scope.ClientsList = response.data;
        angular.forEach(response.data, function (client) {
          if (client.ClientId === tsDates.PortalTsClient) {
            $scope.endClient = client;
          }
        });
        $scope.userDataLoaded = true;
        var reqTsBody = {
          loginid: tokenData.loginid,
          Year: moment(tsDates.fromDate).format('YYYY')
        };
        dataService.newToken().then(function (response) {
          dataService.GetSubmittedTSids(reqTsBody).then(function (response) {
            localStorage.setItem('submittesTimesheets', JSON.stringify(response.data));
            $scope.submittedTimesheets = response.data;
          }).catch(function (error) {
            if (error.statusText == 'Unauthorized') {
              var message = 'Your Session is Expired, Please login again';
              $scope.authenticated = false;
              var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
              localStorage.clear();
              $state.go('signin');
            }
          });
        }).catch(CatchError);

        new TimesheetSubmit();
      });
    }).catch(CatchError);

    function showTimetrackerDetails(allDates) {
      $scope.timeTrackerDetails.StartDate = allDates.StartDate;
      $scope.timeTrackerDetails.EndDate = allDates.EndDate;
      $scope.timeTrackerDetails.TotalHours = '0';
      var timeInfos = [];
      angular.forEach(allDates.dates, function (d) {
        var isDiable;
        var clientProjectStartDate = moment($scope.endClient.StartDate).format('MM/DD/YYYY');
        var eachTSPDate = d.month + '/' + d.date + '/' + d.year;

        if (moment(eachTSPDate).isBefore(clientProjectStartDate)) {
          isDiable = true;
        } else {
          isDiable = false;
        }
        var obj = {
          Date: d.date,
          Day: d.day,
          month: d.month,
          year: d.year,
          Hours: 0,
          fullDate: d.month + '/' + d.date + '/' + d.year,
          disabled: isDiable
        };
        timeInfos.push(obj);
      });
      $scope.timeTrackerDetails.timeInfos = timeInfos;
      $scope.showTimetrackerPage = true;
      $scope.showTimetrackerloader = false;
      $scope.ShowDocuments = false;
      $scope.ShowSubmittedTs = false;
    }
    $scope.showTimetrackerPage = true;

    function TimesheetSubmit() {
      var dates = {
        fromDate: tsDates.fromDate,
        toDate: tsDates.toDate
      };
      $scope.showTimetrackerloader = true;
      var StartDate = moment(dates.fromDate).format('MM/DD/YYYY');
      var EndDate = moment(dates.toDate).format('MM/DD/YYYY');

      function enumerateDaysBetweenDates(SEdates) {
        var now = moment(SEdates.fromDate),
            dates = [],
            endDate = moment(SEdates.toDate);

        while (now.isSameOrBefore(endDate)) {
          var obj = {
            day: now.format('ddd/MM/DD/YYYY').split('/')[0],
            month: now.format('ddd/MM/DD/YYYY').split('/')[1],
            date: now.format('ddd/MM/DD/YYYY').split('/')[2],
            year: now.format('ddd/MM/DD/YYYY').split('/')[3]
          };
          dates.push(obj);
          now.add(1, 'days');
        }
        var objj = {
          StartDate: StartDate,
          EndDate: EndDate,
          dates: dates
        };
        showTimetrackerDetails(objj);
      }

      $scope.timesheet = {
        StartDate: '',
        timeInfos: [{
          date: '',
          Hours: ''
        }]
      };
      $scope.timeTrackerDetails = {};

      enumerateDaysBetweenDates(dates);
      // $scope.userDataLoaded = true;
      $scope.checkAll = function () {
        $scope.showsubmit = !$scope.showsubmit;
      };
    }

    $scope.updateHours = function () {
      var tot = 0;
      angular.forEach($scope.timeTrackerDetails.timeInfos, function (h) {
        if (h.Hours !== '') {
          tot += h.Hours;
        }
      });
      $scope.timeTrackerDetails.TotalHours = tot;
    };
    $scope.cancelTimesheet = function () {
      $state.go('dashboard');
    };
    $scope.SaveTimesheet = function (timesheet) {
      var tsRange = moment(timesheet.StartDate).format('M/D/YYYY') + '-' + moment(timesheet.EndDate).format('M/D/YYYY');
      var RejectedTimeSheet, UniqueTSId;
      angular.forEach($scope.submittedTimesheets, function (ts) {
        if (ts.Status == 3 && ts.submitedRange == tsRange) {
          RejectedTimeSheet = true;
          UniqueTSId = ts.UniqueTSId;
        }
      });

      var ptData = JSON.parse(localStorage.getItem('PrfPicData'));
      $scope.submittedTimesheetLoader = true;
      //   $scope.endtimesheet = timesheet;
      var obj = {
        PayrollYear: timesheet.timeInfos[0].year,
        loginmodel: {
          loginid: JSON.parse(localStorage.getItem('tokenData')).loginid
        },
        RejectedTimeSheet: RejectedTimeSheet,
        monthlytime: [{
          StartDate: timesheet.StartDate,
          EndDate: timesheet.EndDate,
          PayrollMonth: timesheet.timeInfos[0].month,
          TotalHours: timesheet.TotalHours,
          timeinfo: timesheet.timeInfos,
          Client: $scope.endClient.ClientName,
          Title: tsDates.Title,
          Guid: {
            guid: UniqueTSId
          }
        }],
        token: localStorage.getItem('token')
      };
      dataService.newToken().then(function (response) {
        dataService.SaveTime(obj).then(function (response) {
          $scope.timesheetSubSuccess = true;

          $scope.ShowTimeTracker = true;
          $scope.ShowDocuments = true;
          $scope.ShowSubmittedTs = true;
          setTimeout(function () {
            $scope.timesheetSubSuccess = false;
          }, 2000);

          $scope.showTimetrackerPage = false;

          $scope.submittedTimesheetLoader = false;
          $scope.disablesubmit = false;
          localStorage.removeItem('tTrackerDates');
          $state.go('dashboard');
        }).catch(function (error) {
          if (error.statusText == 'Unauthorized') {
            var message = 'Your Session is Expired, Please login again';
            $scope.authenticated = false;
            var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
            $mdToast.show(toast);
            localStorage.clear();
            $state.go('signin');
          }
        });
      }).catch(CatchError);
      $scope.go = function (path) {
        $state.go(path);
      };
      $scope.firstLogin = false;
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('marketerdashboard', {
    controller: MarketerDashboardController,
    controllerAs: 'vm',
    templateUrl: 'app/components/sales/dashboard/Marketer.dashboard.html'
  });

  function MarketerDashboardController($scope, $interval) {
    window.isMobile = /iphone|ipod|ipad|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(navigator.userAgent.toLowerCase());
    $scope.isMobile = window.isMobile;
    $(document).ready(function () {
      $('#marketer-dashboard').fadeIn(500);
    });
    $scope.quotes = [{
      "quote": "It's not what you sell that matters as much as how you sell it!",
      "author": " — Brian Halligan, CEO & Co-Founder, HubSpot"
    }, {
      "quote": "Many companies have forgotten they sell to actual people. Humans care about the entire experience, not just the marketing or sales or service. To really win in the modern age, you must solve for humans.",
      "author": " — Dharmesh Shah, CTO & Co-Founder, HubSpot"
    }, {
      "quote": "Ignoring online marketing is like opening a business but not telling anyone.",
      "author": " — KB Marketing Agency"
    }, {
      "quote": "Marketing’s job is never done. It’s about perpetual motion. We must continue to innovate every day.",
      "author": " — Beth Comstock, Former CMO & Vice Chair, GE"
    }, {
      "quote": "For me, pop culture is very fluid: it's music, it's movies, it's books, it's art, it's tech, it's so many things — and as marketing and brand advocates, we should be able to take products and services and match them to what's happening in pop culture.",
      "author": " — Bozoma Saint John, CMO, Endeavor"
    }, {
      "quote": "Integrated marketing offers opportunities to break through to consumers in new markets.",
      "author": " — Betsy Holden, Senior Advisor, McKinsey & Co."
    }, {
      "quote": "The best marketing doesn't feel like marketing.",
      "author": " — Tom Fishburne, Founder & CEO, Marketoonist"
    }, {
      "quote": "To continue winning the internet marketing game, your content has to be more than just brilliant — it has to give the people consuming that content the ability to become a better version of themselves.",
      "author": " —  Michelle StinsonRoss, Managing Director of Marketing Operations, Apogee Results"
    }, {
      "quote": "Build something 100 people love, not something 1 million people kind of like.",
      "author": " — Brian Chesky, Co-Founder & CEO, Airbnb"
    }, {
      "quote": "When it comes to content, the best marketers know that self-promotion is good!",
      "author": " — Kieran Flanagan, VP Marketing, HubSpot"
    }, {
      "quote": "What separates good content from great content is a willingness to take risks and push the envelope.",
      "author": " — Brian Halligan, CEO & Co-founder, HubSpot"
    }, {
      "quote": "IQuality content means content that is packed with clear utility and is brimming with inspiration, and it has relentless empathy for the audience.",
      "author": " — Ann Handley, CCO, MarketingProfs"
    }, {
      "quote": "Marketing is telling the world you’re a rock star. Content Marketing is showing the world you are one.",
      "author": " — Robert Rose, Chief Strategy Officer, The Content Advisory"
    }, {
      "quote": "Content marketing is really like a first date. If all you do is talk about yourself, there won’t be a second date.",
      "author": " — David Beebe, Founder & CEO, Storified Hospitality Group"
    }, {
      "quote": "Focus on the core problem your business solves and put out lots of content and enthusiasm and ideas about how to solve that problem.",
      "author": " — Laura Fitton, INBOUND & Influencer Relations, HubSpot"
    }, {
      "quote": "IContent builds relationships. Relationships are built on trust. Trust drives revenue.",
      "author": " — Andrew Davis, Author & Keynote Speaker, Monumental Shift"
    }, {
      "quote": "Content marketing is the gap between what brands produce and what consumers actually want.",
      "author": " — Michael Brenner, CEO, Marketing Insider Group"
    }, {
      "quote": "One of the best ways to sabotage your content is to not tie it to your goals. Know why you’re creating content.",
      "author": " — Ellen Gomes Sr. Content Marketing Manager, Glint Inc."
    }, {
      "quote": "There are three objectives for content marketing: reach, engagement, conversion. Define key metrics for each.",
      "author": " — Michael Brenner, CEO, Marketing Insider Group"
    }, {
      "quote": "Instead of interrupting, work on attracting.",
      "author": " — Dharmesh Shah, CTO & Co-Founder, HubSpot"
    }, {
      "quote": "Just because you are the loudest, doesn't make you right.",
      "author": " — Brian Halligan, CEO & Co-Founder, HubSpot"
    }, {
      "quote": "ontent is king.",
      "author": " — Bill Gates, Co-Founder, Microsoft"
    }, {
      "quote": "Master the topic, the message, and the delivery.",
      "author": " — Steve Jobs, Co-Founder, Apple"
    }, {
      "quote": "Either write something worth reading or do something worth writing about.",
      "author": " — Benjamin Franklin, a Founding Father of the United States"
    }, {
      "quote": "It’s important to remember your competitor is only one mouse click away.",
      "author": " — Douglas Warner III, Former CEO, J.P. Morgan Chase & Co"
    }, {
      "quote": "Do what you do so well that they will want to see it again and bring their friends.",
      "author": " — Walt Disney, Co-Founder of The Walt Disney Company"
    }, {
      "quote": "Brand is just a perception, and perception will match reality over time.",
      "author": " — Elon Musk, Co-Founder & CEO, SpaceX"
    }, {
      "quote": "I’ve learned that people will forget what you said, people will forget what you did, but people will never forget how you made them feel.",
      "author": " — Maya Angelou, Civil Rights Activist & Poet"
    }, {
      "quote": "Marketing is really just about sharing your passion.",
      "author": " — Michael Hyatt, NY Times Best Selling Author"
    }, {
      "quote": "Don’t push people to where you want to be; meet them where they are.",
      "author": " — Meghan Keaney Anderson, VP Marketing, HubSpot"
    }, {
      "quote": "People will ignore or skip anything they don’t like. So brands have to start making things they love.",
      "author": " — Steve Pratt, Partner, Pacific Content"
    }, {
      "quote": "Smart marketers and smart brand managers understand the importance of leveraging frame of reference to build their brands.",
      "author": " — Mark Shapiro, Chair, Vistage Worldwide, Inc."
    }, {
      "quote": "Brand equity is the sum of all the hearts and minds of every single person that comes into contact with your company.",
      "author": " — Christopher Betzter, Brand Strategist"
    }, {
      "quote": "A brand is the set of expectations, memories, stories, and relationships that, taken together, account for a consumer’s decision to choose one product or service over another.",
      "author": " — Seth Godin, Founder & CEO, Do You Zoom"
    }, {
      "quote": "Products are made in the factory, but brands are created in the mind.",
      "author": " — Walter Landor, Founder, Landor"
    }, {
      "quote": "Branding is about signals — the signals people use to determine what you stand for as a brand. Signals create associations.",
      "author": " — Allen P. Adamson, Co-Founder, Metaforce"
    }, {
      "quote": "A lesson learned once again through ‘the school of hard knocks’ … never lose sight of your brand, its value, and its inherent need to be fed and nurtured and placed above all else! Saving your way there is a fool's errand.",
      "author": " — Chet Baker, SVP Corporate Development, Entrinsic Health Solutions"
    }, {
      "quote": "Your brand is what people say about you when you’re not in the room.",
      "author": " — Jeff Bezos, Founder & CEO, Amazon"
    }, {
      "quote": "Your brand is a story unfolding across all customer touch points.",
      "author": " — Jonah Sachs, Author"
    }, {
      "quote": "Recruiting great marketers should be your number one priority.",
      "author": " — Kipp Bodnar, CMO, HubSpot"
    }, {
      "quote": "Do the right thing as marketers to build trust.",
      "author": " — Jon Dick, VP Marketing, HubSpot"
    }, {
      "quote": "ake a risk and keep testing, because what works today won’t work tomorrow, but what worked yesterday may work again.",
      "author": " — Amrita Sahasrabudhe, VP Marketing, FastMed Urgent Care"
    }, {
      "quote": "Good marketing makes the company look smart. Great marketing makes the customer feel smart.",
      "author": " — Joe Chernov, VP Marketing, Pendo.io"
    }, {
      "quote": "Your talent determines what you can do. Your motivation determines how much you are willing to do. Your attitude determines how well you do it.",
      "author": " — Lou Holtz, Former Football Coach, Notre Dame"
    }, {
      "quote": "The creative process is fueled by divergent thinking — a breaking away from familiar or established ways of seeing and doing.",
      "author": " — The Innovator’s Toolkit, Harvard Business Essentials"
    }, {
      "quote": "f you take a risk and it doesn't go as planned, welcome to the club.",
      "author": " — Fran Hauser, Startup Investor, Advisor, & Author"
    }, {
      "quote": "We need to accept that we won’t always make the right decisions, that we’ll screw up royally sometimes — understanding that failure is not the opposite of success, it’s part of success.",
      "author": " — Arianna Huffington, Founder & CEO, Thrive Global"
    }, {
      "quote": "IWe need to stop interrupting what people are interested in and be what people are interested in.",
      "author": " — Craig Davis, Co-Founder, Sendle"
    }, {
      "quote": "Speak to your audience in their language about what’s in their heart.",
      "author": " — Jonathan Lister, VP Global Sales Solutions, LinkedIn"
    }, {
      "quote": "Nothing sticks in your head better than a story. Stories can express the most complicated ideas in the most digestible ways.",
      "author": " — Sam Balter, Sr. Marketing Manager of Podcasts, HubSpot"
    }, {
      "quote": "If your stories are all about your products and services, that’s not storytelling. It’s a brochure. Give yourself permission to make the story bigger.",
      "author": " — Jay Baer, Content Marketer & Co-Author"
    }, {
      "quote": "The most powerful person in the world is the storyteller. The storyteller sets the vision, values, and agenda of an entire generation that is to come.",
      "author": " — Steve Jobs, Co-Founder, Apple"
    }, {
      "quote": "You can’t sell anything if you can’t tell anything.",
      "author": " — Beth Comstock, Former CMO & Vice Chair, GE"
    }, {
      "quote": "The purpose of a storyteller is not to tell you how to think, but to give you questions to think upon!",
      "author": " — Brandon Sanderson, Author"
    }, {
      "quote": "Sometimes reality is too complex. Stories give it form.",
      "author": " — Jean Luc Godard, Director, Writer, & Editor"
    }, {
      "quote": "At its very core, marketing is storytelling. The best advertising campaigns take us on an emotional journey — appealing to our wants, needs, and desires — while at the same time telling us about a product or service.",
      "author": " — Melinda Partin, Senior Director of Marketing & Digital Strategy, UW Medicine"
    }, {
      "quote": "Storytelling is the most powerful way to put ideas into the world today.",
      "author": " — Robert McKee, Author"
    }, {
      "quote": "And do you know what is the most-often missing ingredient in a sales message? It’s the sales message that doesn’t tell an interesting story. Storytelling … good storytelling … is a vital component of a marketing campaign.",
      "author": " — Gary Halbert, Author"
    }, {
      "quote": "The brands that win are the brands that tell a great story. When it comes to transmedia storytelling, the brands that win are the brands that tell many great stories and are able to connect them all together.",
      "author": " — Mitch Joel, Author & Founder, Six Pixels Group"
    }, {
      "quote": "Social media marketing is about creating content that brings your audience together as a community and inspiring authentic conversations while increasing your brand's awareness.",
      "author": " — Krystal Wu, Social Media Community Manager, HubSpot"
    }, {
      "quote": "It's important to be where your audience of potential customers is today, and where they might be tomorrow.",
      "author": " — Andrew Delaney, Senior Manager of Social Media, HubSpot"
    }, {
      "quote": "Social media requires that business leaders start thinking like small-town shop owners. This means taking the long view and avoiding short-term benchmarks to gauge progress. It means allowing the personality, heart, and soul of the people who run all levels of the business to show.",
      "author": " — Gary Vaynerchuk, CEO, VaynerMedia"
    }, {
      "quote": "Social media was designed to SHARE what you’re doing and who you are, not BE what you’re doing and be who you are.",
      "author": " — Richie Norton, Author"
    }, {
      "quote": "I use social media as an idea generator, trend mapper, and strategic compass for all of our online business ventures.",
      "author": " — Paul Barron, CEO, Foodable Network"
    }, {
      "quote": "Going viral is not an outcome; it’s a happening. Sometimes it happens; sometimes it doesn’t. Just remember, fans are vanity and sales are sanity.",
      "author": " — Lori R. Taylor, Founder, Rev Media Marketing"
    }, {
      "quote": "Social media is about the people! Not about your business. Provide for the people and the people will provide you.",
      "author": " — Matt Goulart, Founder, Ignite Digital"
    }, {
      "quote": "Social marketing eliminates the middlemen, providing brands the unique opportunity to have a direct relationship with their customers.",
      "author": " — Bryan Weiner, Board of Directors, Cars.com"
    }, {
      "quote": "Our head of social media is the customer.",
      "author": " — McDonald’s"
    }, {
      "quote": "Don't use social media to impress people; use it to impact people.",
      "author": " — Dave Willis, Writer & Pastor"
    }, {
      "quote": "Businesses get blinded by the allure of a large subscription list, but unengaged subscribers aren’t just not interested in what you’re sending, they’re actually harming your deliverability.",
      "author": " — Meghan Keaney Anderson, VP Marketing, HubSpot"
    }, {
      "quote": "IMarketers need to build digital relationships and reputation before closing a sale.",
      "author": " — Chris Brogan, President, Chris Brogan Media"
    }, {
      "quote": "Less is more. Keeping it simple takes time and effort.",
      "author": " — Jeff Bullas, CEO, Jeffbullas.com Pty Ltd."
    }, {
      "quote": "Instead of one-way interruption, web marketing is about delivering useful content at just the right moment that a buyer needs it.",
      "author": " — David Meerman Scott, Keynote Speaker & Author"
    }, {
      "quote": "Content, in all its forms, is the single most critical element of any marketing campaign.",
      "author": " — Rebecca Lieb, Founding Partner & Analyst, Kaleido Insights"
    }, {
      "quote": "Inspiration is the most important part of our digital strategy.",
      "author": " — Paull Young, Charitable GIving Lead, Facebook"
    }, {
      "quote": "Digital marketing is not an art of selling a product. It is an art of making people buy the product that you sell.",
      "author": " — Hecate Strategy"
    }, {
      "quote": "Don’t build links. Build relationships.",
      "author": " — Rand Fishkin, Founder, SparkToro"
    }, {
      "quote": "Discoverability equals sales in the digital world.",
      "author": " — Dev Chandan, Founder, Dev Chandan"
    }, {
      "quote": "Good content isn’t about good storytelling. It’s about telling a true story well.",
      "author": " — Ann Handley"
    }, {
      "quote": "Content is fire, social media is gasoline.",
      "author": " — Jay Baer"
    }, {
      "quote": "Content marketing is more than a buzzword. It is the hottest trend in marketing because it is the biggest gap between what buyers want and brands produce.",
      "author": " — Michael Brenner"
    }, {
      "quote": "Marketing is telling the world you’re a rock star. Content Marketing is showing the world you are one.",
      "author": " — Robert Rose"
    }, {
      "quote": "You can never go wrong by investing in communities and the human beings within them.",
      "author": " — Pam Moore"
    }, {
      "quote": "Don’t settle: Don’t finish crappy books. If you don’t like the menu, leave the restaurant. If you’re not on the right path, get off it.",
      "author": " — Chris Brogan"
    }, {
      "quote": "Content is the reason search began in the first place.",
      "author": " — Lee Odden"
    }, {
      "quote": "The best marketing doesn’t feel like marketing.",
      "author": " — Tom Fishburne"
    }, {
      "quote": "Content: there is no easy button.",
      "author": " — Scott Abel"
    }, {
      "quote": "Less is more. Keeping it simple takes time and effort.",
      "author": " — Jeff Bullas"
    }, {
      "quote": "Content is anything that adds value to the reader's life.",
      "author": " — Avinash Kaushik"
    }, {
      "quote": "Your top of the funnel content must be intellectually divorced from your product but emotionally wed to it.",
      "author": " — Joe Chernov"
    }, {
      "quote": "Our jobs as marketers are to understand how the customer wants to buy and help them to do so.",
      "author": " — Bryan Eisenberg"
    }, {
      "quote": "The future of content marketing is in your hands.",
      "author": " — David Hahn"
    }, {
      "quote": "Content builds relationships. Relationships are built on trust. Trust drives revenue.",
      "author": " — Andrew Davis"
    }, {
      "quote": "Leverage the strength that you have: that no one else can be you.",
      "author": " — Todd Wheatland"
    }, {
      "quote": "Personally, I am very fond of strawberries and cream, but I have found that for some strange reason, fish prefer worms.",
      "author": " — Dale Carnegie"
    }, {
      "quote": "Not viewing your email marketing as content is a mistake.",
      "author": " — Chris Baggott"
    }, {
      "quote": "The cost of being wrong is less than the cost of doing nothing.",
      "author": " — Seth Godin"
    }, {
      "quote": "Don’t be afraid to get creative and experiment with your marketing.",
      "author": " — Mike Volpe"
    }, {
      "quote": "Failure is an option.",
      "author": " — Matthew Schwartz"
    }, {
      "quote": "Marketing is really just about sharing your passion.",
      "author": " — Michael Hyatt"
    }];
    $scope.quote = $scope.quotes[Math.floor(Math.random() * 100 + 1)];
    $interval(function () {
      $scope.quote = $scope.quotes[Math.floor(Math.random() * 100 + 1)];
    }, 9000);
  }
})();


(function () {
  'use strict';

  angular.module('app').component('internalDb', {
    controller: InDBController,
    controllerAs: 'vm',
    templateUrl: 'app/components/sales/inDB/inDB.component.html'
  });

  function InDBController($scope, dataService, $http, $timeout, $location, $mdToast, $q, $mdDialog, moment, $state) {
    var vm = this;
    vm.tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    var allConsTable;
    var heightCanBe = window.innerHeight - 150 + 'px';
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 150 + 'px';
      allConsTable.setHeight(heightCanBe);
      allConsTable.redraw();
    });
    $scope.groupByObj = [{
      name: 'None',
      value: ''
    }, {
      name: 'Source',
      value: 'Source'
    }, {
      name: 'Skill',
      value: 'Skillset'
    }, {
      name: 'Work Auth',
      value: 'VisaType'
    }, {
      name: 'Recruiter',
      value: 'RecruiterName'
    }, {
      name: 'Experience',
      value: 'YearsOfExp'
    }, {
      name: 'Location',
      value: 'PrefLocation'
    }];
    $scope.filterByObj = [{
      name: 'None',
      value: ''
    }, {
      name: 'Dice',
      value: 'Dice'
    }, {
      name: 'TexpertsHRM',
      value: 'TexpertsHRM'
    }];
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };

    function loadData($q) {
      var promiseClients = dataService.GetClientsInfoMrkter();
      var promiseVendors = dataService.GetVendorInfoMrkter();
      var promiseTitles = dataService.GetTitleDDMrkter();
      var promiseMarketers = dataService.GetMarketerInfoMrkter();
      var promiseGetConsls = dataService.GetConsls();

      return $q.all([promiseClients, promiseVendors, promiseTitles, promiseMarketers, promiseGetConsls, dataService.Interviewlookup()]);
    }
    dataService.newToken().then(function (response) {
      loadData($q).then(function (resp) {
        $scope.Clients = resp[0].data;
        $scope.Vendors = resp[1].data;
        $scope.MidVendors = resp[1].data;
        $scope.titles = resp[2].data;
        $scope.marketers = resp[3].data;
        $scope.allConsultants = _.sortBy(resp[4].data, ['FirstName']);
        vm.cons = $scope.allConsultants;
        vm.InterviewModes = resp[5].data.LstImode;
        $scope.InterviewModes = vm.InterviewModes;
        vm.InterviewLevels = resp[5].data.LstILevel;
        $scope.InterviewLevels = vm.InterviewLevels;
        vm.Statuses = resp[5].data.LstInvStatus;
        $scope.Statuses = vm.Statuses;
        $scope.getConsultants();
      }).catch(CatchError);
    }).catch(CatchError);

    function testJSON(text) {
      if (typeof text !== 'string') {
        return false;
      }
      try {
        angular.fromJson(text);
        return true;
      } catch (error) {
        return false;
      }
    }

    function profileDownload(data) {
      var req = {
        conslid: data.ConslId,
        FileUrl: data.ResumeURL
      };
      var ext = data.ResumeURL.substring(data.ResumeURL.lastIndexOf('.') + 1);
      dataService.newToken().then(function (response) {
        dataService.diceProfileDownload(req).then(function (response) {
          var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
            return data + String.fromCharCode(byte);
          }, ''));
          var anchor = $('<a/>');
          anchor.attr({
            href: 'data:application/pdf; base64,' + base64,
            target: '_blank',
            download: data.ResumeURL
          })[0].click();
        });
      }).catch(CatchError);
    }
    // data.FirstName +
    // "-" +
    // data.LastName +
    // "_" +
    // data.YearsOfExp +
    // "_" +
    // data.Skillset +
    // "." +
    // ext
    $scope.preloader = true;
    $scope.getConsultants = function () {
      dataService.newToken().then(function (response) {
        dataService.GetConsls().then(function (response) {
          $scope.allConsultants = '';
          $scope.allConsultants = _.orderBy(response.data, ['ConslId'], ['desc']);
          for (var i = 0; i < $scope.allConsultants.length; i++) {
            var element = $scope.allConsultants[i];
            if (element.FirstName !== '') {
              element.FullName = element.FirstName + ' ' + element.LastName;
            }

            if (element.Exp !== null) {
              element.YearsOfExp = element.Exp;
            } else if (element.YearsOfExp !== null) {
              element.YearsOfExp = element.YearsOfExp;
            } else {
              element.YearsOfExp = '(n/a)';
            }
            if (element.DateLastActive !== undefined) {
              element.DateLastActive = moment(element.DateLastActive).format('MM/DD/YYYY');
            } else {
              element.dateLastActive = '(n/a)';
            }
            if (element.Source == 'Dice') {
              var email = '',
                  pno = '',
                  visaT = '',
                  title = '';
              if (testJSON(element.Skillset)) {
                title = angular.fromJson(element.Skillset)[0];
              } else {
                title = '(n/a)';
              }
              element.Skillset = '';
              element.Skillset = title;
              if (testJSON(element.Email)) {
                email = angular.fromJson(element.Email)[0];
              } else {
                email = '(n/a)';
              }
              element.Email = '';
              element.Email = email;
              if (testJSON(element.PhoneNumber)) {
                pno = angular.fromJson(element.PhoneNumber)[0];
              } else {
                pno = '(n/a)';
              }
              element.PhoneNumber = '';
              element.PhoneNumber = pno;
              if (testJSON(element.WorkPermit)) {
                visaT = angular.fromJson(element.WorkPermit)[0];
              } else {
                visaT = '(n/a)';
              }
              element.VisaType = '';
              element.VisaType = visaT;
              if (element.PrefLocation !== null && element.PrefLocation !== '') {
                if (testJSON(element.PrefLocation)) {
                  var prefLoc = angular.fromJson(element.PrefLocation);
                  var pLocS = '';
                  for (var index = 0; index < prefLoc.length; index++) {
                    var loc = prefLoc[index];
                    if (prefLoc.length - 1 !== index) {
                      pLocS += loc.city + ',';
                    } else {
                      pLocS += loc.city;
                      element.PrefLocation = '';
                      element.PrefLocation = pLocS;
                    }
                  }
                }
              } else {
                element.PrefLocation = 'N/a';
              }
            }
            if (element.Recuriterid !== null || element.Recuriterid !== undefined) {
              for (var w = 0; w < $scope.marketers.length; w++) {
                var marketer = $scope.marketers[w];
                if (marketer.loginid === element.Recuriterid) {
                  element.RecruiterName = marketer.MarkterName;
                  break;
                } else if (w === $scope.marketers.length - 1) {
                  element.RecruiterName = 'Not Assigned';
                  break;
                }
              }
            }
          }
          var printIcon = function printIcon(cell, formatterParams, onRendered) {
            //plain text value
            return "<i class='fa fa-download pointer'></i>";
          };
          $scope.preloader = false;

          allConsTable = new Tabulator('#allCons-table', {
            height: heightCanBe,
            layout: 'fitData',
            pagination: 'local',
            paginationSize: 20,
            paginationSizeSelector: [20, 30, 40, 50],
            groupBy: '',
            groupStartOpen: false,
            groupToggleElement: 'header',
            selectable: false,
            clipboard: true,
            clipboardCopyStyled: false,
            persistence: {
              sort: true,
              filter: true,
              columns: true
            },
            tooltips: true,
            tooltipsHeader: true,
            persistenceID: "allCons-tablepersistenceID",
            columns: [{
              formatter: 'rownum',
              align: 'center',
              width: 40,
              sorter: false
            }, {
              title: 'Name',
              field: 'FullName',
              width: 200
            }, {
              title: 'Email',
              field: 'Email',
              width: 200,
              formatter: 'link',
              formatterParams: {
                urlPrefix: 'mailto://',
                target: '_blank'
              }
            }, {
              title: 'PhoneNumber',
              field: 'PhoneNumber',
              width: 100
            }, {
              title: 'Source',
              field: 'Source',
              width: 100
            }, {
              title: 'Job Title',
              field: 'Skillset',
              width: 160,
              formatter: function formatter(cell, formatterParams) {
                var value = cell.getValue();
                if (value === '' || value === null) {
                  return '(n/a)';
                } else {
                  return value;
                }
              }
            }, {
              title: 'Experience',
              field: 'YearsOfExp',
              width: 120
            }, {
              title: 'Work Auth',
              field: 'VisaType',
              width: 120
            }, {
              title: 'PreferLocation',
              field: 'PrefLocation',
              width: 120
            }, {
              title: 'Recruiter',
              field: 'RecruiterName',
              width: 120
            }, {
              title: 'Last Activity',
              field: 'DateLastActive',
              width: 120
            }, {
              title: 'Resume',
              formatter: printIcon,
              width: 110,
              align: 'center',
              cellClick: function cellClick(e, cell) {
                var data = cell.getRow();

                profileDownload(data._row.data);
              }
            }]
          });
          allConsTable.setData($scope.allConsultants);
        }).catch(CatchError);
      }).catch(CatchError);

      $scope.allConsDownload = function () {
        allConsTable.download('xlsx', 'data.xlsx', {
          sheetName: 'MyData'
        });
      };
      $scope.allConsGroupBy = function (value) {
        allConsTable.setGroupBy(value);
        allConsTable.tabulator('redraw', true);
      };

      function matchAny(data, filterParams) {
        var match = false;
        for (var key in data) {
          // if (data[key] == filterParams.value) {
          //   match = true;
          // }
          var keyData = data[key],
              paramValue;
          if (keyData !== null && keyData !== undefined) {
            if (angular.toJson(keyData).search(filterParams.value) != -1) {
              match = true;
            }
          }
        }
        return match;
      }
      $scope.allConsSearch = function (data) {
        allConsTable.setFilter(matchAny, {
          value: data
        });
      };
      $scope.activity = function (jbId, SkId, ConId) {
        $mdDialog.show({
          controller: viewActivityController,
          templateUrl: 'components/layout/jobpostings/viewActivity.html',
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          locals: {
            ConId: ConId,
            marketers: $scope.marketers,
            vendors: $scope.Vendors,
            clients: $scope.Clients
          }
        });
      };

      function viewActivityController(ConId, marketers, vendors, clients, $scope, $sce) {
        $scope.ConActivity = [];
        var req = {
          ConslId: ConId
        };
        dataService.newToken().then(function (response) {
          dataService.GetInvActivityByConslid(req).then(function (response) {
            for (var index = 0; index < response.data.length; index++) {
              var InnerList = response.data[index].listofEventDetails;
              for (var ingo = 0; ingo < InnerList.length; ingo++) {
                var element = InnerList[ingo];
                if (element.EventStatus === 0) {
                  element.EventStatus = 3;
                }
                var client = _.filter(clients, function (v) {
                  return _.includes([element.ClientId], v.ClientId);
                });
                var vendor = _.filter(vendors, function (v) {
                  return _.includes([element.VendorId], v.VendorId);
                });
                var consultant = _.filter(vm.cons, function (v) {
                  return _.includes([element.ConslId], v.ConslId);
                });
                var Imode = _.filter(vm.InterviewModes, function (v) {
                  return _.includes([element.IntMode.IKey], v.IKey);
                });
                var Ilvel = _.filter(vm.InterviewLevels, function (v) {
                  return _.includes([element.IntLevel.IKey], v.IKey);
                });
                var status = _.filter(vm.Statuses, function (v) {
                  return _.includes([element.EventStatus], v.IKey);
                });
                var marketer = _.filter(marketers, function (v) {
                  return _.includes([element.MarketerId], v.loginid);
                });
                var obj = {
                  id: element.EventId,
                  title: consultant[0].FirstName + ' ' + consultant[0].LastName,
                  start: element.StartDate,
                  marketer: marketer[0].MarkterName,
                  MarkterId: element.MarketerId,
                  url: element.MeetingUrl,
                  modeOfInterview: Imode[0].IValue,
                  levelOfInterview: Ilvel[0].IValue,
                  IntMode: element.IntMode.IKey,
                  IntLevel: element.IntLevel.IKey,
                  comments: element.EventComments,
                  end: element.EndDate,
                  allDay: false,
                  status: status[0].IValue,
                  Client: client[0].ClientName,
                  VendorId: vendor[0].VendorName,
                  CreateDate: element.CreateDate,
                  InterviewId: element.InterviewId,
                  ConslId: element.ConslId,
                  FinalStatus: element.FinalStatus,
                  cid: element.ClientId,
                  vid: element.VendorId,
                  DocUrl: element.DocUrl
                };
                $scope.ConActivity.push(obj);
              }
            }
            $scope.ConActivity = _.chain($scope.ConActivity).groupBy('Client').map(function (value, key) {
              return {
                Client: key,
                title: value[0].title,
                Invs: _.chain(value).groupBy('InterviewId').map(function (value, key) {
                  return {
                    InterviewId: key,
                    InvDetails: value
                  };
                }).value()
              };
            }).value();

            $timeout(function () {
              var toggler = document.getElementsByClassName('caret');
              var i;

              for (i = 0; i < toggler.length; i++) {
                toggler[i].addEventListener('click', function () {
                  this.parentElement.querySelector('.nested').classList.toggle('active');
                  this.classList.toggle('caret-down');
                });
              }
            });
          });
        }).catch(CatchError);
        $scope.downloadResum = function (id, url) {
          var obj = {
            InterviewId: id,
            FileUrl: url
          };
          dataService.newToken().then(function (response) {
            dataService.DownloadResume(obj).then(function (response, status, headers) {
              var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
                return data + String.fromCharCode(byte);
              }, ''));
              var anchor = $('<a/>');
              anchor.attr({
                href: 'data:application/octet-stream; base64,' + base64,
                target: '_blank',
                download: url
              })[0].click();
            }).catch(CatchError);
          }).catch(CatchError);
        };
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
        $scope.moreConInfo = function (con) {
          $scope.SelectedCon = con;
        };
      }
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('profile', {
    controller: ProfileController,
    controllerAs: 'vm',
    templateUrl: 'app/components/consultant/profile/profile.html'
  });

  /** @ngInject */
  function ProfileController($scope, $rootScope, dataService, $q, $http, $mdDialog, $mdToast, moment, $state) {
    $scope.inactive = true;
    var tokenData;
    if (localStorage.getItem('tokenData') !== null) {
      tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    } else {
      localStorage.clear();
      $state.go('signin');
    }
    $scope.loginLoader = true;
    var loginmodel = {
      loginid: tokenData.loginid
    };
    $scope.maxDate = new Date();
    $scope.spinStart = false;
    $scope.documentsList = [];
    $scope.appliedValues = [{
      value: true,
      name: 'Yes'
    }, {
      value: false,
      name: 'No'
    }];

    $scope.workAuthTypes = {
      H1B: 'H1B',
      CPT: 'CPT',
      'OPT-STEM': 'OPT-STEM',
      OPT: 'OPT',
      GC: 'GC',
      USC: 'USC',
      'GC-EAD': 'GC-EAD',
      T1: 'T1'
    };

    function loadData($q) {
      return $q.all([dataService.GetCountriesData(), dataService.GetDocDDValues()]);
    }
    dataService.newToken().then(function (response) {
      loadData($q).then(function (response) {
        $scope.countries = response[0].data.sortBy('CountryName');
        var docs = [];
        angular.forEach(response[1].data, function (doc) {
          doc.docModel = 'model' + doc.DocID;
          docs.push(doc);
        });
        $scope.docTypes = docs;
        GetListOfDocuments();
        GetProfileDataFunc();
      });
    }).catch(CatchError);

    window.isMobile = /iphone|ipod|ipad|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(navigator.userAgent.toLowerCase());
    $scope.isMobile = window.isMobile;
    $scope.innerHeight = window.innerHeight;
    $scope.savingProfile = false;
    $scope.profileTabchangeLoader = false;
    Array.prototype.sortBy = function (p) {
      return this.slice(0).sort(function (a, b) {
        return a[p] > b[p] ? 1 : a[p] < b[p] ? -1 : 0;
      });
    };
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };

    function GetProfileDataFunc() {
      $scope.profileTabchangeLoader = true;
      dataService.GetProfileData(loginmodel).then(function (response) {
        if (response.data.visamodel.CurrentWorkAuth !== 'USC' && response.data.visamodel.CurrentWorkAuth !== 'GC') {
          $scope.workAuthType = 'Other';
        } else {
          $scope.workAuthType = response.data.visamodel.CurrentWorkAuth;
        }
        if (response.data.visamodel.GCApplied) {
          response.data.visamodel.GCApplied = 'true';
        } else {
          response.data.visamodel.GCApplied = 'false';
        }
        if (response.data.visamodel.IsUSCitizen) {
          response.data.visamodel.IsUSCitizen = 'true';
        } else {
          response.data.visamodel.IsUSCitizen = 'false';
        }
        if (response.data.DOB !== '') {
          response.data.DOB = new Date(response.data.DOB);
        } else {
          response.data.DOB = new Date('01/01/0001');
        }
        if (response.data.edumodel === null) {
          response.data.edumodel = {};

          response.data.edumodel.BachelorsGradDate = new Date();
          response.data.edumodel.MastersGradDate = new Date();
        } else {
          response.data.edumodel.BachelorsGradDate = new Date(response.data.edumodel.BachelorsGradDate);
          response.data.edumodel.MastersGradDate = new Date(response.data.edumodel.MastersGradDate);
        }

        if (response.data.identymodel === null) {
          response.data.identymodel = {};
          response.data.identymodel.StateIdIssueDate = new Date();
          response.data.identymodel.StateIdExpDate = new Date();
          response.data.identymodel.DLIssueDate = new Date();
          response.data.identymodel.DLExpDate = new Date();
          response.data.identymodel.PIssueDate = new Date();
          response.data.identymodel.PExpDate = new Date();
        } else {
          response.data.identymodel.StateIdIssueDate = new Date(response.data.identymodel.StateIdIssueDate);
          response.data.identymodel.StateIdExpDate = new Date(response.data.identymodel.StateIdExpDate);
          response.data.identymodel.DLIssueDate = new Date(response.data.identymodel.DLIssueDate);
          response.data.identymodel.DLExpDate = new Date(response.data.identymodel.DLExpDate);
          response.data.identymodel.PIssueDate = new Date(response.data.identymodel.PIssueDate);
          response.data.identymodel.PExpDate = new Date(response.data.identymodel.PExpDate);
        }
        for (var i = 0; i < response.data.workexpmodel.length; i++) {
          response.data.workexpmodel[i].StartDate = new Date(response.data.workexpmodel[i].StartDate);
          response.data.workexpmodel[i].EndDate = new Date(response.data.workexpmodel[i].EndDate);
        }
        response.data.visamodel.CurrentVisaStartDate = new Date(response.data.visamodel.CurrentVisaStartDate);
        response.data.visamodel.CurrentVisaStartDate = new Date(response.data.visamodel.CurrentVisaStartDate);
        response.data.visamodel.CurrentVisaEndDate = new Date(response.data.visamodel.CurrentVisaEndDate);
        response.data.visamodel.CurrentWorkAuthStartDate = new Date(response.data.visamodel.CurrentWorkAuthStartDate);
        response.data.visamodel.CurrentWorkAuthEndDate = new Date(response.data.visamodel.CurrentWorkAuthEndDate);
        response.data.visamodel.labourappliedDate = new Date(response.data.visamodel.labourappliedDate);
        response.data.visamodel.labourapproveDate = new Date(response.data.visamodel.labourapproveDate);
        response.data.visamodel.I40AppliedDate = new Date(response.data.visamodel.I40AppliedDate);
        response.data.visamodel.I40ApprovedDate = new Date(response.data.visamodel.I40ApprovedDate);

        $scope.user = response.data;

        // $scope.prevEmp = response.data.workexpmodel.filter(function (obj) {
        //     $scope.PrevStartDate = new Date(obj.StartDate);
        //     return obj.isCurrent === true;
        // })[0];

        $scope.user.loginid = parseInt(tokenData.loginid);

        $scope.loginLoader = false;
        $scope.MartialStatus = [{
          id: 1,
          name: 'Single'
        }, {
          id: 2,
          name: 'Married'
        }, {
          id: 3,
          name: 'Divorced'
        }];

        var userProfileData = $scope.user;

        $scope.showAdvanced = function (ev) {
          $mdDialog.show({
            controller: DialogController,
            scope: $scope.$new(),
            templateUrl: 'app/components/consultant/profile/add-experience-dialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
          }).then(function (newExp) {}, function () {
            $scope.status = 'You cancelled the dialog.';
          });
        };

        function DialogController($scope, $mdDialog) {
          $scope.hide = function () {
            $mdDialog.hide();
          };

          $scope.cancel = function () {
            $mdDialog.cancel();
          };
          $scope.answer = function (newExp) {
            if (newExp.isCurrent === true) {
              userProfileData.workexpmodel.filter(function (obj) {
                if (obj.isCurrent === true) {
                  obj.isCurrent = false;
                  obj.EndDate = newExp.PrevEndDate;
                }
              });
              delete newExp.PrevEndDate;
              var newExpObj = {
                ClientAddress: newExp.ClientAddress,
                ClientName: newExp.ClientName,
                CompanyId: newExp.CompanyId,
                EndDate: undefined,
                PayrollCompany: newExp.PayrollCompany,
                StartDate: newExp.StartDate,
                Title: newExp.Title,
                isCurrent: newExp.isCurrent
              };
              userProfileData.workexpmodel.push(newExpObj);
              $scope.user = userProfileData;
            } else {
              newExp.isCurrent = false;
              userProfileData.workexpmodel.push(newExp);
              $scope.user = userProfileData;
            }
            $mdDialog.hide();
          };
          $scope.noPrev = false;
          $scope.checkPrevEmp = function (checked) {
            if (checked === true) {
              $scope.noPrev = true;
            } else {
              $scope.noPrev = false;
            }
          };
        }
        $scope.savingProfile = false;
        $scope.profileTabchangeLoader = false;
      }).catch(CatchError);
      return true;
    }

    $scope.workAuthTypeChanged = function (workAuthType) {
      $scope.user.visamodel.CurrentWorkAuth = workAuthType;
    };
    $scope.editProfile = function () {
      $scope.inactive = false;
    };
    $scope.selectedIndex = 0;
    $scope.tabDeSelected = function (indx) {
      dataService.newToken().then(function (response) {
        new GetProfileDataFunc();
      }).catch(CatchError);
    };
    $scope.tabSelected = function () {
      if ($scope.inactive) {
        $scope.inactive = true;
      } else {
        $scope.inactive = true;
      }
    };
    $scope.cancelEdit = function () {
      $scope.inactive = true;
    };
    $scope.PopExp = function (pda) {
      $scope.user.workexpmodel.pop(pda);
    };
    function compareTsController($scope, $mdDialog, userData) {
      $scope.currentChecked = function selectOnlyThis(id) {
        angular.forEach(userData.workexpmodel, function (workexp, index) {
          if (id != index) workexp.isCurrent = false;
        });
      };

      // userData.workexpmodel.pop(ind);
      userData.workexpmodel[ind].DelInd = true;
      $scope.userData = userData;

      $scope.answer = function () {
        user = $scope.userData;
        $mdDialog.cancel();
      };
      $scope.hide = function () {
        $mdDialog.hide();
      };

      $scope.cancel = function () {
        $mdDialog.cancel();
      };
    }
    $scope.DeleteExp = function (user, ind) {
      if (user.workexpmodel[ind].isCurrent) {
        $mdDialog.show({
          controller: compareTsController,
          templateUrl: 'app/components/consultant/profile/ChangeCurrentEmployer.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: {
            userData: user
          },
          fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
        }).then(function (answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function () {
          $scope.status = 'You cancelled the dialog.';
        });
      } else {
        // user.workexpmodel.pop(ind);
        user.workexpmodel[ind].DelInd = true;
      }
    };
    var GetFilesBody = {
      loginid: tokenData.loginid
    };
    function GetListOfDocuments() {
      dataService.newToken().then(function (response) {
        dataService.GetListOfDocuments(loginmodel).then(function (response) {
          $scope.documentsList = [];
          angular.forEach(response.data, function (docFile) {
            var splitData = docFile.split('~#');
            var obj = {
              FileName: splitData[2],
              FileUrl: docFile,
              DocID: splitData[1]
            };
            $scope.documentsList.push(obj);
          });
        }).catch(CatchError);
      }).catch(CatchError);
    }
    $scope.downloadFile = function (FileDetails) {
      var reqObj = {
        FileUrl: FileDetails.FileUrl,
        loginid: tokenData.loginid
      };
      dataService.newToken().then(function (response) {
        dataService.GetFileToDownload(reqObj).then(function (response, status, headers) {
          var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
            return data + String.fromCharCode(byte);
          }, ''));
          var anchor = $('<a/>');
          anchor.attr({
            href: 'data:application/octet-stream; base64,' + base64,
            target: '_blank',
            download: FileDetails.FileName
          })[0].click();
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.uploadFile = function (fd) {
      var file;
      switch (fd.docModel) {
        case 'model1':
          file = $rootScope.model1;
          break;
        case 'model2':
          file = $rootScope.model2;
          break;
        case 'model3':
          file = $rootScope.model3;
          break;
        case 'model4':
          file = $rootScope.model4;
          break;
        case 'model5':
          file = $rootScope.model5;
          break;
      }

      if (file !== undefined) {
        // angular.forEach($scope.documentsList, function (docList) {
        //     if(parseInt(docList.DocID) === fd.DocID){
        //         docList.spinStart = true;
        //     }
        // });
        fd.spinStart = true;
        var formdata = new FormData();

        formdata.append('LoginId', tokenData.loginid);
        formdata.append('DocId', fd.DocID);
        formdata.append('file', file);

        // formdata.append('filename', file.name);
        // formdata.append('filesize', file.size);
        // formdata.append('filetype', file.type);

        $scope.stepsModel = [];
        dataService.newToken().then(function (response) {
          dataService.UploadFiles(formdata).then(function (response) {
            new GetListOfDocuments();
            fd.spinStart = false;
          }).catch(CatchError);
        }).catch(CatchError);
      }
    };
    $scope.saveProfile = function (updateBody) {
      $scope.savingProfile = true;
      // updateBody.loginmodel = {
      //     "loginid": tokenData.loginid
      // };
      updateBody.DOB = moment(updateBody.DOB).format('MM-DD-YYYY');
      angular.forEach(updateBody.workexpmodel, function (wexp) {
        wexp.StartDate = moment(wexp.StartDate).format('MM-DD-YYYY');
        if (wexp.EndDate !== undefined) {
          wexp.EndDate = moment(wexp.EndDate).format('MM-DD-YYYY');
        }
      });
      updateBody.edumodel.BachelorsGradDate = moment(updateBody.edumodel.BachelorsGradDate).format('MM-DD-YYYY');
      updateBody.edumodel.MastersGradDate = moment(updateBody.edumodel.MastersGradDate).format('MM-DD-YYYY');
      updateBody.identymodel.StateIdIssueDate = moment(updateBody.identymodel.StateIdIssueDate).format('MM-DD-YYYY');
      updateBody.identymodel.StateIdExpDate = moment(updateBody.identymodel.StateIdExpDate).format('MM-DD-YYYY');
      updateBody.identymodel.DLIssueDate = moment(updateBody.identymodel.DLIssueDate).format('MM-DD-YYYY');
      updateBody.identymodel.DLExpDate = moment(updateBody.identymodel.DLExpDate).format('MM-DD-YYYY');
      updateBody.identymodel.PIssueDate = moment(updateBody.identymodel.PIssueDate).format('MM-DD-YYYY');
      updateBody.identymodel.PExpDate = moment(updateBody.identymodel.PExpDate).format('MM-DD-YYYY');

      updateBody.visamodel.CurrentVisaStartDate = moment(updateBody.visamodel.CurrentVisaStartDate).format('MM-DD-YYYY');
      updateBody.visamodel.CurrentVisaEndDate = moment(updateBody.visamodel.CurrentVisaEndDate).format('MM-DD-YYYY');
      updateBody.visamodel.CurrentWorkAuthStartDate = moment(updateBody.visamodel.CurrentWorkAuthStartDate).format('MM-DD-YYYY');
      updateBody.visamodel.CurrentWorkAuthEndDate = moment(updateBody.visamodel.CurrentWorkAuthEndDate).format('MM-DD-YYYY');
      updateBody.visamodel.labourappliedDate = moment(updateBody.visamodel.labourappliedDate).format('MM-DD-YYYY');
      updateBody.visamodel.labourapproveDate = moment(updateBody.visamodel.labourapproveDate).format('MM-DD-YYYY');
      updateBody.visamodel.I40AppliedDate = moment(updateBody.visamodel.I40AppliedDate).format('MM-DD-YYYY');
      updateBody.visamodel.I40ApprovedDate = moment(updateBody.visamodel.I40ApprovedDate).format('MM-DD-YYYY');

      if (updateBody.visamodel.GCApplied == 'true') {
        updateBody.visamodel.GCApplied = true;
      } else {
        updateBody.visamodel.GCApplied = false;
      }
      if (updateBody.visamodel.IsUSCitizen == 'true') {
        updateBody.visamodel.IsUSCitizen = true;
      } else {
        updateBody.visamodel.IsUSCitizen = false;
      }

      dataService.newToken().then(function (response) {
        dataService.UpdateProfile(updateBody).then(function (response) {
          new GetProfileDataFunc();
          $scope.loginLoader = false;
          // $scope.savingProfile = false;
        }).catch(CatchError);
      }).catch(CatchError);
      $scope.inactive = true;
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('documents', {
    controller: DocumentsController,
    controllerAs: 'vm',
    templateUrl: 'app/components/consultant/documents/documents.html'
  });

  function DocumentsController($scope, $rootScope, dataService, $q, $http, $mdDialog, moment, $state) {
    window.isMobile = /iphone|ipod|ipad|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(navigator.userAgent.toLowerCase());
    $scope.isMobile = window.isMobile;
    $scope.inactive = true;
    var tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.loginLoader = true;
    var loginmodel = {
      loginid: tokenData.loginid
    };
    $scope.maxDate = new Date();
    $scope.spinStart = false;
    $scope.documentsList = [];
    $scope.appliedValues = [{
      value: true,
      name: 'Yes'
    }, {
      value: false,
      name: 'No'
    }];

    function loadData($q) {
      return $q.all([dataService.GetCountriesData(), dataService.GetDocDDValues()]);
    }
    dataService.newToken().then(function () {
      loadData($q).then(function (response) {
        $scope.countries = response[0].data.sortBy('CountryName');
        var docs = [];
        angular.forEach(response[1].data, function (doc) {
          doc.docModel = 'model' + doc.DocID;
          docs.push(doc);
        });
        $scope.docTypes = docs;
        GetProfileDataFunc();
        GetListOfDocuments();
      });
    }).catch(CatchError);

    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    Array.prototype.sortBy = function (p) {
      return this.slice(0).sort(function (a, b) {
        return a[p] > b[p] ? 1 : a[p] < b[p] ? -1 : 0;
      });
    };

    function GetProfileDataFunc() {
      dataService.GetProfileData(loginmodel).then(function (response) {
        if (response.data.visamodel.CurrentWorkAuth !== 'USC' && response.data.visamodel.CurrentWorkAuth !== 'GC') {
          $scope.workAuthType = 'Other';
        } else {
          $scope.workAuthType = response.data.visamodel.CurrentWorkAuth;
        }
        if (response.data.visamodel.GCApplied) {
          response.data.visamodel.GCApplied = 'true';
        } else {
          response.data.visamodel.GCApplied = 'false';
        }
        if (response.data.visamodel.IsUSCitizen) {
          response.data.visamodel.IsUSCitizen = 'true';
        } else {
          response.data.visamodel.IsUSCitizen = 'false';
        }
        if (response.data.DOB !== '') {
          response.data.DOB = new Date(response.data.DOB);
        } else {
          response.data.DOB = new Date('01/01/0001');
        }
        if (response.data.edumodel === null) {
          response.data.edumodel = {};

          response.data.edumodel.BachelorsGradDate = new Date();
          response.data.edumodel.MastersGradDate = new Date();
        } else {
          response.data.edumodel.BachelorsGradDate = new Date(response.data.edumodel.BachelorsGradDate);
          response.data.edumodel.MastersGradDate = new Date(response.data.edumodel.MastersGradDate);
        }

        if (response.data.identymodel === null) {
          response.data.identymodel = {};
          response.data.identymodel.StateIdIssueDate = new Date();
          response.data.identymodel.StateIdExpDate = new Date();
          response.data.identymodel.DLIssueDate = new Date();
          response.data.identymodel.DLExpDate = new Date();
          response.data.identymodel.PIssueDate = new Date();
          response.data.identymodel.PExpDate = new Date();
        } else {
          response.data.identymodel.StateIdIssueDate = new Date(response.data.identymodel.StateIdIssueDate);
          response.data.identymodel.StateIdExpDate = new Date(response.data.identymodel.StateIdExpDate);
          response.data.identymodel.DLIssueDate = new Date(response.data.identymodel.DLIssueDate);
          response.data.identymodel.DLExpDate = new Date(response.data.identymodel.DLExpDate);
          response.data.identymodel.PIssueDate = new Date(response.data.identymodel.PIssueDate);
          response.data.identymodel.PExpDate = new Date(response.data.identymodel.PExpDate);
        }
        for (var i = 0; i < response.data.workexpmodel.length; i++) {
          response.data.workexpmodel[i].StartDate = new Date(response.data.workexpmodel[i].StartDate);
          response.data.workexpmodel[i].EndDate = new Date(response.data.workexpmodel[i].EndDate);
        }
        response.data.visamodel.CurrentVisaStartDate = new Date(response.data.visamodel.CurrentVisaStartDate);
        response.data.visamodel.CurrentVisaEndDate = new Date(response.data.visamodel.CurrentVisaEndDate);
        response.data.visamodel.CurrentWorkAuthStartDate = new Date(response.data.visamodel.CurrentWorkAuthStartDate);
        response.data.visamodel.CurrentWorkAuthEndDate = new Date(response.data.visamodel.CurrentWorkAuthEndDate);
        response.data.visamodel.labourappliedDate = new Date(response.data.visamodel.labourappliedDate);
        response.data.visamodel.labourapproveDate = new Date(response.data.visamodel.labourapproveDate);
        response.data.visamodel.I40AppliedDate = new Date(response.data.visamodel.I40AppliedDate);
        response.data.visamodel.I40ApprovedDate = new Date(response.data.visamodel.I40ApprovedDate);

        $scope.user = response.data;

        // $scope.prevEmp = response.data.workexpmodel.filter(function (obj) {
        //     $scope.PrevStartDate = new Date(obj.StartDate);
        //     return obj.isCurrent === true;
        // })[0];

        $scope.user.loginid = parseInt(tokenData.loginid);

        $scope.loginLoader = false;
        $scope.MartialStatus = [{
          id: 1,
          name: 'Single'
        }, {
          id: 2,
          name: 'Married'
        }, {
          id: 3,
          name: 'Divorced'
        }];

        var userProfileData = $scope.user;

        $scope.showAdvanced = function (ev) {
          $mdDialog.show({
            controller: DialogController,
            scope: $scope.$new(),
            templateUrl: 'components/profile/add-experience-dialog.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
          }).then(function (newExp) {}, function () {
            $scope.status = 'You cancelled the dialog.';
          });
        };

        function DialogController($scope, $mdDialog) {
          $scope.hide = function () {
            $mdDialog.hide();
          };

          $scope.cancel = function () {
            $mdDialog.cancel();
          };
          $scope.answer = function (newExp) {
            if (newExp.isCurrent === true) {
              userProfileData.workexpmodel.filter(function (obj) {
                if (obj.isCurrent === true) {
                  obj.isCurrent = false;
                  obj.EndDate = newExp.PrevEndDate;
                }
              });
              delete newExp.PrevEndDate;
              var newExpObj = {
                ClientAddress: newExp.ClientAddress,
                ClientName: newExp.ClientName,
                CompanyId: newExp.CompanyId,
                EndDate: undefined,
                PayrollCompany: newExp.PayrollCompany,
                StartDate: newExp.StartDate,
                Title: newExp.Title,
                isCurrent: newExp.isCurrent
              };
              userProfileData.workexpmodel.push(newExpObj);
              $scope.user = userProfileData;
            } else {
              newExp.isCurrent = false;
              userProfileData.workexpmodel.push(newExp);
              $scope.user = userProfileData;
            }
            $mdDialog.hide();
          };
          $scope.noPrev = false;
          $scope.checkPrevEmp = function (checked) {
            if (checked === true) {
              $scope.noPrev = true;
            } else {
              $scope.noPrev = false;
            }
          };
        }
        $scope.savingProfile = false;
      }).catch(CatchError);
    }

    $scope.workAuthTypeChanged = function (workAuthType) {
      $scope.user.visamodel.CurrentWorkAuth = workAuthType;
    };
    $scope.editProfile = function () {
      $scope.inactive = false;
    };
    $scope.cancelEdit = function () {
      $scope.inactive = true;
    };

    $scope.PopExp = function (pda) {
      $scope.user.workexpmodel.pop(pda);
    };
    $scope.DeleteExp = function (user, ind) {
      if (user.workexpmodel[ind].isCurrent) {
        var compareTsController = function compareTsController($scope, $mdDialog, userData) {
          $scope.currentChecked = function selectOnlyThis(id) {
            angular.forEach(userData.workexpmodel, function (workexp, index) {
              if (id != index) workexp.isCurrent = false;
            });
          };

          // userData.workexpmodel.pop(ind);
          userData.workexpmodel[ind].DelInd = true;
          $scope.userData = userData;

          $scope.answer = function () {
            user = $scope.userData;
            $mdDialog.cancel();
          };
          $scope.hide = function () {
            $mdDialog.hide();
          };

          $scope.cancel = function () {
            $mdDialog.cancel();
          };
        };

        $mdDialog.show({
          controller: compareTsController,
          templateUrl: 'components/profile/ChangeCurrentEmployer.html',
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          locals: {
            userData: user
          },
          fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
        }).then(function (answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function () {
          $scope.status = 'You cancelled the dialog.';
        });
      } else {
        // user.workexpmodel.pop(ind);
        user.workexpmodel[ind].DelInd = true;
      }
    };

    var GetFilesBody = {
      loginid: tokenData.loginid
    };

    function GetListOfDocuments() {
      dataService.newToken().then(function (response) {
        dataService.GetListOfDocuments(loginmodel).then(function (response) {
          $scope.documentsList = [];
          angular.forEach(response.data, function (docFile) {
            var splitData = docFile.split('~#');
            var obj = {
              FileName: splitData[2],
              FileUrl: docFile,
              DocID: splitData[1]
            };
            $scope.documentsList.push(obj);
          });
        }).catch(CatchError);
      }).catch(CatchError);
    }

    $scope.downloadFile = function (FileDetails) {
      var reqObj = {
        FileUrl: FileDetails.FileUrl,
        loginid: tokenData.loginid
      };
      dataService.newToken().then(function (response) {
        dataService.GetFileToDownload(reqObj).then(function (response, status, headers) {
          var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
            return data + String.fromCharCode(byte);
          }, ''));
          var anchor = $('<a/>');
          anchor.attr({
            href: 'data:application/octet-stream; base64,' + base64,
            target: '_blank',
            download: FileDetails.FileName
          })[0].click();
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.uploadFile = function (fd, docModel) {
      var file;
      switch (fd.docModel) {
        case 'model1':
          file = $rootScope.model1;
          break;
        case 'model2':
          file = $rootScope.model2;
          break;
        case 'model3':
          file = $rootScope.model3;
          break;
        case 'model4':
          file = $rootScope.model4;
          break;
        case 'model5':
          file = $rootScope.model5;
          break;
      }

      if (file !== undefined) {
        // angular.forEach($scope.documentsList, function (docList) {
        //     if(parseInt(docList.DocID) === fd.DocID){
        //         docList.spinStart = true;
        //     }
        // });
        fd.spinStart = true;
        var formdata = new FormData();

        formdata.append('LoginId', tokenData.loginid);
        formdata.append('DocId', fd.DocID);
        formdata.append('file', file);

        // formdata.append('filename', file.name);
        // formdata.append('filesize', file.size);
        // formdata.append('filetype', file.type);

        $scope.stepsModel = [];
        dataService.newToken().then(function (response) {
          dataService.UploadFiles(formdata).then(function (response) {
            new GetListOfDocuments();
            fd.spinStart = false;
            docModel = null;
          }).catch(CatchError);
        }).catch(CatchError);
      }
    };

    $scope.savingProfile = false;

    $scope.saveProfile = function (updateBody) {
      $scope.savingProfile = true;
      // updateBody.loginmodel = {
      //     "loginid": tokenData.loginid
      // };
      updateBody.DOB = moment(updateBody.DOB).format('MM-DD-YYYY');
      angular.forEach(updateBody.workexpmodel, function (wexp) {
        wexp.StartDate = moment(wexp.StartDate).format('MM-DD-YYYY');
        if (wexp.EndDate !== undefined) {
          wexp.EndDate = moment(wexp.EndDate).format('MM-DD-YYYY');
        }
      });
      updateBody.edumodel.BachelorsGradDate = moment(updateBody.edumodel.BachelorsGradDate).format('MM-DD-YYYY');
      updateBody.edumodel.MastersGradDate = moment(updateBody.edumodel.MastersGradDate).format('MM-DD-YYYY');
      updateBody.identymodel.StateIdIssueDate = moment(updateBody.identymodel.StateIdIssueDate).format('MM-DD-YYYY');
      updateBody.identymodel.StateIdExpDate = moment(updateBody.identymodel.StateIdExpDate).format('MM-DD-YYYY');
      updateBody.identymodel.DLIssueDate = moment(updateBody.identymodel.DLIssueDate).format('MM-DD-YYYY');
      updateBody.identymodel.DLExpDate = moment(updateBody.identymodel.DLExpDate).format('MM-DD-YYYY');
      updateBody.identymodel.PIssueDate = moment(updateBody.identymodel.PIssueDate).format('MM-DD-YYYY');
      updateBody.identymodel.PExpDate = moment(updateBody.identymodel.PExpDate).format('MM-DD-YYYY');

      updateBody.visamodel.CurrentVisaStartDate = moment(updateBody.visamodel.CurrentVisaStartDate).format('MM-DD-YYYY');
      updateBody.visamodel.CurrentVisaEndDate = moment(updateBody.visamodel.CurrentVisaEndDate).format('MM-DD-YYYY');
      updateBody.visamodel.CurrentWorkAuthStartDate = moment(updateBody.visamodel.CurrentWorkAuthStartDate).format('MM-DD-YYYY');
      updateBody.visamodel.CurrentWorkAuthEndDate = moment(updateBody.visamodel.CurrentWorkAuthEndDate).format('MM-DD-YYYY');
      updateBody.visamodel.labourappliedDate = moment(updateBody.visamodel.labourappliedDate).format('MM-DD-YYYY');
      updateBody.visamodel.labourapproveDate = moment(updateBody.visamodel.labourapproveDate).format('MM-DD-YYYY');
      updateBody.visamodel.I40AppliedDate = moment(updateBody.visamodel.I40AppliedDate).format('MM-DD-YYYY');
      updateBody.visamodel.I40ApprovedDate = moment(updateBody.visamodel.I40ApprovedDate).format('MM-DD-YYYY');

      if (updateBody.visamodel.GCApplied == 'true') {
        updateBody.visamodel.GCApplied = true;
      } else {
        updateBody.visamodel.GCApplied = false;
      }
      if (updateBody.visamodel.IsUSCitizen == 'true') {
        updateBody.visamodel.IsUSCitizen = true;
      } else {
        updateBody.visamodel.IsUSCitizen = false;
      }

      dataService.newToken().then(function (response) {
        dataService.UpdateProfile(updateBody).then(function (response) {
          new GetProfileDataFunc();
          $scope.loginLoader = false;
          // $scope.savingProfile = false;
        }).catch(CatchError);
      }).catch(CatchError);
      $scope.inactive = true;
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('dashboard', {
    controller: DashboardController,
    controllerAs: 'vm',
    templateUrl: 'app/components/consultant/dashboard/dashboard.html'
  });

  function DashboardController($state, $scope, $rootScope, dataService, $location, $http, $timeout, $mdToast, $q, $mdDialog, moment) {
    function loadjscssfile(filename, filetype) {
      if (filetype == 'js') {
        // if filename is a external JavaScript file
        var fileref = document.createElement('script');
        fileref.setAttribute('type', 'text/javascript');
        fileref.setAttribute('src', filename);
      } else if (filetype == 'css') {
        // if filename is an external CSS file
        var fileref = document.createElement('link');
        fileref.setAttribute('rel', 'stylesheet');
        fileref.setAttribute('type', 'text/css');
        fileref.setAttribute('href', filename);
      }
      if (typeof fileref !== 'undefined') {
        document.getElementsByTagName('head')[0].appendChild(fileref);
      }
    }
    loadjscssfile('https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.5.3/jspdf.min.js', 'js');
    loadjscssfile('https://cdn.datatables.net/v/dt/dt-1.10.20/b-1.6.1/b-flash-1.6.1/b-html5-1.6.1/fc-3.3.0/fh-3.1.6/datatables.min.js', 'js');
    loadjscssfile('https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css', 'css');
    $scope.innerHeight = window.innerHeight;
    $rootScope.isLogin = false;
    $scope.ShowTimeTracker = false;
    $scope.ShowDocuments = true;
    $scope.ShowSubmittedTs = true;
    $scope.showSubmittedTsloader = true;
    $scope.showSubmittedTsExport = true;
    var tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.tokenData = tokenData;
    $scope.notMon = false;
    window.isMobile = /iphone|ipod|ipad|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(navigator.userAgent.toLowerCase());
    $scope.isMobile = window.isMobile;
    $scope.innerHeight = window.innerHeight;
    $scope.role = tokenData.role;
    var reqLid = {};
    reqLid.loginid = parseInt(tokenData.loginid);
    $scope.userDataLoaded = false;
    $scope.uploadNeeded = true;
    $scope.loginLoader = false;
    $scope.SubmittedRanges = [];
    $scope.PortalSubmittedRanges = [];
    $scope.profilePicUploaded = false;
    $scope.submittedTimesheetLoader = false;
    $scope.ctsUploadLoader = false;
    $scope.readyUpload = false;
    $scope.clientPendingTs = false;
    $scope.clientTsSubmisson = true;
    $scope.TimesheetPeriod = null;
    $scope.minFromDate = new Date(moment(tokenData.projectstartdate).format('MM/DD/YYYY'));

    $scope.beforeJoiningDate = false;
    $scope.afterPresentDate = false;
    $scope.selectedRange = undefined;
    $scope.notInBetweenExp = false;

    $scope.firstLogin = false;
    $scope.image = $rootScope.image;

    // get years os user
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    if ($scope.selectCtsRangesYear === undefined) {
      var currentDateMMDD = moment().format("MM/DD");
      var toBeLessThanDateMMDD = moment("01/16").format("MM/DD");
      var currentYearYYYY = JSON.parse(moment().format('YYYY'));
      $scope.presentYear = currentDateMMDD < toBeLessThanDateMMDD ? currentYearYYYY - 1 : currentYearYYYY;
    }
    var year = $scope.presentYear;
    var a = moment([$scope.presentYear]);

    $scope.prevYear = a.subtract(1, 'y').format('YYYY');

    $scope.getPrevYearTs = function (year) {
      $scope.yearTsLoader = true;
      $scope.showSubmittedTsExport = false;
      reqLid.Year = year;
      new GetSubmittedTSidsFunc(reqLid);
    };
    $scope.getPresnYearTs = function () {
      $scope.yearTsLoader = true;
      $scope.showSubmittedTsExport = false;
      reqLid.Year = $scope.presentYear;
      new GetSubmittedTSidsFunc(reqLid);
    };

    $scope.loadedTs = false;

    $scope.loadTs = function () {
      $scope.loadedTs = true;
      $scope.SubmittedTsS = [];
      reqLid.Year = $scope.presentYear;
      new GetSubmittedTSidsFunc(reqLid);
    };
    var prfid = {
      loginid: tokenData.loginid
    };
    dataService.newToken().then(function (response) {
      dataService.GetClients(prfid).then(function (response) {
        $scope.ShowTimeTracker = true;
        $scope.ClientsList = response.data;
        reqLid.Year = $scope.presentYear;
        new GetSubmittedTSidsFunc(reqLid);
      }).catch(CatchError);
    }).catch(CatchError);

    function GetSubmittedTSidsFunc(reqTsBody) {
      $scope.PendingCtsTs = [];
      $scope.submittedTimesheets = [];
      var TsData = [];
      dataService.newToken().then(function (response) {
        dataService.GetSubmittedTSids(reqTsBody).then(function (response1) {
          var Data1 = response1.data;
          var presentMMDD = moment().format('MM/DD');

          TsData = response1.data;
          $timeout(function () {
            $scope.submittedTimesheets = TsData;
            $scope.SubmittedTsS = [];
            angular.forEach($scope.submittedTimesheets, function (sts) {
              $scope.PortalSubmittedRanges.push(sts.submitedRange);
              if (sts.Status === 2) {
                sts.Status = 'Approved';
              } else if (sts.Status === 3) {
                sts.Status = 'Rejected';
              } else {
                sts.Status = 'Submitted';
              }
              $scope.SubmittedTsS.push(sts);
            });

            $scope.yearTsLoader = false;
            $scope.userDataLoaded = true;
            $scope.submittedTimesheets = $scope.SubmittedTsS;
            //  lastSubmittedTimesheet(submittedTimesheets);
            $scope.labels = [];
            $scope.data = [];
            angular.forEach(TsData, function (timesheet) {
              if (timesheet.Status !== 'Rejected') {
                $scope.labels.push(timesheet.submitedRange);
                $scope.data.push(timesheet.TotalHours);
              }
            });

            //  $scope.labels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
            $scope.series = ['Total Hours'];
            //   $scope.data = [45, 49, 40, 41, 50, 35, 40, 28, 48, 40, 19, 46, 27, 50];
            $scope.chartOptions = {
              maintainAspectRatio: false
            };
            $scope.colors = ['#ff0000'];
            $scope.loginLoader = false;
            var PrfPicData = angular.fromJson(localStorage.getItem('PrfPicData'));
            if (PrfPicData.Pic !== null) {
              $scope.profilePicUploaded = true;
            }
            $scope.picFile = angular.fromJson(localStorage.getItem('PrfPicData'));
            $scope.showSubmittedTsExport = true;
            $scope.loadedTs = false;
          }, 1000);
          $timeout(function () {
            $('#SubmittedMts').DataTable().destroy();
            $('#SubmittedMts').DataTable({
              lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, 'All']],
              bInfo: false,
              sDom: '<"top"if>rt<"bottom"p><"clear">'
            });
          }, 1100);
        }).catch(CatchError);
      }).catch(CatchError);
    }
    $scope.PendingCtsTs = [];
    $scope.GetCTSSubtRangesLoader = false;

    $scope.selectCtsRanges = function (y) {
      $scope.ctsUploadLoader = true;
      $scope.selectCtsRangesYear = y;
      $scope.cts = {
        TimesheetPeriod: null
      };
      $scope.PendingCtsTs = [];
      $scope.SubmittedRanges = [];
      $scope.selClient = undefined;
      $timeout(function () {
        $scope.ctsUploadLoader = false;
      }, 300);
    };
    if ($scope.selectCtsRangesYear === undefined) {
      var currentDateMMDD = moment().format("MM/DD");
      var toBeLessThanDateMMDD = moment("01/16").format("MM/DD");
      var currentYearYYYY = JSON.parse(moment().format('YYYY'));
      $scope.selectCtsRangesYear = currentDateMMDD < toBeLessThanDateMMDD ? currentYearYYYY - 1 : currentYearYYYY;
      // $scope.selectCtsRangesYear = JSON.parse(moment().format('YYYY'));
    }

    $scope.ctsRanges = function () {
      $scope.drpPreload = true;
      $scope.PendingCtsTs = [];
      $scope.SubmittedRanges = [];
      var req = {
        loginid: parseInt(tokenData.loginid),
        Year: $scope.selectCtsRangesYear
      };
      dataService.newToken().then(function (response) {
        dataService.GetSubmittedTSids(req).then(function (response) {
          angular.forEach(response.data, function (sts) {
            if (sts.Status === 1) {
              sts.Status = 'Submitted';
              $scope.SubmittedRanges.push(sts);
            }
          });
          dataService.newToken().then(function (response) {
            dataService.GetCTSSubtRanges(req).then(function (response) {
              $scope.clientPendingTs = true;
              if (response.data.length > 0) {
                for (var index = 0; index < response.data.length; index++) {
                  var element = response.data[index];
                  var UniqueTSId = element.FileUrl.split('~#')[1];
                  element.UniqueTSId = UniqueTSId;
                }
                $scope.PendingCtsTs = _.differenceBy($scope.SubmittedRanges, response.data, 'UniqueTSId');
                $scope.drpPreload = false;
              } else {
                $scope.PendingCtsTs = $scope.SubmittedRanges;
                $scope.drpPreload = false;
              }
            }).catch(CatchError);
          }).catch(CatchError);
        });
      }).catch(CatchError);
    };

    $scope.loadSubmittedCTS = function () {
      var req = {
        loginid: parseInt(tokenData.loginid)
      };
      dataService.newToken().then(function (response) {
        dataService.GetCTSSubtRanges(req).then(function (response) {
          $scope.CtsSubmitted = response.data;
          $timeout(function () {
            $('#SubmittedCts').DataTable().destroy();
            $('#SubmittedCts').DataTable({
              lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, 'All']],
              bInfo: false,
              sDom: '<"top"if>rt<"bottom"p><"clear">'
            });
          });
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.TsSelectedClient = function (SelClientID) {
      $scope.fromDate = null;
      $scope.$broadcast('md-calendar-change', $scope.fromDate);
      $scope.toDate = undefined;
      angular.forEach($scope.ClientsList, function (client) {
        if (client.ClientId == SelClientID) {
          if (client.EndDate == '0001-01-01T00:00:00') {
            client.EndDate = new Date();
          } else {
            client.EndDate = new Date(client.EndDate);
          }
          $scope.selectedClient = client;
          // $scope.selectedClient.StartDate = new Date(moment($scope.selectedClient.StartDate).format("MM/DD/YYYY"));
          // $scope.selectedClient.StartDate = new Date(moment($scope.selectedClient.StartDate).startOf('isoWeek').format("MM/DD/YYYY"));
          // $scope.selectedClient.EndDate = new Date(moment($scope.selectedClient.EndDate).format("MM/DD/YYYY"));
          var startD = moment($scope.selectedClient.StartDate).startOf('week');
          $scope.selectedClient.StartDate = new Date(startD);
          $scope.selectedClient.EndDate = new Date($scope.selectedClient.EndDate);
        }
      });
    };

    $scope.checkfromDate = function (selDate) {
      $scope.SubmittedTSs = [];
      $scope.tsRange = true;
      reqLid.Year = moment(selDate).format('YYYY');
      dataService.newToken().then(function (response) {
        dataService.GetSubmittedTSids(reqLid).then(function (response) {
          angular.forEach(response.data, function (sts) {
            $scope.SubmittedTSs.push(sts.submitedRange + sts.Client);
          });
          if (selDate !== undefined) {
            var toDate = moment(selDate).add(6, 'days').format('MM/DD/YYYY');
            $scope.toDate = new Date(moment(toDate).format('MM/DD/YYYY'));
            $scope.fromDate = new Date(selDate);
          }
          $scope.selectedRange = moment(selDate).format('M/D/YYYY') + '-' + moment($scope.toDate).format('M/D/YYYY');
          var selDateMMDDYYY = moment(selDate).format('MM/DD/YYYY');
          var projectstartdateMMDDYYY = moment(selDate).format('MM/DD/YYYY');
          if (!moment(selDateMMDDYYY).isBetween($scope.selectedClient.StartDate, $scope.selectedClient.EndDate, null, '[]')) {
            $scope.notInBetweenExp = true;
            $scope.afterPresentDate = false;
            $scope.beforeJoiningDate = false;
            $scope.tsRange = true;
          } else if (moment(selDateMMDDYYY).isBefore(projectstartdateMMDDYYY)) {
            $scope.beforeJoiningDate = true;
            $scope.notInBetweenExp = false;
            $scope.afterPresentDate = false;
            $scope.selectedRange = undefined;
            $scope.tsRange = true;
          } else if (moment($scope.toDate).isAfter(moment())) {
            if (moment($scope.toDate).format('dddd') == 'Friday' || moment($scope.toDate).format('dddd') == 'Saturday' || moment($scope.toDate).format('dddd') == 'Sunday') {
              $scope.afterPresentDate = false;
              $scope.tsRange = false;
              $scope.notInBetweenExp = true;
              $scope.selectedRange = moment(selDate).format('M/D/YYYY') + '-' + moment($scope.toDate).format('M/D/YYYY') + $scope.selectedClient.ClientName;
              var index = $scope.SubmittedTSs.indexOf($scope.selectedRange);
              if (index > -1) {
                angular.forEach(response.data, function (subts) {
                  if (subts.submitedRange === $scope.selectedRange) {
                    if (subts.AccountsAction == 'Rejected' || subts.ManagerAction == 'Rejected') {
                      $scope.tsRange = false;
                    } else {
                      $scope.tsRange = true;
                      $scope.notInBetweenExp = false;
                    }
                  }
                });
              } else {
                $scope.tsRange = false;
              }
            } else {
              $scope.afterPresentDate = false;
              $scope.beforeJoiningDate = false;
              $scope.selectedRange = undefined;
              $scope.tsRange = false;
              $scope.notInBetweenExp = false;
            }
          } else {
            $scope.afterPresentDate = false;
            $scope.beforeJoiningDate = false;
            $scope.notInBetweenExp = false;
            $scope.selectedRange = moment(selDate).format('M/D/YYYY') + '-' + moment($scope.toDate).format('M/D/YYYY') + $scope.selectedClient.ClientName;
            var subTsindex = $scope.SubmittedTSs.indexOf($scope.selectedRange);
            if (subTsindex > -1) {
              angular.forEach(response.data, function (subts) {
                subts.submitedRange = subts.submitedRange + subts.Client;
                if (subts.submitedRange === $scope.selectedRange) {
                  if (subts.AccountsAction == 'Rejected' || subts.ManagerAction == 'Rejected') {
                    $scope.tsRange = false;
                  } else {
                    $scope.tsRange = true;
                  }
                }
              });
            } else {
              $scope.tsRange = false;
            }
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.timesheetSubmit = function (PortalTsClient, fromDate, toDate) {
      var title;
      angular.forEach($scope.ClientsList, function (client) {
        if (client.ClientId == PortalTsClient) {
          title = client.Title;
        }
      });
      var tTracker = {
        PortalTsClient: PortalTsClient,
        fromDate: fromDate,
        toDate: toDate,
        Title: title
      };
      localStorage.setItem('tTrackerDates', angular.toJson(tTracker));
      $state.go('tsSubmit');
    };

    $scope.maxFromDate = new Date();

    $scope.onlyWeekendsPredicate = function (date) {
      var day = date.getDay();
      if (day == 1) {
        return date;
      } else {
        return day == 1;
      }
    };

    $scope.openSubTs = function (id, payYear) {
      $scope.submitedRange = payYear;
      var reqBody = {};
      reqBody.PayrollYear = payYear;
      reqBody.TimeTrackerId = id;
      var loginModel = {
        loginid: tokenData.loginid
      };
      reqBody.loginmodel = loginModel;
      localStorage.setItem('submittedTsExportReq', angular.toJson(reqBody));
    };

    $scope.ctsUploadObj = {
      model: 'ctsUpload',
      doc: ''
    };
    $scope.clientRangeSubmisson = function () {
      $scope.clientTsSubmisson = false;
    };
    $scope.uploadCtsFile = function (data) {
      $scope.ctsFile = $rootScope.ctsUpload;
      if ($rootScope.ctsUpload !== undefined) {
        $scope.readyUpload = true;
      }
    };
    $scope.clearUpload = function () {
      $scope.files = [];
      $rootScope.files = [];
    };
    var selectedCtsIndex = 0;
    $scope.selectedCtsIndex = selectedCtsIndex;
    $scope.clientBack = function () {
      selectedCtsIndex = 1;
    };
    $scope.newCts = function () {
      // $scope.selectedCtsIndex = 1;
    };
    $scope.cts = {
      TimesheetPeriod: undefined
    };
    $scope.selCtsRange = function (rang) {
      if (rang.TimesheetPeriod !== 'None' && rang.TimesheetPeriod !== '') {
        angular.forEach($scope.PendingCtsTs, function (ts) {
          if (ts.UniqueTSId == rang.TimesheetPeriod) {
            angular.forEach($scope.ClientsList, function (client) {
              if (ts.Client == client.ClientName) {
                $scope.selClient = client.ClientId;
              }
            });
          }
        });
      } else {
        rang.TimesheetPeriod = undefined;
        $scope.selClient = undefined;
      }
    };
    $rootScope.files = [];
    $scope.fileUploaded = function (type, cts) {
      var imgSize;
      var typeCheck = false;
      var FilesArr = [];
      if (Object.keys($rootScope.files).length > 0) {
        if ($rootScope.files[0] === undefined) {
          FilesArr.push($rootScope.files);
          $rootScope.files = FilesArr;
        }
        for (var index = 0; index < $rootScope.files.length; index++) {
          var element = $rootScope.files[index];
          var filename = element.name;
          var ext = filename.substring(filename.lastIndexOf('.') + 1);
          if (type.toLowerCase() == 'pdf' && (ext.toLowerCase() == 'jpg' || ext.toLowerCase() == 'png') || type.toLowerCase() == 'img' && ext.toLowerCase() == 'pdf') {
            $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('You have uploaded filetype (' + ext + '). Please select appropriate File Type').textContent('Supported file types are JPG, PNG, PDF.').ariaLabel('File Type Not Supported').ok('Got it!')).then(function () {
              $rootScope.files = [];
              cts.FileType = undefined;
            });
            break;
          } else if (ext.toLowerCase() !== 'jpg' && ext.toLowerCase() !== 'png' && ext.toLowerCase() !== 'pdf' && ext.toLowerCase() !== 'jpeg') {
            $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title(ext + ' is not supported').textContent('Supported file types are JPG, PNG, PDF.').ariaLabel('File Type Not Supported').ok('Got it!')).then(function () {
              $rootScope.files = [];
              cts.FileType = undefined;
            });
            break;
          } else {
            if (element.size > 20000000) {
              //   var toast = $mdToast
              //     .simple()
              //     .content("Maximum file size should be 20mb.")
              //     .action("OK")
              //     .highlightAction(true)
              //     .position("top center")
              //     .hideDelay(5000);
              //   $mdToast.show(toast);
              $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Oops.!').textContent('Maximum file size should be 20mb.').ariaLabel('File Type Not Supported').ok('Got it!'));
              $scope.files = undefined;
              $rootScope.files = [];
              cts.FileType = undefined;
            } else if ($rootScope.files.length > 3) {
              $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Oops.!').textContent('You can upload maximum 3 files only.').ariaLabel('File Type Not Supported').ok('Got it!'));
              $scope.files = undefined;
              $rootScope.files = [];
              cts.FileType = undefined;
            } else {
              $scope.files = $rootScope.files;
            }
          }
        }
      }
    };
    $scope.ctsFileUpload = function (data, cid) {
      $scope.ctsUploadLoader = true;

      angular.forEach($scope.SubmittedTsS, function (obj) {
        if (obj.UniqueTSId == data.TimesheetPeriod) {
          $scope.Range = obj.submitedRange;
        }
      });
      var base64Code;
      var file = $rootScope.files;
      var pdf;

      function HttpReq(ctsFormdata) {
        dataService.newToken().then(function (response) {
          dataService.InsertCTSReq(ctsFormdata).then(function (response) {
            for (var index = 0; index < $scope.PendingCtsTs.length; index++) {
              var element = $scope.PendingCtsTs[index];
              if (element.UniqueTSId == data.TimesheetPeriod) {
                dataService.newToken().then(function (response) {
                  dataService.GetCTSSubtRanges(reqLid).then(function (response) {
                    var PendingCtsTs = $scope.PendingCtsTs;
                    PendingCtsTs.splice(index, 1);
                    $scope.PendingCtsTs = [];
                    data.Client = 'None';
                    data.TimesheetPeriod = 'None';
                    data.TotalHours = '';
                    $rootScope.ctsUpload = undefined;
                    $scope.ctsFile = undefined;
                    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Success.').textContent('Client Timesheet Submitted Successfully.').ariaLabel('cts Submitted').ok('Got it!'));
                    $scope.ctsUploadLoader = false;
                    $scope.clientTsSubmisson = true;
                    $scope.selClient = 'None';
                    data.FileType = '';
                    $scope.files = [];
                    $rootScope.files = [];
                    $scope.selectedCtsIndex = 1;
                    $scope.CtsSubmitted = response.data;
                    $scope.PendingCtsTs = PendingCtsTs;
                  }).catch(CatchError);
                }).catch(CatchError);
                break;
              }
            }
          }).catch(CatchError);
        }).catch(CatchError);
      }

      function CreateFormData(pdf) {
        var ctsFormdata = new FormData();
        ctsFormdata.append('file', pdf);
        ctsFormdata.append('TPId', data.TimesheetPeriod);
        ctsFormdata.append('Range', $scope.Range);
        ctsFormdata.append('TotalHours', data.TotalHours);
        ctsFormdata.append('LoginId', tokenData.loginid);
        ctsFormdata.append('clientid', cid);
        HttpReq(ctsFormdata);
      }

      function pdfBlob(blodData) {
        var promise = $q.all([]);
        var ArrayLastIttrteVal = blodData.length - 1;
        $scope.arrayLastIttrte = false;
        var doc = new jsPDF('p', 'pt', 'a4', true);
        var promise1 = new Promise(function (resolve, reject) {
          angular.forEach(blodData, function (imgData, i) {
            if (i !== 0) {
              doc.addPage();
            }
            if (imgData.type == 'image/jpeg') {
              doc.addImage(imgData.blob, 'JPEG', 10, 10, 485, 270, undefined, 'SLOW');
            } else {
              doc.addImage(imgData.blob, 'PNG', 10, 10, 485, 270, undefined, 'SLOW');
            }
            // if (i == blodData.length - 1) {
            //     resolve();
            // }
          });
          setTimeout(function () {
            resolve();
          }, 2000);
        });
        promise1.then(function () {
          // doc.save("hhg.pdf");
          pdf = doc.output('blob');
          new CreateFormData(pdf);
        });
        // if ($scope.arrayLastIttrte === true) {
        //     pdf = doc.output('blob');
        //     CreateFormData(pdf, HttpReq);
        // }
        // doc.save();
      }

      function convertBase64(filedata) {
        var base64Image = [];
        var promise2 = new Promise(function (resolve, reject) {
          angular.forEach(filedata, function (file, i) {
            var reader = new FileReader();
            reader.onloadend = function () {
              var obj = {
                type: file._file.type,
                blob: reader.result
              };
              base64Image.push(obj);
            };
            reader.readAsDataURL(file._file);
            // if (i == filedata.length - 1) {
            //     resolve(base64Image);
            // }
          });
          setTimeout(function () {
            resolve(base64Image);
          }, 2000);
        });
        promise2.then(function (value) {

          new pdfBlob(value);
        });
      }

      if (data.FileType == 'image') {
        new convertBase64(file);
      } else {
        var ctsFormdata = new FormData();
        ctsFormdata.append('file', $rootScope.files[0]._file);
        ctsFormdata.append('TPId', data.TimesheetPeriod);
        ctsFormdata.append('Range', $scope.Range);
        ctsFormdata.append('TotalHours', data.TotalHours);
        ctsFormdata.append('LoginId', tokenData.loginid);
        ctsFormdata.append('clientid', cid);
        HttpReq(ctsFormdata);
      }
    };

    $scope.downloadCts = function (ctsData) {
      var obj = {
        FileUrl: ctsData.FileUrl,
        LoginId: tokenData.loginid
      };
      dataService.newToken().then(function (response) {
        dataService.GetCTSFile(obj).then(function (response) {
          $scope.notAdmittedCtsMsg = false;
          $scope.ctsfileload = true;
          var ctsData = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
            return data + String.fromCharCode(byte);
          }, ''));
          var currentBlob = new Blob([ctsData], {
            type: 'application/pdf'
          });
          $scope.pdfUrl = URL.createObjectURL(currentBlob);
          window.open($scope.pdfUrl, '__blank');
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.picFile = angular.fromJson(localStorage.getItem('PrfPicData'));

    $scope.AvatarUploadfunc = function () {
      var data = $rootScope.AvatarUpload;
      if (data !== undefined) {
        if (data._file.size > 2097152) {
          var toast = $mdToast.simple().content('File size should not be more than 2 MB. Please try again.').action('OK').highlightAction(false).position('top center').hideDelay(30000);
          $mdToast.show(toast);
        } else {
          var formdata = new FormData();
          formdata.append('file', data._file);
          formdata.append('loginid', $scope.tokenData.loginid);
          formdata.append('prfid', $scope.tokenData.prfid);
          formdata.append('filename', data._file.name);
          formdata.append('filesize', data._file.size);
          formdata.append('filetype', data._file.type);
          dataService.newToken().then(function (response) {
            dataService.UploadPicture(formdata).then(function (response) {
              dataService.newToken().then(function (response) {
                dataService.GetProfilePic({
                  prfid: $scope.tokenData.prfid,
                  loginid: $scope.tokenData.loginid
                }).then(function (response) {
                  var ctsImgData = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
                    return data + String.fromCharCode(byte);
                  }, ''));
                  localStorage.setItem('PrfPicData', angular.toJson(ctsImgData));
                  $scope.picFile = angular.fromJson(localStorage.getItem('PrfPicData'));
                  $scope.profilePicUploaded = true;
                }).catch(CatchError);
              }).catch(CatchError);
            }).catch(CatchError);
          }).catch(CatchError);
        }
      }
      $scope.go = function (path) {
        $state.go(path);
      };
    };
  };
})();


(function () {
  'use strict';

  angular.module('app').component('w2users', {
    controller: w2usersController,
    controllerAs: 'vm',
    templateUrl: 'app/components/president/w2users/w2users.html'
  });

  function w2usersController($scope, dataService, $http, $timeout, $mdDialog, $state, $location) {
    $scope.ActiveConslByPayRateRangelabels = [];
    $scope.ActiveConslByPayRateRangedata = [];

    function loadjscssfile(filename, filetype) {
      if (filetype == 'js') {
        // if filename is a external JavaScript file
        var fileref = document.createElement('script');
        fileref.setAttribute('type', 'text/javascript');
        fileref.setAttribute('src', filename);
      } else if (filetype == 'css') {
        // if filename is an external CSS file
        var fileref = document.createElement('link');
        fileref.setAttribute('rel', 'stylesheet');
        fileref.setAttribute('type', 'text/css');
        fileref.setAttribute('href', filename);
      }
      if (typeof fileref !== 'undefined') {
        document.getElementsByTagName('head')[0].appendChild(fileref);
      }
    }
    loadjscssfile('https://cdn.datatables.net/v/dt/dt-1.10.20/b-1.6.1/b-flash-1.6.1/b-html5-1.6.1/fc-3.3.0/fh-3.1.6/datatables.min.js', 'js');
    loadjscssfile('https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css', 'css');
    var CatchError;
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    $scope.logout = function () {
      localStorage.clear();
      $state.go('signin');
    };
    dataService.newToken().then(function (response) {
      dataService.w2Users().then(function (response) {
        $scope.w2UsersList = response.data;
        $timeout(function () {
          $('#w2UsersTable').DataTable({
            lengthMenu: [[20, 40, 60, 80, 100, 120], [20, 40, 60, 80, 100, 120]],
            dom: 'lBfrtip',
            buttons: ['copyHtml5', 'excelHtml5', 'csvHtml5', 'pdfHtml5']
          });
        });
      }).catch(CatchError);
    }).catch(CatchError);
  }
})();


(function () {
  'use strict';

  angular.module('app').component('presidentdashboard', {
    controller: presidentdashboardController,
    controllerAs: 'vm',
    templateUrl: 'app/components/president/dashboard/president.html'
  });

  function presidentdashboardController($scope, dataService, $http, $timeout, $mdDialog, $state, $q) {
    $scope.ActiveConslByPayRateRangelabels = [];
    $scope.ActiveConslByPayRateRangedata = [];

    function loadjscssfile(filename, filetype) {
      if (filetype == 'js') {
        // if filename is a external JavaScript file
        var fileref = document.createElement('script');
        fileref.setAttribute('type', 'text/javascript');
        fileref.setAttribute('src', filename);
      } else if (filetype == 'css') {
        // if filename is an external CSS file
        var fileref = document.createElement('link');
        fileref.setAttribute('rel', 'stylesheet');
        fileref.setAttribute('type', 'text/css');
        fileref.setAttribute('href', filename);
      }
      if (typeof fileref !== 'undefined') {
        document.getElementsByTagName('head')[0].appendChild(fileref);
      }
    }
    window.isMobile = /iphone|ipod|ipad|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(navigator.userAgent.toLowerCase());
    $scope.isMobile = window.isMobile;
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };

    function loadData($q) {
      return $q.all([dataService.TotalActiveConslByPayRateRange(), dataService.GetPresLookup()]);
    }
    dataService.newToken().then(function (response) {
      loadData($q).then(function (response) {
        for (var i = 0; i < response[0].data.length; i++) {
          $scope.ActiveConslByPayRateRangelabels.push(response[0].data[i].Range);
          $scope.ActiveConslByPayRateRangedata.push(response[0].data[i].Count);
        }
        $scope.counts = response[1].data;
      });
    }).catch(CatchError);
    $scope.logout = function () {
      localStorage.clear();
      $state.go('signin');
    };
    $scope.viewClientList = function (data) {
      $scope.user = data;
      $mdDialog.show({
        controller: viewClientListDialogController,
        templateUrl: 'app/components/president/viewConsbyClients.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          user: $scope.user
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });

      function viewClientListDialogController($scope, $mdDialog, user) {
        $scope.user = user;
        $timeout(function () {
          $('#clientConsList').DataTable({
            lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, 'All']]
          });
        });
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
      }
    };
    $scope.viewVendorList = function (data) {
      $scope.user = data;
      $mdDialog.show({
        controller: viewVendorListDialogController,
        templateUrl: 'app/components/president/viewVendorList.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          user: $scope.user
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });

      function viewVendorListDialogController($scope, $mdDialog, user) {
        $scope.user = user;
        $timeout(function () {
          $('#vendorConsList').DataTable({
            lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, 'All']]
          });
        });
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
      }
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('consByVendor', {
    controller: consByVendorController,
    controllerAs: 'vm',
    templateUrl: 'app/components/president/consByVendor/consByVendor.html'
  });

  function consByVendorController($scope, dataService, $http, $timeout, $mdDialog, $state, $location) {
    $scope.ActiveConslByPayRateRangelabels = [];
    $scope.ActiveConslByPayRateRangedata = [];

    function loadjscssfile(filename, filetype) {
      if (filetype == 'js') {
        // if filename is a external JavaScript file
        var fileref = document.createElement('script');
        fileref.setAttribute('type', 'text/javascript');
        fileref.setAttribute('src', filename);
      } else if (filetype == 'css') {
        // if filename is an external CSS file
        var fileref = document.createElement('link');
        fileref.setAttribute('rel', 'stylesheet');
        fileref.setAttribute('type', 'text/css');
        fileref.setAttribute('href', filename);
      }
      if (typeof fileref !== 'undefined') {
        document.getElementsByTagName('head')[0].appendChild(fileref);
      }
    }
    loadjscssfile('https://cdn.datatables.net/v/dt/dt-1.10.20/b-1.6.1/b-flash-1.6.1/b-html5-1.6.1/fc-3.3.0/fh-3.1.6/datatables.min.js', 'js');
    loadjscssfile('https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css', 'css');
    var CatchError;
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    dataService.newToken().then(function (response) {
      dataService.PlacmentsByVendor().then(function (response) {
        $scope.vendorPlacements = response.data;
        $timeout(function () {
          $('#vendorPlacements').DataTable({
            lengthMenu: [[15, 20, 40, 60, 80, 100, 120], [15, 20, 40, 60, 80, 100, 120]]
          });
        });
      }).catch(CatchError);
    }).catch(CatchError);

    $scope.viewVendorList = function (data) {
      $scope.user = data;
      $mdDialog.show({
        controller: viewVendorListDialogController,
        templateUrl: 'app/components/president/consByVendor/viewVendorList.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          user: $scope.user
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });

      function viewVendorListDialogController($scope, $mdDialog, user) {
        $scope.user = user;
        $timeout(function () {
          $('#vendorConsList').DataTable({
            lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, 'All']]
          });
        });
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
      }
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('consByClient', {
    controller: consByClientController,
    controllerAs: 'vm',
    templateUrl: 'app/components/president/consByClient/consByClient.html'
  });

  function consByClientController($scope, dataService, $http, $timeout, $mdDialog, $mdToast, $state, $location) {
    $scope.ActiveConslByPayRateRangelabels = [];
    $scope.ActiveConslByPayRateRangedata = [];
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };

    dataService.newToken().then(function (response) {
      dataService.PlacmentsByClients().then(function (response) {
        $scope.clientPlacements = response.data;
        $timeout(function () {
          $('#clientPlacements').DataTable({
            lengthMenu: [[15, 20, 40, 60, 80, 100, 120], [15, 20, 40, 60, 80, 100, 120]]
          });
        });
      }).catch(CatchError);
    }).catch(CatchError);

    $scope.viewClientList = function (data) {
      $scope.user = data;
      $mdDialog.show({
        controller: viewClientListDialogController,
        templateUrl: 'app/components/president/consByClient/viewConsbyClients.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          user: $scope.user
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });

      function viewClientListDialogController($scope, $mdDialog, user) {
        $scope.user = user;
        $timeout(function () {
          $('#clientConsList').DataTable({
            lengthMenu: [[15, 20, 40, 60, 80, 100, 120], [15, 20, 40, 60, 80, 100, 120]]
          });
        });
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
      }
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("vendors", {
    controller: vendorsController,
    controllerAs: "vm",
    templateUrl: "app/components/hr/vendors/vendors.html"
  });

  function vendorsController($scope, dataService, $http, $timeout, $q, $mdToast, $location, $state, $filter) {
    var vm = this;
    var tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.role = tokenData.newRole;
    var heightCanBe = window.innerHeight - 59 + "px";
    var listHeightCanBe = window.innerHeight - 170 + "px";
    $(".heightCanBe").css("height", heightCanBe);
    $(".listHeightCanBe").css("height", listHeightCanBe);
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 59 + "px";
      listHeightCanBe = window.innerHeight - 170 + "px";
      $(".listHeightCanBe").css("height", listHeightCanBe);
      $(".heightCanBe").css("height", heightCanBe);
    });
    $scope.newVendor = {};
    $scope.newVendor.VendorAddressInfo = [{
      Country: "",
      City: "",
      Zipcode: "",
      State: "",
      Street: ""
    }];
    $scope.newVendor.VendorAddressInfo[0].VendorAcctInfo = [];
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };

    // dataService.newToken().then(function(response){    dataService
    //   .GetVendorInfo()
    //   .then(function (response) {
    $scope.pageLoading = true;

    function loadData($q) {
      var xreflkup = dataService.xreflkup();
      var GetVendorInfo = dataService.GetVendorInfo();
      var GetStatesList = dataService.GetStatesList();

      return $q.all([xreflkup, GetVendorInfo, GetStatesList]);
    }

    dataService.newToken().then(function (response) {
      loadData($q).then(function (response) {
        //Lookups Res
        $scope.lookups = response[0].data;
        //GetVendorInfo Res
        if (response[1].data.length) {
          $scope.pageLoading = false;
          $scope.NoVendors = false;
          $scope.Vendors = response[1].data;
          $scope.selVendor = $scope.Vendors[0];
          $scope.selVendorIndex = 0;
          $scope.selectedVendorAddress = $scope.Vendors[0].VendorAddress;
        } else {
          $scope.pageLoading = false;
          $scope.NoVendors = true;
        }
        //States Res        
        $scope.states = response[2].data;
      });
    }).catch(CatchError);
    $scope.addNewVendorShow = false;
    $scope.addNewVendor = function (id) {
      $scope.addNewVendorShow = true;
      $("body").css("overflow", "hidden");
    };
    $scope.addNewVendorCancel = function (id) {
      $scope.addNewVendorShow = false;
    };

    $scope.addVendor = function (data) {
      data.VenCont.PhoneNumber = data.VenCont.PhoneNumber + " Extn: " + data.VenCont.Extn;
      dataService.newToken().then(function (response) {
        dataService.AddVendor(data).then(function (response) {
          if (response.statusText == "OK") {
            $scope.Vendors = response.data;
            $scope.addNewVendorShow = false;
            var toast = $mdToast.simple().content("Vendor added successfully.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $mdDialog.cancel();
          } else {
            var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $mdDialog.cancel();
            $scope.addNewVendorShow = false;
          }
        }).catch(CatchError);
      }).catch(CatchError);
      console.log(data);
    };
    $scope.newContact = function () {

      var obj = {
        "ContactName": "",
        "Designation": null,
        "AcctEmail": "",
        "PhoneNumber": "",
        "editable": true
      };
      $scope.newVendor.VendorAddressInfo[0].VendorAcctInfo.push(obj);
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("vendorDetails", {
    controller: vendorDetailsController,
    controllerAs: "vm",
    templateUrl: "app/components/hr/vendorDetails/vendorDetails.html"
  });

  function vendorDetailsController($scope, dataService, $http, $timeout, $stateParams, $mdToast, $q, $state, $filter) {
    var vm = this;
    var tokenData = angular.fromJson(localStorage.getItem("tokenData"));
    var heightCanBe = window.innerHeight - 70 + "px";
    var listHeightCanBe = window.innerHeight - 170 + "px";
    $scope.ratingShow = false;

    $scope.emailFormat = /^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/;
    $(".heightCanBe").css("height", heightCanBe);
    $(".listHeightCanBe").css("height", listHeightCanBe);
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 70 + "px";
      listHeightCanBe = window.innerHeight - 170 + "px";
      $(".listHeightCanBe").css("height", listHeightCanBe);
      $(".heightCanBe").css("height", heightCanBe);
    });
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };
    $scope.pageLoader = true;
    $scope.addVendorAddrShow = false;
    $scope.showAddNewAddrForm = false;
    $scope.editSelectedAddr = false;
    $scope.AddNewVendorActShow = false;
    $scope.editvendorActInfo = false;
    $scope.UVendorAdd = {};
    $scope.selectedDocType = "";
    $scope.files = null;
    $scope.vendorname = "";
    var re = /(?:\.([^.]+))?$/;

    function loadData($q) {
      return $q.all([dataService.xreflkup(), dataService.GetStatesList()]);
    }
    dataService.newToken().then(function () {
      loadData($q).then(function (response) {
        $scope.lookups = response[0].data;
        $scope.states = response[1].data;
        getVenDetails();
        // getVenDetails().then(function (response) {
        //   dataService.newToken().then(function (response) {
        //     dataService
        //       .GetVendorRatingById({
        //         VendorId: $stateParams.id,
        //       })
        //       .then(function (response) {
        //         $scope.ratingShow = true;
        //         $scope.rating = response.data.Score;
        //       });
        //   });
        // }).catch(CatchError);
      }).catch(CatchError);
    }).catch(CatchError);

    function getVenDetails() {
      return new Promise(function (resolve, reject) {
        dataService.newToken().then(function (response) {
          dataService.GetVendorInfoByVendorId({
            VendorId: $stateParams.id
          }).then(function (response) {
            var element = response.data;
            var InvoiceTermObj = _.filter($scope.lookups.lstInvTerm, function (v) {
              return _.includes([element.InvoiceTerm], v.InvTermId);
            });
            if (InvoiceTermObj.length > 0) {
              response.data.InvoiceTermValue = InvoiceTermObj[0].Term;
            } else if (element.InvoiceTerm === 0) {
              element.InvoiceTerm = null;
            }
            for (var docLoop = 0; docLoop < response.data.VendorDocumentModel.length; docLoop++) {
              var docEle = response.data.VendorDocumentModel[docLoop];
              var DocTypeObj = _.filter($scope.lookups.lstVdocType, function (v) {
                return _.includes([docEle.DocType], v.Id);
              });
              if (DocTypeObj.length > 0) {
                docEle.DocName = DocTypeObj[0].Type;
              }
            }

            var InvMethodObj = _.filter($scope.lookups.lstInvType, function (v) {
              return _.includes([element.InvMethod], v.InvoiceMethodId);
            });
            if (InvMethodObj.length > 0) {
              response.data.InvMethodValue = InvMethodObj[0].Type;
            } else if (element.InvMethod === 0) {
              element.InvMethod = null;
            }
            var payTermObj = _.filter($scope.lookups.lstPayTerm, function (v) {
              return _.includes([element.PayTerm], v.PayTermId);
            });
            if (payTermObj.length > 0) {
              element.PayTermValue = payTermObj[0].Term;
            } else if (element.VendorPayTerm === 0 || element.VendorPayTerm > 23) {
              element.PayTermValue = null;
            }
            if (response.data.VendorAddressInfo.length > 0) {
              for (var index = 0; index < response.data.VendorAddressInfo.length; index++) {
                var VendorAddressInfoArrEl = response.data.VendorAddressInfo[index];
                if (VendorAddressInfoArrEl.VendorAcctInfo !== null && VendorAddressInfoArrEl.VendorAcctInfo.length > 0) {
                  var _loop = function _loop(ind) {
                    var VendorAcctInfoArrEl = VendorAddressInfoArrEl.VendorAcctInfo[ind];
                    contactInfoObj = _.filter($scope.lookups.lstAcctType, function (v) {
                      return _.includes([VendorAcctInfoArrEl.Designation], v.DesgId);
                    });

                    if (contactInfoObj.length > 0) {
                      VendorAcctInfoArrEl.DesignationValue = contactInfoObj[0].Type;
                    }
                    if (VendorAddressInfoArrEl.VendorAcctInfo.length === ind + 1) {
                      $scope.pageLoader = false;
                    }
                  };

                  for (var ind = 0; ind < VendorAddressInfoArrEl.VendorAcctInfo.length; ind++) {
                    var contactInfoObj;

                    _loop(ind);
                  }
                } else {
                  $scope.pageLoader = false;
                }
              }
            } else {
              $scope.pageLoader = false;
            }

            // function LatestMSA(item) {
            //   if (item!==undefined&&item.DocType === 1)
            //     // response.data.VendorDocumentModel.splice(0, 0, item);
            //     return item;
            // }

            // function Aggrement(item) {
            //   if (item!==undefined&&item.DocType === 2) return item;
            // }
            // if (response.data.VendorDocumentModel.length > 0) {
            //   response.data.VendorDocumentModel.splice(0,0,response.data.VendorDocumentModel.find(Aggrement));
            //   $scope.hasAggrement = true;
            // }
            // if (response.data.VendorDocumentModel.length > 1) {
            //   response.data.VendorDocumentModel.splice(0,0,response.data.VendorDocumentModel.find(LatestMSA));
            //   $scope.hasMsa = true;
            // }
            $scope.vendorData = response.data;
            $scope.ClonedVendorData = JSON.parse(JSON.stringify(response.data));
            setTimeout(function () {
              resolve("success");
              //reject('error');
            }, 700);
            $(function () {
              $('[data-toggle="tooltip"]').tooltip();
            });
          }).catch(CatchError);
        }).catch(CatchError);
      });
    }

    $scope.$watch("dateFormat", function (newValue) {
      $scope.dateFormat2 = $filter("date")(newValue, "yyyy/MM/dd");
    });
    $scope.$watch("dateFormat2", function (newValue) {
      $scope.dateFormat = $filter("date")(newValue, "yyyy/MM/dd");
    });
    $scope.addVendorAddr = function (id) {
      $scope.addVendorAddrShow = true;
    };
    $scope.addVendorAddrCancel = function (id) {
      $scope.addVendorAddrShow = false;
    };
    $scope.editVendorCancel = function (i, Vendor) {
      $scope.vendorData.editable = false;
      $scope.vendorData = angular.copy($scope.ClonedVendorData);
    };
    $scope.editVendor = function (i, Vendor) {
      $scope.vendorData.editable = true;

      $(".datepicker").datepicker({
        changeMonth: true,
        changeYear: true,
        onSelect: function onSelect(dateText, inst) {
          var Els = document.getElementsByClassName("datepicker");
          var event = new Event("change");
          Array.from(Els).forEach(function (element, index, array) {
            element.dispatchEvent(event);
          });
        }
      });
    };
    $scope.editVendorSub = function (data, id, i) {
      $scope.editVendorSubLoader = true;
      var req = {
        VendorId: data.VendorId,
        VendorName: data.VendorName,
        PrimaryEmail: data.PrimaryEmail,
        Fax: data.Fax,
        AddendaInPlace: data.AddendaInPlace,
        AddendaPointsCovered: data.AddendaPointsCovered,
        AddendaSigDate: data.AddendaSigDate,
        ContractInPlace: data.ContractInPlace,
        ContractSignedDate: data.ContractSignedDate,
        VendorContactCell: data.VendorContactCell,
        EmergencyContactNumber: data.EmergencyContactNumber,
        VendorContactFullName: data.VendorContactFullName,
        Instructions: data.Instructions,
        InvMethod: data.InvMethod,
        PayTerm: parseInt(data.PayTerm),
        BillingCyle: parseInt(data.BillingCyle),
        FedId: data.FedId,
        InvoiceTerm: parseInt(data.InvoiceTerm)
      };
      dataService.newToken().then(function (response) {
        dataService.editvendor(req).then(function (response) {
          getVenDetails().then(function (response) {
            $scope.vendorData.editable = false;
            $scope.editVendorSubLoader = false;
          });
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.addnewAddrFormCancel = function (form) {
      $scope.showAddNewAddrForm = false;
      $scope.UVendorAdd = {};
      getVenDetails().then(function (response) {
        $scope.vendorData = angular.copy($scope.ClonedVendorData);
        // $scope.newVendorAddrForm.$setPristine = true;
        // $scope.newVendorAddrForm.$setPristine();
      });
    };
    $scope.addnewAddrForm = function () {
      $scope.UVendorAdd = {
        Country: undefined,
        City: undefined,
        Zipcode: undefined,
        State: undefined,
        Street: undefined
      };
      $scope.showAddNewAddrFormLaoder = true;
      $timeout(function () {
        $scope.showAddNewAddrFormLaoder = false;
        $scope.showAddNewAddrForm = true;
      }, 600);
    };
    $scope.editNewVendorCancel = function (i) {
      $scope.editSelectedAddr = false;
    };
    $scope.editVendorAddr = function (i, VendorAddr) {
      $scope.showAddNewAddrForm = true;
      $scope.UVendorAdd = VendorAddr;
    };
    $scope.editVendorAddrSub = function (form, data, i) {
      $scope.editVendorAddrSubLoader = true;
      if (data.AddrId) {
        dataService.newToken().then(function (response) {
          dataService.updatevendoraddress(data).then(function (response) {
            $scope.editVendorAddrSubLoader = false;
            $scope.showAddNewAddrForm = false;
            getVenDetails().then(function (response) {});
          });
        }).catch(CatchError);
      } else {
        var req = {
          VendorId: $scope.vendorData.VendorId,
          VendorName: $scope.vendorData.VendorName,
          VendorAddressInfo: [{
            Country: data.Country,
            City: data.City,
            Zipcode: data.Zipcode,
            State: data.State,
            Street: data.Street
          }]
        };
        dataService.newToken().then(function (response) {
          dataService.addvendoraddress(req).then(function (response) {
            $scope.editVendorAddrSubLoader = false;
            $scope.showAddNewAddrForm = false;
            getVenDetails().then(function (response) {
              var toast = $mdToast.simple().content(response.data.Message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
              $mdToast.show(toast);
            });
          });
        }).catch(CatchError);
      }
    };
    $scope.validateActEmail = function ($event, data) {
      if ($scope.emailFormat.test(data) === false) {
        $($event.currentTarget).popover("toggle");
      }
    };
    $scope.editvendorActCancel = function (i, data) {
      data.editable = false;
      $scope.vendorData = angular.copy($scope.ClonedVendorData);
    };
    $scope.AddNewVendorAct = function () {
      $scope.AddNewVendorActShow = true;
    };
    $scope.newVendorActCancel = function () {
      $scope.AddNewVendorActShow = false;
    };
    $scope.newVendorActSub = function (form, data) {
      var req = {
        AddrId: $scope.selectedVendorAddr.AddrId,
        VendorAcctInfo: [{
          ContactName: data.ContactName,
          Designation: data.Designation,
          AcctEmail: data.AcctEmail,
          PhoneNumber: data.PhoneNumber
        }]
      };
      dataService.newToken().then(function (response) {
        dataService.addvendorActInfo(req).then(function (response) {
          $scope.AddNewVendorActShow = false;
          getVenDetails().then(function (response) {
            $scope.VendConts = $scope.vendorData.VendorAddressInfo[$scope.selectedVendorAddrIndex].VendorAcctInfo;
          });
        });
      }).catch(CatchError);
    };
    $scope.editvendorAct = function (i, data) {
      $scope.editvendorActInfo = true;
      data.editable = true;
      $scope.ClonedVendorAct = JSON.parse(JSON.stringify(data));
      var phoneNext = data.PhoneNumber.split(" Extn: ");
      data.PhoneNumber = phoneNext[0];
      data.Extn = phoneNext[1];
      $scope.vendorAct = data;
    };
    $scope.vendorActInfoSub = function (data) {
      if (data.Extn) {
        data.PhoneNumber = data.PhoneNumber + " Extn: " + data.Extn;
      }
      if (data.VendorAddrMapId) {
        dataService.newToken().then(function (response) {
          dataService.editvendorActInfo(data).then(function (response) {
            getVenDetails().then(function (response) {
              var toast = $mdToast.simple().content("Contact Updated Succcessfully").action("OK").highlightAction(false).position("top center").hideDelay(3000);
              $mdToast.show(toast);
              data.editable = false;
            });
          });
        }).catch(CatchError);
      } else {
        dataService.newToken().then(function (response) {
          dataService.addvendorActInfo(data).then(function (response) {
            getVenDetails().then(function (response) {});
          });
        }).catch(CatchError);
      }
    };
    $scope.getVenConts = function (data, i) {
      $().tooltip({
        template: '<div class="tooltip CUSTOM-CLASS" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
      });
      $scope.showAddNewAddrForm = false;
      $scope.selectedVendorAddr = data;
      $scope.selectedVendorAddrIndex = i;
      $scope.ViewContsLoader = true;
      $scope.ViewContsLoader = false;
      $scope.ViewConts = true;

      $scope.ClonedVendConts = JSON.parse(JSON.stringify(data.VendorAcctInfo));
      $scope.VendConts = data.VendorAcctInfo;
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    };
    $scope.selDocChange = function () {
      if ($scope.selectedDocType == "") {
        $scope.selectedDocType = null;
      }
    };
    $scope.getFileDetails = function (e) {
      if (re.exec(e.files[0].name)[1] === "doc" || re.exec(e.files[0].name)[1] === "docx" || re.exec(e.files[0].name)[1] === "pdf") {
        $scope.upFiles = e;
        $scope.files = [];
        $scope.$apply(function () {
          for (var i = 0; i < e.files.length; i++) {
            $scope.files.push(e.files[i]);
          }
        });
      } else {
        $("#invalidFileTypeAlertDiv").modal("show");
      }
    };
    $scope.uploadDoc = function (id) {
      if (!$scope.files.length) {
        $("#nofileErrModal").modal("show");
      } else {

        $scope.uploadLoader = true;
        var data = new FormData();
        data.append("vendorId", $scope.vendorData.VendorId);
        data.append("docId", id);
        data.append("creatorId", parseInt(tokenData.loginid));
        data.append("file", $scope.files[0]);
        dataService.newToken().then(function (response) {
          dataService.UploadVendorDocument(data).then(function (response) {
            $scope.uploadLoader = false;
            getVenDetails().then(function (response) {
              $scope.vendorData = angular.copy($scope.ClonedVendorData);
              $scope.selectedDocType = null;
              $scope.files = null;
            });
          }).catch(CatchError);
        }).catch(CatchError);
      }
    };
    $scope.getDoc = function (params) {
      dataService.newToken().then(function (response) {
        dataService.getAgreementDocs({
          VendorDocId: params.VendorDocId,
          DocUrl: params.DocUrl,
          VendorId: params.VendorId
        }).then(function (response) {
          var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
            return data + String.fromCharCode(byte);
          }, ""));
          var anchor = $("<a/>");
          anchor.attr({
            href: "data:application/octet-stream; base64," + base64,
            target: "_blank",
            download: params.DocUrl
          })[0].click();
        });
      }).catch(CatchError);
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("projects", {
    controller: projectsController,
    controllerAs: "vm",
    templateUrl: "app/components/hr/Projects/projects.html"
  });

  function projectsController($scope, dataService, $location, $http, $mdToast, $timeout, $q, $mdSelect, $mdDialog, $rootScope, moment, $stateParams, $state) {
    var tokenData = angular.fromJson(localStorage.getItem("tokenData"));
    $scope.role = tokenData.role;
    $scope.loginLoader = true;
    var heightCanBe = window.innerHeight - 100 + "px";
    $(".heightCanBe").css("height", heightCanBe);
    var ListHeightCanBe = window.innerHeight - 201 + "px";
    $(".ListHeightCanBe").css("height", ListHeightCanBe);
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 100 + "px";
      $(".heightCanBe").css("height", heightCanBe);
      var ListHeightCanBe = window.innerHeight - 201 + "px";
      $(".ListHeightCanBe").css("height", ListHeightCanBe);
    });
    $scope.newProjectDetails = {};
    $scope.newProjectDetails.ClientModel = {};
    $scope.newProjectDetails.ClientModel.ClientAddressInfo = [{
      AddrId: null
    }];
    var re = /(?:\.([^.]+))?$/;
    $scope.files = [];

    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };

    function async($q) {
      return $q.all([dataService.xreflkup(), dataService.GetTitleDD()]);
    }
    dataService.newToken().then(function (response) {
      async($q).then(function (response) {
        $scope.lookups = response[0].data;
        $scope.titles = response[1].data;
        initData().then(function () {
          dataService.newToken().then(function (response) {
            dataService.GetPOUrlsByProjId({
              projid: $scope.ProjectDetails.ProjectID
            }).then(function (response) {
              $scope.POS = response.data;
            });
          }).catch(CatchError);
        });;
      });
    }).catch(CatchError);

    function initData() {
      return new Promise(function (resolve, reject) {
        dataService.newToken().then(function (response) {
          dataService.ProjCodesByPrfid({
            EmpId: $stateParams.id
          }).then(function (response) {
            $scope.userData = response.data;

            $scope.userData.EmpId = $stateParams.id;

            if ($scope.userData.LstProjCodes !== null) {
              var DeignationObj = _.filter($scope.lookups.lstAcctType, function (v) {
                return _.includes([$scope.userData.LstProjCodes[0].AcctDesg], v.DesgId);
              });
              if (DeignationObj.length > 0) {
                $scope.userData.LstProjCodes[0].DesignationValue = DeignationObj[0].Type;
              }
              var payTermObj = _.filter($scope.lookups.lstPayTerm, function (v) {
                return _.includes([$scope.userData.LstProjCodes[0].VendorPayTerm], v.PayTermId);
              });
              if (payTermObj.length > 0) {
                $scope.userData.LstProjCodes[0].PayTermValue = payTermObj[0].Term;
              }

              var InvoiceTermObj = _.filter($scope.lookups.lstInvTerm, function (v) {
                return _.includes([$scope.userData.LstProjCodes[0].InvTermId], v.InvTermId);
              });
              if (InvoiceTermObj.length > 0) {
                $scope.userData.LstProjCodes[0].InvoiceTermValue = InvoiceTermObj[0].Term;
              }

              var TitleObj = _.filter($scope.titles, function (v) {
                return _.includes([$scope.userData.LstProjCodes[0].TitleId], v.TitleId);
              });
              if (TitleObj.length > 0) {
                $scope.userData.LstProjCodes[0].Title = TitleObj[0].Title;
              }

              $scope.tokenData = angular.fromJson(localStorage.getItem("tokenData"));
              $scope.userData.LstProjCodes[0].ProjectStartDate = moment($scope.userData.LstProjCodes[0].ProjectStartDate).format("MM/DD/YYYY");
              if ($scope.userData.LstProjCodes[0].ProjectEndDate !== null) {
                $scope.userData.LstProjCodes[0].ProjectEndDate = moment($scope.userData.LstProjCodes[0].ProjectEndDate).format("MM/DD/YYYY");
              }
              $scope.ProjectDetails = $scope.userData.LstProjCodes[0];
              $scope.selectedProjIndex = 0;
              getVenDetails($scope.ProjectDetails).then(function (response) {
                for (var index = 0; index < response.VendorAddressInfo.length; index++) {
                  var element = response.VendorAddressInfo[index];
                  if ($scope.ProjectDetails.VendorAddrId === element.AddrId) {
                    $scope.contacts = element.VendorAcctInfo;
                    $timeout(function () {
                      $scope.contactsReady = true;
                    });
                  }
                }
              });
              $scope.loginLoader = false;
            } else {
              $scope.ProjectDetails = null;
            }
            $timeout(function () {
              resolve();
            });
            $scope.loginLoader = false;
          }).catch(CatchError);
        }).catch(CatchError);
      });
    }
    $scope.ngShowhidemethod = function (data) {
      $scope.minEndate = new Date(data.ProjectStartDate);
      $("#assignProEndDate").modal("show");
      $scope.ProjectEnd = {
        ProjectEndDate: null
      };
    };
    $scope.ngShowhidemethodCancel = function (data) {
      $("#assignProEndDate").modal("hide");
    };
    $scope.ProjectDetailsSubmit = function (data, ProjectDetails) {
      var vendorId;
      data.ProjectCompleted = !data.ProjectCompleted;

      dataService.newToken().then(function (response) {
        dataService.GetTitleDD().then(function (response) {
          $scope.titles = response.data;
          TitleId;
          var TitleObj = _.filter($scope.titles, function (v) {
            return _.includes([ProjectDetails.TitleId], v.TitleId);
          });
          if (TitleObj.length > 0) {
            data.Title = TitleObj[0].Title;
          }
          var obj = {
            ProjId: $scope.ProjectDetails.ProjectID,
            EndDate: data.ProjectEndDate
          };
          bootbox.prompt({
            title: "Confirm Notifications",
            centerVertical: true,
            message: "<p>Do you want to send notification email to Accounts/Admin:</p>",
            inputType: "radio",
            inputOptions: [{
              text: "No, I do not want to Notify.",
              value: false
            }, {
              text: "Yes, Notify them all.",
              value: true
            }],
            callback: function callback(result) {
              if (result === null) {
                $("#assignProEndDate").modal("hide");
                return;
              } else {
                if (result === "true") {
                  obj.EmailContent = {
                    Subject: "CONSULTANT: OFF PROJECT | " + $scope.userData.LstProjCodes[0].FirstName + " " + $scope.userData.LstProjCodes[0].LastName + " | TeXperts Inc.",
                    Body: '<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\r\n  <meta charset="utf-8">\r\n  <meta http-equiv="x-ua-compatible" content="ie=edge">\r\n  <title>Email Receipt</title>\r\n  <meta name="viewport" content="width=device-width, initial-scale=1">\r\n  <style type="text/css">\r\n  /**\r\n   * Google webfonts. Recommended to include the .woff version for cross-client compatibility.\r\n   */\r\n  @media screen {\r\n    @font-face {\r\n      font-family: \'Source Sans Pro\';\r\n      font-style: normal;\r\n      font-weight: 400;\r\n      src: local(\'Source Sans Pro Regular\'), local(\'SourceSansPro-Regular\'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/ODelI1aHBYDBqgeIAH2zlBM0YzuT7MdOe03otPbuUS0.woff) format(\'woff\');\r\n    }\r\n\r\n    @font-face {\r\n      font-family: \'Source Sans Pro\';\r\n      font-style: normal;\r\n      font-weight: 700;\r\n      src: local(\'Source Sans Pro Bold\'), local(\'SourceSansPro-Bold\'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/toadOcfmlt9b38dHJxOBGFkQc6VGVFSmCnC_l7QZG60.woff) format(\'woff\');\r\n    }\r\n  }\r\n\r\n  /**\r\n   * Avoid browser level font resizing.\r\n   * 1. Windows Mobile\r\n   * 2. iOS / OSX\r\n   */\r\n  body,\r\n  table,\r\n  td,\r\n  a {\r\n    -ms-text-size-adjust: 100%; /* 1 */\r\n    -webkit-text-size-adjust: 100%; /* 2 */\r\n  }\r\n\r\n  /**\r\n   * Remove extra space added to tables and cells in Outlook.\r\n   */\r\n  table,\r\n  td {\r\n    mso-table-rspace: 0pt;\r\n    mso-table-lspace: 0pt;\r\n  }\r\n\r\n  /**\r\n   * Better fluid images in Internet Explorer.\r\n   */\r\n  img {\r\n    -ms-interpolation-mode: bicubic;\r\n  }\r\n\r\n  /**\r\n   * Remove blue links for iOS devices.\r\n   */\r\n  a[x-apple-data-detectors] {\r\n    font-family: inherit !important;\r\n    font-size: inherit !important;\r\n    font-weight: inherit !important;\r\n    line-height: inherit !important;\r\n    color: inherit !important;\r\n    text-decoration: none !important;\r\n  }\r\n\r\n  /**\r\n   * Fix centering issues in Android 4.4.\r\n   */\r\n  div[style*="margin: 16px 0;"] {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  body {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  /**\r\n   * Collapse table borders to avoid space between cells.\r\n   */\r\n  table {\r\n    border-collapse: collapse !important;\r\n  }\r\n\r\n  a {\r\n    color: #1a82e2;\r\n  }\r\n\r\n  img {\r\n    height: auto;\r\n    line-height: 100%;\r\n    text-decoration: none;\r\n    border: 0;\r\n    outline: none;\r\n  }\r\n  </style>\r\n\r\n</head>\r\n<body style="background-color: #ffffff;">\r\n\r\n  <!-- start preheader -->\r\n  <div class="preheader" style="display: none; max-width: 0; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: #fff; opacity: 0;">\r\n    Texperts Inc\r\n  </div>\r\n  <!-- end preheader -->\r\n\r\n  <!-- start body -->\r\n  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 300px;">\r\n    <!-- start hero -->\r\n    <tr>\r\n      <td align="center" bgcolor="#ffffff">\r\n<!--[if (gte mso 9)|(IE)]>\r\n<table align="center" border="0" cellpadding="0" cellspacing="0" width="600">\r\n<tr>\r\n<td align="center" valign="top" width="600">\r\n<![endif]-->\r\n<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">\r\n  <tr>\r\n    <td align="center" style="padding: 16px 24px 0; font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; border-top: 3px solid #394b3f;">\r\n      <h1 style="margin: 0;font-size: 48px;font-weight: 700;letter-spacing: -1px;line-height: 48px;color: #394b3f;">OFF PROJECT EMAIL</h1>\r\n    </td>\r\n  </tr>\r\n</table>\r\n<!--[if (gte mso 9)|(IE)]>\r\n</td>\r\n</tr>\r\n</table>\r\n<![endif]-->\r\n      </td>\r\n    </tr>\r\n    <!-- end hero -->\r\n\r\n    <!-- start copy block -->\r\n    <tr>\r\n      <td align="center" bgcolor="#ffffff">\r\n<!--[if (gte mso 9)|(IE)]>\r\n<table align="center" border="0" cellpadding="0" cellspacing="0" width="600">\r\n<tr>\r\n<td align="center" valign="top" width="600">\r\n<![endif]-->\r\n<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">\r\n\r\n  <!-- start copy -->\r\n  <tr>\r\n    <td align="left" style="padding-top: 30px; font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">\r\n    <table border="1" cellpadding="0" cellspacing="0" width="100%" bgcolor="#394b3f" style="color:#ffffff;">\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Marketer</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + ProjectDetails.MarkterName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Pay Roll  Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">teXperts, Inc</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Last Name</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + $scope.userData.LstProjCodes[0].LastName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant First Name</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + $scope.userData.LstProjCodes[0].FirstName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Phone</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">n/a</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Email</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"> <a href="mailto:' + ProjectDetails.UserName + '" target="_blank" style="color: rgb(0, 161, 255)">' + ProjectDetails.UserName + '</a></td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Skills</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + data.Title + "</td>\r\n</tr>\r\n<tr>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\"><strong>Mid \u2013 Client, State</strong></td>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\">" + ProjectDetails.VendorCompanyName + ", " + ProjectDetails.VendorCompanyCity + ", " + ProjectDetails.VendorState + "</td>\r\n</tr>\r\n<tr>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\"><strong>End \u2013 Client, City, State</strong></td>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\">" + ProjectDetails.ClientName + ", " + ProjectDetails.ClientState + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Project End Date</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + moment(data.ProjectEndDate).format("MM/DD/YYYY") + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Billing Rate to Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">$' + ProjectDetails.HourlyRate + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Start Date</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + moment(ProjectDetails.ProjectStartDate).format("MM/DD/YYYY") + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Billing Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">teXperts Inc</td>\r\n</tr>\r\n       \r\n    </table>\r\n    </td>\r\n  </tr>\r\n</table>\r\n<!--[if (gte mso 9)|(IE)]>\r\n</td>\r\n</tr>\r\n</table>\r\n<![endif]-->\r\n      </td>\r\n    </tr>\r\n    <!-- end copy block -->\r\n  </table>\r\n  <!-- end body -->\r\n\r\n</body>\r\n</html>'
                  };
                }

                dataService.newToken().then(function (response) {
                  dataService.UpdateProjInfo(obj).then(function (response) {
                    if (response.statusText == "OK") {
                      $scope.ProjectDetails.ProjectEndDate = data.ProjectEndDate;
                      $scope.projectEndDateReq = true;
                      $timeout(function () {
                        $("#assignProEndDate").modal("hide");
                        $scope.notifier = false;
                        $scope.projectEndDateReq = false;
                      });
                    }
                  }).catch(CatchError);
                }).catch(CatchError);
              }
            }
          });
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.userStatusUpdate = function (data, status) {
      var obj = {
        loginid: data.loginid,
        EnableUser: status
      };

      dataService.newToken().then(function (response) {
        dataService.removeuser(obj).then(function (response) {
          $scope.userProfileData.EnableUser = status;
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.setProjectDetails = function (data, index) {
      $scope.payRateHistoryData = false;
      // if ($scope.selectedProj === null) {
      //   $scope.selectedProj = index;
      // } else if ($scope.selectedProj === index) {
      //   $scope.selectedProj = null;
      // } else {
      //   $scope.selectedProj = index;
      // }
      $scope.selectedProj = index;
      $scope.selectedProjIndex = index;

      var DeignationObj = _.filter($scope.lookups.lstAcctType, function (v) {
        return _.includes([data.AcctDesg], v.DesgId);
      });
      if (DeignationObj.length > 0) {
        data.DesignationValue = DeignationObj[0].Type;
      }
      var payTermObj = _.filter($scope.lookups.lstPayTerm, function (v) {
        return _.includes([data.VendorPayTerm], v.PayTermId);
      });
      if (payTermObj.length > 0) {
        data.PayTermValue = payTermObj[0].Term;
      }

      var TitleObj = _.filter($scope.titles, function (v) {
        return _.includes([data.TitleId], v.TitleId);
      });
      if (TitleObj.length > 0) {
        data.Title = TitleObj[0].Title;
      }
      var InvoiceTermObj = _.filter($scope.lookups.lstInvTerm, function (v) {
        return _.includes([data.InvTermId], v.InvTermId);
      });
      if (InvoiceTermObj.length > 0) {
        data.InvoiceTermValue = InvoiceTermObj[0].Term;
      }
      if (data.AcctDesg === null) {
        dataService.newToken().then(function (response) {
          getVenDetails(data).then(function (response) {
            for (var _index = 0; _index < response.VendorAddressInfo.length; _index++) {
              var element = response.VendorAddressInfo[_index];
              if (data.VendorAddrId === element.AddrId) {
                $scope.contacts = element.VendorAcctInfo;
                $timeout(function () {
                  $scope.contactsReady = true;
                });
              }
            }
          });
        }).catch(CatchError);
      }
      data.ProjectStartDate = moment(data.ProjectStartDate).format("MM/DD/YYYY");
      if (data.ProjectEndDate !== null) {
        data.ProjectEndDate = moment(data.ProjectEndDate).format("MM/DD/YYYY");
      }
      $scope.ProjectDetails = data;
      dataService.newToken().then(function (response) {
        dataService.GetPOUrlsByProjId({
          projid: $scope.ProjectDetails.ProjectID
        }).then(function (response) {
          $scope.POS = response.data;
        });
      }).catch(CatchError);
    };
    function loadData($q) {
      var promiseClients = dataService.GetClientsInfo();
      var promiseVendors = dataService.GetVendorInfo();
      var promiseMarketers = dataService.GetMarketerInfo();
      var promiseTitles = dataService.GetTitleDD();

      return $q.all([promiseClients, promiseVendors, promiseMarketers, promiseTitles]);
    }
    $scope.newProjectemethodCancel = function () {
      $scope.newProjectDetails = $scope.newProjectDetailsCopy;
      $scope.newProject = false;
    };
    $scope.newProjectemethod = function (flag) {
      $scope.projectCreateStart = false;
      $scope.projectCreateMessage = false;
      $scope.newProjectDetails = {};
      $scope.newProjectDetails.ClientModel = {};
      $scope.newProjectDetails.ClientModel.ClientAddressInfo = [{
        AddrId: null
      }];

      $scope.newProjectDetailsCopy = angular.copy($scope.newProjectDetails);
      dataService.newToken().then(function (response) {
        loadData($q).then(function (resp) {
          $scope.Clients = _.orderBy(resp[0].data, ["ClientName"], ["asc"]);
          $scope.Vendors = _.orderBy(resp[1].data, ["VendorName"], ["asc"]);
          $scope.Marketers = resp[2].data;
          $scope.titles = resp[3].data;
          $scope.dataLoaded = true;
          $(".datepicker").datepicker({
            changeMonth: true,
            changeYear: true,
            onSelect: function onSelect(dateText, inst) {
              var Els = document.getElementsByClassName("datepicker");
              var event = new Event("change");
              Array.from(Els).forEach(function (element, index, array) {
                element.dispatchEvent(event);
              });
            }
          });
        });
      }).catch(CatchError);
      $scope.newProject = true;
    };
    $scope.addTitle = function () {
      $mdSelect.hide();
      $mdDialog.show({
        controller: addTitleDialogController,
        templateUrl: "app/components/hr/createUser/addTitleDialog.html",
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = "You cancelled the dialog.";
      });

      function addTitleDialogController($scope) {
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
        $scope.addTitleSubmit = function (data) {
          $scope.notifier = true;

          dataService.newToken().then(function (response) {
            dataService.AddTitle(data).then(function (response) {
              if (response.data == "Title Added Sucessfully!.") {
                dataService.newToken().then(function (response) {
                  dataService.GetTitleDD().then(function (response) {
                    $rootScope.$broadcast("titles", response.data);
                    $mdDialog.cancel();
                  }).catch(CatchError);
                }).catch(CatchError);
              } else {
                var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
                $mdToast.show(toast);
                $mdDialog.cancel();
              }
            }).catch(CatchError);
          }).catch(CatchError);
        };
      }
      $scope.$on("titles", function (evt, data) {
        $scope.titles = data;
      });
    };
    $scope.addmarketer = function addmarketer(flag) {
      $mdSelect.hide();
      if (flag) {
        $scope.addMarketerShow = false;
      } else {
        $scope.addMarketerShow = true;
      }
    };
    $scope.addMarketerData = function (MarketerData) {
      $mdSelect.hide();
      $scope.notifier = true;

      dataService.newToken().then(function (response) {
        dataService.addmarketer(MarketerData).then(function (response) {
          self.marketerInfo = response.data;
          if (response.statusText == "OK") {
            dataService.newToken().then(function (response) {
              dataService.GetMarketerInfo().then(function (response) {
                $scope.Marketers = response.data;
                $scope.afterAddedMarketer = true;
                $timeout(function () {
                  $scope.addMarketerShow = false;
                  $scope.notifier = false;
                }, 1500);
              }).catch(CatchError);
            }).catch(CatchError);;
          } else {
            var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
            $mdToast.show(toast);
            $mdDialog.cancel();
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.getClientAddr = function (client) {

      dataService.newToken().then(function (response) {
        dataService.GetClientInfoByClientId({
          ClientId: client
        }).then(function (response) {
          $scope.selectedClientAddresses = response.data.ClientAddress;
        });
      }).catch(CatchError);
    };
    $scope.getVendorAddr = function (id) {

      dataService.newToken().then(function (response) {
        dataService.GetVendorInfoByVendorId({
          VendorId: id
        }).then(function (response) {
          $scope.selectedVendorAddresses = response.data.VendorAddressInfo;
        });
      }).catch(CatchError);
    };
    $scope.getVendContacts = function (id) {
      if (id === undefined) {
        $scope.VendContacts = null;
        return;
      }
      for (var ind = 0; ind < $scope.selectedVendorAddresses.length; ind++) {
        var VendorAcctInfoArrEl = $scope.selectedVendorAddresses[ind];
        if (id == VendorAcctInfoArrEl.AddrId) {
          var _loop = function _loop(index) {
            var element = VendorAcctInfoArrEl.VendorAcctInfo[index];

            contactInfoObj = _.filter($scope.lookups.lstAcctType, function (v) {
              return _.includes([element.Designation], v.DesgId);
            });

            if (contactInfoObj.length > 0) {
              element.DesignationValue = contactInfoObj[0].Type;
            }
            $scope.VendContacts = VendorAcctInfoArrEl.VendorAcctInfo;
          };

          for (var index = 0; index < VendorAcctInfoArrEl.VendorAcctInfo.length; index++) {
            var contactInfoObj;

            _loop(index);
          }
        }
      }
    };
    $scope.payRateHistoryReq = function (ProjId) {
      $scope.payRateHistoryspinner = true;
      var obj = {
        ProjId: ProjId
      };

      dataService.newToken().then(function (response) {
        dataService.BillhistbyProjid(obj).then(function (response) {
          $scope.payRateHistory = response.data;
          $scope.payRateHistoryData = true;
        }).catch(CatchError);
      }).catch(CatchError);
    };
    function getVenDetails(data) {
      return new Promise(function (resolve, reject) {
        dataService.GetVendorInfoByVendorId({
          VendorId: data.VendorId
        }).then(function (response) {
          var _loop2 = function _loop2(o) {
            var element = response.data.VendorDocumentModel[o];
            vendocId = _.filter($scope.lookups.lstVdocType, function (v) {
              return _.includes([element.DocType], v.Id);
            });

            if (vendocId.length > 0) {
              element.DocValue = vendocId[0].Type;
            }
          };

          for (var o = 0; o < response.data.VendorDocumentModel.length; o++) {
            var vendocId;

            _loop2(o);
          }
          var element = response.data;
          var InvoiceTermObj = _.filter($scope.lookups.lstInvTerm, function (v) {
            return _.includes([element.InvoiceTerm], v.InvTermId);
          });
          if (InvoiceTermObj.length > 0) {
            response.data.InvoiceTermValue = InvoiceTermObj[0].Term;
          }
          var InvMethodObj = _.filter($scope.lookups.lstInvType, function (v) {
            return _.includes([element.InvMethod], v.InvoiceMethodId);
          });
          if (InvMethodObj.length > 0) {
            response.data.InvMethodValue = InvMethodObj[0].Type;
          }
          if (response.data.VendorAddressInfo.length > 0) {
            for (var index = 0; index < response.data.VendorAddressInfo.length; index++) {
              var VendorAddressInfoArrEl = response.data.VendorAddressInfo[index];
              if (VendorAddressInfoArrEl.VendorAcctInfo !== null && VendorAddressInfoArrEl.VendorAcctInfo.length > 0) {
                var _loop3 = function _loop3(ind) {
                  var VendorAcctInfoArrEl = VendorAddressInfoArrEl.VendorAcctInfo[ind];
                  contactInfoObj = _.filter($scope.lookups.lstAcctType, function (v) {
                    return _.includes([VendorAcctInfoArrEl.Designation], v.DesgId);
                  });

                  if (contactInfoObj.length > 0) {
                    VendorAcctInfoArrEl.DesignationValue = contactInfoObj[0].Type;
                  }
                  if (VendorAddressInfoArrEl.VendorAcctInfo.length === ind + 1) {
                    $scope.pageLoader = false;
                  }
                };

                for (var ind = 0; ind < VendorAddressInfoArrEl.VendorAcctInfo.length; ind++) {
                  var contactInfoObj;

                  _loop3(ind);
                }
              } else {
                $scope.pageLoader = false;
              }
            }
          } else {
            $scope.pageLoader = false;
          }
          var payTermObj = _.filter($scope.lookups.lstPayTerm, function (v) {
            return _.includes([$scope.userData.LstProjCodes[0].VendorPayTerm], v.PayTermId);
          });
          if (payTermObj.length > 0) {
            $scope.userData.LstProjCodes[0].PayTermValue = payTermObj[0].Term;
          }

          $scope.vendorData = response.data;
          $scope.ClonedVendorData = JSON.parse(JSON.stringify(response.data));
          $timeout(function () {
            resolve($scope.vendorData);
          });
        }).catch(CatchError);
      });
    }
    $scope.updateInvoicingContactSub = function (data, selectedProjIndex) {
      $scope.updateInvoicingContactSubLoader = true;
      var req = {
        ProjId: $scope.ProjectDetails.ProjectID,
        loginid: tokenData.loginid,
        vendorModel: {
          VendorId: $scope.ProjectDetails.VendorId,
          VendorAddressInfo: [{
            AddrId: $scope.ProjectDetails.VendorAddrId,
            VendorAcctInfo: [{
              VendorAddrMapId: data.VendorAddrMapId
            }]
          }],
          PayTerm: data.PayTermId
        },
        Prfid: $scope.ProjectDetails.Prfid
      };

      dataService.newToken().then(function (response) {
        dataService.UpdateProjInfo(req).then(function () {
          initData().then(function (response) {
            $scope.setProjectDetails($scope.userData.LstProjCodes[selectedProjIndex], selectedProjIndex);
            $scope.updateInvoicingContactSubLoader = false;
          });
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.saveAsDraft = function (fData) {
      localStorage.setItem("newProjectDetails", JSON.stringify(fData));
      $("#draftSavedAlert").modal("show");
    };
    $scope.generateAdvice = function (id) {

      dataService.newToken().then(function (response) {
        dataService.GetBillingAdviceInfo({
          ProjId: id
        }).then(function (response) {
          var lstInvTerm = _.filter($scope.lookups.lstInvTerm, function (v) {
            return _.includes([response.data.InvTermId], v.InvTermId);
          });
          if (lstInvTerm.length > 0) {
            response.data.InvTermId = lstInvTerm[0].Term;
          }
          var lstInvType = _.filter($scope.lookups.lstInvType, function (v) {
            return _.includes([response.data.InvMethod], v.InvoiceMethodId);
          });
          if (lstInvType.length > 0) {
            response.data.InvMethod = lstInvType[0].Type;
          }
          var lstPayTerm = _.filter($scope.lookups.lstPayTerm, function (v) {
            return _.includes([response.data.VendorPayTerm], v.PayTermId);
          });
          if (lstPayTerm.length > 0) {
            response.data.VendorPayTerm = lstPayTerm[0].Term;
          }
          var lstAcctType = _.filter($scope.lookups.lstAcctType, function (v) {
            return _.includes([response.data.AcctDesg], v.DesgId);
          });
          if (lstAcctType.length > 0) {
            response.data.AcctDesg = lstAcctType[0].Type;
          }

          $scope.adviceData = response.data;
          $("#adviceDataModal").modal("show");
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.downloadInvoice = function (data) {
      $("#PDFDwLoader").modal("show");
      var filename = data.FirstName + "-" + data.LastName + ".pdf";

      html2canvas(document.querySelector("#advice"), {
        scale: 2,
        dpi: 144,
        allowTaint: false,
        useCORS: true
      }).then(function (canvas) {
        var width = $("#advice").width();
        var height = $("#advice").height();
        var pdf = new jsPDF({
          orientation: "l",
          unit: "px",
          format: [width * 1.6, height * 1.6],
          compress: false
        });
        pdf.addImage(canvas.toDataURL("image/png"), "PNG", 20, 10);
        pdf.save(filename, {
          returnPromise: true
        }).then(function () {
          $timeout(function () {
            $("#PDFDwLoader").modal("hide");
          }, 2000);
        });
      });
    };
    $scope.editProjCodeCancel = function () {
      $scope.ProjEditable = false;
      $scope.ProjectDetails = $scope.editProjCodeCopy;
    };
    $scope.editProjCode = function (ProjectDetails) {
      var copyProjectDetails = angular.copy($scope.ProjectDetails);
      $scope.editProjCodeCopy = angular.copy($scope.ProjectDetails);
      $scope.editProjCodeLoader = true;
      copyProjectDetails.StartDate = moment(copyProjectDetails.StartDate).format("MM/DD/YYYY");
      dataService.newToken().then(function (response) {
        loadData($q).then(function (resp) {
          $scope.Clients = _.orderBy(resp[0].data, ["ClientName"], ["asc"]);
          $scope.Vendors = _.orderBy(resp[1].data, ["VendorName"], ["asc"]);
          $scope.Marketers = resp[2].data;
          $scope.titles = resp[3].data;
          dataService.newToken().then(function (response) {
            dataService.GetClientInfoByClientId({
              ClientId: copyProjectDetails.ClientId
            }).then(function (response) {
              $scope.selectedClient = response.data;
              $scope.selectedClientAddresses = response.data.ClientAddress;
              dataService.newToken().then(function (response) {
                dataService.GetVendorInfoByVendorId({
                  VendorId: copyProjectDetails.VendorId
                }).then(function (response) {
                  $scope.selectedVendor = response.data;
                  $scope.selectedVendorAddresses = response.data.VendorAddressInfo;
                  for (var ind = 0; ind < $scope.selectedVendorAddresses.length; ind++) {
                    var _VendorAcctInfoArrEl = $scope.selectedVendorAddresses[ind];
                    if (copyProjectDetails.VendorAddrId == _VendorAcctInfoArrEl.AddrId && _VendorAcctInfoArrEl.VendorAcctInfo !== null) {
                      var _loop4 = function _loop4(index) {
                        var element = _VendorAcctInfoArrEl.VendorAcctInfo[index];

                        contactInfoObj = _.filter($scope.lookups.lstAcctType, function (v) {
                          return _.includes([element.Designation], v.DesgId);
                        });

                        if (contactInfoObj.length > 0) {
                          element.DesignationValue = contactInfoObj[0].Type;
                        }
                        $scope.VendContacts = _VendorAcctInfoArrEl.VendorAcctInfo;
                      };

                      for (var index = 0; index < _VendorAcctInfoArrEl.VendorAcctInfo.length; index++) {
                        var contactInfoObj;

                        _loop4(index);
                      }
                    }
                  }
                  $scope.ProjectDetailsData = copyProjectDetails;
                  $scope.ProjEditable = true;
                  $scope.editProjCodeLoader = false;
                  $(".datepicker").datepicker({
                    changeMonth: true,
                    changeYear: true,
                    onSelect: function onSelect(dateText, inst) {
                      var Els = document.getElementsByClassName("datepicker");
                      var event = new Event("change");
                      Array.from(Els).forEach(function (element, index, array) {
                        element.dispatchEvent(event);
                      });
                    }
                  });
                });
              }).catch(CatchError);
            });
          }).catch(CatchError);
        });
      }).catch(CatchError);
    };
    $scope.newProjectDetailsSubmit = function (data) {
      $scope.projectCreateStart = true;
      var reqObj = {
        RefByNAME: data.RefByNAME,
        BillRate: data.BillRate,
        StartDate: data.StartDate,
        MarkterId: data.Markter.MarketerId,
        prfid: $scope.ProjectDetails.Prfid,
        loggedinuserid: $scope.tokenData.loginid,
        ClientModel: {
          ClientId: data.ClientModel.Client.ClientId,
          ClientAddressInfo: [{
            AddrId: data.ClientModel.ClientAddressInfo[0].Addr.AddrId
          }]
        },
        VendorModel: {
          VendorId: data.VendorModel.Vendor.VendorId,
          PayTerm: data.VendorModel.PayTerm,
          InvoiceTerm: data.VendorModel.InvoiceTerm,
          VendorAddressInfo: [{
            AddrId: data.VendorModel.VendorAddressInfo[0].Addr.AddrId,
            VendorAcctInfo: [{
              VendorAddrMapId: data.VendorModel.VendorAddressInfo[0].VendorAcctInfo[0].VendorAddrMapId
            }]
          }]
        },
        TitleId: data.Title.TitleId
      };
      bootbox.prompt({
        title: "Confirm Notifications",
        centerVertical: true,
        message: "<p>Do you want to send notification email to Accounts/Admin:</p>",
        inputType: "radio",
        inputOptions: [{
          text: "No, I do not want to Notify.",
          value: false
        }, {
          text: "Yes, Notify them all.",
          value: true
        }],
        callback: function callback(result) {
          if (result === null) {
            $scope.$apply(function () {
              $scope.projectCreateStart = false;
            });
          } else {
            if (result === "true") {
              reqObj.EmailContent = {
                Subject: "CONSULTANT: NEW PROJECT START | " + $scope.userData.LstProjCodes[0].FirstName + " " + $scope.userData.LstProjCodes[0].LastName + " | TeXperts Inc.",
                Body: '<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\r\n  <meta charset="utf-8">\r\n  <meta http-equiv="x-ua-compatible" content="ie=edge">\r\n  <title>Email Receipt</title>\r\n  <meta name="viewport" content="width=device-width, initial-scale=1">\r\n  <style type="text/css">\r\n  /**\r\n   * Google webfonts. Recommended to include the .woff version for cross-client compatibility.\r\n   */\r\n  @media screen {\r\n    @font-face {\r\n      font-family: \'Source Sans Pro\';\r\n      font-style: normal;\r\n      font-weight: 400;\r\n      src: local(\'Source Sans Pro Regular\'), local(\'SourceSansPro-Regular\'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/ODelI1aHBYDBqgeIAH2zlBM0YzuT7MdOe03otPbuUS0.woff) format(\'woff\');\r\n    }\r\n\r\n    @font-face {\r\n      font-family: \'Source Sans Pro\';\r\n      font-style: normal;\r\n      font-weight: 700;\r\n      src: local(\'Source Sans Pro Bold\'), local(\'SourceSansPro-Bold\'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/toadOcfmlt9b38dHJxOBGFkQc6VGVFSmCnC_l7QZG60.woff) format(\'woff\');\r\n    }\r\n  }\r\n\r\n  /**\r\n   * Avoid browser level font resizing.\r\n   * 1. Windows Mobile\r\n   * 2. iOS / OSX\r\n   */\r\n  body,\r\n  table,\r\n  td,\r\n  a {\r\n    -ms-text-size-adjust: 100%; /* 1 */\r\n    -webkit-text-size-adjust: 100%; /* 2 */\r\n  }\r\n\r\n  /**\r\n   * Remove extra space added to tables and cells in Outlook.\r\n   */\r\n  table,\r\n  td {\r\n    mso-table-rspace: 0pt;\r\n    mso-table-lspace: 0pt;\r\n  }\r\n\r\n  /**\r\n   * Better fluid images in Internet Explorer.\r\n   */\r\n  img {\r\n    -ms-interpolation-mode: bicubic;\r\n  }\r\n\r\n  /**\r\n   * Remove blue links for iOS devices.\r\n   */\r\n  a[x-apple-data-detectors] {\r\n    font-family: inherit !important;\r\n    font-size: inherit !important;\r\n    font-weight: inherit !important;\r\n    line-height: inherit !important;\r\n    color: inherit !important;\r\n    text-decoration: none !important;\r\n  }\r\n\r\n  /**\r\n   * Fix centering issues in Android 4.4.\r\n   */\r\n  div[style*="margin: 16px 0;"] {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  body {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  /**\r\n   * Collapse table borders to avoid space between cells.\r\n   */\r\n  table {\r\n    border-collapse: collapse !important;\r\n  }\r\n\r\n  a {\r\n    color: #1a82e2;\r\n  }\r\n\r\n  img {\r\n    height: auto;\r\n    line-height: 100%;\r\n    text-decoration: none;\r\n    border: 0;\r\n    outline: none;\r\n  }\r\n  </style>\r\n\r\n</head>\r\n<body style="background-color: #ffffff;">\r\n\r\n  <!-- start preheader -->\r\n  <div class="preheader" style="display: none; max-width: 0; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: #fff; opacity: 0;">\r\n    Texperts Inc\r\n  </div>\r\n  <!-- end preheader -->\r\n\r\n  <!-- start body -->\r\n  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 300px;">\r\n    <!-- start hero -->\r\n    <tr>\r\n      <td align="center" bgcolor="#ffffff">\r\n<!--[if (gte mso 9)|(IE)]>\r\n<table align="center" border="0" cellpadding="0" cellspacing="0" width="600">\r\n<tr>\r\n<td align="center" valign="top" width="600">\r\n<![endif]-->\r\n<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">\r\n  <tr>\r\n    <td align="center" style="padding: 16px 24px 0; font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; border-top: 3px solid #394b3f;">\r\n      <h1 style="margin: 0;font-size: 48px;font-weight: 700;letter-spacing: -1px;line-height: 48px;color: #394b3f;">NEW PROJECT EMAIL</h1>\r\n    </td>\r\n  </tr>\r\n</table>\r\n<!--[if (gte mso 9)|(IE)]>\r\n</td>\r\n</tr>\r\n</table>\r\n<![endif]-->\r\n      </td>\r\n    </tr>\r\n    <!-- end hero -->\r\n\r\n    <!-- start copy block -->\r\n    <tr>\r\n      <td align="center" bgcolor="#ffffff">\r\n<!--[if (gte mso 9)|(IE)]>\r\n<table align="center" border="0" cellpadding="0" cellspacing="0" width="600">\r\n<tr>\r\n<td align="center" valign="top" width="600">\r\n<![endif]-->\r\n<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">\r\n\r\n  <!-- start copy -->\r\n  <tr>\r\n    <td align="left" style="padding-top: 30px; font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">\r\n    <table border="1" cellpadding="0" cellspacing="0" width="100%" bgcolor="#394b3f" style="color:#ffffff;">\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Marketer</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + data.Markter.MarkterName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Pay Roll  Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">teXperts, Inc</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Last Name</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + $scope.userData.LstProjCodes[0].LastName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant First Name</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + $scope.userData.LstProjCodes[0].FirstName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Email</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"> <a href="mailto:' + $scope.userData.LstProjCodes[0].UserName + '" target="_blank" style="color: rgb(0, 161, 255)">' + $scope.userData.LstProjCodes[0].UserName + '</a></td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Phone</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">n/a</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Skills</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + data.Title.Title + "</td>\r\n</tr>\r\n<tr>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\"><strong>Mid \u2013 Client, State</strong></td>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\">" + data.VendorModel.Vendor.VendorName + ", " + data.VendorModel.VendorAddressInfo[0].Addr.City + ", " + data.VendorModel.VendorAddressInfo[0].Addr.State + "</td>\r\n</tr>\r\n<tr>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\"><strong>End \u2013 Client, City, State</strong></td>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\">" + data.ClientModel.Client.ClientName + ", " + data.ClientModel.ClientAddressInfo[0].Addr.State + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Start Date</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + moment(data.StartDate).format("MM/DD/YYYY") + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Billing Rate to Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">$' + data.BillRate + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Billing Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">teXperts Inc</td>\r\n</tr>\r\n       \r\n    </table>\r\n    </td>\r\n  </tr>\r\n</table>\r\n<!--[if (gte mso 9)|(IE)]>\r\n</td>\r\n</tr>\r\n</table>\r\n<![endif]-->\r\n      </td>\r\n    </tr>\r\n    <!-- end copy block -->\r\n  </table>\r\n  <!-- end body -->\r\n\r\n</body>\r\n</html>'
              };
            }

            dataService.newToken().then(function (response) {
              dataService.CreateProjCode(reqObj).then(function (response) {
                if (response.statusText == "OK") {
                  $scope.newProject = false;
                  $("#ProjectCreatedSuccesfully").modal("show");
                  initData().then(function () {
                    $scope.dataLoaded = false;
                    $scope.projectCreateMessage = false;
                    $scope.projectCreateStart = false;
                  });
                }
              }).catch(CatchError);
            }).catch(CatchError);
          }
        }
      });
    };
    $scope.ProjEditableSub = function (data) {
      var TitleObj = _.filter($scope.titles, function (v) {
        return _.includes([data.TitleId], v.TitleId);
      });
      if (TitleObj.length > 0) {
        data.Title = TitleObj[0].Title;
      }
      var MarketerObj = _.filter($scope.Marketers, function (v) {
        return _.includes([data.MarkterId], v.MarketerId);
      });
      if (MarketerObj.length > 0) {
        data.MarketerName = MarketerObj[0].MarkterName;
      }
      var ClientObj = _.filter($scope.Clients, function (v) {
        return _.includes([data.ClientId], v.ClientId);
      });
      if (ClientObj.length > 0) {
        data.ClientName = ClientObj[0].ClientName;
      }

      var ClientAddrObj = _.filter($scope.selectedClientAddresses, function (v) {
        return _.includes([data.ClientAddrId], v.AddrId);
      });
      if (ClientAddrObj.length > 0) {
        data.ClientAddress = ClientAddrObj[0];
      }

      var VendorObj = _.filter($scope.Vendors, function (v) {
        return _.includes([data.VendorId], v.VendorId);
      });
      if (VendorObj.length > 0) {
        data.VendorName = VendorObj[0].VendorName;
      }

      var VendorAddrObj = _.filter($scope.selectedVendorAddresses, function (v) {
        return _.includes([data.VendorAddrId], v.AddrId);
      });
      if (VendorAddrObj.length > 0) {
        data.VendorAddress = VendorAddrObj[0];
      }

      var reqObj = {
        RefByNAME: data.ReferedBy,
        StartDate: data.ProjectStartDate,
        MarkterId: data.MarkterId,
        titleid: data.TitleId,
        prfid: $scope.ProjectDetails.Prfid,
        loginid: $scope.tokenData.loginid,
        ProjId: data.ProjectID,
        ClientModel: {
          ClientId: data.ClientId,
          ClientAddressInfo: [{
            AddrId: data.ClientAddrId
          }]
        },
        VendorModel: {
          VendorId: data.VendorId,
          InvoiceTerm: data.InvTermId,
          PayTerm: data.VendorPayTerm,
          VendorAddressInfo: [{
            AddrId: data.VendorAddrId,
            VendorAcctInfo: [{
              VendorAddrMapId: data.VendAddrMapId
            }]
          }]
        }
      };
      var endDate;
      if (data.ProjectEndDate !== null && data.ProjectEndDate !== undefined) {
        endDate = moment(data.ProjectEndDate).format("MM/DD/YYYY");
      } else {
        endDate = "n/a";
      }
      bootbox.prompt({
        title: "Confirm Notifications",
        centerVertical: true,
        message: "<p>Do you want to send notification email to Accounts/Admin:</p>",
        inputType: "radio",
        inputOptions: [{
          text: "No, I do not want to Notify.",
          value: false
        }, {
          text: "Yes, Notify them all.",
          value: true
        }],
        callback: function callback(result) {
          if (result === null) {

            $scope.ProjEditable = false;

            $scope.loginLoader = false;
          } else if (result === "true") {
            reqObj.EmailContent = {
              Subject: "CONSULTANT: PROJECT DETAILS CHANGED | " + $scope.userData.LstProjCodes[0].FirstName + " " + $scope.userData.LstProjCodes[0].LastName + " | TeXperts Inc.",
              Body: '<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\r\n  <meta charset="utf-8">\r\n  <meta http-equiv="x-ua-compatible" content="ie=edge">\r\n  <title>Email Receipt</title>\r\n  <meta name="viewport" content="width=device-width, initial-scale=1">\r\n  <style type="text/css">\r\n  /**\r\n   * Google webfonts. Recommended to include the .woff version for cross-client compatibility.\r\n   */\r\n  @media screen {\r\n    @font-face {\r\n      font-family: \'Source Sans Pro\';\r\n      font-style: normal;\r\n      font-weight: 400;\r\n      src: local(\'Source Sans Pro Regular\'), local(\'SourceSansPro-Regular\'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/ODelI1aHBYDBqgeIAH2zlBM0YzuT7MdOe03otPbuUS0.woff) format(\'woff\');\r\n    }\r\n\r\n    @font-face {\r\n      font-family: \'Source Sans Pro\';\r\n      font-style: normal;\r\n      font-weight: 700;\r\n      src: local(\'Source Sans Pro Bold\'), local(\'SourceSansPro-Bold\'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/toadOcfmlt9b38dHJxOBGFkQc6VGVFSmCnC_l7QZG60.woff) format(\'woff\');\r\n    }\r\n  }\r\n\r\n  /**\r\n   * Avoid browser level font resizing.\r\n   * 1. Windows Mobile\r\n   * 2. iOS / OSX\r\n   */\r\n  body,\r\n  table,\r\n  td,\r\n  a {\r\n    -ms-text-size-adjust: 100%; /* 1 */\r\n    -webkit-text-size-adjust: 100%; /* 2 */\r\n  }\r\n\r\n  /**\r\n   * Remove extra space added to tables and cells in Outlook.\r\n   */\r\n  table,\r\n  td {\r\n    mso-table-rspace: 0pt;\r\n    mso-table-lspace: 0pt;\r\n  }\r\n\r\n  /**\r\n   * Better fluid images in Internet Explorer.\r\n   */\r\n  img {\r\n    -ms-interpolation-mode: bicubic;\r\n  }\r\n\r\n  /**\r\n   * Remove blue links for iOS devices.\r\n   */\r\n  a[x-apple-data-detectors] {\r\n    font-family: inherit !important;\r\n    font-size: inherit !important;\r\n    font-weight: inherit !important;\r\n    line-height: inherit !important;\r\n    color: inherit !important;\r\n    text-decoration: none !important;\r\n  }\r\n\r\n  /**\r\n   * Fix centering issues in Android 4.4.\r\n   */\r\n  div[style*="margin: 16px 0;"] {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  body {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  /**\r\n   * Collapse table borders to avoid space between cells.\r\n   */\r\n  table {\r\n    border-collapse: collapse !important;\r\n  }\r\n\r\n  a {\r\n    color: #1a82e2;\r\n  }\r\n\r\n  img {\r\n    height: auto;\r\n    line-height: 100%;\r\n    text-decoration: none;\r\n    border: 0;\r\n    outline: none;\r\n  }\r\n  </style>\r\n\r\n</head>\r\n<body style="background-color: #ffffff;">\r\n\r\n  <!-- start preheader -->\r\n  <div class="preheader" style="display: none; max-width: 0; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: #fff; opacity: 0;">\r\n    Texperts Inc\r\n  </div>\r\n  <!-- end preheader -->\r\n\r\n  <!-- start body -->\r\n  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 300px;">\r\n    <!-- start hero -->\r\n    <tr>\r\n      <td align="center" bgcolor="#ffffff">\r\n<!--[if (gte mso 9)|(IE)]>\r\n<table align="center" border="0" cellpadding="0" cellspacing="0" width="600">\r\n<tr>\r\n<td align="center" valign="top" width="600">\r\n<![endif]-->\r\n<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">\r\n  <tr>\r\n    <td align="center" style="padding: 16px 24px 0; font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; border-top: 3px solid #394b3f;">\r\n      <h1 style="margin: 0;font-size: 48px;font-weight: 700;letter-spacing: -1px;line-height: 48px;color: #394b3f;">PROJECT DETAILS UPDATED</h1>\r\n    </td>\r\n  </tr>\r\n</table>\r\n<!--[if (gte mso 9)|(IE)]>\r\n</td>\r\n</tr>\r\n</table>\r\n<![endif]-->\r\n      </td>\r\n    </tr>\r\n    <!-- end hero -->\r\n\r\n    <!-- start copy block -->\r\n    <tr>\r\n      <td align="center" bgcolor="#ffffff">\r\n<!--[if (gte mso 9)|(IE)]>\r\n<table align="center" border="0" cellpadding="0" cellspacing="0" width="600">\r\n<tr>\r\n<td align="center" valign="top" width="600">\r\n<![endif]-->\r\n<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">\r\n\r\n  <!-- start copy -->\r\n  <tr>\r\n    <td align="left" style="padding-top: 30px; font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">\r\n    <table border="1" cellpadding="0" cellspacing="0" width="100%" bgcolor="#394b3f" style="color:#ffffff;">\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Marketer</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + data.MarketerName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Pay Roll  Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">teXperts, Inc</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Last Name</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + $scope.userData.LstProjCodes[0].LastName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant First Name</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + $scope.userData.LstProjCodes[0].FirstName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Email</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><a href="mailto:' + data.UserName + '" target="_blank" style="color: rgb(0, 161, 255)">' + data.UserName + '</a></td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Phone</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">n/a</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Skills</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + data.Title + "</td>\r\n</tr>\r\n<tr>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\"><strong>Mid \u2013 Client, State</strong></td>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\">" + data.VendorName + ", " + data.VendorAddress.City + ", " + data.VendorAddress.State + "</td>\r\n</tr>\r\n<tr>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\"><strong>End \u2013 Client, City, State</strong></td>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\">" + data.ClientName + ", " + data.ClientAddress.State + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Billing Rate to Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">$' + data.HourlyRate + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>End Date</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + endDate + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Start Date</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + moment(data.ProjectStartDate).format("MM/DD/YYYY") + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Billing Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">teXperts Inc</td>\r\n</tr>\r\n       \r\n    </table>\r\n    </td>\r\n  </tr>\r\n</table>\r\n<!--[if (gte mso 9)|(IE)]>\r\n</td>\r\n</tr>\r\n</table>\r\n<![endif]-->\r\n      </td>\r\n    </tr>\r\n    <!-- end copy block -->\r\n  </table>\r\n  <!-- end body -->\r\n\r\n</body>\r\n</html>'
            };
          }

          dataService.newToken().then(function (response) {
            dataService.UpdateProjInfo(reqObj).then(function (response) {
              dataService.newToken().then(function (response) {
                dataService.ProjCodesByPrfid({
                  EmpId: $stateParams.id
                }).then(function (response) {
                  $scope.userData = response.data;
                  $scope.setProjectDetails(response.data.LstProjCodes[$scope.selectedProjIndex], $scope.selectedProjIndex);
                  $scope.ProjEditable = false;

                  $scope.loginLoader = false;
                  $("#ProjectUpdatedSuccesfully").modal("show");
                }).catch(CatchError);
              }).catch(CatchError);
            }).catch(CatchError);
          }).catch(CatchError);
        }
      });
    };
    $scope.ngShowhidemethod2 = function (ProjectDetails) {
      $scope.rawProjectDetails = angular.copy(ProjectDetails);
      $scope.billRateUpdateData = angular.copy(ProjectDetails);
      ProjectDetails.ProjectStartDate;
      $scope.ProjectDetails.ProjectStartDate = new Date($scope.ProjectDetails.ProjectStartDate);
      $scope.ProjectDetails.PrevProjEndDate = undefined;
      $scope.ProjectDetails.NewProjStartDate = undefined;
      $("#updateHourlyRate").modal("show");
    };
    $scope.ProjectDetailsHrsRate = function (data) {
      $scope.notifier = true;

      dataService.newToken().then(function (response) {
        dataService.GetTitleDD().then(function (response) {
          $scope.titles = response.data;
          TitleId;
          var TitleObj = _.filter($scope.titles, function (v) {
            return _.includes([data.TitleId], v.TitleId);
          });
          if (TitleObj.length > 0) {
            data.Title = TitleObj[0].Title;
          }
          var obj = {
            ProjId: data.ProjectID,
            NewPayRate: data.HourlyRate,
            PaytermId: data.PayTermId,
            PrevProjEndDate: data.PrevProjEndDate,
            NewProjStartDate: data.NewProjStartDate,
            IsActive: true,
            IsHourlyEdit: true, //This should be true when user clicks on hourly edit.
            loginid: $scope.tokenData.loginid,
            VendorInfo: {
              vendorModel: {
                VendorId: data.VendorId
              }
            },
            ClientInfo: {
              ClientId: 0
            },
            Prfid: data.Prfid
          };
          bootbox.prompt({
            title: "Confirm Notifications",
            centerVertical: true,
            message: "<p>Do you want to send notification email to Accounts/Admin:</p>",
            inputType: "radio",
            inputOptions: [{
              text: "No, I do not want to Notify.",
              value: false
            }, {
              text: "Yes, Notify them all.",
              value: true
            }],
            callback: function callback(result) {
              if (result === null) {
                $scope.notifier = false;
                $("#updateHourlyRate").modal("hide");
              } else {
                if (result === "true") {
                  obj.EmailContent = {
                    Subject: "CONSULTANT: Pay Rise | " + $scope.userData.LstProjCodes[0].FirstName + " " + $scope.userData.LstProjCodes[0].LastName + " | TeXperts Inc.",
                    Body: '<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\r\n  <meta charset="utf-8">\r\n  <meta http-equiv="x-ua-compatible" content="ie=edge">\r\n  <title>Bill Rate Update</title>\r\n  <meta name="viewport" content="width=device-width, initial-scale=1">\r\n  <style type="text/css">\r\n  /**\r\n   * Google webfonts. Recommended to include the .woff version for cross-client compatibility.\r\n   */\r\n  @media screen {\r\n    @font-face {\r\n      font-family: \'Source Sans Pro\';\r\n      font-style: normal;\r\n      font-weight: 400;\r\n      src: local(\'Source Sans Pro Regular\'), local(\'SourceSansPro-Regular\'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/ODelI1aHBYDBqgeIAH2zlBM0YzuT7MdOe03otPbuUS0.woff) format(\'woff\');\r\n    }\r\n\r\n    @font-face {\r\n      font-family: \'Source Sans Pro\';\r\n      font-style: normal;\r\n      font-weight: 700;\r\n      src: local(\'Source Sans Pro Bold\'), local(\'SourceSansPro-Bold\'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/toadOcfmlt9b38dHJxOBGFkQc6VGVFSmCnC_l7QZG60.woff) format(\'woff\');\r\n    }\r\n  }\r\n\r\n  /**\r\n   * Avoid browser level font resizing.\r\n   * 1. Windows Mobile\r\n   * 2. iOS / OSX\r\n   */\r\n  body,\r\n  table,\r\n  td,\r\n  a {\r\n    -ms-text-size-adjust: 100%; /* 1 */\r\n    -webkit-text-size-adjust: 100%; /* 2 */\r\n  }\r\n\r\n  /**\r\n   * Remove extra space added to tables and cells in Outlook.\r\n   */\r\n  table,\r\n  td {\r\n    mso-table-rspace: 0pt;\r\n    mso-table-lspace: 0pt;\r\n  }\r\n\r\n  /**\r\n   * Better fluid images in Internet Explorer.\r\n   */\r\n  img {\r\n    -ms-interpolation-mode: bicubic;\r\n  }\r\n\r\n  /**\r\n   * Remove blue links for iOS devices.\r\n   */\r\n  a[x-apple-data-detectors] {\r\n    font-family: inherit !important;\r\n    font-size: inherit !important;\r\n    font-weight: inherit !important;\r\n    line-height: inherit !important;\r\n    color: inherit !important;\r\n    text-decoration: none !important;\r\n  }\r\n\r\n  /**\r\n   * Fix centering issues in Android 4.4.\r\n   */\r\n  div[style*="margin: 16px 0;"] {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  body {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  /**\r\n   * Collapse table borders to avoid space between cells.\r\n   */\r\n  table {\r\n    border-collapse: collapse !important;\r\n  }\r\n\r\n  a {\r\n    color: #1a82e2;\r\n  }\r\n\r\n  img {\r\n    height: auto;\r\n    line-height: 100%;\r\n    text-decoration: none;\r\n    border: 0;\r\n    outline: none;\r\n  }\r\n  </style>\r\n\r\n</head>\r\n<body style="background-color: #ffffff;">\r\n\r\n  <!-- start preheader -->\r\n  <div class="preheader" style="display: none; max-width: 0; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: #fff; opacity: 0;">\r\n    Texperts Inc\r\n  </div>\r\n  <!-- end preheader -->\r\n\r\n  <!-- start body -->\r\n  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 300px;">\r\n    <!-- start hero -->\r\n    <tr>\r\n      <td align="center" bgcolor="#ffffff">\r\n<!--[if (gte mso 9)|(IE)]>\r\n<table align="center" border="0" cellpadding="0" cellspacing="0" width="600">\r\n<tr>\r\n<td align="center" valign="top" width="600">\r\n<![endif]-->\r\n<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">\r\n  <tr>\r\n    <td align="center" style="padding: 16px 24px 0; font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; border-top: 3px solid #394b3f;">\r\n      <h1 style="margin: 0;font-size: 48px;font-weight: 700;letter-spacing: -1px;line-height: 48px;color: #394b3f;">CONSULTANT PAY RISE EMAIL</h1>\r\n    </td>\r\n  </tr>\r\n</table>\r\n<!--[if (gte mso 9)|(IE)]>\r\n</td>\r\n</tr>\r\n</table>\r\n<![endif]-->\r\n      </td>\r\n    </tr>\r\n    <!-- end hero -->\r\n\r\n    <!-- start copy block -->\r\n    <tr>\r\n      <td align="center" bgcolor="#ffffff">\r\n<!--[if (gte mso 9)|(IE)]>\r\n<table align="center" border="0" cellpadding="0" cellspacing="0" width="600">\r\n<tr>\r\n<td align="center" valign="top" width="600">\r\n<![endif]-->\r\n<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">\r\n\r\n  <!-- start copy -->\r\n  <tr>\r\n    <td align="left" style="padding-top: 30px; font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">\r\n    <table border="1" cellpadding="0" cellspacing="0" width="100%" bgcolor="#394b3f" style="color:#ffffff;">\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Marketer</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + data.MarkterName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Pay Roll  Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">teXperts, Inc</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Last Name</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + $scope.userData.LstProjCodes[0].LastName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant First Name</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + $scope.userData.LstProjCodes[0].FirstName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Phone</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">n/a</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Email</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><a href="mailto:' + data.UserName + '" target="_blank" style="color: rgb(0, 161, 255)">' + data.UserName + '</a></td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Skills</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + data.Title + "</td>\r\n</tr>\r\n<tr>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\"><strong>Mid \u2013 Client, State</strong></td>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\">" + $scope.ProjectDetails.VendorCompanyName + ", " + $scope.ProjectDetails.VendorCompanyCity + ", " + $scope.ProjectDetails.VendorState + "</td>\r\n</tr>\r\n<tr>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\"><strong>End \u2013 Client, City, State</strong></td>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\">" + $scope.ProjectDetails.ClientName + ", " + $scope.ProjectDetails.ClientState + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Previous Project End Date</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + moment(data.PrevProjEndDate).format("MM/DD/YYYY") + '</td>\r\n</tr>\r\n <tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>New Project Start Date</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + moment(data.NewProjStartDate).format("MM/DD/YYYY") + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>New Billing Rate to Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">$' + data.HourlyRate + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Billing Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">teXperts Inc</td>\r\n</tr>\r\n\r\n</table>\r\n</td>\r\n</tr>\r\n</table>\r\n<!--[if (gte mso 9)|(IE)]>\r\n</td>\r\n</tr>\r\n</table>\r\n<![endif]-->\r\n</td>\r\n</tr>\r\n<!-- end copy block -->\r\n  </table>\r\n  <!-- end body -->\r\n\r\n</body>\r\n</html>'
                  };
                }

                dataService.newToken().then(function (response) {
                  dataService.UpdateBillRate(obj).then(function (response) {
                    if (response.statusText == "OK") {
                      initData().then(function () {
                        $scope.notifier = false;
                        $scope.ProjectDetails.HourlyRate = data.HourlyRate;
                        $("#updateHourlyRate").modal("hide");
                        $("#BillRateUpdatedSuccesfully").modal("show");
                      });
                    }
                  }).catch(CatchError);
                }).catch(CatchError);
              }
            }
          });
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.getFileDetails = function (e, id, form) {
      if (re.exec(e.files[0].name)[1] === "doc" || re.exec(e.files[0].name)[1] === "docx" || re.exec(e.files[0].name)[1] === "pdf") {
        e.files[0].DocId = id;
        $scope.$apply(function () {
          $scope.files.push(e.files[0]);
        });
        var $el = $("#file");
        $el.wrap("<form>").closest("form").get(0).reset();
        $el.unwrap();
      } else {
        $("#invalidFileTypeAlertDiv").modal("show");
      }
    };
    $scope.removeFilePO = function (index) {
      $scope.files.splice(index, 1);
    };
    $scope.POFormSub = function () {
      $scope.POFormSubLoader = true;
      for (var index = 0; index < $scope.files.length; index++) {
        var _element = $scope.files[index];
        var data = new FormData();
        data.append("ProjId", $scope.ProjectDetails.ProjectID);
        data.append("file", _element);
        dataService.newToken().then(function (response) {
          dataService.UploadPO(data).then(function () {
            dataService.newToken().then(function (response) {
              dataService.GetPOUrlsByProjId({
                projid: $scope.ProjectDetails.ProjectID
              }).then(function (response) {
                $scope.POS = response.data;
                $scope.files = [];
                $scope.POFormSubLoader = false;
              });
            }).catch(CatchError);
          });
        }).catch(CatchError);
      }
    };
    $scope.GetPOByProjId = function (file) {
      file.fileDownloadReq = true;
      var reqObj = {
        projid: $scope.ProjectDetails.ProjectID,
        FIleUrl: file.FileUrl
      };
      dataService.newToken().then(function (response) {
        dataService.GetPOByProjId(reqObj).then(function (response) {
          var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
            return data + String.fromCharCode(byte);
          }, ''));
          var anchor = $('<a/>');
          anchor.attr({
            href: 'data:application/octet-stream; base64,' + base64,
            target: '_blank',
            download: file.FileUrl
          })[0].click();
          file.fileDownloadReq = false;
        });
      }).catch(CatchError);
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("payRise", {
    controller: payRiseController,
    controllerAs: "vm",
    templateUrl: "app/components/hr/payRise/payRise.html"
  });

  function payRiseController($scope, dataService, $http, $timeout, $q, $mdToast, $location, $state) {
    var reportsTable,
        vm = this;
    var heightCanBe = window.innerHeight - 360 + "px";
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 360 + "px";
    });
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };
    $scope.years = ["2019", "2020"];
    $scope.months = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    $scope.PRType = "all";
    $scope.selectedConsultant = null;
    $scope.consultantList = [];
    dataService.newToken().then(function (response) {
      dataService.GetPayRaiseInfo().then(function (response) {
        $scope.reportsAll = [];
        $scope.bodyRowsAll = [];
        $scope.reports = [];
        $scope.bodyRows = [];
        for (var f = 0; f < response.data.length; f++) {
          var rowData = [];
          $scope.consultantList.push(response.data[f].FirstName + " " + response.data[f].LastName);
          var obj = {
            FirstName: response.data[f].FirstName,
            LastName: response.data[f].LastName,
            TotalProjects: response.data[f].TotalProjects,
            CurrentProjStartDate: response.data[f].CurrentProjStartDate,
            CurrentProjEndDate: response.data[f].CurrentProjEndDate,
            TotalDays: response.data[f].TotalDays,
            M3Date: response.data[f].lstpayrollmonths !== null && response.data[f].lstpayrollmonths[0] ? response.data[f].lstpayrollmonths[0].Date : "n/a",
            M6Date: response.data[f].lstpayrollmonths !== null && response.data[f].lstpayrollmonths[1] ? response.data[f].lstpayrollmonths[1].Date : "n/a",
            M9Date: response.data[f].lstpayrollmonths !== null && response.data[f].lstpayrollmonths[2] ? response.data[f].lstpayrollmonths[2].Date : "n/a",
            M12Date: response.data[f].lstpayrollmonths !== null && response.data[f].lstpayrollmonths[3] ? response.data[f].lstpayrollmonths[3].Date : "n/a",
            M24Date: response.data[f].lstpayrollmonths !== null && response.data[f].lstpayrollmonths[4] ? response.data[f].lstpayrollmonths[4].Date : "n/a"
          };
          rowData[0] = f + 1;
          rowData[1] = obj.LastName;
          rowData[2] = obj.FirstName;
          rowData[3] = moment(obj.CurrentProjStartDate).format("MM/DD/YYYY");
          rowData[4] = moment(obj.CurrentProjEndDate).format("MM/DD/YYYY");
          rowData[5] = obj.TotalProjects;
          rowData[6] = obj.TotalDays;
          rowData[7] = moment(obj.M3Date).format("MM/DD/YYYY");
          rowData[8] = moment(obj.M6Date).format("MM/DD/YYYY");
          rowData[9] = moment(obj.M9Date).format("MM/DD/YYYY");
          rowData[10] = moment(obj.M12Date).format("MM/DD/YYYY");
          rowData[11] = obj.M24Date ? moment(obj.M24Date).format("MM/DD/YYYY") : "n/a";
          $scope.bodyRowsAll.push(rowData);
          $scope.reportsAll.push(obj);
        }
      }).catch(CatchError);
    }).catch(CatchError);

    $scope.viewDownloadBtn = false;
    $scope.GeneratePDF = function (type, scon, year, month) {
      $scope.reports = [];
      $scope.bodyRows = [];
      if (type === "all") {
        $scope.bodyRows = $scope.bodyRowsAll;
        $scope.reports = $scope.reportsAll;
        $scope.filename = "AllConsultants-";
        $scope.showTabl = true;
      } else if (type === "byConsultant") {
        for (var i = 0; i < $scope.reportsAll.length; i++) {
          var name = $scope.reportsAll[i].FirstName + " " + $scope.reportsAll[i].LastName;
          if (name === scon) {
            $scope.filename = $scope.reportsAll[i].LastName + "-" + $scope.reportsAll[i].FirstName;
            $scope.reports.push($scope.reportsAll[i]);
            break;
          }
        }
        for (var j = 0; j < $scope.bodyRowsAll.length; j++) {
          var name = $scope.bodyRowsAll[j][2] + " " + $scope.bodyRowsAll[j][1];
          if (name === scon) {
            $scope.bodyRows.push($scope.bodyRowsAll[j]);
            $scope.bodyRowsAll[j][0] = "1";
            break;
          }
        }
        $scope.showTabl = true;
      } else if (type === "byPayPeriod") {
        $scope.highLightPeriod = "";
        var PeriodStart = month !== "1" ? JSON.stringify(JSON.parse(month) - 1) + "/15/" + year : "12/16/" + JSON.stringify(JSON.parse(year) - 1);
        PeriodStart = moment(PeriodStart).format("MM/DD/YYYY");
        var PeriodEnd = month + "/16/" + year;
        PeriodEnd = moment(PeriodEnd).format("MM/DD/YYYY");
        var start = month !== "1" ? JSON.stringify(JSON.parse(month) - 1) + "/16/" + year : "12/16/" + JSON.stringify(JSON.parse(year) - 1);
        $scope.filename = start + "-" + month + "/15/" + year + "-";
        for (var i = 0; i < $scope.reportsAll.length; i++) {
          var m3 = moment($scope.reportsAll[i].M3Date).isBetween(PeriodStart, PeriodEnd);
          var m6 = moment($scope.reportsAll[i].M6Date).isBetween(PeriodStart, PeriodEnd);
          var m9 = moment($scope.reportsAll[i].M9Date).isBetween(PeriodStart, PeriodEnd);
          var m12 = moment($scope.reportsAll[i].M12Date).isBetween(PeriodStart, PeriodEnd);
          var m24 = moment($scope.reportsAll[i].M24Date).isBetween(PeriodStart, PeriodEnd);
          if (m3 || m6 || m9 || m12 || m24) {
            $scope.reports.push($scope.reportsAll[i]);
          }
        }
        var i = 1;
        for (var j = 0; j < $scope.bodyRowsAll.length; j++) {
          var m3 = moment($scope.bodyRowsAll[j][7]).isBetween(PeriodStart, PeriodEnd);
          var m6 = moment($scope.bodyRowsAll[j][8]).isBetween(PeriodStart, PeriodEnd);
          var m9 = moment($scope.bodyRowsAll[j][9]).isBetween(PeriodStart, PeriodEnd);
          var m12 = moment($scope.bodyRowsAll[j][10]).isBetween(PeriodStart, PeriodEnd);
          var m24 = moment($scope.bodyRowsAll[j][11]).isBetween(PeriodStart, PeriodEnd);
          if (m3) {
            $scope.highLightPeriod += " " + moment($scope.bodyRowsAll[j][7]).format("MM/DD/YY");
            $scope.bodyRowsAll[j][0] = i;
            $scope.bodyRows.push($scope.bodyRowsAll[j]);
            i++;
          }
          if (m6) {
            $scope.highLightPeriod += " " + moment($scope.bodyRowsAll[j][8]).format("MM/DD/YY");
            $scope.bodyRowsAll[j][0] = i;
            $scope.bodyRows.push($scope.bodyRowsAll[j]);
            i++;
          } else if (m9) {
            $scope.highLightPeriod += " " + moment($scope.bodyRowsAll[j][9]).format("MM/DD/YY");
            $scope.bodyRowsAll[j][0] = i;
            $scope.bodyRows.push($scope.bodyRowsAll[j]);
            i++;
          }
          if (m12) {
            $scope.highLightPeriod += " " + moment($scope.bodyRowsAll[j][10]).format("MM/DD/YY");
            $scope.bodyRowsAll[j][0] = i;
            $scope.bodyRows.push($scope.bodyRowsAll[j]);
            i++;
          } else if (m24) {
            $scope.highLightPeriod += " " + moment($scope.bodyRowsAll[j][11]).format("MM/DD/YY");
            $scope.bodyRowsAll[j][0] = i;
            $scope.bodyRows.push($scope.bodyRowsAll[j]);
            i++;
          }
        }
        $scope.showTabl = true;
      }
      reportsTable = new Tabulator("#reportsTable", {
        height: heightCanBe,
        data: $scope.reports,
        layout: "fitColumns",
        columns: [{
          formatter: "rownum",
          align: "center",
          width: 40,
          sorter: false
        }, {
          title: "Last Name",
          field: "LastName"
        }, {
          title: "FirstName",
          field: "FirstName"
        }, {
          title: "Start",
          field: "CurrentProjStartDate",
          formatter: "datetime",
          formatterParams: {
            inputFormat: "YYYY-MM-DD",
            outputFormat: "MM/DD/YY",
            invalidPlaceholder: "n/a"
          }
        }, {
          title: "End",
          field: "CurrentProjEndDate",
          formatter: "datetime",
          formatterParams: {
            inputFormat: "YYYY-MM-DD",
            outputFormat: "MM/DD/YY",
            invalidPlaceholder: "n/a"
          }
        }, {
          title: "Total Projects",
          field: "TotalProjects"
        }, {
          title: "Total Days",
          field: "TotalDays"
        }, {
          title: "3M Raise",
          field: "M3Date",
          formatter: "datetime",
          formatterParams: {
            inputFormat: "YYYY-MM-DD",
            outputFormat: "MM/DD/YY",
            invalidPlaceholder: "n/a"
          }
        }, {
          title: "6M Raise",
          field: "M6Date",
          formatter: "datetime",
          formatterParams: {
            inputFormat: "YYYY-MM-DD",
            outputFormat: "MM/DD/YY",
            invalidPlaceholder: "n/a"
          }
        }, {
          title: "9M Raise",
          field: "M9Date",
          formatter: "datetime",
          formatterParams: {
            inputFormat: "YYYY-MM-DD",
            outputFormat: "MM/DD/YY",
            invalidPlaceholder: "n/a"
          }
        }, {
          title: "12M Raise",
          field: "M12Date",
          formatter: "datetime",
          formatterParams: {
            inputFormat: "YYYY-MM-DD",
            outputFormat: "MM/DD/YY",
            invalidPlaceholder: "n/a"
          }
        }, {
          title: "24M Raise",
          field: "M24Date",
          formatter: "datetime",
          formatterParams: {
            inputFormat: "YYYY-MM-DD",
            outputFormat: "MM/DD/YY",
            invalidPlaceholder: "n/a"
          }
        }],
        tableBuilt: function tableBuilt() {
          $scope.viewDownloadBtn = true;
          $timeout(function () {
            var instance = new Mark(document.querySelector(".payrisedataTabl"));
            instance.mark($scope.highLightPeriod);
          });
        }
      });
    };
    $scope.showTabl = false;
    $scope.clearData = function () {
      $scope.showTabl = false;
    };

    $scope.downloadPDF = function () {
      var headRows = [["#", "Last Name", "First Name", "Start Date", "End Date", "#Projects", "#Days", "3M raise", "6M raise", "9M raise", "12M raise", "24M raise"]];
      var doc = new jsPDF("l");
      var totalPagesExp = "{total_pages_count_string}";
      var base64Img = "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";
      doc.autoTable({
        head: headRows,
        body: $scope.bodyRows,
        theme: 'grid',
        didDrawPage: function didDrawPage(data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);
          doc.setFontStyle("normal");
          if (base64Img) {
            doc.addImage(base64Img, "JPEG", data.settings.margin.left, 5, 28, 20);
          }
          doc.text($scope.filename + " Pay Raise Report", data.settings.margin.left + 80, 20);

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          if (typeof doc.putTotalPages === "function") {
            str = str + " of " + totalPagesExp;
          }
          doc.setFontSize(8);

          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
        },
        margin: {
          top: 30
        }
      });
      if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
      }

      doc.save($scope.filename + "PayRiseReport.pdf");
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('managerAppTs', {
    controller: ManagerAppTsController,
    controllerAs: 'vm',
    templateUrl: 'app/components/hr/managerAppTs/managerAppTs.html'
  });

  function ManagerAppTsController($scope, dataService, $q, $http, $mdDialog, $mdToast, $timeout, moment, $state) {
    var tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.tokenData = tokenData;
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };

    function role() {
      if (tokenData.UserValid == 'true') {
        return tokenData.role;
      }
    }
    $scope.role = role();
    var reqLid = {};
    reqLid.loginid = tokenData.loginid;
    var loginmodel = {
      loginid: tokenData.loginid
    };
    var empId;
    $scope.tsprocessing = false;

    $scope.loginLoader = false;
    $scope.showDetailsPage = false;
    var toast;

    // get years os userv
    $scope.presentYear = moment().format('YYYY');
    var a = moment([$scope.presentYear]);
    $scope.openPanel = false;
    $scope.prevYear = a.subtract(1, 'y').format('YYYY');

    $scope.getPrevYearTs = function (eid) {
      $scope.yearTsLoader = true;
      new GetTSforAccoounts(eid, $scope.prevYear);
    };
    $scope.getPresnYearTs = function (eid) {
      $scope.yearTsLoader = true;
      new GetTSforAccoounts(eid, $scope.presentYear);
    };

    dataService.newToken().then(function (response) {
      dataService.GetUsersByManagerId(reqLid).then(function (response) {
        $scope.usersList = response.data;
        $scope.loginLoader = true;
        $timeout(function () {
          if ($.fn.dataTable.isDataTable('#usersTable')) {
            $('#usersTable').DataTable();
          } else {
            $('#usersTable').DataTable({
              lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, 'All']]
            });
          }
        });
      }).catch(CatchError);
    }).catch(CatchError);

    $scope.searched = function (searchUsers) {
      if (searchUsers === '') {
        $scope.itemsPerPage = 10;
      } else {
        $scope.itemsPerPage = $scope.tsAccs.length;
      }
    };

    function GetTSforAccoounts(eid, yy) {
      var reqData = {
        loginid: eid,
        Year: yy
      };
      dataService.newToken().then(function (response) {
        dataService.GetTimeSheetsForAccounts(reqData).then(function (response) {
          angular.forEach(response.data, function (recrd) {
            if (recrd.ManagerAction === null || recrd.ManagerAction === '') {
              recrd.tsaction = 'Submitted';
            } else {
              recrd.tsaction = recrd.ManagerAction;
            }
          });
          $scope.Timesheets = response.data;
          $scope.loginLoader = true;
          $scope.showSubmittedTsloader = false;
          $scope.showSubmittedTsExport = true;
          $scope.getUserData = true;
          $scope.search = 'Submitted';
          $scope.yearTsLoader = false;
        }).catch(CatchError);
      }).catch(CatchError);
    }

    $scope.showUserDetails = function (id) {
      var year = moment(id.StartDate).format('YYYY');
      $scope.getUserData = false;
      $scope.selectedIndex = 0;
      $scope.openPanel = true;
      $scope.showDetailsPage = true;
      $scope.userDetails = id;
      var reqData = {
        loginid: id.loginid,
        Year: year
      };

      dataService.newToken().then(function (response) {
        dataService.GetTimeSheetsForAccounts(reqData).then(function (response) {
          angular.forEach(response.data, function (recrd) {
            if (recrd.ManagerAction === null || recrd.ManagerAction === '') {
              recrd.tsaction = 'Submitted';
            } else {
              recrd.tsaction = recrd.ManagerAction;
            }
          });
          $scope.Timesheets = response.data;
          $scope.loginLoader = true;
          $scope.showSubmittedTsloader = false;
          $scope.showSubmittedTsExport = true;
          $scope.getUserData = true;
          $scope.search = 'Submitted';
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.approveTs = function (tsData) {
      var year = moment(tsData.StartDate).format('YYYY');
      tsData.tsprocessing = true;
      var obj = {
        GUID: tsData.Guid,
        loginid: $scope.userDetails.loginid,
        IsAccountsProcessed: true,
        IsManagerProcessed: true,
        ManagerAction: 'Approved',
        Year: year
      };

      dataService.newToken().then(function (response) {
        dataService.MgrAppOrReject(obj).then(function (response) {
          if (response.data !== false) {
            var reqData = {
              loginid: tsData.loginid,
              Year: year
            };
            dataService.newToken().then(function (response) {
              dataService.GetTimeSheetsForAccounts(reqData).then(function (response) {
                angular.forEach(response.data, function (recrd) {
                  if (recrd.ManagerAction === null || recrd.ManagerAction === '') {
                    recrd.tsaction = 'Submitted';
                  } else {
                    recrd.tsaction = recrd.ManagerAction;
                  }
                });
                $scope.Timesheets = response.data;
                $scope.loginLoader = true;
                $scope.showSubmittedTsloader = false;
                $scope.showSubmittedTsExport = true;
                $scope.getUserData = true;
                toast = $mdToast.simple().content('Timesheet Approved Successfully').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                $mdToast.show(toast);
                tsData.tsprocessing = false;
              }).catch(CatchError);
            }).catch(CatchError);
          } else {
            toast = $mdToast.simple().content('Oops, Something went wrong.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
            $mdToast.show(toast);
            tsData.tsprocessing = false;
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.RejectBox = function (ts, ev) {
      ts.showRejectBox = true;
      // ts.tsprocessing = true;
      var year = moment(ts.StartDate).format('YYYY');
      $scope.rejectTs = function (answer) {
        ts.tsprocessing = true;
        $mdDialog.hide(answer);
        var obj = {
          GUID: ts.Guid,
          loginid: ts.loginid,
          IsManagerProcessed: true,
          IsAccountsProcessed: true,
          MgrRejectReason: answer,
          ManagerAction: 'Rejected',
          Year: year
        };

        dataService.newToken().then(function (response) {
          dataService.MgrAppOrReject(obj).then(function (response) {
            var reqData = {
              EmpId: ts.EmpId,
              Year: year
            };

            if (response.data === true) {
              dataService.newToken().then(function (response) {
                dataService.GetTimeSheetsForAccounts(reqData).then(function (response) {
                  angular.forEach(response.data, function (recrd) {
                    if (recrd.ManagerAction === null || recrd.ManagerAction === '') {
                      recrd.tsaction = 'Submitted';
                    } else {
                      recrd.tsaction = recrd.ManagerAction;
                    }
                  });
                  $scope.Timesheets = response.data;
                  $scope.loginLoader = true;
                  $scope.showSubmittedTsloader = false;
                  $scope.showSubmittedTsExport = true;
                  $scope.getUserData = true;
                  toast = $mdToast.simple().content('Timesheet Rejected Successfully').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                  $mdToast.show(toast);
                  ts.tsprocessing = false;
                  ts.showRejectBox = false;
                }).catch(CatchError);
              }).catch(CatchError);
            } else {
              toast = $mdToast.simple().content('Oops..!, Something went wrong. Reload the page and try again').action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
              ts.tsprocessing = false;
              ts.showRejectBox = false;
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    };
    $scope.hideRejectBox = function (ts, ev) {
      ts.showRejectBox = false;
    };

    $scope.showRejectDialog = function (ts, ev) {
      // ts.tsprocessing = true;
      $scope.ts = ts;
      $mdDialog.show({
        controller: showRejectionDialogController,
        templateUrl: 'app/components/accounts/account/showRejectionDialogController.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          ts: $scope.ts
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function showRejectionDialogController($scope, $mdDialog, ts) {
      var year = moment(ts.StartDate).format('YYYY');

      $scope.ts = ts;
      $scope.hide = function () {
        $mdDialog.hide();
      };

      $scope.cancel = function () {
        $mdDialog.cancel();
      };

      $scope.rejectTs = function (answer) {
        $scope.ts.tsprocessing = true;
        $mdDialog.hide(answer);
        var obj = {
          GUID: ts.Guid,
          EmpId: ts.EmpId,
          IsManagerProcessed: true,
          IsAccountsProcessed: true,
          MgrRejectReason: answer,
          ManagerAction: 'Rejected',
          Year: year
        };

        dataService.newToken().then(function (response) {
          dataService.MgrAppOrReject(obj).then(function (response) {
            var reqData = {
              EmpId: ts.EmpId,
              Year: year
            };

            if (response.data === true) {
              dataService.newToken().then(function (response) {
                dataService.GetTimeSheetsForAccounts(reqData).then(function (response) {
                  angular.forEach(response.data, function (recrd) {
                    if (recrd.ManagerAction === null || recrd.ManagerAction === '') {
                      recrd.tsaction = 'Submitted';
                    } else {
                      recrd.tsaction = recrd.ManagerAction;
                    }
                  });
                  $scope.Timesheets = response.data;
                  $scope.loginLoader = true;
                  $scope.showSubmittedTsloader = false;
                  $scope.showSubmittedTsExport = true;
                  $scope.getUserData = true;
                  toast = $mdToast.simple().content('Timesheet Rejected Successfully').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                  $mdToast.show(toast);
                }).catch(CatchError);
              }).catch(CatchError);
              $scope.ts.tsprocessing = false;
            } else {
              toast = $mdToast.simple().content('Oops..!, Something went wrong.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
              $scope.ts.tsprocessing = false;
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }

    $scope.filter = function (param) {
      if (param == 'All') {
        $scope.search = '';
      } else {
        $scope.search = param;
      }
    };
    $scope.closeUserDetails = function () {
      $scope.showDetailsPage = false;
      $scope.openPanel = false;
    };

    $scope.go = function (path) {
      $state.go(path);
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('h1bfiling', {
    controller: H1bfilingController,
    controllerAs: 'vm',
    templateUrl: 'app/components/hr/h1bfiling/h1bfiling.html'
  });

  function H1bfilingController($scope, dataService, $http, $timeout, $mdDialog, $state) {
    var vm = this;
    $scope.ActiveConslByPayRateRangelabels = [];
    $scope.ActiveConslByPayRateRangedata = [];
    $scope.Selected = {
      PrfIds: []
    };
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    dataService.newToken().then(function (response) {
      dataService.GetAllUsers().then(function (response) {
        $scope.users = response.data;
        $timeout(function () {
          var uTable3 = $('#h1bTable').DataTable();
          uTable3.on('order.dt search.dt', function () {
            uTable3.column(0, {
              search: 'applied',
              order: 'applied'
            }).nodes().each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
          }).draw();
        });
      }).catch(CatchError);
    }).catch(CatchError);
    $scope.selectAll = function () {
      // angular.forEach($scope.users, function (user) {
      //     user.Selected = !$scope.selectedAll;
      // });
      if ($scope.selectedAll === undefined || $scope.selectedAll === false) {
        $scope.Selected.PrfIds = $scope.users.map(function (user) {
          return user.PrfId;
        });
      } else {
        $scope.Selected.PrfIds = [];
      }
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('hrdashboard', {
    controller: HrDashboardController,
    controllerAs: 'vm',
    templateUrl: 'app/components/hr/hrDashboard/hrDashboard.html'
  });

  function HrDashboardController($scope, $rootScope, dataService, $location, $q, $mdDialog, $mdToast, $timeout, $mdSelect, moment, $state) {
    $rootScope.isLogin = false;
    var vm = this;
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    $scope.isMobile = false;
    if (isMobile) {
      $scope.isMobile = true;
    }
    var expiringUsersVisaTabl, UsersByWorkAuthTb, AllUsersTb;
    var heightCanBe = window.innerHeight - 210 + 'px';
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 210 + 'px';
      if (expiringUsersVisaTabl) {
        expiringUsersVisaTabl.setHeight(heightCanBe);
        expiringUsersVisaTabl.redraw();
      }
      if (UsersByWorkAuthTb) {
        UsersByWorkAuthTb.setHeight(heightCanBe);
        UsersByWorkAuthTb.redraw();
      }
      if (AllUsersTb) {
        AllUsersTb.setHeight(heightCanBe);
        AllUsersTb.redraw();
      }
    });

    $scope.clearSearchTerm = function () {
      $scope.searchTerm = '';
    };
    $('#hisUser').on('keydown', function (ev) {
      ev.stopPropagation();
    });
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    $scope.userDataLoaded = false;
    var tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    // tokenData = angular.fromJson(tokenData.role);
    $scope.tokenData = tokenData;
    // $scope.tokenData.newRole = angular.fromJson($scope.tokenData.role);
    $scope.monthlabels = [];
    $scope.monthdata = [];
    $scope.windowHeight = window.innerHeight;
    $scope.usersloaded = false;
    $scope.WAuthListLoaded = false;
    $scope.WorkAuthUsersLoaded = true;
    $scope.selectedClient = undefined;
    $scope.selectedVendor = undefined;
    $scope.newProjectDetails = {};

    function initData($q) {
      return $q.all([dataService.GetWrkAuthDD()]);
    }

    dataService.newToken().then(function () {
      initData($q).then(function (response) {
        $scope.workAuthTypes = response[0].data;
        new UserwithvisaexpiryFunc();
      });
    }).catch(CatchError);

    function matchAny(data, filterParams) {
      var match = false;
      for (var key in data) {
        if (key == 'FullName' || key == 'DisplayName' || key == 'Email' || key == 'UserName' || key == 'WorkAuth' || key == 'WorkAuthStartDate' || key == 'WorkAuthEndDate' || key == 'CurrentWorkAuthStartDate' || key == 'CurrentWorkAuthEndDate' || key == 'Skillset' || key == 'VisaType') {
          if (key == "WorkAuthStartDate" || key == "WorkAuthEndDate" || key == "CurrentWorkAuthStartDate" || key == "CurrentWorkAuthEndDate") {
            data[key] = moment(data[key]).format("MM/DD/YYYY");
          }
          var keyData = data[key];
          if (keyData !== null && keyData !== undefined) {
            keyData = keyData.toLowerCase();
            var param = filterParams.value.toLowerCase();
            if (JSON.stringify(keyData).search(param) != -1) {
              match = true;
            }
          }
        }
      }
      return match;
    }
    $scope.search = function (data) {
      expiringUsersVisaTabl.setFilter(matchAny, {
        value: data
      });
    };
    $scope.searchAllUsersTb = function (data) {
      AllUsersTb.setFilter(matchAny, {
        value: data
      });
    };
    $scope.searchUsersByWorkAuthTb = function (data) {
      UsersByWorkAuthTb.setFilter(matchAny, {
        value: data
      });
    };
    $scope.groupByObj = [{
      name: 'None',
      value: ''
    }, {
      name: 'Work Auth',
      value: 'WorkAuth'
    }];
    $scope.usersByWorkAuthGrouping = [{
      name: 'None',
      value: ''
    }, {
      name: 'Work Auth',
      value: 'CurrentWorkAuth'
    }];
    $scope.hotListGroupBy = function (value) {
      expiringUsersVisaTabl.setGroupBy(value);
      expiringUsersVisaTabl.tabulator('redraw', true);
    };
    $scope.UsersByWorkAuthTbGroupBy = function (value) {
      UsersByWorkAuthTb.setGroupBy(value);
      UsersByWorkAuthTb.tabulator('redraw', true);
    };
    $scope.newworkAuthType = function (data) {
      $mdSelect.hide();
      $mdDialog.show({
        controller: newworkAuthDialogController,
        templateUrl: 'app/components/hr/hrDashboard/newworkAuthDialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });

      function newworkAuthDialogController($scope, $mdDialog) {
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
        $scope.addworkAuthData = function (data) {
          $scope.notifier = true;
          dataService.newToken().then(function (response) {
            dataService.AddWorkAuth({
              WrkAuth: data
            }).then(function (response) {
              dataService.newToken().then(function (response) {
                dataService.GetWrkAuthDD().then(function (response) {
                  $rootScope.$broadcast('workAuthTypes', response.data);
                  $mdDialog.cancel();
                }).catch(CatchError);
              }).catch(CatchError);
            }).catch(CatchError);
          }).catch(CatchError);
        };
      }
    };
    $scope.$on('workAuthTypes', function (evt, data) {
      $scope.workAuthTypes = data;
    });
    $scope.clearUpload = function () {
      vm.uploadedFile = undefined;
      $rootScope.prfDataFile = undefined;
    };
    $scope.fileDat = function (prfData, prfDataFile, ev) {
      if ($rootScope.prfDataFile !== undefined) {
        var ext = $rootScope.prfDataFile.name.substring($rootScope.prfDataFile.name.lastIndexOf('.') + 1);
        if ($rootScope.prfDataFile !== undefined && (ext.toLowerCase() == 'png' || ext.toLowerCase() == 'jpg' || ext.toLowerCase() == 'pdf')) {
          vm.uploadedFile = $rootScope.prfDataFile;
        } else {
          $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#usersmissingprfd'))).clickOutsideToClose(true).title('File Type Not Supported').textContent('Supported file types are JPG, PNG, PDF.').ariaLabel('File Type Not Supported').ok('Got it!').targetEvent(ev));
        }
      }
    };

    $scope.UpdateWorkAuthRec = function (data) {
      $scope.usersloaded = false;
      $scope.incompleteProfileData = [];
      // var obj = {
      //     "loginid": data.loginid,
      //     "prfid": "",
      //     "WrkAuth":data.workAuthType,
      //     "WrkAuthStartDate": data.WorkAuthStartDate,
      //     "WrkAuthEndDate": data.WorkAuthEndDate,
      //     "File": data.File,
      // }
      var file = $rootScope.prfDataFile;
      var wrkAuthFormdata = new FormData();
      wrkAuthFormdata.append('file', file);
      wrkAuthFormdata.append('loginid', data.loginid);
      wrkAuthFormdata.append('prfid', data.ProfileModel.prfid);
      wrkAuthFormdata.append('WrkAuth', data.workAuthType);
      wrkAuthFormdata.append('WrkAuthStartDate', moment(data.WorkAuthStartDate).format('MM/DD/YYYY'));
      wrkAuthFormdata.append('WrkAuthEndDate', moment(data.WorkAuthEndDate).format('MM/DD/YYYY'));
      dataService.newToken().then(function (response) {
        dataService.UpdateWorkAuth(wrkAuthFormdata).then(function (response) {
          dataService.newToken().then(function (response) {
            dataService.usersmissingprfdata().then(function (response) {
              for (var f = 0; f < response.data.length; f++) {
                if (response.data[f].WorkAuthStartDate == '0001-01-01T00:00:00' || response.data[f].WorkAuthEndDate == '0001-01-01T00:00:00')
                  // response.data[f].WorkAuthStartDate = moment().format("MM/DD/YYYY");
                  // response.data[f].WorkAuthEndDate = moment().format("MM/DD/YYYY");
                  response.data[f].WorkAuthStartDate = null;
                response.data[f].WorkAuthEndDate = null;
              }

              $scope.incompleteProfileData = response.data;
              delete $rootScope.prfDataFile;
              $scope.userDataLoaded = true;
              $scope.usersloaded = true;
              vm.uploadedFile = undefined;
            }).catch(CatchError);
          }).catch(CatchError);
        }).catch(CatchError);
      }).catch(CatchError);
    };

    function UserwithvisaexpiryFunc() {

      console.log("UserwithvisaexpiryFunc");
      $scope.usersloaded = false;
      dataService.newToken().then(function (response) {
        dataService.userwithvisaexpiry().then(function (response) {
          $scope.expiringUsersVisa = response.data;

          $scope.userDataLoaded = true;
          $scope.usersloaded = true;
          var ViewIcon = function ViewIcon(cell, formatterParams, onRendered) {
            return "<button class='btn btn-sm btn-primary p-0 pl-2 pr-2' style='font-size: 11px;width: 65px;margin: auto;'><i class='fas fa-envelope' style='font-size: 11px;'></i> Notify</button>";
          };
          $timeout(function () {
            expiringUsersVisaTabl = new Tabulator('#expiringUsersVisa', {
              data: $scope.expiringUsersVisa,
              height: heightCanBe,
              layout: 'fitColumns',
              pagination: 'local',
              paginationSize: 20,
              paginationSizeSelector: [20, 30, 40, 50],
              groupBy: '',
              groupStartOpen: true,
              groupToggleElement: 'header',
              selectable: false,
              clipboard: false,
              clipboardCopyStyled: false,
              persistence: {
                sort: true,
                filter: true,
                columns: true
              },
              tooltips: true,
              tooltipsHeader: true,
              persistenceID: "expiringUsersVisapersistenceID",
              columns: [{
                formatter: 'rownum',
                align: 'center',
                width: 40,
                sorter: false
              }, {
                title: 'Name',
                field: 'DisplayName',
                width: 200
              }, {
                title: 'Email',
                field: 'UserName'
              }, {
                title: 'WorkAuth',
                field: 'WorkAuth'
              }, {
                title: 'Work Auth Start Date',
                field: 'WorkAuthStartDate',
                formatter: 'datetime',
                formatterParams: {
                  inputFormat: 'YYYY-MM-DD',
                  outputFormat: 'MM/DD/YYYY',
                  invalidPlaceholder: 'n/a'
                }
              }, {
                title: 'Work Auth End Date',
                field: 'WorkAuthEndDate',
                formatter: 'datetime',
                formatterParams: {
                  inputFormat: 'YYYY-MM-DD',
                  outputFormat: 'MM/DD/YYYY',
                  invalidPlaceholder: 'n/a'
                }
              }, {
                formatter: ViewIcon,
                title: 'Notify',
                align: 'left',
                cellClick: function cellClick(e, cell) {
                  var data = cell.getRow();
                  $scope.notifyUser(data._row.data);
                }
              }]
            });
          });
        }).catch(CatchError);
      }).catch(CatchError);
    }
    $scope.usersmissingprfdataLoad = function () {
      $scope.usersloaded = false;
      dataService.newToken().then(function (response) {
        dataService.usersmissingprfdata().then(function (response) {
          for (var f = 0; f < response.data.length; f++) {
            if (response.data[f].WorkAuthStartDate == '0001-01-01T00:00:00' || response.data[f].WorkAuthEndDate == '0001-01-01T00:00:00') response.data[f].WorkAuthStartDate = null;
            response.data[f].WorkAuthEndDate = null;
          }
          $scope.incompleteProfileData = response.data;
          $scope.userDataLoaded = true;
          $scope.usersloaded = true;
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.LoadWorkAuthList = function () {
      dataService.newToken().then(function (response) {
        dataService.WorkAuthList().then(function (response) {
          $scope.WAuthList = response.data;

          $scope.WAuthListLoaded = true;
          $scope.LoadUsersByWorkAuth($scope.WAuthList[0]);
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.LoadUsersByWorkAuth = function (wAuth) {
      $scope.WorkAuthUsersLoaded = false;
      $scope.selectedWorkAuth = wAuth;
      var reqObj = {
        wrkauthkey: wAuth.WorkAuth
      };

      dataService.newToken().then(function (response) {
        dataService.UsersByWorkAuth(reqObj).then(function (response) {
          $scope.WAuthListLoaded = true;
          $scope.WorkAuthUsers = response.data;
          $scope.WorkAuthUsersLoaded = true;
          $timeout(function () {
            var ViewIcon = function ViewIcon(cell, formatterParams, onRendered) {
              return "<button class='btn btn-sm btn-primary p-0 pl-2 pr-2' style='font-size: 11px; width: 65px;margin: auto;'><i class='fas fa-eye' style='font-size: 11px;'></i> View</button>";
            };
            if (UsersByWorkAuthTb !== undefined) {
              $(".WAuths").click(function () {
                $(".WAuths").removeClass("active");
                $(this).addClass("active");
              });
              UsersByWorkAuthTb.setData($scope.WorkAuthUsers);
            } else {
              $(".WAuths").click(function () {
                $(".WAuths").removeClass("active");
              });
              UsersByWorkAuthTb = new Tabulator('#WorkAuthUsers', {
                height: heightCanBe,
                layout: 'fitColumns',
                pagination: 'local',
                paginationSize: 20,
                paginationSizeSelector: [20, 30, 40, 50],
                groupBy: '',
                groupStartOpen: false,
                groupToggleElement: 'header',
                selectable: false,
                clipboard: false,
                clipboardCopyStyled: false,
                persistence: {
                  sort: true,
                  filter: true,
                  columns: true
                },
                tooltips: true,
                tooltipsHeader: true,
                persistenceID: "WorkAuthUserspersistenceID",
                columns: [{
                  formatter: 'rownum',
                  align: 'center',
                  width: 40,
                  sorter: false
                }, {
                  title: 'Name',
                  field: 'FirstName',
                  width: 200
                }, {
                  title: 'Email',
                  field: 'UserName'
                }, {
                  title: 'WorkAuth',
                  field: 'CurrentWorkAuth'
                }, {
                  title: 'Work Auth Start Date',
                  field: 'CurrentWorkAuthStartDate',
                  formatter: 'datetime',
                  formatterParams: {
                    inputFormat: 'YYYY-MM-DD',
                    outputFormat: 'MM/DD/YYYY',
                    invalidPlaceholder: 'n/a'
                  }
                }, {
                  title: 'Work Auth End Date',
                  field: 'CurrentWorkAuthEndDate',
                  formatter: 'datetime',
                  formatterParams: {
                    inputFormat: 'YYYY-MM-DD',
                    outputFormat: 'MM/DD/YYYY',
                    invalidPlaceholder: 'n/a'
                  }
                }, {
                  formatter: ViewIcon,
                  title: 'View',
                  align: 'left',
                  cellClick: function cellClick(e, cell) {
                    var data = cell.getRow();
                    $scope.downloadWorkAuth(data._row.data);
                  }
                }]
              });
              UsersByWorkAuthTb.setData($scope.WorkAuthUsers);
            }
          });
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.downloadWorkAuth = function (data) {
      $scope.docData = data;
      $mdDialog.show({
        controller: fileViewerlDialogController,
        templateUrl: 'app/components/hr/hrDashboard/fileViewer.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          docData: $scope.docData
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function fileViewerlDialogController($scope, docData) {
      $scope.startLoader = true;
      // var Filename = docData.CurrentWorkAuthUrl.split('~#')[2];
      if (docData.CurrentWorkAuthUrl === undefined) {
        docData.CurrentWorkAuthUrl = docData.WorkAuthUrl;
      }
      var reqObj = {
        loginid: docData.LoginId,
        FileUrl: docData.CurrentWorkAuthUrl
      };
      var result = docData.CurrentWorkAuthUrl.split('~#')[2].split('.');
      var fileType = result[result.length - 1];

      dataService.newToken().then(function (response) {
        dataService.GetWorkAuthFile(reqObj).then(function (response, status, headers) {
          if (fileType == 'jpg' || fileType == 'png') {
            var ctsImgData = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, ''));
            var elImg = $('#ctsImgViewWrapper');
            elImg.attr('src', 'data:application/pdf;base64,' + ctsImgData);
            $scope.startLoader = false;
          } else {
            var ctsPdfData = new Blob([new Uint8Array(response.data)], {
              type: 'application/pdf'
            });

            $scope.pdfUrl = URL.createObjectURL(ctsPdfData);
            var elPdf = $('#ctsViewFile');
            elPdf.attr('src', $scope.pdfUrl);
            $scope.startLoader = false;
          }
        }).catch(CatchError);
      }).catch(CatchError);
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
    }

    $scope.showProjectsOfUser = function (data) {
      $scope.userProjsData = data;
      $mdDialog.show({
        controller: showProjectsOfUserlDialogController,
        templateUrl: 'app/components/hr/hrDashboard/showProjectsOfUserlDialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        escapeToClose: false,
        fullscreen: true,
        locals: {
          userProjsData: $scope.userProjsData
        }
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function loadData($q) {
      var promiseClients = dataService.GetClientsInfo();
      var promiseVendors = dataService.GetVendorInfo();
      var promiseMarketers = dataService.GetMarketerInfo();
      var promiseTitles = dataService.GetTitleDD();

      return $q.all([promiseClients, promiseVendors, promiseMarketers, promiseTitles]);
    }

    function showProjectsOfUserlDialogController($scope, userProjsData, $q, $rootScope) {
      $scope.userData = userProjsData;
      $scope.tokenData = angular.fromJson(localStorage.getItem('tokenData'));
      $scope.ProjectDetails = $scope.userData.LstProjCodes[0];
      $scope.setProjectDetails = function (data) {
        $scope.ProjectDetails = data;
      };
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.endForStartDate = function (data) {
        var date = moment(data);
        $scope.minStartdate = new Date(date.add(1, 'days').format('MM/DD/YYYY'));
      };
      $scope.ngShowhide = false;
      $scope.ngShowhidemethod = function (flag) {
        if (flag) {
          $scope.ngShowhide = false;
        } else {
          $scope.ngShowhide = true;
        }
      };
      $scope.ngShowhide2 = false;
      $scope.ngShowhidemethod2 = function (flag) {
        if (flag) {
          $scope.ngShowhide2 = false;
        } else {
          $scope.ngShowhide2 = true;
        }
      };
      $scope.addClientShow = false;
      $scope.addClientAddrShow = false;
      $scope.dataLoaded = false;
      $scope.newProject = false;
      $scope.HrsRateEditReq = false;
      $scope.projectEndDateReq = false;
      $scope.payRateHistoryData = false;

      $scope.newProjectemethod = function (flag) {
        $scope.newProjectDetails = {
          RefByNAME: null,
          BillRate: null,
          StartDate: null,
          MarkterName: null,
          MarkterId: null
        };

        $scope.selectedClient = null;
        $scope.ClientAddress = null;
        $scope.selectedVendor = null;
        $scope.VendorAddress = null;
        if (flag) {
          $scope.newProject = false;
        } else {
          $scope.newProject = true;
        }
        dataService.newToken().then(function (response) {
          loadData($q).then(function (resp) {
            $scope.Clients = resp[0].data;
            $scope.Vendors = resp[1].data;
            $scope.Marketers = resp[2].data;
            $scope.titles = resp[3].data;
            $scope.dataLoaded = true;

            $scope.getSelectedText = function () {
              if ($scope.selectedItem !== undefined) {
                return 'You have selected: Item ' + $scope.selectedItem;
              } else {
                return 'Please Select End Client';
              }
            };

            $scope.newClient = function newClient(flag) {
              $mdSelect.hide();
              $scope.addClient = {
                ClientName: null,
                ClientAddress: null
              };

              if (flag) {
                $scope.addClientShow = false;
              } else {
                $scope.addClientShow = true;
              }
            };

            $scope.addClientData = function (clientData) {
              $mdSelect.hide();

              $scope.notifier = true;
              $scope.afterAddedClient = false;
              dataService.newToken().then(function (response) {
                dataService.AddClient(clientData).then(function (response) {
                  if (response.statusText == 'OK') {
                    dataService.newToken().then(function (response) {
                      dataService.GetClientsInfo().then(function (response) {
                        $scope.selectedClient = undefined;
                        $scope.Clients = response.data;
                        $scope.afterAddedClient = true;
                        $timeout(function () {
                          $scope.addClientShow = false;
                          $scope.notifier = false;
                          $scope.afterAddedClient = false;
                        }, 1500);
                      }).catch(CatchError);
                    });
                  } else {
                    var toast = $mdToast.simple().content('oops !, Something went wrong please try again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                    $mdToast.show(toast);
                    $mdDialog.cancel();
                  }
                }).catch(CatchError);
              }).catch(CatchError);
            };

            $scope.newClientAddress = function newClientAddress(flag) {
              $mdSelect.hide();
              if (flag) {
                $scope.addClientAddrShow = false;
              } else {
                $scope.addClientAddrShow = true;
              }
            };

            $scope.selectedClientAddr = function (id) {
              for (var g = 0; g < $scope.Clients.length; g++) {
                if ($scope.Clients[g].ClientId === id) {
                  $scope.selectedClientAddresses = $scope.Clients[g].ClientAddress;
                }
              }
            };

            $scope.addClientAddrsData = function (data) {
              $scope.notifier = true;

              var obj = {
                ClientId: $scope.selectedClient,
                ClientAddress: [{
                  Address: data.ClientAddress
                }]
              };
              dataService.newToken().then(function (response) {
                dataService.AddClientAddress(obj).then(function (res) {
                  if (res.statusText == 'OK') {
                    $scope.Clients = res.data;
                    for (var b = 0; b < res.data.length; b++) {
                      if (res.data[b].ClientId === $scope.selectedClient) {
                        // $scope.selectedClient = res.data[b].ClientId;
                        $scope.selectedClientAddresses = res.data[b].ClientAddress;
                        break;
                      }
                    }
                    dataService.newToken().then(function (response) {
                      dataService.GetClientsInfo().then(function (response) {
                        $scope.endClients = response.data;
                        $scope.afterAddedClientAddr = true;
                        $timeout(function () {
                          $scope.addClientAddrShow = false;
                          $scope.notifier = false;
                          $scope.afterAddedClientAddr = false;
                        }, 1500);
                      }).catch(CatchError);
                    });
                  } else {
                    var toast = $mdToast.simple().content('oops !, Something went wrong please try again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                    $mdToast.show(toast);
                    $mdDialog.cancel();
                  }
                }).catch(CatchError);
              }).catch(CatchError);
            };

            $scope.newvendor = function newvendor(flag) {
              $mdSelect.hide();
              if (flag) {
                $scope.addVendorShow = false;
              } else {
                $scope.addVendorShow = true;
              }
            };

            $scope.addVendorData = function (vendorData) {
              $scope.notifier = true;
              dataService.newToken().then(function (response) {
                dataService.AddVendor(vendorData).then(function (response) {
                  if (response.statusText == 'OK') {
                    dataService.newToken().then(function (response) {
                      dataService.GetVendorInfo().then(function (response) {
                        $scope.selectedVendor = undefined;
                        $scope.Vendors = response.data;
                        $scope.afterAddedVendor = true;
                        $timeout(function () {
                          $scope.addVendorShow = false;
                          $scope.notifier = false;
                          $scope.afterAddedVendor = false;
                        }, 1500);
                      }).catch(CatchError);
                    });
                  } else {
                    var toast = $mdToast.simple().content('oops !, Something went wrong please try again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                    $mdToast.show(toast);
                    $mdDialog.cancel();
                  }
                }).catch(CatchError);
              }).catch(CatchError);
            };
            $scope.selectedVendorAddr = function (id) {
              for (var g = 0; g < $scope.Vendors.length; g++) {
                if ($scope.Vendors[g].VendorId === id) {
                  $scope.selectedVendorAddresses = $scope.Vendors[g].VendorAddress;
                }
              }
            };

            $scope.newVendorAddress = function newVendorAddress(flag) {
              $mdSelect.hide();
              if (flag) {
                $scope.addVendorAddressShow = false;
              } else {
                $scope.addVendorAddressShow = true;
              }
            };
            $scope.addVendorAddrsData = function (data) {
              $scope.notifier = true;

              var obj = {
                VendorId: $scope.selectedVendor,
                VendorAddress: [{
                  Address: data.VendorAddress
                }]
              };
              dataService.newToken().then(function (response) {
                dataService.AddVendorAddress(obj).then(function (res) {
                  for (var k = 0; k < res.data.length; k++) {
                    if (res.data[k].VendorId == $scope.selectedVendor) {
                      $scope.selectedVendorAddresses = res.data[k].VendorAddress;
                    }
                  }
                  if (res.statusText == 'OK') {
                    dataService.newToken().then(function (response) {
                      dataService.GetVendorInfo().then(function (response) {
                        $scope.Vendors = response.data;
                        $scope.afterAddedVendorAddr = true;
                        $timeout(function () {
                          $scope.addVendorAddressShow = false;
                          $scope.notifier = false;
                          $scope.afterAddedVendorAddr = false;
                        }, 1500);
                      }).catch(CatchError);
                    });
                  } else {
                    var toast = $mdToast.simple().content('oops !, Something went wrong please try again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                    $mdToast.show(toast);
                    $mdDialog.cancel();
                  }
                }).catch(CatchError);
              }).catch(CatchError);
            };

            //self.marketerInfo = response.data;

            $scope.addTitle = function (flag) {
              $mdSelect.hide();
              $mdSelect.hide();
              if (flag) {
                $scope.addTitleShow = false;
              } else {
                $scope.addTitleShow = true;
              }
            };

            $scope.addTitleSubmit = function (data) {
              $mdSelect.hide();
              $scope.notifier = true;
              dataService.newToken().then(function (response) {
                dataService.AddTitle(data).then(function (response) {
                  if (response.data == 'Title Added Sucessfully!.') {
                    dataService.newToken().then(function (response) {
                      dataService.GetTitleDD().then(function (response) {
                        $scope.titles = response.data;
                        $scope.afterAddedTitle = true;
                        $timeout(function () {
                          $scope.addTitleShow = false;
                          $scope.notifier = false;
                        }, 1500);
                      }).catch(CatchError);
                    });
                  } else {
                    var toast = $mdToast.simple().content('oops !, Something went wrong please try again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                    $mdToast.show(toast);
                    $mdDialog.cancel();
                  }
                }).catch(CatchError);
              }).catch(CatchError);
            };

            $scope.addmarketer = function addmarketer(flag) {
              $mdSelect.hide();
              if (flag) {
                $scope.addMarketerShow = false;
              } else {
                $scope.addMarketerShow = true;
              }
            };

            $scope.addMarketerData = function (MarketerData) {
              $mdSelect.hide();
              $scope.notifier = true;

              dataService.newToken().then(function (response) {
                dataService.addmarketer(MarketerData).then(function (response) {
                  self.marketerInfo = response.data;
                  if (response.statusText == 'OK') {
                    dataService.newToken().then(function (response) {
                      dataService.GetMarketerInfo().then(function (response) {
                        $scope.Marketers = response.data;
                        $scope.afterAddedMarketer = true;
                        $timeout(function () {
                          $scope.addMarketerShow = false;
                          $scope.notifier = false;
                        }, 1500);
                      }).catch(CatchError);
                    });
                  } else {
                    var toast = $mdToast.simple().content('oops !, Something went wrong please try again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                    $mdToast.show(toast);
                    $mdDialog.cancel();
                  }
                }).catch(CatchError);
              }).catch(CatchError);
            };
          });
        }.catch(CatchError));
      };

      $scope.ProjectDetailsHrsRate = function (data) {
        $scope.notifier = true;

        var vendorId;
        dataService.newToken().then(function (response) {
          loadData($q).then(function (resp) {
            $scope.Clients = resp[0].data;
            $scope.Vendors = resp[1].data;
            $scope.Marketers = resp[2].data;
            $scope.titles = resp[3].data;
            for (var p = 0; p < $scope.Vendors.length; p++) {
              if ($scope.Vendors[p].VendorName == data.VendorCompanyName) {
                vendorId = $scope.Vendors[p].VendorId;
                break;
              }
            }
            var obj = {
              ProjId: data.ProjectID,
              NewPayRate: data.HourlyRate,
              PaytermId: data.PayTermId,
              PrevProjEndDate: data.PrevProjEndDate,
              NewProjStartDate: data.NewProjStartDate,
              IsActive: true,
              IsHourlyEdit: true, //This should be true when user clicks on hourly edit.
              loginid: $scope.tokenData.loginid,
              VendorId: vendorId,
              Prfid: data.Prfid
            };
            dataService.newToken().then(function (response) {
              dataService.UpdateProjInfo(obj).then(function (response) {
                if (response.statusText == 'OK') {
                  $scope.HrsRateEditReq = true;
                  $timeout(function () {
                    $scope.ngShowhide2 = false;
                    $scope.notifier = false;
                    $scope.HrsRateEditReq = false;
                  }, 1500);
                }
              }).catch(CatchError);
            }).catch(CatchError);
          });
        }).catch(CatchError);
      };
      $scope.payRateHistoryspinner = false;

      $scope.payRateHistoryReq = function (ProjId) {
        $scope.payRateHistoryspinner = true;
        var obj = {
          ProjId: ProjId
        };
        dataService.newToken().then(function (response) {
          dataService.BillhistbyProjid(obj).then(function (response) {
            $scope.payRateHistory = response.data;
            $scope.payRateHistoryData = true;
          }).catch(CatchError);
        }).catch(CatchError);
      };

      $scope.ProjectDetailsSubmit = function (data) {
        $scope.notifier = true;

        var vendorId;
        dataService.newToken().then(function (response) {
          loadData($q).then(function (resp) {
            $scope.Clients = resp[0].data;
            $scope.Vendors = resp[1].data;
            $scope.Marketers = resp[2].data;
            $scope.titles = resp[3].data;
            // for (var p = 0; p < $scope.Vendors.length; p++) {
            //     if ($scope.Vendors[p].VendorName == $scope.ProjectDetails.VendorCompanyName) {
            //         vendorId = $scope.Vendors[p].VendorId;
            //         break;
            //     }
            // }
            data.ProjectCompleted = !data.ProjectCompleted;
            var obj = {
              ProjId: $scope.ProjectDetails.ProjectID,
              NewPayRate: null,
              PaytermId: $scope.ProjectDetails.PayTermId,
              PrevProjEndDate: data.ProjectEndDate,
              NewProjStartDate: null,
              IsActive: data.ProjectCompleted,
              IsHourlyEdit: false, //This should be true when user clicks on hourly edit.
              loginid: $scope.tokenData.loginid,
              VendorId: $scope.ProjectDetails.VendorId,
              Prfid: $scope.ProjectDetails.Prfid,
              TitleId: data.title
            };
            dataService.newToken().then(function (response) {
              dataService.UpdateProjInfo(obj).then(function (response) {
                if (response.statusText == 'OK') {
                  $scope.ProjectDetails.ProjectEndDate = data.ProjectEndDate;
                  $scope.projectEndDateReq = true;
                  $timeout(function () {
                    $scope.ngShowhide = false;
                    $scope.notifier = false;
                    $scope.projectEndDateReq = false;
                  });
                }
              }).catch(CatchError);
            }).catch(CatchError);
          });
        }).catch(CatchError);
      };

      $scope.newProjectDetailsSubmit = function (data, selectedClient, ClientAddress, selectedVendor, VendorAddress) {
        $scope.projectCreateStart = true;
        // $scope.projectCreateMessage = true;
        var reqConstrct = {
          RefByNAME: data.RefByNAME,
          IsActive: true,
          VendorAddrId: VendorAddress,
          Service: 'string',
          BillRate: data.BillRate,
          StartDate: data.StartDate,
          EndDate: undefined,
          MarkterName: data.Marketer.MarkterName,
          MarkterId: data.Marketer.MarketerId,
          VendorId: selectedVendor,
          prfid: $scope.userData.EmpId,
          loggedinuserid: $scope.tokenData.loginid,
          ClientId: selectedClient,
          ClientAddrId: ClientAddress,
          TitleId: data.title
        };
        dataService.newToken().then(function (response) {
          dataService.CreateProjCode(reqConstrct).then(function (response) {
            if (response.statusText == 'OK') {
              var newProjectCode = response.data.ProjectID;
              var projectAddedEmpId = response.data.EmpId;
              dataService.newToken().then(function (response) {
                dataService.GetConslWithProjCodes().then(function (getRes) {
                  $rootScope.$broadcast('usersByProjectsCast', getRes.data);
                  //$scope.usersByProjects = getRes.data;
                  for (var r = 0; r < getRes.data.length; r++) {
                    if (projectAddedEmpId === getRes.data[r].EmpId) {
                      $scope.userData = getRes.data[r];
                      $scope.ProjectDetails = $scope.userData.LstProjCodes[0];
                    }
                  }

                  $scope.projectCreateMessage = true;
                  $scope.projectCreateStart = false;
                  $timeout(function () {
                    $scope.newProject = false;
                    $scope.projectCreateMessage = false;
                  }, 3000);
                }).catch(CatchError);
              }).catch(CatchError);
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
      $scope.cancelCustomDialog = function () {
        $scope.ngShowhide = false;
      };
    }

    $scope.$on('usersByProjectsCast', function (evt, data) {
      $scope.usersByProjects = data;
    });

    $scope.projectCreateStart = false;

    $scope.selectedIndex = 0;
    $scope.searched = function (searchUsers) {
      if (searchUsers === '') {
        $scope.itemsPerPage = 10;
      } else {
        $scope.itemsPerPage = $scope.usersList.length;
      }
    };
    $scope.notifyUser = function (user) {
      var obj = [];
      obj.push(user);
      $scope.notifyUsers(obj);
    };

    $scope.notifyUsers = function (users) {
      $scope.users = users;
      $mdDialog.show({
        controller: hrDashboardEmailDialogController,
        templateUrl: 'app/components/hr/hrDashboard/hrDashboardEmailDialogController.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          users: $scope.users
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function hrDashboardEmailDialogController($scope, $mdDialog, users) {
      $scope.users = users;
      $scope.mailer = {};
      var emails;
      if ($scope.users.length > 1) {
        emails = '';
        for (var t = 0; t < users.length; t++) {
          if (users.length - 1 === t) {
            emails += users[t].UserName;
          } else {
            emails += users[t].UserName + ';';
          }
        }
      } else {
        emails = $scope.users[0].UserName;
        $scope.mailer.Subject = $scope.users[0].emailcontent.Subject;
        $scope.mailer.Body = $scope.users[0].emailcontent.Body;
        $scope.mailer.Body = $scope.mailer.Body.replace('@@EmployeeName', $scope.users[0].DisplayName);
        $scope.mailer.Body = $scope.mailer.Body.replace('@@Date', moment($scope.users[0].WorkAuthEndDate).format('MM/DD/YYYY'));
      }
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.notifier = false;
      $scope.mailer.Recipient = emails;
      $scope.sendNotifyEmail = function (mailData) {
        $scope.notifier = true;
        dataService.newToken().then(function (response) {
          dataService.SendNotification(mailData).then(function (response) {
            if (response.data === true) {
              $mdDialog.cancel();
              var toast = $mdToast.simple().content('Notifications sent Successfully').action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
            } else {
              $mdDialog.cancel();
              var errtoast = $mdToast.simple().content('oops,Something wentwrong. Try again').action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(errtoast);
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }

    // Upload Work Auths

    $scope.clearWUpload = function () {
      vm.uploadedFile = undefined;
      $rootScope.prfDataFile = undefined;
    };
    $scope.fileDatW = function (prfData, prfDataFile, ev) {
      if (prfDataFile !== undefined) {
        var ext = prfDataFile.name.substring(prfDataFile.name.lastIndexOf('.') + 1);
        if ($rootScope.prfDataFile !== undefined && (ext.toLowerCase() == 'png' || ext.toLowerCase() == 'jpg' || ext.toLowerCase() == 'pdf')) {
          vm.uploadedFile = $rootScope.prfDataFile;
        } else {
          $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#usersmissingprfd'))).clickOutsideToClose(true).title('File Type Not Supported').textContent('Supported file types are JPG, PNG, PDF.').ariaLabel('File Type Not Supported').ok('Got it!').targetEvent(ev));
        }
      }
    };
    $scope.showAddngHis = false;
    $scope.showHis = false;
    $scope.loadingHis = false;
    $scope.usersUploadWorkAuths = function () {
      $scope.loadingHis = true;
      $scope.showAddngHis = false;
      vm.uploadedFile = undefined;
      $scope.usersloaded = false;
      $scope.showHis = false;
      dataService.newToken().then(function (response) {
        dataService.GetAllUsers().then(function (response) {
          for (var index = 0; index < response.data.length; index++) {
            var element = response.data[index];
            element.FullName = element.FirstName + ' ' + element.LastName;
          }
          $scope.AllUsers = response.data;
          $scope.loadingHis = false;
          $scope.userDataLoaded = true;
          $scope.usersloaded = true;
          var ViewIcon = function ViewIcon(cell, formatterParams, onRendered) {
            return "<button class='btn btn-sm btn-primary p-0 pl-2 pr-2' style='font-size: 11px;width: 95px;margin: auto;'>View history</button>";
          };

          $timeout(function () {
            AllUsersTb = new Tabulator('#AllUsers', {
              data: $scope.AllUsers,
              height: heightCanBe,
              layout: 'fitColumns',
              pagination: 'local',
              paginationSize: 20,
              paginationSizeSelector: [20, 30, 40, 50],
              groupBy: '',
              groupStartOpen: false,
              groupToggleElement: 'header',
              selectable: false,
              clipboard: false,
              clipboardCopyStyled: false,
              persistence: {
                sort: true,
                filter: true,
                columns: true
              },
              tooltips: true,
              tooltipsHeader: true,
              persistenceID: "AllUserspersistenceID",
              rowClick: function rowClick(e, row) {
                //e - the click event object
                //row - row component
                $scope.selectedUserToArch(row._row.data);
              },
              columns: [{
                formatter: 'rownum',
                align: 'center',
                width: 40,
                sorter: false
              }, {
                title: 'Name',
                field: 'FullName',
                width: 200
              }, {
                title: 'Status',
                field: 'EnableUser',
                formatter: function formatter(cell) {
                  if (cell._cell.value) {
                    return "Active";
                  } else {
                    return "Inactive";
                  }
                }
              }, {
                formatter: ViewIcon,
                title: 'Notify',
                align: 'left',
                cellClick: function cellClick(e, cell) {
                  var data = cell.getRow();
                  $scope.selectedUserToArch(data._row.data);
                }
              }]
            });
          });
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.newWa = false;
    $scope.newWaChange = function () {
      $scope.ctrl = {};
      $scope.files = [];
      $scope.$watch('newWASubForm', function (newWASubForm) {
        if (newWASubForm) {
          $scope.newWASubForm.$setPristine();
        }
      });
      $scope.newWa = true;
    };
    $scope.selectedUserToArch = function (user) {
      $scope.loadingHis = true;
      $scope.newWa = false;
      $scope.UserWAHistory = [];
      dataService.newToken().then(function (response) {
        dataService.GetWorkAuthHistroyById({
          prfid: user.PrfId
        }).then(function (response) {
          $scope.selectedUser = user;
          for (var index = 0; index < response.data.length; index++) {
            var element = response.data[index];
            response.data[index].LoginId = user.LoginId;
            response.data[index].WaType = _.filter($scope.workAuthTypes, function (v) {
              return _.includes([element.WorkAuthId], v.WrkAuthId);
            })[0].WrkAuth;
          }
          $scope.UserWAHistory = response.data;
          var ViewIcon = function ViewIcon(cell, formatterParams, onRendered) {
            return "<button class='btn btn-sm btn-primary p-0 pl-2 pr-2' style='font-size: 11px; width: 65px;margin: auto;'><i class='fas fa-eye' style='font-size: 11px;'></i> View</button>";
          };
          $timeout(function () {
            expiringUsersVisaTabl = new Tabulator('#UserWAHistory', {
              data: $scope.UserWAHistory,
              layout: 'fitColumns',
              pagination: 'local',
              paginationSize: 20,
              paginationSizeSelector: [20, 30, 40, 50],
              groupBy: '',
              groupStartOpen: false,
              groupToggleElement: 'header',
              selectable: false,
              clipboard: false,
              clipboardCopyStyled: false,
              rowClick: function rowClick(e, row) {
                //e - the click event object
                //row - row component
                $scope.selectedUserToArch(row._row.data);
              },
              persistence: {
                sort: true,
                filter: true,
                columns: true
              },
              tooltips: true,
              tooltipsHeader: true,
              persistenceID: "UserWAHistorypersistenceID",
              columns: [{
                formatter: 'rownum',
                align: 'center',
                width: 40,
                sorter: false
              }, {
                title: 'Name',
                field: 'WaType',
                width: 200
              }, {
                title: 'Work Auth Start Date',
                field: 'WrkAuthStartDate',
                formatter: 'datetime',
                formatterParams: {
                  inputFormat: 'YYYY-MM-DD',
                  outputFormat: 'MM/DD/YYYY',
                  invalidPlaceholder: 'n/a'
                }
              }, {
                title: 'Work Auth Start Date',
                field: 'WrkAuthEndDate',
                formatter: 'datetime',
                formatterParams: {
                  inputFormat: 'YYYY-MM-DD',
                  outputFormat: 'MM/DD/YYYY',
                  invalidPlaceholder: 'n/a'
                }
              }, {
                title: 'Uploaded on',
                field: 'CreateDate',
                formatter: 'datetime',
                formatterParams: {
                  inputFormat: 'YYYY-MM-DD',
                  outputFormat: 'MM/DD/YYYY',
                  invalidPlaceholder: 'n/a'
                }
              }, {
                title: 'CreateDate',
                field: 'CreateDate',
                formatter: 'datetime',
                formatterParams: {
                  inputFormat: 'YYYY-MM-DD',
                  outputFormat: 'MM/DD/YYYY',
                  invalidPlaceholder: 'n/a'
                }
              }, {
                formatter: ViewIcon,
                title: 'View Document',
                align: 'left',
                cellClick: function cellClick(e, cell) {
                  var data = cell.getRow();
                  $scope.downloadWorkAuth(data._row.data);
                }
              }]
            });
          });
          $scope.showAddngHis = true;
          $scope.showHis = true;
          $scope.loadingHis = false;
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.removeFile = function (element) {
      $scope.files = [];
      $scope.EnableBtn = false;
    };
    $scope.invalidFileTypes = false;

    $scope.setFiles = function (element) {
      $scope.$apply(function (scope) {
        $scope.AttachStatus = '';
        $scope.files = [];
        for (var i = 0; i < element.files.length; i++) {
          var fileType = element.files[i].type.toLowerCase();
          if (fileType === "image/jpg" || fileType === "image/png" || fileType === "application/pdf") {
            $scope.files.push(element.files[i]);
            $scope.invalidFileTypes = false;
          } else {
            $scope.invalidFileTypes = true;
            $scope.files = [];
            element = undefined;
            break;
          }
        }
        if ($scope.files.length > 0) {
          $scope.EnableBtn = true;
        }
        $scope.progressVisible = false;
      });
    };
    $scope.ctrl = {};
    $scope.addWaLoader = false;
    $scope.newWASub = function (selectedUser, data) {
      $scope.addWaLoader = true;
      $scope.loadingHis = true;
      var fData = new FormData();
      fData.append('LoginId', selectedUser.LoginId);
      fData.append('prfid', selectedUser.PrfId);
      fData.append('WrkAuthId', $scope.ctrl.WrkAuthId);
      fData.append('WrkAuthStartDate', moment($scope.ctrl.WrkAuthStartDate).format('MM/DD/YYYY'));
      fData.append('WrkAuthEndDate', moment($scope.ctrl.WrkAuthEndDate).format('MM/DD/YYYY'));
      for (var index = 0; index < $scope.files.length; index++) {
        var element = $scope.files[index];
        fData.append('file', $scope.files[index]);
      }

      dataService.newToken().then(function (response) {
        dataService.InsertWorkAuth(fData).then(function (response) {
          dataService.newToken().then(function (response) {
            dataService.GetWorkAuthHistroyById({
              prfid: selectedUser.PrfId
            }).then(function (response) {
              for (var index = 0; index < response.data.length; index++) {
                var element = response.data[index];
                response.data[index].LoginId = selectedUser.LoginId;
                response.data[index].WaType = _.filter($scope.workAuthTypes, function (v) {
                  return _.includes([element.WorkAuthId], v.WrkAuthId);
                })[0].WrkAuth;
              }
              $scope.UserWAHistory = response.data;
              $scope.loadingHis = false;
              $scope.ctrl = {};
              $scope.files = [];
              $scope.$watch('newWASubForm', function (newWASubForm) {
                if (newWASubForm) {
                  $scope.newWASubForm.$setPristine();
                }
              });
              $scope.addWaLoader = false;
              $timeout(function () {
                var uTable = $('.UserWAHistory').DataTable({
                  retrieve: true,
                  paging: false,
                  lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, 'All']],
                  dom: 'lBfrtip',
                  buttons: ['copyHtml5', 'excelHtml5', 'csvHtml5', 'pdfHtml5']
                });
                uTable.on('order.dt search.dt', function () {
                  uTable.column(0, {
                    search: 'applied',
                    order: 'applied'
                  }).nodes().each(function (cell, i) {
                    cell.innerHTML = i + 1;
                  });
                }).draw();
              });
              $scope.newWa = false;
            }).catch(CatchError);
          }).catch(CatchError);
        }).catch(CatchError);
      }).catch(CatchError);
    };

    $scope.downloadDoc = function (user) {
      var reqObj = {
        loginid: user.LoginId,
        FileUrl: user.WorkAuthUrl
      };

      dataService.newToken().then(function (response) {
        dataService.GetWorkAuthFile(reqObj).then(function (response, status, headers) {
          var base64 = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
            return data + String.fromCharCode(byte);
          }, ''));
          var anchor = $('<a/>');
          anchor.attr({
            href: 'data:application/octet-stream; base64,' + base64,
            target: '_blank',
            download: user.WorkAuthUrl
          })[0].click();
        }).catch(CatchError);
      }).catch(CatchError);
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("createuser", {
    controller: CreateUser,
    controllerAs: "vm",
    templateUrl: "app/components/hr/createUser/createUser.html"
  });

  function CreateUser($scope, dataService, $q, $http, $timeout, $mdToast, $mdDialog, $mdSelect, $rootScope, $element, moment, $state) {
    var vm = this;
    $scope.tokenData = angular.fromJson(localStorage.getItem("tokenData"));
    $scope.loginLoader = false;
    $scope.successPage = false;
    $scope.errorPage = false;
    $scope.createUserData = {};
    $scope.maxDate = new Date();
    $scope.usernames = [];
    $scope.newUserData = {};
    $scope.disableTsapprover = false;
    $scope.loader = false;
    $scope.showForm = true;
    $scope.successPage = false;

    $element.find("input").on("keydown", function (ev) {
      ev.stopPropagation();
    });
    $scope.clearSearchTerm = function () {
      $scope.searchTitle = "";
    };
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };
    function initData($q) {
      return $q.all([dataService.GetTitleDD(), dataService.xreflkup(), dataService.GetClientsInfo(), dataService.GetVendorInfo(), dataService.GetMarketerInfo(), dataService.GetManagersList()]);
    }
    dataService.newToken().then(function (response) {
      initData($q).then(function (response) {
        $scope.titles = response[0].data;
        $scope.lookups = response[1].data;
        vm.endClients = response[2].data;
        vm.VendorInfo = response[3].data;
        vm.marketerInfo = response[4].data;
        $scope.ManagersList = response[5].data;
        $scope.loginLoader = true;
        $timeout(function () {
          $(".datepicker").datepicker({
            changeMonth: true,
            changeYear: true,
            onSelect: function onSelect(dateText, inst) {
              var Els = document.getElementsByClassName("datepicker");
              var event = new Event("change");
              Array.from(Els).forEach(function (element, index, array) {
                element.dispatchEvent(event);
              });
            }
          });
        });
        new GetAllUsers();
      });
    }).catch(CatchError);
    function GetAllUsers() {
      dataService.newToken().then(function (response) {
        dataService.GetAllUsers().then(function (response) {
          angular.forEach(response.data, function (user) {
            var uname = user.UserName.toLowerCase();
            $scope.usernames.push(uname);
          });
        }).catch(CatchError);
      }).catch(CatchError);
    }
    $scope.checkUsername = function (username) {
      if (username !== undefined) {
        var uname = username.toLowerCase();
        $scope.userExists = $scope.usernames.includes(uname);
      }
    };
    if ($scope.tokenData.newRole == "Admin") {
      $scope.roles = [{
        RoleId: 1,
        RoleType: "HR"
      }, {
        RoleId: 6,
        RoleType: "Accounts"
      }];
    } else {
      $scope.roles = [{
        RoleId: "2",
        RoleType: "Marketer"
      }, {
        RoleId: "3",
        RoleType: "MarketerAdmin"
      }, {
        RoleId: "4",
        RoleType: "HR"
      }, {
        RoleId: "5",
        RoleType: "Consultant"
      }];
    }
    $scope.addTitle = function () {
      $mdSelect.hide();
      $mdDialog.show({
        controller: addTitleDialogController,
        templateUrl: "app/components/hr/createUser/addTitleDialog.html",
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = "You cancelled the dialog.";
      });

      function addTitleDialogController($scope) {
        $scope.cancel = function () {
          $mdDialog.cancel();
        };
        $scope.addTitleSubmit = function (data) {
          $scope.notifier = true;
          dataService.newToken().then(function (response) {
            dataService.AddTitle(data).then(function (response) {
              if (response.data == "Title Added Sucessfully!.") {
                dataService.newToken().then(function (response) {
                  dataService.GetTitleDD().then(function (response) {
                    $rootScope.$broadcast("titles", response.data);
                    var toast = $mdToast.simple().content("Title Added Successfully.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
                    $mdToast.show(toast);
                    $mdDialog.cancel();
                  }).catch(CatchError);
                }).catch(CatchError);
              } else {
                var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
                $mdToast.show(toast);
                $mdDialog.cancel();
              }
            }).catch(CatchError);
          }).catch(CatchError);
        };
      }
      $scope.$on("titles", function (evt, data) {
        $scope.titles = data;
      });
    };
    $scope.selectedClientAddr = function (id) {
      $scope.selectedClientAddresses = [];
      $scope.newUserData.EndCLientAddress = undefined;
      dataService.newToken().then(function (response) {
        dataService.GetClientInfoByClientId({
          ClientId: id
        }).then(function (response) {
          $scope.showEndCLientAddress = true;
          $scope.selectedClientAddresses = response.data.ClientAddress;
        });
      }).catch(CatchError);
    };
    $scope.selectedVendor = function (id) {
      $scope.newUserData.VendorAddress = undefined;
      $scope.newUserData.VendorAddressMap = null;
      $scope.selectedVendorAddresses = [];
      $scope.showVenAddr = false;
      $scope.showVenCont = false;
      dataService.newToken().then(function (response) {
        dataService.GetVendorInfoByVendorId({
          VendorId: id
        }).then(function (response) {
          $scope.showVenAddr = true;
          $scope.selectedVendorAddresses = response.data.VendorAddressInfo;
        });
      }).catch(CatchError);
    };
    $scope.selectedVendorAddr = function (data) {
      $scope.showVenCont = false;
      $timeout(function () {
        $scope.showVenCont = true;
        $scope.newUserData.VendorAddressMap = null;
        $scope.selectedAddrCont = data.VendorAcctInfo;
      });
    };
    $scope.getMarketerText = function () {
      if ($scope.selectedVendor !== undefined) {
        return "You have selected: Item " + $scope.selectedVendor;
      } else {
        return "Please select a Vendor";
      }
    };
    vm.addmarketer = function () {
      $mdSelect.hide();
      $mdDialog.show({
        controller: addmarketerDialogController,
        templateUrl: "app/components/hr/createUser/newMarketeerDialog.html",
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = "You cancelled the dialog.";
      });
    };
    function addmarketerDialogController($scope, $mdDialog) {
      $scope.marketerEmails = [];
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      angular.forEach(response.data, function (user) {
        $scope.marketerEmails.push(user.MarkterEmailAddr);
      });
      $scope.checkMarketer = function (marketer) {
        $scope.marketerExists = $scope.marketerEmails.includes(marketer);
      };
      $scope.addMarketerData = function (MarketerData) {
        $scope.notifier = true;

        dataService.newToken().then(function (response) {
          dataService.addmarketer(MarketerData).then(function (response) {
            vm.marketerInfo = response.data;
            if (response.statusText == "OK") {
              dataService.newToken().then(function (response) {
                dataService.GetMarketerInfo().then(function (response) {
                  $scope.marketerInfo = response.data;
                  var toast = $mdToast.simple().content("Marketer added successfully.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
                  $mdToast.show(toast);
                  $mdDialog.cancel();
                }).catch(CatchError);
              }).catch(CatchError);
            } else {
              var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
              $mdToast.show(toast);
              $mdDialog.cancel();
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }
    $scope.roleChanged = function (role) {
      if (role == "Employee" || role == "HR" || role == "Accounts" || role == "Admin") {
        $scope.createUserData.EmployerName = "Texperts";
        $scope.disable = true;
        if (role == "Accounts") {
          $scope.disableTsapprover = true;
          // $scope.createUserData.IsEmployee = false;
        } else {
          $scope.disableTsapprover = false;
          // $scope.createUserData.IsEmployee = false;
        }
      } else {
        $scope.disableTsapprover = false;
        $scope.createUserData.IsEmployee = false;
        $scope.createUserData.EmployerName = "";
        $scope.disable = false;
      }
    };
    $scope.createUserReq = function (createUserData, selectedClient, EndCLientAddress, selectedVendor, VendorAddress) {
      $scope.ffsub = true;
      $scope.loader = true;
      String.prototype.capitalize = function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
      };
      createUserData.FirstName = createUserData.FirstName.capitalize();
      var mgrId;
      if (createUserData.ManagerId === undefined) {
        mgrId = undefined;
      } else {
        mgrId = createUserData.ManagerId.ManagerId;
      }
      if (createUserData.IsEmployee === undefined) {
        createUserData.IsEmployee = false;
      } else {
        createUserData.IsEmployee = true;
      }

      function marketer() {
        if (createUserData.MarketerId !== undefined) {
          return createUserData.MarketerId.MarketerId;
        } else {
          return "";
        }
      }
      var roles = [];
      roles.push(createUserData.role);
      var reqObj = {
        UserName: createUserData.UserName,
        FirstName: createUserData.FirstName,
        MiddleName: createUserData.MiddleName,
        LastName: createUserData.LastName,
        Dob: createUserData.Dob,
        Cell: createUserData.Cell,
        SSN: createUserData.SSN,
        Title: createUserData.title.Title,
        TitleId: createUserData.title.TitleId,
        EmployerName: createUserData.EmployerName,
        EmployedSince: moment(createUserData.EmployedSince).format("MM/DD/YYYY"),
        EndClient: createUserData.selectedClient.ClientId,
        EndClientId: createUserData.selectedClient.ClientId,
        EndClientAddressId: createUserData.EndCLientAddress.AddrId,
        VendorId: createUserData.selectedVendor.VendorId,
        VendorAddressId: createUserData.VendorAddress.AddrId,
        MarkterId: createUserData.MarketerId.MarketerId,
        StartDate: moment(createUserData.ProjectAssignedDate).format("MM/DD/YYYY"),
        Role: createUserData.role,
        Roles: roles,
        ManagerId: createUserData.ManagerId.ManagerId,
        BillRate: createUserData.BillRate,
        IsBackOfficeEmp: createUserData.IsBackOfficeEmp,
        RefName: createUserData.RefName,
        CreatedBy: $scope.tokenData.loginid,
        loginid: $scope.tokenData.loginid,
        InvTermId: createUserData.InvTerm.InvTermId,
        PayTermId: createUserData.PayTerm,
        VendorAddrMapId: createUserData.VendorAddressMap.VendorAddrMapId
      };
      bootbox.prompt({
        title: "Confirm Notifications",
        centerVertical: true,
        message: "<p>Do you want to send notification email to Accounts/Admin:</p>",
        inputType: "radio",
        inputOptions: [{
          text: "No, I do not want to Notify.",
          value: false
        }, {
          text: "Yes, Notify them all.",
          value: true
        }],
        callback: function callback(result) {
          if (result === null) {
            $scope.$apply(function () {
              $scope.ffsub = false;
              $scope.loader = false;
            });
          } else {
            if (result === "true") {
              reqObj.EmailContent = {
                Subject: "CONSULTANT: NEW PROJECT START | " + createUserData.FirstName + " " + createUserData.LastName + " | TeXperts Inc.",
                Body: '<!DOCTYPE html>\r\n<html>\r\n<head>\r\n\r\n  <meta charset="utf-8">\r\n  <meta http-equiv="x-ua-compatible" content="ie=edge">\r\n  <title>Email Receipt</title>\r\n  <meta name="viewport" content="width=device-width, initial-scale=1">\r\n  <style type="text/css">\r\n  /**\r\n   * Google webfonts. Recommended to include the .woff version for cross-client compatibility.\r\n   */\r\n  @media screen {\r\n    @font-face {\r\n      font-family: \'Source Sans Pro\';\r\n      font-style: normal;\r\n      font-weight: 400;\r\n      src: local(\'Source Sans Pro Regular\'), local(\'SourceSansPro-Regular\'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/ODelI1aHBYDBqgeIAH2zlBM0YzuT7MdOe03otPbuUS0.woff) format(\'woff\');\r\n    }\r\n\r\n    @font-face {\r\n      font-family: \'Source Sans Pro\';\r\n      font-style: normal;\r\n      font-weight: 700;\r\n      src: local(\'Source Sans Pro Bold\'), local(\'SourceSansPro-Bold\'), url(https://fonts.gstatic.com/s/sourcesanspro/v10/toadOcfmlt9b38dHJxOBGFkQc6VGVFSmCnC_l7QZG60.woff) format(\'woff\');\r\n    }\r\n  }\r\n\r\n  /**\r\n   * Avoid browser level font resizing.\r\n   * 1. Windows Mobile\r\n   * 2. iOS / OSX\r\n   */\r\n  body,\r\n  table,\r\n  td,\r\n  a {\r\n    -ms-text-size-adjust: 100%; /* 1 */\r\n    -webkit-text-size-adjust: 100%; /* 2 */\r\n  }\r\n\r\n  /**\r\n   * Remove extra space added to tables and cells in Outlook.\r\n   */\r\n  table,\r\n  td {\r\n    mso-table-rspace: 0pt;\r\n    mso-table-lspace: 0pt;\r\n  }\r\n\r\n  /**\r\n   * Better fluid images in Internet Explorer.\r\n   */\r\n  img {\r\n    -ms-interpolation-mode: bicubic;\r\n  }\r\n\r\n  /**\r\n   * Remove blue links for iOS devices.\r\n   */\r\n  a[x-apple-data-detectors] {\r\n    font-family: inherit !important;\r\n    font-size: inherit !important;\r\n    font-weight: inherit !important;\r\n    line-height: inherit !important;\r\n    color: inherit !important;\r\n    text-decoration: none !important;\r\n  }\r\n\r\n  /**\r\n   * Fix centering issues in Android 4.4.\r\n   */\r\n  div[style*="margin: 16px 0;"] {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  body {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  /**\r\n   * Collapse table borders to avoid space between cells.\r\n   */\r\n  table {\r\n    border-collapse: collapse !important;\r\n  }\r\n\r\n  a {\r\n    color: #1a82e2;\r\n  }\r\n\r\n  img {\r\n    height: auto;\r\n    line-height: 100%;\r\n    text-decoration: none;\r\n    border: 0;\r\n    outline: none;\r\n  }\r\n  </style>\r\n\r\n</head>\r\n<body style="background-color: #ffffff;">\r\n\r\n  <!-- start preheader -->\r\n  <div class="preheader" style="display: none; max-width: 0; max-height: 0; overflow: hidden; font-size: 1px; line-height: 1px; color: #fff; opacity: 0;">\r\n Texperts Inc\r\n  </div>\r\n  <!-- end preheader -->\r\n\r\n  <!-- start body -->\r\n  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 300px;">\r\n    <!-- start hero -->\r\n    <tr>\r\n      <td align="center" bgcolor="#ffffff">\r\n<!--[if (gte mso 9)|(IE)]>\r\n<table align="center" border="0" cellpadding="0" cellspacing="0" width="600">\r\n<tr>\r\n<td align="center" valign="top" width="600">\r\n<![endif]-->\r\n<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">\r\n  <tr>\r\n    <td align="center" style="padding: 16px 24px 0; font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; border-top: 3px solid #394b3f;">\r\n      <h1 style="margin: 0;font-size: 48px;font-weight: 700;letter-spacing: -1px;line-height: 48px;color: #394b3f;">NEW PROJECT EMAIL</h1>\r\n    </td>\r\n  </tr>\r\n</table>\r\n<!--[if (gte mso 9)|(IE)]>\r\n</td>\r\n</tr>\r\n</table>\r\n<![endif]-->\r\n      </td>\r\n    </tr>\r\n    <!-- end hero -->\r\n\r\n    <!-- start copy block -->\r\n    <tr>\r\n      <td align="center" bgcolor="#ffffff">\r\n<!--[if (gte mso 9)|(IE)]>\r\n<table align="center" border="0" cellpadding="0" cellspacing="0" width="600">\r\n<tr>\r\n<td align="center" valign="top" width="600">\r\n<![endif]-->\r\n<table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px;">\r\n\r\n  <!-- start copy -->\r\n  <tr>\r\n    <td align="left" style="padding-top: 30px; font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">\r\n    <table border="1" cellpadding="0" cellspacing="0" width="100%" bgcolor="#394b3f" style="color:#ffffff;">\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Marketer</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + createUserData.MarketerId.MarkterName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Pay Roll  Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">teXperts, Inc</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Last Name</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + createUserData.LastName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant First Name</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + createUserData.FirstName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Email</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + createUserData.UserName + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Consultant Phone</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">n/a</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Skills</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + createUserData.title.Title + "</td>\r\n</tr>\r\n<tr>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\"><strong>Mid \u2013 Client, State</strong></td>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\">" + createUserData.selectedVendor.VendorName + ", " + createUserData.VendorAddress.City + ", " + createUserData.VendorAddress.State + "</td>\r\n</tr>\r\n<tr>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\"><strong>End \u2013 Client, City, State</strong></td>\r\n<td align=\"left\" width=\"50%\" style=\"padding: 6px 12px;font-family: 'Source Sans Pro', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;\">" + createUserData.selectedClient.ClientName + ", " + createUserData.EndCLientAddress.State + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Start Date</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">' + moment(createUserData.ProjectAssignedDate).format("MM/DD/YYYY") + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Billing Rate to Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">$' + createUserData.BillRate + '</td>\r\n</tr>\r\n<tr>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;"><strong>Billing Company</strong></td>\r\n<td align="left" width="50%" style="padding: 6px 12px;font-family: \'Source Sans Pro\', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 24px;">teXperts Inc</td>\r\n</tr>\r\n       \r\n    </table>\r\n    </td>\r\n  </tr>\r\n</table>\r\n<!--[if (gte mso 9)|(IE)]>\r\n</td>\r\n</tr>\r\n</table>\r\n<![endif]-->\r\n      </td>\r\n    </tr>\r\n    <!-- end copy block -->\r\n  </table>\r\n  <!-- end body -->\r\n\r\n</body>\r\n</html>'
              };
            }
            dataService.newToken().then(function (response) {
              dataService.CreateUser(reqObj).then(function (response) {
                $scope.ffsub = false;
                $scope.loader = false;
                $scope.showForm = false;
                $scope.showVenAddr = false;
                $scope.showVenCont = false;

                if (response.data.regresp === true) {
                  var toast = $mdToast.simple().content("User Created Successfully").action("OK").highlightAction(false).position("top center").hideDelay(3000);
                  $mdToast.show(toast);
                  $scope.newUserData = {};
                  vm.SelClientAddrObj = {};
                  vm.SelClientObj = {};
                  vm.SelVendorObj = {};
                  vm.SelVendorAddrObj = {};
                  $scope.successPage = true;
                } else {
                  var elsetoast = $mdToast.simple().content(response.data.Message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
                  $mdToast.show(elsetoast);
                  $("#errorPage").modal("show");
                  $scope.errorPage = true;
                  $scope.errorPageMsg = response.data.Message;
                  $scope.showForm = true;
                  $scope.loader = false;
                }
              }).catch(CatchError);
            }).catch(CatchError);
          }
        }
      });
    };
    $scope.createAnother = function () {
      $scope.loginLoader = false;
      $scope.showForm = true;
      $scope.successPage = false;
      $scope.errorPage = false;
      $timeout(function () {
        $scope.loginLoader = true;
        $scope.stage = "";
        $scope.newUserData = {};
        vm.SelClientAddrObj = {};
        vm.SelClientObj = {};
        vm.SelVendorObj = {};
        vm.SelVendorAddrObj = {};
        $(".datepicker").datepicker({
          changeMonth: true,
          changeYear: true,
          yearRange: "1950:2020",
          onSelect: function onSelect(dateText, inst) {
            var Els = document.getElementsByClassName("datepicker");
            var event = new Event("change");
            Array.from(Els).forEach(function (element, index, array) {
              element.dispatchEvent(event);
            });
          }
        });
      }, 2);
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('assignmanager', {
    controller: GetmgrtoconsultantController,
    controllerAs: 'vm',
    templateUrl: 'app/components/hr/Getmgrtoconsultant/Getmgrtoconsultant.html'
  });

  function GetmgrtoconsultantController($scope, dataService, $timeout, $mdToast, $state) {
    $scope.userDataLoaded = false;
    var tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.tokenData = tokenData;
    $scope.changeManagerLoader = false;
    var Getmgrtoconsultanttable;
    var conData;
    // var CatchError;
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    dataService.newToken().then(function (response) {
      dataService.Getmgrtoconsultant().then(function (response) {
        $scope.empMgrRelation = response.data;
        dataService.newToken().then(function (response) {
          dataService.GetManagersList().then(function (response) {
            $scope.ManagersList = response.data;
            $scope.userDataLoaded = true;
            var ProfileIcon = function ProfileIcon(cell, formatterParams, onRendered) {
              var data = cell.getRow();
              return "<i class='fas fa-pen pointer text-info' style='font-size: 18px;'></i>";
            };
            Getmgrtoconsultanttable = new Tabulator("#GetmgrtoconsultantTable", {
              data: $scope.empMgrRelation,
              layout: "fitColumns",
              height: "100%",
              pagination: "local",
              paginationSize: 20,
              columns: [{
                formatter: "rownum",
                hozAlign: "center",
                width: 40
              }, {
                title: "Consultant",
                field: "ConsultantName"
              }, {
                title: "Reporting Manager",
                field: "ManagerName",
                editor: "select",
                editorParams: $scope.ManagersList
              }, {
                formatter: ProfileIcon,
                title: 'Edit',
                align: 'left',
                cellClick: function cellClick(e, cell) {
                  var data = cell.getRow();
                  $scope.showManagerAssPage(data._row.data);
                  //$state.go('userprofile',{id:data._row.data.LoginId});
                }
              }]
            });
          }).catch(CatchError);
        }).catch(CatchError);
      }).catch(CatchError);
    }).catch(CatchError);
    $scope.conDataEdit = false;
    $scope.showManagerAssPage = function (data) {
      $scope.changedMgr = undefined;
      $("#showManagerAssPage").modal("show");
      $timeout(function () {
        $scope.conData = JSON.parse(angular.toJson(data));
      });
    };
    $scope.changeManagerview = function (emp) {
      emp.change = true;
    };
    $scope.cancelEditMgr = function (emp) {
      emp.change = false;
    };
    $scope.changeManager = function (conData) {
      $scope.changeManagerLoader = true;
      var dataObj = {
        ManagerId: parseInt(conData.ManagerId),
        LoginId: parseInt(conData.LoginId)
      };
      dataService.newToken().then(function (response) {
        dataService.Editmgrtoconsultant(dataObj).then(function (response) {
          dataService.newToken().then(function (response) {
            dataService.Getmgrtoconsultant().then(function (response) {
              $scope.empMgrRelation = response.data;
              $scope.changeManagerLoader = false;
              emp.change = false;
              $("#showManagerAssPage").modal("hide");
            }).catch(CatchError);
          }).catch(CatchError);
        }).catch(CatchError);
      }).catch(CatchError);
    };

    function matchAny(data, filterParams) {
      var match = false;
      for (var key in data) {
        if (key == 'ConsultantName') {
          var keyData = data[key];
          if (keyData !== null && keyData !== undefined) {
            keyData = keyData.toLowerCase();
            var param = filterParams.value.toLowerCase();
            if (JSON.stringify(keyData).search(param) != -1) {
              match = true;
            }
          }
        }
      }
      return match;
    }
    $scope.search = function (data) {
      Getmgrtoconsultanttable.setFilter(matchAny, {
        value: data
      });
    };
    $scope.clearSearchTerm = function () {
      $scope.searchData = "";
      Getmgrtoconsultanttable.clearFilter();
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("clients", {
    controller: clientsController,
    controllerAs: "vm",
    templateUrl: "app/components/hr/clients/clients.html"
  });

  function clientsController($scope, dataService, $http, $timeout, $q, $mdToast, $location, $state) {
    var vm = this;
    var tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.role = tokenData.newRole;
    var heightCanBe = window.innerHeight - 140 + "px";
    var listHeightCanBe = window.innerHeight - 240 + "px";
    $(".heightCanBe").css("height", heightCanBe);
    $(".listHeightCanBe").css("height", listHeightCanBe);
    $scope.addNewClientShow = false;
    $scope.addClientAddrShow = false;
    $scope.clientname = "";

    $(window).resize(function () {
      heightCanBe = window.innerHeight - 140 + "px";
      listHeightCanBe = window.innerHeight - 240 + "px";
      $(".listHeightCanBe").css("height", listHeightCanBe);
      $(".heightCanBe").css("height", heightCanBe);
    });
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };
    $scope.pageLoading = true;

    function loadData($q) {
      return $q.all([dataService.GetClientsInfo(), dataService.GetStatesList()]);
    }
    dataService.newToken().then(function () {
      loadData($q).then(function (response) {
        if (response[0].data.length) {
          $scope.pageLoading = false;
          $scope.NoClients = false;
          $scope.Clients = response[0].data;
          $scope.selClient = $scope.Clients[0];
          $scope.selClientIndex = 0;
          $scope.selectedClientAddress = $scope.Clients[0].ClientAddress;
        } else {
          $scope.pageLoading = false;
          $scope.NoClients = true;
        }
        $scope.states = response[1].data;
      });
    }).catch(CatchError);
    $scope.addNewClient = function (id) {
      $scope.addNewClientShow = true;
      $scope.ACdata = {
        cname: undefined,
        inputAddress: undefined,
        inputCity: undefined,
        inputState: undefined,
        inputCountry: undefined,
        inputZip: undefined
      };
    };
    $scope.addNewClientCancel = function (id) {
      $scope.addNewClientShow = false;
    };
    $scope.addClient = function (form, data) {
      if (form.$valid) {
        var req = {
          ClientName: data.cname,
          ClientAddressInfo: [{
            Country: data.inputCountry,
            City: data.inputCity,
            Zipcode: data.inputZip,
            State: data.inputState,
            Street: data.inputAddress
          }]
        };
        dataService.newToken().then(function (response) {
          dataService.AddClient(req).then(function (response) {
            if (response.statusText == "OK") {
              $scope.Clients = response.data.lstClientInfo;
              $scope.addNewClientShow = false;
              var toast = $mdToast.simple().content(response.data.Message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
              $mdToast.show(toast);
              $mdDialog.cancel();
            }
          }).catch(CatchError);
        }).catch(CatchError);
      }
      console.log(data);
    };
    $scope.addClientAddr = function (id) {
      $scope.addClientAddrShow = true;
    };
    $scope.addClientAddrCancel = function (id) {
      $scope.addClientAddrShow = false;
    };
    $scope.addClientAddrSub = function (form, data, selClient) {
      if (form.$valid) {
        var req = {
          ClientId: selClient.ClientId,
          ClientAddressInfo: [{
            Country: data.inputCountry,
            City: data.inputCity,
            Zipcode: data.inputZip,
            State: data.inputState,
            Street: data.inputAddress
          }]
        };
        dataService.newToken().then(function (response) {
          dataService.AddClientAddress(req).then(function (response) {
            if (response.statusText == "OK") {
              $scope.Clients = response.data;
              var toast = $mdToast.simple().content("Client Address added successfully.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
              $mdToast.show(toast);
              $mdDialog.cancel();
              $scope.addNewClientShow = false;
            } else {
              var toast = $mdToast.simple().content("oops !, Something went wrong please try again.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
              $mdToast.show(toast);
              $mdDialog.cancel();
              $scope.addNewClientShow = false;
            }
          }).catch(CatchError);
        }).catch(CatchError);
      }
      console.log(data);
    };
    $scope.editClientCancel = function (i, Client) {
      $scope.Clients[i].editable = false;
    };
    $scope.editClient = function (i, Client) {
      $scope.Clients[i].editable = true;
      $scope.clientNameEdited = Client.ClientName;
    };
    $scope.editClientSub = function (clientname, id, i) {
      if ($scope.clientNameEdited !== clientname && clientname !== "" && clientname !== undefined && clientname !== null) {
        dataService.newToken().then(function (response) {
          dataService.editclient({
            ClientId: id,
            ClientName: clientname
          }).then(function (response) {
            $scope.Clients = response.data;
            $scope.Clients[i].editable = false;
          }).catch(CatchError);
        }).catch(CatchError);
      } else {
        if ($scope.clientNameEdited !== clientname) {
          $scope.errorMsg = "Nothing to save.";
        }
        $scope.Clients[i].editableErr = true;
      }
    };
    $scope.editNewClientCancel = function (i) {
      $scope.Clients[$scope.selClientIndex].ClientAddress[i].editable = false;
    };
    $scope.editClientAddr = function (i, ClientAddr) {
      $scope.Clients[$scope.selClientIndex].ClientAddress[i].editable = true;
    };
    $scope.editClientAddrSub = function (form, data, i) {
      var req = {
        ClientId: $scope.selClient.ClientId,
        ClientName: $scope.selClient.ClientName,
        ClientAddressInfo: [{
          AddrId: $scope.Clients[$scope.selClientIndex].ClientAddress[i].AddrId,
          Country: data.Country,
          City: data.City,
          Zipcode: data.Zipcode,
          State: data.State,
          Street: data.Street
        }]
      };
      dataService.newToken().then(function (response) {
        dataService.updateclientaddress(req).then(function (response) {
          $scope.Clients = response.data;
        });
      }).catch(CatchError);
    };
    $scope.addNewAddrCancel = function (i) {
      $scope.newAddr = false;
    };
    $scope.addNewAddr = function (i, ClientAddr) {
      $scope.newAddr = true;
    };
    $scope.addclientaddress = function (form, data, i) {
      var req = {
        ClientId: $scope.selClient.ClientId,
        ClientName: $scope.selClient.ClientName,
        ClientAddressInfo: [{
          Country: data.Country,
          City: data.City,
          Zipcode: data.Zipcode,
          State: data.State,
          Street: data.Street
        }]
      };
      dataService.newToken().then(function (response) {
        dataService.addclientaddress(req).then(function (response) {
          $scope.Clients = response.data;
        });
      }).catch(CatchError);
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("clientDetails", {
    controller: clientDetailsController,
    controllerAs: "vm",
    templateUrl: "app/components/hr/clientDetails/clientDetails.html"
  });

  function clientDetailsController($scope, dataService, $http, $timeout, $q, $mdToast, $stateParams, $state) {
    var vm = this;
    var heightCanBe = window.innerHeight - 140 + "px";
    var listHeightCanBe = window.innerHeight - 240 + "px";
    $(".heightCanBe").css("height", heightCanBe);
    $(".listHeightCanBe").css("height", listHeightCanBe);
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 140 + "px";
      listHeightCanBe = window.innerHeight - 240 + "px";
      $(".listHeightCanBe").css("height", listHeightCanBe);
      $(".heightCanBe").css("height", heightCanBe);
    });
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };

    function loadData($q) {
      return $q.all([dataService.GetStatesList(), GetClients()]);
    }
    dataService.newToken().then(function () {
      loadData($q).then(function (response) {
        $scope.states = response[0].data;
        $(function () {
          $('[data-toggle="tooltip"]').tooltip({
            trigger: 'click'
          });
        });
      });
    }).catch(CatchError);

    function GetClients() {
      return new Promise(function (resolve, reject) {
        dataService.newToken().then(function (response) {
          dataService.GetClientInfoByClientId({
            ClientId: $stateParams.id
          }).then(function (response) {
            response.data.editClientName = false;
            $scope.ClientData = response.data;
            $scope.ClonedClientData = JSON.parse(JSON.stringify(response.data));

            resolve();
          }).catch(CatchError);
        }).catch(CatchError);
      });
    }
    // GetClients().then(function () {
    //   $(function () {
    //     $('[data-toggle="tooltip"]').tooltip({
    //       trigger: 'click'
    //     })
    //   })
    // });
    // dataService.newToken().then(function (response) {
    //   dataService
    //     .GetStatesList()
    //     .then(function (response) {
    //       $scope.states = response.data;
    //     })
    //     .catch(CatchError);
    // });
    $scope.editClientCancel = function (i, Client) {
      GetClients().then(function () {
        $scope.ClientData.editClientName = false;
        $scope.ClientData = angular.copy($scope.ClonedClientData);
      });
    };
    $scope.editClient = function (i, Client) {
      $scope.ClientData.editClientName = true;
    };
    $scope.editClientSub = function (clientname, id, i) {
      dataService.newToken().then(function (response) {
        dataService.editclient({
          ClientId: id,
          ClientName: clientname
        }).then(function (response) {
          $scope.ClientData.editClientName = false;
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.editNewClientCancel = function (i) {
      if ($scope.ClientData.ClientAddress.isNew) {
        $scope.ClientData.ClientAddress.splice($scope.ClientData.ClientAddress.length - 1, 1);
        $scope.ClientData = angular.copy($scope.ClonedClientData);
        $scope.isEdit = false;
      } else {
        $scope.ClientData.ClientAddress[i].editable = false;
        GetClients().then(function () {
          $scope.ClientData = angular.copy($scope.ClonedClientData);
        });
        $scope.isEdit = false;
      }
    };
    $scope.editClientAddr = function (i, ClientAddr) {
      $scope.ClientData.ClientAddress[i].editable = true;
      $scope.isEdit = true;
    };
    $scope.editClientAddrSub = function (data, i) {

      if (!data.Country || !data.City || !data.Zipcode || !data.State || !data.Street) {
        $("#AllFieldsRequired").modal("show");
      } else {
        var req = {
          ClientId: $scope.ClientData.ClientId,
          ClientName: $scope.ClientData.ClientName,
          ClientAddressInfo: [{
            Country: data.Country,
            City: data.City,
            Zipcode: data.Zipcode,
            State: data.State,
            Street: data.Street
          }]
        };
        if (data.AddrId) {
          req.ClientAddressInfo[0].AddrId = data.AddrId;
          dataService.newToken().then(function (response) {
            dataService.updateclientaddress(req).then(function (response) {
              $scope.ClientData.ClientAddress[i].editable = false;
              $scope.isEdit = false;
              GetClients().then(function () {
                var toast = $mdToast.simple().content("Address updated successfully.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
                $mdToast.show(toast);
              });
            });
          }).catch(CatchError);
        } else {
          dataService.newToken().then(function (response) {
            dataService.addclientaddress(req).then(function (response) {
              $scope.ClientData.ClientAddress[i].editable = false;
              $scope.ClientData.ClientAddress[i].isNew = false;
              $scope.isEdit = false;
              GetClients().then(function () {
                var toast = $mdToast.simple().content("Address created successfully.").action("OK").highlightAction(false).position("top center").hideDelay(3000);
                $mdToast.show(toast);
              });
            }).catch(CatchError);
          }).catch(CatchError);
        }
      }
    };
    $scope.addNewAddrCancel = function (i) {
      $scope.newAddr = false;
    };
    $scope.addNewAddr = function () {
      $scope.ClientData.ClientAddress.push({
        Country: "",
        City: "",
        Zipcode: "",
        State: "",
        Street: "",
        editable: true,
        isNew: true
      });
      $scope.isEdit = true;
    };
    $scope.addclientaddress = function (form, data, i) {
      var req = {
        ClientId: $scope.selClient.ClientId,
        ClientName: $scope.selClient.ClientName,
        ClientAddressInfo: [{
          Country: data.Country,
          City: data.City,
          Zipcode: data.Zipcode,
          State: data.State,
          Street: data.Street
        }]
      };
      dataService.newToken().then(function (response) {
        dataService.addclientaddress(req).then(function (response) {
          $scope.Clients = response.data;
          GetClients().then(function () {});
        });
      }).catch(CatchError);
    };
  }
})();


(function () {
  'use strict';

  angular.module('app').component('archiveusers', {
    controller: ArchiveUsersController,
    controllerAs: 'vm',
    templateUrl: 'app/components/hr/ArchiveUsers/ArchiveUsers.html'
  });

  function ArchiveUsersController($scope, dataService, $http, $timeout, $q, $mdToast, $location, $state) {
    var vm = this;
    $scope.clearSearchTerm = function () {
      $scope.searchTerm = '';
    };
    $('input#UsersSearch').on('keydown', function (ev) {
      ev.stopPropagation();
    });
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };

    function loadData($q) {
      return $q.all([dataService.GetAllInactiveUsers(), dataService.GetAllArchivedUsers()]);
    }
    dataService.newToken().then(function (response) {
      loadData($q).then(function (resp) {
        for (var index = 0; index < resp[0].data.length; index++) {
          var element = resp[0].data[index];
          element.FullName = element.FirstName + ' ' + element.LastName;
        }
        $scope.InActiveUsers = resp[0].data;
        $scope.ArchivedUsers = resp[1].data;

        $timeout(function () {
          var uTable = $('#ArchTable').DataTable({
            columnDefs: [{
              searchable: false,
              orderable: false,
              targets: 0
            }]
          });
          uTable.on('order.dt search.dt', function () {
            uTable.column(0, {
              search: 'applied',
              order: 'applied'
            }).nodes().each(function (cell, i) {
              cell.innerHTML = i + 1;
            });
          }).draw();
        });
      }).catch(CatchError);
    }).catch(CatchError);
    $scope.tabLoad = false;
    $scope.ArchivingLoader = false;
    $scope.ArchiveSelected = function (ArcUsers) {
      $scope.ArchivingLoader = true;
      $scope.tabLoad = true;

      var obj = {
        lstusermodel: [],
        AddToArch: true
      };

      for (var index = 0; index < ArcUsers.length; index++) {
        var element = ArcUsers[index];
        obj.lstusermodel.push({
          loginid: element
        });
      }
      dataService.newToken().then(function (response) {
        dataService.MoveUserToArchive(obj).then(function (response) {
          if (response.data == 'Update Success...') {
            loadData($q).then(function (resp) {
              for (var index = 0; index < resp[0].data.length; index++) {
                var element = resp[0].data[index];
                element.FullName = element.FirstName + ' ' + element.LastName;
              }
              $scope.InActiveUsers = resp[0].data;
              $scope.ArchivedUsers = resp[1].data;
              $timeout(function () {
                var uTable = $('#ArchTable').DataTable({
                  columnDefs: [{
                    searchable: false,
                    orderable: false,
                    targets: 0
                  }]
                });
                uTable.on('order.dt search.dt', function () {
                  uTable.column(0, {
                    search: 'applied',
                    order: 'applied'
                  }).nodes().each(function (cell, i) {
                    cell.innerHTML = i + 1;
                  });
                }).draw();
              });
              $scope.tabLoad = false;
              $scope.ArchivingLoader = false;
            });
          }
          $scope.selectedUser = undefined;
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.UnArchiveUser = function (user) {
      $scope.tabLoad = true;
      var obj = {
        lstusermodel: [{
          loginid: user.loginid
        }],
        AddToArch: false
      };
      dataService.newToken().then(function (response) {
        dataService.MoveUserToArchive(obj).then(function (response) {
          if (response.data == 'Update Success...') {
            loadData($q).then(function (resp) {
              for (var index = 0; index < resp[0].data.length; index++) {
                var element = resp[0].data[index];
                element.FullName = element.FirstName + ' ' + element.LastName;
              }
              $scope.InActiveUsers = resp[0].data;
              $scope.ArchivedUsers = resp[1].data;
              $timeout(function () {
                var uTable = $('#ArchTable').DataTable({
                  columnDefs: [{
                    searchable: false,
                    orderable: false,
                    targets: 0
                  }]
                });
                uTable.on('order.dt search.dt', function () {
                  uTable.column(0, {
                    search: 'applied',
                    order: 'applied'
                  }).nodes().each(function (cell, i) {
                    cell.innerHTML = i + 1;
                  });
                }).draw();
              });
              $scope.tabLoad = false;
            });
          }
          $scope.selectedUser = undefined;
        }).catch(CatchError);
      }).catch(CatchError);
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("addvendor", {
    controller: addvendorController,
    controllerAs: "vm",
    templateUrl: "app/components/hr/addVendor/addVendor.html"
  });

  function addvendorController($scope, dataService, $http, $timeout, $q, $mdToast, $location, $state, $filter) {
    $scope.tokenData = angular.fromJson(localStorage.getItem("tokenData"));
    var vm = this;
    var heightCanBe = window.innerHeight - 59 + "px";
    $(".heightCanBe").css("height", heightCanBe);
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 59 + "px";
      $(".heightCanBe").css("height", heightCanBe);
    });
    $scope.newVendor = {};
    $scope.newVendor.VendorAddressInfo = [{
      Country: "",
      City: "",
      Zipcode: "",
      State: "",
      Street: ""
    }];
    $scope.newVendor.VendorAddressInfo[0].VendorAcctInfo = [];
    $scope.addNewVendorShow = false;
    $scope.files = [];
    var re = /(?:\.([^.]+))?$/;

    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };
    function loadData($q) {
      return $q.all([dataService.xreflkup(), dataService.GetStatesList()]);
    }
    dataService.newToken().then(function (response) {
      loadData($q).then(function (response) {
        $scope.lookups = response[0].data;
        $scope.states = response[1].data;
        $(".datepicker").datepicker({
          changeMonth: true,
          changeYear: true,
          onSelect: function onSelect(dateText, inst) {
            var Els = document.getElementsByClassName("datepicker");
            var event = new Event("change");
            Array.from(Els).forEach(function (element, index, array) {
              element.dispatchEvent(event);
            });
          }
        });
      });
    }).catch(CatchError);

    $scope.addNewVendor = function (id) {
      $scope.addNewVendorShow = true;
      $("body").css("overflow", "hidden");
    };
    $scope.addNewVendorCancel = function (id) {
      $scope.addNewVendorShow = false;
    };

    $scope.getFileDetails = function (e, id) {
      if (re.exec(e.files[0].name)[1] === "doc" || re.exec(e.files[0].name)[1] === "docx" || re.exec(e.files[0].name)[1] === "pdf") {
        e.files[0].DocId = id;
        $scope.$apply(function () {
          $scope.files.push(e.files[0]);
        });
      } else {
        $("#invalidFileTypeAlertDiv").modal("show");
      }
    };
    $scope.newVendorCloned = angular.copy($scope.newVendor);
    $scope.addVendor = function (data) {
      $scope.addVendorLoader = true;
      for (var index = 0; index < data.VendorAddressInfo.length; index++) {
        var element = data.VendorAddressInfo[index];
        for (var sind = 0; sind < element.VendorAcctInfo.length; sind++) {
          var VendorAcctInfo = element.VendorAcctInfo[sind];
          if (VendorAcctInfo.Extn) {
            VendorAcctInfo.PhoneNumber = VendorAcctInfo.PhoneNumber + " Extn: " + VendorAcctInfo.Extn;
          }
        }
      }
      dataService.newToken().then(function (response) {
        dataService.AddVendor(data).then(function (response) {
          if (response.data.Message === "Vendor Already Exists.") {
            $scope.newVendor = $scope.newVendorCloned;
          } else {
            $state.go("vendors");
          }
          $scope.Vendors = response.data;
          $scope.addNewVendorShow = false;

          var toast = $mdToast.simple().content(response.data.Message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
          $mdToast.show(toast);
          $scope.addVendorLoader = false;
        }).catch(CatchError);
      }).catch(CatchError);
    };
    var obj = {
      ContactName: null,
      Designation: null,
      AcctEmail: null,
      PhoneNumber: null,
      editable: true
    };
    $scope.newVendor.VendorAddressInfo[0].VendorAcctInfo.push(obj);
  }
})();


/* eslint-disable angular/window-service */
(function () {
  "use strict";

  angular.module("app").component("downloadTS", {
    controller: DownloadTSController,
    controllerAs: "vm",
    templateUrl: "app/components/accounts/downloadTS/downloadTS.component.html"
  });

  function DownloadTSController($scope, $timeout, dataService, $q, $http, $mdDialog, $mdToast, moment, $state) {
    var self = this;
    $scope.userDataLoaded = false;
    var tokenData = angular.fromJson(localStorage.getItem("tokenData"));
    $scope.tokenData = tokenData;
    $scope.monthlabels = [];
    $scope.monthdata = [];
    $scope.windowHeight = window.innerHeight;
    $scope.usersloaded = false;
    self.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    self.payrollYear = [moment().format("YYYY"), moment().subtract(1, "years").format("YYYY")];
    $scope.userPPMtsTableLoad = true;
    $scope.dwnAllUsersDataLoad = false;
    $scope.userPPMtsTableDisplay = false;

    // function daysInMonth(month, year) {
    //   return new Date(year, month, 0).getDate();
    // }
    function loadjscssfile(filename, filetype) {
      if (filetype == "js") {
        // if filename is a external JavaScript file
        var fileref = document.createElement("script");
        fileref.setAttribute("type", "text/javascript");
        fileref.setAttribute("src", filename);
      } else if (filetype == "css") {
        // if filename is an external CSS file
        var fileref = document.createElement("link");
        fileref.setAttribute("rel", "stylesheet");
        fileref.setAttribute("type", "text/css");
        fileref.setAttribute("href", filename);
      }
      if (typeof fileref !== "undefined") {
        document.getElementsByTagName("head")[0].appendChild(fileref);
      }
    }
    loadjscssfile("https://cdn.datatables.net/v/dt/dt-1.10.20/b-1.6.1/b-flash-1.6.1/b-html5-1.6.1/fc-3.3.0/fh-3.1.6/datatables.min.js", "js");
    loadjscssfile("https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css", "css");
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };

    function loadData($q) {
      return $q.all([dataService.GetAllUsers(), dataService.Trange()]);
    }

    dataService.newToken().then(function (response) {
      loadData($q).then(function () {
        $scope.userDataLoaded = true;
        $scope.users = response.data;
        $(".usersSearch").on("keydown", function (ev) {
          ev.stopPropagation();
        });
        $scope.pendingTrange = response.data;
      });
    }).catch(CatchError);

    $scope.dwnAllUsersDataOpen = function () {
      $scope.dwnAllUsersDataOpened = false;
    };
    $scope.exportxlsTableVisible = true;

    $scope.dwnAllTsSubmit = function (data) {
      $scope.dwnAllUsersDataLoad = false;
      $scope.dwnAllUsersDataOpened = true;

      $scope.payrollMonth = data.PayrollMonth;
      $scope.payrollYear = data.Year;
      dataService.newToken().then(function (response) {
        dataService.PayrollMonthInfo(data).then(function (response) {
          $scope.dwnAllUsersData = response.data;
          $scope.dwnAllUsersDataLoad = true;
          $scope.dwnAllUsersDataOpened = false;
          $scope.exportxlsTableVisible = false;
          $timeout(function () {
            if ($.fn.dataTable.isDataTable("#exportxlsTable")) {
              var uTable = $("#exportxlsTable").DataTable();
              uTable.on("order.dt search.dt", function () {
                uTable.column(0, {
                  search: "applied",
                  order: "applied"
                }).nodes().each(function (cell, i) {
                  cell.innerHTML = i + 1;
                });
              }).draw();
              $scope.exportxlsTableVisible = true;
              $("#exportxlsTableVisible").css("visibility", "visible");
            } else {
              var uTable2 = $("#exportxlsTable").DataTable({
                lengthMenu: [[15, 20, 25, 50, -1], [15, 20, 25, 50, "All"]],
                dom: "lBfrtip",
                buttons: ["excel", "csv"],
                fixedColumns: {
                  leftColumns: response.data[0].weekendinginfo.length + 3,
                  rightColumns: 0
                }
              });
              uTable2.on("order.dt search.dt", function () {
                uTable2.column(0, {
                  search: "applied",
                  order: "applied"
                }).nodes().each(function (cell, i) {
                  cell.innerHTML = i + 1;
                });
              }).draw();
              $scope.exportxlsTableVisible = true;
              $("#exportxlsTableVisible").css("visibility", "visible");
            }
          });
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.searched = function (searchUsers) {
      if (searchUsers === "") {
        $scope.itemsPerPage = 10;
      } else {
        $scope.itemsPerPage = $scope.usersList.length;
      }
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("notifyUsers", {
    controller: NotifyUsersController,
    controllerAs: "vm",
    templateUrl: "app/components/accounts/notifyUsers/notifyUsers.component.html"
  });

  function NotifyUsersController($scope, $timeout, dataService, $q, $http, $mdDialog, $mdToast, moment, $state) {
    var self = this;
    $scope.userDataLoaded = false;
    var tokenData = angular.fromJson(localStorage.getItem("tokenData"));
    $scope.tokenData = tokenData;
    $scope.monthlabels = [];
    $scope.monthdata = [];
    $scope.windowHeight = window.innerHeight;
    $scope.usersloaded = false;
    self.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    self.payrollYear = [moment().format("YYYY"), moment().subtract(1, "years").format("YYYY")];
    $scope.userPPMtsTableLoad = true;
    $scope.dwnAllUsersDataLoad = false;
    $scope.userPPMtsTableDisplay = false;

    function loadjscssfile(filename, filetype) {
      if (filetype == "js") {
        // if filename is a external JavaScript file
        var fileref = document.createElement("script");
        fileref.setAttribute("type", "text/javascript");
        fileref.setAttribute("src", filename);
      } else if (filetype == "css") {
        // if filename is an external CSS file
        var fileref = document.createElement("link");
        fileref.setAttribute("rel", "stylesheet");
        fileref.setAttribute("type", "text/css");
        fileref.setAttribute("href", filename);
      }
      if (typeof fileref !== "undefined") {
        document.getElementsByTagName("head")[0].appendChild(fileref);
      }
    }
    loadjscssfile("https://cdn.datatables.net/v/dt/dt-1.10.20/b-1.6.1/b-flash-1.6.1/b-html5-1.6.1/fc-3.3.0/fh-3.1.6/datatables.min.js", "js");
    loadjscssfile("https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css", "css");
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == "Unauthorized") {
        var message = "Your Session is Expired, Please login again";
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action("OK").highlightAction(false).position("top center").hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go("signin");
      }
    };
    function loadData($q) {
      return $q.all([dataService.GetAllUsers(), dataService.Trange()]);
    }
    $scope.usersloaded = false;
    dataService.newToken().then(function (response) {
      loadData($q).then(function (response) {
        $scope.users = response[0].data;
        $scope.usersloaded = true;

        $scope.userDataLoaded = true;
        $scope.pendingTrange = response[1].data;
        $scope.onTabSelected(0, $scope.pendingTrange[0]);
      });
    }).catch(CatchError);
    $scope.onTabSelected = function (index, range) {
      $scope.selectedIndex = index;
      $scope.usersloaded = false;

      var obj = {
        Range: moment(range).format("MM/DD/YYYY")
      };
      dataService.newToken().then(function (response) {
        dataService.RangeByUsers(obj).then(function (response) {
          $scope.userPendingTs = response.data;
          $scope.pendingUserItemHeight = $scope.windowHeight - 230;
          $scope.usersloaded = true;
          $timeout(function () {
            if ($.fn.dataTable.isDataTable(".userTs")) {
              var uTable3 = $(".userTs").DataTable();
              uTable3.on("order.dt search.dt", function () {
                uTable3.column(0, {
                  search: "applied",
                  order: "applied"
                }).nodes().each(function (cell, i) {
                  cell.innerHTML = i + 1;
                });
              }).draw();
            } else {
              var uTable4 = $(".userTs").DataTable({
                lengthMenu: [[10, 20, 30, 40, 50, -1], [10, 20, 30, 40, 50, "All"]]
              });
              uTable4.on("order.dt search.dt", function () {
                uTable4.column(0, {
                  search: "applied",
                  order: "applied"
                }).nodes().each(function (cell, i) {
                  cell.innerHTML = i + 1;
                });
              }).draw();
            }
          });
          $(".notifyUsersTable").DataTable().destroy();

          $timeout(function () {
            if ($.fn.dataTable.isDataTable(".notifyUsersTable")) {
              var uTable5 = $(".notifyUsersTable").DataTable();
              uTable5.on("order.dt search.dt", function () {
                uTable5.column(0, {
                  search: "applied",
                  order: "applied"
                }).nodes().each(function (cell, i) {
                  cell.innerHTML = i + 1;
                });
              }).draw();
            } else {
              var uTable6 = $(".notifyUsersTable").DataTable({
                lengthMenu: [[10, 20, 30, 40, 50, -1], [10, 20, 30, 40, 50, "All"]]
              });
              uTable6.on("order.dt search.dt", function () {
                uTable6.column(0, {
                  search: "applied",
                  order: "applied"
                }).nodes().each(function (cell, i) {
                  cell.innerHTML = i + 1;
                });
              }).draw();
            }
          });
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.searched = function (searchUsers) {
      if (searchUsers === "") {
        $scope.itemsPerPage = 10;
      } else {
        $scope.itemsPerPage = $scope.usersList.length;
      }
    };
    $scope.notifyUser = function (user, range) {
      var obj = {
        range: range,
        users: [{
          FristName: user.FristName,
          LastName: user.LastName,
          Username: user.Username,
          isCTSSubmitted: user.isCTSSubmitted,
          isMTSSubmitted: user.isMTSSubmitted,
          loginid: user.loginid
        }]
      };
      $scope.notifyUsers(obj);
    };
    $scope.notifyUsers = function (users) {
      $scope.users = users;
      $mdDialog.show({
        controller: accountsDashboardEmailDialogController,
        templateUrl: "app/components/accounts/notifyUsers/notifyUsersEmailDialog.html",
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          users: $scope.users
        },
        openFrom: {
          left: -50,
          width: 30,
          height: 80
        },
        closeTo: {
          left: 1500
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = "You cancelled the dialog.";
      });
    };
    function accountsDashboardEmailDialogController($scope, $mdDialog, users) {
      $scope.users = users;
      var emails = "";
      for (var t = 0; t < users.users.length; t++) {
        if (users.users.length - 1 === t) {
          emails += users.users[t].Username;
        } else {
          emails += users.users[t].Username + ";";
        }
      }

      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.mailer = {};
      $scope.mailer.Recipient = emails;
      $scope.notifier = false;

      $scope.sendNotifyEmail = function (mailData) {
        $scope.notifier = true;
        dataService.newToken().then(function (response) {
          dataService.SendNotification(mailData).then(function (response) {
            if (response.data === true) {
              $mdDialog.cancel();
              var toast = $mdToast.simple().content("Notifications sent Successfully").action("OK").highlightAction(false).position("top center").hideDelay(3000);
              $mdToast.show(toast);
            } else {
              $mdDialog.cancel();
              var errtoast = $mdToast.simple().content("oops,Something wentwrong. Try again").action("OK").highlightAction(false).position("top center").hideDelay(3000);
              $mdToast.show(errtoast);
            }
            $scope.notifier = true;
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }
  }
})();


(function () {
  'use strict';

  angular.module('app').component('accountsDashboard', {
    controller: accountsPayperiodController,
    controllerAs: 'vm',
    templateUrl: 'app/components/accounts/accountsPayperiod/accountsPayperiod.component.html'
  });

  function accountsPayperiodController($scope, dataService, $location, $http, $mdDialog, $mdToast, $timeout, moment, $state) {
    var tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.tokenData = tokenData;

    function role() {
      if (tokenData.UserValid == 'true') {
        return tokenData.role;
      }
    }
    $scope.role = role();
    var reqLid = {};
    reqLid.loginid = tokenData.loginid;
    var loginmodel = {
      loginid: tokenData.loginid
    };
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    var empId;

    $scope.loginLoader = false;
    $scope.showDetailsPage = false;

    $scope.tsprocessing = false;
    $scope.tsAccs = [];
    dataService.newToken().then(function (response) {
      dataService.GetAllUsers().then(function (response) {
        $scope.users = response.data;
        dataService.newToken().then(function (response) {
          dataService.GetSubmittedTSForAccounts(reqLid).then(function (ids) {
            var empIds = ids.data;
            angular.forEach($scope.users, function (user) {
              if (empIds.indexOf(user.EmpId) > -1) {
                $scope.tsAccs.push(user);
              }
            });

            var usersList = $scope.tsAccs;
            var allRoles = {
              '1': 'HR',
              '3': 'Admin',
              '4': 'Consultant',
              '5': 'Employee',
              '6': 'Accounts'
            };
            angular.forEach(usersList, function (element) {
              element.RoleId = allRoles[element.RoleId];
            });
            $scope.usersList = usersList;
            $scope.loginLoader = true;
          }).catch(CatchError);
        }).catch(CatchError);
      }).catch(CatchError);
    }).catch(CatchError);
    $scope.filter = function (param) {
      if (param == 'All') {
        $scope.search = '';
      } else {
        $scope.search = param;
      }
    };
    $scope.openPanel = false;
    $scope.showUserDetails = function (id) {
      $scope.getUserData = false;
      $scope.selectedIndex = 0;
      $scope.openPanel = true;
      $scope.showDetailsPage = true;
      $scope.userDetails = id;
      empId = {
        EmpId: id.EmpId
      };
      dataService.newToken().then(function (response) {
        dataService.GetTimeSheetsForAccounts(empId).then(function (response) {
          $scope.Timesheets = response.data;
          $scope.loginLoader = true;
          $scope.showSubmittedTsloader = false;
          $scope.showSubmittedTsExport = true;
          $scope.getUserData = true;
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.approveTs = function (tsData) {
      $scope.tsprocessing = true;
      var obj = {
        GUID: tsData.Guid,
        EmpId: $scope.userDetails.EmpId,
        IsAccountsProcessed: true,
        AccountsAction: 'Approved'
      };

      dataService.newToken().then(function (response) {
        dataService.AcctsAppOrReject(obj).then(function (response) {
          var toast;
          if (response.data === true) {
            dataService.newToken().then(function (response) {
              dataService.GetTimeSheetsForAccounts(empId).then(function (response) {
                $scope.Timesheets = response.data;
                $scope.loginLoader = true;
                $scope.showSubmittedTsloader = false;
                $scope.showSubmittedTsExport = true;
                $scope.getUserData = true;

                toast = $mdToast.simple().content('Timesheet Approved Successfully').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                $mdToast.show(toast);
              }).catch(CatchError);
            }).catch(CatchError);
          } else {
            toast = $mdToast.simple().content('Oops..!, Something went wrong.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
            $mdToast.show(toast);
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.showRejectionDialog = function (ts, ev) {
      $scope.ts = ts;
      $mdDialog.show({
        controller: showRejectionDialogController,
        templateUrl: 'app/components/accounts/account/showRejectionDialogController.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          ts: $scope.ts
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };
    function showRejectionDialogController($scope, $mdDialog, ts) {
      $scope.ts = ts;
      $scope.hide = function () {
        $mdDialog.hide();
      };

      $scope.cancel = function () {
        $mdDialog.cancel();
      };

      $scope.rejectTs = function (answer) {
        $mdDialog.hide(answer);
        var obj = {
          GUID: ts.Guid,
          EmpId: ts.EmpId,
          IsAccountsProcessed: true,
          AcctsRejectReason: answer,
          AccountsAction: 'Rejected'
        };

        dataService.newToken().then(function (response) {
          dataService.AcctsAppOrReject(obj).then(function (response) {
            var toast;
            if (response.data === true) {
              dataService.newToken().then(function (response) {
                dataService.GetTimeSheetsForAccounts(empId).then(function (response) {
                  $scope.Timesheets = response.data;
                  $scope.loginLoader = true;
                  $scope.showSubmittedTsloader = false;
                  $scope.showSubmittedTsExport = true;
                  $scope.getUserData = true;
                  toast = $mdToast.simple().content('Timesheet Rejected Successfully').action('OK').highlightAction(false).position('top center').hideDelay(3000);
                  $mdToast.show(toast);
                }).catch(CatchError);
              }).catch(CatchError);
            } else {
              toast = $mdToast.simple().content('Oops..!, Something went wrong.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    }
    $scope.compareTs = function (tsData) {
      $scope.tsData = tsData;
      $mdDialog.show({
        controller: compareTsController,
        templateUrl: 'app/components/accounts/account/compareTs.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          tsData: $scope.tsData
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };
    function compareTsController($scope, $mdDialog, tsData) {
      $scope.tsData = tsData;

      function renderOnload(img) {
        $scope.clientTimesheetDoc = img;
      }
      var img = tsData.document;
      var reader = new FileReader();
      reader.onload = renderOnload(img);
      $scope.hide = function () {
        $mdDialog.hide();
      };

      $scope.cancel = function () {
        $mdDialog.cancel();
      };
    }
    $scope.month = null;
    $scope.months = null;
    $scope.loadMonths = function () {
      return $timeout(function () {
        $scope.months = [{
          id: 1,
          name: 'January'
        }, {
          id: 2,
          name: 'February'
        }, {
          id: 3,
          name: 'March'
        }, {
          id: 4,
          name: 'April'
        }, {
          id: 5,
          name: 'May'
        }, {
          id: 6,
          name: 'June'
        }, {
          id: 7,
          name: 'July'
        }, {
          id: 8,
          name: 'August'
        }, {
          id: 9,
          name: 'September'
        }, {
          id: 10,
          name: 'October'
        }, {
          id: 11,
          name: 'November'
        }, {
          id: 12,
          name: 'December'
        }];
      }, 650);
    };
    $scope.payPeriodTs = [];
    $scope.payPeriod = function (selMonth) {
      $scope.payPeriodStartDate = moment(selMonth - 1 + '/16/2018').format('MM/DD/YYYY');
      $scope.payPeriodEndDate = moment(selMonth + '/15/2018').format('MM/DD/YYYY');
      $scope.payPeriodRange = $scope.payPeriodStartDate + '-' + $scope.payPeriodEndDate;
      angular.forEach($scope.Timesheets, function (ts) {
        var range = moment.range($scope.payPeriodStartDate, $scope.payPeriodEndDate);
        if (range.contains(ts.StartDate)) {
          $scope.payPeriodTs.push(ts);
        }
      });
    };
    $scope.go = function (path) {
      $state.go(path);
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("accountsdashboard", {
    controller: AccountsDashboardController,
    controllerAs: "vm",
    templateUrl: "app/components/accounts/accountsDashboard/accountsDashboard.component.html"
  });

  function AccountsDashboardController($scope) {}
})();


(function () {
  'use strict';

  angular.module('app').component('accounts', {
    controller: AccountController,
    controllerAs: 'vm',
    templateUrl: 'app/components/accounts/account/account.component.html'
  });

  function AccountController($scope, dataService, $location, $http, $mdDialog, $mdToast, $timeout, moment, $state) {
    var vm = this;
    var tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.tokenData = tokenData;

    $scope.role = tokenData.role;
    var reqLid = {};
    reqLid.loginid = tokenData.loginid;
    var empId;

    $scope.loginLoader = false;
    $scope.showDetailsPage = false;
    $scope.showUserTsPeriods = false;
    $scope.TimePeriodRangeData = false;
    $scope.TimePeriodRangeData = false;
    $scope.Timesheets = [];
    var actionReq, totEmps, TimesheetsTable;
    var heightCanBe = window.innerHeight - 160 + 'px';
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 160 + 'px';
      if (totEmps !== this.undefined || actionReq !== this.undefined) {
        actionReq.setHeight(heightCanBe);
        actionReq.redraw();
        totEmps.setHeight(heightCanBe);
        totEmps.redraw();
      }
    });
    $scope.tsprocessing = false;
    $scope.tsAccs = [];
    // get years os userv
    $scope.presentYear = moment().format('YYYY');
    var year = $scope.presentYear;
    var a = moment([$scope.presentYear]);

    $scope.prevYear = a.subtract(1, 'y').format('YYYY');

    $scope.getPrevYearTs = function (LoginId, eid) {
      $scope.yearTsLoader = true;
      new UserTss(LoginId, eid, $scope.prevYear);
    };
    $scope.getPresnYearTs = function (LoginId, eid) {
      $scope.yearTsLoader = true;
      new UserTss(LoginId, eid, $scope.presentYear);
    };
    $scope.searched = function (searchUsers) {
      if (searchUsers === null) {
        $scope.itemsPerPage = 10;
      } else {
        $scope.itemsPerPage = $scope.usersList.length;
      }
    };
    var CatchError = function CatchError(error) {
      if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };
    $scope.refreshIngUsers = false;
    $scope.openPanel = false;
    $scope.ctsfileload = true;
    $scope.month = null;
    $scope.months = null;
    $scope.payPeriodTs = [];

    new GetAllUsers();

    function GetAllUsers() {
      $scope.tsAccs = [];
      dataService.newToken().then(function (response) {
        dataService.GetAllUsers().then(function (response) {
          $scope.users = response.data;
          dataService.newToken().then(function (response) {
            dataService.GetSubmittedTSForAccounts(reqLid).then(function (ids) {
              var empIds = ids.data;
              angular.forEach($scope.users, function (user) {
                if (empIds.indexOf(user.PrfId) > -1) {
                  user.tsStatus = true;
                  $scope.tsAccs.push(user);
                } else {
                  user.tsStatus = false;
                }
              });
              $timeout(function () {
                var ViewIcon = function ViewIcon(cell, formatterParams, onRendered) {
                  return "<button class='btn btn-sm btn-primary p-0 pl-2 pr-2' style='font-size: 11px;position: absolute;left: 0;right: 0;width: 95px;margin: auto;'>Open <i class='fas fa-chevron-right' style='font-size: 11px;'></i></button>";
                };
                actionReq = new Tabulator('#actionRequiredTable', {
                  data: $scope.tsAccs,
                  height: heightCanBe,
                  layout: 'fitDataFill',
                  pagination: 'local',
                  paginationSize: 20,
                  paginationSizeSelector: [20, 30, 40, 50],
                  groupBy: '',
                  groupStartOpen: false,
                  groupToggleElement: 'header',
                  selectable: false,
                  clipboard: true,
                  clipboardCopyStyled: false,
                  persistence: {
                    sort: true,
                    filter: true,
                    columns: true
                  },
                  tooltips: true,
                  tooltipsHeader: true,
                  persistenceID: "usersListId",
                  columns: [{
                    formatter: 'rownum',
                    align: 'center',
                    width: 40,
                    sorter: false
                  }, {
                    title: 'Name',
                    field: 'FirstName'
                  }, {
                    title: 'Email',
                    field: 'UserName'
                  }, {
                    title: 'Employee Id',
                    field: 'PrfId'
                  }, {
                    title: 'Role',
                    field: 'Role'
                  }, {
                    formatter: ViewIcon,
                    title: 'Notify',
                    align: 'center',
                    width: 140,
                    cellClick: function cellClick(e, cell) {
                      var data = cell.getRow();
                      $scope.showUserDetails(data._row.data);
                    }
                  }]
                });
                totEmps = new Tabulator('#TotalEmployeesTable', {
                  data: $scope.users,
                  height: heightCanBe,
                  layout: 'fitDataFill',
                  pagination: 'local',
                  paginationSize: 20,
                  paginationSizeSelector: [20, 30, 40, 50],
                  groupBy: '',
                  groupStartOpen: false,
                  groupToggleElement: 'header',
                  selectable: false,
                  clipboard: true,
                  clipboardCopyStyled: false,
                  persistence: {
                    sort: true,
                    filter: true,
                    columns: true
                  },
                  tooltips: true,
                  tooltipsHeader: true,
                  persistenceID: "TotalEmployeesTablepersistenceID",
                  columns: [{
                    formatter: 'rownum',
                    align: 'center',
                    width: 40,
                    sorter: false
                  }, {
                    title: 'Name',
                    field: 'FirstName'
                  }, {
                    title: 'Email',
                    field: 'UserName'
                  }, {
                    title: 'Employee Id',
                    field: 'PrfId'
                  }, {
                    title: 'Role',
                    field: 'Role'
                  }, {
                    formatter: ViewIcon,
                    title: 'Notify',
                    align: 'center',
                    width: 140,
                    cellClick: function cellClick(e, cell) {
                      var data = cell.getRow();
                      $scope.getUserTs(data._row.data);
                    }
                  }]
                });
              });
              $scope.loginLoader = true;
              $scope.refreshIngUsers = false;
            }).catch(CatchError);
          }).catch(CatchError);;
        }).catch(CatchError);
      }).catch(CatchError);
    }
    $scope.searched = function (searchUsers) {
      if (searchUsers === '') {
        $scope.itemsPerPage = 10;
      } else {
        $scope.itemsPerPage = $scope.tsAccs.length;
      }
    };
    $scope.refreshUsers = function () {
      $scope.refreshIngUsers = true;
      $scope.openPanel = false;
      $scope.openShowUserTsPeriodsPanel = false;
      $scope.showDetailsPage = false;
      $scope.showUserTsPeriods = false;
      new GetAllUsers();
    };

    function GetTimeSheetsForAccountsFunc(empId) {
      dataService.newToken().then(function (response) {
        dataService.GetTimeSheetsForAccounts(empId).then(function (response) {
          angular.forEach(response.data, function (recrd) {
            if (recrd.AccountsAction === null || recrd.AccountsAction === '') {
              recrd.tsaction = 'Submitted';
            } else {
              recrd.tsaction = recrd.AccountsAction;
            }
          });
          $scope.Timesheets = response.data;
          $scope.loginLoader = true;
          $scope.showSubmittedTsloader = false;
          $scope.showSubmittedTsExport = true;
          $scope.getUserData = true;

          var toast = $mdToast.simple().content('Timesheet Rejected Successfully').highlightAction(false).position('top center').hideDelay(3000);
          $mdToast.show(toast);

          $scope.showDetailsPage = true;
          $scope.openPanel = true;
        }).catch(CatchError);
      }).catch(CatchError);
    }
    $scope.filter = function (param) {
      if (param == 'All') {
        $scope.search = '';
      } else {
        $scope.search = param;
      }
    };

    function UserTss(loginid, eid, yy) {
      $scope.Timesheets = [];
      empId = {
        loginid: loginid,
        EmpId: eid,
        Year: yy
      };
      dataService.newToken().then(function (response) {
        dataService.GetTimeSheetsForAccounts(empId).then(function (response) {
          $scope.NoTsThisYear = [];
          angular.forEach(response.data, function (recrd) {
            if (recrd.AccountsAction === null || recrd.AccountsAction === '') {
              recrd.tsaction = 'Submitted';
              $scope.NoTsThisYear.push(recrd.tsaction);
            } else {
              recrd.tsaction = recrd.AccountsAction;
            }
            if (recrd.tsaction == 'Submitted') {
              $scope.Timesheets.push(recrd);
            }
          });
          // $scope.Timesheets = response.data;
          $scope.loginLoader = true;
          $scope.showSubmittedTsloader = false;
          $scope.showSubmittedTsExport = true;
          $scope.getUserData = true;
          $scope.search = 'Submitted';

          $scope.yearTsLoader = false;
        }).catch(CatchError);
      }).catch(CatchError);
    }
    $scope.showUserDetails = function (id) {
      $scope.getUserData = false;
      $scope.selectedIndex = 0;
      $scope.openPanel = true;
      $scope.showDetailsPage = true;
      $scope.showUserTsPeriods = false;
      $scope.userDetails = id;
      if ($scope.toggleYear) {
        $scope.toggleYear = !$scope.toggleYear;
      }
      new UserTss(id.LoginId, id.PrfId, year);
    };
    $scope.closeopenPanel = function () {
      $scope.openPanel = false;
      $scope.openShowUserTsPeriodsPanel = false;
      $scope.showDetailsPage = false;
      $scope.showUserTsPeriods = false;
    };
    $scope.getUserTs = function (userData) {
      $scope.TimePeriodRangeData = false;

      $scope.userDetails = userData;
      $scope.openPanel = false;
      $scope.showDetailsPage = false;

      $scope.showUserTsPeriods = true;
      $scope.openShowUserTsPeriodsPanel = true;
      $scope.openShowUserTsPeriodsPanel = true;
      $timeout(function () {
        $scope.TimePeriodRangeData = true;
        $scope.timePeriodTimesheets = {};
        $scope.tsTable = false;
      }, 600);
    };
    $scope.TimePeriodRange = function (timeperiodrange) {
      $scope.TimePeriodRangeData = true;
      $scope.tsTable = false;
      $scope.timePeriodTimesheetsLoader = true;
      var obj = {
        EmpId: $scope.userDetails.PrfId,
        StartDate: moment(timeperiodrange.tsFromDate).format('MM/DD/YYYY'),
        EndDate: moment(timeperiodrange.tsToDate).format('MM/DD/YYYY')
      };
      dataService.newToken().then(function (response) {
        dataService.GetTimeSheetsByPP(obj).then(function (response) {
          $scope.timePeriodTimesheets = response.data;
          $scope.timePeriodTimesheetsLoader = false;
          $scope.tsTable = true;
          $timeout(function () {
            $('#TimesheetsTable').DataTable().destroy();
            $('#TimesheetsTable').DataTable({
              lengthMenu: [[10, 25, 50, -1], [10, 25, 50, 'All']]
            });
          });
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.approveTs = function (tsData) {
      tsData.tsprocessing = true;
      var year = moment(tsData.StartDate).format('YYYY');
      var obj = {
        GUID: tsData.Guid,
        EmpId: $scope.userDetails.PrfId,
        IsAccountsProcessed: true,
        AccountsAction: 'Approved',
        Year: year
      };

      dataService.newToken().then(function (response) {
        dataService.AcctsAppOrReject(obj).then(function (response) {
          var toast;
          if (response.data === true) {
            empId.Year = year;
            dataService.newToken().then(function (response) {
              dataService.GetTimeSheetsForAccounts(empId).then(function (tsresponse) {
                angular.forEach(tsresponse.data, function (recrd) {
                  if (recrd.AccountsAction === null || recrd.AccountsAction === '') {
                    recrd.tsaction = 'Submitted';
                  } else {
                    recrd.tsaction = recrd.AccountsAction;
                  }
                });
                $scope.Timesheets = tsresponse.data;
                $scope.loginLoader = true;
                $scope.showSubmittedTsloader = false;
                $scope.showSubmittedTsExport = true;
                $scope.getUserData = true;

                toast = $mdToast.simple().content('Timesheet Approved Successfully').highlightAction(false).position('top center').hideDelay(3000);
                $mdToast.show(toast);
                tsData.tsprocessing = false;
              }).catch(CatchError);
            }).catch(CatchError);;
          } else {
            toast = $mdToast.simple().content('Oops..!, Something went wrong.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
            $mdToast.show(toast);

            tsData.tsprocessing = false;
          }
        }).catch(CatchError);
      }).catch(CatchError);
    };
    $scope.RejectBox = function (ts) {
      ts.showRejectBox = true;
      $scope.rejectTs = function (answer) {
        var year = moment(ts.StartDate).format('YYYY');
        ts.tsprocessing = true;
        var obj = {
          GUID: ts.Guid,
          EmpId: ts.EmpId,
          IsAccountsProcessed: true,
          AcctsRejectReason: answer,
          AccountsAction: 'Rejected',
          Year: year
        };
        dataService.newToken().then(function (response) {
          dataService.AcctsAppOrReject(obj).then(function (response) {
            var toast;
            if (response.data === true) {
              toast = $mdToast.simple().content('Timesheet Rejected Successfully').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
              empId.Year = year;
              new GetTimeSheetsForAccountsFunc(empId);
              ts.tsprocessing = false;
              ts.showRejectBox = false;
            } else {
              toast = $mdToast.simple().content('Oops..!, Something went wrong.Reload the page and try again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
              ts.tsprocessing = false;
              ts.showRejectBox = false;
            }
          }).catch(CatchError);
        }).catch(CatchError);
      };
    };
    $scope.hideRejectBox = function (ts) {
      ts.showRejectBox = false;
      // ts.tsprocessing = true;
    };
    $scope.compareTs = function (tsData) {
      $scope.ctsfileload = false;
      $scope.tsData = tsData;
      $mdDialog.show({
        controller: compareTsController,
        templateUrl: 'app/components/accounts/account/compareTs.html',
        parent: $(document.body),
        clickOutsideToClose: true,
        locals: {
          tsData: $scope.tsData
        },
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function compareTsController($scope, $mdDialog, tsData) {
      if (tsData.DocUrl === null) {
        $scope.ctsfileload = true;
        $scope.notAdmittedCtsMsg = true;
        $scope.tsData = tsData;
      } else {
        var obj = {
          FileUrl: tsData.DocUrl,
          LoginId: tsData.loginid
        };
        var fileType = tsData.DocUrl.split('~#')[2].split('.')[1];
        dataService.newToken().then(function (response) {
          dataService.GetCTSFile(obj).then(function (response) {
            $scope.notAdmittedCtsMsg = false;
            $scope.ctsfileload = true;
            if (fileType == 'jpg' || fileType == 'png') {
              var ctsData = btoa(new Uint8Array(response.data).reduce(function (data, byte) {
                return data + String.fromCharCode(byte);
              }, ''));
              var el = $('#ctsImgViewWrapper');
              el.attr('src', 'data:application/pdf;base64,' + ctsData);
            } else {
              var ctsData = new Blob([new Uint8Array(response.data)], {
                type: 'application/pdf'
              });
              $scope.pdfUrl = URL.createObjectURL(ctsData);
              var el = $('#ctsViewFile');
              el.attr('src', $scope.pdfUrl);
            }
          }).catch(CatchError);
        }).catch(CatchError);

        $scope.tsData = tsData;
      }

      // function renderOnload(img) {
      //     $scope.clientTimesheetDoc = img;
      // }
      // var img = tsData.document;
      // var reader = new FileReader();
      // reader.onload = renderOnload(img);
      $scope.hide = function () {
        $mdDialog.hide();
      };

      $scope.cancel = function () {
        $mdDialog.cancel();
      };
    }
    $scope.loadMonths = function () {
      return $timeout(function () {
        $scope.months = [{
          id: 1,
          name: 'January'
        }, {
          id: 2,
          name: 'February'
        }, {
          id: 3,
          name: 'March'
        }, {
          id: 4,
          name: 'April'
        }, {
          id: 5,
          name: 'May'
        }, {
          id: 6,
          name: 'June'
        }, {
          id: 7,
          name: 'July'
        }, {
          id: 8,
          name: 'August'
        }, {
          id: 9,
          name: 'September'
        }, {
          id: 10,
          name: 'October'
        }, {
          id: 11,
          name: 'November'
        }, {
          id: 12,
          name: 'December'
        }];
      }, 650);
    };
    $scope.payPeriod = function (selMonth) {
      $scope.payPeriodStartDate = moment(selMonth - 1 + '/16/2018').format('MM/DD/YYYY');
      $scope.payPeriodEndDate = moment(selMonth + '/15/2018').format('MM/DD/YYYY');
      $scope.payPeriodRange = $scope.payPeriodStartDate + '-' + $scope.payPeriodEndDate;
      angular.forEach($scope.Timesheets, function (ts) {
        var range = moment.range($scope.payPeriodStartDate, $scope.payPeriodEndDate);
        if (range.contains(ts.StartDate)) {
          $scope.payPeriodTs.push(ts);
        }
      });
    };
    $scope.go = function (path) {
      $state.go(path);
    };
  }
})();


(function () {
  "use strict";

  angular.module("app").component("admindashboard", {
    controller: adminDashboardController,
    controllerAs: "vm",
    templateUrl: "app/components/admin/adminDashboard/adminDashboard.component.html"
  });

  function adminDashboardController($scope) {}
})();


angular.module('app').directive('ciSpinner', function ($mdDialog) {
  return {
    restrict: 'AE',

    template: '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>',
    link: function link(scope, element, attrs) {}
  };
}).directive('texpertsLoader', function ($mdDialog) {
  return {
    restrict: 'AE',

    template: '<div class="loader"><div class="inner one"></div><div class="inner two"></div><div class="inner three"></div></div>',
    link: function link(scope, element, attrs) {}
  };
}).directive('preventActionloader', function ($mdDialog) {
  return {
    restrict: 'AE',

    template: '<div class="preventActionloader"></div><div class="preventActionloaderWrap"><div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>',
    link: function link(scope, element, attrs) {}
  };
});


(function () {
  'use strict';

  angular.module('app').component('sidebar', {
    controller: SidebarController,
    controllerAs: 'vm',
    templateUrl: 'app/components/sidebar/sidebar.html'
  });

  /** @ngInject */
  function SidebarController($scope, dataService, $location, $mdSidenav, $mdDialog, $mdToast, $mdMenu, $timeout, $rootScope, $state) {
    var vm = this;
    $rootScope.isPresident = false;

    $scope.tokenData = JSON.parse(localStorage.getItem('tokenData'));
    $scope.role = $scope.tokenData.newRole;
    if ($scope.tokenData.newRole === 'President') {
      $rootScope.isPresident = true;
    } else {
      $rootScope.isPresident = false;
    }
    window.isMobile = /iphone|ipod|ipad|android|blackberry|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(navigator.userAgent.toLowerCase());
    $scope.isMobile = window.isMobile;
    $scope.isPresident = $rootScope.isPresident;
    $scope.curl = $location.url().split('/');
    $scope.toggleMyAcc = function () {
      $('#myAccDetails').slideToggle();
    };
    $scope.logout = function () {
      localStorage.clear();
      $state.go('signin');
    };

    $scope.logout = function () {
      localStorage.clear();
      $state.go('signin');
    };

    $scope.go = function (path) {
      $state.go(path);
    };

    $scope.toggleRight = function () {
      $rootScope.$broadcast('toggleRight', 'right');
    };

    $scope.changePasswordView = function (ev) {
      $mdDialog.show({
        controller: fpwdController,
        templateUrl: 'app/components/sidebar/changePwdForm.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };
    $scope.spinStart = false;
    $scope.loadDC = function () {
      $scope.spinStart = true;
      dataService.newToken().then(function (response) {
        dataService.getAccsTok().then(function (res) {
          var reqObj = {
            Token: res.data.access_token,
            Skill: "q='dot net'"
          };
          dataService.newToken().then(function (response) {
            dataService.GetDiceProfiles(reqObj).then(function (response) {
              var paD = JSON.parse(response.data);
              $scope.DiceUsage = paD.usage;
              $scope.spinStart = false;
            });
          }).catch(CatchError);
        });
      }).catch(CatchError);
    };

    function fpwdController($scope, $mdDialog) {
      $scope.hide = function () {
        $mdDialog.hide();
      };

      $scope.cancel = function () {
        $mdDialog.cancel();
      };

      $scope.ChangePassword = {
        NewPassword: '',
        ConfirmPassword: ''
      };
      $scope.chaningPass = false;

      $scope.chngPwdSubmit = function (data) {
        $scope.chaningPass = true;
        var tokenData = JSON.parse(localStorage.getItem('tokenData'));
        data.loginid = parseInt(tokenData.loginid);
        dataService.newToken().then(function (response) {
          dataService.ChangePassword(data).then(function (response) {
            if (response.data !== 'Password update failed.') {
              $scope.message = response.data;
              $mdDialog.hide();
              localStorage.clear();
              $state.go('signin');
              var toast = $mdToast.simple().content('Password changed successfully. Please login again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
            } else {
              toast = $mdToast.simple().content('Incorrect Password provided. Please try again.').action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
            }
          }).catch(function (error) {
            if (error.statusText == 'Unauthorized') {
              //  $scope.authenticated = false;
              var toast = $mdToast.simple().content(error.data.error_description).action('OK').highlightAction(false).position('top center').hideDelay(3000);
              $mdToast.show(toast);
            }
          });
        }).catch(CatchError);
      };
    }

    var userProfile = localStorage.getItem('userProfile');
    $scope.userProfile = JSON.parse(userProfile);
  }
})();


(function () {
  'use strict';

  angular.module('app').component('signin', {
    controller: LoginController,
    controllerAs: 'vm',
    templateUrl: 'app/components/login/login.html'
  });

  function LoginController($scope, $timeout, dataService, $location, $mdToast, $mdDialog, $rootScope, $interval, $state) {
    $rootScope.isLogin = true;
    $scope.isEmailValid = false;
    $scope.loadscript = false;
    $scope.curl = $location.url().split('/');
    $timeout(function () {
      $scope.loadscript = true;
    });
    $scope.invalidCredentials = false;

    var CatchError = function CatchError(error) {
      if (error.data.error === 'invalid_grant') {
        $scope.invalidCredentials = true;
        $scope.user.password = '';
        $scope.authenticated = false;
      } else if (error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('/');
      }
    };
    $scope.user = {
      username: '',
      password: ''
    };
    $scope.login = function (userAuthData) {
      localStorage.clear();
      $scope.authenticated = true;
      var loginmodel = {};
      loginmodel.UserName = userAuthData.username;
      loginmodel.password = userAuthData.password;

      dataService.getToken(loginmodel).then(function (response) {
        var isValidUser = response.data.UserValid.toLowerCase();
        if (isValidUser !== 'false') {
          $scope.authenticated = true;
          response.data.role = angular.fromJson(response.data.role);
          localStorage.setItem('tokenData', angular.toJson(response.data));
          localStorage.setItem('token', JSON.stringify(response.data.access_token));
          if (response.data.newRole === 'Employee') {
            var loginid = {
              loginid: response.data.loginid
            };
            dataService.GetProfilePictureInfo(loginid).then(function (profile) {
              var tokenRes = response.data.newRole;
              localStorage.setItem('PrfPicData', angular.toJson(profile.data));
              $rootScope.isLogin = false;
              $state.go('dashboard');
            }).catch(CatchError);
          } else {
            var tokenRes = response.data.newRole;
            $rootScope.isLogin = false;
            if (response.data.newRole === 'President') {
              $rootScope.isPresident = true;
              $state.go('presidentdashboard');
            } else if (response.data.newRole === 'MarketerAdmin') {
              $state.go('marketerdashboard');
            } else {
              if (response.data.newRole == 'Admin') {
                $state.go('adminDashboard');
              } else if (response.data.newRole == 'HR') {
                $state.go('hr-dashboard');
              } else if (response.data.newRole == 'Accounts') {
                $state.go('accountsdashboard');
              } else if (response.data.newRole == 'Marketer') {
                $state.go('marketerdashboard');
              } else if (response.data.newRole == 'MarketerAdmin') {
                $state.go('marketerdashboard');
              }
            }
          }
        } else {
          var toast = $mdToast.simple().content('No user found with provided details.').action('OK').highlightAction(false).position('top center').hideDelay(5000);
          $mdToast.show(toast);
          $scope.authenticated = false;
        }
      }).catch(CatchError);
    };

    $scope.forgotPassword = function (ev) {
      $mdDialog.show({
        controller: fpwdController,
        templateUrl: 'app/components/login/forgotPwdForm.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
      }).then(function (answer) {
        $scope.status = 'You said the information was "' + answer + '".';
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    };

    function fpwdController($scope, $mdDialog) {
      $scope.hide = function () {
        $mdDialog.hide();
      };

      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.resMsg = false;
      $scope.resOkBtn = false;
      $scope.fwdSubmit = function (data) {
        $scope.resMsg = true;
        dataService.newToken().then(function (response) {
          dataService.forgotpw(data).then(function (response) {
            $scope.resMsg = false;

            if (response.data.UserValid === false && response.data.Message === null) {
              $scope.message = 'User does not exists.';
            } else if (response.data.UserValid === true && response.data.Message !== null && response.data.Username !== null) {
              $scope.message = response.data.Message;
              $scope.resOkBtn = true;
            } else {
              $scope.message = response.data.Message;
            }
          }).catch(CatchError);
        }).catch(CatchError);
        // $mdDialog.hide();
      };
    }
  }
})();


(function () {
  'use strict';

  angular.module('app').component('admin', {
    controller: adminController,
    controllerAs: 'vm',
    templateUrl: 'app/components/admin/admin.component.html'
  });

  function adminController($scope, dataService, $location, $http, $mdToast, $timeout, $q, $mdSelect, $mdDialog, $rootScope, moment, $state) {
    var tokenData = angular.fromJson(localStorage.getItem('tokenData'));
    $scope.role = tokenData.newRole;
    $scope.loginLoader = false;
    var usersTb;
    var heightCanBe = window.innerHeight - 125 + 'px';
    $(window).resize(function () {
      heightCanBe = window.innerHeight - 125 + 'px';
      if (usersTb) {
        usersTb.setHeight(heightCanBe);
        usersTb.redraw();
      }
    });
    var reqLid = {};
    reqLid.loginid = tokenData.loginid;
    var loginmodel = {
      loginid: tokenData.loginid
    };
    var CatchError = function CatchError(error) {
      if (error.error === "invalid_grant" || error.statusText == 'Unauthorized') {
        var message = 'Your Session is Expired, Please login again';
        $scope.authenticated = false;
        var toast = $mdToast.simple().content(message).action('OK').highlightAction(false).position('top center').hideDelay(3000);
        $mdToast.show(toast);
        localStorage.clear();
        $state.go('signin');
      }
    };

    function matchAny(data, filterParams) {
      var match = false;
      for (var key in data) {
        if (key == 'FullName' || key == 'FirstName' || key == 'DisplayName' || key == 'Email' || key == 'UserName' || key == 'WorkAuth' || key == 'WorkAuthStartDate' || key == 'WorkAuthEndDate' || key == 'Skillset' || key == 'VisaType') {
          var keyData = data[key];
          if (keyData !== null && keyData !== undefined) {
            keyData = keyData.toLowerCase();
            var param = filterParams.value.toLowerCase();
            if (JSON.stringify(keyData).search(param) != -1) {
              match = true;
            }
          }
        }
      }
      return match;
    }
    $scope.search = function (data) {
      usersTb.setFilter(matchAny, {
        value: data
      });
    };
    $scope.userStatusUpdate = function (data, status) {
      var obj = {
        loginid: data.LoginId,
        EnableUser: status
      };
      dataService.newToken().then(function (response) {
        dataService.removeuser(obj).then(function (response) {
          for (var index = 0; index < $scope.usersList.length; index++) {
            var element = $scope.usersList[index];
            if (element.PrfId === data.PrfId) {
              $scope.usersList[index].EnableUser = status;
              usersTb.setData($scope.usersList);
              break;
            }
          };
        }).catch(CatchError);
      }).catch(CatchError);
    };
    dataService.newToken().then(function (response) {
      dataService.GetAllUsers().then(function (response) {
        $scope.usersList = response.data;
        $scope.loginLoader = true;
        var ProjectsIcon = function ProjectsIcon(cell, formatterParams, onRendered) {
          var data = cell.getRow();
          return "<i class='fas fa-tasks pointer text-info' style='font-size: 18px;'></i>";
        };
        var EnableIcon = function EnableIcon(cell, formatterParams, onRendered) {
          var data = cell.getRow();
          if (!data._row.data.EnableUser) {
            return '<button class="btn btn-success btn-sm">Enable</button>';
          } else {
            return '<button class="btn btn-danger btn-sm">Disable</button>';
          }
        };
        $timeout(function () {
          console.log(heightCanBe);
          usersTb = new Tabulator('#usersList', {
            data: $scope.usersList,
            height: heightCanBe,
            layout: 'fitColumns',
            tooltips: true,
            tooltipsHeader: true,
            pagination: 'local',
            paginationSize: 100,
            paginationSizeSelector: [20, 30, 40, 50],
            groupBy: '',
            groupStartOpen: true,
            groupToggleElement: 'header',
            selectable: false,
            clipboard: true,
            clipboardCopyStyled: false,
            columns: [{
              formatter: 'rownum',
              align: 'center',
              width: 40,
              sorter: false
            }, {
              title: 'First Name',
              field: 'FirstName'
            }, {
              title: 'Last Name',
              field: 'LastName'
            }, {
              title: 'Email',
              field: 'UserName'
            }, {
              title: 'Role',
              field: 'Role'
            }, {
              title: 'Status',
              field: 'EnableUser',
              formatter: function formatter(cell, formatterParams, onRendered) {
                var val = cell.getValue();
                if (val) {
                  return "Active";
                } else {
                  return "Inactive";
                }
              }
            }, {
              formatter: ProjectsIcon,
              title: 'Projects',
              align: 'left',
              cellClick: function cellClick(e, cell) {
                var data = cell.getRow();
                //$scope.showUserDetails(data._row.data);
                $state.go('projects', {
                  id: data._row.data.PrfId
                });
              }
            }, {
              formatter: EnableIcon,
              title: 'Action',
              align: 'left',
              cellClick: function cellClick(e, cell) {
                var data = cell.getRow();
                if (!data._row.data.EnableUser) {
                  $scope.userStatusUpdate(data._row.data, true);
                } else {
                  $scope.userStatusUpdate(data._row.data, false);
                }
                //$state.go('userprofile',{id:data._row.data.LoginId});
              }
            }]
          });
        });
      }).catch(CatchError);
    }).catch(CatchError);

    $scope.showUserDetails = function (data) {
      $("#profileModal").modal("show");
    };
  }
})();


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Chart.js
 * http://chartjs.org/
 * Version: 2.7.2
 *
 * Copyright 2018 Chart.js Contributors
 * Released under the MIT license
 * https://github.com/chartjs/Chart.js/blob/master/LICENSE.md
 */
(function (f) {
	if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
		module.exports = f();
	} else if (typeof define === "function" && define.amd) {
		define([], f);
	} else {
		var g;if (typeof window !== "undefined") {
			g = window;
		} else if (typeof global !== "undefined") {
			g = global;
		} else if (typeof self !== "undefined") {
			g = self;
		} else {
			g = this;
		}g.Chart = f();
	}
})(function () {
	var define, module, exports;return function () {
		function e(t, n, r) {
			function s(o, u) {
				if (!n[o]) {
					if (!t[o]) {
						var a = typeof require == "function" && require;if (!u && a) return a(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = "MODULE_NOT_FOUND", f;
					}var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
						var n = t[o][1][e];return s(n ? n : e);
					}, l, l.exports, e, t, n, r);
				}return n[o].exports;
			}var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
				s(r[o]);
			}return s;
		}return e;
	}()({ 1: [function (require, module, exports) {}, {}], 2: [function (require, module, exports) {
			/* MIT license */
			var colorNames = require(6);

			module.exports = {
				getRgba: getRgba,
				getHsla: getHsla,
				getRgb: getRgb,
				getHsl: getHsl,
				getHwb: getHwb,
				getAlpha: getAlpha,

				hexString: hexString,
				rgbString: rgbString,
				rgbaString: rgbaString,
				percentString: percentString,
				percentaString: percentaString,
				hslString: hslString,
				hslaString: hslaString,
				hwbString: hwbString,
				keyword: keyword
			};

			function getRgba(string) {
				if (!string) {
					return;
				}
				var abbr = /^#([a-fA-F0-9]{3})$/i,
				    hex = /^#([a-fA-F0-9]{6})$/i,
				    rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
				    per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
				    keyword = /(\w+)/;

				var rgb = [0, 0, 0],
				    a = 1,
				    match = string.match(abbr);
				if (match) {
					match = match[1];
					for (var i = 0; i < rgb.length; i++) {
						rgb[i] = parseInt(match[i] + match[i], 16);
					}
				} else if (match = string.match(hex)) {
					match = match[1];
					for (var i = 0; i < rgb.length; i++) {
						rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
					}
				} else if (match = string.match(rgba)) {
					for (var i = 0; i < rgb.length; i++) {
						rgb[i] = parseInt(match[i + 1]);
					}
					a = parseFloat(match[4]);
				} else if (match = string.match(per)) {
					for (var i = 0; i < rgb.length; i++) {
						rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
					}
					a = parseFloat(match[4]);
				} else if (match = string.match(keyword)) {
					if (match[1] == "transparent") {
						return [0, 0, 0, 0];
					}
					rgb = colorNames[match[1]];
					if (!rgb) {
						return;
					}
				}

				for (var i = 0; i < rgb.length; i++) {
					rgb[i] = scale(rgb[i], 0, 255);
				}
				if (!a && a != 0) {
					a = 1;
				} else {
					a = scale(a, 0, 1);
				}
				rgb[3] = a;
				return rgb;
			}

			function getHsla(string) {
				if (!string) {
					return;
				}
				var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
				var match = string.match(hsl);
				if (match) {
					var alpha = parseFloat(match[4]);
					var h = scale(parseInt(match[1]), 0, 360),
					    s = scale(parseFloat(match[2]), 0, 100),
					    l = scale(parseFloat(match[3]), 0, 100),
					    a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
					return [h, s, l, a];
				}
			}

			function getHwb(string) {
				if (!string) {
					return;
				}
				var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
				var match = string.match(hwb);
				if (match) {
					var alpha = parseFloat(match[4]);
					var h = scale(parseInt(match[1]), 0, 360),
					    w = scale(parseFloat(match[2]), 0, 100),
					    b = scale(parseFloat(match[3]), 0, 100),
					    a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
					return [h, w, b, a];
				}
			}

			function getRgb(string) {
				var rgba = getRgba(string);
				return rgba && rgba.slice(0, 3);
			}

			function getHsl(string) {
				var hsla = getHsla(string);
				return hsla && hsla.slice(0, 3);
			}

			function getAlpha(string) {
				var vals = getRgba(string);
				if (vals) {
					return vals[3];
				} else if (vals = getHsla(string)) {
					return vals[3];
				} else if (vals = getHwb(string)) {
					return vals[3];
				}
			}

			// generators
			function hexString(rgb) {
				return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1]) + hexDouble(rgb[2]);
			}

			function rgbString(rgba, alpha) {
				if (alpha < 1 || rgba[3] && rgba[3] < 1) {
					return rgbaString(rgba, alpha);
				}
				return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
			}

			function rgbaString(rgba, alpha) {
				if (alpha === undefined) {
					alpha = rgba[3] !== undefined ? rgba[3] : 1;
				}
				return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
			}

			function percentString(rgba, alpha) {
				if (alpha < 1 || rgba[3] && rgba[3] < 1) {
					return percentaString(rgba, alpha);
				}
				var r = Math.round(rgba[0] / 255 * 100),
				    g = Math.round(rgba[1] / 255 * 100),
				    b = Math.round(rgba[2] / 255 * 100);

				return "rgb(" + r + "%, " + g + "%, " + b + "%)";
			}

			function percentaString(rgba, alpha) {
				var r = Math.round(rgba[0] / 255 * 100),
				    g = Math.round(rgba[1] / 255 * 100),
				    b = Math.round(rgba[2] / 255 * 100);
				return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
			}

			function hslString(hsla, alpha) {
				if (alpha < 1 || hsla[3] && hsla[3] < 1) {
					return hslaString(hsla, alpha);
				}
				return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
			}

			function hslaString(hsla, alpha) {
				if (alpha === undefined) {
					alpha = hsla[3] !== undefined ? hsla[3] : 1;
				}
				return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
			}

			// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
			// (hwb have alpha optional & 1 is default value)
			function hwbString(hwb, alpha) {
				if (alpha === undefined) {
					alpha = hwb[3] !== undefined ? hwb[3] : 1;
				}
				return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
			}

			function keyword(rgb) {
				return reverseNames[rgb.slice(0, 3)];
			}

			// helpers
			function scale(num, min, max) {
				return Math.min(Math.max(min, num), max);
			}

			function hexDouble(num) {
				var str = num.toString(16).toUpperCase();
				return str.length < 2 ? "0" + str : str;
			}

			//create a list of reverse color names
			var reverseNames = {};
			for (var name in colorNames) {
				reverseNames[colorNames[name]] = name;
			}
		}, { "6": 6 }], 3: [function (require, module, exports) {
			/* MIT license */
			var convert = require(5);
			var string = require(2);

			var Color = function Color(obj) {
				if (obj instanceof Color) {
					return obj;
				}
				if (!(this instanceof Color)) {
					return new Color(obj);
				}

				this.valid = false;
				this.values = {
					rgb: [0, 0, 0],
					hsl: [0, 0, 0],
					hsv: [0, 0, 0],
					hwb: [0, 0, 0],
					cmyk: [0, 0, 0, 0],
					alpha: 1
				};

				// parse Color() argument
				var vals;
				if (typeof obj === 'string') {
					vals = string.getRgba(obj);
					if (vals) {
						this.setValues('rgb', vals);
					} else if (vals = string.getHsla(obj)) {
						this.setValues('hsl', vals);
					} else if (vals = string.getHwb(obj)) {
						this.setValues('hwb', vals);
					}
				} else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object') {
					vals = obj;
					if (vals.r !== undefined || vals.red !== undefined) {
						this.setValues('rgb', vals);
					} else if (vals.l !== undefined || vals.lightness !== undefined) {
						this.setValues('hsl', vals);
					} else if (vals.v !== undefined || vals.value !== undefined) {
						this.setValues('hsv', vals);
					} else if (vals.w !== undefined || vals.whiteness !== undefined) {
						this.setValues('hwb', vals);
					} else if (vals.c !== undefined || vals.cyan !== undefined) {
						this.setValues('cmyk', vals);
					}
				}
			};

			Color.prototype = {
				isValid: function isValid() {
					return this.valid;
				},
				rgb: function rgb() {
					return this.setSpace('rgb', arguments);
				},
				hsl: function hsl() {
					return this.setSpace('hsl', arguments);
				},
				hsv: function hsv() {
					return this.setSpace('hsv', arguments);
				},
				hwb: function hwb() {
					return this.setSpace('hwb', arguments);
				},
				cmyk: function cmyk() {
					return this.setSpace('cmyk', arguments);
				},

				rgbArray: function rgbArray() {
					return this.values.rgb;
				},
				hslArray: function hslArray() {
					return this.values.hsl;
				},
				hsvArray: function hsvArray() {
					return this.values.hsv;
				},
				hwbArray: function hwbArray() {
					var values = this.values;
					if (values.alpha !== 1) {
						return values.hwb.concat([values.alpha]);
					}
					return values.hwb;
				},
				cmykArray: function cmykArray() {
					return this.values.cmyk;
				},
				rgbaArray: function rgbaArray() {
					var values = this.values;
					return values.rgb.concat([values.alpha]);
				},
				hslaArray: function hslaArray() {
					var values = this.values;
					return values.hsl.concat([values.alpha]);
				},
				alpha: function alpha(val) {
					if (val === undefined) {
						return this.values.alpha;
					}
					this.setValues('alpha', val);
					return this;
				},

				red: function red(val) {
					return this.setChannel('rgb', 0, val);
				},
				green: function green(val) {
					return this.setChannel('rgb', 1, val);
				},
				blue: function blue(val) {
					return this.setChannel('rgb', 2, val);
				},
				hue: function hue(val) {
					if (val) {
						val %= 360;
						val = val < 0 ? 360 + val : val;
					}
					return this.setChannel('hsl', 0, val);
				},
				saturation: function saturation(val) {
					return this.setChannel('hsl', 1, val);
				},
				lightness: function lightness(val) {
					return this.setChannel('hsl', 2, val);
				},
				saturationv: function saturationv(val) {
					return this.setChannel('hsv', 1, val);
				},
				whiteness: function whiteness(val) {
					return this.setChannel('hwb', 1, val);
				},
				blackness: function blackness(val) {
					return this.setChannel('hwb', 2, val);
				},
				value: function value(val) {
					return this.setChannel('hsv', 2, val);
				},
				cyan: function cyan(val) {
					return this.setChannel('cmyk', 0, val);
				},
				magenta: function magenta(val) {
					return this.setChannel('cmyk', 1, val);
				},
				yellow: function yellow(val) {
					return this.setChannel('cmyk', 2, val);
				},
				black: function black(val) {
					return this.setChannel('cmyk', 3, val);
				},

				hexString: function hexString() {
					return string.hexString(this.values.rgb);
				},
				rgbString: function rgbString() {
					return string.rgbString(this.values.rgb, this.values.alpha);
				},
				rgbaString: function rgbaString() {
					return string.rgbaString(this.values.rgb, this.values.alpha);
				},
				percentString: function percentString() {
					return string.percentString(this.values.rgb, this.values.alpha);
				},
				hslString: function hslString() {
					return string.hslString(this.values.hsl, this.values.alpha);
				},
				hslaString: function hslaString() {
					return string.hslaString(this.values.hsl, this.values.alpha);
				},
				hwbString: function hwbString() {
					return string.hwbString(this.values.hwb, this.values.alpha);
				},
				keyword: function keyword() {
					return string.keyword(this.values.rgb, this.values.alpha);
				},

				rgbNumber: function rgbNumber() {
					var rgb = this.values.rgb;
					return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
				},

				luminosity: function luminosity() {
					// http://www.w3.org/TR/WCAG20/#relativeluminancedef
					var rgb = this.values.rgb;
					var lum = [];
					for (var i = 0; i < rgb.length; i++) {
						var chan = rgb[i] / 255;
						lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
					}
					return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
				},

				contrast: function contrast(color2) {
					// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
					var lum1 = this.luminosity();
					var lum2 = color2.luminosity();
					if (lum1 > lum2) {
						return (lum1 + 0.05) / (lum2 + 0.05);
					}
					return (lum2 + 0.05) / (lum1 + 0.05);
				},

				level: function level(color2) {
					var contrastRatio = this.contrast(color2);
					if (contrastRatio >= 7.1) {
						return 'AAA';
					}

					return contrastRatio >= 4.5 ? 'AA' : '';
				},

				dark: function dark() {
					// YIQ equation from http://24ways.org/2010/calculating-color-contrast
					var rgb = this.values.rgb;
					var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
					return yiq < 128;
				},

				light: function light() {
					return !this.dark();
				},

				negate: function negate() {
					var rgb = [];
					for (var i = 0; i < 3; i++) {
						rgb[i] = 255 - this.values.rgb[i];
					}
					this.setValues('rgb', rgb);
					return this;
				},

				lighten: function lighten(ratio) {
					var hsl = this.values.hsl;
					hsl[2] += hsl[2] * ratio;
					this.setValues('hsl', hsl);
					return this;
				},

				darken: function darken(ratio) {
					var hsl = this.values.hsl;
					hsl[2] -= hsl[2] * ratio;
					this.setValues('hsl', hsl);
					return this;
				},

				saturate: function saturate(ratio) {
					var hsl = this.values.hsl;
					hsl[1] += hsl[1] * ratio;
					this.setValues('hsl', hsl);
					return this;
				},

				desaturate: function desaturate(ratio) {
					var hsl = this.values.hsl;
					hsl[1] -= hsl[1] * ratio;
					this.setValues('hsl', hsl);
					return this;
				},

				whiten: function whiten(ratio) {
					var hwb = this.values.hwb;
					hwb[1] += hwb[1] * ratio;
					this.setValues('hwb', hwb);
					return this;
				},

				blacken: function blacken(ratio) {
					var hwb = this.values.hwb;
					hwb[2] += hwb[2] * ratio;
					this.setValues('hwb', hwb);
					return this;
				},

				greyscale: function greyscale() {
					var rgb = this.values.rgb;
					// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
					var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
					this.setValues('rgb', [val, val, val]);
					return this;
				},

				clearer: function clearer(ratio) {
					var alpha = this.values.alpha;
					this.setValues('alpha', alpha - alpha * ratio);
					return this;
				},

				opaquer: function opaquer(ratio) {
					var alpha = this.values.alpha;
					this.setValues('alpha', alpha + alpha * ratio);
					return this;
				},

				rotate: function rotate(degrees) {
					var hsl = this.values.hsl;
					var hue = (hsl[0] + degrees) % 360;
					hsl[0] = hue < 0 ? 360 + hue : hue;
					this.setValues('hsl', hsl);
					return this;
				},

				/**
     * Ported from sass implementation in C
     * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
     */
				mix: function mix(mixinColor, weight) {
					var color1 = this;
					var color2 = mixinColor;
					var p = weight === undefined ? 0.5 : weight;

					var w = 2 * p - 1;
					var a = color1.alpha() - color2.alpha();

					var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
					var w2 = 1 - w1;

					return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
				},

				toJSON: function toJSON() {
					return this.rgb();
				},

				clone: function clone() {
					// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
					// making the final build way to big to embed in Chart.js. So let's do it manually,
					// assuming that values to clone are 1 dimension arrays containing only numbers,
					// except 'alpha' which is a number.
					var result = new Color();
					var source = this.values;
					var target = result.values;
					var value, type;

					for (var prop in source) {
						if (source.hasOwnProperty(prop)) {
							value = source[prop];
							type = {}.toString.call(value);
							if (type === '[object Array]') {
								target[prop] = value.slice(0);
							} else if (type === '[object Number]') {
								target[prop] = value;
							} else {
								console.error('unexpected color value:', value);
							}
						}
					}

					return result;
				}
			};

			Color.prototype.spaces = {
				rgb: ['red', 'green', 'blue'],
				hsl: ['hue', 'saturation', 'lightness'],
				hsv: ['hue', 'saturation', 'value'],
				hwb: ['hue', 'whiteness', 'blackness'],
				cmyk: ['cyan', 'magenta', 'yellow', 'black']
			};

			Color.prototype.maxes = {
				rgb: [255, 255, 255],
				hsl: [360, 100, 100],
				hsv: [360, 100, 100],
				hwb: [360, 100, 100],
				cmyk: [100, 100, 100, 100]
			};

			Color.prototype.getValues = function (space) {
				var values = this.values;
				var vals = {};

				for (var i = 0; i < space.length; i++) {
					vals[space.charAt(i)] = values[space][i];
				}

				if (values.alpha !== 1) {
					vals.a = values.alpha;
				}

				// {r: 255, g: 255, b: 255, a: 0.4}
				return vals;
			};

			Color.prototype.setValues = function (space, vals) {
				var values = this.values;
				var spaces = this.spaces;
				var maxes = this.maxes;
				var alpha = 1;
				var i;

				this.valid = true;

				if (space === 'alpha') {
					alpha = vals;
				} else if (vals.length) {
					// [10, 10, 10]
					values[space] = vals.slice(0, space.length);
					alpha = vals[space.length];
				} else if (vals[space.charAt(0)] !== undefined) {
					// {r: 10, g: 10, b: 10}
					for (i = 0; i < space.length; i++) {
						values[space][i] = vals[space.charAt(i)];
					}

					alpha = vals.a;
				} else if (vals[spaces[space][0]] !== undefined) {
					// {red: 10, green: 10, blue: 10}
					var chans = spaces[space];

					for (i = 0; i < space.length; i++) {
						values[space][i] = vals[chans[i]];
					}

					alpha = vals.alpha;
				}

				values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));

				if (space === 'alpha') {
					return false;
				}

				var capped;

				// cap values of the space prior converting all values
				for (i = 0; i < space.length; i++) {
					capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
					values[space][i] = Math.round(capped);
				}

				// convert to all the other color spaces
				for (var sname in spaces) {
					if (sname !== space) {
						values[sname] = convert[space][sname](values[space]);
					}
				}

				return true;
			};

			Color.prototype.setSpace = function (space, args) {
				var vals = args[0];

				if (vals === undefined) {
					// color.rgb()
					return this.getValues(space);
				}

				// color.rgb(10, 10, 10)
				if (typeof vals === 'number') {
					vals = Array.prototype.slice.call(args);
				}

				this.setValues(space, vals);
				return this;
			};

			Color.prototype.setChannel = function (space, index, val) {
				var svalues = this.values[space];
				if (val === undefined) {
					// color.red()
					return svalues[index];
				} else if (val === svalues[index]) {
					// color.red(color.red())
					return this;
				}

				// color.red(100)
				svalues[index] = val;
				this.setValues(space, svalues);

				return this;
			};

			if (typeof window !== 'undefined') {
				window.Color = Color;
			}

			module.exports = Color;
		}, { "2": 2, "5": 5 }], 4: [function (require, module, exports) {
			/* MIT license */

			module.exports = {
				rgb2hsl: rgb2hsl,
				rgb2hsv: rgb2hsv,
				rgb2hwb: rgb2hwb,
				rgb2cmyk: rgb2cmyk,
				rgb2keyword: rgb2keyword,
				rgb2xyz: rgb2xyz,
				rgb2lab: rgb2lab,
				rgb2lch: rgb2lch,

				hsl2rgb: hsl2rgb,
				hsl2hsv: hsl2hsv,
				hsl2hwb: hsl2hwb,
				hsl2cmyk: hsl2cmyk,
				hsl2keyword: hsl2keyword,

				hsv2rgb: hsv2rgb,
				hsv2hsl: hsv2hsl,
				hsv2hwb: hsv2hwb,
				hsv2cmyk: hsv2cmyk,
				hsv2keyword: hsv2keyword,

				hwb2rgb: hwb2rgb,
				hwb2hsl: hwb2hsl,
				hwb2hsv: hwb2hsv,
				hwb2cmyk: hwb2cmyk,
				hwb2keyword: hwb2keyword,

				cmyk2rgb: cmyk2rgb,
				cmyk2hsl: cmyk2hsl,
				cmyk2hsv: cmyk2hsv,
				cmyk2hwb: cmyk2hwb,
				cmyk2keyword: cmyk2keyword,

				keyword2rgb: keyword2rgb,
				keyword2hsl: keyword2hsl,
				keyword2hsv: keyword2hsv,
				keyword2hwb: keyword2hwb,
				keyword2cmyk: keyword2cmyk,
				keyword2lab: keyword2lab,
				keyword2xyz: keyword2xyz,

				xyz2rgb: xyz2rgb,
				xyz2lab: xyz2lab,
				xyz2lch: xyz2lch,

				lab2xyz: lab2xyz,
				lab2rgb: lab2rgb,
				lab2lch: lab2lch,

				lch2lab: lch2lab,
				lch2xyz: lch2xyz,
				lch2rgb: lch2rgb
			};

			function rgb2hsl(rgb) {
				var r = rgb[0] / 255,
				    g = rgb[1] / 255,
				    b = rgb[2] / 255,
				    min = Math.min(r, g, b),
				    max = Math.max(r, g, b),
				    delta = max - min,
				    h,
				    s,
				    l;

				if (max == min) h = 0;else if (r == max) h = (g - b) / delta;else if (g == max) h = 2 + (b - r) / delta;else if (b == max) h = 4 + (r - g) / delta;

				h = Math.min(h * 60, 360);

				if (h < 0) h += 360;

				l = (min + max) / 2;

				if (max == min) s = 0;else if (l <= 0.5) s = delta / (max + min);else s = delta / (2 - max - min);

				return [h, s * 100, l * 100];
			}

			function rgb2hsv(rgb) {
				var r = rgb[0],
				    g = rgb[1],
				    b = rgb[2],
				    min = Math.min(r, g, b),
				    max = Math.max(r, g, b),
				    delta = max - min,
				    h,
				    s,
				    v;

				if (max == 0) s = 0;else s = delta / max * 1000 / 10;

				if (max == min) h = 0;else if (r == max) h = (g - b) / delta;else if (g == max) h = 2 + (b - r) / delta;else if (b == max) h = 4 + (r - g) / delta;

				h = Math.min(h * 60, 360);

				if (h < 0) h += 360;

				v = max / 255 * 1000 / 10;

				return [h, s, v];
			}

			function rgb2hwb(rgb) {
				var r = rgb[0],
				    g = rgb[1],
				    b = rgb[2],
				    h = rgb2hsl(rgb)[0],
				    w = 1 / 255 * Math.min(r, Math.min(g, b)),
				    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

				return [h, w * 100, b * 100];
			}

			function rgb2cmyk(rgb) {
				var r = rgb[0] / 255,
				    g = rgb[1] / 255,
				    b = rgb[2] / 255,
				    c,
				    m,
				    y,
				    k;

				k = Math.min(1 - r, 1 - g, 1 - b);
				c = (1 - r - k) / (1 - k) || 0;
				m = (1 - g - k) / (1 - k) || 0;
				y = (1 - b - k) / (1 - k) || 0;
				return [c * 100, m * 100, y * 100, k * 100];
			}

			function rgb2keyword(rgb) {
				return reverseKeywords[JSON.stringify(rgb)];
			}

			function rgb2xyz(rgb) {
				var r = rgb[0] / 255,
				    g = rgb[1] / 255,
				    b = rgb[2] / 255;

				// assume sRGB
				r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
				g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
				b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;

				var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
				var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
				var z = r * 0.0193 + g * 0.1192 + b * 0.9505;

				return [x * 100, y * 100, z * 100];
			}

			function rgb2lab(rgb) {
				var xyz = rgb2xyz(rgb),
				    x = xyz[0],
				    y = xyz[1],
				    z = xyz[2],
				    l,
				    a,
				    b;

				x /= 95.047;
				y /= 100;
				z /= 108.883;

				x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
				y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
				z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;

				l = 116 * y - 16;
				a = 500 * (x - y);
				b = 200 * (y - z);

				return [l, a, b];
			}

			function rgb2lch(args) {
				return lab2lch(rgb2lab(args));
			}

			function hsl2rgb(hsl) {
				var h = hsl[0] / 360,
				    s = hsl[1] / 100,
				    l = hsl[2] / 100,
				    t1,
				    t2,
				    t3,
				    rgb,
				    val;

				if (s == 0) {
					val = l * 255;
					return [val, val, val];
				}

				if (l < 0.5) t2 = l * (1 + s);else t2 = l + s - l * s;
				t1 = 2 * l - t2;

				rgb = [0, 0, 0];
				for (var i = 0; i < 3; i++) {
					t3 = h + 1 / 3 * -(i - 1);
					t3 < 0 && t3++;
					t3 > 1 && t3--;

					if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;else if (2 * t3 < 1) val = t2;else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;else val = t1;

					rgb[i] = val * 255;
				}

				return rgb;
			}

			function hsl2hsv(hsl) {
				var h = hsl[0],
				    s = hsl[1] / 100,
				    l = hsl[2] / 100,
				    sv,
				    v;

				if (l === 0) {
					// no need to do calc on black
					// also avoids divide by 0 error
					return [0, 0, 0];
				}

				l *= 2;
				s *= l <= 1 ? l : 2 - l;
				v = (l + s) / 2;
				sv = 2 * s / (l + s);
				return [h, sv * 100, v * 100];
			}

			function hsl2hwb(args) {
				return rgb2hwb(hsl2rgb(args));
			}

			function hsl2cmyk(args) {
				return rgb2cmyk(hsl2rgb(args));
			}

			function hsl2keyword(args) {
				return rgb2keyword(hsl2rgb(args));
			}

			function hsv2rgb(hsv) {
				var h = hsv[0] / 60,
				    s = hsv[1] / 100,
				    v = hsv[2] / 100,
				    hi = Math.floor(h) % 6;

				var f = h - Math.floor(h),
				    p = 255 * v * (1 - s),
				    q = 255 * v * (1 - s * f),
				    t = 255 * v * (1 - s * (1 - f)),
				    v = 255 * v;

				switch (hi) {
					case 0:
						return [v, t, p];
					case 1:
						return [q, v, p];
					case 2:
						return [p, v, t];
					case 3:
						return [p, q, v];
					case 4:
						return [t, p, v];
					case 5:
						return [v, p, q];
				}
			}

			function hsv2hsl(hsv) {
				var h = hsv[0],
				    s = hsv[1] / 100,
				    v = hsv[2] / 100,
				    sl,
				    l;

				l = (2 - s) * v;
				sl = s * v;
				sl /= l <= 1 ? l : 2 - l;
				sl = sl || 0;
				l /= 2;
				return [h, sl * 100, l * 100];
			}

			function hsv2hwb(args) {
				return rgb2hwb(hsv2rgb(args));
			}

			function hsv2cmyk(args) {
				return rgb2cmyk(hsv2rgb(args));
			}

			function hsv2keyword(args) {
				return rgb2keyword(hsv2rgb(args));
			}

			// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
			function hwb2rgb(hwb) {
				var h = hwb[0] / 360,
				    wh = hwb[1] / 100,
				    bl = hwb[2] / 100,
				    ratio = wh + bl,
				    i,
				    v,
				    f,
				    n;

				// wh + bl cant be > 1
				if (ratio > 1) {
					wh /= ratio;
					bl /= ratio;
				}

				i = Math.floor(6 * h);
				v = 1 - bl;
				f = 6 * h - i;
				if ((i & 0x01) != 0) {
					f = 1 - f;
				}
				n = wh + f * (v - wh); // linear interpolation

				switch (i) {
					default:
					case 6:
					case 0:
						r = v;g = n;b = wh;break;
					case 1:
						r = n;g = v;b = wh;break;
					case 2:
						r = wh;g = v;b = n;break;
					case 3:
						r = wh;g = n;b = v;break;
					case 4:
						r = n;g = wh;b = v;break;
					case 5:
						r = v;g = wh;b = n;break;
				}

				return [r * 255, g * 255, b * 255];
			}

			function hwb2hsl(args) {
				return rgb2hsl(hwb2rgb(args));
			}

			function hwb2hsv(args) {
				return rgb2hsv(hwb2rgb(args));
			}

			function hwb2cmyk(args) {
				return rgb2cmyk(hwb2rgb(args));
			}

			function hwb2keyword(args) {
				return rgb2keyword(hwb2rgb(args));
			}

			function cmyk2rgb(cmyk) {
				var c = cmyk[0] / 100,
				    m = cmyk[1] / 100,
				    y = cmyk[2] / 100,
				    k = cmyk[3] / 100,
				    r,
				    g,
				    b;

				r = 1 - Math.min(1, c * (1 - k) + k);
				g = 1 - Math.min(1, m * (1 - k) + k);
				b = 1 - Math.min(1, y * (1 - k) + k);
				return [r * 255, g * 255, b * 255];
			}

			function cmyk2hsl(args) {
				return rgb2hsl(cmyk2rgb(args));
			}

			function cmyk2hsv(args) {
				return rgb2hsv(cmyk2rgb(args));
			}

			function cmyk2hwb(args) {
				return rgb2hwb(cmyk2rgb(args));
			}

			function cmyk2keyword(args) {
				return rgb2keyword(cmyk2rgb(args));
			}

			function xyz2rgb(xyz) {
				var x = xyz[0] / 100,
				    y = xyz[1] / 100,
				    z = xyz[2] / 100,
				    r,
				    g,
				    b;

				r = x * 3.2406 + y * -1.5372 + z * -0.4986;
				g = x * -0.9689 + y * 1.8758 + z * 0.0415;
				b = x * 0.0557 + y * -0.2040 + z * 1.0570;

				// assume sRGB
				r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r = r * 12.92;

				g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g = g * 12.92;

				b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b = b * 12.92;

				r = Math.min(Math.max(0, r), 1);
				g = Math.min(Math.max(0, g), 1);
				b = Math.min(Math.max(0, b), 1);

				return [r * 255, g * 255, b * 255];
			}

			function xyz2lab(xyz) {
				var x = xyz[0],
				    y = xyz[1],
				    z = xyz[2],
				    l,
				    a,
				    b;

				x /= 95.047;
				y /= 100;
				z /= 108.883;

				x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
				y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
				z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;

				l = 116 * y - 16;
				a = 500 * (x - y);
				b = 200 * (y - z);

				return [l, a, b];
			}

			function xyz2lch(args) {
				return lab2lch(xyz2lab(args));
			}

			function lab2xyz(lab) {
				var l = lab[0],
				    a = lab[1],
				    b = lab[2],
				    x,
				    y,
				    z,
				    y2;

				if (l <= 8) {
					y = l * 100 / 903.3;
					y2 = 7.787 * (y / 100) + 16 / 116;
				} else {
					y = 100 * Math.pow((l + 16) / 116, 3);
					y2 = Math.pow(y / 100, 1 / 3);
				}

				x = x / 95.047 <= 0.008856 ? x = 95.047 * (a / 500 + y2 - 16 / 116) / 7.787 : 95.047 * Math.pow(a / 500 + y2, 3);

				z = z / 108.883 <= 0.008859 ? z = 108.883 * (y2 - b / 200 - 16 / 116) / 7.787 : 108.883 * Math.pow(y2 - b / 200, 3);

				return [x, y, z];
			}

			function lab2lch(lab) {
				var l = lab[0],
				    a = lab[1],
				    b = lab[2],
				    hr,
				    h,
				    c;

				hr = Math.atan2(b, a);
				h = hr * 360 / 2 / Math.PI;
				if (h < 0) {
					h += 360;
				}
				c = Math.sqrt(a * a + b * b);
				return [l, c, h];
			}

			function lab2rgb(args) {
				return xyz2rgb(lab2xyz(args));
			}

			function lch2lab(lch) {
				var l = lch[0],
				    c = lch[1],
				    h = lch[2],
				    a,
				    b,
				    hr;

				hr = h / 360 * 2 * Math.PI;
				a = c * Math.cos(hr);
				b = c * Math.sin(hr);
				return [l, a, b];
			}

			function lch2xyz(args) {
				return lab2xyz(lch2lab(args));
			}

			function lch2rgb(args) {
				return lab2rgb(lch2lab(args));
			}

			function keyword2rgb(keyword) {
				return cssKeywords[keyword];
			}

			function keyword2hsl(args) {
				return rgb2hsl(keyword2rgb(args));
			}

			function keyword2hsv(args) {
				return rgb2hsv(keyword2rgb(args));
			}

			function keyword2hwb(args) {
				return rgb2hwb(keyword2rgb(args));
			}

			function keyword2cmyk(args) {
				return rgb2cmyk(keyword2rgb(args));
			}

			function keyword2lab(args) {
				return rgb2lab(keyword2rgb(args));
			}

			function keyword2xyz(args) {
				return rgb2xyz(keyword2rgb(args));
			}

			var cssKeywords = {
				aliceblue: [240, 248, 255],
				antiquewhite: [250, 235, 215],
				aqua: [0, 255, 255],
				aquamarine: [127, 255, 212],
				azure: [240, 255, 255],
				beige: [245, 245, 220],
				bisque: [255, 228, 196],
				black: [0, 0, 0],
				blanchedalmond: [255, 235, 205],
				blue: [0, 0, 255],
				blueviolet: [138, 43, 226],
				brown: [165, 42, 42],
				burlywood: [222, 184, 135],
				cadetblue: [95, 158, 160],
				chartreuse: [127, 255, 0],
				chocolate: [210, 105, 30],
				coral: [255, 127, 80],
				cornflowerblue: [100, 149, 237],
				cornsilk: [255, 248, 220],
				crimson: [220, 20, 60],
				cyan: [0, 255, 255],
				darkblue: [0, 0, 139],
				darkcyan: [0, 139, 139],
				darkgoldenrod: [184, 134, 11],
				darkgray: [169, 169, 169],
				darkgreen: [0, 100, 0],
				darkgrey: [169, 169, 169],
				darkkhaki: [189, 183, 107],
				darkmagenta: [139, 0, 139],
				darkolivegreen: [85, 107, 47],
				darkorange: [255, 140, 0],
				darkorchid: [153, 50, 204],
				darkred: [139, 0, 0],
				darksalmon: [233, 150, 122],
				darkseagreen: [143, 188, 143],
				darkslateblue: [72, 61, 139],
				darkslategray: [47, 79, 79],
				darkslategrey: [47, 79, 79],
				darkturquoise: [0, 206, 209],
				darkviolet: [148, 0, 211],
				deeppink: [255, 20, 147],
				deepskyblue: [0, 191, 255],
				dimgray: [105, 105, 105],
				dimgrey: [105, 105, 105],
				dodgerblue: [30, 144, 255],
				firebrick: [178, 34, 34],
				floralwhite: [255, 250, 240],
				forestgreen: [34, 139, 34],
				fuchsia: [255, 0, 255],
				gainsboro: [220, 220, 220],
				ghostwhite: [248, 248, 255],
				gold: [255, 215, 0],
				goldenrod: [218, 165, 32],
				gray: [128, 128, 128],
				green: [0, 128, 0],
				greenyellow: [173, 255, 47],
				grey: [128, 128, 128],
				honeydew: [240, 255, 240],
				hotpink: [255, 105, 180],
				indianred: [205, 92, 92],
				indigo: [75, 0, 130],
				ivory: [255, 255, 240],
				khaki: [240, 230, 140],
				lavender: [230, 230, 250],
				lavenderblush: [255, 240, 245],
				lawngreen: [124, 252, 0],
				lemonchiffon: [255, 250, 205],
				lightblue: [173, 216, 230],
				lightcoral: [240, 128, 128],
				lightcyan: [224, 255, 255],
				lightgoldenrodyellow: [250, 250, 210],
				lightgray: [211, 211, 211],
				lightgreen: [144, 238, 144],
				lightgrey: [211, 211, 211],
				lightpink: [255, 182, 193],
				lightsalmon: [255, 160, 122],
				lightseagreen: [32, 178, 170],
				lightskyblue: [135, 206, 250],
				lightslategray: [119, 136, 153],
				lightslategrey: [119, 136, 153],
				lightsteelblue: [176, 196, 222],
				lightyellow: [255, 255, 224],
				lime: [0, 255, 0],
				limegreen: [50, 205, 50],
				linen: [250, 240, 230],
				magenta: [255, 0, 255],
				maroon: [128, 0, 0],
				mediumaquamarine: [102, 205, 170],
				mediumblue: [0, 0, 205],
				mediumorchid: [186, 85, 211],
				mediumpurple: [147, 112, 219],
				mediumseagreen: [60, 179, 113],
				mediumslateblue: [123, 104, 238],
				mediumspringgreen: [0, 250, 154],
				mediumturquoise: [72, 209, 204],
				mediumvioletred: [199, 21, 133],
				midnightblue: [25, 25, 112],
				mintcream: [245, 255, 250],
				mistyrose: [255, 228, 225],
				moccasin: [255, 228, 181],
				navajowhite: [255, 222, 173],
				navy: [0, 0, 128],
				oldlace: [253, 245, 230],
				olive: [128, 128, 0],
				olivedrab: [107, 142, 35],
				orange: [255, 165, 0],
				orangered: [255, 69, 0],
				orchid: [218, 112, 214],
				palegoldenrod: [238, 232, 170],
				palegreen: [152, 251, 152],
				paleturquoise: [175, 238, 238],
				palevioletred: [219, 112, 147],
				papayawhip: [255, 239, 213],
				peachpuff: [255, 218, 185],
				peru: [205, 133, 63],
				pink: [255, 192, 203],
				plum: [221, 160, 221],
				powderblue: [176, 224, 230],
				purple: [128, 0, 128],
				rebeccapurple: [102, 51, 153],
				red: [255, 0, 0],
				rosybrown: [188, 143, 143],
				royalblue: [65, 105, 225],
				saddlebrown: [139, 69, 19],
				salmon: [250, 128, 114],
				sandybrown: [244, 164, 96],
				seagreen: [46, 139, 87],
				seashell: [255, 245, 238],
				sienna: [160, 82, 45],
				silver: [192, 192, 192],
				skyblue: [135, 206, 235],
				slateblue: [106, 90, 205],
				slategray: [112, 128, 144],
				slategrey: [112, 128, 144],
				snow: [255, 250, 250],
				springgreen: [0, 255, 127],
				steelblue: [70, 130, 180],
				tan: [210, 180, 140],
				teal: [0, 128, 128],
				thistle: [216, 191, 216],
				tomato: [255, 99, 71],
				turquoise: [64, 224, 208],
				violet: [238, 130, 238],
				wheat: [245, 222, 179],
				white: [255, 255, 255],
				whitesmoke: [245, 245, 245],
				yellow: [255, 255, 0],
				yellowgreen: [154, 205, 50]
			};

			var reverseKeywords = {};
			for (var key in cssKeywords) {
				reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
			}
		}, {}], 5: [function (require, module, exports) {
			var conversions = require(4);

			var convert = function convert() {
				return new Converter();
			};

			for (var func in conversions) {
				// export Raw versions
				convert[func + "Raw"] = function (func) {
					// accept array or plain args
					return function (arg) {
						if (typeof arg == "number") arg = Array.prototype.slice.call(arguments);
						return conversions[func](arg);
					};
				}(func);

				var pair = /(\w+)2(\w+)/.exec(func),
				    from = pair[1],
				    to = pair[2];

				// export rgb2hsl and ["rgb"]["hsl"]
				convert[from] = convert[from] || {};

				convert[from][to] = convert[func] = function (func) {
					return function (arg) {
						if (typeof arg == "number") arg = Array.prototype.slice.call(arguments);

						var val = conversions[func](arg);
						if (typeof val == "string" || val === undefined) return val; // keyword

						for (var i = 0; i < val.length; i++) {
							val[i] = Math.round(val[i]);
						}return val;
					};
				}(func);
			}

			/* Converter does lazy conversion and caching */
			var Converter = function Converter() {
				this.convs = {};
			};

			/* Either get the values for a space or
     set the values for a space, depending on args */
			Converter.prototype.routeSpace = function (space, args) {
				var values = args[0];
				if (values === undefined) {
					// color.rgb()
					return this.getValues(space);
				}
				// color.rgb(10, 10, 10)
				if (typeof values == "number") {
					values = Array.prototype.slice.call(args);
				}

				return this.setValues(space, values);
			};

			/* Set the values for a space, invalidating cache */
			Converter.prototype.setValues = function (space, values) {
				this.space = space;
				this.convs = {};
				this.convs[space] = values;
				return this;
			};

			/* Get the values for a space. If there's already
     a conversion for the space, fetch it, otherwise
     compute it */
			Converter.prototype.getValues = function (space) {
				var vals = this.convs[space];
				if (!vals) {
					var fspace = this.space,
					    from = this.convs[fspace];
					vals = convert[fspace][space](from);

					this.convs[space] = vals;
				}
				return vals;
			};

			["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function (space) {
				Converter.prototype[space] = function (vals) {
					return this.routeSpace(space, arguments);
				};
			});

			module.exports = convert;
		}, { "4": 4 }], 6: [function (require, module, exports) {
			'use strict';

			module.exports = {
				"aliceblue": [240, 248, 255],
				"antiquewhite": [250, 235, 215],
				"aqua": [0, 255, 255],
				"aquamarine": [127, 255, 212],
				"azure": [240, 255, 255],
				"beige": [245, 245, 220],
				"bisque": [255, 228, 196],
				"black": [0, 0, 0],
				"blanchedalmond": [255, 235, 205],
				"blue": [0, 0, 255],
				"blueviolet": [138, 43, 226],
				"brown": [165, 42, 42],
				"burlywood": [222, 184, 135],
				"cadetblue": [95, 158, 160],
				"chartreuse": [127, 255, 0],
				"chocolate": [210, 105, 30],
				"coral": [255, 127, 80],
				"cornflowerblue": [100, 149, 237],
				"cornsilk": [255, 248, 220],
				"crimson": [220, 20, 60],
				"cyan": [0, 255, 255],
				"darkblue": [0, 0, 139],
				"darkcyan": [0, 139, 139],
				"darkgoldenrod": [184, 134, 11],
				"darkgray": [169, 169, 169],
				"darkgreen": [0, 100, 0],
				"darkgrey": [169, 169, 169],
				"darkkhaki": [189, 183, 107],
				"darkmagenta": [139, 0, 139],
				"darkolivegreen": [85, 107, 47],
				"darkorange": [255, 140, 0],
				"darkorchid": [153, 50, 204],
				"darkred": [139, 0, 0],
				"darksalmon": [233, 150, 122],
				"darkseagreen": [143, 188, 143],
				"darkslateblue": [72, 61, 139],
				"darkslategray": [47, 79, 79],
				"darkslategrey": [47, 79, 79],
				"darkturquoise": [0, 206, 209],
				"darkviolet": [148, 0, 211],
				"deeppink": [255, 20, 147],
				"deepskyblue": [0, 191, 255],
				"dimgray": [105, 105, 105],
				"dimgrey": [105, 105, 105],
				"dodgerblue": [30, 144, 255],
				"firebrick": [178, 34, 34],
				"floralwhite": [255, 250, 240],
				"forestgreen": [34, 139, 34],
				"fuchsia": [255, 0, 255],
				"gainsboro": [220, 220, 220],
				"ghostwhite": [248, 248, 255],
				"gold": [255, 215, 0],
				"goldenrod": [218, 165, 32],
				"gray": [128, 128, 128],
				"green": [0, 128, 0],
				"greenyellow": [173, 255, 47],
				"grey": [128, 128, 128],
				"honeydew": [240, 255, 240],
				"hotpink": [255, 105, 180],
				"indianred": [205, 92, 92],
				"indigo": [75, 0, 130],
				"ivory": [255, 255, 240],
				"khaki": [240, 230, 140],
				"lavender": [230, 230, 250],
				"lavenderblush": [255, 240, 245],
				"lawngreen": [124, 252, 0],
				"lemonchiffon": [255, 250, 205],
				"lightblue": [173, 216, 230],
				"lightcoral": [240, 128, 128],
				"lightcyan": [224, 255, 255],
				"lightgoldenrodyellow": [250, 250, 210],
				"lightgray": [211, 211, 211],
				"lightgreen": [144, 238, 144],
				"lightgrey": [211, 211, 211],
				"lightpink": [255, 182, 193],
				"lightsalmon": [255, 160, 122],
				"lightseagreen": [32, 178, 170],
				"lightskyblue": [135, 206, 250],
				"lightslategray": [119, 136, 153],
				"lightslategrey": [119, 136, 153],
				"lightsteelblue": [176, 196, 222],
				"lightyellow": [255, 255, 224],
				"lime": [0, 255, 0],
				"limegreen": [50, 205, 50],
				"linen": [250, 240, 230],
				"magenta": [255, 0, 255],
				"maroon": [128, 0, 0],
				"mediumaquamarine": [102, 205, 170],
				"mediumblue": [0, 0, 205],
				"mediumorchid": [186, 85, 211],
				"mediumpurple": [147, 112, 219],
				"mediumseagreen": [60, 179, 113],
				"mediumslateblue": [123, 104, 238],
				"mediumspringgreen": [0, 250, 154],
				"mediumturquoise": [72, 209, 204],
				"mediumvioletred": [199, 21, 133],
				"midnightblue": [25, 25, 112],
				"mintcream": [245, 255, 250],
				"mistyrose": [255, 228, 225],
				"moccasin": [255, 228, 181],
				"navajowhite": [255, 222, 173],
				"navy": [0, 0, 128],
				"oldlace": [253, 245, 230],
				"olive": [128, 128, 0],
				"olivedrab": [107, 142, 35],
				"orange": [255, 165, 0],
				"orangered": [255, 69, 0],
				"orchid": [218, 112, 214],
				"palegoldenrod": [238, 232, 170],
				"palegreen": [152, 251, 152],
				"paleturquoise": [175, 238, 238],
				"palevioletred": [219, 112, 147],
				"papayawhip": [255, 239, 213],
				"peachpuff": [255, 218, 185],
				"peru": [205, 133, 63],
				"pink": [255, 192, 203],
				"plum": [221, 160, 221],
				"powderblue": [176, 224, 230],
				"purple": [128, 0, 128],
				"rebeccapurple": [102, 51, 153],
				"red": [255, 0, 0],
				"rosybrown": [188, 143, 143],
				"royalblue": [65, 105, 225],
				"saddlebrown": [139, 69, 19],
				"salmon": [250, 128, 114],
				"sandybrown": [244, 164, 96],
				"seagreen": [46, 139, 87],
				"seashell": [255, 245, 238],
				"sienna": [160, 82, 45],
				"silver": [192, 192, 192],
				"skyblue": [135, 206, 235],
				"slateblue": [106, 90, 205],
				"slategray": [112, 128, 144],
				"slategrey": [112, 128, 144],
				"snow": [255, 250, 250],
				"springgreen": [0, 255, 127],
				"steelblue": [70, 130, 180],
				"tan": [210, 180, 140],
				"teal": [0, 128, 128],
				"thistle": [216, 191, 216],
				"tomato": [255, 99, 71],
				"turquoise": [64, 224, 208],
				"violet": [238, 130, 238],
				"wheat": [245, 222, 179],
				"white": [255, 255, 255],
				"whitesmoke": [245, 245, 245],
				"yellow": [255, 255, 0],
				"yellowgreen": [154, 205, 50]
			};
		}, {}], 7: [function (require, module, exports) {
			/**
    * @namespace Chart
    */
			var Chart = require(29)();

			Chart.helpers = require(45);

			// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
			require(27)(Chart);

			Chart.defaults = require(25);
			Chart.Element = require(26);
			Chart.elements = require(40);
			Chart.Interaction = require(28);
			Chart.layouts = require(30);
			Chart.platform = require(48);
			Chart.plugins = require(31);
			Chart.Ticks = require(34);

			require(22)(Chart);
			require(23)(Chart);
			require(24)(Chart);
			require(33)(Chart);
			require(32)(Chart);
			require(35)(Chart);

			require(55)(Chart);
			require(53)(Chart);
			require(54)(Chart);
			require(56)(Chart);
			require(57)(Chart);
			require(58)(Chart);

			// Controllers must be loaded after elements
			// See Chart.core.datasetController.dataElementType
			require(15)(Chart);
			require(16)(Chart);
			require(17)(Chart);
			require(18)(Chart);
			require(19)(Chart);
			require(20)(Chart);
			require(21)(Chart);

			require(8)(Chart);
			require(9)(Chart);
			require(10)(Chart);
			require(11)(Chart);
			require(12)(Chart);
			require(13)(Chart);
			require(14)(Chart);

			// Loading built-it plugins
			var plugins = require(49);
			for (var k in plugins) {
				if (plugins.hasOwnProperty(k)) {
					Chart.plugins.register(plugins[k]);
				}
			}

			Chart.platform.initialize();

			module.exports = Chart;
			if (typeof window !== 'undefined') {
				window.Chart = Chart;
			}

			// DEPRECATIONS

			/**
    * Provided for backward compatibility, not available anymore
    * @namespace Chart.Legend
    * @deprecated since version 2.1.5
    * @todo remove at version 3
    * @private
    */
			Chart.Legend = plugins.legend._element;

			/**
    * Provided for backward compatibility, not available anymore
    * @namespace Chart.Title
    * @deprecated since version 2.1.5
    * @todo remove at version 3
    * @private
    */
			Chart.Title = plugins.title._element;

			/**
    * Provided for backward compatibility, use Chart.plugins instead
    * @namespace Chart.pluginService
    * @deprecated since version 2.1.5
    * @todo remove at version 3
    * @private
    */
			Chart.pluginService = Chart.plugins;

			/**
    * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
    * effect, instead simply create/register plugins via plain JavaScript objects.
    * @interface Chart.PluginBase
    * @deprecated since version 2.5.0
    * @todo remove at version 3
    * @private
    */
			Chart.PluginBase = Chart.Element.extend({});

			/**
    * Provided for backward compatibility, use Chart.helpers.canvas instead.
    * @namespace Chart.canvasHelpers
    * @deprecated since version 2.6.0
    * @todo remove at version 3
    * @private
    */
			Chart.canvasHelpers = Chart.helpers.canvas;

			/**
    * Provided for backward compatibility, use Chart.layouts instead.
    * @namespace Chart.layoutService
    * @deprecated since version 2.8.0
    * @todo remove at version 3
    * @private
    */
			Chart.layoutService = Chart.layouts;
		}, { "10": 10, "11": 11, "12": 12, "13": 13, "14": 14, "15": 15, "16": 16, "17": 17, "18": 18, "19": 19, "20": 20, "21": 21, "22": 22, "23": 23, "24": 24, "25": 25, "26": 26, "27": 27, "28": 28, "29": 29, "30": 30, "31": 31, "32": 32, "33": 33, "34": 34, "35": 35, "40": 40, "45": 45, "48": 48, "49": 49, "53": 53, "54": 54, "55": 55, "56": 56, "57": 57, "58": 58, "8": 8, "9": 9 }], 8: [function (require, module, exports) {
			'use strict';

			module.exports = function (Chart) {

				Chart.Bar = function (context, config) {
					config.type = 'bar';

					return new Chart(context, config);
				};
			};
		}, {}], 9: [function (require, module, exports) {
			'use strict';

			module.exports = function (Chart) {

				Chart.Bubble = function (context, config) {
					config.type = 'bubble';
					return new Chart(context, config);
				};
			};
		}, {}], 10: [function (require, module, exports) {
			'use strict';

			module.exports = function (Chart) {

				Chart.Doughnut = function (context, config) {
					config.type = 'doughnut';

					return new Chart(context, config);
				};
			};
		}, {}], 11: [function (require, module, exports) {
			'use strict';

			module.exports = function (Chart) {

				Chart.Line = function (context, config) {
					config.type = 'line';

					return new Chart(context, config);
				};
			};
		}, {}], 12: [function (require, module, exports) {
			'use strict';

			module.exports = function (Chart) {

				Chart.PolarArea = function (context, config) {
					config.type = 'polarArea';

					return new Chart(context, config);
				};
			};
		}, {}], 13: [function (require, module, exports) {
			'use strict';

			module.exports = function (Chart) {

				Chart.Radar = function (context, config) {
					config.type = 'radar';

					return new Chart(context, config);
				};
			};
		}, {}], 14: [function (require, module, exports) {
			'use strict';

			module.exports = function (Chart) {
				Chart.Scatter = function (context, config) {
					config.type = 'scatter';
					return new Chart(context, config);
				};
			};
		}, {}], 15: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var elements = require(40);
			var helpers = require(45);

			defaults._set('bar', {
				hover: {
					mode: 'label'
				},

				scales: {
					xAxes: [{
						type: 'category',

						// Specific to Bar Controller
						categoryPercentage: 0.8,
						barPercentage: 0.9,

						// offset settings
						offset: true,

						// grid line settings
						gridLines: {
							offsetGridLines: true
						}
					}],

					yAxes: [{
						type: 'linear'
					}]
				}
			});

			defaults._set('horizontalBar', {
				hover: {
					mode: 'index',
					axis: 'y'
				},

				scales: {
					xAxes: [{
						type: 'linear',
						position: 'bottom'
					}],

					yAxes: [{
						position: 'left',
						type: 'category',

						// Specific to Horizontal Bar Controller
						categoryPercentage: 0.8,
						barPercentage: 0.9,

						// offset settings
						offset: true,

						// grid line settings
						gridLines: {
							offsetGridLines: true
						}
					}]
				},

				elements: {
					rectangle: {
						borderSkipped: 'left'
					}
				},

				tooltips: {
					callbacks: {
						title: function title(item, data) {
							// Pick first xLabel for now
							var title = '';

							if (item.length > 0) {
								if (item[0].yLabel) {
									title = item[0].yLabel;
								} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
									title = data.labels[item[0].index];
								}
							}

							return title;
						},

						label: function label(item, data) {
							var datasetLabel = data.datasets[item.datasetIndex].label || '';
							return datasetLabel + ': ' + item.xLabel;
						}
					},
					mode: 'index',
					axis: 'y'
				}
			});

			/**
    * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
    * @private
    */
			function computeMinSampleSize(scale, pixels) {
				var min = scale.isHorizontal() ? scale.width : scale.height;
				var ticks = scale.getTicks();
				var prev, curr, i, ilen;

				for (i = 1, ilen = pixels.length; i < ilen; ++i) {
					min = Math.min(min, pixels[i] - pixels[i - 1]);
				}

				for (i = 0, ilen = ticks.length; i < ilen; ++i) {
					curr = scale.getPixelForTick(i);
					min = i > 0 ? Math.min(min, curr - prev) : min;
					prev = curr;
				}

				return min;
			}

			/**
    * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
    * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
    * mode currently always generates bars equally sized (until we introduce scriptable options?).
    * @private
    */
			function computeFitCategoryTraits(index, ruler, options) {
				var thickness = options.barThickness;
				var count = ruler.stackCount;
				var curr = ruler.pixels[index];
				var size, ratio;

				if (helpers.isNullOrUndef(thickness)) {
					size = ruler.min * options.categoryPercentage;
					ratio = options.barPercentage;
				} else {
					// When bar thickness is enforced, category and bar percentages are ignored.
					// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
					// and deprecate barPercentage since this value is ignored when thickness is absolute.
					size = thickness * count;
					ratio = 1;
				}

				return {
					chunk: size / count,
					ratio: ratio,
					start: curr - size / 2
				};
			}

			/**
    * Computes an "optimal" category that globally arranges bars side by side (no gap when
    * percentage options are 1), based on the previous and following categories. This mode
    * generates bars with different widths when data are not evenly spaced.
    * @private
    */
			function computeFlexCategoryTraits(index, ruler, options) {
				var pixels = ruler.pixels;
				var curr = pixels[index];
				var prev = index > 0 ? pixels[index - 1] : null;
				var next = index < pixels.length - 1 ? pixels[index + 1] : null;
				var percent = options.categoryPercentage;
				var start, size;

				if (prev === null) {
					// first data: its size is double based on the next point or,
					// if it's also the last data, we use the scale end extremity.
					prev = curr - (next === null ? ruler.end - curr : next - curr);
				}

				if (next === null) {
					// last data: its size is also double based on the previous point.
					next = curr + curr - prev;
				}

				start = curr - (curr - prev) / 2 * percent;
				size = (next - prev) / 2 * percent;

				return {
					chunk: size / ruler.stackCount,
					ratio: options.barPercentage,
					start: start
				};
			}

			module.exports = function (Chart) {

				Chart.controllers.bar = Chart.DatasetController.extend({

					dataElementType: elements.Rectangle,

					initialize: function initialize() {
						var me = this;
						var meta;

						Chart.DatasetController.prototype.initialize.apply(me, arguments);

						meta = me.getMeta();
						meta.stack = me.getDataset().stack;
						meta.bar = true;
					},

					update: function update(reset) {
						var me = this;
						var rects = me.getMeta().data;
						var i, ilen;

						me._ruler = me.getRuler();

						for (i = 0, ilen = rects.length; i < ilen; ++i) {
							me.updateElement(rects[i], i, reset);
						}
					},

					updateElement: function updateElement(rectangle, index, reset) {
						var me = this;
						var chart = me.chart;
						var meta = me.getMeta();
						var dataset = me.getDataset();
						var custom = rectangle.custom || {};
						var rectangleOptions = chart.options.elements.rectangle;

						rectangle._xScale = me.getScaleForId(meta.xAxisID);
						rectangle._yScale = me.getScaleForId(meta.yAxisID);
						rectangle._datasetIndex = me.index;
						rectangle._index = index;

						rectangle._model = {
							datasetLabel: dataset.label,
							label: chart.data.labels[index],
							borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
							backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
							borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
							borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
						};

						me.updateElementGeometry(rectangle, index, reset);

						rectangle.pivot();
					},

					/**
      * @private
      */
					updateElementGeometry: function updateElementGeometry(rectangle, index, reset) {
						var me = this;
						var model = rectangle._model;
						var vscale = me.getValueScale();
						var base = vscale.getBasePixel();
						var horizontal = vscale.isHorizontal();
						var ruler = me._ruler || me.getRuler();
						var vpixels = me.calculateBarValuePixels(me.index, index);
						var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

						model.horizontal = horizontal;
						model.base = reset ? base : vpixels.base;
						model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
						model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
						model.height = horizontal ? ipixels.size : undefined;
						model.width = horizontal ? undefined : ipixels.size;
					},

					/**
      * @private
      */
					getValueScaleId: function getValueScaleId() {
						return this.getMeta().yAxisID;
					},

					/**
      * @private
      */
					getIndexScaleId: function getIndexScaleId() {
						return this.getMeta().xAxisID;
					},

					/**
      * @private
      */
					getValueScale: function getValueScale() {
						return this.getScaleForId(this.getValueScaleId());
					},

					/**
      * @private
      */
					getIndexScale: function getIndexScale() {
						return this.getScaleForId(this.getIndexScaleId());
					},

					/**
      * Returns the stacks based on groups and bar visibility.
      * @param {Number} [last] - The dataset index
      * @returns {Array} The stack list
      * @private
      */
					_getStacks: function _getStacks(last) {
						var me = this;
						var chart = me.chart;
						var scale = me.getIndexScale();
						var stacked = scale.options.stacked;
						var ilen = last === undefined ? chart.data.datasets.length : last + 1;
						var stacks = [];
						var i, meta;

						for (i = 0; i < ilen; ++i) {
							meta = chart.getDatasetMeta(i);
							if (meta.bar && chart.isDatasetVisible(i) && (stacked === false || stacked === true && stacks.indexOf(meta.stack) === -1 || stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1))) {
								stacks.push(meta.stack);
							}
						}

						return stacks;
					},

					/**
      * Returns the effective number of stacks based on groups and bar visibility.
      * @private
      */
					getStackCount: function getStackCount() {
						return this._getStacks().length;
					},

					/**
      * Returns the stack index for the given dataset based on groups and bar visibility.
      * @param {Number} [datasetIndex] - The dataset index
      * @param {String} [name] - The stack name to find
      * @returns {Number} The stack index
      * @private
      */
					getStackIndex: function getStackIndex(datasetIndex, name) {
						var stacks = this._getStacks(datasetIndex);
						var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present

						return index === -1 ? stacks.length - 1 : index;
					},

					/**
      * @private
      */
					getRuler: function getRuler() {
						var me = this;
						var scale = me.getIndexScale();
						var stackCount = me.getStackCount();
						var datasetIndex = me.index;
						var isHorizontal = scale.isHorizontal();
						var start = isHorizontal ? scale.left : scale.top;
						var end = start + (isHorizontal ? scale.width : scale.height);
						var pixels = [];
						var i, ilen, min;

						for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
							pixels.push(scale.getPixelForValue(null, i, datasetIndex));
						}

						min = helpers.isNullOrUndef(scale.options.barThickness) ? computeMinSampleSize(scale, pixels) : -1;

						return {
							min: min,
							pixels: pixels,
							start: start,
							end: end,
							stackCount: stackCount,
							scale: scale
						};
					},

					/**
      * Note: pixel values are not clamped to the scale area.
      * @private
      */
					calculateBarValuePixels: function calculateBarValuePixels(datasetIndex, index) {
						var me = this;
						var chart = me.chart;
						var meta = me.getMeta();
						var scale = me.getValueScale();
						var datasets = chart.data.datasets;
						var value = scale.getRightValue(datasets[datasetIndex].data[index]);
						var stacked = scale.options.stacked;
						var stack = meta.stack;
						var start = 0;
						var i, imeta, ivalue, base, head, size;

						if (stacked || stacked === undefined && stack !== undefined) {
							for (i = 0; i < datasetIndex; ++i) {
								imeta = chart.getDatasetMeta(i);

								if (imeta.bar && imeta.stack === stack && imeta.controller.getValueScaleId() === scale.id && chart.isDatasetVisible(i)) {

									ivalue = scale.getRightValue(datasets[i].data[index]);
									if (value < 0 && ivalue < 0 || value >= 0 && ivalue > 0) {
										start += ivalue;
									}
								}
							}
						}

						base = scale.getPixelForValue(start);
						head = scale.getPixelForValue(start + value);
						size = (head - base) / 2;

						return {
							size: size,
							base: base,
							head: head,
							center: head + size / 2
						};
					},

					/**
      * @private
      */
					calculateBarIndexPixels: function calculateBarIndexPixels(datasetIndex, index, ruler) {
						var me = this;
						var options = ruler.scale.options;
						var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);

						var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
						var center = range.start + range.chunk * stackIndex + range.chunk / 2;
						var size = Math.min(helpers.valueOrDefault(options.maxBarThickness, Infinity), range.chunk * range.ratio);

						return {
							base: center - size / 2,
							head: center + size / 2,
							center: center,
							size: size
						};
					},

					draw: function draw() {
						var me = this;
						var chart = me.chart;
						var scale = me.getValueScale();
						var rects = me.getMeta().data;
						var dataset = me.getDataset();
						var ilen = rects.length;
						var i = 0;

						helpers.canvas.clipArea(chart.ctx, chart.chartArea);

						for (; i < ilen; ++i) {
							if (!isNaN(scale.getRightValue(dataset.data[i]))) {
								rects[i].draw();
							}
						}

						helpers.canvas.unclipArea(chart.ctx);
					},

					setHoverStyle: function setHoverStyle(rectangle) {
						var dataset = this.chart.data.datasets[rectangle._datasetIndex];
						var index = rectangle._index;
						var custom = rectangle.custom || {};
						var model = rectangle._model;

						model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
						model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
						model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
					},

					removeHoverStyle: function removeHoverStyle(rectangle) {
						var dataset = this.chart.data.datasets[rectangle._datasetIndex];
						var index = rectangle._index;
						var custom = rectangle.custom || {};
						var model = rectangle._model;
						var rectangleElementOptions = this.chart.options.elements.rectangle;

						model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
						model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
						model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
					}
				});

				Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
					/**
      * @private
      */
					getValueScaleId: function getValueScaleId() {
						return this.getMeta().xAxisID;
					},

					/**
      * @private
      */
					getIndexScaleId: function getIndexScaleId() {
						return this.getMeta().yAxisID;
					}
				});
			};
		}, { "25": 25, "40": 40, "45": 45 }], 16: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var elements = require(40);
			var helpers = require(45);

			defaults._set('bubble', {
				hover: {
					mode: 'single'
				},

				scales: {
					xAxes: [{
						type: 'linear', // bubble should probably use a linear scale by default
						position: 'bottom',
						id: 'x-axis-0' // need an ID so datasets can reference the scale
					}],
					yAxes: [{
						type: 'linear',
						position: 'left',
						id: 'y-axis-0'
					}]
				},

				tooltips: {
					callbacks: {
						title: function title() {
							// Title doesn't make sense for scatter since we format the data as a point
							return '';
						},
						label: function label(item, data) {
							var datasetLabel = data.datasets[item.datasetIndex].label || '';
							var dataPoint = data.datasets[item.datasetIndex].data[item.index];
							return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
						}
					}
				}
			});

			module.exports = function (Chart) {

				Chart.controllers.bubble = Chart.DatasetController.extend({
					/**
      * @protected
      */
					dataElementType: elements.Point,

					/**
      * @protected
      */
					update: function update(reset) {
						var me = this;
						var meta = me.getMeta();
						var points = meta.data;

						// Update Points
						helpers.each(points, function (point, index) {
							me.updateElement(point, index, reset);
						});
					},

					/**
      * @protected
      */
					updateElement: function updateElement(point, index, reset) {
						var me = this;
						var meta = me.getMeta();
						var custom = point.custom || {};
						var xScale = me.getScaleForId(meta.xAxisID);
						var yScale = me.getScaleForId(meta.yAxisID);
						var options = me._resolveElementOptions(point, index);
						var data = me.getDataset().data[index];
						var dsIndex = me.index;

						var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue((typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object' ? data : NaN, index, dsIndex);
						var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

						point._xScale = xScale;
						point._yScale = yScale;
						point._options = options;
						point._datasetIndex = dsIndex;
						point._index = index;
						point._model = {
							backgroundColor: options.backgroundColor,
							borderColor: options.borderColor,
							borderWidth: options.borderWidth,
							hitRadius: options.hitRadius,
							pointStyle: options.pointStyle,
							radius: reset ? 0 : options.radius,
							skip: custom.skip || isNaN(x) || isNaN(y),
							x: x,
							y: y
						};

						point.pivot();
					},

					/**
      * @protected
      */
					setHoverStyle: function setHoverStyle(point) {
						var model = point._model;
						var options = point._options;

						model.backgroundColor = helpers.valueOrDefault(options.hoverBackgroundColor, helpers.getHoverColor(options.backgroundColor));
						model.borderColor = helpers.valueOrDefault(options.hoverBorderColor, helpers.getHoverColor(options.borderColor));
						model.borderWidth = helpers.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
						model.radius = options.radius + options.hoverRadius;
					},

					/**
      * @protected
      */
					removeHoverStyle: function removeHoverStyle(point) {
						var model = point._model;
						var options = point._options;

						model.backgroundColor = options.backgroundColor;
						model.borderColor = options.borderColor;
						model.borderWidth = options.borderWidth;
						model.radius = options.radius;
					},

					/**
      * @private
      */
					_resolveElementOptions: function _resolveElementOptions(point, index) {
						var me = this;
						var chart = me.chart;
						var datasets = chart.data.datasets;
						var dataset = datasets[me.index];
						var custom = point.custom || {};
						var options = chart.options.elements.point;
						var resolve = helpers.options.resolve;
						var data = dataset.data[index];
						var values = {};
						var i, ilen, key;

						// Scriptable options
						var context = {
							chart: chart,
							dataIndex: index,
							dataset: dataset,
							datasetIndex: me.index
						};

						var keys = ['backgroundColor', 'borderColor', 'borderWidth', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth', 'hoverRadius', 'hitRadius', 'pointStyle'];

						for (i = 0, ilen = keys.length; i < ilen; ++i) {
							key = keys[i];
							values[key] = resolve([custom[key], dataset[key], options[key]], context, index);
						}

						// Custom radius resolution
						values.radius = resolve([custom.radius, data ? data.r : undefined, dataset.radius, options.radius], context, index);

						return values;
					}
				});
			};
		}, { "25": 25, "40": 40, "45": 45 }], 17: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var elements = require(40);
			var helpers = require(45);

			defaults._set('doughnut', {
				animation: {
					// Boolean - Whether we animate the rotation of the Doughnut
					animateRotate: true,
					// Boolean - Whether we animate scaling the Doughnut from the centre
					animateScale: false
				},
				hover: {
					mode: 'single'
				},
				legendCallback: function legendCallback(chart) {
					var text = [];
					text.push('<ul class="' + chart.id + '-legend">');

					var data = chart.data;
					var datasets = data.datasets;
					var labels = data.labels;

					if (datasets.length) {
						for (var i = 0; i < datasets[0].data.length; ++i) {
							text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
							if (labels[i]) {
								text.push(labels[i]);
							}
							text.push('</li>');
						}
					}

					text.push('</ul>');
					return text.join('');
				},
				legend: {
					labels: {
						generateLabels: function generateLabels(chart) {
							var data = chart.data;
							if (data.labels.length && data.datasets.length) {
								return data.labels.map(function (label, i) {
									var meta = chart.getDatasetMeta(0);
									var ds = data.datasets[0];
									var arc = meta.data[i];
									var custom = arc && arc.custom || {};
									var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
									var arcOpts = chart.options.elements.arc;
									var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
									var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
									var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

									return {
										text: label,
										fillStyle: fill,
										strokeStyle: stroke,
										lineWidth: bw,
										hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

										// Extra data used for toggling the correct item
										index: i
									};
								});
							}
							return [];
						}
					},

					onClick: function onClick(e, legendItem) {
						var index = legendItem.index;
						var chart = this.chart;
						var i, ilen, meta;

						for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
							meta = chart.getDatasetMeta(i);
							// toggle visibility of index if exists
							if (meta.data[index]) {
								meta.data[index].hidden = !meta.data[index].hidden;
							}
						}

						chart.update();
					}
				},

				// The percentage of the chart that we cut out of the middle.
				cutoutPercentage: 50,

				// The rotation of the chart, where the first data arc begins.
				rotation: Math.PI * -0.5,

				// The total circumference of the chart.
				circumference: Math.PI * 2.0,

				// Need to override these to give a nice default
				tooltips: {
					callbacks: {
						title: function title() {
							return '';
						},
						label: function label(tooltipItem, data) {
							var dataLabel = data.labels[tooltipItem.index];
							var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

							if (helpers.isArray(dataLabel)) {
								// show value on first line of multiline label
								// need to clone because we are changing the value
								dataLabel = dataLabel.slice();
								dataLabel[0] += value;
							} else {
								dataLabel += value;
							}

							return dataLabel;
						}
					}
				}
			});

			defaults._set('pie', helpers.clone(defaults.doughnut));
			defaults._set('pie', {
				cutoutPercentage: 0
			});

			module.exports = function (Chart) {

				Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({

					dataElementType: elements.Arc,

					linkScales: helpers.noop,

					// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
					getRingIndex: function getRingIndex(datasetIndex) {
						var ringIndex = 0;

						for (var j = 0; j < datasetIndex; ++j) {
							if (this.chart.isDatasetVisible(j)) {
								++ringIndex;
							}
						}

						return ringIndex;
					},

					update: function update(reset) {
						var me = this;
						var chart = me.chart;
						var chartArea = chart.chartArea;
						var opts = chart.options;
						var arcOpts = opts.elements.arc;
						var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
						var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
						var minSize = Math.min(availableWidth, availableHeight);
						var offset = { x: 0, y: 0 };
						var meta = me.getMeta();
						var cutoutPercentage = opts.cutoutPercentage;
						var circumference = opts.circumference;

						// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
						if (circumference < Math.PI * 2.0) {
							var startAngle = opts.rotation % (Math.PI * 2.0);
							startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
							var endAngle = startAngle + circumference;
							var start = { x: Math.cos(startAngle), y: Math.sin(startAngle) };
							var end = { x: Math.cos(endAngle), y: Math.sin(endAngle) };
							var contains0 = startAngle <= 0 && endAngle >= 0 || startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle;
							var contains90 = startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle || startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle;
							var contains180 = startAngle <= -Math.PI && -Math.PI <= endAngle || startAngle <= Math.PI && Math.PI <= endAngle;
							var contains270 = startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle || startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle;
							var cutout = cutoutPercentage / 100.0;
							var min = { x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout)) };
							var max = { x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout)) };
							var size = { width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5 };
							minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
							offset = { x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5 };
						}

						chart.borderWidth = me.getMaxBorderWidth(meta.data);
						chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
						chart.innerRadius = Math.max(cutoutPercentage ? chart.outerRadius / 100 * cutoutPercentage : 0, 0);
						chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
						chart.offsetX = offset.x * chart.outerRadius;
						chart.offsetY = offset.y * chart.outerRadius;

						meta.total = me.calculateTotal();

						me.outerRadius = chart.outerRadius - chart.radiusLength * me.getRingIndex(me.index);
						me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);

						helpers.each(meta.data, function (arc, index) {
							me.updateElement(arc, index, reset);
						});
					},

					updateElement: function updateElement(arc, index, reset) {
						var me = this;
						var chart = me.chart;
						var chartArea = chart.chartArea;
						var opts = chart.options;
						var animationOpts = opts.animation;
						var centerX = (chartArea.left + chartArea.right) / 2;
						var centerY = (chartArea.top + chartArea.bottom) / 2;
						var startAngle = opts.rotation; // non reset case handled later
						var endAngle = opts.rotation; // non reset case handled later
						var dataset = me.getDataset();
						var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
						var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
						var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

						helpers.extend(arc, {
							// Utility
							_datasetIndex: me.index,
							_index: index,

							// Desired view properties
							_model: {
								x: centerX + chart.offsetX,
								y: centerY + chart.offsetY,
								startAngle: startAngle,
								endAngle: endAngle,
								circumference: circumference,
								outerRadius: outerRadius,
								innerRadius: innerRadius,
								label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
							}
						});

						var model = arc._model;
						// Resets the visual styles
						this.removeHoverStyle(arc);

						// Set correct angles if not resetting
						if (!reset || !animationOpts.animateRotate) {
							if (index === 0) {
								model.startAngle = opts.rotation;
							} else {
								model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
							}

							model.endAngle = model.startAngle + model.circumference;
						}

						arc.pivot();
					},

					removeHoverStyle: function removeHoverStyle(arc) {
						Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
					},

					calculateTotal: function calculateTotal() {
						var dataset = this.getDataset();
						var meta = this.getMeta();
						var total = 0;
						var value;

						helpers.each(meta.data, function (element, index) {
							value = dataset.data[index];
							if (!isNaN(value) && !element.hidden) {
								total += Math.abs(value);
							}
						});

						/* if (total === 0) {
      	total = NaN;
      }*/

						return total;
					},

					calculateCircumference: function calculateCircumference(value) {
						var total = this.getMeta().total;
						if (total > 0 && !isNaN(value)) {
							return Math.PI * 2.0 * (Math.abs(value) / total);
						}
						return 0;
					},

					// gets the max border or hover width to properly scale pie charts
					getMaxBorderWidth: function getMaxBorderWidth(arcs) {
						var max = 0;
						var index = this.index;
						var length = arcs.length;
						var borderWidth;
						var hoverWidth;

						for (var i = 0; i < length; i++) {
							borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
							hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;

							max = borderWidth > max ? borderWidth : max;
							max = hoverWidth > max ? hoverWidth : max;
						}
						return max;
					}
				});
			};
		}, { "25": 25, "40": 40, "45": 45 }], 18: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var elements = require(40);
			var helpers = require(45);

			defaults._set('line', {
				showLines: true,
				spanGaps: false,

				hover: {
					mode: 'label'
				},

				scales: {
					xAxes: [{
						type: 'category',
						id: 'x-axis-0'
					}],
					yAxes: [{
						type: 'linear',
						id: 'y-axis-0'
					}]
				}
			});

			module.exports = function (Chart) {

				function lineEnabled(dataset, options) {
					return helpers.valueOrDefault(dataset.showLine, options.showLines);
				}

				Chart.controllers.line = Chart.DatasetController.extend({

					datasetElementType: elements.Line,

					dataElementType: elements.Point,

					update: function update(reset) {
						var me = this;
						var meta = me.getMeta();
						var line = meta.dataset;
						var points = meta.data || [];
						var options = me.chart.options;
						var lineElementOptions = options.elements.line;
						var scale = me.getScaleForId(meta.yAxisID);
						var i, ilen, custom;
						var dataset = me.getDataset();
						var showLine = lineEnabled(dataset, options);

						// Update Line
						if (showLine) {
							custom = line.custom || {};

							// Compatibility: If the properties are defined with only the old name, use those values
							if (dataset.tension !== undefined && dataset.lineTension === undefined) {
								dataset.lineTension = dataset.tension;
							}

							// Utility
							line._scale = scale;
							line._datasetIndex = me.index;
							// Data
							line._children = points;
							// Model
							line._model = {
								// Appearance
								// The default behavior of lines is to break at null values, according
								// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
								// This option gives lines the ability to span gaps
								spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
								tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
								backgroundColor: custom.backgroundColor ? custom.backgroundColor : dataset.backgroundColor || lineElementOptions.backgroundColor,
								borderWidth: custom.borderWidth ? custom.borderWidth : dataset.borderWidth || lineElementOptions.borderWidth,
								borderColor: custom.borderColor ? custom.borderColor : dataset.borderColor || lineElementOptions.borderColor,
								borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : dataset.borderCapStyle || lineElementOptions.borderCapStyle,
								borderDash: custom.borderDash ? custom.borderDash : dataset.borderDash || lineElementOptions.borderDash,
								borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : dataset.borderDashOffset || lineElementOptions.borderDashOffset,
								borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : dataset.borderJoinStyle || lineElementOptions.borderJoinStyle,
								fill: custom.fill ? custom.fill : dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill,
								steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
								cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode)
							};

							line.pivot();
						}

						// Update Points
						for (i = 0, ilen = points.length; i < ilen; ++i) {
							me.updateElement(points[i], i, reset);
						}

						if (showLine && line._model.tension !== 0) {
							me.updateBezierControlPoints();
						}

						// Now pivot the point for animation
						for (i = 0, ilen = points.length; i < ilen; ++i) {
							points[i].pivot();
						}
					},

					getPointBackgroundColor: function getPointBackgroundColor(point, index) {
						var backgroundColor = this.chart.options.elements.point.backgroundColor;
						var dataset = this.getDataset();
						var custom = point.custom || {};

						if (custom.backgroundColor) {
							backgroundColor = custom.backgroundColor;
						} else if (dataset.pointBackgroundColor) {
							backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
						} else if (dataset.backgroundColor) {
							backgroundColor = dataset.backgroundColor;
						}

						return backgroundColor;
					},

					getPointBorderColor: function getPointBorderColor(point, index) {
						var borderColor = this.chart.options.elements.point.borderColor;
						var dataset = this.getDataset();
						var custom = point.custom || {};

						if (custom.borderColor) {
							borderColor = custom.borderColor;
						} else if (dataset.pointBorderColor) {
							borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
						} else if (dataset.borderColor) {
							borderColor = dataset.borderColor;
						}

						return borderColor;
					},

					getPointBorderWidth: function getPointBorderWidth(point, index) {
						var borderWidth = this.chart.options.elements.point.borderWidth;
						var dataset = this.getDataset();
						var custom = point.custom || {};

						if (!isNaN(custom.borderWidth)) {
							borderWidth = custom.borderWidth;
						} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
							borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
						} else if (!isNaN(dataset.borderWidth)) {
							borderWidth = dataset.borderWidth;
						}

						return borderWidth;
					},

					updateElement: function updateElement(point, index, reset) {
						var me = this;
						var meta = me.getMeta();
						var custom = point.custom || {};
						var dataset = me.getDataset();
						var datasetIndex = me.index;
						var value = dataset.data[index];
						var yScale = me.getScaleForId(meta.yAxisID);
						var xScale = me.getScaleForId(meta.xAxisID);
						var pointOptions = me.chart.options.elements.point;
						var x, y;

						// Compatibility: If the properties are defined with only the old name, use those values
						if (dataset.radius !== undefined && dataset.pointRadius === undefined) {
							dataset.pointRadius = dataset.radius;
						}
						if (dataset.hitRadius !== undefined && dataset.pointHitRadius === undefined) {
							dataset.pointHitRadius = dataset.hitRadius;
						}

						x = xScale.getPixelForValue((typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' ? value : NaN, index, datasetIndex);
						y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

						// Utility
						point._xScale = xScale;
						point._yScale = yScale;
						point._datasetIndex = datasetIndex;
						point._index = index;

						// Desired view properties
						point._model = {
							x: x,
							y: y,
							skip: custom.skip || isNaN(x) || isNaN(y),
							// Appearance
							radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
							pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
							backgroundColor: me.getPointBackgroundColor(point, index),
							borderColor: me.getPointBorderColor(point, index),
							borderWidth: me.getPointBorderWidth(point, index),
							tension: meta.dataset._model ? meta.dataset._model.tension : 0,
							steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
							// Tooltip
							hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
						};
					},

					calculatePointY: function calculatePointY(value, index, datasetIndex) {
						var me = this;
						var chart = me.chart;
						var meta = me.getMeta();
						var yScale = me.getScaleForId(meta.yAxisID);
						var sumPos = 0;
						var sumNeg = 0;
						var i, ds, dsMeta;

						if (yScale.options.stacked) {
							for (i = 0; i < datasetIndex; i++) {
								ds = chart.data.datasets[i];
								dsMeta = chart.getDatasetMeta(i);
								if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
									var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
									if (stackedRightValue < 0) {
										sumNeg += stackedRightValue || 0;
									} else {
										sumPos += stackedRightValue || 0;
									}
								}
							}

							var rightValue = Number(yScale.getRightValue(value));
							if (rightValue < 0) {
								return yScale.getPixelForValue(sumNeg + rightValue);
							}
							return yScale.getPixelForValue(sumPos + rightValue);
						}

						return yScale.getPixelForValue(value);
					},

					updateBezierControlPoints: function updateBezierControlPoints() {
						var me = this;
						var meta = me.getMeta();
						var area = me.chart.chartArea;
						var points = meta.data || [];
						var i, ilen, point, model, controlPoints;

						// Only consider points that are drawn in case the spanGaps option is used
						if (meta.dataset._model.spanGaps) {
							points = points.filter(function (pt) {
								return !pt._model.skip;
							});
						}

						function capControlPoint(pt, min, max) {
							return Math.max(Math.min(pt, max), min);
						}

						if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
							helpers.splineCurveMonotone(points);
						} else {
							for (i = 0, ilen = points.length; i < ilen; ++i) {
								point = points[i];
								model = point._model;
								controlPoints = helpers.splineCurve(helpers.previousItem(points, i)._model, model, helpers.nextItem(points, i)._model, meta.dataset._model.tension);
								model.controlPointPreviousX = controlPoints.previous.x;
								model.controlPointPreviousY = controlPoints.previous.y;
								model.controlPointNextX = controlPoints.next.x;
								model.controlPointNextY = controlPoints.next.y;
							}
						}

						if (me.chart.options.elements.line.capBezierPoints) {
							for (i = 0, ilen = points.length; i < ilen; ++i) {
								model = points[i]._model;
								model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
								model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
								model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
								model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
							}
						}
					},

					draw: function draw() {
						var me = this;
						var chart = me.chart;
						var meta = me.getMeta();
						var points = meta.data || [];
						var area = chart.chartArea;
						var ilen = points.length;
						var i = 0;

						helpers.canvas.clipArea(chart.ctx, area);

						if (lineEnabled(me.getDataset(), chart.options)) {
							meta.dataset.draw();
						}

						helpers.canvas.unclipArea(chart.ctx);

						// Draw the points
						for (; i < ilen; ++i) {
							points[i].draw(area);
						}
					},

					setHoverStyle: function setHoverStyle(point) {
						// Point
						var dataset = this.chart.data.datasets[point._datasetIndex];
						var index = point._index;
						var custom = point.custom || {};
						var model = point._model;

						model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
						model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
						model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
						model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
					},

					removeHoverStyle: function removeHoverStyle(point) {
						var me = this;
						var dataset = me.chart.data.datasets[point._datasetIndex];
						var index = point._index;
						var custom = point.custom || {};
						var model = point._model;

						// Compatibility: If the properties are defined with only the old name, use those values
						if (dataset.radius !== undefined && dataset.pointRadius === undefined) {
							dataset.pointRadius = dataset.radius;
						}

						model.radius = custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
						model.backgroundColor = me.getPointBackgroundColor(point, index);
						model.borderColor = me.getPointBorderColor(point, index);
						model.borderWidth = me.getPointBorderWidth(point, index);
					}
				});
			};
		}, { "25": 25, "40": 40, "45": 45 }], 19: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var elements = require(40);
			var helpers = require(45);

			defaults._set('polarArea', {
				scale: {
					type: 'radialLinear',
					angleLines: {
						display: false
					},
					gridLines: {
						circular: true
					},
					pointLabels: {
						display: false
					},
					ticks: {
						beginAtZero: true
					}
				},

				// Boolean - Whether to animate the rotation of the chart
				animation: {
					animateRotate: true,
					animateScale: true
				},

				startAngle: -0.5 * Math.PI,
				legendCallback: function legendCallback(chart) {
					var text = [];
					text.push('<ul class="' + chart.id + '-legend">');

					var data = chart.data;
					var datasets = data.datasets;
					var labels = data.labels;

					if (datasets.length) {
						for (var i = 0; i < datasets[0].data.length; ++i) {
							text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
							if (labels[i]) {
								text.push(labels[i]);
							}
							text.push('</li>');
						}
					}

					text.push('</ul>');
					return text.join('');
				},
				legend: {
					labels: {
						generateLabels: function generateLabels(chart) {
							var data = chart.data;
							if (data.labels.length && data.datasets.length) {
								return data.labels.map(function (label, i) {
									var meta = chart.getDatasetMeta(0);
									var ds = data.datasets[0];
									var arc = meta.data[i];
									var custom = arc.custom || {};
									var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
									var arcOpts = chart.options.elements.arc;
									var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
									var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
									var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

									return {
										text: label,
										fillStyle: fill,
										strokeStyle: stroke,
										lineWidth: bw,
										hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

										// Extra data used for toggling the correct item
										index: i
									};
								});
							}
							return [];
						}
					},

					onClick: function onClick(e, legendItem) {
						var index = legendItem.index;
						var chart = this.chart;
						var i, ilen, meta;

						for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
							meta = chart.getDatasetMeta(i);
							meta.data[index].hidden = !meta.data[index].hidden;
						}

						chart.update();
					}
				},

				// Need to override these to give a nice default
				tooltips: {
					callbacks: {
						title: function title() {
							return '';
						},
						label: function label(item, data) {
							return data.labels[item.index] + ': ' + item.yLabel;
						}
					}
				}
			});

			module.exports = function (Chart) {

				Chart.controllers.polarArea = Chart.DatasetController.extend({

					dataElementType: elements.Arc,

					linkScales: helpers.noop,

					update: function update(reset) {
						var me = this;
						var chart = me.chart;
						var chartArea = chart.chartArea;
						var meta = me.getMeta();
						var opts = chart.options;
						var arcOpts = opts.elements.arc;
						var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
						chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
						chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
						chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

						me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
						me.innerRadius = me.outerRadius - chart.radiusLength;

						meta.count = me.countVisibleElements();

						helpers.each(meta.data, function (arc, index) {
							me.updateElement(arc, index, reset);
						});
					},

					updateElement: function updateElement(arc, index, reset) {
						var me = this;
						var chart = me.chart;
						var dataset = me.getDataset();
						var opts = chart.options;
						var animationOpts = opts.animation;
						var scale = chart.scale;
						var labels = chart.data.labels;

						var circumference = me.calculateCircumference(dataset.data[index]);
						var centerX = scale.xCenter;
						var centerY = scale.yCenter;

						// If there is NaN data before us, we need to calculate the starting angle correctly.
						// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
						var visibleCount = 0;
						var meta = me.getMeta();
						for (var i = 0; i < index; ++i) {
							if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
								++visibleCount;
							}
						}

						// var negHalfPI = -0.5 * Math.PI;
						var datasetStartAngle = opts.startAngle;
						var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
						var startAngle = datasetStartAngle + circumference * visibleCount;
						var endAngle = startAngle + (arc.hidden ? 0 : circumference);

						var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);

						helpers.extend(arc, {
							// Utility
							_datasetIndex: me.index,
							_index: index,
							_scale: scale,

							// Desired view properties
							_model: {
								x: centerX,
								y: centerY,
								innerRadius: 0,
								outerRadius: reset ? resetRadius : distance,
								startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
								endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
								label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
							}
						});

						// Apply border and fill style
						me.removeHoverStyle(arc);

						arc.pivot();
					},

					removeHoverStyle: function removeHoverStyle(arc) {
						Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
					},

					countVisibleElements: function countVisibleElements() {
						var dataset = this.getDataset();
						var meta = this.getMeta();
						var count = 0;

						helpers.each(meta.data, function (element, index) {
							if (!isNaN(dataset.data[index]) && !element.hidden) {
								count++;
							}
						});

						return count;
					},

					calculateCircumference: function calculateCircumference(value) {
						var count = this.getMeta().count;
						if (count > 0 && !isNaN(value)) {
							return 2 * Math.PI / count;
						}
						return 0;
					}
				});
			};
		}, { "25": 25, "40": 40, "45": 45 }], 20: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var elements = require(40);
			var helpers = require(45);

			defaults._set('radar', {
				scale: {
					type: 'radialLinear'
				},
				elements: {
					line: {
						tension: 0 // no bezier in radar
					}
				}
			});

			module.exports = function (Chart) {

				Chart.controllers.radar = Chart.DatasetController.extend({

					datasetElementType: elements.Line,

					dataElementType: elements.Point,

					linkScales: helpers.noop,

					update: function update(reset) {
						var me = this;
						var meta = me.getMeta();
						var line = meta.dataset;
						var points = meta.data;
						var custom = line.custom || {};
						var dataset = me.getDataset();
						var lineElementOptions = me.chart.options.elements.line;
						var scale = me.chart.scale;

						// Compatibility: If the properties are defined with only the old name, use those values
						if (dataset.tension !== undefined && dataset.lineTension === undefined) {
							dataset.lineTension = dataset.tension;
						}

						helpers.extend(meta.dataset, {
							// Utility
							_datasetIndex: me.index,
							_scale: scale,
							// Data
							_children: points,
							_loop: true,
							// Model
							_model: {
								// Appearance
								tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
								backgroundColor: custom.backgroundColor ? custom.backgroundColor : dataset.backgroundColor || lineElementOptions.backgroundColor,
								borderWidth: custom.borderWidth ? custom.borderWidth : dataset.borderWidth || lineElementOptions.borderWidth,
								borderColor: custom.borderColor ? custom.borderColor : dataset.borderColor || lineElementOptions.borderColor,
								fill: custom.fill ? custom.fill : dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill,
								borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : dataset.borderCapStyle || lineElementOptions.borderCapStyle,
								borderDash: custom.borderDash ? custom.borderDash : dataset.borderDash || lineElementOptions.borderDash,
								borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : dataset.borderDashOffset || lineElementOptions.borderDashOffset,
								borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : dataset.borderJoinStyle || lineElementOptions.borderJoinStyle
							}
						});

						meta.dataset.pivot();

						// Update Points
						helpers.each(points, function (point, index) {
							me.updateElement(point, index, reset);
						}, me);

						// Update bezier control points
						me.updateBezierControlPoints();
					},
					updateElement: function updateElement(point, index, reset) {
						var me = this;
						var custom = point.custom || {};
						var dataset = me.getDataset();
						var scale = me.chart.scale;
						var pointElementOptions = me.chart.options.elements.point;
						var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);

						// Compatibility: If the properties are defined with only the old name, use those values
						if (dataset.radius !== undefined && dataset.pointRadius === undefined) {
							dataset.pointRadius = dataset.radius;
						}
						if (dataset.hitRadius !== undefined && dataset.pointHitRadius === undefined) {
							dataset.pointHitRadius = dataset.hitRadius;
						}

						helpers.extend(point, {
							// Utility
							_datasetIndex: me.index,
							_index: index,
							_scale: scale,

							// Desired view properties
							_model: {
								x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
								y: reset ? scale.yCenter : pointPosition.y,

								// Appearance
								tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
								radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
								backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
								borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
								borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
								pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),

								// Tooltip
								hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
							}
						});

						point._model.skip = custom.skip ? custom.skip : isNaN(point._model.x) || isNaN(point._model.y);
					},
					updateBezierControlPoints: function updateBezierControlPoints() {
						var chartArea = this.chart.chartArea;
						var meta = this.getMeta();

						helpers.each(meta.data, function (point, index) {
							var model = point._model;
							var controlPoints = helpers.splineCurve(helpers.previousItem(meta.data, index, true)._model, model, helpers.nextItem(meta.data, index, true)._model, model.tension);

							// Prevent the bezier going outside of the bounds of the graph
							model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
							model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);

							model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
							model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);

							// Now pivot the point for animation
							point.pivot();
						});
					},

					setHoverStyle: function setHoverStyle(point) {
						// Point
						var dataset = this.chart.data.datasets[point._datasetIndex];
						var custom = point.custom || {};
						var index = point._index;
						var model = point._model;

						model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
						model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
						model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
						model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
					},

					removeHoverStyle: function removeHoverStyle(point) {
						var dataset = this.chart.data.datasets[point._datasetIndex];
						var custom = point.custom || {};
						var index = point._index;
						var model = point._model;
						var pointElementOptions = this.chart.options.elements.point;

						model.radius = custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
						model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
						model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
						model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
					}
				});
			};
		}, { "25": 25, "40": 40, "45": 45 }], 21: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);

			defaults._set('scatter', {
				hover: {
					mode: 'single'
				},

				scales: {
					xAxes: [{
						id: 'x-axis-1', // need an ID so datasets can reference the scale
						type: 'linear', // scatter should not use a category axis
						position: 'bottom'
					}],
					yAxes: [{
						id: 'y-axis-1',
						type: 'linear',
						position: 'left'
					}]
				},

				showLines: false,

				tooltips: {
					callbacks: {
						title: function title() {
							return ''; // doesn't make sense for scatter since data are formatted as a point
						},
						label: function label(item) {
							return '(' + item.xLabel + ', ' + item.yLabel + ')';
						}
					}
				}
			});

			module.exports = function (Chart) {

				// Scatter charts use line controllers
				Chart.controllers.scatter = Chart.controllers.line;
			};
		}, { "25": 25 }], 22: [function (require, module, exports) {
			/* global window: false */
			'use strict';

			var defaults = require(25);
			var Element = require(26);
			var helpers = require(45);

			defaults._set('global', {
				animation: {
					duration: 1000,
					easing: 'easeOutQuart',
					onProgress: helpers.noop,
					onComplete: helpers.noop
				}
			});

			module.exports = function (Chart) {

				Chart.Animation = Element.extend({
					chart: null, // the animation associated chart instance
					currentStep: 0, // the current animation step
					numSteps: 60, // default number of steps
					easing: '', // the easing to use for this animation
					render: null, // render function used by the animation service

					onAnimationProgress: null, // user specified callback to fire on each step of the animation
					onAnimationComplete: null // user specified callback to fire when the animation finishes
				});

				Chart.animationService = {
					frameDuration: 17,
					animations: [],
					dropFrames: 0,
					request: null,

					/**
      * @param {Chart} chart - The chart to animate.
      * @param {Chart.Animation} animation - The animation that we will animate.
      * @param {Number} duration - The animation duration in ms.
      * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
      */
					addAnimation: function addAnimation(chart, animation, duration, lazy) {
						var animations = this.animations;
						var i, ilen;

						animation.chart = chart;

						if (!lazy) {
							chart.animating = true;
						}

						for (i = 0, ilen = animations.length; i < ilen; ++i) {
							if (animations[i].chart === chart) {
								animations[i] = animation;
								return;
							}
						}

						animations.push(animation);

						// If there are no animations queued, manually kickstart a digest, for lack of a better word
						if (animations.length === 1) {
							this.requestAnimationFrame();
						}
					},

					cancelAnimation: function cancelAnimation(chart) {
						var index = helpers.findIndex(this.animations, function (animation) {
							return animation.chart === chart;
						});

						if (index !== -1) {
							this.animations.splice(index, 1);
							chart.animating = false;
						}
					},

					requestAnimationFrame: function requestAnimationFrame() {
						var me = this;
						if (me.request === null) {
							// Skip animation frame requests until the active one is executed.
							// This can happen when processing mouse events, e.g. 'mousemove'
							// and 'mouseout' events will trigger multiple renders.
							me.request = helpers.requestAnimFrame.call(window, function () {
								me.request = null;
								me.startDigest();
							});
						}
					},

					/**
      * @private
      */
					startDigest: function startDigest() {
						var me = this;
						var startTime = Date.now();
						var framesToDrop = 0;

						if (me.dropFrames > 1) {
							framesToDrop = Math.floor(me.dropFrames);
							me.dropFrames = me.dropFrames % 1;
						}

						me.advance(1 + framesToDrop);

						var endTime = Date.now();

						me.dropFrames += (endTime - startTime) / me.frameDuration;

						// Do we have more stuff to animate?
						if (me.animations.length > 0) {
							me.requestAnimationFrame();
						}
					},

					/**
      * @private
      */
					advance: function advance(count) {
						var animations = this.animations;
						var animation, chart;
						var i = 0;

						while (i < animations.length) {
							animation = animations[i];
							chart = animation.chart;

							animation.currentStep = (animation.currentStep || 0) + count;
							animation.currentStep = Math.min(animation.currentStep, animation.numSteps);

							helpers.callback(animation.render, [chart, animation], chart);
							helpers.callback(animation.onAnimationProgress, [animation], chart);

							if (animation.currentStep >= animation.numSteps) {
								helpers.callback(animation.onAnimationComplete, [animation], chart);
								chart.animating = false;
								animations.splice(i, 1);
							} else {
								++i;
							}
						}
					}
				};

				/**
     * Provided for backward compatibility, use Chart.Animation instead
     * @prop Chart.Animation#animationObject
     * @deprecated since version 2.6.0
     * @todo remove at version 3
     */
				Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
					get: function get() {
						return this;
					}
				});

				/**
     * Provided for backward compatibility, use Chart.Animation#chart instead
     * @prop Chart.Animation#chartInstance
     * @deprecated since version 2.6.0
     * @todo remove at version 3
     */
				Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
					get: function get() {
						return this.chart;
					},
					set: function set(value) {
						this.chart = value;
					}
				});
			};
		}, { "25": 25, "26": 26, "45": 45 }], 23: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var helpers = require(45);
			var Interaction = require(28);
			var layouts = require(30);
			var platform = require(48);
			var plugins = require(31);

			module.exports = function (Chart) {

				// Create a dictionary of chart types, to allow for extension of existing types
				Chart.types = {};

				// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
				// Destroy method on the chart will remove the instance of the chart from this reference.
				Chart.instances = {};

				// Controllers available for dataset visualization eg. bar, line, slice, etc.
				Chart.controllers = {};

				/**
     * Initializes the given config with global and chart default values.
     */
				function initConfig(config) {
					config = config || {};

					// Do NOT use configMerge() for the data object because this method merges arrays
					// and so would change references to labels and datasets, preventing data updates.
					var data = config.data = config.data || {};
					data.datasets = data.datasets || [];
					data.labels = data.labels || [];

					config.options = helpers.configMerge(defaults.global, defaults[config.type], config.options || {});

					return config;
				}

				/**
     * Updates the config of the chart
     * @param chart {Chart} chart to update the options for
     */
				function updateConfig(chart) {
					var newOptions = chart.options;

					helpers.each(chart.scales, function (scale) {
						layouts.removeBox(chart, scale);
					});

					newOptions = helpers.configMerge(Chart.defaults.global, Chart.defaults[chart.config.type], newOptions);

					chart.options = chart.config.options = newOptions;
					chart.ensureScalesHaveIDs();
					chart.buildOrUpdateScales();
					// Tooltip
					chart.tooltip._options = newOptions.tooltips;
					chart.tooltip.initialize();
				}

				function positionIsHorizontal(position) {
					return position === 'top' || position === 'bottom';
				}

				helpers.extend(Chart.prototype, /** @lends Chart */{
					/**
      * @private
      */
					construct: function construct(item, config) {
						var me = this;

						config = initConfig(config);

						var context = platform.acquireContext(item, config);
						var canvas = context && context.canvas;
						var height = canvas && canvas.height;
						var width = canvas && canvas.width;

						me.id = helpers.uid();
						me.ctx = context;
						me.canvas = canvas;
						me.config = config;
						me.width = width;
						me.height = height;
						me.aspectRatio = height ? width / height : null;
						me.options = config.options;
						me._bufferedRender = false;

						/**
       * Provided for backward compatibility, Chart and Chart.Controller have been merged,
       * the "instance" still need to be defined since it might be called from plugins.
       * @prop Chart#chart
       * @deprecated since version 2.6.0
       * @todo remove at version 3
       * @private
       */
						me.chart = me;
						me.controller = me; // chart.chart.controller #inception

						// Add the chart instance to the global namespace
						Chart.instances[me.id] = me;

						// Define alias to the config data: `chart.data === chart.config.data`
						Object.defineProperty(me, 'data', {
							get: function get() {
								return me.config.data;
							},
							set: function set(value) {
								me.config.data = value;
							}
						});

						if (!context || !canvas) {
							// The given item is not a compatible context2d element, let's return before finalizing
							// the chart initialization but after setting basic chart / controller properties that
							// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
							// https://github.com/chartjs/Chart.js/issues/2807
							console.error("Failed to create chart: can't acquire context from the given item");
							return;
						}

						me.initialize();
						me.update();
					},

					/**
      * @private
      */
					initialize: function initialize() {
						var me = this;

						// Before init plugin notification
						plugins.notify(me, 'beforeInit');

						helpers.retinaScale(me, me.options.devicePixelRatio);

						me.bindEvents();

						if (me.options.responsive) {
							// Initial resize before chart draws (must be silent to preserve initial animations).
							me.resize(true);
						}

						// Make sure scales have IDs and are built before we build any controllers.
						me.ensureScalesHaveIDs();
						me.buildOrUpdateScales();
						me.initToolTip();

						// After init plugin notification
						plugins.notify(me, 'afterInit');

						return me;
					},

					clear: function clear() {
						helpers.canvas.clear(this);
						return this;
					},

					stop: function stop() {
						// Stops any current animation loop occurring
						Chart.animationService.cancelAnimation(this);
						return this;
					},

					resize: function resize(silent) {
						var me = this;
						var options = me.options;
						var canvas = me.canvas;
						var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;

						// the canvas render width and height will be casted to integers so make sure that
						// the canvas display style uses the same integer values to avoid blurring effect.

						// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collased
						var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
						var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));

						if (me.width === newWidth && me.height === newHeight) {
							return;
						}

						canvas.width = me.width = newWidth;
						canvas.height = me.height = newHeight;
						canvas.style.width = newWidth + 'px';
						canvas.style.height = newHeight + 'px';

						helpers.retinaScale(me, options.devicePixelRatio);

						if (!silent) {
							// Notify any plugins about the resize
							var newSize = { width: newWidth, height: newHeight };
							plugins.notify(me, 'resize', [newSize]);

							// Notify of resize
							if (me.options.onResize) {
								me.options.onResize(me, newSize);
							}

							me.stop();
							me.update(me.options.responsiveAnimationDuration);
						}
					},

					ensureScalesHaveIDs: function ensureScalesHaveIDs() {
						var options = this.options;
						var scalesOptions = options.scales || {};
						var scaleOptions = options.scale;

						helpers.each(scalesOptions.xAxes, function (xAxisOptions, index) {
							xAxisOptions.id = xAxisOptions.id || 'x-axis-' + index;
						});

						helpers.each(scalesOptions.yAxes, function (yAxisOptions, index) {
							yAxisOptions.id = yAxisOptions.id || 'y-axis-' + index;
						});

						if (scaleOptions) {
							scaleOptions.id = scaleOptions.id || 'scale';
						}
					},

					/**
      * Builds a map of scale ID to scale object for future lookup.
      */
					buildOrUpdateScales: function buildOrUpdateScales() {
						var me = this;
						var options = me.options;
						var scales = me.scales || {};
						var items = [];
						var updated = Object.keys(scales).reduce(function (obj, id) {
							obj[id] = false;
							return obj;
						}, {});

						if (options.scales) {
							items = items.concat((options.scales.xAxes || []).map(function (xAxisOptions) {
								return { options: xAxisOptions, dtype: 'category', dposition: 'bottom' };
							}), (options.scales.yAxes || []).map(function (yAxisOptions) {
								return { options: yAxisOptions, dtype: 'linear', dposition: 'left' };
							}));
						}

						if (options.scale) {
							items.push({
								options: options.scale,
								dtype: 'radialLinear',
								isDefault: true,
								dposition: 'chartArea'
							});
						}

						helpers.each(items, function (item) {
							var scaleOptions = item.options;
							var id = scaleOptions.id;
							var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);

							if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
								scaleOptions.position = item.dposition;
							}

							updated[id] = true;
							var scale = null;
							if (id in scales && scales[id].type === scaleType) {
								scale = scales[id];
								scale.options = scaleOptions;
								scale.ctx = me.ctx;
								scale.chart = me;
							} else {
								var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
								if (!scaleClass) {
									return;
								}
								scale = new scaleClass({
									id: id,
									type: scaleType,
									options: scaleOptions,
									ctx: me.ctx,
									chart: me
								});
								scales[scale.id] = scale;
							}

							scale.mergeTicksOptions();

							// TODO(SB): I think we should be able to remove this custom case (options.scale)
							// and consider it as a regular scale part of the "scales"" map only! This would
							// make the logic easier and remove some useless? custom code.
							if (item.isDefault) {
								me.scale = scale;
							}
						});
						// clear up discarded scales
						helpers.each(updated, function (hasUpdated, id) {
							if (!hasUpdated) {
								delete scales[id];
							}
						});

						me.scales = scales;

						Chart.scaleService.addScalesToLayout(this);
					},

					buildOrUpdateControllers: function buildOrUpdateControllers() {
						var me = this;
						var types = [];
						var newControllers = [];

						helpers.each(me.data.datasets, function (dataset, datasetIndex) {
							var meta = me.getDatasetMeta(datasetIndex);
							var type = dataset.type || me.config.type;

							if (meta.type && meta.type !== type) {
								me.destroyDatasetMeta(datasetIndex);
								meta = me.getDatasetMeta(datasetIndex);
							}
							meta.type = type;

							types.push(meta.type);

							if (meta.controller) {
								meta.controller.updateIndex(datasetIndex);
								meta.controller.linkScales();
							} else {
								var ControllerClass = Chart.controllers[meta.type];
								if (ControllerClass === undefined) {
									throw new Error('"' + meta.type + '" is not a chart type.');
								}

								meta.controller = new ControllerClass(me, datasetIndex);
								newControllers.push(meta.controller);
							}
						}, me);

						return newControllers;
					},

					/**
      * Reset the elements of all datasets
      * @private
      */
					resetElements: function resetElements() {
						var me = this;
						helpers.each(me.data.datasets, function (dataset, datasetIndex) {
							me.getDatasetMeta(datasetIndex).controller.reset();
						}, me);
					},

					/**
     * Resets the chart back to it's state before the initial animation
     */
					reset: function reset() {
						this.resetElements();
						this.tooltip.initialize();
					},

					update: function update(config) {
						var me = this;

						if (!config || (typeof config === "undefined" ? "undefined" : _typeof(config)) !== 'object') {
							// backwards compatibility
							config = {
								duration: config,
								lazy: arguments[1]
							};
						}

						updateConfig(me);

						// plugins options references might have change, let's invalidate the cache
						// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
						plugins._invalidate(me);

						if (plugins.notify(me, 'beforeUpdate') === false) {
							return;
						}

						// In case the entire data object changed
						me.tooltip._data = me.data;

						// Make sure dataset controllers are updated and new controllers are reset
						var newControllers = me.buildOrUpdateControllers();

						// Make sure all dataset controllers have correct meta data counts
						helpers.each(me.data.datasets, function (dataset, datasetIndex) {
							me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
						}, me);

						me.updateLayout();

						// Can only reset the new controllers after the scales have been updated
						if (me.options.animation && me.options.animation.duration) {
							helpers.each(newControllers, function (controller) {
								controller.reset();
							});
						}

						me.updateDatasets();

						// Need to reset tooltip in case it is displayed with elements that are removed
						// after update.
						me.tooltip.initialize();

						// Last active contains items that were previously in the tooltip.
						// When we reset the tooltip, we need to clear it
						me.lastActive = [];

						// Do this before render so that any plugins that need final scale updates can use it
						plugins.notify(me, 'afterUpdate');

						if (me._bufferedRender) {
							me._bufferedRequest = {
								duration: config.duration,
								easing: config.easing,
								lazy: config.lazy
							};
						} else {
							me.render(config);
						}
					},

					/**
      * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
      * hook, in which case, plugins will not be called on `afterLayout`.
      * @private
      */
					updateLayout: function updateLayout() {
						var me = this;

						if (plugins.notify(me, 'beforeLayout') === false) {
							return;
						}

						layouts.update(this, this.width, this.height);

						/**
       * Provided for backward compatibility, use `afterLayout` instead.
       * @method IPlugin#afterScaleUpdate
       * @deprecated since version 2.5.0
       * @todo remove at version 3
       * @private
       */
						plugins.notify(me, 'afterScaleUpdate');
						plugins.notify(me, 'afterLayout');
					},

					/**
      * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
      * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
      * @private
      */
					updateDatasets: function updateDatasets() {
						var me = this;

						if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
							return;
						}

						for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
							me.updateDataset(i);
						}

						plugins.notify(me, 'afterDatasetsUpdate');
					},

					/**
      * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
      * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
      * @private
      */
					updateDataset: function updateDataset(index) {
						var me = this;
						var meta = me.getDatasetMeta(index);
						var args = {
							meta: meta,
							index: index
						};

						if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
							return;
						}

						meta.controller.update();

						plugins.notify(me, 'afterDatasetUpdate', [args]);
					},

					render: function render(config) {
						var me = this;

						if (!config || (typeof config === "undefined" ? "undefined" : _typeof(config)) !== 'object') {
							// backwards compatibility
							config = {
								duration: config,
								lazy: arguments[1]
							};
						}

						var duration = config.duration;
						var lazy = config.lazy;

						if (plugins.notify(me, 'beforeRender') === false) {
							return;
						}

						var animationOptions = me.options.animation;
						var onComplete = function onComplete(animation) {
							plugins.notify(me, 'afterRender');
							helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
						};

						if (animationOptions && (typeof duration !== 'undefined' && duration !== 0 || typeof duration === 'undefined' && animationOptions.duration !== 0)) {
							var animation = new Chart.Animation({
								numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
								easing: config.easing || animationOptions.easing,

								render: function render(chart, animationObject) {
									var easingFunction = helpers.easing.effects[animationObject.easing];
									var currentStep = animationObject.currentStep;
									var stepDecimal = currentStep / animationObject.numSteps;

									chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
								},

								onAnimationProgress: animationOptions.onProgress,
								onAnimationComplete: onComplete
							});

							Chart.animationService.addAnimation(me, animation, duration, lazy);
						} else {
							me.draw();

							// See https://github.com/chartjs/Chart.js/issues/3781
							onComplete(new Chart.Animation({ numSteps: 0, chart: me }));
						}

						return me;
					},

					draw: function draw(easingValue) {
						var me = this;

						me.clear();

						if (helpers.isNullOrUndef(easingValue)) {
							easingValue = 1;
						}

						me.transition(easingValue);

						if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
							return;
						}

						// Draw all the scales
						helpers.each(me.boxes, function (box) {
							box.draw(me.chartArea);
						}, me);

						if (me.scale) {
							me.scale.draw();
						}

						me.drawDatasets(easingValue);
						me._drawTooltip(easingValue);

						plugins.notify(me, 'afterDraw', [easingValue]);
					},

					/**
      * @private
      */
					transition: function transition(easingValue) {
						var me = this;

						for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
							if (me.isDatasetVisible(i)) {
								me.getDatasetMeta(i).controller.transition(easingValue);
							}
						}

						me.tooltip.transition(easingValue);
					},

					/**
      * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
      * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
      * @private
      */
					drawDatasets: function drawDatasets(easingValue) {
						var me = this;

						if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
							return;
						}

						// Draw datasets reversed to support proper line stacking
						for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
							if (me.isDatasetVisible(i)) {
								me.drawDataset(i, easingValue);
							}
						}

						plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
					},

					/**
      * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
      * hook, in which case, plugins will not be called on `afterDatasetDraw`.
      * @private
      */
					drawDataset: function drawDataset(index, easingValue) {
						var me = this;
						var meta = me.getDatasetMeta(index);
						var args = {
							meta: meta,
							index: index,
							easingValue: easingValue
						};

						if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
							return;
						}

						meta.controller.draw(easingValue);

						plugins.notify(me, 'afterDatasetDraw', [args]);
					},

					/**
      * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
      * hook, in which case, plugins will not be called on `afterTooltipDraw`.
      * @private
      */
					_drawTooltip: function _drawTooltip(easingValue) {
						var me = this;
						var tooltip = me.tooltip;
						var args = {
							tooltip: tooltip,
							easingValue: easingValue
						};

						if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
							return;
						}

						tooltip.draw();

						plugins.notify(me, 'afterTooltipDraw', [args]);
					},

					// Get the single element that was clicked on
					// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
					getElementAtEvent: function getElementAtEvent(e) {
						return Interaction.modes.single(this, e);
					},

					getElementsAtEvent: function getElementsAtEvent(e) {
						return Interaction.modes.label(this, e, { intersect: true });
					},

					getElementsAtXAxis: function getElementsAtXAxis(e) {
						return Interaction.modes['x-axis'](this, e, { intersect: true });
					},

					getElementsAtEventForMode: function getElementsAtEventForMode(e, mode, options) {
						var method = Interaction.modes[mode];
						if (typeof method === 'function') {
							return method(this, e, options);
						}

						return [];
					},

					getDatasetAtEvent: function getDatasetAtEvent(e) {
						return Interaction.modes.dataset(this, e, { intersect: true });
					},

					getDatasetMeta: function getDatasetMeta(datasetIndex) {
						var me = this;
						var dataset = me.data.datasets[datasetIndex];
						if (!dataset._meta) {
							dataset._meta = {};
						}

						var meta = dataset._meta[me.id];
						if (!meta) {
							meta = dataset._meta[me.id] = {
								type: null,
								data: [],
								dataset: null,
								controller: null,
								hidden: null, // See isDatasetVisible() comment
								xAxisID: null,
								yAxisID: null
							};
						}

						return meta;
					},

					getVisibleDatasetCount: function getVisibleDatasetCount() {
						var count = 0;
						for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
							if (this.isDatasetVisible(i)) {
								count++;
							}
						}
						return count;
					},

					isDatasetVisible: function isDatasetVisible(datasetIndex) {
						var meta = this.getDatasetMeta(datasetIndex);

						// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
						// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
						return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
					},

					generateLegend: function generateLegend() {
						return this.options.legendCallback(this);
					},

					/**
      * @private
      */
					destroyDatasetMeta: function destroyDatasetMeta(datasetIndex) {
						var id = this.id;
						var dataset = this.data.datasets[datasetIndex];
						var meta = dataset._meta && dataset._meta[id];

						if (meta) {
							meta.controller.destroy();
							delete dataset._meta[id];
						}
					},

					destroy: function destroy() {
						var me = this;
						var canvas = me.canvas;
						var i, ilen;

						me.stop();

						// dataset controllers need to cleanup associated data
						for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
							me.destroyDatasetMeta(i);
						}

						if (canvas) {
							me.unbindEvents();
							helpers.canvas.clear(me);
							platform.releaseContext(me.ctx);
							me.canvas = null;
							me.ctx = null;
						}

						plugins.notify(me, 'destroy');

						delete Chart.instances[me.id];
					},

					toBase64Image: function toBase64Image() {
						return this.canvas.toDataURL.apply(this.canvas, arguments);
					},

					initToolTip: function initToolTip() {
						var me = this;
						me.tooltip = new Chart.Tooltip({
							_chart: me,
							_chartInstance: me, // deprecated, backward compatibility
							_data: me.data,
							_options: me.options.tooltips
						}, me);
					},

					/**
      * @private
      */
					bindEvents: function bindEvents() {
						var me = this;
						var listeners = me._listeners = {};
						var listener = function listener() {
							me.eventHandler.apply(me, arguments);
						};

						helpers.each(me.options.events, function (type) {
							platform.addEventListener(me, type, listener);
							listeners[type] = listener;
						});

						// Elements used to detect size change should not be injected for non responsive charts.
						// See https://github.com/chartjs/Chart.js/issues/2210
						if (me.options.responsive) {
							listener = function listener() {
								me.resize();
							};

							platform.addEventListener(me, 'resize', listener);
							listeners.resize = listener;
						}
					},

					/**
      * @private
      */
					unbindEvents: function unbindEvents() {
						var me = this;
						var listeners = me._listeners;
						if (!listeners) {
							return;
						}

						delete me._listeners;
						helpers.each(listeners, function (listener, type) {
							platform.removeEventListener(me, type, listener);
						});
					},

					updateHoverStyle: function updateHoverStyle(elements, mode, enabled) {
						var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
						var element, i, ilen;

						for (i = 0, ilen = elements.length; i < ilen; ++i) {
							element = elements[i];
							if (element) {
								this.getDatasetMeta(element._datasetIndex).controller[method](element);
							}
						}
					},

					/**
      * @private
      */
					eventHandler: function eventHandler(e) {
						var me = this;
						var tooltip = me.tooltip;

						if (plugins.notify(me, 'beforeEvent', [e]) === false) {
							return;
						}

						// Buffer any update calls so that renders do not occur
						me._bufferedRender = true;
						me._bufferedRequest = null;

						var changed = me.handleEvent(e);
						// for smooth tooltip animations issue #4989
						// the tooltip should be the source of change
						// Animation check workaround:
						// tooltip._start will be null when tooltip isn't animating
						if (tooltip) {
							changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
						}

						plugins.notify(me, 'afterEvent', [e]);

						var bufferedRequest = me._bufferedRequest;
						if (bufferedRequest) {
							// If we have an update that was triggered, we need to do a normal render
							me.render(bufferedRequest);
						} else if (changed && !me.animating) {
							// If entering, leaving, or changing elements, animate the change via pivot
							me.stop();

							// We only need to render at this point. Updating will cause scales to be
							// recomputed generating flicker & using more memory than necessary.
							me.render(me.options.hover.animationDuration, true);
						}

						me._bufferedRender = false;
						me._bufferedRequest = null;

						return me;
					},

					/**
      * Handle an event
      * @private
      * @param {IEvent} event the event to handle
      * @return {Boolean} true if the chart needs to re-render
      */
					handleEvent: function handleEvent(e) {
						var me = this;
						var options = me.options || {};
						var hoverOptions = options.hover;
						var changed = false;

						me.lastActive = me.lastActive || [];

						// Find Active Elements for hover and tooltips
						if (e.type === 'mouseout') {
							me.active = [];
						} else {
							me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
						}

						// Invoke onHover hook
						// Need to call with native event here to not break backwards compatibility
						helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

						if (e.type === 'mouseup' || e.type === 'click') {
							if (options.onClick) {
								// Use e.native here for backwards compatibility
								options.onClick.call(me, e.native, me.active);
							}
						}

						// Remove styling for last active (even if it may still be active)
						if (me.lastActive.length) {
							me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
						}

						// Built in hover styling
						if (me.active.length && hoverOptions.mode) {
							me.updateHoverStyle(me.active, hoverOptions.mode, true);
						}

						changed = !helpers.arrayEquals(me.active, me.lastActive);

						// Remember Last Actives
						me.lastActive = me.active;

						return changed;
					}
				});

				/**
     * Provided for backward compatibility, use Chart instead.
     * @class Chart.Controller
     * @deprecated since version 2.6.0
     * @todo remove at version 3
     * @private
     */
				Chart.Controller = Chart;
			};
		}, { "25": 25, "28": 28, "30": 30, "31": 31, "45": 45, "48": 48 }], 24: [function (require, module, exports) {
			'use strict';

			var helpers = require(45);

			module.exports = function (Chart) {

				var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

				/**
     * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
     * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
     * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
     */
				function listenArrayEvents(array, listener) {
					if (array._chartjs) {
						array._chartjs.listeners.push(listener);
						return;
					}

					Object.defineProperty(array, '_chartjs', {
						configurable: true,
						enumerable: false,
						value: {
							listeners: [listener]
						}
					});

					arrayEvents.forEach(function (key) {
						var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
						var base = array[key];

						Object.defineProperty(array, key, {
							configurable: true,
							enumerable: false,
							value: function value() {
								var args = Array.prototype.slice.call(arguments);
								var res = base.apply(this, args);

								helpers.each(array._chartjs.listeners, function (object) {
									if (typeof object[method] === 'function') {
										object[method].apply(object, args);
									}
								});

								return res;
							}
						});
					});
				}

				/**
     * Removes the given array event listener and cleanup extra attached properties (such as
     * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
     */
				function unlistenArrayEvents(array, listener) {
					var stub = array._chartjs;
					if (!stub) {
						return;
					}

					var listeners = stub.listeners;
					var index = listeners.indexOf(listener);
					if (index !== -1) {
						listeners.splice(index, 1);
					}

					if (listeners.length > 0) {
						return;
					}

					arrayEvents.forEach(function (key) {
						delete array[key];
					});

					delete array._chartjs;
				}

				// Base class for all dataset controllers (line, bar, etc)
				Chart.DatasetController = function (chart, datasetIndex) {
					this.initialize(chart, datasetIndex);
				};

				helpers.extend(Chart.DatasetController.prototype, {

					/**
      * Element type used to generate a meta dataset (e.g. Chart.element.Line).
      * @type {Chart.core.element}
      */
					datasetElementType: null,

					/**
      * Element type used to generate a meta data (e.g. Chart.element.Point).
      * @type {Chart.core.element}
      */
					dataElementType: null,

					initialize: function initialize(chart, datasetIndex) {
						var me = this;
						me.chart = chart;
						me.index = datasetIndex;
						me.linkScales();
						me.addElements();
					},

					updateIndex: function updateIndex(datasetIndex) {
						this.index = datasetIndex;
					},

					linkScales: function linkScales() {
						var me = this;
						var meta = me.getMeta();
						var dataset = me.getDataset();

						if (meta.xAxisID === null || !(meta.xAxisID in me.chart.scales)) {
							meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
						}
						if (meta.yAxisID === null || !(meta.yAxisID in me.chart.scales)) {
							meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
						}
					},

					getDataset: function getDataset() {
						return this.chart.data.datasets[this.index];
					},

					getMeta: function getMeta() {
						return this.chart.getDatasetMeta(this.index);
					},

					getScaleForId: function getScaleForId(scaleID) {
						return this.chart.scales[scaleID];
					},

					reset: function reset() {
						this.update(true);
					},

					/**
      * @private
      */
					destroy: function destroy() {
						if (this._data) {
							unlistenArrayEvents(this._data, this);
						}
					},

					createMetaDataset: function createMetaDataset() {
						var me = this;
						var type = me.datasetElementType;
						return type && new type({
							_chart: me.chart,
							_datasetIndex: me.index
						});
					},

					createMetaData: function createMetaData(index) {
						var me = this;
						var type = me.dataElementType;
						return type && new type({
							_chart: me.chart,
							_datasetIndex: me.index,
							_index: index
						});
					},

					addElements: function addElements() {
						var me = this;
						var meta = me.getMeta();
						var data = me.getDataset().data || [];
						var metaData = meta.data;
						var i, ilen;

						for (i = 0, ilen = data.length; i < ilen; ++i) {
							metaData[i] = metaData[i] || me.createMetaData(i);
						}

						meta.dataset = meta.dataset || me.createMetaDataset();
					},

					addElementAndReset: function addElementAndReset(index) {
						var element = this.createMetaData(index);
						this.getMeta().data.splice(index, 0, element);
						this.updateElement(element, index, true);
					},

					buildOrUpdateElements: function buildOrUpdateElements() {
						var me = this;
						var dataset = me.getDataset();
						var data = dataset.data || (dataset.data = []);

						// In order to correctly handle data addition/deletion animation (an thus simulate
						// real-time charts), we need to monitor these data modifications and synchronize
						// the internal meta data accordingly.
						if (me._data !== data) {
							if (me._data) {
								// This case happens when the user replaced the data array instance.
								unlistenArrayEvents(me._data, me);
							}

							listenArrayEvents(data, me);
							me._data = data;
						}

						// Re-sync meta data in case the user replaced the data array or if we missed
						// any updates and so make sure that we handle number of datapoints changing.
						me.resyncElements();
					},

					update: helpers.noop,

					transition: function transition(easingValue) {
						var meta = this.getMeta();
						var elements = meta.data || [];
						var ilen = elements.length;
						var i = 0;

						for (; i < ilen; ++i) {
							elements[i].transition(easingValue);
						}

						if (meta.dataset) {
							meta.dataset.transition(easingValue);
						}
					},

					draw: function draw() {
						var meta = this.getMeta();
						var elements = meta.data || [];
						var ilen = elements.length;
						var i = 0;

						if (meta.dataset) {
							meta.dataset.draw();
						}

						for (; i < ilen; ++i) {
							elements[i].draw();
						}
					},

					removeHoverStyle: function removeHoverStyle(element, elementOpts) {
						var dataset = this.chart.data.datasets[element._datasetIndex];
						var index = element._index;
						var custom = element.custom || {};
						var valueOrDefault = helpers.valueAtIndexOrDefault;
						var model = element._model;

						model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
						model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
						model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
					},

					setHoverStyle: function setHoverStyle(element) {
						var dataset = this.chart.data.datasets[element._datasetIndex];
						var index = element._index;
						var custom = element.custom || {};
						var valueOrDefault = helpers.valueAtIndexOrDefault;
						var getHoverColor = helpers.getHoverColor;
						var model = element._model;

						model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
						model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
						model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
					},

					/**
      * @private
      */
					resyncElements: function resyncElements() {
						var me = this;
						var meta = me.getMeta();
						var data = me.getDataset().data;
						var numMeta = meta.data.length;
						var numData = data.length;

						if (numData < numMeta) {
							meta.data.splice(numData, numMeta - numData);
						} else if (numData > numMeta) {
							me.insertElements(numMeta, numData - numMeta);
						}
					},

					/**
      * @private
      */
					insertElements: function insertElements(start, count) {
						for (var i = 0; i < count; ++i) {
							this.addElementAndReset(start + i);
						}
					},

					/**
      * @private
      */
					onDataPush: function onDataPush() {
						this.insertElements(this.getDataset().data.length - 1, arguments.length);
					},

					/**
      * @private
      */
					onDataPop: function onDataPop() {
						this.getMeta().data.pop();
					},

					/**
      * @private
      */
					onDataShift: function onDataShift() {
						this.getMeta().data.shift();
					},

					/**
      * @private
      */
					onDataSplice: function onDataSplice(start, count) {
						this.getMeta().data.splice(start, count);
						this.insertElements(start, arguments.length - 2);
					},

					/**
      * @private
      */
					onDataUnshift: function onDataUnshift() {
						this.insertElements(0, arguments.length);
					}
				});

				Chart.DatasetController.extend = helpers.inherits;
			};
		}, { "45": 45 }], 25: [function (require, module, exports) {
			'use strict';

			var helpers = require(45);

			module.exports = {
				/**
     * @private
     */
				_set: function _set(scope, values) {
					return helpers.merge(this[scope] || (this[scope] = {}), values);
				}
			};
		}, { "45": 45 }], 26: [function (require, module, exports) {
			'use strict';

			var color = require(3);
			var helpers = require(45);

			function interpolate(start, view, model, ease) {
				var keys = Object.keys(model);
				var i, ilen, key, actual, origin, target, type, c0, c1;

				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];

					target = model[key];

					// if a value is added to the model after pivot() has been called, the view
					// doesn't contain it, so let's initialize the view to the target value.
					if (!view.hasOwnProperty(key)) {
						view[key] = target;
					}

					actual = view[key];

					if (actual === target || key[0] === '_') {
						continue;
					}

					if (!start.hasOwnProperty(key)) {
						start[key] = actual;
					}

					origin = start[key];

					type = typeof target === "undefined" ? "undefined" : _typeof(target);

					if (type === (typeof origin === "undefined" ? "undefined" : _typeof(origin))) {
						if (type === 'string') {
							c0 = color(origin);
							if (c0.valid) {
								c1 = color(target);
								if (c1.valid) {
									view[key] = c1.mix(c0, ease).rgbString();
									continue;
								}
							}
						} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
							view[key] = origin + (target - origin) * ease;
							continue;
						}
					}

					view[key] = target;
				}
			}

			var Element = function Element(configuration) {
				helpers.extend(this, configuration);
				this.initialize.apply(this, arguments);
			};

			helpers.extend(Element.prototype, {

				initialize: function initialize() {
					this.hidden = false;
				},

				pivot: function pivot() {
					var me = this;
					if (!me._view) {
						me._view = helpers.clone(me._model);
					}
					me._start = {};
					return me;
				},

				transition: function transition(ease) {
					var me = this;
					var model = me._model;
					var start = me._start;
					var view = me._view;

					// No animation -> No Transition
					if (!model || ease === 1) {
						me._view = model;
						me._start = null;
						return me;
					}

					if (!view) {
						view = me._view = {};
					}

					if (!start) {
						start = me._start = {};
					}

					interpolate(start, view, model, ease);

					return me;
				},

				tooltipPosition: function tooltipPosition() {
					return {
						x: this._model.x,
						y: this._model.y
					};
				},

				hasValue: function hasValue() {
					return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
				}
			});

			Element.extend = helpers.inherits;

			module.exports = Element;
		}, { "3": 3, "45": 45 }], 27: [function (require, module, exports) {
			/* global window: false */
			/* global document: false */
			'use strict';

			var color = require(3);
			var defaults = require(25);
			var helpers = require(45);

			module.exports = function (Chart) {

				// -- Basic js utility methods

				helpers.configMerge = function () /* objects ... */{
					return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
						merger: function merger(key, target, source, options) {
							var tval = target[key] || {};
							var sval = source[key];

							if (key === 'scales') {
								// scale config merging is complex. Add our own function here for that
								target[key] = helpers.scaleMerge(tval, sval);
							} else if (key === 'scale') {
								// used in polar area & radar charts since there is only one scale
								target[key] = helpers.merge(tval, [Chart.scaleService.getScaleDefaults(sval.type), sval]);
							} else {
								helpers._merger(key, target, source, options);
							}
						}
					});
				};

				helpers.scaleMerge = function () /* objects ... */{
					return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
						merger: function merger(key, target, source, options) {
							if (key === 'xAxes' || key === 'yAxes') {
								var slen = source[key].length;
								var i, type, scale;

								if (!target[key]) {
									target[key] = [];
								}

								for (i = 0; i < slen; ++i) {
									scale = source[key][i];
									type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');

									if (i >= target[key].length) {
										target[key].push({});
									}

									if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) {
										// new/untyped scale or type changed: let's apply the new defaults
										// then merge source scale to correctly overwrite the defaults.
										helpers.merge(target[key][i], [Chart.scaleService.getScaleDefaults(type), scale]);
									} else {
										// scales type are the same
										helpers.merge(target[key][i], scale);
									}
								}
							} else {
								helpers._merger(key, target, source, options);
							}
						}
					});
				};

				helpers.where = function (collection, filterCallback) {
					if (helpers.isArray(collection) && Array.prototype.filter) {
						return collection.filter(filterCallback);
					}
					var filtered = [];

					helpers.each(collection, function (item) {
						if (filterCallback(item)) {
							filtered.push(item);
						}
					});

					return filtered;
				};
				helpers.findIndex = Array.prototype.findIndex ? function (array, callback, scope) {
					return array.findIndex(callback, scope);
				} : function (array, callback, scope) {
					scope = scope === undefined ? array : scope;
					for (var i = 0, ilen = array.length; i < ilen; ++i) {
						if (callback.call(scope, array[i], i, array)) {
							return i;
						}
					}
					return -1;
				};
				helpers.findNextWhere = function (arrayToSearch, filterCallback, startIndex) {
					// Default to start of the array
					if (helpers.isNullOrUndef(startIndex)) {
						startIndex = -1;
					}
					for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
						var currentItem = arrayToSearch[i];
						if (filterCallback(currentItem)) {
							return currentItem;
						}
					}
				};
				helpers.findPreviousWhere = function (arrayToSearch, filterCallback, startIndex) {
					// Default to end of the array
					if (helpers.isNullOrUndef(startIndex)) {
						startIndex = arrayToSearch.length;
					}
					for (var i = startIndex - 1; i >= 0; i--) {
						var currentItem = arrayToSearch[i];
						if (filterCallback(currentItem)) {
							return currentItem;
						}
					}
				};

				// -- Math methods
				helpers.isNumber = function (n) {
					return !isNaN(parseFloat(n)) && isFinite(n);
				};
				helpers.almostEquals = function (x, y, epsilon) {
					return Math.abs(x - y) < epsilon;
				};
				helpers.almostWhole = function (x, epsilon) {
					var rounded = Math.round(x);
					return rounded - epsilon < x && rounded + epsilon > x;
				};
				helpers.max = function (array) {
					return array.reduce(function (max, value) {
						if (!isNaN(value)) {
							return Math.max(max, value);
						}
						return max;
					}, Number.NEGATIVE_INFINITY);
				};
				helpers.min = function (array) {
					return array.reduce(function (min, value) {
						if (!isNaN(value)) {
							return Math.min(min, value);
						}
						return min;
					}, Number.POSITIVE_INFINITY);
				};
				helpers.sign = Math.sign ? function (x) {
					return Math.sign(x);
				} : function (x) {
					x = +x; // convert to a number
					if (x === 0 || isNaN(x)) {
						return x;
					}
					return x > 0 ? 1 : -1;
				};
				helpers.log10 = Math.log10 ? function (x) {
					return Math.log10(x);
				} : function (x) {
					var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
					// Check for whole powers of 10,
					// which due to floating point rounding error should be corrected.
					var powerOf10 = Math.round(exponent);
					var isPowerOf10 = x === Math.pow(10, powerOf10);

					return isPowerOf10 ? powerOf10 : exponent;
				};
				helpers.toRadians = function (degrees) {
					return degrees * (Math.PI / 180);
				};
				helpers.toDegrees = function (radians) {
					return radians * (180 / Math.PI);
				};
				// Gets the angle from vertical upright to the point about a centre.
				helpers.getAngleFromPoint = function (centrePoint, anglePoint) {
					var distanceFromXCenter = anglePoint.x - centrePoint.x;
					var distanceFromYCenter = anglePoint.y - centrePoint.y;
					var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

					var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

					if (angle < -0.5 * Math.PI) {
						angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
					}

					return {
						angle: angle,
						distance: radialDistanceFromCenter
					};
				};
				helpers.distanceBetweenPoints = function (pt1, pt2) {
					return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
				};
				helpers.aliasPixel = function (pixelWidth) {
					return pixelWidth % 2 === 0 ? 0 : 0.5;
				};
				helpers.splineCurve = function (firstPoint, middlePoint, afterPoint, t) {
					// Props to Rob Spencer at scaled innovation for his post on splining between points
					// http://scaledinnovation.com/analytics/splines/aboutSplines.html

					// This function must also respect "skipped" points

					var previous = firstPoint.skip ? middlePoint : firstPoint;
					var current = middlePoint;
					var next = afterPoint.skip ? middlePoint : afterPoint;

					var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
					var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

					var s01 = d01 / (d01 + d12);
					var s12 = d12 / (d01 + d12);

					// If all points are the same, s01 & s02 will be inf
					s01 = isNaN(s01) ? 0 : s01;
					s12 = isNaN(s12) ? 0 : s12;

					var fa = t * s01; // scaling factor for triangle Ta
					var fb = t * s12;

					return {
						previous: {
							x: current.x - fa * (next.x - previous.x),
							y: current.y - fa * (next.y - previous.y)
						},
						next: {
							x: current.x + fb * (next.x - previous.x),
							y: current.y + fb * (next.y - previous.y)
						}
					};
				};
				helpers.EPSILON = Number.EPSILON || 1e-14;
				helpers.splineCurveMonotone = function (points) {
					// This function calculates Bézier control points in a similar way than |splineCurve|,
					// but preserves monotonicity of the provided data and ensures no local extremums are added
					// between the dataset discrete points due to the interpolation.
					// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

					var pointsWithTangents = (points || []).map(function (point) {
						return {
							model: point._model,
							deltaK: 0,
							mK: 0
						};
					});

					// Calculate slopes (deltaK) and initialize tangents (mK)
					var pointsLen = pointsWithTangents.length;
					var i, pointBefore, pointCurrent, pointAfter;
					for (i = 0; i < pointsLen; ++i) {
						pointCurrent = pointsWithTangents[i];
						if (pointCurrent.model.skip) {
							continue;
						}

						pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
						pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
						if (pointAfter && !pointAfter.model.skip) {
							var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;

							// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
							pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
						}

						if (!pointBefore || pointBefore.model.skip) {
							pointCurrent.mK = pointCurrent.deltaK;
						} else if (!pointAfter || pointAfter.model.skip) {
							pointCurrent.mK = pointBefore.deltaK;
						} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
							pointCurrent.mK = 0;
						} else {
							pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
						}
					}

					// Adjust tangents to ensure monotonic properties
					var alphaK, betaK, tauK, squaredMagnitude;
					for (i = 0; i < pointsLen - 1; ++i) {
						pointCurrent = pointsWithTangents[i];
						pointAfter = pointsWithTangents[i + 1];
						if (pointCurrent.model.skip || pointAfter.model.skip) {
							continue;
						}

						if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
							pointCurrent.mK = pointAfter.mK = 0;
							continue;
						}

						alphaK = pointCurrent.mK / pointCurrent.deltaK;
						betaK = pointAfter.mK / pointCurrent.deltaK;
						squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
						if (squaredMagnitude <= 9) {
							continue;
						}

						tauK = 3 / Math.sqrt(squaredMagnitude);
						pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
						pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
					}

					// Compute control points
					var deltaX;
					for (i = 0; i < pointsLen; ++i) {
						pointCurrent = pointsWithTangents[i];
						if (pointCurrent.model.skip) {
							continue;
						}

						pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
						pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
						if (pointBefore && !pointBefore.model.skip) {
							deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
							pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
							pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
						}
						if (pointAfter && !pointAfter.model.skip) {
							deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
							pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
							pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
						}
					}
				};
				helpers.nextItem = function (collection, index, loop) {
					if (loop) {
						return index >= collection.length - 1 ? collection[0] : collection[index + 1];
					}
					return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
				};
				helpers.previousItem = function (collection, index, loop) {
					if (loop) {
						return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
					}
					return index <= 0 ? collection[0] : collection[index - 1];
				};
				// Implementation of the nice number algorithm used in determining where axis labels will go
				helpers.niceNum = function (range, round) {
					var exponent = Math.floor(helpers.log10(range));
					var fraction = range / Math.pow(10, exponent);
					var niceFraction;

					if (round) {
						if (fraction < 1.5) {
							niceFraction = 1;
						} else if (fraction < 3) {
							niceFraction = 2;
						} else if (fraction < 7) {
							niceFraction = 5;
						} else {
							niceFraction = 10;
						}
					} else if (fraction <= 1.0) {
						niceFraction = 1;
					} else if (fraction <= 2) {
						niceFraction = 2;
					} else if (fraction <= 5) {
						niceFraction = 5;
					} else {
						niceFraction = 10;
					}

					return niceFraction * Math.pow(10, exponent);
				};
				// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
				helpers.requestAnimFrame = function () {
					if (typeof window === 'undefined') {
						return function (callback) {
							callback();
						};
					}
					return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
						return window.setTimeout(callback, 1000 / 60);
					};
				}();
				// -- DOM methods
				helpers.getRelativePosition = function (evt, chart) {
					var mouseX, mouseY;
					var e = evt.originalEvent || evt;
					var canvas = evt.currentTarget || evt.srcElement;
					var boundingRect = canvas.getBoundingClientRect();

					var touches = e.touches;
					if (touches && touches.length > 0) {
						mouseX = touches[0].clientX;
						mouseY = touches[0].clientY;
					} else {
						mouseX = e.clientX;
						mouseY = e.clientY;
					}

					// Scale mouse coordinates into canvas coordinates
					// by following the pattern laid out by 'jerryj' in the comments of
					// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
					var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
					var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
					var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
					var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
					var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
					var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

					// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
					// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
					mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
					mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);

					return {
						x: mouseX,
						y: mouseY
					};
				};

				// Private helper function to convert max-width/max-height values that may be percentages into a number
				function parseMaxStyle(styleValue, node, parentProperty) {
					var valueInPixels;
					if (typeof styleValue === 'string') {
						valueInPixels = parseInt(styleValue, 10);

						if (styleValue.indexOf('%') !== -1) {
							// percentage * size in dimension
							valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
						}
					} else {
						valueInPixels = styleValue;
					}

					return valueInPixels;
				}

				/**
     * Returns if the given value contains an effective constraint.
     * @private
     */
				function isConstrainedValue(value) {
					return value !== undefined && value !== null && value !== 'none';
				}

				// Private helper to get a constraint dimension
				// @param domNode : the node to check the constraint on
				// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
				// @param percentageProperty : property of parent to use when calculating width as a percentage
				// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
				function getConstraintDimension(domNode, maxStyle, percentageProperty) {
					var view = document.defaultView;
					var parentNode = domNode.parentNode;
					var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
					var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
					var hasCNode = isConstrainedValue(constrainedNode);
					var hasCContainer = isConstrainedValue(constrainedContainer);
					var infinity = Number.POSITIVE_INFINITY;

					if (hasCNode || hasCContainer) {
						return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
					}

					return 'none';
				}
				// returns Number or undefined if no constraint
				helpers.getConstraintWidth = function (domNode) {
					return getConstraintDimension(domNode, 'max-width', 'clientWidth');
				};
				// returns Number or undefined if no constraint
				helpers.getConstraintHeight = function (domNode) {
					return getConstraintDimension(domNode, 'max-height', 'clientHeight');
				};
				helpers.getMaximumWidth = function (domNode) {
					var container = domNode.parentNode;
					if (!container) {
						return domNode.clientWidth;
					}

					var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
					var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
					var w = container.clientWidth - paddingLeft - paddingRight;
					var cw = helpers.getConstraintWidth(domNode);
					return isNaN(cw) ? w : Math.min(w, cw);
				};
				helpers.getMaximumHeight = function (domNode) {
					var container = domNode.parentNode;
					if (!container) {
						return domNode.clientHeight;
					}

					var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
					var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
					var h = container.clientHeight - paddingTop - paddingBottom;
					var ch = helpers.getConstraintHeight(domNode);
					return isNaN(ch) ? h : Math.min(h, ch);
				};
				helpers.getStyle = function (el, property) {
					return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
				};
				helpers.retinaScale = function (chart, forceRatio) {
					var pixelRatio = chart.currentDevicePixelRatio = forceRatio || window.devicePixelRatio || 1;
					if (pixelRatio === 1) {
						return;
					}

					var canvas = chart.canvas;
					var height = chart.height;
					var width = chart.width;

					canvas.height = height * pixelRatio;
					canvas.width = width * pixelRatio;
					chart.ctx.scale(pixelRatio, pixelRatio);

					// If no style has been set on the canvas, the render size is used as display size,
					// making the chart visually bigger, so let's enforce it to the "correct" values.
					// See https://github.com/chartjs/Chart.js/issues/3575
					if (!canvas.style.height && !canvas.style.width) {
						canvas.style.height = height + 'px';
						canvas.style.width = width + 'px';
					}
				};
				// -- Canvas methods
				helpers.fontString = function (pixelSize, fontStyle, fontFamily) {
					return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
				};
				helpers.longestText = function (ctx, font, arrayOfThings, cache) {
					cache = cache || {};
					var data = cache.data = cache.data || {};
					var gc = cache.garbageCollect = cache.garbageCollect || [];

					if (cache.font !== font) {
						data = cache.data = {};
						gc = cache.garbageCollect = [];
						cache.font = font;
					}

					ctx.font = font;
					var longest = 0;
					helpers.each(arrayOfThings, function (thing) {
						// Undefined strings and arrays should not be measured
						if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
							longest = helpers.measureText(ctx, data, gc, longest, thing);
						} else if (helpers.isArray(thing)) {
							// if it is an array lets measure each element
							// to do maybe simplify this function a bit so we can do this more recursively?
							helpers.each(thing, function (nestedThing) {
								// Undefined strings and arrays should not be measured
								if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
									longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
								}
							});
						}
					});

					var gcLen = gc.length / 2;
					if (gcLen > arrayOfThings.length) {
						for (var i = 0; i < gcLen; i++) {
							delete data[gc[i]];
						}
						gc.splice(0, gcLen);
					}
					return longest;
				};
				helpers.measureText = function (ctx, data, gc, longest, string) {
					var textWidth = data[string];
					if (!textWidth) {
						textWidth = data[string] = ctx.measureText(string).width;
						gc.push(string);
					}
					if (textWidth > longest) {
						longest = textWidth;
					}
					return longest;
				};
				helpers.numberOfLabelLines = function (arrayOfThings) {
					var numberOfLines = 1;
					helpers.each(arrayOfThings, function (thing) {
						if (helpers.isArray(thing)) {
							if (thing.length > numberOfLines) {
								numberOfLines = thing.length;
							}
						}
					});
					return numberOfLines;
				};

				helpers.color = !color ? function (value) {
					console.error('Color.js not found!');
					return value;
				} : function (value) {
					/* global CanvasGradient */
					if (value instanceof CanvasGradient) {
						value = defaults.global.defaultColor;
					}

					return color(value);
				};

				helpers.getHoverColor = function (colorValue) {
					/* global CanvasPattern */
					return colorValue instanceof CanvasPattern ? colorValue : helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
				};
			};
		}, { "25": 25, "3": 3, "45": 45 }], 28: [function (require, module, exports) {
			'use strict';

			var helpers = require(45);

			/**
    * Helper function to get relative position for an event
    * @param {Event|IEvent} event - The event to get the position for
    * @param {Chart} chart - The chart
    * @returns {Point} the event position
    */
			function getRelativePosition(e, chart) {
				if (e.native) {
					return {
						x: e.x,
						y: e.y
					};
				}

				return helpers.getRelativePosition(e, chart);
			}

			/**
    * Helper function to traverse all of the visible elements in the chart
    * @param chart {chart} the chart
    * @param handler {Function} the callback to execute for each visible item
    */
			function parseVisibleItems(chart, handler) {
				var datasets = chart.data.datasets;
				var meta, i, j, ilen, jlen;

				for (i = 0, ilen = datasets.length; i < ilen; ++i) {
					if (!chart.isDatasetVisible(i)) {
						continue;
					}

					meta = chart.getDatasetMeta(i);
					for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
						var element = meta.data[j];
						if (!element._view.skip) {
							handler(element);
						}
					}
				}
			}

			/**
    * Helper function to get the items that intersect the event position
    * @param items {ChartElement[]} elements to filter
    * @param position {Point} the point to be nearest to
    * @return {ChartElement[]} the nearest items
    */
			function getIntersectItems(chart, position) {
				var elements = [];

				parseVisibleItems(chart, function (element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
					}
				});

				return elements;
			}

			/**
    * Helper function to get the items nearest to the event position considering all visible items in teh chart
    * @param chart {Chart} the chart to look at elements from
    * @param position {Point} the point to be nearest to
    * @param intersect {Boolean} if true, only consider items that intersect the position
    * @param distanceMetric {Function} function to provide the distance between points
    * @return {ChartElement[]} the nearest items
    */
			function getNearestItems(chart, position, intersect, distanceMetric) {
				var minDistance = Number.POSITIVE_INFINITY;
				var nearestItems = [];

				parseVisibleItems(chart, function (element) {
					if (intersect && !element.inRange(position.x, position.y)) {
						return;
					}

					var center = element.getCenterPoint();
					var distance = distanceMetric(position, center);

					if (distance < minDistance) {
						nearestItems = [element];
						minDistance = distance;
					} else if (distance === minDistance) {
						// Can have multiple items at the same distance in which case we sort by size
						nearestItems.push(element);
					}
				});

				return nearestItems;
			}

			/**
    * Get a distance metric function for two points based on the
    * axis mode setting
    * @param {String} axis the axis mode. x|y|xy
    */
			function getDistanceMetricForAxis(axis) {
				var useX = axis.indexOf('x') !== -1;
				var useY = axis.indexOf('y') !== -1;

				return function (pt1, pt2) {
					var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
					var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
					return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
				};
			}

			function indexMode(chart, e, options) {
				var position = getRelativePosition(e, chart);
				// Default axis for index mode is 'x' to match old behaviour
				options.axis = options.axis || 'x';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
				var elements = [];

				if (!items.length) {
					return [];
				}

				chart.data.datasets.forEach(function (dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var element = meta.data[items[0]._index];

						// don't count items that are skipped (null data)
						if (element && !element._view.skip) {
							elements.push(element);
						}
					}
				});

				return elements;
			}

			/**
    * @interface IInteractionOptions
    */
			/**
    * If true, only consider items that intersect the point
    * @name IInterfaceOptions#boolean
    * @type Boolean
    */

			/**
    * Contains interaction related functions
    * @namespace Chart.Interaction
    */
			module.exports = {
				// Helper function for different modes
				modes: {
					single: function single(chart, e) {
						var position = getRelativePosition(e, chart);
						var elements = [];

						parseVisibleItems(chart, function (element) {
							if (element.inRange(position.x, position.y)) {
								elements.push(element);
								return elements;
							}
						});

						return elements.slice(0, 1);
					},

					/**
      * @function Chart.Interaction.modes.label
      * @deprecated since version 2.4.0
      * @todo remove at version 3
      * @private
      */
					label: indexMode,

					/**
      * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
      * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
      * @function Chart.Interaction.modes.index
      * @since v2.4.0
      * @param chart {chart} the chart we are returning items from
      * @param e {Event} the event we are find things at
      * @param options {IInteractionOptions} options to use during interaction
      * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
      */
					index: indexMode,

					/**
      * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
      * If the options.intersect is false, we find the nearest item and return the items in that dataset
      * @function Chart.Interaction.modes.dataset
      * @param chart {chart} the chart we are returning items from
      * @param e {Event} the event we are find things at
      * @param options {IInteractionOptions} options to use during interaction
      * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
      */
					dataset: function dataset(chart, e, options) {
						var position = getRelativePosition(e, chart);
						options.axis = options.axis || 'xy';
						var distanceMetric = getDistanceMetricForAxis(options.axis);
						var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

						if (items.length > 0) {
							items = chart.getDatasetMeta(items[0]._datasetIndex).data;
						}

						return items;
					},

					/**
      * @function Chart.Interaction.modes.x-axis
      * @deprecated since version 2.4.0. Use index mode and intersect == true
      * @todo remove at version 3
      * @private
      */
					'x-axis': function xAxis(chart, e) {
						return indexMode(chart, e, { intersect: false });
					},

					/**
      * Point mode returns all elements that hit test based on the event position
      * of the event
      * @function Chart.Interaction.modes.intersect
      * @param chart {chart} the chart we are returning items from
      * @param e {Event} the event we are find things at
      * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
      */
					point: function point(chart, e) {
						var position = getRelativePosition(e, chart);
						return getIntersectItems(chart, position);
					},

					/**
      * nearest mode returns the element closest to the point
      * @function Chart.Interaction.modes.intersect
      * @param chart {chart} the chart we are returning items from
      * @param e {Event} the event we are find things at
      * @param options {IInteractionOptions} options to use
      * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
      */
					nearest: function nearest(chart, e, options) {
						var position = getRelativePosition(e, chart);
						options.axis = options.axis || 'xy';
						var distanceMetric = getDistanceMetricForAxis(options.axis);
						var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);

						// We have multiple items at the same distance from the event. Now sort by smallest
						if (nearestItems.length > 1) {
							nearestItems.sort(function (a, b) {
								var sizeA = a.getArea();
								var sizeB = b.getArea();
								var ret = sizeA - sizeB;

								if (ret === 0) {
									// if equal sort by dataset index
									ret = a._datasetIndex - b._datasetIndex;
								}

								return ret;
							});
						}

						// Return only 1 item
						return nearestItems.slice(0, 1);
					},

					/**
      * x mode returns the elements that hit-test at the current x coordinate
      * @function Chart.Interaction.modes.x
      * @param chart {chart} the chart we are returning items from
      * @param e {Event} the event we are find things at
      * @param options {IInteractionOptions} options to use
      * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
      */
					x: function x(chart, e, options) {
						var position = getRelativePosition(e, chart);
						var items = [];
						var intersectsItem = false;

						parseVisibleItems(chart, function (element) {
							if (element.inXRange(position.x)) {
								items.push(element);
							}

							if (element.inRange(position.x, position.y)) {
								intersectsItem = true;
							}
						});

						// If we want to trigger on an intersect and we don't have any items
						// that intersect the position, return nothing
						if (options.intersect && !intersectsItem) {
							items = [];
						}
						return items;
					},

					/**
      * y mode returns the elements that hit-test at the current y coordinate
      * @function Chart.Interaction.modes.y
      * @param chart {chart} the chart we are returning items from
      * @param e {Event} the event we are find things at
      * @param options {IInteractionOptions} options to use
      * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
      */
					y: function y(chart, e, options) {
						var position = getRelativePosition(e, chart);
						var items = [];
						var intersectsItem = false;

						parseVisibleItems(chart, function (element) {
							if (element.inYRange(position.y)) {
								items.push(element);
							}

							if (element.inRange(position.x, position.y)) {
								intersectsItem = true;
							}
						});

						// If we want to trigger on an intersect and we don't have any items
						// that intersect the position, return nothing
						if (options.intersect && !intersectsItem) {
							items = [];
						}
						return items;
					}
				}
			};
		}, { "45": 45 }], 29: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);

			defaults._set('global', {
				responsive: true,
				responsiveAnimationDuration: 0,
				maintainAspectRatio: true,
				events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
				hover: {
					onHover: null,
					mode: 'nearest',
					intersect: true,
					animationDuration: 400
				},
				onClick: null,
				defaultColor: 'rgba(0,0,0,0.1)',
				defaultFontColor: '#666',
				defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
				defaultFontSize: 12,
				defaultFontStyle: 'normal',
				showLines: true,

				// Element defaults defined in element extensions
				elements: {},

				// Layout options such as padding
				layout: {
					padding: {
						top: 0,
						right: 0,
						bottom: 0,
						left: 0
					}
				}
			});

			module.exports = function () {

				// Occupy the global variable of Chart, and create a simple base class
				var Chart = function Chart(item, config) {
					this.construct(item, config);
					return this;
				};

				Chart.Chart = Chart;

				return Chart;
			};
		}, { "25": 25 }], 30: [function (require, module, exports) {
			'use strict';

			var helpers = require(45);

			function filterByPosition(array, position) {
				return helpers.where(array, function (v) {
					return v.position === position;
				});
			}

			function sortByWeight(array, reverse) {
				array.forEach(function (v, i) {
					v._tmpIndex_ = i;
					return v;
				});
				array.sort(function (a, b) {
					var v0 = reverse ? b : a;
					var v1 = reverse ? a : b;
					return v0.weight === v1.weight ? v0._tmpIndex_ - v1._tmpIndex_ : v0.weight - v1.weight;
				});
				array.forEach(function (v) {
					delete v._tmpIndex_;
				});
			}

			/**
    * @interface ILayoutItem
    * @prop {String} position - The position of the item in the chart layout. Possible values are
    * 'left', 'top', 'right', 'bottom', and 'chartArea'
    * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
    * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
    * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
    * @prop {Function} update - Takes two parameters: width and height. Returns size of item
    * @prop {Function} getPadding -  Returns an object with padding on the edges
    * @prop {Number} width - Width of item. Must be valid after update()
    * @prop {Number} height - Height of item. Must be valid after update()
    * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
    * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
    * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
    * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
    */

			// The layout service is very self explanatory.  It's responsible for the layout within a chart.
			// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
			// It is this service's responsibility of carrying out that layout.
			module.exports = {
				defaults: {},

				/**
     * Register a box to a chart.
     * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
     * @param {Chart} chart - the chart to use
     * @param {ILayoutItem} item - the item to add to be layed out
     */
				addBox: function addBox(chart, item) {
					if (!chart.boxes) {
						chart.boxes = [];
					}

					// initialize item with default values
					item.fullWidth = item.fullWidth || false;
					item.position = item.position || 'top';
					item.weight = item.weight || 0;

					chart.boxes.push(item);
				},

				/**
     * Remove a layoutItem from a chart
     * @param {Chart} chart - the chart to remove the box from
     * @param {Object} layoutItem - the item to remove from the layout
     */
				removeBox: function removeBox(chart, layoutItem) {
					var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
					if (index !== -1) {
						chart.boxes.splice(index, 1);
					}
				},

				/**
     * Sets (or updates) options on the given `item`.
     * @param {Chart} chart - the chart in which the item lives (or will be added to)
     * @param {Object} item - the item to configure with the given options
     * @param {Object} options - the new item options.
     */
				configure: function configure(chart, item, options) {
					var props = ['fullWidth', 'position', 'weight'];
					var ilen = props.length;
					var i = 0;
					var prop;

					for (; i < ilen; ++i) {
						prop = props[i];
						if (options.hasOwnProperty(prop)) {
							item[prop] = options[prop];
						}
					}
				},

				/**
     * Fits boxes of the given chart into the given size by having each box measure itself
     * then running a fitting algorithm
     * @param {Chart} chart - the chart
     * @param {Number} width - the width to fit into
     * @param {Number} height - the height to fit into
     */
				update: function update(chart, width, height) {
					if (!chart) {
						return;
					}

					var layoutOptions = chart.options.layout || {};
					var padding = helpers.options.toPadding(layoutOptions.padding);
					var leftPadding = padding.left;
					var rightPadding = padding.right;
					var topPadding = padding.top;
					var bottomPadding = padding.bottom;

					var leftBoxes = filterByPosition(chart.boxes, 'left');
					var rightBoxes = filterByPosition(chart.boxes, 'right');
					var topBoxes = filterByPosition(chart.boxes, 'top');
					var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
					var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

					// Sort boxes by weight. A higher weight is further away from the chart area
					sortByWeight(leftBoxes, true);
					sortByWeight(rightBoxes, false);
					sortByWeight(topBoxes, true);
					sortByWeight(bottomBoxes, false);

					// Essentially we now have any number of boxes on each of the 4 sides.
					// Our canvas looks like the following.
					// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
					// B1 is the bottom axis
					// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
					// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
					// an error will be thrown.
					//
					// |----------------------------------------------------|
					// |                  T1 (Full Width)                   |
					// |----------------------------------------------------|
					// |    |    |                 T2                  |    |
					// |    |----|-------------------------------------|----|
					// |    |    | C1 |                           | C2 |    |
					// |    |    |----|                           |----|    |
					// |    |    |                                     |    |
					// | L1 | L2 |           ChartArea (C0)            | R1 |
					// |    |    |                                     |    |
					// |    |    |----|                           |----|    |
					// |    |    | C3 |                           | C4 |    |
					// |    |----|-------------------------------------|----|
					// |    |    |                 B1                  |    |
					// |----------------------------------------------------|
					// |                  B2 (Full Width)                   |
					// |----------------------------------------------------|
					//
					// What we do to find the best sizing, we do the following
					// 1. Determine the minimum size of the chart area.
					// 2. Split the remaining width equally between each vertical axis
					// 3. Split the remaining height equally between each horizontal axis
					// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
					// 5. Adjust the sizes of each axis based on it's minimum reported size.
					// 6. Refit each axis
					// 7. Position each axis in the final location
					// 8. Tell the chart the final location of the chart area
					// 9. Tell any axes that overlay the chart area the positions of the chart area

					// Step 1
					var chartWidth = width - leftPadding - rightPadding;
					var chartHeight = height - topPadding - bottomPadding;
					var chartAreaWidth = chartWidth / 2; // min 50%
					var chartAreaHeight = chartHeight / 2; // min 50%

					// Step 2
					var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);

					// Step 3
					var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);

					// Step 4
					var maxChartAreaWidth = chartWidth;
					var maxChartAreaHeight = chartHeight;
					var minBoxSizes = [];

					function getMinimumBoxSize(box) {
						var minSize;
						var isHorizontal = box.isHorizontal();

						if (isHorizontal) {
							minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
							maxChartAreaHeight -= minSize.height;
						} else {
							minSize = box.update(verticalBoxWidth, maxChartAreaHeight);
							maxChartAreaWidth -= minSize.width;
						}

						minBoxSizes.push({
							horizontal: isHorizontal,
							minSize: minSize,
							box: box
						});
					}

					helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);

					// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
					var maxHorizontalLeftPadding = 0;
					var maxHorizontalRightPadding = 0;
					var maxVerticalTopPadding = 0;
					var maxVerticalBottomPadding = 0;

					helpers.each(topBoxes.concat(bottomBoxes), function (horizontalBox) {
						if (horizontalBox.getPadding) {
							var boxPadding = horizontalBox.getPadding();
							maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
							maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
						}
					});

					helpers.each(leftBoxes.concat(rightBoxes), function (verticalBox) {
						if (verticalBox.getPadding) {
							var boxPadding = verticalBox.getPadding();
							maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
							maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
						}
					});

					// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
					// be if the axes are drawn at their minimum sizes.
					// Steps 5 & 6
					var totalLeftBoxesWidth = leftPadding;
					var totalRightBoxesWidth = rightPadding;
					var totalTopBoxesHeight = topPadding;
					var totalBottomBoxesHeight = bottomPadding;

					// Function to fit a box
					function fitBox(box) {
						var minBoxSize = helpers.findNextWhere(minBoxSizes, function (minBox) {
							return minBox.box === box;
						});

						if (minBoxSize) {
							if (box.isHorizontal()) {
								var scaleMargin = {
									left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
									right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
									top: 0,
									bottom: 0
								};

								// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
								// on the margin. Sometimes they need to increase in size slightly
								box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
							} else {
								box.update(minBoxSize.minSize.width, maxChartAreaHeight);
							}
						}
					}

					// Update, and calculate the left and right margins for the horizontal boxes
					helpers.each(leftBoxes.concat(rightBoxes), fitBox);

					helpers.each(leftBoxes, function (box) {
						totalLeftBoxesWidth += box.width;
					});

					helpers.each(rightBoxes, function (box) {
						totalRightBoxesWidth += box.width;
					});

					// Set the Left and Right margins for the horizontal boxes
					helpers.each(topBoxes.concat(bottomBoxes), fitBox);

					// Figure out how much margin is on the top and bottom of the vertical boxes
					helpers.each(topBoxes, function (box) {
						totalTopBoxesHeight += box.height;
					});

					helpers.each(bottomBoxes, function (box) {
						totalBottomBoxesHeight += box.height;
					});

					function finalFitVerticalBox(box) {
						var minBoxSize = helpers.findNextWhere(minBoxSizes, function (minSize) {
							return minSize.box === box;
						});

						var scaleMargin = {
							left: 0,
							right: 0,
							top: totalTopBoxesHeight,
							bottom: totalBottomBoxesHeight
						};

						if (minBoxSize) {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
						}
					}

					// Let the left layout know the final margin
					helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);

					// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
					totalLeftBoxesWidth = leftPadding;
					totalRightBoxesWidth = rightPadding;
					totalTopBoxesHeight = topPadding;
					totalBottomBoxesHeight = bottomPadding;

					helpers.each(leftBoxes, function (box) {
						totalLeftBoxesWidth += box.width;
					});

					helpers.each(rightBoxes, function (box) {
						totalRightBoxesWidth += box.width;
					});

					helpers.each(topBoxes, function (box) {
						totalTopBoxesHeight += box.height;
					});
					helpers.each(bottomBoxes, function (box) {
						totalBottomBoxesHeight += box.height;
					});

					// We may be adding some padding to account for rotated x axis labels
					var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
					totalLeftBoxesWidth += leftPaddingAddition;
					totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);

					var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
					totalTopBoxesHeight += topPaddingAddition;
					totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);

					// Figure out if our chart area changed. This would occur if the dataset layout label rotation
					// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
					// without calling `fit` again
					var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
					var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;

					if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
						helpers.each(leftBoxes, function (box) {
							box.height = newMaxChartAreaHeight;
						});

						helpers.each(rightBoxes, function (box) {
							box.height = newMaxChartAreaHeight;
						});

						helpers.each(topBoxes, function (box) {
							if (!box.fullWidth) {
								box.width = newMaxChartAreaWidth;
							}
						});

						helpers.each(bottomBoxes, function (box) {
							if (!box.fullWidth) {
								box.width = newMaxChartAreaWidth;
							}
						});

						maxChartAreaHeight = newMaxChartAreaHeight;
						maxChartAreaWidth = newMaxChartAreaWidth;
					}

					// Step 7 - Position the boxes
					var left = leftPadding + leftPaddingAddition;
					var top = topPadding + topPaddingAddition;

					function placeBox(box) {
						if (box.isHorizontal()) {
							box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
							box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
							box.top = top;
							box.bottom = top + box.height;

							// Move to next point
							top = box.bottom;
						} else {

							box.left = left;
							box.right = left + box.width;
							box.top = totalTopBoxesHeight;
							box.bottom = totalTopBoxesHeight + maxChartAreaHeight;

							// Move to next point
							left = box.right;
						}
					}

					helpers.each(leftBoxes.concat(topBoxes), placeBox);

					// Account for chart width and height
					left += maxChartAreaWidth;
					top += maxChartAreaHeight;

					helpers.each(rightBoxes, placeBox);
					helpers.each(bottomBoxes, placeBox);

					// Step 8
					chart.chartArea = {
						left: totalLeftBoxesWidth,
						top: totalTopBoxesHeight,
						right: totalLeftBoxesWidth + maxChartAreaWidth,
						bottom: totalTopBoxesHeight + maxChartAreaHeight
					};

					// Step 9
					helpers.each(chartAreaBoxes, function (box) {
						box.left = chart.chartArea.left;
						box.top = chart.chartArea.top;
						box.right = chart.chartArea.right;
						box.bottom = chart.chartArea.bottom;

						box.update(maxChartAreaWidth, maxChartAreaHeight);
					});
				}
			};
		}, { "45": 45 }], 31: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var helpers = require(45);

			defaults._set('global', {
				plugins: {}
			});

			/**
    * The plugin service singleton
    * @namespace Chart.plugins
    * @since 2.1.0
    */
			module.exports = {
				/**
     * Globally registered plugins.
     * @private
     */
				_plugins: [],

				/**
     * This identifier is used to invalidate the descriptors cache attached to each chart
     * when a global plugin is registered or unregistered. In this case, the cache ID is
     * incremented and descriptors are regenerated during following API calls.
     * @private
     */
				_cacheId: 0,

				/**
     * Registers the given plugin(s) if not already registered.
     * @param {Array|Object} plugins plugin instance(s).
     */
				register: function register(plugins) {
					var p = this._plugins;
					[].concat(plugins).forEach(function (plugin) {
						if (p.indexOf(plugin) === -1) {
							p.push(plugin);
						}
					});

					this._cacheId++;
				},

				/**
     * Unregisters the given plugin(s) only if registered.
     * @param {Array|Object} plugins plugin instance(s).
     */
				unregister: function unregister(plugins) {
					var p = this._plugins;
					[].concat(plugins).forEach(function (plugin) {
						var idx = p.indexOf(plugin);
						if (idx !== -1) {
							p.splice(idx, 1);
						}
					});

					this._cacheId++;
				},

				/**
     * Remove all registered plugins.
     * @since 2.1.5
     */
				clear: function clear() {
					this._plugins = [];
					this._cacheId++;
				},

				/**
     * Returns the number of registered plugins?
     * @returns {Number}
     * @since 2.1.5
     */
				count: function count() {
					return this._plugins.length;
				},

				/**
     * Returns all registered plugin instances.
     * @returns {Array} array of plugin objects.
     * @since 2.1.5
     */
				getAll: function getAll() {
					return this._plugins;
				},

				/**
     * Calls enabled plugins for `chart` on the specified hook and with the given args.
     * This method immediately returns as soon as a plugin explicitly returns false. The
     * returned value can be used, for instance, to interrupt the current action.
     * @param {Object} chart - The chart instance for which plugins should be called.
     * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
     * @param {Array} [args] - Extra arguments to apply to the hook call.
     * @returns {Boolean} false if any of the plugins return false, else returns true.
     */
				notify: function notify(chart, hook, args) {
					var descriptors = this.descriptors(chart);
					var ilen = descriptors.length;
					var i, descriptor, plugin, params, method;

					for (i = 0; i < ilen; ++i) {
						descriptor = descriptors[i];
						plugin = descriptor.plugin;
						method = plugin[hook];
						if (typeof method === 'function') {
							params = [chart].concat(args || []);
							params.push(descriptor.options);
							if (method.apply(plugin, params) === false) {
								return false;
							}
						}
					}

					return true;
				},

				/**
     * Returns descriptors of enabled plugins for the given chart.
     * @returns {Array} [{ plugin, options }]
     * @private
     */
				descriptors: function descriptors(chart) {
					var cache = chart.$plugins || (chart.$plugins = {});
					if (cache.id === this._cacheId) {
						return cache.descriptors;
					}

					var plugins = [];
					var descriptors = [];
					var config = chart && chart.config || {};
					var options = config.options && config.options.plugins || {};

					this._plugins.concat(config.plugins || []).forEach(function (plugin) {
						var idx = plugins.indexOf(plugin);
						if (idx !== -1) {
							return;
						}

						var id = plugin.id;
						var opts = options[id];
						if (opts === false) {
							return;
						}

						if (opts === true) {
							opts = helpers.clone(defaults.global.plugins[id]);
						}

						plugins.push(plugin);
						descriptors.push({
							plugin: plugin,
							options: opts || {}
						});
					});

					cache.descriptors = descriptors;
					cache.id = this._cacheId;
					return descriptors;
				},

				/**
     * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
     * but in some cases, this reference can be changed by the user when updating options.
     * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
     * @private
     */
				_invalidate: function _invalidate(chart) {
					delete chart.$plugins;
				}
			};

			/**
    * Plugin extension hooks.
    * @interface IPlugin
    * @since 2.1.0
    */
			/**
    * @method IPlugin#beforeInit
    * @desc Called before initializing `chart`.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#afterInit
    * @desc Called after `chart` has been initialized and before the first update.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#beforeUpdate
    * @desc Called before updating `chart`. If any plugin returns `false`, the update
    * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Object} options - The plugin options.
    * @returns {Boolean} `false` to cancel the chart update.
    */
			/**
    * @method IPlugin#afterUpdate
    * @desc Called after `chart` has been updated and before rendering. Note that this
    * hook will not be called if the chart update has been previously cancelled.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#beforeDatasetsUpdate
    * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
    * the datasets update is cancelled until another `update` is triggered.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Object} options - The plugin options.
    * @returns {Boolean} false to cancel the datasets update.
    * @since version 2.1.5
   */
			/**
    * @method IPlugin#afterDatasetsUpdate
    * @desc Called after the `chart` datasets have been updated. Note that this hook
    * will not be called if the datasets update has been previously cancelled.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Object} options - The plugin options.
    * @since version 2.1.5
    */
			/**
    * @method IPlugin#beforeDatasetUpdate
    * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
    * returns `false`, the datasets update is cancelled until another `update` is triggered.
    * @param {Chart} chart - The chart instance.
    * @param {Object} args - The call arguments.
    * @param {Number} args.index - The dataset index.
    * @param {Object} args.meta - The dataset metadata.
    * @param {Object} options - The plugin options.
    * @returns {Boolean} `false` to cancel the chart datasets drawing.
    */
			/**
    * @method IPlugin#afterDatasetUpdate
    * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
    * that this hook will not be called if the datasets update has been previously cancelled.
    * @param {Chart} chart - The chart instance.
    * @param {Object} args - The call arguments.
    * @param {Number} args.index - The dataset index.
    * @param {Object} args.meta - The dataset metadata.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#beforeLayout
    * @desc Called before laying out `chart`. If any plugin returns `false`,
    * the layout update is cancelled until another `update` is triggered.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Object} options - The plugin options.
    * @returns {Boolean} `false` to cancel the chart layout.
    */
			/**
    * @method IPlugin#afterLayout
    * @desc Called after the `chart` has been layed out. Note that this hook will not
    * be called if the layout update has been previously cancelled.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#beforeRender
    * @desc Called before rendering `chart`. If any plugin returns `false`,
    * the rendering is cancelled until another `render` is triggered.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Object} options - The plugin options.
    * @returns {Boolean} `false` to cancel the chart rendering.
    */
			/**
    * @method IPlugin#afterRender
    * @desc Called after the `chart` has been fully rendered (and animation completed). Note
    * that this hook will not be called if the rendering has been previously cancelled.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#beforeDraw
    * @desc Called before drawing `chart` at every animation frame specified by the given
    * easing value. If any plugin returns `false`, the frame drawing is cancelled until
    * another `render` is triggered.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
    * @param {Object} options - The plugin options.
    * @returns {Boolean} `false` to cancel the chart drawing.
    */
			/**
    * @method IPlugin#afterDraw
    * @desc Called after the `chart` has been drawn for the specific easing value. Note
    * that this hook will not be called if the drawing has been previously cancelled.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#beforeDatasetsDraw
    * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
    * the datasets drawing is cancelled until another `render` is triggered.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
    * @param {Object} options - The plugin options.
    * @returns {Boolean} `false` to cancel the chart datasets drawing.
    */
			/**
    * @method IPlugin#afterDatasetsDraw
    * @desc Called after the `chart` datasets have been drawn. Note that this hook
    * will not be called if the datasets drawing has been previously cancelled.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#beforeDatasetDraw
    * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
    * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
    * is cancelled until another `render` is triggered.
    * @param {Chart} chart - The chart instance.
    * @param {Object} args - The call arguments.
    * @param {Number} args.index - The dataset index.
    * @param {Object} args.meta - The dataset metadata.
    * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
    * @param {Object} options - The plugin options.
    * @returns {Boolean} `false` to cancel the chart datasets drawing.
    */
			/**
    * @method IPlugin#afterDatasetDraw
    * @desc Called after the `chart` datasets at the given `args.index` have been drawn
    * (datasets are drawn in the reverse order). Note that this hook will not be called
    * if the datasets drawing has been previously cancelled.
    * @param {Chart} chart - The chart instance.
    * @param {Object} args - The call arguments.
    * @param {Number} args.index - The dataset index.
    * @param {Object} args.meta - The dataset metadata.
    * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#beforeTooltipDraw
    * @desc Called before drawing the `tooltip`. If any plugin returns `false`,
    * the tooltip drawing is cancelled until another `render` is triggered.
    * @param {Chart} chart - The chart instance.
    * @param {Object} args - The call arguments.
    * @param {Object} args.tooltip - The tooltip.
    * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
    * @param {Object} options - The plugin options.
    * @returns {Boolean} `false` to cancel the chart tooltip drawing.
    */
			/**
    * @method IPlugin#afterTooltipDraw
    * @desc Called after drawing the `tooltip`. Note that this hook will not
    * be called if the tooltip drawing has been previously cancelled.
    * @param {Chart} chart - The chart instance.
    * @param {Object} args - The call arguments.
    * @param {Object} args.tooltip - The tooltip.
    * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#beforeEvent
    * @desc Called before processing the specified `event`. If any plugin returns `false`,
    * the event will be discarded.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {IEvent} event - The event object.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#afterEvent
    * @desc Called after the `event` has been consumed. Note that this hook
    * will not be called if the `event` has been previously discarded.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {IEvent} event - The event object.
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#resize
    * @desc Called after the chart as been resized.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
    * @param {Object} options - The plugin options.
    */
			/**
    * @method IPlugin#destroy
    * @desc Called after the chart as been destroyed.
    * @param {Chart.Controller} chart - The chart instance.
    * @param {Object} options - The plugin options.
    */
		}, { "25": 25, "45": 45 }], 32: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var Element = require(26);
			var helpers = require(45);
			var Ticks = require(34);

			defaults._set('scale', {
				display: true,
				position: 'left',
				offset: false,

				// grid line settings
				gridLines: {
					display: true,
					color: 'rgba(0, 0, 0, 0.1)',
					lineWidth: 1,
					drawBorder: true,
					drawOnChartArea: true,
					drawTicks: true,
					tickMarkLength: 10,
					zeroLineWidth: 1,
					zeroLineColor: 'rgba(0,0,0,0.25)',
					zeroLineBorderDash: [],
					zeroLineBorderDashOffset: 0.0,
					offsetGridLines: false,
					borderDash: [],
					borderDashOffset: 0.0
				},

				// scale label
				scaleLabel: {
					// display property
					display: false,

					// actual label
					labelString: '',

					// line height
					lineHeight: 1.2,

					// top/bottom padding
					padding: {
						top: 4,
						bottom: 4
					}
				},

				// label settings
				ticks: {
					beginAtZero: false,
					minRotation: 0,
					maxRotation: 50,
					mirror: false,
					padding: 0,
					reverse: false,
					display: true,
					autoSkip: true,
					autoSkipPadding: 0,
					labelOffset: 0,
					// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
					callback: Ticks.formatters.values,
					minor: {},
					major: {}
				}
			});

			function labelsFromTicks(ticks) {
				var labels = [];
				var i, ilen;

				for (i = 0, ilen = ticks.length; i < ilen; ++i) {
					labels.push(ticks[i].label);
				}

				return labels;
			}

			function getLineValue(scale, index, offsetGridLines) {
				var lineValue = scale.getPixelForTick(index);

				if (offsetGridLines) {
					if (index === 0) {
						lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
					} else {
						lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
					}
				}
				return lineValue;
			}

			module.exports = function (Chart) {

				function computeTextSize(context, tick, font) {
					return helpers.isArray(tick) ? helpers.longestText(context, font, tick) : context.measureText(tick).width;
				}

				function parseFontOptions(options) {
					var valueOrDefault = helpers.valueOrDefault;
					var globalDefaults = defaults.global;
					var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
					var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
					var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);

					return {
						size: size,
						style: style,
						family: family,
						font: helpers.fontString(size, style, family)
					};
				}

				function parseLineHeight(options) {
					return helpers.options.toLineHeight(helpers.valueOrDefault(options.lineHeight, 1.2), helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
				}

				Chart.Scale = Element.extend({
					/**
      * Get the padding needed for the scale
      * @method getPadding
      * @private
      * @returns {Padding} the necessary padding
      */
					getPadding: function getPadding() {
						var me = this;
						return {
							left: me.paddingLeft || 0,
							top: me.paddingTop || 0,
							right: me.paddingRight || 0,
							bottom: me.paddingBottom || 0
						};
					},

					/**
      * Returns the scale tick objects ({label, major})
      * @since 2.7
      */
					getTicks: function getTicks() {
						return this._ticks;
					},

					// These methods are ordered by lifecyle. Utilities then follow.
					// Any function defined here is inherited by all scale types.
					// Any function can be extended by the scale type

					mergeTicksOptions: function mergeTicksOptions() {
						var ticks = this.options.ticks;
						if (ticks.minor === false) {
							ticks.minor = {
								display: false
							};
						}
						if (ticks.major === false) {
							ticks.major = {
								display: false
							};
						}
						for (var key in ticks) {
							if (key !== 'major' && key !== 'minor') {
								if (typeof ticks.minor[key] === 'undefined') {
									ticks.minor[key] = ticks[key];
								}
								if (typeof ticks.major[key] === 'undefined') {
									ticks.major[key] = ticks[key];
								}
							}
						}
					},
					beforeUpdate: function beforeUpdate() {
						helpers.callback(this.options.beforeUpdate, [this]);
					},
					update: function update(maxWidth, maxHeight, margins) {
						var me = this;
						var i, ilen, labels, label, ticks, tick;

						// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
						me.beforeUpdate();

						// Absorb the master measurements
						me.maxWidth = maxWidth;
						me.maxHeight = maxHeight;
						me.margins = helpers.extend({
							left: 0,
							right: 0,
							top: 0,
							bottom: 0
						}, margins);
						me.longestTextCache = me.longestTextCache || {};

						// Dimensions
						me.beforeSetDimensions();
						me.setDimensions();
						me.afterSetDimensions();

						// Data min/max
						me.beforeDataLimits();
						me.determineDataLimits();
						me.afterDataLimits();

						// Ticks - `this.ticks` is now DEPRECATED!
						// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
						// and must not be accessed directly from outside this class. `this.ticks` being
						// around for long time and not marked as private, we can't change its structure
						// without unexpected breaking changes. If you need to access the scale ticks,
						// use scale.getTicks() instead.

						me.beforeBuildTicks();

						// New implementations should return an array of objects but for BACKWARD COMPAT,
						// we still support no return (`this.ticks` internally set by calling this method).
						ticks = me.buildTicks() || [];

						me.afterBuildTicks();

						me.beforeTickToLabelConversion();

						// New implementations should return the formatted tick labels but for BACKWARD
						// COMPAT, we still support no return (`this.ticks` internally changed by calling
						// this method and supposed to contain only string values).
						labels = me.convertTicksToLabels(ticks) || me.ticks;

						me.afterTickToLabelConversion();

						me.ticks = labels; // BACKWARD COMPATIBILITY

						// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

						// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
						for (i = 0, ilen = labels.length; i < ilen; ++i) {
							label = labels[i];
							tick = ticks[i];
							if (!tick) {
								ticks.push(tick = {
									label: label,
									major: false
								});
							} else {
								tick.label = label;
							}
						}

						me._ticks = ticks;

						// Tick Rotation
						me.beforeCalculateTickRotation();
						me.calculateTickRotation();
						me.afterCalculateTickRotation();
						// Fit
						me.beforeFit();
						me.fit();
						me.afterFit();
						//
						me.afterUpdate();

						return me.minSize;
					},
					afterUpdate: function afterUpdate() {
						helpers.callback(this.options.afterUpdate, [this]);
					},

					//

					beforeSetDimensions: function beforeSetDimensions() {
						helpers.callback(this.options.beforeSetDimensions, [this]);
					},
					setDimensions: function setDimensions() {
						var me = this;
						// Set the unconstrained dimension before label rotation
						if (me.isHorizontal()) {
							// Reset position before calculating rotation
							me.width = me.maxWidth;
							me.left = 0;
							me.right = me.width;
						} else {
							me.height = me.maxHeight;

							// Reset position before calculating rotation
							me.top = 0;
							me.bottom = me.height;
						}

						// Reset padding
						me.paddingLeft = 0;
						me.paddingTop = 0;
						me.paddingRight = 0;
						me.paddingBottom = 0;
					},
					afterSetDimensions: function afterSetDimensions() {
						helpers.callback(this.options.afterSetDimensions, [this]);
					},

					// Data limits
					beforeDataLimits: function beforeDataLimits() {
						helpers.callback(this.options.beforeDataLimits, [this]);
					},
					determineDataLimits: helpers.noop,
					afterDataLimits: function afterDataLimits() {
						helpers.callback(this.options.afterDataLimits, [this]);
					},

					//
					beforeBuildTicks: function beforeBuildTicks() {
						helpers.callback(this.options.beforeBuildTicks, [this]);
					},
					buildTicks: helpers.noop,
					afterBuildTicks: function afterBuildTicks() {
						helpers.callback(this.options.afterBuildTicks, [this]);
					},

					beforeTickToLabelConversion: function beforeTickToLabelConversion() {
						helpers.callback(this.options.beforeTickToLabelConversion, [this]);
					},
					convertTicksToLabels: function convertTicksToLabels() {
						var me = this;
						// Convert ticks to strings
						var tickOpts = me.options.ticks;
						me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
					},
					afterTickToLabelConversion: function afterTickToLabelConversion() {
						helpers.callback(this.options.afterTickToLabelConversion, [this]);
					},

					//

					beforeCalculateTickRotation: function beforeCalculateTickRotation() {
						helpers.callback(this.options.beforeCalculateTickRotation, [this]);
					},
					calculateTickRotation: function calculateTickRotation() {
						var me = this;
						var context = me.ctx;
						var tickOpts = me.options.ticks;
						var labels = labelsFromTicks(me._ticks);

						// Get the width of each grid by calculating the difference
						// between x offsets between 0 and 1.
						var tickFont = parseFontOptions(tickOpts);
						context.font = tickFont.font;

						var labelRotation = tickOpts.minRotation || 0;

						if (labels.length && me.options.display && me.isHorizontal()) {
							var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
							var labelWidth = originalLabelWidth;
							var cosRotation, sinRotation;

							// Allow 3 pixels x2 padding either side for label readability
							var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

							// Max label rotation can be set or default to 90 - also act as a loop counter
							while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
								var angleRadians = helpers.toRadians(labelRotation);
								cosRotation = Math.cos(angleRadians);
								sinRotation = Math.sin(angleRadians);

								if (sinRotation * originalLabelWidth > me.maxHeight) {
									// go back one step
									labelRotation--;
									break;
								}

								labelRotation++;
								labelWidth = cosRotation * originalLabelWidth;
							}
						}

						me.labelRotation = labelRotation;
					},
					afterCalculateTickRotation: function afterCalculateTickRotation() {
						helpers.callback(this.options.afterCalculateTickRotation, [this]);
					},

					//

					beforeFit: function beforeFit() {
						helpers.callback(this.options.beforeFit, [this]);
					},
					fit: function fit() {
						var me = this;
						// Reset
						var minSize = me.minSize = {
							width: 0,
							height: 0
						};

						var labels = labelsFromTicks(me._ticks);

						var opts = me.options;
						var tickOpts = opts.ticks;
						var scaleLabelOpts = opts.scaleLabel;
						var gridLineOpts = opts.gridLines;
						var display = opts.display;
						var isHorizontal = me.isHorizontal();

						var tickFont = parseFontOptions(tickOpts);
						var tickMarkLength = opts.gridLines.tickMarkLength;

						// Width
						if (isHorizontal) {
							// subtract the margins to line up with the chartArea if we are a full width scale
							minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
						} else {
							minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
						}

						// height
						if (isHorizontal) {
							minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
						} else {
							minSize.height = me.maxHeight; // fill all the height
						}

						// Are we showing a title for the scale?
						if (scaleLabelOpts.display && display) {
							var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
							var scaleLabelPadding = helpers.options.toPadding(scaleLabelOpts.padding);
							var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;

							if (isHorizontal) {
								minSize.height += deltaHeight;
							} else {
								minSize.width += deltaHeight;
							}
						}

						// Don't bother fitting the ticks if we are not showing them
						if (tickOpts.display && display) {
							var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
							var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
							var lineSpace = tickFont.size * 0.5;
							var tickPadding = me.options.ticks.padding;

							if (isHorizontal) {
								// A horizontal axis is more constrained by the height.
								me.longestLabelWidth = largestTextWidth;

								var angleRadians = helpers.toRadians(me.labelRotation);
								var cosRotation = Math.cos(angleRadians);
								var sinRotation = Math.sin(angleRadians);

								// TODO - improve this calculation
								var labelHeight = sinRotation * largestTextWidth + tickFont.size * tallestLabelHeightInLines + lineSpace * (tallestLabelHeightInLines - 1) + lineSpace; // padding

								minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

								me.ctx.font = tickFont.font;
								var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
								var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);

								// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
								// which means that the right padding is dominated by the font height
								if (me.labelRotation !== 0) {
									me.paddingLeft = opts.position === 'bottom' ? cosRotation * firstLabelWidth + 3 : cosRotation * lineSpace + 3; // add 3 px to move away from canvas edges
									me.paddingRight = opts.position === 'bottom' ? cosRotation * lineSpace + 3 : cosRotation * lastLabelWidth + 3;
								} else {
									me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
									me.paddingRight = lastLabelWidth / 2 + 3;
								}
							} else {
								// A vertical axis is more constrained by the width. Labels are the
								// dominant factor here, so get that length first and account for padding
								if (tickOpts.mirror) {
									largestTextWidth = 0;
								} else {
									// use lineSpace for consistency with horizontal axis
									// tickPadding is not implemented for horizontal
									largestTextWidth += tickPadding + lineSpace;
								}

								minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);

								me.paddingTop = tickFont.size / 2;
								me.paddingBottom = tickFont.size / 2;
							}
						}

						me.handleMargins();

						me.width = minSize.width;
						me.height = minSize.height;
					},

					/**
      * Handle margins and padding interactions
      * @private
      */
					handleMargins: function handleMargins() {
						var me = this;
						if (me.margins) {
							me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
							me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
							me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
							me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
						}
					},

					afterFit: function afterFit() {
						helpers.callback(this.options.afterFit, [this]);
					},

					// Shared Methods
					isHorizontal: function isHorizontal() {
						return this.options.position === 'top' || this.options.position === 'bottom';
					},
					isFullWidth: function isFullWidth() {
						return this.options.fullWidth;
					},

					// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
					getRightValue: function getRightValue(rawValue) {
						// Null and undefined values first
						if (helpers.isNullOrUndef(rawValue)) {
							return NaN;
						}
						// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
						if (typeof rawValue === 'number' && !isFinite(rawValue)) {
							return NaN;
						}
						// If it is in fact an object, dive in one more level
						if (rawValue) {
							if (this.isHorizontal()) {
								if (rawValue.x !== undefined) {
									return this.getRightValue(rawValue.x);
								}
							} else if (rawValue.y !== undefined) {
								return this.getRightValue(rawValue.y);
							}
						}

						// Value is good, return it
						return rawValue;
					},

					/**
      * Used to get the value to display in the tooltip for the data at the given index
      * @param index
      * @param datasetIndex
      */
					getLabelForIndex: helpers.noop,

					/**
      * Returns the location of the given data point. Value can either be an index or a numerical value
      * The coordinate (0, 0) is at the upper-left corner of the canvas
      * @param value
      * @param index
      * @param datasetIndex
      */
					getPixelForValue: helpers.noop,

					/**
      * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
      * The coordinate (0, 0) is at the upper-left corner of the canvas
      * @param pixel
      */
					getValueForPixel: helpers.noop,

					/**
      * Returns the location of the tick at the given index
      * The coordinate (0, 0) is at the upper-left corner of the canvas
      */
					getPixelForTick: function getPixelForTick(index) {
						var me = this;
						var offset = me.options.offset;
						if (me.isHorizontal()) {
							var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
							var tickWidth = innerWidth / Math.max(me._ticks.length - (offset ? 0 : 1), 1);
							var pixel = tickWidth * index + me.paddingLeft;

							if (offset) {
								pixel += tickWidth / 2;
							}

							var finalVal = me.left + Math.round(pixel);
							finalVal += me.isFullWidth() ? me.margins.left : 0;
							return finalVal;
						}
						var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
						return me.top + index * (innerHeight / (me._ticks.length - 1));
					},

					/**
      * Utility for getting the pixel location of a percentage of scale
      * The coordinate (0, 0) is at the upper-left corner of the canvas
      */
					getPixelForDecimal: function getPixelForDecimal(decimal) {
						var me = this;
						if (me.isHorizontal()) {
							var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
							var valueOffset = innerWidth * decimal + me.paddingLeft;

							var finalVal = me.left + Math.round(valueOffset);
							finalVal += me.isFullWidth() ? me.margins.left : 0;
							return finalVal;
						}
						return me.top + decimal * me.height;
					},

					/**
      * Returns the pixel for the minimum chart value
      * The coordinate (0, 0) is at the upper-left corner of the canvas
      */
					getBasePixel: function getBasePixel() {
						return this.getPixelForValue(this.getBaseValue());
					},

					getBaseValue: function getBaseValue() {
						var me = this;
						var min = me.min;
						var max = me.max;

						return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
					},

					/**
      * Returns a subset of ticks to be plotted to avoid overlapping labels.
      * @private
      */
					_autoSkip: function _autoSkip(ticks) {
						var skipRatio;
						var me = this;
						var isHorizontal = me.isHorizontal();
						var optionTicks = me.options.ticks.minor;
						var tickCount = ticks.length;
						var labelRotationRadians = helpers.toRadians(me.labelRotation);
						var cosRotation = Math.cos(labelRotationRadians);
						var longestRotatedLabel = me.longestLabelWidth * cosRotation;
						var result = [];
						var i, tick, shouldSkip;

						// figure out the maximum number of gridlines to show
						var maxTicks;
						if (optionTicks.maxTicksLimit) {
							maxTicks = optionTicks.maxTicksLimit;
						}

						if (isHorizontal) {
							skipRatio = false;

							if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > me.width - (me.paddingLeft + me.paddingRight)) {
								skipRatio = 1 + Math.floor((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount / (me.width - (me.paddingLeft + me.paddingRight)));
							}

							// if they defined a max number of optionTicks,
							// increase skipRatio until that number is met
							if (maxTicks && tickCount > maxTicks) {
								skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
							}
						}

						for (i = 0; i < tickCount; i++) {
							tick = ticks[i];

							// Since we always show the last tick,we need may need to hide the last shown one before
							shouldSkip = skipRatio > 1 && i % skipRatio > 0 || i % skipRatio === 0 && i + skipRatio >= tickCount;
							if (shouldSkip && i !== tickCount - 1) {
								// leave tick in place but make sure it's not displayed (#4635)
								delete tick.label;
							}
							result.push(tick);
						}
						return result;
					},

					// Actually draw the scale on the canvas
					// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
					draw: function draw(chartArea) {
						var me = this;
						var options = me.options;
						if (!options.display) {
							return;
						}

						var context = me.ctx;
						var globalDefaults = defaults.global;
						var optionTicks = options.ticks.minor;
						var optionMajorTicks = options.ticks.major || optionTicks;
						var gridLines = options.gridLines;
						var scaleLabel = options.scaleLabel;

						var isRotated = me.labelRotation !== 0;
						var isHorizontal = me.isHorizontal();

						var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
						var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
						var tickFont = parseFontOptions(optionTicks);
						var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
						var majorTickFont = parseFontOptions(optionMajorTicks);

						var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

						var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
						var scaleLabelFont = parseFontOptions(scaleLabel);
						var scaleLabelPadding = helpers.options.toPadding(scaleLabel.padding);
						var labelRotationRadians = helpers.toRadians(me.labelRotation);

						var itemsToDraw = [];

						var axisWidth = me.options.gridLines.lineWidth;
						var xTickStart = options.position === 'right' ? me.right : me.right - axisWidth - tl;
						var xTickEnd = options.position === 'right' ? me.right + tl : me.right;
						var yTickStart = options.position === 'bottom' ? me.top + axisWidth : me.bottom - tl - axisWidth;
						var yTickEnd = options.position === 'bottom' ? me.top + axisWidth + tl : me.bottom + axisWidth;

						helpers.each(ticks, function (tick, index) {
							// autoskipper skipped this tick (#4635)
							if (helpers.isNullOrUndef(tick.label)) {
								return;
							}

							var label = tick.label;
							var lineWidth, lineColor, borderDash, borderDashOffset;
							if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
								// Draw the first index specially
								lineWidth = gridLines.zeroLineWidth;
								lineColor = gridLines.zeroLineColor;
								borderDash = gridLines.zeroLineBorderDash;
								borderDashOffset = gridLines.zeroLineBorderDashOffset;
							} else {
								lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
								lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
								borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
								borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
							}

							// Common properties
							var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
							var textAlign = 'middle';
							var textBaseline = 'middle';
							var tickPadding = optionTicks.padding;

							if (isHorizontal) {
								var labelYOffset = tl + tickPadding;

								if (options.position === 'bottom') {
									// bottom
									textBaseline = !isRotated ? 'top' : 'middle';
									textAlign = !isRotated ? 'center' : 'right';
									labelY = me.top + labelYOffset;
								} else {
									// top
									textBaseline = !isRotated ? 'bottom' : 'middle';
									textAlign = !isRotated ? 'center' : 'left';
									labelY = me.bottom - labelYOffset;
								}

								var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
								if (xLineValue < me.left) {
									lineColor = 'rgba(0,0,0,0)';
								}
								xLineValue += helpers.aliasPixel(lineWidth);

								labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)

								tx1 = tx2 = x1 = x2 = xLineValue;
								ty1 = yTickStart;
								ty2 = yTickEnd;
								y1 = chartArea.top;
								y2 = chartArea.bottom + axisWidth;
							} else {
								var isLeft = options.position === 'left';
								var labelXOffset;

								if (optionTicks.mirror) {
									textAlign = isLeft ? 'left' : 'right';
									labelXOffset = tickPadding;
								} else {
									textAlign = isLeft ? 'right' : 'left';
									labelXOffset = tl + tickPadding;
								}

								labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;

								var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
								if (yLineValue < me.top) {
									lineColor = 'rgba(0,0,0,0)';
								}
								yLineValue += helpers.aliasPixel(lineWidth);

								labelY = me.getPixelForTick(index) + optionTicks.labelOffset;

								tx1 = xTickStart;
								tx2 = xTickEnd;
								x1 = chartArea.left;
								x2 = chartArea.right + axisWidth;
								ty1 = ty2 = y1 = y2 = yLineValue;
							}

							itemsToDraw.push({
								tx1: tx1,
								ty1: ty1,
								tx2: tx2,
								ty2: ty2,
								x1: x1,
								y1: y1,
								x2: x2,
								y2: y2,
								labelX: labelX,
								labelY: labelY,
								glWidth: lineWidth,
								glColor: lineColor,
								glBorderDash: borderDash,
								glBorderDashOffset: borderDashOffset,
								rotation: -1 * labelRotationRadians,
								label: label,
								major: tick.major,
								textBaseline: textBaseline,
								textAlign: textAlign
							});
						});

						// Draw all of the tick labels, tick marks, and grid lines at the correct places
						helpers.each(itemsToDraw, function (itemToDraw) {
							if (gridLines.display) {
								context.save();
								context.lineWidth = itemToDraw.glWidth;
								context.strokeStyle = itemToDraw.glColor;
								if (context.setLineDash) {
									context.setLineDash(itemToDraw.glBorderDash);
									context.lineDashOffset = itemToDraw.glBorderDashOffset;
								}

								context.beginPath();

								if (gridLines.drawTicks) {
									context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
									context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
								}

								if (gridLines.drawOnChartArea) {
									context.moveTo(itemToDraw.x1, itemToDraw.y1);
									context.lineTo(itemToDraw.x2, itemToDraw.y2);
								}

								context.stroke();
								context.restore();
							}

							if (optionTicks.display) {
								// Make sure we draw text in the correct color and font
								context.save();
								context.translate(itemToDraw.labelX, itemToDraw.labelY);
								context.rotate(itemToDraw.rotation);
								context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
								context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
								context.textBaseline = itemToDraw.textBaseline;
								context.textAlign = itemToDraw.textAlign;

								var label = itemToDraw.label;
								if (helpers.isArray(label)) {
									var lineCount = label.length;
									var lineHeight = tickFont.size * 1.5;
									var y = me.isHorizontal() ? 0 : -lineHeight * (lineCount - 1) / 2;

									for (var i = 0; i < lineCount; ++i) {
										// We just make sure the multiline element is a string here..
										context.fillText('' + label[i], 0, y);
										// apply same lineSpacing as calculated @ L#320
										y += lineHeight;
									}
								} else {
									context.fillText(label, 0, 0);
								}
								context.restore();
							}
						});

						if (scaleLabel.display) {
							// Draw the scale label
							var scaleLabelX;
							var scaleLabelY;
							var rotation = 0;
							var halfLineHeight = parseLineHeight(scaleLabel) / 2;

							if (isHorizontal) {
								scaleLabelX = me.left + (me.right - me.left) / 2; // midpoint of the width
								scaleLabelY = options.position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
							} else {
								var isLeft = options.position === 'left';
								scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
								scaleLabelY = me.top + (me.bottom - me.top) / 2;
								rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
							}

							context.save();
							context.translate(scaleLabelX, scaleLabelY);
							context.rotate(rotation);
							context.textAlign = 'center';
							context.textBaseline = 'middle';
							context.fillStyle = scaleLabelFontColor; // render in correct colour
							context.font = scaleLabelFont.font;
							context.fillText(scaleLabel.labelString, 0, 0);
							context.restore();
						}

						if (gridLines.drawBorder) {
							// Draw the line at the edge of the axis
							context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
							context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
							var x1 = me.left;
							var x2 = me.right + axisWidth;
							var y1 = me.top;
							var y2 = me.bottom + axisWidth;

							var aliasPixel = helpers.aliasPixel(context.lineWidth);
							if (isHorizontal) {
								y1 = y2 = options.position === 'top' ? me.bottom : me.top;
								y1 += aliasPixel;
								y2 += aliasPixel;
							} else {
								x1 = x2 = options.position === 'left' ? me.right : me.left;
								x1 += aliasPixel;
								x2 += aliasPixel;
							}

							context.beginPath();
							context.moveTo(x1, y1);
							context.lineTo(x2, y2);
							context.stroke();
						}
					}
				});
			};
		}, { "25": 25, "26": 26, "34": 34, "45": 45 }], 33: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var helpers = require(45);
			var layouts = require(30);

			module.exports = function (Chart) {

				Chart.scaleService = {
					// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
					// use the new chart options to grab the correct scale
					constructors: {},
					// Use a registration function so that we can move to an ES6 map when we no longer need to support
					// old browsers

					// Scale config defaults
					defaults: {},
					registerScaleType: function registerScaleType(type, scaleConstructor, scaleDefaults) {
						this.constructors[type] = scaleConstructor;
						this.defaults[type] = helpers.clone(scaleDefaults);
					},
					getScaleConstructor: function getScaleConstructor(type) {
						return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
					},
					getScaleDefaults: function getScaleDefaults(type) {
						// Return the scale defaults merged with the global settings so that we always use the latest ones
						return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
					},
					updateScaleDefaults: function updateScaleDefaults(type, additions) {
						var me = this;
						if (me.defaults.hasOwnProperty(type)) {
							me.defaults[type] = helpers.extend(me.defaults[type], additions);
						}
					},
					addScalesToLayout: function addScalesToLayout(chart) {
						// Adds each scale to the chart.boxes array to be sized accordingly
						helpers.each(chart.scales, function (scale) {
							// Set ILayoutItem parameters for backwards compatibility
							scale.fullWidth = scale.options.fullWidth;
							scale.position = scale.options.position;
							scale.weight = scale.options.weight;
							layouts.addBox(chart, scale);
						});
					}
				};
			};
		}, { "25": 25, "30": 30, "45": 45 }], 34: [function (require, module, exports) {
			'use strict';

			var helpers = require(45);

			/**
    * Namespace to hold static tick generation functions
    * @namespace Chart.Ticks
    */
			module.exports = {
				/**
     * Namespace to hold formatters for different types of ticks
     * @namespace Chart.Ticks.formatters
     */
				formatters: {
					/**
      * Formatter for value labels
      * @method Chart.Ticks.formatters.values
      * @param value the value to display
      * @return {String|Array} the label to display
      */
					values: function values(value) {
						return helpers.isArray(value) ? value : '' + value;
					},

					/**
      * Formatter for linear numeric ticks
      * @method Chart.Ticks.formatters.linear
      * @param tickValue {Number} the value to be formatted
      * @param index {Number} the position of the tickValue parameter in the ticks array
      * @param ticks {Array<Number>} the list of ticks being converted
      * @return {String} string representation of the tickValue parameter
      */
					linear: function linear(tickValue, index, ticks) {
						// If we have lots of ticks, don't use the ones
						var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

						// If we have a number like 2.5 as the delta, figure out how many decimal places we need
						if (Math.abs(delta) > 1) {
							if (tickValue !== Math.floor(tickValue)) {
								// not an integer
								delta = tickValue - Math.floor(tickValue);
							}
						}

						var logDelta = helpers.log10(Math.abs(delta));
						var tickString = '';

						if (tickValue !== 0) {
							var numDecimal = -1 * Math.floor(logDelta);
							numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
							tickString = tickValue.toFixed(numDecimal);
						} else {
							tickString = '0'; // never show decimal places for 0
						}

						return tickString;
					},

					logarithmic: function logarithmic(tickValue, index, ticks) {
						var remain = tickValue / Math.pow(10, Math.floor(helpers.log10(tickValue)));

						if (tickValue === 0) {
							return '0';
						} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
							return tickValue.toExponential();
						}
						return '';
					}
				}
			};
		}, { "45": 45 }], 35: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var Element = require(26);
			var helpers = require(45);

			defaults._set('global', {
				tooltips: {
					enabled: true,
					custom: null,
					mode: 'nearest',
					position: 'average',
					intersect: true,
					backgroundColor: 'rgba(0,0,0,0.8)',
					titleFontStyle: 'bold',
					titleSpacing: 2,
					titleMarginBottom: 6,
					titleFontColor: '#fff',
					titleAlign: 'left',
					bodySpacing: 2,
					bodyFontColor: '#fff',
					bodyAlign: 'left',
					footerFontStyle: 'bold',
					footerSpacing: 2,
					footerMarginTop: 6,
					footerFontColor: '#fff',
					footerAlign: 'left',
					yPadding: 6,
					xPadding: 6,
					caretPadding: 2,
					caretSize: 5,
					cornerRadius: 6,
					multiKeyBackground: '#fff',
					displayColors: true,
					borderColor: 'rgba(0,0,0,0)',
					borderWidth: 0,
					callbacks: {
						// Args are: (tooltipItems, data)
						beforeTitle: helpers.noop,
						title: function title(tooltipItems, data) {
							// Pick first xLabel for now
							var title = '';
							var labels = data.labels;
							var labelCount = labels ? labels.length : 0;

							if (tooltipItems.length > 0) {
								var item = tooltipItems[0];

								if (item.xLabel) {
									title = item.xLabel;
								} else if (labelCount > 0 && item.index < labelCount) {
									title = labels[item.index];
								}
							}

							return title;
						},
						afterTitle: helpers.noop,

						// Args are: (tooltipItems, data)
						beforeBody: helpers.noop,

						// Args are: (tooltipItem, data)
						beforeLabel: helpers.noop,
						label: function label(tooltipItem, data) {
							var label = data.datasets[tooltipItem.datasetIndex].label || '';

							if (label) {
								label += ': ';
							}
							label += tooltipItem.yLabel;
							return label;
						},
						labelColor: function labelColor(tooltipItem, chart) {
							var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
							var activeElement = meta.data[tooltipItem.index];
							var view = activeElement._view;
							return {
								borderColor: view.borderColor,
								backgroundColor: view.backgroundColor
							};
						},
						labelTextColor: function labelTextColor() {
							return this._options.bodyFontColor;
						},
						afterLabel: helpers.noop,

						// Args are: (tooltipItems, data)
						afterBody: helpers.noop,

						// Args are: (tooltipItems, data)
						beforeFooter: helpers.noop,
						footer: helpers.noop,
						afterFooter: helpers.noop
					}
				}
			});

			module.exports = function (Chart) {

				/**
    	 * Helper method to merge the opacity into a color
    	 */
				function mergeOpacity(colorString, opacity) {
					var color = helpers.color(colorString);
					return color.alpha(opacity * color.alpha()).rgbaString();
				}

				// Helper to push or concat based on if the 2nd parameter is an array or not
				function pushOrConcat(base, toPush) {
					if (toPush) {
						if (helpers.isArray(toPush)) {
							// base = base.concat(toPush);
							Array.prototype.push.apply(base, toPush);
						} else {
							base.push(toPush);
						}
					}

					return base;
				}

				// Private helper to create a tooltip item model
				// @param element : the chart element (point, arc, bar) to create the tooltip item for
				// @return : new tooltip item
				function createTooltipItem(element) {
					var xScale = element._xScale;
					var yScale = element._yScale || element._scale; // handle radar || polarArea charts
					var index = element._index;
					var datasetIndex = element._datasetIndex;

					return {
						xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
						yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
						index: index,
						datasetIndex: datasetIndex,
						x: element._model.x,
						y: element._model.y
					};
				}

				/**
     * Helper to get the reset model for the tooltip
     * @param tooltipOpts {Object} the tooltip options
     */
				function getBaseModel(tooltipOpts) {
					var globalDefaults = defaults.global;
					var valueOrDefault = helpers.valueOrDefault;

					return {
						// Positioning
						xPadding: tooltipOpts.xPadding,
						yPadding: tooltipOpts.yPadding,
						xAlign: tooltipOpts.xAlign,
						yAlign: tooltipOpts.yAlign,

						// Body
						bodyFontColor: tooltipOpts.bodyFontColor,
						_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
						_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
						_bodyAlign: tooltipOpts.bodyAlign,
						bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
						bodySpacing: tooltipOpts.bodySpacing,

						// Title
						titleFontColor: tooltipOpts.titleFontColor,
						_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
						_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
						titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
						_titleAlign: tooltipOpts.titleAlign,
						titleSpacing: tooltipOpts.titleSpacing,
						titleMarginBottom: tooltipOpts.titleMarginBottom,

						// Footer
						footerFontColor: tooltipOpts.footerFontColor,
						_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
						_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
						footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
						_footerAlign: tooltipOpts.footerAlign,
						footerSpacing: tooltipOpts.footerSpacing,
						footerMarginTop: tooltipOpts.footerMarginTop,

						// Appearance
						caretSize: tooltipOpts.caretSize,
						cornerRadius: tooltipOpts.cornerRadius,
						backgroundColor: tooltipOpts.backgroundColor,
						opacity: 0,
						legendColorBackground: tooltipOpts.multiKeyBackground,
						displayColors: tooltipOpts.displayColors,
						borderColor: tooltipOpts.borderColor,
						borderWidth: tooltipOpts.borderWidth
					};
				}

				/**
     * Get the size of the tooltip
     */
				function getTooltipSize(tooltip, model) {
					var ctx = tooltip._chart.ctx;

					var height = model.yPadding * 2; // Tooltip Padding
					var width = 0;

					// Count of all lines in the body
					var body = model.body;
					var combinedBodyLength = body.reduce(function (count, bodyItem) {
						return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
					}, 0);
					combinedBodyLength += model.beforeBody.length + model.afterBody.length;

					var titleLineCount = model.title.length;
					var footerLineCount = model.footer.length;
					var titleFontSize = model.titleFontSize;
					var bodyFontSize = model.bodyFontSize;
					var footerFontSize = model.footerFontSize;

					height += titleLineCount * titleFontSize; // Title Lines
					height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
					height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
					height += combinedBodyLength * bodyFontSize; // Body Lines
					height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
					height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
					height += footerLineCount * footerFontSize; // Footer Lines
					height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

					// Title width
					var widthPadding = 0;
					var maxLineWidth = function maxLineWidth(line) {
						width = Math.max(width, ctx.measureText(line).width + widthPadding);
					};

					ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
					helpers.each(model.title, maxLineWidth);

					// Body width
					ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
					helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

					// Body lines may include some extra width due to the color box
					widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
					helpers.each(body, function (bodyItem) {
						helpers.each(bodyItem.before, maxLineWidth);
						helpers.each(bodyItem.lines, maxLineWidth);
						helpers.each(bodyItem.after, maxLineWidth);
					});

					// Reset back to 0
					widthPadding = 0;

					// Footer width
					ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
					helpers.each(model.footer, maxLineWidth);

					// Add padding
					width += 2 * model.xPadding;

					return {
						width: width,
						height: height
					};
				}

				/**
     * Helper to get the alignment of a tooltip given the size
     */
				function determineAlignment(tooltip, size) {
					var model = tooltip._model;
					var chart = tooltip._chart;
					var chartArea = tooltip._chart.chartArea;
					var xAlign = 'center';
					var yAlign = 'center';

					if (model.y < size.height) {
						yAlign = 'top';
					} else if (model.y > chart.height - size.height) {
						yAlign = 'bottom';
					}

					var lf, rf; // functions to determine left, right alignment
					var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
					var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
					var midX = (chartArea.left + chartArea.right) / 2;
					var midY = (chartArea.top + chartArea.bottom) / 2;

					if (yAlign === 'center') {
						lf = function lf(x) {
							return x <= midX;
						};
						rf = function rf(x) {
							return x > midX;
						};
					} else {
						lf = function lf(x) {
							return x <= size.width / 2;
						};
						rf = function rf(x) {
							return x >= chart.width - size.width / 2;
						};
					}

					olf = function olf(x) {
						return x + size.width + model.caretSize + model.caretPadding > chart.width;
					};
					orf = function orf(x) {
						return x - size.width - model.caretSize - model.caretPadding < 0;
					};
					yf = function yf(y) {
						return y <= midY ? 'top' : 'bottom';
					};

					if (lf(model.x)) {
						xAlign = 'left';

						// Is tooltip too wide and goes over the right side of the chart.?
						if (olf(model.x)) {
							xAlign = 'center';
							yAlign = yf(model.y);
						}
					} else if (rf(model.x)) {
						xAlign = 'right';

						// Is tooltip too wide and goes outside left edge of canvas?
						if (orf(model.x)) {
							xAlign = 'center';
							yAlign = yf(model.y);
						}
					}

					var opts = tooltip._options;
					return {
						xAlign: opts.xAlign ? opts.xAlign : xAlign,
						yAlign: opts.yAlign ? opts.yAlign : yAlign
					};
				}

				/**
     * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
     */
				function getBackgroundPoint(vm, size, alignment, chart) {
					// Background Position
					var x = vm.x;
					var y = vm.y;

					var caretSize = vm.caretSize;
					var caretPadding = vm.caretPadding;
					var cornerRadius = vm.cornerRadius;
					var xAlign = alignment.xAlign;
					var yAlign = alignment.yAlign;
					var paddingAndSize = caretSize + caretPadding;
					var radiusAndPadding = cornerRadius + caretPadding;

					if (xAlign === 'right') {
						x -= size.width;
					} else if (xAlign === 'center') {
						x -= size.width / 2;
						if (x + size.width > chart.width) {
							x = chart.width - size.width;
						}
						if (x < 0) {
							x = 0;
						}
					}

					if (yAlign === 'top') {
						y += paddingAndSize;
					} else if (yAlign === 'bottom') {
						y -= size.height + paddingAndSize;
					} else {
						y -= size.height / 2;
					}

					if (yAlign === 'center') {
						if (xAlign === 'left') {
							x += paddingAndSize;
						} else if (xAlign === 'right') {
							x -= paddingAndSize;
						}
					} else if (xAlign === 'left') {
						x -= radiusAndPadding;
					} else if (xAlign === 'right') {
						x += radiusAndPadding;
					}

					return {
						x: x,
						y: y
					};
				}

				Chart.Tooltip = Element.extend({
					initialize: function initialize() {
						this._model = getBaseModel(this._options);
						this._lastActive = [];
					},

					// Get the title
					// Args are: (tooltipItem, data)
					getTitle: function getTitle() {
						var me = this;
						var opts = me._options;
						var callbacks = opts.callbacks;

						var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
						var title = callbacks.title.apply(me, arguments);
						var afterTitle = callbacks.afterTitle.apply(me, arguments);

						var lines = [];
						lines = pushOrConcat(lines, beforeTitle);
						lines = pushOrConcat(lines, title);
						lines = pushOrConcat(lines, afterTitle);

						return lines;
					},

					// Args are: (tooltipItem, data)
					getBeforeBody: function getBeforeBody() {
						var lines = this._options.callbacks.beforeBody.apply(this, arguments);
						return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
					},

					// Args are: (tooltipItem, data)
					getBody: function getBody(tooltipItems, data) {
						var me = this;
						var callbacks = me._options.callbacks;
						var bodyItems = [];

						helpers.each(tooltipItems, function (tooltipItem) {
							var bodyItem = {
								before: [],
								lines: [],
								after: []
							};
							pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
							pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
							pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));

							bodyItems.push(bodyItem);
						});

						return bodyItems;
					},

					// Args are: (tooltipItem, data)
					getAfterBody: function getAfterBody() {
						var lines = this._options.callbacks.afterBody.apply(this, arguments);
						return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
					},

					// Get the footer and beforeFooter and afterFooter lines
					// Args are: (tooltipItem, data)
					getFooter: function getFooter() {
						var me = this;
						var callbacks = me._options.callbacks;

						var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
						var footer = callbacks.footer.apply(me, arguments);
						var afterFooter = callbacks.afterFooter.apply(me, arguments);

						var lines = [];
						lines = pushOrConcat(lines, beforeFooter);
						lines = pushOrConcat(lines, footer);
						lines = pushOrConcat(lines, afterFooter);

						return lines;
					},

					update: function update(changed) {
						var me = this;
						var opts = me._options;

						// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
						// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
						// which breaks any animations.
						var existingModel = me._model;
						var model = me._model = getBaseModel(opts);
						var active = me._active;

						var data = me._data;

						// In the case where active.length === 0 we need to keep these at existing values for good animations
						var alignment = {
							xAlign: existingModel.xAlign,
							yAlign: existingModel.yAlign
						};
						var backgroundPoint = {
							x: existingModel.x,
							y: existingModel.y
						};
						var tooltipSize = {
							width: existingModel.width,
							height: existingModel.height
						};
						var tooltipPosition = {
							x: existingModel.caretX,
							y: existingModel.caretY
						};

						var i, len;

						if (active.length) {
							model.opacity = 1;

							var labelColors = [];
							var labelTextColors = [];
							tooltipPosition = Chart.Tooltip.positioners[opts.position].call(me, active, me._eventPosition);

							var tooltipItems = [];
							for (i = 0, len = active.length; i < len; ++i) {
								tooltipItems.push(createTooltipItem(active[i]));
							}

							// If the user provided a filter function, use it to modify the tooltip items
							if (opts.filter) {
								tooltipItems = tooltipItems.filter(function (a) {
									return opts.filter(a, data);
								});
							}

							// If the user provided a sorting function, use it to modify the tooltip items
							if (opts.itemSort) {
								tooltipItems = tooltipItems.sort(function (a, b) {
									return opts.itemSort(a, b, data);
								});
							}

							// Determine colors for boxes
							helpers.each(tooltipItems, function (tooltipItem) {
								labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
								labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
							});

							// Build the Text Lines
							model.title = me.getTitle(tooltipItems, data);
							model.beforeBody = me.getBeforeBody(tooltipItems, data);
							model.body = me.getBody(tooltipItems, data);
							model.afterBody = me.getAfterBody(tooltipItems, data);
							model.footer = me.getFooter(tooltipItems, data);

							// Initial positioning and colors
							model.x = Math.round(tooltipPosition.x);
							model.y = Math.round(tooltipPosition.y);
							model.caretPadding = opts.caretPadding;
							model.labelColors = labelColors;
							model.labelTextColors = labelTextColors;

							// data points
							model.dataPoints = tooltipItems;

							// We need to determine alignment of the tooltip
							tooltipSize = getTooltipSize(this, model);
							alignment = determineAlignment(this, tooltipSize);
							// Final Size and Position
							backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
						} else {
							model.opacity = 0;
						}

						model.xAlign = alignment.xAlign;
						model.yAlign = alignment.yAlign;
						model.x = backgroundPoint.x;
						model.y = backgroundPoint.y;
						model.width = tooltipSize.width;
						model.height = tooltipSize.height;

						// Point where the caret on the tooltip points to
						model.caretX = tooltipPosition.x;
						model.caretY = tooltipPosition.y;

						me._model = model;

						if (changed && opts.custom) {
							opts.custom.call(me, model);
						}

						return me;
					},
					drawCaret: function drawCaret(tooltipPoint, size) {
						var ctx = this._chart.ctx;
						var vm = this._view;
						var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

						ctx.lineTo(caretPosition.x1, caretPosition.y1);
						ctx.lineTo(caretPosition.x2, caretPosition.y2);
						ctx.lineTo(caretPosition.x3, caretPosition.y3);
					},
					getCaretPosition: function getCaretPosition(tooltipPoint, size, vm) {
						var x1, x2, x3, y1, y2, y3;
						var caretSize = vm.caretSize;
						var cornerRadius = vm.cornerRadius;
						var xAlign = vm.xAlign;
						var yAlign = vm.yAlign;
						var ptX = tooltipPoint.x;
						var ptY = tooltipPoint.y;
						var width = size.width;
						var height = size.height;

						if (yAlign === 'center') {
							y2 = ptY + height / 2;

							if (xAlign === 'left') {
								x1 = ptX;
								x2 = x1 - caretSize;
								x3 = x1;

								y1 = y2 + caretSize;
								y3 = y2 - caretSize;
							} else {
								x1 = ptX + width;
								x2 = x1 + caretSize;
								x3 = x1;

								y1 = y2 - caretSize;
								y3 = y2 + caretSize;
							}
						} else {
							if (xAlign === 'left') {
								x2 = ptX + cornerRadius + caretSize;
								x1 = x2 - caretSize;
								x3 = x2 + caretSize;
							} else if (xAlign === 'right') {
								x2 = ptX + width - cornerRadius - caretSize;
								x1 = x2 - caretSize;
								x3 = x2 + caretSize;
							} else {
								x2 = vm.caretX;
								x1 = x2 - caretSize;
								x3 = x2 + caretSize;
							}
							if (yAlign === 'top') {
								y1 = ptY;
								y2 = y1 - caretSize;
								y3 = y1;
							} else {
								y1 = ptY + height;
								y2 = y1 + caretSize;
								y3 = y1;
								// invert drawing order
								var tmp = x3;
								x3 = x1;
								x1 = tmp;
							}
						}
						return { x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3 };
					},
					drawTitle: function drawTitle(pt, vm, ctx, opacity) {
						var title = vm.title;

						if (title.length) {
							ctx.textAlign = vm._titleAlign;
							ctx.textBaseline = 'top';

							var titleFontSize = vm.titleFontSize;
							var titleSpacing = vm.titleSpacing;

							ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
							ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

							var i, len;
							for (i = 0, len = title.length; i < len; ++i) {
								ctx.fillText(title[i], pt.x, pt.y);
								pt.y += titleFontSize + titleSpacing; // Line Height and spacing

								if (i + 1 === title.length) {
									pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
								}
							}
						}
					},
					drawBody: function drawBody(pt, vm, ctx, opacity) {
						var bodyFontSize = vm.bodyFontSize;
						var bodySpacing = vm.bodySpacing;
						var body = vm.body;

						ctx.textAlign = vm._bodyAlign;
						ctx.textBaseline = 'top';
						ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

						// Before Body
						var xLinePadding = 0;
						var fillLineOfText = function fillLineOfText(line) {
							ctx.fillText(line, pt.x + xLinePadding, pt.y);
							pt.y += bodyFontSize + bodySpacing;
						};

						// Before body lines
						ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
						helpers.each(vm.beforeBody, fillLineOfText);

						var drawColorBoxes = vm.displayColors;
						xLinePadding = drawColorBoxes ? bodyFontSize + 2 : 0;

						// Draw body lines now
						helpers.each(body, function (bodyItem, i) {
							var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
							ctx.fillStyle = textColor;
							helpers.each(bodyItem.before, fillLineOfText);

							helpers.each(bodyItem.lines, function (line) {
								// Draw Legend-like boxes if needed
								if (drawColorBoxes) {
									// Fill a white rect so that colours merge nicely if the opacity is < 1
									ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
									ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

									// Border
									ctx.lineWidth = 1;
									ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
									ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

									// Inner square
									ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
									ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
									ctx.fillStyle = textColor;
								}

								fillLineOfText(line);
							});

							helpers.each(bodyItem.after, fillLineOfText);
						});

						// Reset back to 0 for after body
						xLinePadding = 0;

						// After body lines
						helpers.each(vm.afterBody, fillLineOfText);
						pt.y -= bodySpacing; // Remove last body spacing
					},
					drawFooter: function drawFooter(pt, vm, ctx, opacity) {
						var footer = vm.footer;

						if (footer.length) {
							pt.y += vm.footerMarginTop;

							ctx.textAlign = vm._footerAlign;
							ctx.textBaseline = 'top';

							ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
							ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

							helpers.each(footer, function (line) {
								ctx.fillText(line, pt.x, pt.y);
								pt.y += vm.footerFontSize + vm.footerSpacing;
							});
						}
					},
					drawBackground: function drawBackground(pt, vm, ctx, tooltipSize, opacity) {
						ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
						ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
						ctx.lineWidth = vm.borderWidth;
						var xAlign = vm.xAlign;
						var yAlign = vm.yAlign;
						var x = pt.x;
						var y = pt.y;
						var width = tooltipSize.width;
						var height = tooltipSize.height;
						var radius = vm.cornerRadius;

						ctx.beginPath();
						ctx.moveTo(x + radius, y);
						if (yAlign === 'top') {
							this.drawCaret(pt, tooltipSize);
						}
						ctx.lineTo(x + width - radius, y);
						ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
						if (yAlign === 'center' && xAlign === 'right') {
							this.drawCaret(pt, tooltipSize);
						}
						ctx.lineTo(x + width, y + height - radius);
						ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
						if (yAlign === 'bottom') {
							this.drawCaret(pt, tooltipSize);
						}
						ctx.lineTo(x + radius, y + height);
						ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
						if (yAlign === 'center' && xAlign === 'left') {
							this.drawCaret(pt, tooltipSize);
						}
						ctx.lineTo(x, y + radius);
						ctx.quadraticCurveTo(x, y, x + radius, y);
						ctx.closePath();

						ctx.fill();

						if (vm.borderWidth > 0) {
							ctx.stroke();
						}
					},
					draw: function draw() {
						var ctx = this._chart.ctx;
						var vm = this._view;

						if (vm.opacity === 0) {
							return;
						}

						var tooltipSize = {
							width: vm.width,
							height: vm.height
						};
						var pt = {
							x: vm.x,
							y: vm.y
						};

						// IE11/Edge does not like very small opacities, so snap to 0
						var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

						// Truthy/falsey value for empty tooltip
						var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

						if (this._options.enabled && hasTooltipContent) {
							// Draw Background
							this.drawBackground(pt, vm, ctx, tooltipSize, opacity);

							// Draw Title, Body, and Footer
							pt.x += vm.xPadding;
							pt.y += vm.yPadding;

							// Titles
							this.drawTitle(pt, vm, ctx, opacity);

							// Body
							this.drawBody(pt, vm, ctx, opacity);

							// Footer
							this.drawFooter(pt, vm, ctx, opacity);
						}
					},

					/**
      * Handle an event
      * @private
      * @param {IEvent} event - The event to handle
      * @returns {Boolean} true if the tooltip changed
      */
					handleEvent: function handleEvent(e) {
						var me = this;
						var options = me._options;
						var changed = false;

						me._lastActive = me._lastActive || [];

						// Find Active Elements for tooltips
						if (e.type === 'mouseout') {
							me._active = [];
						} else {
							me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
						}

						// Remember Last Actives
						changed = !helpers.arrayEquals(me._active, me._lastActive);

						// Only handle target event on tooltip change
						if (changed) {
							me._lastActive = me._active;

							if (options.enabled || options.custom) {
								me._eventPosition = {
									x: e.x,
									y: e.y
								};

								me.update(true);
								me.pivot();
							}
						}

						return changed;
					}
				});

				/**
     * @namespace Chart.Tooltip.positioners
     */
				Chart.Tooltip.positioners = {
					/**
      * Average mode places the tooltip at the average position of the elements shown
      * @function Chart.Tooltip.positioners.average
      * @param elements {ChartElement[]} the elements being displayed in the tooltip
      * @returns {Point} tooltip position
      */
					average: function average(elements) {
						if (!elements.length) {
							return false;
						}

						var i, len;
						var x = 0;
						var y = 0;
						var count = 0;

						for (i = 0, len = elements.length; i < len; ++i) {
							var el = elements[i];
							if (el && el.hasValue()) {
								var pos = el.tooltipPosition();
								x += pos.x;
								y += pos.y;
								++count;
							}
						}

						return {
							x: Math.round(x / count),
							y: Math.round(y / count)
						};
					},

					/**
      * Gets the tooltip position nearest of the item nearest to the event position
      * @function Chart.Tooltip.positioners.nearest
      * @param elements {Chart.Element[]} the tooltip elements
      * @param eventPosition {Point} the position of the event in canvas coordinates
      * @returns {Point} the tooltip position
      */
					nearest: function nearest(elements, eventPosition) {
						var x = eventPosition.x;
						var y = eventPosition.y;
						var minDistance = Number.POSITIVE_INFINITY;
						var i, len, nearestElement;

						for (i = 0, len = elements.length; i < len; ++i) {
							var el = elements[i];
							if (el && el.hasValue()) {
								var center = el.getCenterPoint();
								var d = helpers.distanceBetweenPoints(eventPosition, center);

								if (d < minDistance) {
									minDistance = d;
									nearestElement = el;
								}
							}
						}

						if (nearestElement) {
							var tp = nearestElement.tooltipPosition();
							x = tp.x;
							y = tp.y;
						}

						return {
							x: x,
							y: y
						};
					}
				};
			};
		}, { "25": 25, "26": 26, "45": 45 }], 36: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var Element = require(26);
			var helpers = require(45);

			defaults._set('global', {
				elements: {
					arc: {
						backgroundColor: defaults.global.defaultColor,
						borderColor: '#fff',
						borderWidth: 2
					}
				}
			});

			module.exports = Element.extend({
				inLabelRange: function inLabelRange(mouseX) {
					var vm = this._view;

					if (vm) {
						return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
					}
					return false;
				},

				inRange: function inRange(chartX, chartY) {
					var vm = this._view;

					if (vm) {
						var pointRelativePosition = helpers.getAngleFromPoint(vm, { x: chartX, y: chartY });
						var angle = pointRelativePosition.angle;
						var distance = pointRelativePosition.distance;

						// Sanitise angle range
						var startAngle = vm.startAngle;
						var endAngle = vm.endAngle;
						while (endAngle < startAngle) {
							endAngle += 2.0 * Math.PI;
						}
						while (angle > endAngle) {
							angle -= 2.0 * Math.PI;
						}
						while (angle < startAngle) {
							angle += 2.0 * Math.PI;
						}

						// Check if within the range of the open/close angle
						var betweenAngles = angle >= startAngle && angle <= endAngle;
						var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;

						return betweenAngles && withinRadius;
					}
					return false;
				},

				getCenterPoint: function getCenterPoint() {
					var vm = this._view;
					var halfAngle = (vm.startAngle + vm.endAngle) / 2;
					var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
					return {
						x: vm.x + Math.cos(halfAngle) * halfRadius,
						y: vm.y + Math.sin(halfAngle) * halfRadius
					};
				},

				getArea: function getArea() {
					var vm = this._view;
					return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
				},

				tooltipPosition: function tooltipPosition() {
					var vm = this._view;
					var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
					var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

					return {
						x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
						y: vm.y + Math.sin(centreAngle) * rangeFromCentre
					};
				},

				draw: function draw() {
					var ctx = this._chart.ctx;
					var vm = this._view;
					var sA = vm.startAngle;
					var eA = vm.endAngle;

					ctx.beginPath();

					ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
					ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);

					ctx.closePath();
					ctx.strokeStyle = vm.borderColor;
					ctx.lineWidth = vm.borderWidth;

					ctx.fillStyle = vm.backgroundColor;

					ctx.fill();
					ctx.lineJoin = 'bevel';

					if (vm.borderWidth) {
						ctx.stroke();
					}
				}
			});
		}, { "25": 25, "26": 26, "45": 45 }], 37: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var Element = require(26);
			var helpers = require(45);

			var globalDefaults = defaults.global;

			defaults._set('global', {
				elements: {
					line: {
						tension: 0.4,
						backgroundColor: globalDefaults.defaultColor,
						borderWidth: 3,
						borderColor: globalDefaults.defaultColor,
						borderCapStyle: 'butt',
						borderDash: [],
						borderDashOffset: 0.0,
						borderJoinStyle: 'miter',
						capBezierPoints: true,
						fill: true // do we fill in the area between the line and its base axis
					}
				}
			});

			module.exports = Element.extend({
				draw: function draw() {
					var me = this;
					var vm = me._view;
					var ctx = me._chart.ctx;
					var spanGaps = vm.spanGaps;
					var points = me._children.slice(); // clone array
					var globalOptionLineElements = globalDefaults.elements.line;
					var lastDrawnIndex = -1;
					var index, current, previous, currentVM;

					// If we are looping, adding the first point again
					if (me._loop && points.length) {
						points.push(points[0]);
					}

					ctx.save();

					// Stroke Line Options
					ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

					// IE 9 and 10 do not support line dash
					if (ctx.setLineDash) {
						ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
					}

					ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
					ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
					ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
					ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

					// Stroke Line
					ctx.beginPath();
					lastDrawnIndex = -1;

					for (index = 0; index < points.length; ++index) {
						current = points[index];
						previous = helpers.previousItem(points, index);
						currentVM = current._view;

						// First point moves to it's starting position no matter what
						if (index === 0) {
							if (!currentVM.skip) {
								ctx.moveTo(currentVM.x, currentVM.y);
								lastDrawnIndex = index;
							}
						} else {
							previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

							if (!currentVM.skip) {
								if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) {
									// There was a gap and this is the first point after the gap
									ctx.moveTo(currentVM.x, currentVM.y);
								} else {
									// Line to next point
									helpers.canvas.lineTo(ctx, previous._view, current._view);
								}
								lastDrawnIndex = index;
							}
						}
					}

					ctx.stroke();
					ctx.restore();
				}
			});
		}, { "25": 25, "26": 26, "45": 45 }], 38: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var Element = require(26);
			var helpers = require(45);

			var defaultColor = defaults.global.defaultColor;

			defaults._set('global', {
				elements: {
					point: {
						radius: 3,
						pointStyle: 'circle',
						backgroundColor: defaultColor,
						borderColor: defaultColor,
						borderWidth: 1,
						// Hover
						hitRadius: 1,
						hoverRadius: 4,
						hoverBorderWidth: 1
					}
				}
			});

			function xRange(mouseX) {
				var vm = this._view;
				return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
			}

			function yRange(mouseY) {
				var vm = this._view;
				return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
			}

			module.exports = Element.extend({
				inRange: function inRange(mouseX, mouseY) {
					var vm = this._view;
					return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
				},

				inLabelRange: xRange,
				inXRange: xRange,
				inYRange: yRange,

				getCenterPoint: function getCenterPoint() {
					var vm = this._view;
					return {
						x: vm.x,
						y: vm.y
					};
				},

				getArea: function getArea() {
					return Math.PI * Math.pow(this._view.radius, 2);
				},

				tooltipPosition: function tooltipPosition() {
					var vm = this._view;
					return {
						x: vm.x,
						y: vm.y,
						padding: vm.radius + vm.borderWidth
					};
				},

				draw: function draw(chartArea) {
					var vm = this._view;
					var model = this._model;
					var ctx = this._chart.ctx;
					var pointStyle = vm.pointStyle;
					var radius = vm.radius;
					var x = vm.x;
					var y = vm.y;
					var color = helpers.color;
					var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
					var ratio = 0;

					if (vm.skip) {
						return;
					}

					ctx.strokeStyle = vm.borderColor || defaultColor;
					ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
					ctx.fillStyle = vm.backgroundColor || defaultColor;

					// Cliping for Points.
					// going out from inner charArea?
					if (chartArea !== undefined && (model.x < chartArea.left || chartArea.right * errMargin < model.x || model.y < chartArea.top || chartArea.bottom * errMargin < model.y)) {
						// Point fade out
						if (model.x < chartArea.left) {
							ratio = (x - model.x) / (chartArea.left - model.x);
						} else if (chartArea.right * errMargin < model.x) {
							ratio = (model.x - x) / (model.x - chartArea.right);
						} else if (model.y < chartArea.top) {
							ratio = (y - model.y) / (chartArea.top - model.y);
						} else if (chartArea.bottom * errMargin < model.y) {
							ratio = (model.y - y) / (model.y - chartArea.bottom);
						}
						ratio = Math.round(ratio * 100) / 100;
						ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
						ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
					}

					helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y);
				}
			});
		}, { "25": 25, "26": 26, "45": 45 }], 39: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var Element = require(26);

			defaults._set('global', {
				elements: {
					rectangle: {
						backgroundColor: defaults.global.defaultColor,
						borderColor: defaults.global.defaultColor,
						borderSkipped: 'bottom',
						borderWidth: 0
					}
				}
			});

			function isVertical(bar) {
				return bar._view.width !== undefined;
			}

			/**
    * Helper function to get the bounds of the bar regardless of the orientation
    * @param bar {Chart.Element.Rectangle} the bar
    * @return {Bounds} bounds of the bar
    * @private
    */
			function getBarBounds(bar) {
				var vm = bar._view;
				var x1, x2, y1, y2;

				if (isVertical(bar)) {
					// vertical
					var halfWidth = vm.width / 2;
					x1 = vm.x - halfWidth;
					x2 = vm.x + halfWidth;
					y1 = Math.min(vm.y, vm.base);
					y2 = Math.max(vm.y, vm.base);
				} else {
					// horizontal bar
					var halfHeight = vm.height / 2;
					x1 = Math.min(vm.x, vm.base);
					x2 = Math.max(vm.x, vm.base);
					y1 = vm.y - halfHeight;
					y2 = vm.y + halfHeight;
				}

				return {
					left: x1,
					top: y1,
					right: x2,
					bottom: y2
				};
			}

			module.exports = Element.extend({
				draw: function draw() {
					var ctx = this._chart.ctx;
					var vm = this._view;
					var left, right, top, bottom, signX, signY, borderSkipped;
					var borderWidth = vm.borderWidth;

					if (!vm.horizontal) {
						// bar
						left = vm.x - vm.width / 2;
						right = vm.x + vm.width / 2;
						top = vm.y;
						bottom = vm.base;
						signX = 1;
						signY = bottom > top ? 1 : -1;
						borderSkipped = vm.borderSkipped || 'bottom';
					} else {
						// horizontal bar
						left = vm.base;
						right = vm.x;
						top = vm.y - vm.height / 2;
						bottom = vm.y + vm.height / 2;
						signX = right > left ? 1 : -1;
						signY = 1;
						borderSkipped = vm.borderSkipped || 'left';
					}

					// Canvas doesn't allow us to stroke inside the width so we can
					// adjust the sizes to fit if we're setting a stroke on the line
					if (borderWidth) {
						// borderWidth shold be less than bar width and bar height.
						var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
						borderWidth = borderWidth > barSize ? barSize : borderWidth;
						var halfStroke = borderWidth / 2;
						// Adjust borderWidth when bar top position is near vm.base(zero).
						var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
						var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
						var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
						var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
						// not become a vertical line?
						if (borderLeft !== borderRight) {
							top = borderTop;
							bottom = borderBottom;
						}
						// not become a horizontal line?
						if (borderTop !== borderBottom) {
							left = borderLeft;
							right = borderRight;
						}
					}

					ctx.beginPath();
					ctx.fillStyle = vm.backgroundColor;
					ctx.strokeStyle = vm.borderColor;
					ctx.lineWidth = borderWidth;

					// Corner points, from bottom-left to bottom-right clockwise
					// | 1 2 |
					// | 0 3 |
					var corners = [[left, bottom], [left, top], [right, top], [right, bottom]];

					// Find first (starting) corner with fallback to 'bottom'
					var borders = ['bottom', 'left', 'top', 'right'];
					var startCorner = borders.indexOf(borderSkipped, 0);
					if (startCorner === -1) {
						startCorner = 0;
					}

					function cornerAt(index) {
						return corners[(startCorner + index) % 4];
					}

					// Draw rectangle from 'startCorner'
					var corner = cornerAt(0);
					ctx.moveTo(corner[0], corner[1]);

					for (var i = 1; i < 4; i++) {
						corner = cornerAt(i);
						ctx.lineTo(corner[0], corner[1]);
					}

					ctx.fill();
					if (borderWidth) {
						ctx.stroke();
					}
				},

				height: function height() {
					var vm = this._view;
					return vm.base - vm.y;
				},

				inRange: function inRange(mouseX, mouseY) {
					var inRange = false;

					if (this._view) {
						var bounds = getBarBounds(this);
						inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
					}

					return inRange;
				},

				inLabelRange: function inLabelRange(mouseX, mouseY) {
					var me = this;
					if (!me._view) {
						return false;
					}

					var inRange = false;
					var bounds = getBarBounds(me);

					if (isVertical(me)) {
						inRange = mouseX >= bounds.left && mouseX <= bounds.right;
					} else {
						inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
					}

					return inRange;
				},

				inXRange: function inXRange(mouseX) {
					var bounds = getBarBounds(this);
					return mouseX >= bounds.left && mouseX <= bounds.right;
				},

				inYRange: function inYRange(mouseY) {
					var bounds = getBarBounds(this);
					return mouseY >= bounds.top && mouseY <= bounds.bottom;
				},

				getCenterPoint: function getCenterPoint() {
					var vm = this._view;
					var x, y;
					if (isVertical(this)) {
						x = vm.x;
						y = (vm.y + vm.base) / 2;
					} else {
						x = (vm.x + vm.base) / 2;
						y = vm.y;
					}

					return { x: x, y: y };
				},

				getArea: function getArea() {
					var vm = this._view;
					return vm.width * Math.abs(vm.y - vm.base);
				},

				tooltipPosition: function tooltipPosition() {
					var vm = this._view;
					return {
						x: vm.x,
						y: vm.y
					};
				}
			});
		}, { "25": 25, "26": 26 }], 40: [function (require, module, exports) {
			'use strict';

			module.exports = {};
			module.exports.Arc = require(36);
			module.exports.Line = require(37);
			module.exports.Point = require(38);
			module.exports.Rectangle = require(39);
		}, { "36": 36, "37": 37, "38": 38, "39": 39 }], 41: [function (require, module, exports) {
			'use strict';

			var helpers = require(42);

			/**
    * @namespace Chart.helpers.canvas
    */
			var exports = module.exports = {
				/**
     * Clears the entire canvas associated to the given `chart`.
     * @param {Chart} chart - The chart for which to clear the canvas.
     */
				clear: function clear(chart) {
					chart.ctx.clearRect(0, 0, chart.width, chart.height);
				},

				/**
     * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
     * given size (width, height) and the same `radius` for all corners.
     * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
     * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
     * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
     * @param {Number} width - The rectangle's width.
     * @param {Number} height - The rectangle's height.
     * @param {Number} radius - The rounded amount (in pixels) for the four corners.
     * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
     */
				roundedRect: function roundedRect(ctx, x, y, width, height, radius) {
					if (radius) {
						var rx = Math.min(radius, width / 2);
						var ry = Math.min(radius, height / 2);

						ctx.moveTo(x + rx, y);
						ctx.lineTo(x + width - rx, y);
						ctx.quadraticCurveTo(x + width, y, x + width, y + ry);
						ctx.lineTo(x + width, y + height - ry);
						ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height);
						ctx.lineTo(x + rx, y + height);
						ctx.quadraticCurveTo(x, y + height, x, y + height - ry);
						ctx.lineTo(x, y + ry);
						ctx.quadraticCurveTo(x, y, x + rx, y);
					} else {
						ctx.rect(x, y, width, height);
					}
				},

				drawPoint: function drawPoint(ctx, style, radius, x, y) {
					var type, edgeLength, xOffset, yOffset, height, size;

					if (style && (typeof style === "undefined" ? "undefined" : _typeof(style)) === 'object') {
						type = style.toString();
						if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
							ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
							return;
						}
					}

					if (isNaN(radius) || radius <= 0) {
						return;
					}

					switch (style) {
						// Default includes circle
						default:
							ctx.beginPath();
							ctx.arc(x, y, radius, 0, Math.PI * 2);
							ctx.closePath();
							ctx.fill();
							break;
						case 'triangle':
							ctx.beginPath();
							edgeLength = 3 * radius / Math.sqrt(3);
							height = edgeLength * Math.sqrt(3) / 2;
							ctx.moveTo(x - edgeLength / 2, y + height / 3);
							ctx.lineTo(x + edgeLength / 2, y + height / 3);
							ctx.lineTo(x, y - 2 * height / 3);
							ctx.closePath();
							ctx.fill();
							break;
						case 'rect':
							size = 1 / Math.SQRT2 * radius;
							ctx.beginPath();
							ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
							ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
							break;
						case 'rectRounded':
							var offset = radius / Math.SQRT2;
							var leftX = x - offset;
							var topY = y - offset;
							var sideSize = Math.SQRT2 * radius;
							ctx.beginPath();
							this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius / 2);
							ctx.closePath();
							ctx.fill();
							break;
						case 'rectRot':
							size = 1 / Math.SQRT2 * radius;
							ctx.beginPath();
							ctx.moveTo(x - size, y);
							ctx.lineTo(x, y + size);
							ctx.lineTo(x + size, y);
							ctx.lineTo(x, y - size);
							ctx.closePath();
							ctx.fill();
							break;
						case 'cross':
							ctx.beginPath();
							ctx.moveTo(x, y + radius);
							ctx.lineTo(x, y - radius);
							ctx.moveTo(x - radius, y);
							ctx.lineTo(x + radius, y);
							ctx.closePath();
							break;
						case 'crossRot':
							ctx.beginPath();
							xOffset = Math.cos(Math.PI / 4) * radius;
							yOffset = Math.sin(Math.PI / 4) * radius;
							ctx.moveTo(x - xOffset, y - yOffset);
							ctx.lineTo(x + xOffset, y + yOffset);
							ctx.moveTo(x - xOffset, y + yOffset);
							ctx.lineTo(x + xOffset, y - yOffset);
							ctx.closePath();
							break;
						case 'star':
							ctx.beginPath();
							ctx.moveTo(x, y + radius);
							ctx.lineTo(x, y - radius);
							ctx.moveTo(x - radius, y);
							ctx.lineTo(x + radius, y);
							xOffset = Math.cos(Math.PI / 4) * radius;
							yOffset = Math.sin(Math.PI / 4) * radius;
							ctx.moveTo(x - xOffset, y - yOffset);
							ctx.lineTo(x + xOffset, y + yOffset);
							ctx.moveTo(x - xOffset, y + yOffset);
							ctx.lineTo(x + xOffset, y - yOffset);
							ctx.closePath();
							break;
						case 'line':
							ctx.beginPath();
							ctx.moveTo(x - radius, y);
							ctx.lineTo(x + radius, y);
							ctx.closePath();
							break;
						case 'dash':
							ctx.beginPath();
							ctx.moveTo(x, y);
							ctx.lineTo(x + radius, y);
							ctx.closePath();
							break;
					}

					ctx.stroke();
				},

				clipArea: function clipArea(ctx, area) {
					ctx.save();
					ctx.beginPath();
					ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
					ctx.clip();
				},

				unclipArea: function unclipArea(ctx) {
					ctx.restore();
				},

				lineTo: function lineTo(ctx, previous, target, flip) {
					if (target.steppedLine) {
						if (target.steppedLine === 'after' && !flip || target.steppedLine !== 'after' && flip) {
							ctx.lineTo(previous.x, target.y);
						} else {
							ctx.lineTo(target.x, previous.y);
						}
						ctx.lineTo(target.x, target.y);
						return;
					}

					if (!target.tension) {
						ctx.lineTo(target.x, target.y);
						return;
					}

					ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
				}
			};

			// DEPRECATIONS

			/**
    * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
    * @namespace Chart.helpers.clear
    * @deprecated since version 2.7.0
    * @todo remove at version 3
    * @private
    */
			helpers.clear = exports.clear;

			/**
    * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
    * @namespace Chart.helpers.drawRoundedRectangle
    * @deprecated since version 2.7.0
    * @todo remove at version 3
    * @private
    */
			helpers.drawRoundedRectangle = function (ctx) {
				ctx.beginPath();
				exports.roundedRect.apply(exports, arguments);
				ctx.closePath();
			};
		}, { "42": 42 }], 42: [function (require, module, exports) {
			'use strict';

			/**
    * @namespace Chart.helpers
    */

			var helpers = {
				/**
     * An empty function that can be used, for example, for optional callback.
     */
				noop: function noop() {},

				/**
     * Returns a unique id, sequentially generated from a global variable.
     * @returns {Number}
     * @function
     */
				uid: function () {
					var id = 0;
					return function () {
						return id++;
					};
				}(),

				/**
     * Returns true if `value` is neither null nor undefined, else returns false.
     * @param {*} value - The value to test.
     * @returns {Boolean}
     * @since 2.7.0
     */
				isNullOrUndef: function isNullOrUndef(value) {
					return value === null || typeof value === 'undefined';
				},

				/**
     * Returns true if `value` is an array, else returns false.
     * @param {*} value - The value to test.
     * @returns {Boolean}
     * @function
     */
				isArray: Array.isArray ? Array.isArray : function (value) {
					return Object.prototype.toString.call(value) === '[object Array]';
				},

				/**
     * Returns true if `value` is an object (excluding null), else returns false.
     * @param {*} value - The value to test.
     * @returns {Boolean}
     * @since 2.7.0
     */
				isObject: function isObject(value) {
					return value !== null && Object.prototype.toString.call(value) === '[object Object]';
				},

				/**
     * Returns `value` if defined, else returns `defaultValue`.
     * @param {*} value - The value to return if defined.
     * @param {*} defaultValue - The value to return if `value` is undefined.
     * @returns {*}
     */
				valueOrDefault: function valueOrDefault(value, defaultValue) {
					return typeof value === 'undefined' ? defaultValue : value;
				},

				/**
     * Returns value at the given `index` in array if defined, else returns `defaultValue`.
     * @param {Array} value - The array to lookup for value at `index`.
     * @param {Number} index - The index in `value` to lookup for value.
     * @param {*} defaultValue - The value to return if `value[index]` is undefined.
     * @returns {*}
     */
				valueAtIndexOrDefault: function valueAtIndexOrDefault(value, index, defaultValue) {
					return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
				},

				/**
     * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
     * value returned by `fn`. If `fn` is not a function, this method returns undefined.
     * @param {Function} fn - The function to call.
     * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
     * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
     * @returns {*}
     */
				callback: function callback(fn, args, thisArg) {
					if (fn && typeof fn.call === 'function') {
						return fn.apply(thisArg, args);
					}
				},

				/**
     * Note(SB) for performance sake, this method should only be used when loopable type
     * is unknown or in none intensive code (not called often and small loopable). Else
     * it's preferable to use a regular for() loop and save extra function calls.
     * @param {Object|Array} loopable - The object or array to be iterated.
     * @param {Function} fn - The function to call for each item.
     * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
     * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
     */
				each: function each(loopable, fn, thisArg, reverse) {
					var i, len, keys;
					if (helpers.isArray(loopable)) {
						len = loopable.length;
						if (reverse) {
							for (i = len - 1; i >= 0; i--) {
								fn.call(thisArg, loopable[i], i);
							}
						} else {
							for (i = 0; i < len; i++) {
								fn.call(thisArg, loopable[i], i);
							}
						}
					} else if (helpers.isObject(loopable)) {
						keys = Object.keys(loopable);
						len = keys.length;
						for (i = 0; i < len; i++) {
							fn.call(thisArg, loopable[keys[i]], keys[i]);
						}
					}
				},

				/**
     * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
     * @see http://stackoverflow.com/a/14853974
     * @param {Array} a0 - The array to compare
     * @param {Array} a1 - The array to compare
     * @returns {Boolean}
     */
				arrayEquals: function arrayEquals(a0, a1) {
					var i, ilen, v0, v1;

					if (!a0 || !a1 || a0.length !== a1.length) {
						return false;
					}

					for (i = 0, ilen = a0.length; i < ilen; ++i) {
						v0 = a0[i];
						v1 = a1[i];

						if (v0 instanceof Array && v1 instanceof Array) {
							if (!helpers.arrayEquals(v0, v1)) {
								return false;
							}
						} else if (v0 !== v1) {
							// NOTE: two different object instances will never be equal: {x:20} != {x:20}
							return false;
						}
					}

					return true;
				},

				/**
     * Returns a deep copy of `source` without keeping references on objects and arrays.
     * @param {*} source - The value to clone.
     * @returns {*}
     */
				clone: function clone(source) {
					if (helpers.isArray(source)) {
						return source.map(helpers.clone);
					}

					if (helpers.isObject(source)) {
						var target = {};
						var keys = Object.keys(source);
						var klen = keys.length;
						var k = 0;

						for (; k < klen; ++k) {
							target[keys[k]] = helpers.clone(source[keys[k]]);
						}

						return target;
					}

					return source;
				},

				/**
     * The default merger when Chart.helpers.merge is called without merger option.
     * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
     * @private
     */
				_merger: function _merger(key, target, source, options) {
					var tval = target[key];
					var sval = source[key];

					if (helpers.isObject(tval) && helpers.isObject(sval)) {
						helpers.merge(tval, sval, options);
					} else {
						target[key] = helpers.clone(sval);
					}
				},

				/**
     * Merges source[key] in target[key] only if target[key] is undefined.
     * @private
     */
				_mergerIf: function _mergerIf(key, target, source) {
					var tval = target[key];
					var sval = source[key];

					if (helpers.isObject(tval) && helpers.isObject(sval)) {
						helpers.mergeIf(tval, sval);
					} else if (!target.hasOwnProperty(key)) {
						target[key] = helpers.clone(sval);
					}
				},

				/**
     * Recursively deep copies `source` properties into `target` with the given `options`.
     * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
     * @param {Object} target - The target object in which all sources are merged into.
     * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
     * @param {Object} [options] - Merging options:
     * @param {Function} [options.merger] - The merge method (key, target, source, options)
     * @returns {Object} The `target` object.
     */
				merge: function merge(target, source, options) {
					var sources = helpers.isArray(source) ? source : [source];
					var ilen = sources.length;
					var merge, i, keys, klen, k;

					if (!helpers.isObject(target)) {
						return target;
					}

					options = options || {};
					merge = options.merger || helpers._merger;

					for (i = 0; i < ilen; ++i) {
						source = sources[i];
						if (!helpers.isObject(source)) {
							continue;
						}

						keys = Object.keys(source);
						for (k = 0, klen = keys.length; k < klen; ++k) {
							merge(keys[k], target, source, options);
						}
					}

					return target;
				},

				/**
     * Recursively deep copies `source` properties into `target` *only* if not defined in target.
     * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
     * @param {Object} target - The target object in which all sources are merged into.
     * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
     * @returns {Object} The `target` object.
     */
				mergeIf: function mergeIf(target, source) {
					return helpers.merge(target, source, { merger: helpers._mergerIf });
				},

				/**
     * Applies the contents of two or more objects together into the first object.
     * @param {Object} target - The target object in which all objects are merged into.
     * @param {Object} arg1 - Object containing additional properties to merge in target.
     * @param {Object} argN - Additional objects containing properties to merge in target.
     * @returns {Object} The `target` object.
     */
				extend: function extend(target) {
					var setFn = function setFn(value, key) {
						target[key] = value;
					};
					for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
						helpers.each(arguments[i], setFn);
					}
					return target;
				},

				/**
     * Basic javascript inheritance based on the model created in Backbone.js
     */
				inherits: function inherits(extensions) {
					var me = this;
					var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function () {
						return me.apply(this, arguments);
					};

					var Surrogate = function Surrogate() {
						this.constructor = ChartElement;
					};

					Surrogate.prototype = me.prototype;
					ChartElement.prototype = new Surrogate();
					ChartElement.extend = helpers.inherits;

					if (extensions) {
						helpers.extend(ChartElement.prototype, extensions);
					}

					ChartElement.__super__ = me.prototype;
					return ChartElement;
				}
			};

			module.exports = helpers;

			// DEPRECATIONS

			/**
    * Provided for backward compatibility, use Chart.helpers.callback instead.
    * @function Chart.helpers.callCallback
    * @deprecated since version 2.6.0
    * @todo remove at version 3
    * @private
    */
			helpers.callCallback = helpers.callback;

			/**
    * Provided for backward compatibility, use Array.prototype.indexOf instead.
    * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
    * @function Chart.helpers.indexOf
    * @deprecated since version 2.7.0
    * @todo remove at version 3
    * @private
    */
			helpers.indexOf = function (array, item, fromIndex) {
				return Array.prototype.indexOf.call(array, item, fromIndex);
			};

			/**
    * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
    * @function Chart.helpers.getValueOrDefault
    * @deprecated since version 2.7.0
    * @todo remove at version 3
    * @private
    */
			helpers.getValueOrDefault = helpers.valueOrDefault;

			/**
    * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
    * @function Chart.helpers.getValueAtIndexOrDefault
    * @deprecated since version 2.7.0
    * @todo remove at version 3
    * @private
    */
			helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
		}, {}], 43: [function (require, module, exports) {
			'use strict';

			var helpers = require(42);

			/**
    * Easing functions adapted from Robert Penner's easing equations.
    * @namespace Chart.helpers.easingEffects
    * @see http://www.robertpenner.com/easing/
    */
			var effects = {
				linear: function linear(t) {
					return t;
				},

				easeInQuad: function easeInQuad(t) {
					return t * t;
				},

				easeOutQuad: function easeOutQuad(t) {
					return -t * (t - 2);
				},

				easeInOutQuad: function easeInOutQuad(t) {
					if ((t /= 0.5) < 1) {
						return 0.5 * t * t;
					}
					return -0.5 * (--t * (t - 2) - 1);
				},

				easeInCubic: function easeInCubic(t) {
					return t * t * t;
				},

				easeOutCubic: function easeOutCubic(t) {
					return (t = t - 1) * t * t + 1;
				},

				easeInOutCubic: function easeInOutCubic(t) {
					if ((t /= 0.5) < 1) {
						return 0.5 * t * t * t;
					}
					return 0.5 * ((t -= 2) * t * t + 2);
				},

				easeInQuart: function easeInQuart(t) {
					return t * t * t * t;
				},

				easeOutQuart: function easeOutQuart(t) {
					return -((t = t - 1) * t * t * t - 1);
				},

				easeInOutQuart: function easeInOutQuart(t) {
					if ((t /= 0.5) < 1) {
						return 0.5 * t * t * t * t;
					}
					return -0.5 * ((t -= 2) * t * t * t - 2);
				},

				easeInQuint: function easeInQuint(t) {
					return t * t * t * t * t;
				},

				easeOutQuint: function easeOutQuint(t) {
					return (t = t - 1) * t * t * t * t + 1;
				},

				easeInOutQuint: function easeInOutQuint(t) {
					if ((t /= 0.5) < 1) {
						return 0.5 * t * t * t * t * t;
					}
					return 0.5 * ((t -= 2) * t * t * t * t + 2);
				},

				easeInSine: function easeInSine(t) {
					return -Math.cos(t * (Math.PI / 2)) + 1;
				},

				easeOutSine: function easeOutSine(t) {
					return Math.sin(t * (Math.PI / 2));
				},

				easeInOutSine: function easeInOutSine(t) {
					return -0.5 * (Math.cos(Math.PI * t) - 1);
				},

				easeInExpo: function easeInExpo(t) {
					return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
				},

				easeOutExpo: function easeOutExpo(t) {
					return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
				},

				easeInOutExpo: function easeInOutExpo(t) {
					if (t === 0) {
						return 0;
					}
					if (t === 1) {
						return 1;
					}
					if ((t /= 0.5) < 1) {
						return 0.5 * Math.pow(2, 10 * (t - 1));
					}
					return 0.5 * (-Math.pow(2, -10 * --t) + 2);
				},

				easeInCirc: function easeInCirc(t) {
					if (t >= 1) {
						return t;
					}
					return -(Math.sqrt(1 - t * t) - 1);
				},

				easeOutCirc: function easeOutCirc(t) {
					return Math.sqrt(1 - (t = t - 1) * t);
				},

				easeInOutCirc: function easeInOutCirc(t) {
					if ((t /= 0.5) < 1) {
						return -0.5 * (Math.sqrt(1 - t * t) - 1);
					}
					return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
				},

				easeInElastic: function easeInElastic(t) {
					var s = 1.70158;
					var p = 0;
					var a = 1;
					if (t === 0) {
						return 0;
					}
					if (t === 1) {
						return 1;
					}
					if (!p) {
						p = 0.3;
					}
					if (a < 1) {
						a = 1;
						s = p / 4;
					} else {
						s = p / (2 * Math.PI) * Math.asin(1 / a);
					}
					return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
				},

				easeOutElastic: function easeOutElastic(t) {
					var s = 1.70158;
					var p = 0;
					var a = 1;
					if (t === 0) {
						return 0;
					}
					if (t === 1) {
						return 1;
					}
					if (!p) {
						p = 0.3;
					}
					if (a < 1) {
						a = 1;
						s = p / 4;
					} else {
						s = p / (2 * Math.PI) * Math.asin(1 / a);
					}
					return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
				},

				easeInOutElastic: function easeInOutElastic(t) {
					var s = 1.70158;
					var p = 0;
					var a = 1;
					if (t === 0) {
						return 0;
					}
					if ((t /= 0.5) === 2) {
						return 1;
					}
					if (!p) {
						p = 0.45;
					}
					if (a < 1) {
						a = 1;
						s = p / 4;
					} else {
						s = p / (2 * Math.PI) * Math.asin(1 / a);
					}
					if (t < 1) {
						return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
					}
					return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
				},
				easeInBack: function easeInBack(t) {
					var s = 1.70158;
					return t * t * ((s + 1) * t - s);
				},

				easeOutBack: function easeOutBack(t) {
					var s = 1.70158;
					return (t = t - 1) * t * ((s + 1) * t + s) + 1;
				},

				easeInOutBack: function easeInOutBack(t) {
					var s = 1.70158;
					if ((t /= 0.5) < 1) {
						return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
					}
					return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
				},

				easeInBounce: function easeInBounce(t) {
					return 1 - effects.easeOutBounce(1 - t);
				},

				easeOutBounce: function easeOutBounce(t) {
					if (t < 1 / 2.75) {
						return 7.5625 * t * t;
					}
					if (t < 2 / 2.75) {
						return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
					}
					if (t < 2.5 / 2.75) {
						return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
					}
					return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
				},

				easeInOutBounce: function easeInOutBounce(t) {
					if (t < 0.5) {
						return effects.easeInBounce(t * 2) * 0.5;
					}
					return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
				}
			};

			module.exports = {
				effects: effects
			};

			// DEPRECATIONS

			/**
    * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
    * @function Chart.helpers.easingEffects
    * @deprecated since version 2.7.0
    * @todo remove at version 3
    * @private
    */
			helpers.easingEffects = effects;
		}, { "42": 42 }], 44: [function (require, module, exports) {
			'use strict';

			var helpers = require(42);

			/**
    * @alias Chart.helpers.options
    * @namespace
    */
			module.exports = {
				/**
     * Converts the given line height `value` in pixels for a specific font `size`.
     * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
     * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
     * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
     * @since 2.7.0
     */
				toLineHeight: function toLineHeight(value, size) {
					var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
					if (!matches || matches[1] === 'normal') {
						return size * 1.2;
					}

					value = +matches[2];

					switch (matches[3]) {
						case 'px':
							return value;
						case '%':
							value /= 100;
							break;
						default:
							break;
					}

					return size * value;
				},

				/**
     * Converts the given value into a padding object with pre-computed width/height.
     * @param {Number|Object} value - If a number, set the value to all TRBL component,
     *  else, if and object, use defined properties and sets undefined ones to 0.
     * @returns {Object} The padding values (top, right, bottom, left, width, height)
     * @since 2.7.0
     */
				toPadding: function toPadding(value) {
					var t, r, b, l;

					if (helpers.isObject(value)) {
						t = +value.top || 0;
						r = +value.right || 0;
						b = +value.bottom || 0;
						l = +value.left || 0;
					} else {
						t = r = b = l = +value || 0;
					}

					return {
						top: t,
						right: r,
						bottom: b,
						left: l,
						height: t + b,
						width: l + r
					};
				},

				/**
     * Evaluates the given `inputs` sequentially and returns the first defined value.
     * @param {Array[]} inputs - An array of values, falling back to the last value.
     * @param {Object} [context] - If defined and the current value is a function, the value
     * is called with `context` as first argument and the result becomes the new input.
     * @param {Number} [index] - If defined and the current value is an array, the value
     * at `index` become the new input.
     * @since 2.7.0
     */
				resolve: function resolve(inputs, context, index) {
					var i, ilen, value;

					for (i = 0, ilen = inputs.length; i < ilen; ++i) {
						value = inputs[i];
						if (value === undefined) {
							continue;
						}
						if (context !== undefined && typeof value === 'function') {
							value = value(context);
						}
						if (index !== undefined && helpers.isArray(value)) {
							value = value[index];
						}
						if (value !== undefined) {
							return value;
						}
					}
				}
			};
		}, { "42": 42 }], 45: [function (require, module, exports) {
			'use strict';

			module.exports = require(42);
			module.exports.easing = require(43);
			module.exports.canvas = require(41);
			module.exports.options = require(44);
		}, { "41": 41, "42": 42, "43": 43, "44": 44 }], 46: [function (require, module, exports) {
			/**
    * Platform fallback implementation (minimal).
    * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
    */

			module.exports = {
				acquireContext: function acquireContext(item) {
					if (item && item.canvas) {
						// Support for any object associated to a canvas (including a context2d)
						item = item.canvas;
					}

					return item && item.getContext('2d') || null;
				}
			};
		}, {}], 47: [function (require, module, exports) {
			/**
    * Chart.Platform implementation for targeting a web browser
    */

			'use strict';

			var helpers = require(45);

			var EXPANDO_KEY = '$chartjs';
			var CSS_PREFIX = 'chartjs-';
			var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
			var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
			var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

			/**
    * DOM event types -> Chart.js event types.
    * Note: only events with different types are mapped.
    * @see https://developer.mozilla.org/en-US/docs/Web/Events
    */
			var EVENT_TYPES = {
				touchstart: 'mousedown',
				touchmove: 'mousemove',
				touchend: 'mouseup',
				pointerenter: 'mouseenter',
				pointerdown: 'mousedown',
				pointermove: 'mousemove',
				pointerup: 'mouseup',
				pointerleave: 'mouseout',
				pointerout: 'mouseout'
			};

			/**
    * The "used" size is the final value of a dimension property after all calculations have
    * been performed. This method uses the computed style of `element` but returns undefined
    * if the computed style is not expressed in pixels. That can happen in some cases where
    * `element` has a size relative to its parent and this last one is not yet displayed,
    * for example because of `display: none` on a parent node.
    * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
    * @returns {Number} Size in pixels or undefined if unknown.
    */
			function readUsedSize(element, property) {
				var value = helpers.getStyle(element, property);
				var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
				return matches ? Number(matches[1]) : undefined;
			}

			/**
    * Initializes the canvas style and render size without modifying the canvas display size,
    * since responsiveness is handled by the controller.resize() method. The config is used
    * to determine the aspect ratio to apply in case no explicit height has been specified.
    */
			function initCanvas(canvas, config) {
				var style = canvas.style;

				// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
				// returns null or '' if no explicit value has been set to the canvas attribute.
				var renderHeight = canvas.getAttribute('height');
				var renderWidth = canvas.getAttribute('width');

				// Chart.js modifies some canvas values that we want to restore on destroy
				canvas[EXPANDO_KEY] = {
					initial: {
						height: renderHeight,
						width: renderWidth,
						style: {
							display: style.display,
							height: style.height,
							width: style.width
						}
					}
				};

				// Force canvas to display as block to avoid extra space caused by inline
				// elements, which would interfere with the responsive resize process.
				// https://github.com/chartjs/Chart.js/issues/2538
				style.display = style.display || 'block';

				if (renderWidth === null || renderWidth === '') {
					var displayWidth = readUsedSize(canvas, 'width');
					if (displayWidth !== undefined) {
						canvas.width = displayWidth;
					}
				}

				if (renderHeight === null || renderHeight === '') {
					if (canvas.style.height === '') {
						// If no explicit render height and style height, let's apply the aspect ratio,
						// which one can be specified by the user but also by charts as default option
						// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
						canvas.height = canvas.width / (config.options.aspectRatio || 2);
					} else {
						var displayHeight = readUsedSize(canvas, 'height');
						if (displayWidth !== undefined) {
							canvas.height = displayHeight;
						}
					}
				}

				return canvas;
			}

			/**
    * Detects support for options object argument in addEventListener.
    * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    * @private
    */
			var supportsEventListenerOptions = function () {
				var supports = false;
				try {
					var options = Object.defineProperty({}, 'passive', {
						get: function get() {
							supports = true;
						}
					});
					window.addEventListener('e', null, options);
				} catch (e) {
					// continue regardless of error
				}
				return supports;
			}();

			// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
			// https://github.com/chartjs/Chart.js/issues/4287
			var eventListenerOptions = supportsEventListenerOptions ? { passive: true } : false;

			function _addEventListener(node, type, listener) {
				node.addEventListener(type, listener, eventListenerOptions);
			}

			function _removeEventListener(node, type, listener) {
				node.removeEventListener(type, listener, eventListenerOptions);
			}

			function createEvent(type, chart, x, y, nativeEvent) {
				return {
					type: type,
					chart: chart,
					native: nativeEvent || null,
					x: x !== undefined ? x : null,
					y: y !== undefined ? y : null
				};
			}

			function fromNativeEvent(event, chart) {
				var type = EVENT_TYPES[event.type] || event.type;
				var pos = helpers.getRelativePosition(event, chart);
				return createEvent(type, chart, pos.x, pos.y, event);
			}

			function throttled(fn, thisArg) {
				var ticking = false;
				var args = [];

				return function () {
					args = Array.prototype.slice.call(arguments);
					thisArg = thisArg || this;

					if (!ticking) {
						ticking = true;
						helpers.requestAnimFrame.call(window, function () {
							ticking = false;
							fn.apply(thisArg, args);
						});
					}
				};
			}

			// Implementation based on https://github.com/marcj/css-element-queries
			function createResizer(handler) {
				var resizer = document.createElement('div');
				var cls = CSS_PREFIX + 'size-monitor';
				var maxSize = 1000000;
				var style = 'position:absolute;' + 'left:0;' + 'top:0;' + 'right:0;' + 'bottom:0;' + 'overflow:hidden;' + 'pointer-events:none;' + 'visibility:hidden;' + 'z-index:-1;';

				resizer.style.cssText = style;
				resizer.className = cls;
				resizer.innerHTML = '<div class="' + cls + '-expand" style="' + style + '">' + '<div style="' + 'position:absolute;' + 'width:' + maxSize + 'px;' + 'height:' + maxSize + 'px;' + 'left:0;' + 'top:0">' + '</div>' + '</div>' + '<div class="' + cls + '-shrink" style="' + style + '">' + '<div style="' + 'position:absolute;' + 'width:200%;' + 'height:200%;' + 'left:0; ' + 'top:0">' + '</div>' + '</div>';

				var expand = resizer.childNodes[0];
				var shrink = resizer.childNodes[1];

				resizer._reset = function () {
					expand.scrollLeft = maxSize;
					expand.scrollTop = maxSize;
					shrink.scrollLeft = maxSize;
					shrink.scrollTop = maxSize;
				};
				var onScroll = function onScroll() {
					resizer._reset();
					handler();
				};

				_addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
				_addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

				return resizer;
			}

			// https://davidwalsh.name/detect-node-insertion
			function watchForRender(node, handler) {
				var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
				var proxy = expando.renderProxy = function (e) {
					if (e.animationName === CSS_RENDER_ANIMATION) {
						handler();
					}
				};

				helpers.each(ANIMATION_START_EVENTS, function (type) {
					_addEventListener(node, type, proxy);
				});

				// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
				// is removed then added back immediately (same animation frame?). Accessing the
				// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
				// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
				// https://github.com/chartjs/Chart.js/issues/4737
				expando.reflow = !!node.offsetParent;

				node.classList.add(CSS_RENDER_MONITOR);
			}

			function unwatchForRender(node) {
				var expando = node[EXPANDO_KEY] || {};
				var proxy = expando.renderProxy;

				if (proxy) {
					helpers.each(ANIMATION_START_EVENTS, function (type) {
						_removeEventListener(node, type, proxy);
					});

					delete expando.renderProxy;
				}

				node.classList.remove(CSS_RENDER_MONITOR);
			}

			function addResizeListener(node, listener, chart) {
				var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

				// Let's keep track of this added resizer and thus avoid DOM query when removing it.
				var resizer = expando.resizer = createResizer(throttled(function () {
					if (expando.resizer) {
						return listener(createEvent('resize', chart));
					}
				}));

				// The resizer needs to be attached to the node parent, so we first need to be
				// sure that `node` is attached to the DOM before injecting the resizer element.
				watchForRender(node, function () {
					if (expando.resizer) {
						var container = node.parentNode;
						if (container && container !== resizer.parentNode) {
							container.insertBefore(resizer, container.firstChild);
						}

						// The container size might have changed, let's reset the resizer state.
						resizer._reset();
					}
				});
			}

			function removeResizeListener(node) {
				var expando = node[EXPANDO_KEY] || {};
				var resizer = expando.resizer;

				delete expando.resizer;
				unwatchForRender(node);

				if (resizer && resizer.parentNode) {
					resizer.parentNode.removeChild(resizer);
				}
			}

			function injectCSS(platform, css) {
				// http://stackoverflow.com/q/3922139
				var style = platform._style || document.createElement('style');
				if (!platform._style) {
					platform._style = style;
					css = '/* Chart.js */\n' + css;
					style.setAttribute('type', 'text/css');
					document.getElementsByTagName('head')[0].appendChild(style);
				}

				style.appendChild(document.createTextNode(css));
			}

			module.exports = {
				/**
     * This property holds whether this platform is enabled for the current environment.
     * Currently used by platform.js to select the proper implementation.
     * @private
     */
				_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

				initialize: function initialize() {
					var keyframes = 'from{opacity:0.99}to{opacity:1}';

					injectCSS(this,
					// DOM rendering detection
					// https://davidwalsh.name/detect-node-insertion
					'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' + '@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' + '.' + CSS_RENDER_MONITOR + '{' + '-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' + 'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' + '}');
				},

				acquireContext: function acquireContext(item, config) {
					if (typeof item === 'string') {
						item = document.getElementById(item);
					} else if (item.length) {
						// Support for array based queries (such as jQuery)
						item = item[0];
					}

					if (item && item.canvas) {
						// Support for any object associated to a canvas (including a context2d)
						item = item.canvas;
					}

					// To prevent canvas fingerprinting, some add-ons undefine the getContext
					// method, for example: https://github.com/kkapsner/CanvasBlocker
					// https://github.com/chartjs/Chart.js/issues/2807
					var context = item && item.getContext && item.getContext('2d');

					// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
					// inside an iframe or when running in a protected environment. We could guess the
					// types from their toString() value but let's keep things flexible and assume it's
					// a sufficient condition if the item has a context2D which has item as `canvas`.
					// https://github.com/chartjs/Chart.js/issues/3887
					// https://github.com/chartjs/Chart.js/issues/4102
					// https://github.com/chartjs/Chart.js/issues/4152
					if (context && context.canvas === item) {
						initCanvas(item, config);
						return context;
					}

					return null;
				},

				releaseContext: function releaseContext(context) {
					var canvas = context.canvas;
					if (!canvas[EXPANDO_KEY]) {
						return;
					}

					var initial = canvas[EXPANDO_KEY].initial;
					['height', 'width'].forEach(function (prop) {
						var value = initial[prop];
						if (helpers.isNullOrUndef(value)) {
							canvas.removeAttribute(prop);
						} else {
							canvas.setAttribute(prop, value);
						}
					});

					helpers.each(initial.style || {}, function (value, key) {
						canvas.style[key] = value;
					});

					// The canvas render size might have been changed (and thus the state stack discarded),
					// we can't use save() and restore() to restore the initial state. So make sure that at
					// least the canvas context is reset to the default state by setting the canvas width.
					// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
					canvas.width = canvas.width;

					delete canvas[EXPANDO_KEY];
				},

				addEventListener: function addEventListener(chart, type, listener) {
					var canvas = chart.canvas;
					if (type === 'resize') {
						// Note: the resize event is not supported on all browsers.
						addResizeListener(canvas, listener, chart);
						return;
					}

					var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
					var proxies = expando.proxies || (expando.proxies = {});
					var proxy = proxies[chart.id + '_' + type] = function (event) {
						listener(fromNativeEvent(event, chart));
					};

					_addEventListener(canvas, type, proxy);
				},

				removeEventListener: function removeEventListener(chart, type, listener) {
					var canvas = chart.canvas;
					if (type === 'resize') {
						// Note: the resize event is not supported on all browsers.
						removeResizeListener(canvas, listener);
						return;
					}

					var expando = listener[EXPANDO_KEY] || {};
					var proxies = expando.proxies || {};
					var proxy = proxies[chart.id + '_' + type];
					if (!proxy) {
						return;
					}

					_removeEventListener(canvas, type, proxy);
				}
			};

			// DEPRECATIONS

			/**
    * Provided for backward compatibility, use EventTarget.addEventListener instead.
    * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
    * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
    * @function Chart.helpers.addEvent
    * @deprecated since version 2.7.0
    * @todo remove at version 3
    * @private
    */
			helpers.addEvent = _addEventListener;

			/**
    * Provided for backward compatibility, use EventTarget.removeEventListener instead.
    * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
    * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
    * @function Chart.helpers.removeEvent
    * @deprecated since version 2.7.0
    * @todo remove at version 3
    * @private
    */
			helpers.removeEvent = _removeEventListener;
		}, { "45": 45 }], 48: [function (require, module, exports) {
			'use strict';

			var helpers = require(45);
			var basic = require(46);
			var dom = require(47);

			// @TODO Make possible to select another platform at build time.
			var implementation = dom._enabled ? dom : basic;

			/**
    * @namespace Chart.platform
    * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
    * @since 2.4.0
    */
			module.exports = helpers.extend({
				/**
     * @since 2.7.0
     */
				initialize: function initialize() {},

				/**
     * Called at chart construction time, returns a context2d instance implementing
     * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
     * @param {*} item - The native item from which to acquire context (platform specific)
     * @param {Object} options - The chart options
     * @returns {CanvasRenderingContext2D} context2d instance
     */
				acquireContext: function acquireContext() {},

				/**
     * Called at chart destruction time, releases any resources associated to the context
     * previously returned by the acquireContext() method.
     * @param {CanvasRenderingContext2D} context - The context2d instance
     * @returns {Boolean} true if the method succeeded, else false
     */
				releaseContext: function releaseContext() {},

				/**
     * Registers the specified listener on the given chart.
     * @param {Chart} chart - Chart from which to listen for event
     * @param {String} type - The ({@link IEvent}) type to listen for
     * @param {Function} listener - Receives a notification (an object that implements
     * the {@link IEvent} interface) when an event of the specified type occurs.
     */
				addEventListener: function addEventListener() {},

				/**
     * Removes the specified listener previously registered with addEventListener.
     * @param {Chart} chart -Chart from which to remove the listener
     * @param {String} type - The ({@link IEvent}) type to remove
     * @param {Function} listener - The listener function to remove from the event target.
     */
				removeEventListener: function removeEventListener() {}

			}, implementation);

			/**
    * @interface IPlatform
    * Allows abstracting platform dependencies away from the chart
    * @borrows Chart.platform.acquireContext as acquireContext
    * @borrows Chart.platform.releaseContext as releaseContext
    * @borrows Chart.platform.addEventListener as addEventListener
    * @borrows Chart.platform.removeEventListener as removeEventListener
    */

			/**
    * @interface IEvent
    * @prop {String} type - The event type name, possible values are:
    * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
    * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
    * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
    * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
    * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
    */
		}, { "45": 45, "46": 46, "47": 47 }], 49: [function (require, module, exports) {
			'use strict';

			module.exports = {};
			module.exports.filler = require(50);
			module.exports.legend = require(51);
			module.exports.title = require(52);
		}, { "50": 50, "51": 51, "52": 52 }], 50: [function (require, module, exports) {
			/**
    * Plugin based on discussion from the following Chart.js issues:
    * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
    * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
    */

			'use strict';

			var defaults = require(25);
			var elements = require(40);
			var helpers = require(45);

			defaults._set('global', {
				plugins: {
					filler: {
						propagate: true
					}
				}
			});

			var mappers = {
				dataset: function dataset(source) {
					var index = source.fill;
					var chart = source.chart;
					var meta = chart.getDatasetMeta(index);
					var visible = meta && chart.isDatasetVisible(index);
					var points = visible && meta.dataset._children || [];
					var length = points.length || 0;

					return !length ? null : function (point, i) {
						return i < length && points[i]._view || null;
					};
				},

				boundary: function boundary(source) {
					var boundary = source.boundary;
					var x = boundary ? boundary.x : null;
					var y = boundary ? boundary.y : null;

					return function (point) {
						return {
							x: x === null ? point.x : x,
							y: y === null ? point.y : y
						};
					};
				}
			};

			// @todo if (fill[0] === '#')
			function decodeFill(el, index, count) {
				var model = el._model || {};
				var fill = model.fill;
				var target;

				if (fill === undefined) {
					fill = !!model.backgroundColor;
				}

				if (fill === false || fill === null) {
					return false;
				}

				if (fill === true) {
					return 'origin';
				}

				target = parseFloat(fill, 10);
				if (isFinite(target) && Math.floor(target) === target) {
					if (fill[0] === '-' || fill[0] === '+') {
						target = index + target;
					}

					if (target === index || target < 0 || target >= count) {
						return false;
					}

					return target;
				}

				switch (fill) {
					// compatibility
					case 'bottom':
						return 'start';
					case 'top':
						return 'end';
					case 'zero':
						return 'origin';
					// supported boundaries
					case 'origin':
					case 'start':
					case 'end':
						return fill;
					// invalid fill values
					default:
						return false;
				}
			}

			function computeBoundary(source) {
				var model = source.el._model || {};
				var scale = source.el._scale || {};
				var fill = source.fill;
				var target = null;
				var horizontal;

				if (isFinite(fill)) {
					return null;
				}

				// Backward compatibility: until v3, we still need to support boundary values set on
				// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
				// controllers might still use it (e.g. the Smith chart).

				if (fill === 'start') {
					target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
				} else if (fill === 'end') {
					target = model.scaleTop === undefined ? scale.top : model.scaleTop;
				} else if (model.scaleZero !== undefined) {
					target = model.scaleZero;
				} else if (scale.getBasePosition) {
					target = scale.getBasePosition();
				} else if (scale.getBasePixel) {
					target = scale.getBasePixel();
				}

				if (target !== undefined && target !== null) {
					if (target.x !== undefined && target.y !== undefined) {
						return target;
					}

					if (typeof target === 'number' && isFinite(target)) {
						horizontal = scale.isHorizontal();
						return {
							x: horizontal ? target : null,
							y: horizontal ? null : target
						};
					}
				}

				return null;
			}

			function resolveTarget(sources, index, propagate) {
				var source = sources[index];
				var fill = source.fill;
				var visited = [index];
				var target;

				if (!propagate) {
					return fill;
				}

				while (fill !== false && visited.indexOf(fill) === -1) {
					if (!isFinite(fill)) {
						return fill;
					}

					target = sources[fill];
					if (!target) {
						return false;
					}

					if (target.visible) {
						return fill;
					}

					visited.push(fill);
					fill = target.fill;
				}

				return false;
			}

			function createMapper(source) {
				var fill = source.fill;
				var type = 'dataset';

				if (fill === false) {
					return null;
				}

				if (!isFinite(fill)) {
					type = 'boundary';
				}

				return mappers[type](source);
			}

			function isDrawable(point) {
				return point && !point.skip;
			}

			function drawArea(ctx, curve0, curve1, len0, len1) {
				var i;

				if (!len0 || !len1) {
					return;
				}

				// building first area curve (normal)
				ctx.moveTo(curve0[0].x, curve0[0].y);
				for (i = 1; i < len0; ++i) {
					helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
				}

				// joining the two area curves
				ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

				// building opposite area curve (reverse)
				for (i = len1 - 1; i > 0; --i) {
					helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
				}
			}

			function doFill(ctx, points, mapper, view, color, loop) {
				var count = points.length;
				var span = view.spanGaps;
				var curve0 = [];
				var curve1 = [];
				var len0 = 0;
				var len1 = 0;
				var i, ilen, index, p0, p1, d0, d1;

				ctx.beginPath();

				for (i = 0, ilen = count + !!loop; i < ilen; ++i) {
					index = i % count;
					p0 = points[index]._view;
					p1 = mapper(p0, index, view);
					d0 = isDrawable(p0);
					d1 = isDrawable(p1);

					if (d0 && d1) {
						len0 = curve0.push(p0);
						len1 = curve1.push(p1);
					} else if (len0 && len1) {
						if (!span) {
							drawArea(ctx, curve0, curve1, len0, len1);
							len0 = len1 = 0;
							curve0 = [];
							curve1 = [];
						} else {
							if (d0) {
								curve0.push(p0);
							}
							if (d1) {
								curve1.push(p1);
							}
						}
					}
				}

				drawArea(ctx, curve0, curve1, len0, len1);

				ctx.closePath();
				ctx.fillStyle = color;
				ctx.fill();
			}

			module.exports = {
				id: 'filler',

				afterDatasetsUpdate: function afterDatasetsUpdate(chart, options) {
					var count = (chart.data.datasets || []).length;
					var propagate = options.propagate;
					var sources = [];
					var meta, i, el, source;

					for (i = 0; i < count; ++i) {
						meta = chart.getDatasetMeta(i);
						el = meta.dataset;
						source = null;

						if (el && el._model && el instanceof elements.Line) {
							source = {
								visible: chart.isDatasetVisible(i),
								fill: decodeFill(el, i, count),
								chart: chart,
								el: el
							};
						}

						meta.$filler = source;
						sources.push(source);
					}

					for (i = 0; i < count; ++i) {
						source = sources[i];
						if (!source) {
							continue;
						}

						source.fill = resolveTarget(sources, i, propagate);
						source.boundary = computeBoundary(source);
						source.mapper = createMapper(source);
					}
				},

				beforeDatasetDraw: function beforeDatasetDraw(chart, args) {
					var meta = args.meta.$filler;
					if (!meta) {
						return;
					}

					var ctx = chart.ctx;
					var el = meta.el;
					var view = el._view;
					var points = el._children || [];
					var mapper = meta.mapper;
					var color = view.backgroundColor || defaults.global.defaultColor;

					if (mapper && color && points.length) {
						helpers.canvas.clipArea(ctx, chart.chartArea);
						doFill(ctx, points, mapper, view, color, el._loop);
						helpers.canvas.unclipArea(ctx);
					}
				}
			};
		}, { "25": 25, "40": 40, "45": 45 }], 51: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var Element = require(26);
			var helpers = require(45);
			var layouts = require(30);

			var noop = helpers.noop;

			defaults._set('global', {
				legend: {
					display: true,
					position: 'top',
					fullWidth: true,
					reverse: false,
					weight: 1000,

					// a callback that will handle
					onClick: function onClick(e, legendItem) {
						var index = legendItem.datasetIndex;
						var ci = this.chart;
						var meta = ci.getDatasetMeta(index);

						// See controller.isDatasetVisible comment
						meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

						// We hid a dataset ... rerender the chart
						ci.update();
					},

					onHover: null,

					labels: {
						boxWidth: 40,
						padding: 10,
						// Generates labels shown in the legend
						// Valid properties to return:
						// text : text to display
						// fillStyle : fill of coloured box
						// strokeStyle: stroke of coloured box
						// hidden : if this legend item refers to a hidden item
						// lineCap : cap style for line
						// lineDash
						// lineDashOffset :
						// lineJoin :
						// lineWidth :
						generateLabels: function generateLabels(chart) {
							var data = chart.data;
							return helpers.isArray(data.datasets) ? data.datasets.map(function (dataset, i) {
								return {
									text: dataset.label,
									fillStyle: !helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0],
									hidden: !chart.isDatasetVisible(i),
									lineCap: dataset.borderCapStyle,
									lineDash: dataset.borderDash,
									lineDashOffset: dataset.borderDashOffset,
									lineJoin: dataset.borderJoinStyle,
									lineWidth: dataset.borderWidth,
									strokeStyle: dataset.borderColor,
									pointStyle: dataset.pointStyle,

									// Below is extra data used for toggling the datasets
									datasetIndex: i
								};
							}, this) : [];
						}
					}
				},

				legendCallback: function legendCallback(chart) {
					var text = [];
					text.push('<ul class="' + chart.id + '-legend">');
					for (var i = 0; i < chart.data.datasets.length; i++) {
						text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
						if (chart.data.datasets[i].label) {
							text.push(chart.data.datasets[i].label);
						}
						text.push('</li>');
					}
					text.push('</ul>');
					return text.join('');
				}
			});

			/**
    * Helper function to get the box width based on the usePointStyle option
    * @param labelopts {Object} the label options on the legend
    * @param fontSize {Number} the label font size
    * @return {Number} width of the color box area
    */
			function getBoxWidth(labelOpts, fontSize) {
				return labelOpts.usePointStyle ? fontSize * Math.SQRT2 : labelOpts.boxWidth;
			}

			/**
    * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
    */
			var Legend = Element.extend({

				initialize: function initialize(config) {
					helpers.extend(this, config);

					// Contains hit boxes for each dataset (in dataset order)
					this.legendHitBoxes = [];

					// Are we in doughnut mode which has a different data type
					this.doughnutMode = false;
				},

				// These methods are ordered by lifecycle. Utilities then follow.
				// Any function defined here is inherited by all legend types.
				// Any function can be extended by the legend type

				beforeUpdate: noop,
				update: function update(maxWidth, maxHeight, margins) {
					var me = this;

					// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
					me.beforeUpdate();

					// Absorb the master measurements
					me.maxWidth = maxWidth;
					me.maxHeight = maxHeight;
					me.margins = margins;

					// Dimensions
					me.beforeSetDimensions();
					me.setDimensions();
					me.afterSetDimensions();
					// Labels
					me.beforeBuildLabels();
					me.buildLabels();
					me.afterBuildLabels();

					// Fit
					me.beforeFit();
					me.fit();
					me.afterFit();
					//
					me.afterUpdate();

					return me.minSize;
				},
				afterUpdate: noop,

				//

				beforeSetDimensions: noop,
				setDimensions: function setDimensions() {
					var me = this;
					// Set the unconstrained dimension before label rotation
					if (me.isHorizontal()) {
						// Reset position before calculating rotation
						me.width = me.maxWidth;
						me.left = 0;
						me.right = me.width;
					} else {
						me.height = me.maxHeight;

						// Reset position before calculating rotation
						me.top = 0;
						me.bottom = me.height;
					}

					// Reset padding
					me.paddingLeft = 0;
					me.paddingTop = 0;
					me.paddingRight = 0;
					me.paddingBottom = 0;

					// Reset minSize
					me.minSize = {
						width: 0,
						height: 0
					};
				},
				afterSetDimensions: noop,

				//

				beforeBuildLabels: noop,
				buildLabels: function buildLabels() {
					var me = this;
					var labelOpts = me.options.labels || {};
					var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];

					if (labelOpts.filter) {
						legendItems = legendItems.filter(function (item) {
							return labelOpts.filter(item, me.chart.data);
						});
					}

					if (me.options.reverse) {
						legendItems.reverse();
					}

					me.legendItems = legendItems;
				},
				afterBuildLabels: noop,

				//

				beforeFit: noop,
				fit: function fit() {
					var me = this;
					var opts = me.options;
					var labelOpts = opts.labels;
					var display = opts.display;

					var ctx = me.ctx;

					var globalDefault = defaults.global;
					var valueOrDefault = helpers.valueOrDefault;
					var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
					var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
					var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
					var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);

					// Reset hit boxes
					var hitboxes = me.legendHitBoxes = [];

					var minSize = me.minSize;
					var isHorizontal = me.isHorizontal();

					if (isHorizontal) {
						minSize.width = me.maxWidth; // fill all the width
						minSize.height = display ? 10 : 0;
					} else {
						minSize.width = display ? 10 : 0;
						minSize.height = me.maxHeight; // fill all the height
					}

					// Increase sizes here
					if (display) {
						ctx.font = labelFont;

						if (isHorizontal) {
							// Labels

							// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
							var lineWidths = me.lineWidths = [0];
							var totalHeight = me.legendItems.length ? fontSize + labelOpts.padding : 0;

							ctx.textAlign = 'left';
							ctx.textBaseline = 'top';

							helpers.each(me.legendItems, function (legendItem, i) {
								var boxWidth = getBoxWidth(labelOpts, fontSize);
								var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;

								if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
									totalHeight += fontSize + labelOpts.padding;
									lineWidths[lineWidths.length] = me.left;
								}

								// Store the hitbox width and height here. Final position will be updated in `draw`
								hitboxes[i] = {
									left: 0,
									top: 0,
									width: width,
									height: fontSize
								};

								lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
							});

							minSize.height += totalHeight;
						} else {
							var vPadding = labelOpts.padding;
							var columnWidths = me.columnWidths = [];
							var totalWidth = labelOpts.padding;
							var currentColWidth = 0;
							var currentColHeight = 0;
							var itemHeight = fontSize + vPadding;

							helpers.each(me.legendItems, function (legendItem, i) {
								var boxWidth = getBoxWidth(labelOpts, fontSize);
								var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;

								// If too tall, go to new column
								if (currentColHeight + itemHeight > minSize.height) {
									totalWidth += currentColWidth + labelOpts.padding;
									columnWidths.push(currentColWidth); // previous column width

									currentColWidth = 0;
									currentColHeight = 0;
								}

								// Get max width
								currentColWidth = Math.max(currentColWidth, itemWidth);
								currentColHeight += itemHeight;

								// Store the hitbox width and height here. Final position will be updated in `draw`
								hitboxes[i] = {
									left: 0,
									top: 0,
									width: itemWidth,
									height: fontSize
								};
							});

							totalWidth += currentColWidth;
							columnWidths.push(currentColWidth);
							minSize.width += totalWidth;
						}
					}

					me.width = minSize.width;
					me.height = minSize.height;
				},
				afterFit: noop,

				// Shared Methods
				isHorizontal: function isHorizontal() {
					return this.options.position === 'top' || this.options.position === 'bottom';
				},

				// Actually draw the legend on the canvas
				draw: function draw() {
					var me = this;
					var opts = me.options;
					var labelOpts = opts.labels;
					var globalDefault = defaults.global;
					var lineDefault = globalDefault.elements.line;
					var legendWidth = me.width;
					var lineWidths = me.lineWidths;

					if (opts.display) {
						var ctx = me.ctx;
						var valueOrDefault = helpers.valueOrDefault;
						var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
						var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
						var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
						var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
						var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
						var cursor;

						// Canvas setup
						ctx.textAlign = 'left';
						ctx.textBaseline = 'middle';
						ctx.lineWidth = 0.5;
						ctx.strokeStyle = fontColor; // for strikethrough effect
						ctx.fillStyle = fontColor; // render in correct colour
						ctx.font = labelFont;

						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var hitboxes = me.legendHitBoxes;

						// current position
						var drawLegendBox = function drawLegendBox(x, y, legendItem) {
							if (isNaN(boxWidth) || boxWidth <= 0) {
								return;
							}

							// Set the ctx for the box
							ctx.save();

							ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
							ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
							ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
							ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
							ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
							ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
							var isLineWidthZero = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0;

							if (ctx.setLineDash) {
								// IE 9 and 10 do not support line dash
								ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
							}

							if (opts.labels && opts.labels.usePointStyle) {
								// Recalculate x and y for drawPoint() because its expecting
								// x and y to be center of figure (instead of top left)
								var radius = fontSize * Math.SQRT2 / 2;
								var offSet = radius / Math.SQRT2;
								var centerX = x + offSet;
								var centerY = y + offSet;

								// Draw pointStyle as legend symbol
								helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
							} else {
								// Draw box as legend symbol
								if (!isLineWidthZero) {
									ctx.strokeRect(x, y, boxWidth, fontSize);
								}
								ctx.fillRect(x, y, boxWidth, fontSize);
							}

							ctx.restore();
						};
						var fillText = function fillText(x, y, legendItem, textWidth) {
							var halfFontSize = fontSize / 2;
							var xLeft = boxWidth + halfFontSize + x;
							var yMiddle = y + halfFontSize;

							ctx.fillText(legendItem.text, xLeft, yMiddle);

							if (legendItem.hidden) {
								// Strikethrough the text if hidden
								ctx.beginPath();
								ctx.lineWidth = 2;
								ctx.moveTo(xLeft, yMiddle);
								ctx.lineTo(xLeft + textWidth, yMiddle);
								ctx.stroke();
							}
						};

						// Horizontal
						var isHorizontal = me.isHorizontal();
						if (isHorizontal) {
							cursor = {
								x: me.left + (legendWidth - lineWidths[0]) / 2,
								y: me.top + labelOpts.padding,
								line: 0
							};
						} else {
							cursor = {
								x: me.left + labelOpts.padding,
								y: me.top + labelOpts.padding,
								line: 0
							};
						}

						var itemHeight = fontSize + labelOpts.padding;
						helpers.each(me.legendItems, function (legendItem, i) {
							var textWidth = ctx.measureText(legendItem.text).width;
							var width = boxWidth + fontSize / 2 + textWidth;
							var x = cursor.x;
							var y = cursor.y;

							if (isHorizontal) {
								if (x + width >= legendWidth) {
									y = cursor.y += itemHeight;
									cursor.line++;
									x = cursor.x = me.left + (legendWidth - lineWidths[cursor.line]) / 2;
								}
							} else if (y + itemHeight > me.bottom) {
								x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
								y = cursor.y = me.top + labelOpts.padding;
								cursor.line++;
							}

							drawLegendBox(x, y, legendItem);

							hitboxes[i].left = x;
							hitboxes[i].top = y;

							// Fill the actual label
							fillText(x, y, legendItem, textWidth);

							if (isHorizontal) {
								cursor.x += width + labelOpts.padding;
							} else {
								cursor.y += itemHeight;
							}
						});
					}
				},

				/**
     * Handle an event
     * @private
     * @param {IEvent} event - The event to handle
     * @return {Boolean} true if a change occured
     */
				handleEvent: function handleEvent(e) {
					var me = this;
					var opts = me.options;
					var type = e.type === 'mouseup' ? 'click' : e.type;
					var changed = false;

					if (type === 'mousemove') {
						if (!opts.onHover) {
							return;
						}
					} else if (type === 'click') {
						if (!opts.onClick) {
							return;
						}
					} else {
						return;
					}

					// Chart event already has relative position in it
					var x = e.x;
					var y = e.y;

					if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
						// See if we are touching one of the dataset boxes
						var lh = me.legendHitBoxes;
						for (var i = 0; i < lh.length; ++i) {
							var hitBox = lh[i];

							if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
								// Touching an element
								if (type === 'click') {
									// use e.native for backwards compatibility
									opts.onClick.call(me, e.native, me.legendItems[i]);
									changed = true;
									break;
								} else if (type === 'mousemove') {
									// use e.native for backwards compatibility
									opts.onHover.call(me, e.native, me.legendItems[i]);
									changed = true;
									break;
								}
							}
						}
					}

					return changed;
				}
			});

			function createNewLegendAndAttach(chart, legendOpts) {
				var legend = new Legend({
					ctx: chart.ctx,
					options: legendOpts,
					chart: chart
				});

				layouts.configure(chart, legend, legendOpts);
				layouts.addBox(chart, legend);
				chart.legend = legend;
			}

			module.exports = {
				id: 'legend',

				/**
     * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
     * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
     * the plugin, which one will be re-exposed in the chart.js file.
     * https://github.com/chartjs/Chart.js/pull/2640
     * @private
     */
				_element: Legend,

				beforeInit: function beforeInit(chart) {
					var legendOpts = chart.options.legend;

					if (legendOpts) {
						createNewLegendAndAttach(chart, legendOpts);
					}
				},

				beforeUpdate: function beforeUpdate(chart) {
					var legendOpts = chart.options.legend;
					var legend = chart.legend;

					if (legendOpts) {
						helpers.mergeIf(legendOpts, defaults.global.legend);

						if (legend) {
							layouts.configure(chart, legend, legendOpts);
							legend.options = legendOpts;
						} else {
							createNewLegendAndAttach(chart, legendOpts);
						}
					} else if (legend) {
						layouts.removeBox(chart, legend);
						delete chart.legend;
					}
				},

				afterEvent: function afterEvent(chart, e) {
					var legend = chart.legend;
					if (legend) {
						legend.handleEvent(e);
					}
				}
			};
		}, { "25": 25, "26": 26, "30": 30, "45": 45 }], 52: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var Element = require(26);
			var helpers = require(45);
			var layouts = require(30);

			var noop = helpers.noop;

			defaults._set('global', {
				title: {
					display: false,
					fontStyle: 'bold',
					fullWidth: true,
					lineHeight: 1.2,
					padding: 10,
					position: 'top',
					text: '',
					weight: 2000 // by default greater than legend (1000) to be above
				}
			});

			/**
    * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
    */
			var Title = Element.extend({
				initialize: function initialize(config) {
					var me = this;
					helpers.extend(me, config);

					// Contains hit boxes for each dataset (in dataset order)
					me.legendHitBoxes = [];
				},

				// These methods are ordered by lifecycle. Utilities then follow.

				beforeUpdate: noop,
				update: function update(maxWidth, maxHeight, margins) {
					var me = this;

					// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
					me.beforeUpdate();

					// Absorb the master measurements
					me.maxWidth = maxWidth;
					me.maxHeight = maxHeight;
					me.margins = margins;

					// Dimensions
					me.beforeSetDimensions();
					me.setDimensions();
					me.afterSetDimensions();
					// Labels
					me.beforeBuildLabels();
					me.buildLabels();
					me.afterBuildLabels();

					// Fit
					me.beforeFit();
					me.fit();
					me.afterFit();
					//
					me.afterUpdate();

					return me.minSize;
				},
				afterUpdate: noop,

				//

				beforeSetDimensions: noop,
				setDimensions: function setDimensions() {
					var me = this;
					// Set the unconstrained dimension before label rotation
					if (me.isHorizontal()) {
						// Reset position before calculating rotation
						me.width = me.maxWidth;
						me.left = 0;
						me.right = me.width;
					} else {
						me.height = me.maxHeight;

						// Reset position before calculating rotation
						me.top = 0;
						me.bottom = me.height;
					}

					// Reset padding
					me.paddingLeft = 0;
					me.paddingTop = 0;
					me.paddingRight = 0;
					me.paddingBottom = 0;

					// Reset minSize
					me.minSize = {
						width: 0,
						height: 0
					};
				},
				afterSetDimensions: noop,

				//

				beforeBuildLabels: noop,
				buildLabels: noop,
				afterBuildLabels: noop,

				//

				beforeFit: noop,
				fit: function fit() {
					var me = this;
					var valueOrDefault = helpers.valueOrDefault;
					var opts = me.options;
					var display = opts.display;
					var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
					var minSize = me.minSize;
					var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
					var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
					var textSize = display ? lineCount * lineHeight + opts.padding * 2 : 0;

					if (me.isHorizontal()) {
						minSize.width = me.maxWidth; // fill all the width
						minSize.height = textSize;
					} else {
						minSize.width = textSize;
						minSize.height = me.maxHeight; // fill all the height
					}

					me.width = minSize.width;
					me.height = minSize.height;
				},
				afterFit: noop,

				// Shared Methods
				isHorizontal: function isHorizontal() {
					var pos = this.options.position;
					return pos === 'top' || pos === 'bottom';
				},

				// Actually draw the title block on the canvas
				draw: function draw() {
					var me = this;
					var ctx = me.ctx;
					var valueOrDefault = helpers.valueOrDefault;
					var opts = me.options;
					var globalDefaults = defaults.global;

					if (opts.display) {
						var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
						var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
						var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
						var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
						var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
						var offset = lineHeight / 2 + opts.padding;
						var rotation = 0;
						var top = me.top;
						var left = me.left;
						var bottom = me.bottom;
						var right = me.right;
						var maxWidth, titleX, titleY;

						ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
						ctx.font = titleFont;

						// Horizontal
						if (me.isHorizontal()) {
							titleX = left + (right - left) / 2; // midpoint of the width
							titleY = top + offset;
							maxWidth = right - left;
						} else {
							titleX = opts.position === 'left' ? left + offset : right - offset;
							titleY = top + (bottom - top) / 2;
							maxWidth = bottom - top;
							rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
						}

						ctx.save();
						ctx.translate(titleX, titleY);
						ctx.rotate(rotation);
						ctx.textAlign = 'center';
						ctx.textBaseline = 'middle';

						var text = opts.text;
						if (helpers.isArray(text)) {
							var y = 0;
							for (var i = 0; i < text.length; ++i) {
								ctx.fillText(text[i], 0, y, maxWidth);
								y += lineHeight;
							}
						} else {
							ctx.fillText(text, 0, 0, maxWidth);
						}

						ctx.restore();
					}
				}
			});

			function createNewTitleBlockAndAttach(chart, titleOpts) {
				var title = new Title({
					ctx: chart.ctx,
					options: titleOpts,
					chart: chart
				});

				layouts.configure(chart, title, titleOpts);
				layouts.addBox(chart, title);
				chart.titleBlock = title;
			}

			module.exports = {
				id: 'title',

				/**
     * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
     * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
     * the plugin, which one will be re-exposed in the chart.js file.
     * https://github.com/chartjs/Chart.js/pull/2640
     * @private
     */
				_element: Title,

				beforeInit: function beforeInit(chart) {
					var titleOpts = chart.options.title;

					if (titleOpts) {
						createNewTitleBlockAndAttach(chart, titleOpts);
					}
				},

				beforeUpdate: function beforeUpdate(chart) {
					var titleOpts = chart.options.title;
					var titleBlock = chart.titleBlock;

					if (titleOpts) {
						helpers.mergeIf(titleOpts, defaults.global.title);

						if (titleBlock) {
							layouts.configure(chart, titleBlock, titleOpts);
							titleBlock.options = titleOpts;
						} else {
							createNewTitleBlockAndAttach(chart, titleOpts);
						}
					} else if (titleBlock) {
						layouts.removeBox(chart, titleBlock);
						delete chart.titleBlock;
					}
				}
			};
		}, { "25": 25, "26": 26, "30": 30, "45": 45 }], 53: [function (require, module, exports) {
			'use strict';

			module.exports = function (Chart) {

				// Default config for a category scale
				var defaultConfig = {
					position: 'bottom'
				};

				var DatasetScale = Chart.Scale.extend({
					/**
     * Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
     * else fall back to data.labels
     * @private
     */
					getLabels: function getLabels() {
						var data = this.chart.data;
						return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
					},

					determineDataLimits: function determineDataLimits() {
						var me = this;
						var labels = me.getLabels();
						me.minIndex = 0;
						me.maxIndex = labels.length - 1;
						var findIndex;

						if (me.options.ticks.min !== undefined) {
							// user specified min value
							findIndex = labels.indexOf(me.options.ticks.min);
							me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
						}

						if (me.options.ticks.max !== undefined) {
							// user specified max value
							findIndex = labels.indexOf(me.options.ticks.max);
							me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
						}

						me.min = labels[me.minIndex];
						me.max = labels[me.maxIndex];
					},

					buildTicks: function buildTicks() {
						var me = this;
						var labels = me.getLabels();
						// If we are viewing some subset of labels, slice the original array
						me.ticks = me.minIndex === 0 && me.maxIndex === labels.length - 1 ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
					},

					getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
						var me = this;
						var data = me.chart.data;
						var isHorizontal = me.isHorizontal();

						if (data.yLabels && !isHorizontal) {
							return me.getRightValue(data.datasets[datasetIndex].data[index]);
						}
						return me.ticks[index - me.minIndex];
					},

					// Used to get data value locations.  Value can either be an index or a numerical value
					getPixelForValue: function getPixelForValue(value, index) {
						var me = this;
						var offset = me.options.offset;
						// 1 is added because we need the length but we have the indexes
						var offsetAmt = Math.max(me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1), 1);

						// If value is a data object, then index is the index in the data array,
						// not the index of the scale. We need to change that.
						var valueCategory;
						if (value !== undefined && value !== null) {
							valueCategory = me.isHorizontal() ? value.x : value.y;
						}
						if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
							var labels = me.getLabels();
							value = valueCategory || value;
							var idx = labels.indexOf(value);
							index = idx !== -1 ? idx : index;
						}

						if (me.isHorizontal()) {
							var valueWidth = me.width / offsetAmt;
							var widthOffset = valueWidth * (index - me.minIndex);

							if (offset) {
								widthOffset += valueWidth / 2;
							}

							return me.left + Math.round(widthOffset);
						}
						var valueHeight = me.height / offsetAmt;
						var heightOffset = valueHeight * (index - me.minIndex);

						if (offset) {
							heightOffset += valueHeight / 2;
						}

						return me.top + Math.round(heightOffset);
					},
					getPixelForTick: function getPixelForTick(index) {
						return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
					},
					getValueForPixel: function getValueForPixel(pixel) {
						var me = this;
						var offset = me.options.offset;
						var value;
						var offsetAmt = Math.max(me._ticks.length - (offset ? 0 : 1), 1);
						var horz = me.isHorizontal();
						var valueDimension = (horz ? me.width : me.height) / offsetAmt;

						pixel -= horz ? me.left : me.top;

						if (offset) {
							pixel -= valueDimension / 2;
						}

						if (pixel <= 0) {
							value = 0;
						} else {
							value = Math.round(pixel / valueDimension);
						}

						return value + me.minIndex;
					},
					getBasePixel: function getBasePixel() {
						return this.bottom;
					}
				});

				Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
			};
		}, {}], 54: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var helpers = require(45);
			var Ticks = require(34);

			module.exports = function (Chart) {

				var defaultConfig = {
					position: 'left',
					ticks: {
						callback: Ticks.formatters.linear
					}
				};

				var LinearScale = Chart.LinearScaleBase.extend({

					determineDataLimits: function determineDataLimits() {
						var me = this;
						var opts = me.options;
						var chart = me.chart;
						var data = chart.data;
						var datasets = data.datasets;
						var isHorizontal = me.isHorizontal();
						var DEFAULT_MIN = 0;
						var DEFAULT_MAX = 1;

						function IDMatches(meta) {
							return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
						}

						// First Calculate the range
						me.min = null;
						me.max = null;

						var hasStacks = opts.stacked;
						if (hasStacks === undefined) {
							helpers.each(datasets, function (dataset, datasetIndex) {
								if (hasStacks) {
									return;
								}

								var meta = chart.getDatasetMeta(datasetIndex);
								if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
									hasStacks = true;
								}
							});
						}

						if (opts.stacked || hasStacks) {
							var valuesPerStack = {};

							helpers.each(datasets, function (dataset, datasetIndex) {
								var meta = chart.getDatasetMeta(datasetIndex);
								var key = [meta.type,
								// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
								opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '', meta.stack].join('.');

								if (valuesPerStack[key] === undefined) {
									valuesPerStack[key] = {
										positiveValues: [],
										negativeValues: []
									};
								}

								// Store these per type
								var positiveValues = valuesPerStack[key].positiveValues;
								var negativeValues = valuesPerStack[key].negativeValues;

								if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
									helpers.each(dataset.data, function (rawValue, index) {
										var value = +me.getRightValue(rawValue);
										if (isNaN(value) || meta.data[index].hidden) {
											return;
										}

										positiveValues[index] = positiveValues[index] || 0;
										negativeValues[index] = negativeValues[index] || 0;

										if (opts.relativePoints) {
											positiveValues[index] = 100;
										} else if (value < 0) {
											negativeValues[index] += value;
										} else {
											positiveValues[index] += value;
										}
									});
								}
							});

							helpers.each(valuesPerStack, function (valuesForType) {
								var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
								var minVal = helpers.min(values);
								var maxVal = helpers.max(values);
								me.min = me.min === null ? minVal : Math.min(me.min, minVal);
								me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
							});
						} else {
							helpers.each(datasets, function (dataset, datasetIndex) {
								var meta = chart.getDatasetMeta(datasetIndex);
								if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
									helpers.each(dataset.data, function (rawValue, index) {
										var value = +me.getRightValue(rawValue);
										if (isNaN(value) || meta.data[index].hidden) {
											return;
										}

										if (me.min === null) {
											me.min = value;
										} else if (value < me.min) {
											me.min = value;
										}

										if (me.max === null) {
											me.max = value;
										} else if (value > me.max) {
											me.max = value;
										}
									});
								}
							});
						}

						me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
						me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

						// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
						this.handleTickRangeOptions();
					},
					getTickLimit: function getTickLimit() {
						var maxTicks;
						var me = this;
						var tickOpts = me.options.ticks;

						if (me.isHorizontal()) {
							maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
						} else {
							// The factor of 2 used to scale the font size has been experimentally determined.
							var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
							maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
						}

						return maxTicks;
					},
					// Called after the ticks are built. We need
					handleDirectionalChanges: function handleDirectionalChanges() {
						if (!this.isHorizontal()) {
							// We are in a vertical orientation. The top value is the highest. So reverse the array
							this.ticks.reverse();
						}
					},
					getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
						return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
					},
					// Utils
					getPixelForValue: function getPixelForValue(value) {
						// This must be called after fit has been run so that
						// this.left, this.top, this.right, and this.bottom have been defined
						var me = this;
						var start = me.start;

						var rightValue = +me.getRightValue(value);
						var pixel;
						var range = me.end - start;

						if (me.isHorizontal()) {
							pixel = me.left + me.width / range * (rightValue - start);
						} else {
							pixel = me.bottom - me.height / range * (rightValue - start);
						}
						return pixel;
					},
					getValueForPixel: function getValueForPixel(pixel) {
						var me = this;
						var isHorizontal = me.isHorizontal();
						var innerDimension = isHorizontal ? me.width : me.height;
						var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
						return me.start + (me.end - me.start) * offset;
					},
					getPixelForTick: function getPixelForTick(index) {
						return this.getPixelForValue(this.ticksAsNumbers[index]);
					}
				});
				Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
			};
		}, { "25": 25, "34": 34, "45": 45 }], 55: [function (require, module, exports) {
			'use strict';

			var helpers = require(45);

			/**
    * Generate a set of linear ticks
    * @param generationOptions the options used to generate the ticks
    * @param dataRange the range of the data
    * @returns {Array<Number>} array of tick values
    */
			function generateTicks(generationOptions, dataRange) {
				var ticks = [];
				// To get a "nice" value for the tick spacing, we will use the appropriately named
				// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
				// for details.

				var spacing;
				if (generationOptions.stepSize && generationOptions.stepSize > 0) {
					spacing = generationOptions.stepSize;
				} else {
					var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
					spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
				}
				var niceMin = Math.floor(dataRange.min / spacing) * spacing;
				var niceMax = Math.ceil(dataRange.max / spacing) * spacing;

				// If min, max and stepSize is set and they make an evenly spaced scale use it.
				if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
					// If very close to our whole number, use it.
					if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
						niceMin = generationOptions.min;
						niceMax = generationOptions.max;
					}
				}

				var numSpaces = (niceMax - niceMin) / spacing;
				// If very close to our rounded value, use it.
				if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
					numSpaces = Math.round(numSpaces);
				} else {
					numSpaces = Math.ceil(numSpaces);
				}

				var precision = 1;
				if (spacing < 1) {
					precision = Math.pow(10, spacing.toString().length - 2);
					niceMin = Math.round(niceMin * precision) / precision;
					niceMax = Math.round(niceMax * precision) / precision;
				}
				ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
				for (var j = 1; j < numSpaces; ++j) {
					ticks.push(Math.round((niceMin + j * spacing) * precision) / precision);
				}
				ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);

				return ticks;
			}

			module.exports = function (Chart) {

				var noop = helpers.noop;

				Chart.LinearScaleBase = Chart.Scale.extend({
					getRightValue: function getRightValue(value) {
						if (typeof value === 'string') {
							return +value;
						}
						return Chart.Scale.prototype.getRightValue.call(this, value);
					},

					handleTickRangeOptions: function handleTickRangeOptions() {
						var me = this;
						var opts = me.options;
						var tickOpts = opts.ticks;

						// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
						// do nothing since that would make the chart weird. If the user really wants a weird chart
						// axis, they can manually override it
						if (tickOpts.beginAtZero) {
							var minSign = helpers.sign(me.min);
							var maxSign = helpers.sign(me.max);

							if (minSign < 0 && maxSign < 0) {
								// move the top up to 0
								me.max = 0;
							} else if (minSign > 0 && maxSign > 0) {
								// move the bottom down to 0
								me.min = 0;
							}
						}

						var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
						var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

						if (tickOpts.min !== undefined) {
							me.min = tickOpts.min;
						} else if (tickOpts.suggestedMin !== undefined) {
							if (me.min === null) {
								me.min = tickOpts.suggestedMin;
							} else {
								me.min = Math.min(me.min, tickOpts.suggestedMin);
							}
						}

						if (tickOpts.max !== undefined) {
							me.max = tickOpts.max;
						} else if (tickOpts.suggestedMax !== undefined) {
							if (me.max === null) {
								me.max = tickOpts.suggestedMax;
							} else {
								me.max = Math.max(me.max, tickOpts.suggestedMax);
							}
						}

						if (setMin !== setMax) {
							// We set the min or the max but not both.
							// So ensure that our range is good
							// Inverted or 0 length range can happen when
							// ticks.min is set, and no datasets are visible
							if (me.min >= me.max) {
								if (setMin) {
									me.max = me.min + 1;
								} else {
									me.min = me.max - 1;
								}
							}
						}

						if (me.min === me.max) {
							me.max++;

							if (!tickOpts.beginAtZero) {
								me.min--;
							}
						}
					},
					getTickLimit: noop,
					handleDirectionalChanges: noop,

					buildTicks: function buildTicks() {
						var me = this;
						var opts = me.options;
						var tickOpts = opts.ticks;

						// Figure out what the max number of ticks we can support it is based on the size of
						// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
						// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
						// the graph. Make sure we always have at least 2 ticks
						var maxTicks = me.getTickLimit();
						maxTicks = Math.max(2, maxTicks);

						var numericGeneratorOptions = {
							maxTicks: maxTicks,
							min: tickOpts.min,
							max: tickOpts.max,
							stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
						};
						var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

						me.handleDirectionalChanges();

						// At this point, we need to update our max and min given the tick values since we have expanded the
						// range of the scale
						me.max = helpers.max(ticks);
						me.min = helpers.min(ticks);

						if (tickOpts.reverse) {
							ticks.reverse();

							me.start = me.max;
							me.end = me.min;
						} else {
							me.start = me.min;
							me.end = me.max;
						}
					},
					convertTicksToLabels: function convertTicksToLabels() {
						var me = this;
						me.ticksAsNumbers = me.ticks.slice();
						me.zeroLineIndex = me.ticks.indexOf(0);

						Chart.Scale.prototype.convertTicksToLabels.call(me);
					}
				});
			};
		}, { "45": 45 }], 56: [function (require, module, exports) {
			'use strict';

			var helpers = require(45);
			var Ticks = require(34);

			/**
    * Generate a set of logarithmic ticks
    * @param generationOptions the options used to generate the ticks
    * @param dataRange the range of the data
    * @returns {Array<Number>} array of tick values
    */
			function generateTicks(generationOptions, dataRange) {
				var ticks = [];
				var valueOrDefault = helpers.valueOrDefault;

				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
				var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));

				var endExp = Math.floor(helpers.log10(dataRange.max));
				var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
				var exp, significand;

				if (tickVal === 0) {
					exp = Math.floor(helpers.log10(dataRange.minNotZero));
					significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

					ticks.push(tickVal);
					tickVal = significand * Math.pow(10, exp);
				} else {
					exp = Math.floor(helpers.log10(tickVal));
					significand = Math.floor(tickVal / Math.pow(10, exp));
				}
				var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

				do {
					ticks.push(tickVal);

					++significand;
					if (significand === 10) {
						significand = 1;
						++exp;
						precision = exp >= 0 ? 1 : precision;
					}

					tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
				} while (exp < endExp || exp === endExp && significand < endSignificand);

				var lastTick = valueOrDefault(generationOptions.max, tickVal);
				ticks.push(lastTick);

				return ticks;
			}

			module.exports = function (Chart) {

				var defaultConfig = {
					position: 'left',

					// label settings
					ticks: {
						callback: Ticks.formatters.logarithmic
					}
				};

				var LogarithmicScale = Chart.Scale.extend({
					determineDataLimits: function determineDataLimits() {
						var me = this;
						var opts = me.options;
						var chart = me.chart;
						var data = chart.data;
						var datasets = data.datasets;
						var isHorizontal = me.isHorizontal();
						function IDMatches(meta) {
							return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
						}

						// Calculate Range
						me.min = null;
						me.max = null;
						me.minNotZero = null;

						var hasStacks = opts.stacked;
						if (hasStacks === undefined) {
							helpers.each(datasets, function (dataset, datasetIndex) {
								if (hasStacks) {
									return;
								}

								var meta = chart.getDatasetMeta(datasetIndex);
								if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
									hasStacks = true;
								}
							});
						}

						if (opts.stacked || hasStacks) {
							var valuesPerStack = {};

							helpers.each(datasets, function (dataset, datasetIndex) {
								var meta = chart.getDatasetMeta(datasetIndex);
								var key = [meta.type,
								// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
								opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '', meta.stack].join('.');

								if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
									if (valuesPerStack[key] === undefined) {
										valuesPerStack[key] = [];
									}

									helpers.each(dataset.data, function (rawValue, index) {
										var values = valuesPerStack[key];
										var value = +me.getRightValue(rawValue);
										// invalid, hidden and negative values are ignored
										if (isNaN(value) || meta.data[index].hidden || value < 0) {
											return;
										}
										values[index] = values[index] || 0;
										values[index] += value;
									});
								}
							});

							helpers.each(valuesPerStack, function (valuesForType) {
								if (valuesForType.length > 0) {
									var minVal = helpers.min(valuesForType);
									var maxVal = helpers.max(valuesForType);
									me.min = me.min === null ? minVal : Math.min(me.min, minVal);
									me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
								}
							});
						} else {
							helpers.each(datasets, function (dataset, datasetIndex) {
								var meta = chart.getDatasetMeta(datasetIndex);
								if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
									helpers.each(dataset.data, function (rawValue, index) {
										var value = +me.getRightValue(rawValue);
										// invalid, hidden and negative values are ignored
										if (isNaN(value) || meta.data[index].hidden || value < 0) {
											return;
										}

										if (me.min === null) {
											me.min = value;
										} else if (value < me.min) {
											me.min = value;
										}

										if (me.max === null) {
											me.max = value;
										} else if (value > me.max) {
											me.max = value;
										}

										if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
											me.minNotZero = value;
										}
									});
								}
							});
						}

						// Common base implementation to handle ticks.min, ticks.max
						this.handleTickRangeOptions();
					},
					handleTickRangeOptions: function handleTickRangeOptions() {
						var me = this;
						var opts = me.options;
						var tickOpts = opts.ticks;
						var valueOrDefault = helpers.valueOrDefault;
						var DEFAULT_MIN = 1;
						var DEFAULT_MAX = 10;

						me.min = valueOrDefault(tickOpts.min, me.min);
						me.max = valueOrDefault(tickOpts.max, me.max);

						if (me.min === me.max) {
							if (me.min !== 0 && me.min !== null) {
								me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
								me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
							} else {
								me.min = DEFAULT_MIN;
								me.max = DEFAULT_MAX;
							}
						}
						if (me.min === null) {
							me.min = Math.pow(10, Math.floor(helpers.log10(me.max)) - 1);
						}
						if (me.max === null) {
							me.max = me.min !== 0 ? Math.pow(10, Math.floor(helpers.log10(me.min)) + 1) : DEFAULT_MAX;
						}
						if (me.minNotZero === null) {
							if (me.min > 0) {
								me.minNotZero = me.min;
							} else if (me.max < 1) {
								me.minNotZero = Math.pow(10, Math.floor(helpers.log10(me.max)));
							} else {
								me.minNotZero = DEFAULT_MIN;
							}
						}
					},
					buildTicks: function buildTicks() {
						var me = this;
						var opts = me.options;
						var tickOpts = opts.ticks;
						var reverse = !me.isHorizontal();

						var generationOptions = {
							min: tickOpts.min,
							max: tickOpts.max
						};
						var ticks = me.ticks = generateTicks(generationOptions, me);

						// At this point, we need to update our max and min given the tick values since we have expanded the
						// range of the scale
						me.max = helpers.max(ticks);
						me.min = helpers.min(ticks);

						if (tickOpts.reverse) {
							reverse = !reverse;
							me.start = me.max;
							me.end = me.min;
						} else {
							me.start = me.min;
							me.end = me.max;
						}
						if (reverse) {
							ticks.reverse();
						}
					},
					convertTicksToLabels: function convertTicksToLabels() {
						this.tickValues = this.ticks.slice();

						Chart.Scale.prototype.convertTicksToLabels.call(this);
					},
					// Get the correct tooltip label
					getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
						return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
					},
					getPixelForTick: function getPixelForTick(index) {
						return this.getPixelForValue(this.tickValues[index]);
					},
					/**
      * Returns the value of the first tick.
      * @param {Number} value - The minimum not zero value.
      * @return {Number} The first tick value.
      * @private
      */
					_getFirstTickValue: function _getFirstTickValue(value) {
						var exp = Math.floor(helpers.log10(value));
						var significand = Math.floor(value / Math.pow(10, exp));

						return significand * Math.pow(10, exp);
					},
					getPixelForValue: function getPixelForValue(value) {
						var me = this;
						var reverse = me.options.ticks.reverse;
						var log10 = helpers.log10;
						var firstTickValue = me._getFirstTickValue(me.minNotZero);
						var offset = 0;
						var innerDimension, pixel, start, end, sign;

						value = +me.getRightValue(value);
						if (reverse) {
							start = me.end;
							end = me.start;
							sign = -1;
						} else {
							start = me.start;
							end = me.end;
							sign = 1;
						}
						if (me.isHorizontal()) {
							innerDimension = me.width;
							pixel = reverse ? me.right : me.left;
						} else {
							innerDimension = me.height;
							sign *= -1; // invert, since the upper-left corner of the canvas is at pixel (0, 0)
							pixel = reverse ? me.top : me.bottom;
						}
						if (value !== start) {
							if (start === 0) {
								// include zero tick
								offset = helpers.getValueOrDefault(me.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
								innerDimension -= offset;
								start = firstTickValue;
							}
							if (value !== 0) {
								offset += innerDimension / (log10(end) - log10(start)) * (log10(value) - log10(start));
							}
							pixel += sign * offset;
						}
						return pixel;
					},
					getValueForPixel: function getValueForPixel(pixel) {
						var me = this;
						var reverse = me.options.ticks.reverse;
						var log10 = helpers.log10;
						var firstTickValue = me._getFirstTickValue(me.minNotZero);
						var innerDimension, start, end, value;

						if (reverse) {
							start = me.end;
							end = me.start;
						} else {
							start = me.start;
							end = me.end;
						}
						if (me.isHorizontal()) {
							innerDimension = me.width;
							value = reverse ? me.right - pixel : pixel - me.left;
						} else {
							innerDimension = me.height;
							value = reverse ? pixel - me.top : me.bottom - pixel;
						}
						if (value !== start) {
							if (start === 0) {
								// include zero tick
								var offset = helpers.getValueOrDefault(me.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
								value -= offset;
								innerDimension -= offset;
								start = firstTickValue;
							}
							value *= log10(end) - log10(start);
							value /= innerDimension;
							value = Math.pow(10, log10(start) + value);
						}
						return value;
					}
				});
				Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
			};
		}, { "34": 34, "45": 45 }], 57: [function (require, module, exports) {
			'use strict';

			var defaults = require(25);
			var helpers = require(45);
			var Ticks = require(34);

			module.exports = function (Chart) {

				var globalDefaults = defaults.global;

				var defaultConfig = {
					display: true,

					// Boolean - Whether to animate scaling the chart from the centre
					animate: true,
					position: 'chartArea',

					angleLines: {
						display: true,
						color: 'rgba(0, 0, 0, 0.1)',
						lineWidth: 1
					},

					gridLines: {
						circular: false
					},

					// label settings
					ticks: {
						// Boolean - Show a backdrop to the scale label
						showLabelBackdrop: true,

						// String - The colour of the label backdrop
						backdropColor: 'rgba(255,255,255,0.75)',

						// Number - The backdrop padding above & below the label in pixels
						backdropPaddingY: 2,

						// Number - The backdrop padding to the side of the label in pixels
						backdropPaddingX: 2,

						callback: Ticks.formatters.linear
					},

					pointLabels: {
						// Boolean - if true, show point labels
						display: true,

						// Number - Point label font size in pixels
						fontSize: 10,

						// Function - Used to convert point labels
						callback: function callback(label) {
							return label;
						}
					}
				};

				function getValueCount(scale) {
					var opts = scale.options;
					return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
				}

				function getPointLabelFontOptions(scale) {
					var pointLabelOptions = scale.options.pointLabels;
					var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
					var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
					var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
					var font = helpers.fontString(fontSize, fontStyle, fontFamily);

					return {
						size: fontSize,
						style: fontStyle,
						family: fontFamily,
						font: font
					};
				}

				function measureLabelSize(ctx, fontSize, label) {
					if (helpers.isArray(label)) {
						return {
							w: helpers.longestText(ctx, ctx.font, label),
							h: label.length * fontSize + (label.length - 1) * 1.5 * fontSize
						};
					}

					return {
						w: ctx.measureText(label).width,
						h: fontSize
					};
				}

				function determineLimits(angle, pos, size, min, max) {
					if (angle === min || angle === max) {
						return {
							start: pos - size / 2,
							end: pos + size / 2
						};
					} else if (angle < min || angle > max) {
						return {
							start: pos - size - 5,
							end: pos
						};
					}

					return {
						start: pos,
						end: pos + size + 5
					};
				}

				/**
     * Helper function to fit a radial linear scale with point labels
     */
				function fitWithPointLabels(scale) {
					/*
      * Right, this is really confusing and there is a lot of maths going on here
      * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
      *
      * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
      *
      * Solution:
      *
      * We assume the radius of the polygon is half the size of the canvas at first
      * at each index we check if the text overlaps.
      *
      * Where it does, we store that angle and that index.
      *
      * After finding the largest index and angle we calculate how much we need to remove
      * from the shape radius to move the point inwards by that x.
      *
      * We average the left and right distances to get the maximum shape radius that can fit in the box
      * along with labels.
      *
      * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
      * on each side, removing that from the size, halving it and adding the left x protrusion width.
      *
      * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
      * and position it in the most space efficient manner
      *
      * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
      */

					var plFont = getPointLabelFontOptions(scale);

					// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
					// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
					var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
					var furthestLimits = {
						r: scale.width,
						l: 0,
						t: scale.height,
						b: 0
					};
					var furthestAngles = {};
					var i, textSize, pointPosition;

					scale.ctx.font = plFont.font;
					scale._pointLabelSizes = [];

					var valueCount = getValueCount(scale);
					for (i = 0; i < valueCount; i++) {
						pointPosition = scale.getPointPosition(i, largestPossibleRadius);
						textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
						scale._pointLabelSizes[i] = textSize;

						// Add quarter circle to make degree 0 mean top of circle
						var angleRadians = scale.getIndexAngle(i);
						var angle = helpers.toDegrees(angleRadians) % 360;
						var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
						var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

						if (hLimits.start < furthestLimits.l) {
							furthestLimits.l = hLimits.start;
							furthestAngles.l = angleRadians;
						}

						if (hLimits.end > furthestLimits.r) {
							furthestLimits.r = hLimits.end;
							furthestAngles.r = angleRadians;
						}

						if (vLimits.start < furthestLimits.t) {
							furthestLimits.t = vLimits.start;
							furthestAngles.t = angleRadians;
						}

						if (vLimits.end > furthestLimits.b) {
							furthestLimits.b = vLimits.end;
							furthestAngles.b = angleRadians;
						}
					}

					scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
				}

				/**
     * Helper function to fit a radial linear scale with no point labels
     */
				function _fit(scale) {
					var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
					scale.drawingArea = Math.round(largestPossibleRadius);
					scale.setCenterPoint(0, 0, 0, 0);
				}

				function getTextAlignForAngle(angle) {
					if (angle === 0 || angle === 180) {
						return 'center';
					} else if (angle < 180) {
						return 'left';
					}

					return 'right';
				}

				function fillText(ctx, text, position, fontSize) {
					if (helpers.isArray(text)) {
						var y = position.y;
						var spacing = 1.5 * fontSize;

						for (var i = 0; i < text.length; ++i) {
							ctx.fillText(text[i], position.x, y);
							y += spacing;
						}
					} else {
						ctx.fillText(text, position.x, position.y);
					}
				}

				function adjustPointPositionForLabelHeight(angle, textSize, position) {
					if (angle === 90 || angle === 270) {
						position.y -= textSize.h / 2;
					} else if (angle > 270 || angle < 90) {
						position.y -= textSize.h;
					}
				}

				function drawPointLabels(scale) {
					var ctx = scale.ctx;
					var opts = scale.options;
					var angleLineOpts = opts.angleLines;
					var pointLabelOpts = opts.pointLabels;

					ctx.lineWidth = angleLineOpts.lineWidth;
					ctx.strokeStyle = angleLineOpts.color;

					var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

					// Point Label Font
					var plFont = getPointLabelFontOptions(scale);

					ctx.textBaseline = 'top';

					for (var i = getValueCount(scale) - 1; i >= 0; i--) {
						if (angleLineOpts.display) {
							var outerPosition = scale.getPointPosition(i, outerDistance);
							ctx.beginPath();
							ctx.moveTo(scale.xCenter, scale.yCenter);
							ctx.lineTo(outerPosition.x, outerPosition.y);
							ctx.stroke();
							ctx.closePath();
						}

						if (pointLabelOpts.display) {
							// Extra 3px out for some label spacing
							var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);

							// Keep this in loop since we may support array properties here
							var pointLabelFontColor = helpers.valueAtIndexOrDefault(pointLabelOpts.fontColor, i, globalDefaults.defaultFontColor);
							ctx.font = plFont.font;
							ctx.fillStyle = pointLabelFontColor;

							var angleRadians = scale.getIndexAngle(i);
							var angle = helpers.toDegrees(angleRadians);
							ctx.textAlign = getTextAlignForAngle(angle);
							adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
							fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
						}
					}
				}

				function drawRadiusLine(scale, gridLineOpts, radius, index) {
					var ctx = scale.ctx;
					ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
					ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);

					if (scale.options.gridLines.circular) {
						// Draw circular arcs between the points
						ctx.beginPath();
						ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
						ctx.closePath();
						ctx.stroke();
					} else {
						// Draw straight lines connecting each index
						var valueCount = getValueCount(scale);

						if (valueCount === 0) {
							return;
						}

						ctx.beginPath();
						var pointPosition = scale.getPointPosition(0, radius);
						ctx.moveTo(pointPosition.x, pointPosition.y);

						for (var i = 1; i < valueCount; i++) {
							pointPosition = scale.getPointPosition(i, radius);
							ctx.lineTo(pointPosition.x, pointPosition.y);
						}

						ctx.closePath();
						ctx.stroke();
					}
				}

				function numberOrZero(param) {
					return helpers.isNumber(param) ? param : 0;
				}

				var LinearRadialScale = Chart.LinearScaleBase.extend({
					setDimensions: function setDimensions() {
						var me = this;
						var opts = me.options;
						var tickOpts = opts.ticks;
						// Set the unconstrained dimension before label rotation
						me.width = me.maxWidth;
						me.height = me.maxHeight;
						me.xCenter = Math.round(me.width / 2);
						me.yCenter = Math.round(me.height / 2);

						var minSize = helpers.min([me.height, me.width]);
						var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
						me.drawingArea = opts.display ? minSize / 2 - (tickFontSize / 2 + tickOpts.backdropPaddingY) : minSize / 2;
					},
					determineDataLimits: function determineDataLimits() {
						var me = this;
						var chart = me.chart;
						var min = Number.POSITIVE_INFINITY;
						var max = Number.NEGATIVE_INFINITY;

						helpers.each(chart.data.datasets, function (dataset, datasetIndex) {
							if (chart.isDatasetVisible(datasetIndex)) {
								var meta = chart.getDatasetMeta(datasetIndex);

								helpers.each(dataset.data, function (rawValue, index) {
									var value = +me.getRightValue(rawValue);
									if (isNaN(value) || meta.data[index].hidden) {
										return;
									}

									min = Math.min(value, min);
									max = Math.max(value, max);
								});
							}
						});

						me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
						me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;

						// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
						me.handleTickRangeOptions();
					},
					getTickLimit: function getTickLimit() {
						var tickOpts = this.options.ticks;
						var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
						return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
					},
					convertTicksToLabels: function convertTicksToLabels() {
						var me = this;

						Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);

						// Point labels
						me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
					},
					getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
						return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
					},
					fit: function fit() {
						if (this.options.pointLabels.display) {
							fitWithPointLabels(this);
						} else {
							_fit(this);
						}
					},
					/**
      * Set radius reductions and determine new radius and center point
      * @private
      */
					setReductions: function setReductions(largestPossibleRadius, furthestLimits, furthestAngles) {
						var me = this;
						var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
						var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
						var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
						var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);

						radiusReductionLeft = numberOrZero(radiusReductionLeft);
						radiusReductionRight = numberOrZero(radiusReductionRight);
						radiusReductionTop = numberOrZero(radiusReductionTop);
						radiusReductionBottom = numberOrZero(radiusReductionBottom);

						me.drawingArea = Math.min(Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
						me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
					},
					setCenterPoint: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
						var me = this;
						var maxRight = me.width - rightMovement - me.drawingArea;
						var maxLeft = leftMovement + me.drawingArea;
						var maxTop = topMovement + me.drawingArea;
						var maxBottom = me.height - bottomMovement - me.drawingArea;

						me.xCenter = Math.round((maxLeft + maxRight) / 2 + me.left);
						me.yCenter = Math.round((maxTop + maxBottom) / 2 + me.top);
					},

					getIndexAngle: function getIndexAngle(index) {
						var angleMultiplier = Math.PI * 2 / getValueCount(this);
						var startAngle = this.chart.options && this.chart.options.startAngle ? this.chart.options.startAngle : 0;

						var startAngleRadians = startAngle * Math.PI * 2 / 360;

						// Start from the top instead of right, so remove a quarter of the circle
						return index * angleMultiplier + startAngleRadians;
					},
					getDistanceFromCenterForValue: function getDistanceFromCenterForValue(value) {
						var me = this;

						if (value === null) {
							return 0; // null always in center
						}

						// Take into account half font size + the yPadding of the top value
						var scalingFactor = me.drawingArea / (me.max - me.min);
						if (me.options.ticks.reverse) {
							return (me.max - value) * scalingFactor;
						}
						return (value - me.min) * scalingFactor;
					},
					getPointPosition: function getPointPosition(index, distanceFromCenter) {
						var me = this;
						var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
						return {
							x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
							y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
						};
					},
					getPointPositionForValue: function getPointPositionForValue(index, value) {
						return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
					},

					getBasePosition: function getBasePosition() {
						var me = this;
						var min = me.min;
						var max = me.max;

						return me.getPointPositionForValue(0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
					},

					draw: function draw() {
						var me = this;
						var opts = me.options;
						var gridLineOpts = opts.gridLines;
						var tickOpts = opts.ticks;
						var valueOrDefault = helpers.valueOrDefault;

						if (opts.display) {
							var ctx = me.ctx;
							var startAngle = this.getIndexAngle(0);

							// Tick Font
							var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
							var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
							var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
							var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);

							helpers.each(me.ticks, function (label, index) {
								// Don't draw a centre value (if it is minimum)
								if (index > 0 || tickOpts.reverse) {
									var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

									// Draw circular lines around the scale
									if (gridLineOpts.display && index !== 0) {
										drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
									}

									if (tickOpts.display) {
										var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
										ctx.font = tickLabelFont;

										ctx.save();
										ctx.translate(me.xCenter, me.yCenter);
										ctx.rotate(startAngle);

										if (tickOpts.showLabelBackdrop) {
											var labelWidth = ctx.measureText(label).width;
											ctx.fillStyle = tickOpts.backdropColor;
											ctx.fillRect(-labelWidth / 2 - tickOpts.backdropPaddingX, -yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY, labelWidth + tickOpts.backdropPaddingX * 2, tickFontSize + tickOpts.backdropPaddingY * 2);
										}

										ctx.textAlign = 'center';
										ctx.textBaseline = 'middle';
										ctx.fillStyle = tickFontColor;
										ctx.fillText(label, 0, -yCenterOffset);
										ctx.restore();
									}
								}
							});

							if (opts.angleLines.display || opts.pointLabels.display) {
								drawPointLabels(me);
							}
						}
					}
				});
				Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
			};
		}, { "25": 25, "34": 34, "45": 45 }], 58: [function (require, module, exports) {
			/* global window: false */
			'use strict';

			var moment = require(1);
			moment = typeof moment === 'function' ? moment : window.moment;

			var defaults = require(25);
			var helpers = require(45);

			// Integer constants are from the ES6 spec.
			var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
			var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

			var INTERVALS = {
				millisecond: {
					common: true,
					size: 1,
					steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
				},
				second: {
					common: true,
					size: 1000,
					steps: [1, 2, 5, 10, 30]
				},
				minute: {
					common: true,
					size: 60000,
					steps: [1, 2, 5, 10, 30]
				},
				hour: {
					common: true,
					size: 3600000,
					steps: [1, 2, 3, 6, 12]
				},
				day: {
					common: true,
					size: 86400000,
					steps: [1, 2, 5]
				},
				week: {
					common: false,
					size: 604800000,
					steps: [1, 2, 3, 4]
				},
				month: {
					common: true,
					size: 2.628e9,
					steps: [1, 2, 3]
				},
				quarter: {
					common: false,
					size: 7.884e9,
					steps: [1, 2, 3, 4]
				},
				year: {
					common: true,
					size: 3.154e10
				}
			};

			var UNITS = Object.keys(INTERVALS);

			function sorter(a, b) {
				return a - b;
			}

			function arrayUnique(items) {
				var hash = {};
				var out = [];
				var i, ilen, item;

				for (i = 0, ilen = items.length; i < ilen; ++i) {
					item = items[i];
					if (!hash[item]) {
						hash[item] = true;
						out.push(item);
					}
				}

				return out;
			}

			/**
    * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
    * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
    * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
    * extremity (left + width or top + height). Note that it would be more optimized to directly
    * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
    * to create the lookup table. The table ALWAYS contains at least two items: min and max.
    *
    * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
    * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
    * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
    * If 'series', timestamps will be positioned at the same distance from each other. In this
    * case, only timestamps that break the time linearity are registered, meaning that in the
    * best case, all timestamps are linear, the table contains only min and max.
    */
			function buildLookupTable(timestamps, min, max, distribution) {
				if (distribution === 'linear' || !timestamps.length) {
					return [{ time: min, pos: 0 }, { time: max, pos: 1 }];
				}

				var table = [];
				var items = [min];
				var i, ilen, prev, curr, next;

				for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
					curr = timestamps[i];
					if (curr > min && curr < max) {
						items.push(curr);
					}
				}

				items.push(max);

				for (i = 0, ilen = items.length; i < ilen; ++i) {
					next = items[i + 1];
					prev = items[i - 1];
					curr = items[i];

					// only add points that breaks the scale linearity
					if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
						table.push({ time: curr, pos: i / (ilen - 1) });
					}
				}

				return table;
			}

			// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
			function lookup(table, key, value) {
				var lo = 0;
				var hi = table.length - 1;
				var mid, i0, i1;

				while (lo >= 0 && lo <= hi) {
					mid = lo + hi >> 1;
					i0 = table[mid - 1] || null;
					i1 = table[mid];

					if (!i0) {
						// given value is outside table (before first item)
						return { lo: null, hi: i1 };
					} else if (i1[key] < value) {
						lo = mid + 1;
					} else if (i0[key] > value) {
						hi = mid - 1;
					} else {
						return { lo: i0, hi: i1 };
					}
				}

				// given value is outside table (after last item)
				return { lo: i1, hi: null };
			}

			/**
    * Linearly interpolates the given source `value` using the table items `skey` values and
    * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
    * returns the position for a timestamp equal to 42. If value is out of bounds, values at
    * index [0, 1] or [n - 1, n] are used for the interpolation.
    */
			function interpolate(table, skey, sval, tkey) {
				var range = lookup(table, skey, sval);

				// Note: the lookup table ALWAYS contains at least 2 items (min and max)
				var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
				var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

				var span = next[skey] - prev[skey];
				var ratio = span ? (sval - prev[skey]) / span : 0;
				var offset = (next[tkey] - prev[tkey]) * ratio;

				return prev[tkey] + offset;
			}

			/**
    * Convert the given value to a moment object using the given time options.
    * @see http://momentjs.com/docs/#/parsing/
    */
			function momentify(value, options) {
				var parser = options.parser;
				var format = options.parser || options.format;

				if (typeof parser === 'function') {
					return parser(value);
				}

				if (typeof value === 'string' && typeof format === 'string') {
					return moment(value, format);
				}

				if (!(value instanceof moment)) {
					value = moment(value);
				}

				if (value.isValid()) {
					return value;
				}

				// Labels are in an incompatible moment format and no `parser` has been provided.
				// The user might still use the deprecated `format` option to convert his inputs.
				if (typeof format === 'function') {
					return format(value);
				}

				return value;
			}

			function parse(input, scale) {
				if (helpers.isNullOrUndef(input)) {
					return null;
				}

				var options = scale.options.time;
				var value = momentify(scale.getRightValue(input), options);
				if (!value.isValid()) {
					return null;
				}

				if (options.round) {
					value.startOf(options.round);
				}

				return value.valueOf();
			}

			/**
    * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
    * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
    */
			function determineStepSize(min, max, unit, capacity) {
				var range = max - min;
				var interval = INTERVALS[unit];
				var milliseconds = interval.size;
				var steps = interval.steps;
				var i, ilen, factor;

				if (!steps) {
					return Math.ceil(range / (capacity * milliseconds));
				}

				for (i = 0, ilen = steps.length; i < ilen; ++i) {
					factor = steps[i];
					if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
						break;
					}
				}

				return factor;
			}

			/**
    * Figures out what unit results in an appropriate number of auto-generated ticks
    */
			function determineUnitForAutoTicks(minUnit, min, max, capacity) {
				var ilen = UNITS.length;
				var i, interval, factor;

				for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
					interval = INTERVALS[UNITS[i]];
					factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

					if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
						return UNITS[i];
					}
				}

				return UNITS[ilen - 1];
			}

			/**
    * Figures out what unit to format a set of ticks with
    */
			function determineUnitForFormatting(ticks, minUnit, min, max) {
				var duration = moment.duration(moment(max).diff(moment(min)));
				var ilen = UNITS.length;
				var i, unit;

				for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
					unit = UNITS[i];
					if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
						return unit;
					}
				}

				return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
			}

			function determineMajorUnit(unit) {
				for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
					if (INTERVALS[UNITS[i]].common) {
						return UNITS[i];
					}
				}
			}

			/**
    * Generates a maximum of `capacity` timestamps between min and max, rounded to the
    * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
    * Important: this method can return ticks outside the min and max range, it's the
    * responsibility of the calling code to clamp values if needed.
    */
			function generate(min, max, capacity, options) {
				var timeOpts = options.time;
				var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
				var major = determineMajorUnit(minor);
				var stepSize = helpers.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
				var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
				var majorTicksEnabled = options.ticks.major.enabled;
				var interval = INTERVALS[minor];
				var first = moment(min);
				var last = moment(max);
				var ticks = [];
				var time;

				if (!stepSize) {
					stepSize = determineStepSize(min, max, minor, capacity);
				}

				// For 'week' unit, handle the first day of week option
				if (weekday) {
					first = first.isoWeekday(weekday);
					last = last.isoWeekday(weekday);
				}

				// Align first/last ticks on unit
				first = first.startOf(weekday ? 'day' : minor);
				last = last.startOf(weekday ? 'day' : minor);

				// Make sure that the last tick include max
				if (last < max) {
					last.add(1, minor);
				}

				time = moment(first);

				if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
					// Align the first tick on the previous `minor` unit aligned on the `major` unit:
					// we first aligned time on the previous `major` unit then add the number of full
					// stepSize there is between first and the previous major time.
					time.startOf(major);
					time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
				}

				for (; time < last; time.add(stepSize, minor)) {
					ticks.push(+time);
				}

				ticks.push(+time);

				return ticks;
			}

			/**
    * Returns the right and left offsets from edges in the form of {left, right}.
    * Offsets are added when the `offset` option is true.
    */
			function computeOffsets(table, ticks, min, max, options) {
				var left = 0;
				var right = 0;
				var upper, lower;

				if (options.offset && ticks.length) {
					if (!options.time.min) {
						upper = ticks.length > 1 ? ticks[1] : max;
						lower = ticks[0];
						left = (interpolate(table, 'time', upper, 'pos') - interpolate(table, 'time', lower, 'pos')) / 2;
					}
					if (!options.time.max) {
						upper = ticks[ticks.length - 1];
						lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
						right = (interpolate(table, 'time', upper, 'pos') - interpolate(table, 'time', lower, 'pos')) / 2;
					}
				}

				return { left: left, right: right };
			}

			function ticksFromTimestamps(values, majorUnit) {
				var ticks = [];
				var i, ilen, value, major;

				for (i = 0, ilen = values.length; i < ilen; ++i) {
					value = values[i];
					major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;

					ticks.push({
						value: value,
						major: major
					});
				}

				return ticks;
			}

			function determineLabelFormat(data, timeOpts) {
				var i, momentDate, hasTime;
				var ilen = data.length;

				// find the label with the most parts (milliseconds, minutes, etc.)
				// format all labels with the same level of detail as the most specific label
				for (i = 0; i < ilen; i++) {
					momentDate = momentify(data[i], timeOpts);
					if (momentDate.millisecond() !== 0) {
						return 'MMM D, YYYY h:mm:ss.SSS a';
					}
					if (momentDate.second() !== 0 || momentDate.minute() !== 0 || momentDate.hour() !== 0) {
						hasTime = true;
					}
				}
				if (hasTime) {
					return 'MMM D, YYYY h:mm:ss a';
				}
				return 'MMM D, YYYY';
			}

			module.exports = function (Chart) {

				var defaultConfig = {
					position: 'bottom',

					/**
      * Data distribution along the scale:
      * - 'linear': data are spread according to their time (distances can vary),
      * - 'series': data are spread at the same distance from each other.
      * @see https://github.com/chartjs/Chart.js/pull/4507
      * @since 2.7.0
      */
					distribution: 'linear',

					/**
      * Scale boundary strategy (bypassed by min/max time options)
      * - `data`: make sure data are fully visible, ticks outside are removed
      * - `ticks`: make sure ticks are fully visible, data outside are truncated
      * @see https://github.com/chartjs/Chart.js/pull/4556
      * @since 2.7.0
      */
					bounds: 'data',

					time: {
						parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
						format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
						unit: false, // false == automatic or override with week, month, year, etc.
						round: false, // none, or override with week, month, year, etc.
						displayFormat: false, // DEPRECATED
						isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
						minUnit: 'millisecond',

						// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
						displayFormats: {
							millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
							second: 'h:mm:ss a', // 11:20:01 AM
							minute: 'h:mm a', // 11:20 AM
							hour: 'hA', // 5PM
							day: 'MMM D', // Sep 4
							week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
							month: 'MMM YYYY', // Sept 2015
							quarter: '[Q]Q - YYYY', // Q3
							year: 'YYYY' // 2015
						}
					},
					ticks: {
						autoSkip: false,

						/**
       * Ticks generation input values:
       * - 'auto': generates "optimal" ticks based on scale size and time options.
       * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
       * - 'labels': generates ticks from user given `data.labels` values ONLY.
       * @see https://github.com/chartjs/Chart.js/pull/4507
       * @since 2.7.0
       */
						source: 'auto',

						major: {
							enabled: false
						}
					}
				};

				var TimeScale = Chart.Scale.extend({
					initialize: function initialize() {
						if (!moment) {
							throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
						}

						this.mergeTicksOptions();

						Chart.Scale.prototype.initialize.call(this);
					},

					update: function update() {
						var me = this;
						var options = me.options;

						// DEPRECATIONS: output a message only one time per update
						if (options.time && options.time.format) {
							console.warn('options.time.format is deprecated and replaced by options.time.parser.');
						}

						return Chart.Scale.prototype.update.apply(me, arguments);
					},

					/**
      * Allows data to be referenced via 't' attribute
      */
					getRightValue: function getRightValue(rawValue) {
						if (rawValue && rawValue.t !== undefined) {
							rawValue = rawValue.t;
						}
						return Chart.Scale.prototype.getRightValue.call(this, rawValue);
					},

					determineDataLimits: function determineDataLimits() {
						var me = this;
						var chart = me.chart;
						var timeOpts = me.options.time;
						var unit = timeOpts.unit || 'day';
						var min = MAX_INTEGER;
						var max = MIN_INTEGER;
						var timestamps = [];
						var datasets = [];
						var labels = [];
						var i, j, ilen, jlen, data, timestamp;

						// Convert labels to timestamps
						for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
							labels.push(parse(chart.data.labels[i], me));
						}

						// Convert data to timestamps
						for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
							if (chart.isDatasetVisible(i)) {
								data = chart.data.datasets[i].data;

								// Let's consider that all data have the same format.
								if (helpers.isObject(data[0])) {
									datasets[i] = [];

									for (j = 0, jlen = data.length; j < jlen; ++j) {
										timestamp = parse(data[j], me);
										timestamps.push(timestamp);
										datasets[i][j] = timestamp;
									}
								} else {
									timestamps.push.apply(timestamps, labels);
									datasets[i] = labels.slice(0);
								}
							} else {
								datasets[i] = [];
							}
						}

						if (labels.length) {
							// Sort labels **after** data have been converted
							labels = arrayUnique(labels).sort(sorter);
							min = Math.min(min, labels[0]);
							max = Math.max(max, labels[labels.length - 1]);
						}

						if (timestamps.length) {
							timestamps = arrayUnique(timestamps).sort(sorter);
							min = Math.min(min, timestamps[0]);
							max = Math.max(max, timestamps[timestamps.length - 1]);
						}

						min = parse(timeOpts.min, me) || min;
						max = parse(timeOpts.max, me) || max;

						// In case there is no valid min/max, set limits based on unit time option
						min = min === MAX_INTEGER ? +moment().startOf(unit) : min;
						max = max === MIN_INTEGER ? +moment().endOf(unit) + 1 : max;

						// Make sure that max is strictly higher than min (required by the lookup table)
						me.min = Math.min(min, max);
						me.max = Math.max(min + 1, max);

						// PRIVATE
						me._horizontal = me.isHorizontal();
						me._table = [];
						me._timestamps = {
							data: timestamps,
							datasets: datasets,
							labels: labels
						};
					},

					buildTicks: function buildTicks() {
						var me = this;
						var min = me.min;
						var max = me.max;
						var options = me.options;
						var timeOpts = options.time;
						var timestamps = [];
						var ticks = [];
						var i, ilen, timestamp;

						switch (options.ticks.source) {
							case 'data':
								timestamps = me._timestamps.data;
								break;
							case 'labels':
								timestamps = me._timestamps.labels;
								break;
							case 'auto':
							default:
								timestamps = generate(min, max, me.getLabelCapacity(min), options);
						}

						if (options.bounds === 'ticks' && timestamps.length) {
							min = timestamps[0];
							max = timestamps[timestamps.length - 1];
						}

						// Enforce limits with user min/max options
						min = parse(timeOpts.min, me) || min;
						max = parse(timeOpts.max, me) || max;

						// Remove ticks outside the min/max range
						for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
							timestamp = timestamps[i];
							if (timestamp >= min && timestamp <= max) {
								ticks.push(timestamp);
							}
						}

						me.min = min;
						me.max = max;

						// PRIVATE
						me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
						me._majorUnit = determineMajorUnit(me._unit);
						me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
						me._offsets = computeOffsets(me._table, ticks, min, max, options);
						me._labelFormat = determineLabelFormat(me._timestamps.data, timeOpts);

						return ticksFromTimestamps(ticks, me._majorUnit);
					},

					getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
						var me = this;
						var data = me.chart.data;
						var timeOpts = me.options.time;
						var label = data.labels && index < data.labels.length ? data.labels[index] : '';
						var value = data.datasets[datasetIndex].data[index];

						if (helpers.isObject(value)) {
							label = me.getRightValue(value);
						}
						if (timeOpts.tooltipFormat) {
							return momentify(label, timeOpts).format(timeOpts.tooltipFormat);
						}
						if (typeof label === 'string') {
							return label;
						}

						return momentify(label, timeOpts).format(me._labelFormat);
					},

					/**
      * Function to format an individual tick mark
      * @private
      */
					tickFormatFunction: function tickFormatFunction(tick, index, ticks, formatOverride) {
						var me = this;
						var options = me.options;
						var time = tick.valueOf();
						var formats = options.time.displayFormats;
						var minorFormat = formats[me._unit];
						var majorUnit = me._majorUnit;
						var majorFormat = formats[majorUnit];
						var majorTime = tick.clone().startOf(majorUnit).valueOf();
						var majorTickOpts = options.ticks.major;
						var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
						var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
						var tickOpts = major ? majorTickOpts : options.ticks.minor;
						var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);

						return formatter ? formatter(label, index, ticks) : label;
					},

					convertTicksToLabels: function convertTicksToLabels(ticks) {
						var labels = [];
						var i, ilen;

						for (i = 0, ilen = ticks.length; i < ilen; ++i) {
							labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
						}

						return labels;
					},

					/**
      * @private
      */
					getPixelForOffset: function getPixelForOffset(time) {
						var me = this;
						var size = me._horizontal ? me.width : me.height;
						var start = me._horizontal ? me.left : me.top;
						var pos = interpolate(me._table, 'time', time, 'pos');

						return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
					},

					getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
						var me = this;
						var time = null;

						if (index !== undefined && datasetIndex !== undefined) {
							time = me._timestamps.datasets[datasetIndex][index];
						}

						if (time === null) {
							time = parse(value, me);
						}

						if (time !== null) {
							return me.getPixelForOffset(time);
						}
					},

					getPixelForTick: function getPixelForTick(index) {
						var ticks = this.getTicks();
						return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
					},

					getValueForPixel: function getValueForPixel(pixel) {
						var me = this;
						var size = me._horizontal ? me.width : me.height;
						var start = me._horizontal ? me.left : me.top;
						var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
						var time = interpolate(me._table, 'pos', pos, 'time');

						return moment(time);
					},

					/**
      * Crude approximation of what the label width might be
      * @private
      */
					getLabelWidth: function getLabelWidth(label) {
						var me = this;
						var ticksOpts = me.options.ticks;
						var tickLabelWidth = me.ctx.measureText(label).width;
						var angle = helpers.toRadians(ticksOpts.maxRotation);
						var cosRotation = Math.cos(angle);
						var sinRotation = Math.sin(angle);
						var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);

						return tickLabelWidth * cosRotation + tickFontSize * sinRotation;
					},

					/**
      * @private
      */
					getLabelCapacity: function getLabelCapacity(exampleTime) {
						var me = this;

						var formatOverride = me.options.time.displayFormats.millisecond; // Pick the longest format for guestimation

						var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, [], formatOverride);
						var tickLabelWidth = me.getLabelWidth(exampleLabel);
						var innerWidth = me.isHorizontal() ? me.width : me.height;

						var capacity = Math.floor(innerWidth / tickLabelWidth);
						return capacity > 0 ? capacity : 1;
					}
				});

				Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
			};
		}, { "1": 1, "25": 25, "45": 45 }] }, {}, [7])(7);
});


var app = angular.module('app');

app.directive('fileread', [function () {
  return {
    scope: {
      opts: '='
    },
    link: function link($scope, $elm, $attrs, $rootScope) {
      $elm.on('change', function (changeEvent) {
        var reader = new FileReader();

        reader.onload = function (evt) {
          $scope.$apply(function () {
            var data = evt.target.result;

            var workbook = XLSX.read(data, {
              type: 'binary'
            });

            var headerNames = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
              header: 1
            })[0];

            data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);

            $scope.opts.columnDefs = [];
            headerNames.forEach(function (h) {
              $scope.opts.columnDefs.push({
                field: h
              });
            });

            $scope.opts.data = data;
            $scope.$emit('xlxJson', data);
            $elm.val(null);
          });
        };

        reader.readAsBinaryString(changeEvent.target.files[0]);
      });
    }
  };
}]);

app.directive('simpleAccordion', function () {
  return {
    // attribute
    restrict: 'A',
    scope: {
      // default: '400ms'
      // options: 'milliseconds', 'slow', or 'fast'
      toggleSpeed: '@toggleSpeed',
      slideUpSpeed: '@slideUpSpeed',
      // default: 'swing'
      // options: 'swing', 'linear'
      toggleEasing: '@toggleEasing',
      slideUpEasing: '@slideUpEasing'
    },
    link: function link(scope, element, attrs) {
      element.find('.accordion-toggle').click(function () {
        var elem = $(this);
        elem.next().slideToggle(scope.toggleSpeed, scope.toggleEasing);
        $('.accordion-content').not($(this).next()).slideUp(scope.slideUpSpeed, scope.slideUpEasing);
      });
    }
  };
});


angular.module('app').directive('ngClick', function ($timeout) {
    var delay = 500; // min milliseconds between clicks

    return {
        restrict: 'A',
        priority: -1, // cause out postLink function to execute before native `ngClick`'s
        // ensuring that we can stop the propagation of the 'click' event
        // before it reaches `ngClick`'s listener
        link: function link(scope, elem) {
            var disabled = false;

            function onClick(evt) {
                if (disabled) {
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                } else {
                    disabled = true;
                    $timeout(function () {
                        disabled = false;
                    }, delay, false);
                }
            }

            scope.$on('$destroy', function () {
                elem.off('click', onClick);
            });
            elem.on('click', onClick);
        }
    };
});


var app = angular.module('app');

app.directive("passwordStrength", function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.$watch(attrs.passwordStrength, function (value) {
                function hasUpperCase(str) {
                    if (str.toLowerCase() != str) {
                        return true;
                    }
                    return false;
                }
                if (angular.isDefined(value)) {
                    if (value.length > 8 && hasUpperCase(value)) {
                        scope.strength = 'strong';
                    } else if (value.length > 3) {
                        scope.strength = 'medium';
                    } else {
                        scope.strength = 'weak';
                    }
                }
            });
        }
    };
});

app.directive("compareTo", function () {
    return {
        require: "ngModel",
        scope: {
            ConfirmPassword: "=compareTo"
        },
        link: function link(scope, element, attributes, modelVal) {

            modelVal.$validators.compareTo = function (val) {
                return val == scope.ConfirmPassword;
            };

            scope.$watch("ConfirmPassword", function () {
                modelVal.$validate();
            });
        }
    };
});


var app = angular.module('app');

(function () {
  app.directive('onlyNumbersInput', onlyLettersInput);

  function onlyLettersInput() {
    return {
      require: 'ngModel',
      link: function link(scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          var transformedInput = text.replace(/[^0-9,-]/g, '');
          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  }
  app.directive('onlyAlphaNumeric', onlyAlphaNumeric);

  function onlyAlphaNumeric() {
    return {
      require: 'ngModel',
      link: function link(scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          var transformedInput = text.replace(/[^a-zA-Z0-9]/g, '');
          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  }
  app.directive('alphaNumSpace', alphaNumSpace);

  function alphaNumSpace() {
    return {
      require: 'ngModel',
      link: function link(scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          var transformedInput = text.replace(/[^a-zA-Z0-9 ]/g, '');
          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  }
  app.directive('alphaNum', alphaNum);

  function alphaNum() {
    return {
      require: 'ngModel',
      link: function link(scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          var transformedInput = text.replace(/[^a-zA-Z0-9]/g, '');
          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  }
})();


var app = angular.module('app');

(function () {

  app.directive('onlyLettersInput', onlyLettersInput);

  function onlyLettersInput() {
    return {
      require: 'ngModel',
      link: function link(scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          var transformedInput = text.replace(/[^a-zA-Z ]/g, '');
          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        ngModelCtrl.$parsers.push(fromUser);
      }
    };
  }

  app.directive('myEnter', function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.myEnter);
          });

          event.preventDefault();
        }
      });
    };
  });
})();


// var app = angular.module('app');
var module = angular.module('ngPdfObject', []);
module.directive('ngPdfObject', function () {
	return {
		replace: 'true',
		scope: {
			url: "@url",
			height: "@height",
			width: "@width"
		},
		template: '<div id="pdf"><div>',
		link: function link(scope, elem, attrs) {

			var success = new PDFObject({
				url: scope.url,
				width: scope.height,
				height: scope.height
			}).embed("pdf");
		}
	};
});


angular.module('app').directive('multipleEmailValidator', dnMultipleEmailValidatorImpl);

function dnMultipleEmailValidatorImpl() {
  return {
    require: 'ngModel',
    link: dnMultipleEmailValidatorLinkImpl
  };
}

function dnMultipleEmailValidatorLinkImpl(scope, element, attributes, controller) {
  controller.$validators.multipleEmailValidator = function (modelValue, viewValue) {
    var errorFlag = true;
    if (!controller.$isEmpty(viewValue)) {
      var emailIdsArr = viewValue.split(/,|;/g);
      angular.forEach(emailIdsArr, function (value, key) {
        if (!EMAIL_PATTERN.test(value.trim())) {
          errorFlag = false;
        }
      });
    }
    return errorFlag;
  };
}

var EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


var app = angular.module('app');

app.directive('myChip', function () {
  return {
    restrict: 'EA',
    link: function link(scope, elem, attrs) {
      var myChip = elem.parent().parent();
      myChip.addClass('invalidEmail');

      scope.$watch(function () {
        return scope.$chip.active;
      }, function (newVal) {
        if (newVal) {
          myChip.addClass('invalidEmail');
        } else {
          myChip.removeClass('invalidEmail');
        }
      });
    }
  };
});


var app = angular.module('app');

app.filter('ssn', function () {
  return function (ssn) {
    if (!ssn) {
      return 'n/a';
    }
    return 'XXX-XX-' + ssn.toString().slice(5);
  };
});

app.directive('masked', ['$parse', function ($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, elm, attrs, ngModelCtrl) {
      elm.mask(attrs.format, {
        completed: function completed() {
          ngModelCtrl.$setViewValue(elm.val());
          scope.$apply();
        }
      });
    }
  };
}]);

app.directive('windowSize', function ($window) {
  return function (scope, element) {
    var w = angular.element($window);
    scope.getWindowDimensions = function () {
      return {
        h: w.height(),
        w: w.width()
      };
    };
    scope.$watch(scope.getWindowDimensions, function (newValue, oldValue) {
      scope.windowHeight = newValue.h;
      scope.windowWidth = newValue.w;
      scope.style = function () {
        return {
          height: newValue.h - 100 + 'px',
          width: newValue.w - 100 + 'px'
        };
      };
    }, true);

    w.bind('resize', function () {
      scope.$apply();
    });
  };
});
// example
// <div ng-if="windowWidth > 500">
//     <h4 style="margin:5px 0">It works!</h4>
//     <p style="margin:0">window.height: {{windowHeight}}</p>			     <p style="margin:0">window.width: {{windowWidth}}</p>			     <p style="margin:0">{{mainCtrl.test}}</p>
//   </div>


var app = angular.module('app');

app.directive('fileModel', ['$parse', '$rootScope', function ($parse, $rootScope) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.$watch('customOnChange', function (nVal) {
                element.val(nVal);
            });
            var model = $parse(attrs.fileModel);
            var modelSetter = model.assign;

            element.bind('change', function () {
                $rootScope.$apply(function () {
                    modelSetter($rootScope, element[0].files[0]);
                });
            });
        }
    };
}]);

app.directive('customOnChange', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.$watch('onChange', function (nVal) {
                element.val(nVal);
            });
            var onChangeHandler = scope.$eval(attrs.customOnChange);

            element.bind('change', function () {
                element.on('change', onChangeHandler);
                scope.$apply(function () {
                    scope.$eval(attrs.customOnChange);
                });
            });
            element.on('$destroy', function () {
                element.off();
            });
        }
    };
});

app.directive('ngFileModel', ['$parse', '$rootScope', function ($parse, $rootScope) {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            var model = $parse(attrs.ngFileModel);
            var isMultiple = attrs.multiple;
            var modelSetter = model.assign;
            element.bind('change', function () {
                var values = [];
                angular.forEach(element[0].files, function (item) {
                    var value = {
                        // File Name 
                        name: item.name,
                        //File Size 
                        size: item.size,
                        //File URL to view 
                        url: URL.createObjectURL(item),
                        // File Input Value 
                        _file: item
                    };
                    values.push(value);
                });
                scope.$apply(function () {
                    if (isMultiple) {
                        modelSetter($rootScope, values);
                    } else {
                        modelSetter($rootScope, values[0]);
                    }
                });
            });
        }
    };
}]);


/**
 * dirPagination - AngularJS module for paginating (almost) anything.
 *
 *
 * Credits
 * =======
 *
 * Daniel Tabuenca: https://groups.google.com/d/msg/angular/an9QpzqIYiM/r8v-3W1X5vcJ
 * for the idea on how to dynamically invoke the ng-repeat directive.
 *
 * I borrowed a couple of lines and a few attribute names from the AngularUI Bootstrap project:
 * https://github.com/angular-ui/bootstrap/blob/master/src/pagination/pagination.js
 *
 * Copyright 2014 Michael Bromley <michael@michaelbromley.co.uk>
 */

(function () {

    /**
     * Config
     */
    var moduleName = 'angularUtils.directives.dirPagination';
    var DEFAULT_ID = '__default';

    /**
     * Module
     */
    var module;
    try {
        module = angular.module(moduleName);
    } catch (err) {
        // named module does not exist, so create one
        module = angular.module(moduleName, []);
    }

    module.directive('dirPaginate', ['$compile', '$parse', 'paginationService', dirPaginateDirective]).directive('dirPaginateNoCompile', noCompileDirective).directive('dirPaginationControls', ['paginationService', 'paginationTemplate', dirPaginationControlsDirective]).filter('itemsPerPage', ['paginationService', itemsPerPageFilter]).service('paginationService', paginationService).provider('paginationTemplate', paginationTemplateProvider).run(['$templateCache', dirPaginationControlsTemplateInstaller]);

    function dirPaginateDirective($compile, $parse, paginationService) {

        return {
            terminal: true,
            multiElement: true,
            compile: dirPaginationCompileFn
        };

        function dirPaginationCompileFn(tElement, tAttrs) {

            var expression = tAttrs.dirPaginate;
            // regex taken directly from https://github.com/angular/angular.js/blob/master/src/ng/directive/ngRepeat.js#L211
            var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

            var filterPattern = /\|\s*itemsPerPage\s*:[^|]*/;
            if (match[2].match(filterPattern) === null) {
                throw 'pagination directive: the \'itemsPerPage\' filter must be set.';
            }
            var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
            var collectionGetter = $parse(itemsPerPageFilterRemoved);

            addNoCompileAttributes(tElement);

            // If any value is specified for paginationId, we register the un-evaluated expression at this stage for the benefit of any
            // dir-pagination-controls directives that may be looking for this ID.
            var rawId = tAttrs.paginationId || DEFAULT_ID;
            paginationService.registerInstance(rawId);

            return function dirPaginationLinkFn(scope, element, attrs) {

                // Now that we have access to the `scope` we can interpolate any expression given in the paginationId attribute and
                // potentially register a new ID if it evaluates to a different value than the rawId.
                var paginationId = $parse(attrs.paginationId)(scope) || attrs.paginationId || DEFAULT_ID;
                paginationService.registerInstance(paginationId);

                var repeatExpression = getRepeatExpression(expression, paginationId);
                addNgRepeatToElement(element, attrs, repeatExpression);

                removeTemporaryAttributes(element);
                var compiled = $compile(element);

                var currentPageGetter = makeCurrentPageGetterFn(scope, attrs, paginationId);
                paginationService.setCurrentPageParser(paginationId, currentPageGetter, scope);

                if (typeof attrs.totalItems !== 'undefined') {
                    paginationService.setAsyncModeTrue(paginationId);
                    scope.$watch(function () {
                        return $parse(attrs.totalItems)(scope);
                    }, function (result) {
                        if (0 <= result) {
                            paginationService.setCollectionLength(paginationId, result);
                        }
                    });
                } else {
                    scope.$watchCollection(function () {
                        return collectionGetter(scope);
                    }, function (collection) {
                        if (collection) {
                            paginationService.setCollectionLength(paginationId, collection.length);
                        }
                    });
                }

                // Delegate to the link function returned by the new compilation of the ng-repeat
                compiled(scope);
            };
        }

        /**
         * If a pagination id has been specified, we need to check that it is present as the second argument passed to
         * the itemsPerPage filter. If it is not there, we add it and return the modified expression.
         *
         * @param expression
         * @param paginationId
         * @returns {*}
         */
        function getRepeatExpression(expression, paginationId) {
            var repeatExpression,
                idDefinedInFilter = !!expression.match(/(\|\s*itemsPerPage\s*:[^|]*:[^|]*)/);

            if (paginationId !== DEFAULT_ID && !idDefinedInFilter) {
                repeatExpression = expression.replace(/(\|\s*itemsPerPage\s*:[^|]*)/, "$1 : '" + paginationId + "'");
            } else {
                repeatExpression = expression;
            }

            return repeatExpression;
        }

        /**
         * Adds the ng-repeat directive to the element. In the case of multi-element (-start, -end) it adds the
         * appropriate multi-element ng-repeat to the first and last element in the range.
         * @param element
         * @param attrs
         * @param repeatExpression
         */
        function addNgRepeatToElement(element, attrs, repeatExpression) {
            if (element[0].hasAttribute('dir-paginate-start') || element[0].hasAttribute('data-dir-paginate-start')) {
                // using multiElement mode (dir-paginate-start, dir-paginate-end)
                attrs.$set('ngRepeatStart', repeatExpression);
                element.eq(element.length - 1).attr('ng-repeat-end', true);
            } else {
                attrs.$set('ngRepeat', repeatExpression);
            }
        }

        /**
         * Adds the dir-paginate-no-compile directive to each element in the tElement range.
         * @param tElement
         */
        function addNoCompileAttributes(tElement) {
            angular.forEach(tElement, function (el) {
                if (el.nodeType === Node.ELEMENT_NODE) {
                    angular.element(el).attr('dir-paginate-no-compile', true);
                }
            });
        }

        /**
         * Removes the variations on dir-paginate (data-, -start, -end) and the dir-paginate-no-compile directives.
         * @param element
         */
        function removeTemporaryAttributes(element) {
            angular.forEach(element, function (el) {
                if (el.nodeType === Node.ELEMENT_NODE) {
                    angular.element(el).removeAttr('dir-paginate-no-compile');
                }
            });
            element.eq(0).removeAttr('dir-paginate-start').removeAttr('dir-paginate').removeAttr('data-dir-paginate-start').removeAttr('data-dir-paginate');
            element.eq(element.length - 1).removeAttr('dir-paginate-end').removeAttr('data-dir-paginate-end');
        }

        /**
         * Creates a getter function for the current-page attribute, using the expression provided or a default value if
         * no current-page expression was specified.
         *
         * @param scope
         * @param attrs
         * @param paginationId
         * @returns {*}
         */
        function makeCurrentPageGetterFn(scope, attrs, paginationId) {
            var currentPageGetter;
            if (attrs.currentPage) {
                currentPageGetter = $parse(attrs.currentPage);
            } else {
                // if the current-page attribute was not set, we'll make our own
                var defaultCurrentPage = paginationId + '__currentPage';
                scope[defaultCurrentPage] = 1;
                currentPageGetter = $parse(defaultCurrentPage);
            }
            return currentPageGetter;
        }
    }

    /**
     * This is a helper directive that allows correct compilation when in multi-element mode (ie dir-paginate-start, dir-paginate-end).
     * It is dynamically added to all elements in the dir-paginate compile function, and it prevents further compilation of
     * any inner directives. It is then removed in the link function, and all inner directives are then manually compiled.
     */
    function noCompileDirective() {
        return {
            priority: 5000,
            terminal: true
        };
    }

    function dirPaginationControlsTemplateInstaller($templateCache) {
        $templateCache.put('angularUtils.directives.dirPagination.template', '<ul class="pagination" ng-if="1 < pages.length"><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(1)">&laquo;</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a></li><li ng-repeat="pageNumber in pages track by $index" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }"><a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a></li><li ng-if="boundaryLinks"  ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)">&raquo;</a></li></ul>');
    }

    function dirPaginationControlsDirective(paginationService, paginationTemplate) {

        var numberRegex = /^\d+$/;

        return {
            restrict: 'AE',
            templateUrl: function templateUrl(elem, attrs) {
                return attrs.templateUrl || paginationTemplate.getPath();
            },
            scope: {
                maxSize: '=?',
                onPageChange: '&?',
                paginationId: '=?'
            },
            link: dirPaginationControlsLinkFn
        };

        function dirPaginationControlsLinkFn(scope, element, attrs) {

            // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding dir-paginate directive has
            // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
            // no corresponding dir-paginate directive and wrongly throwing an exception.
            var rawId = attrs.paginationId || DEFAULT_ID;
            var paginationId = scope.paginationId || attrs.paginationId || DEFAULT_ID;

            if (!paginationService.isRegistered(paginationId) && !paginationService.isRegistered(rawId)) {
                var idMessage = paginationId !== DEFAULT_ID ? ' (id: ' + paginationId + ') ' : ' ';
                throw 'pagination directive: the pagination controls' + idMessage + 'cannot be used without the corresponding pagination directive.';
            }

            if (!scope.maxSize) {
                scope.maxSize = 9;
            }
            scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : true;
            scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : false;

            var paginationRange = Math.max(scope.maxSize, 5);
            scope.pages = [];
            scope.pagination = {
                last: 1,
                current: 1
            };
            scope.range = {
                lower: 1,
                upper: 1,
                total: 1
            };

            scope.$watch(function () {
                return (paginationService.getCollectionLength(paginationId) + 1) * paginationService.getItemsPerPage(paginationId);
            }, function (length) {
                if (0 < length) {
                    generatePagination();
                }
            });

            scope.$watch(function () {
                return paginationService.getItemsPerPage(paginationId);
            }, function (current, previous) {
                if (current != previous && typeof previous !== 'undefined') {
                    goToPage(scope.pagination.current);
                }
            });

            scope.$watch(function () {
                return paginationService.getCurrentPage(paginationId);
            }, function (currentPage, previousPage) {
                if (currentPage != previousPage) {
                    goToPage(currentPage);
                }
            });

            scope.setCurrent = function (num) {
                if (isValidPageNumber(num)) {
                    num = parseInt(num, 10);
                    paginationService.setCurrentPage(paginationId, num);
                }
            };

            function goToPage(num) {
                if (isValidPageNumber(num)) {
                    scope.pages = generatePagesArray(num, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                    scope.pagination.current = num;
                    updateRangeValues();

                    // if a callback has been set, then call it with the page number as an argument
                    if (scope.onPageChange) {
                        scope.onPageChange({
                            newPageNumber: num
                        });
                    }
                }
            }

            function generatePagination() {
                var page = parseInt(paginationService.getCurrentPage(paginationId)) || 1;

                scope.pages = generatePagesArray(page, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                scope.pagination.current = page;
                scope.pagination.last = scope.pages[scope.pages.length - 1];
                if (scope.pagination.last < scope.pagination.current) {
                    scope.setCurrent(scope.pagination.last);
                } else {
                    updateRangeValues();
                }
            }

            /**
             * This function updates the values (lower, upper, total) of the `scope.range` object, which can be used in the pagination
             * template to display the current page range, e.g. "showing 21 - 40 of 144 results";
             */
            function updateRangeValues() {
                var currentPage = paginationService.getCurrentPage(paginationId),
                    itemsPerPage = paginationService.getItemsPerPage(paginationId),
                    totalItems = paginationService.getCollectionLength(paginationId);

                scope.range.lower = (currentPage - 1) * itemsPerPage + 1;
                scope.range.upper = Math.min(currentPage * itemsPerPage, totalItems);
                scope.range.total = totalItems;
            }

            function isValidPageNumber(num) {
                return numberRegex.test(num) && 0 < num && num <= scope.pagination.last;
            }
        }

        /**
         * Generate an array of page numbers (or the '...' string) which is used in an ng-repeat to generate the
         * links used in pagination
         *
         * @param currentPage
         * @param rowsPerPage
         * @param paginationRange
         * @param collectionLength
         * @returns {Array}
         */
        function generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
            var pages = [];
            var totalPages = Math.ceil(collectionLength / rowsPerPage);
            var halfWay = Math.ceil(paginationRange / 2);
            var position;

            if (currentPage <= halfWay) {
                position = 'start';
            } else if (totalPages - halfWay < currentPage) {
                position = 'end';
            } else {
                position = 'middle';
            }

            var ellipsesNeeded = paginationRange < totalPages;
            var i = 1;
            while (i <= totalPages && i <= paginationRange) {
                var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);

                var openingEllipsesNeeded = i === 2 && (position === 'middle' || position === 'end');
                var closingEllipsesNeeded = i === paginationRange - 1 && (position === 'middle' || position === 'start');
                if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                    pages.push('...');
                } else {
                    pages.push(pageNumber);
                }
                i++;
            }
            return pages;
        }

        /**
         * Given the position in the sequence of pagination links [i], figure out what page number corresponds to that position.
         *
         * @param i
         * @param currentPage
         * @param paginationRange
         * @param totalPages
         * @returns {*}
         */
        function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
            var halfWay = Math.ceil(paginationRange / 2);
            if (i === paginationRange) {
                return totalPages;
            } else if (i === 1) {
                return i;
            } else if (paginationRange < totalPages) {
                if (totalPages - halfWay < currentPage) {
                    return totalPages - paginationRange + i;
                } else if (halfWay < currentPage) {
                    return currentPage - halfWay + i;
                } else {
                    return i;
                }
            } else {
                return i;
            }
        }
    }

    /**
     * This filter slices the collection into pages based on the current page number and number of items per page.
     * @param paginationService
     * @returns {Function}
     */
    function itemsPerPageFilter(paginationService) {

        return function (collection, itemsPerPage, paginationId) {
            if (typeof paginationId === 'undefined') {
                paginationId = DEFAULT_ID;
            }
            if (!paginationService.isRegistered(paginationId)) {
                throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
            }
            var end;
            var start;
            if (collection instanceof Array) {
                itemsPerPage = parseInt(itemsPerPage) || 9999999999;
                if (paginationService.isAsyncMode(paginationId)) {
                    start = 0;
                } else {
                    start = (paginationService.getCurrentPage(paginationId) - 1) * itemsPerPage;
                }
                end = start + itemsPerPage;
                paginationService.setItemsPerPage(paginationId, itemsPerPage);

                return collection.slice(start, end);
            } else {
                return collection;
            }
        };
    }

    /**
     * This service allows the various parts of the module to communicate and stay in sync.
     */
    function paginationService() {

        var instances = {};
        var lastRegisteredInstance;

        this.registerInstance = function (instanceId) {
            if (typeof instances[instanceId] === 'undefined') {
                instances[instanceId] = {
                    asyncMode: false
                };
                lastRegisteredInstance = instanceId;
            }
        };

        this.isRegistered = function (instanceId) {
            return typeof instances[instanceId] !== 'undefined';
        };

        this.getLastInstanceId = function () {
            return lastRegisteredInstance;
        };

        this.setCurrentPageParser = function (instanceId, val, scope) {
            instances[instanceId].currentPageParser = val;
            instances[instanceId].context = scope;
        };
        this.setCurrentPage = function (instanceId, val) {
            instances[instanceId].currentPageParser.assign(instances[instanceId].context, val);
        };
        this.getCurrentPage = function (instanceId) {
            var parser = instances[instanceId].currentPageParser;
            return parser ? parser(instances[instanceId].context) : 1;
        };

        this.setItemsPerPage = function (instanceId, val) {
            instances[instanceId].itemsPerPage = val;
        };
        this.getItemsPerPage = function (instanceId) {
            return instances[instanceId].itemsPerPage;
        };

        this.setCollectionLength = function (instanceId, val) {
            instances[instanceId].collectionLength = val;
        };
        this.getCollectionLength = function (instanceId) {
            return instances[instanceId].collectionLength;
        };

        this.setAsyncModeTrue = function (instanceId) {
            instances[instanceId].asyncMode = true;
        };

        this.isAsyncMode = function (instanceId) {
            return instances[instanceId].asyncMode;
        };
    }

    /**
     * This provider allows global configuration of the template path used by the dir-pagination-controls directive.
     */
    function paginationTemplateProvider() {

        var templatePath = 'angularUtils.directives.dirPagination.template';

        this.setPath = function (path) {
            templatePath = path;
        };

        this.$get = function () {
            return {
                getPath: function getPath() {
                    return templatePath;
                }
            };
        };
    }
})();


angular.module('app').factory('dataService', function ($http) {
    var dataFactory = {};
    // var baseUrl = 'https://txphrmprodapi.azurewebsites.net/api/';
    var baseUrl = 'https://efsdevapi.azurewebsites.net/api/';
    // var baseUrl = 'https://txphrmprodapi.azurewebsites.net/api/';
    //http://texpertshrmdev.azurewebsites.net/token
    dataFactory.ValidateUser = function (loginmodel) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/ValidateUser',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'content-type': 'application/json'

            },
            data: loginmodel
        });
    };
    dataFactory.getToken = function (loginmodel) {
        //var deferred = $q.defer();
        var url = 'grant_type=password' + "&username=" + loginmodel.UserName + "&password=" + encodeURIComponent(loginmodel.password);
        return $http({
            method: 'POST',
            url: 'https://efsdevapi.azurewebsites.net/token',
            data: url,
            contentType: 'application/x-www-form-urlencoded'

        });
    };
    dataFactory.newToken = function (loginmodel) {
        var init = new Promise(function (resolve, reject) {
            if (localStorage.getItem("tokenData")) {
                var TD = JSON.parse(localStorage.getItem("tokenData").replace(".expires", "expires").replace(".issued", "issued"));
                var curDate = moment(new Date().toUTCString()).unix();
                var issued = moment(TD.issued).unix();
                var gapT = curDate - issued;
                var exp_in = TD.expires_in;
                if (gapT >= exp_in) {
                    var url = "grant_type=refresh_token&refresh_token=" + angular.fromJson(localStorage.getItem("tokenData")).refresh_token;
                    $http({
                        method: "POST",
                        url: "https://efsdevapi.azurewebsites.net/token",
                        data: url,
                        contentType: "application/x-www-form-urlencoded"
                    }).then(function (response) {
                        response.data.role = angular.fromJson(response.data.role);
                        localStorage.setItem("tokenData", angular.toJson(response.data));
                        localStorage.setItem("token", JSON.stringify(response.data.access_token));
                        resolve(true);
                    }).catch(function (error) {
                        reject(error.data);
                    });
                } else {
                    resolve(true);
                }
            } else {
                resolve(true);
            }
        });
        return init.then(function () {
            return true;
        });
        return init.reject(false);
        //   .catch(function(response){
        //     return reject(response);
        // });

        // var url = 'grant_type=password' + "&username=" + loginmodel.UserName + "&password=" + encodeURIComponent(loginmodel.password);
        // return $http({
        //     method: 'POST',
        //     url: 'https://efsdevapi.azurewebsites.net/token',
        //     data: url,
        //     contentType: 'application/x-www-form-urlencoded'

        // });
    };
    dataFactory.UserAssets = function (reData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/UserAssets',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.Trange = function (reData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'AcctDashboard/Trange',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.RangeByUsers = function (reData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'AcctDashboard/RangeByUsers',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.SendNotification = function (reData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'AcctDashboard/SendNotification',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.removeuser = function (reData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'Admin/removeuser',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.userwithvisaexpiry = function (reData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/userwithvisaexpiry',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.UpdateWorkAuth = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/UpdateWorkAuth',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity

            },
            data: data
        });
    };
    dataFactory.GetWorkAuthFile = function (reData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetWorkAuthFile',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reData),
            contentType: 'application/json; charset=UTF-8',
            responseType: 'arraybuffer'
        });
    };
    dataFactory.usersmissingprfdata = function (reData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/usersmissingprfdata',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetAllRoles = function (param) {
        return $http({
            method: 'GET',
            url: baseUrl + 'Role/GetAllRoles',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(param),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.CreateUser = function (UserRegisterBindingModel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Account/Register',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(UserRegisterBindingModel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetPOUrlsByProjId = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetPOUrlsByProjId',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetPOByProjId = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetPOByProjId',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json; charset=UTF-8',
            responseType: 'arraybuffer'
        });
    };
    dataFactory.UploadPO = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/UploadPO',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity

            },
            data: data
        });
    };
    dataFactory.UsersByWorkAuth = function (UsersByWorkAuth) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/UsersByWorkAuth',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(UsersByWorkAuth),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.WorkAuthList = function (WorkAuthList) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/WorkAuthList',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(WorkAuthList),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetConslWithProjCodes = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetConslWithProjCodes ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddClient = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/addclient ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddVendor = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/addvendor ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddClientMrkter = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/addclient ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.addmarketer = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/addmarketer ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddClientAddress = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/addclientaddress ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddClientAddressMrkter = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/Iaddclient',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddVendorAddress = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'Generic/AddVendorAddress ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddVendorAddressMrkter = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/Iaddvendor ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetClientsInfo = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/GetClientPartialDetails ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetClientsInfoMrkter = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/IGetClientsInfo ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetDiceIds = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetDiceIds ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetConslByDiceId = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetConslByDiceId ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetMarketerInfo = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetMarketerInfo ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetMarketerInfoMrkter = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetMarketerInfo ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.dwnAllUsersTs = function () {
        return $http({
            method: 'GET',
            url: 'factory/timesheet.js',
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.TsByPayPeriod = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'AcctDashboard/TsByPayPeriod',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.PayrollMonthInfo = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'AcctDashboard/PayrollMonthInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddVendor = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/addvendor ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddVendorMrkter = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/addvendor ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.CreateProjCode = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/CreateProjCode ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.BillhistbyProjid = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/BillhistbyProjid ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.UpdateProjInfo = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/UpdateProjInfo ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.UpdateBillRate = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/UpdateBillRate ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetBillingAdviceInfo = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetBillingAdviceInfo ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetVendorInfo = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/GetVendorPartialDetails ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetVendorInfoMrkter = function (reqData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/IGetVendorInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(reqData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetProfileByEmpid = function (GetProfileByEmpidData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'Admin/GetProfileByEmpid',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(GetProfileByEmpidData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetAllInactiveUsers = function (data) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'Common/GetAllInactiveUsers',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetAllArchivedUsers = function (data) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'Common/GetAllArchivedUsers',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.MoveUserToArchive = function (data) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'Admin/MoveUserToArchive',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetTsGuidForAdmin = function (GetTsGuidForAdminData) {
        //var deferred = $q.defer();
        return $http({
            method: 'POST',
            url: baseUrl + 'Admin/GetTsGuidForAdmin',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(GetTsGuidForAdminData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    //dataFactory.CreateUser = function(loginmodel) {
    //    //var deferred = $q.defer();
    //    return $http({
    //        method: 'POST',
    //        url: baseUrl + 'Employee/NewUser',
    //        data: angular.toJson(loginmodel),
    //        contentType: 'application/json; charset=UTF-8',
    //        dataType: 'json'
    //    });
    //};

    dataFactory.SaveUser = function (ConsultantInfomodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/SaveUser',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(ConsultantInfomodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.SendContactEmail = function (content) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/SendContactEmail',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(content),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.SaveTime = function (TimeTracker) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/SaveTime',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(TimeTracker),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetSubmittedTSids = function (TimeTracker) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetSubmittedTSids',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(TimeTracker),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetTSbyGUID = function (TimeTracker) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetTSbyGUID',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(TimeTracker),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetUserInfo = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetUserInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetCountriesList = function () {
        return $http({
            method: 'GET',
            url: baseUrl + 'Employee/GetCountriesList',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.CheckUserName = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/IsUserexists',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetRecuitersList = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetRecuitersList',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetDegreesList = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetDegreesList',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetCoursesList = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetCoursesList',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetHistory = function (params) {
        return $http({
            method: 'POST',
            url: baseUrl + 'User/GetHistory',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(params),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetResultsData = function (params) {
        return $http({
            method: 'POST',
            url: baseUrl + 'TestRun/GetResultsData',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(params),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetStepsforHist = function (id) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Steps/GetStepsforHist',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(id),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetDropDownPrefillData = function (loggedInUser) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Prefill/DropDownPrefillData',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(loggedInUser),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetDisplayResult = function (loggedInUser) {
        return $http({
            method: 'POST',
            url: baseUrl + 'values/DisplayResult',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(loggedInUser),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetDisplaySteps = function (id) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Steps/DisplaySteps',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(id),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetDataForTestRun = function (options) {
        return $http({
            method: 'POST',
            url: baseUrl + 'TestRun/GetData',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(options),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.CheckIfWfRunning = function (options) {
        return $http({
            method: 'POST',
            url: baseUrl + 'TestRun/CheckIfWfRunning',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(options),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetTimeSheetsByPP = function (param) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/GetTimeSheetsByPP',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(param),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.CreateBulkUsers = function (param) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Account/CreateBulkUsers',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(param),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.InsertBulkCreatedUsers = function (param) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Admin/InsertBulkCreatedUsers',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(param),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetBulkCreatedUsers = function (param) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Admin/GetBulkCreatedUsers',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(param),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.BulkEmpsDataUpload = function (param) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Admin/BulkEmpsDataUpload',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity

            },
            data: param
        });
    };

    dataFactory.UploadPicture = function (param) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/InsertPrfPic',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity

            },
            data: param
        });
    };
    dataFactory.UpdatePrfPic = function (param) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/UpdatePrfPic',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity

            },
            data: param
        });
    };

    dataFactory.GetProfilePic = function (param) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/GetProfilePic',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(param),
            contentType: 'application/json; charset=UTF-8',
            responseType: 'arraybuffer'
        });
    };
    dataFactory.GetAllUsers = function (param) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Common/GetAllUsers',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(param),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetAllUsersHR = function (param) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetAllUsers',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(param),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetSubmittedTSForAccounts = function (param) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/GetSubmittedTSForAccounts',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(param),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.UpdateUser = function (params) {
        return $http({
            method: 'POST',
            url: baseUrl + 'User/UpdateUser',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(params),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.UpdateUserRoles = function (params) {
        return $http({
            method: 'POST',
            url: baseUrl + 'User/UpdateRoles',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(params),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetScheduledTasks = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'Scheduler/GetScheduledTasks',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.ScheduleTask = function (task) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Scheduler/CreatTask',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(task),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.UpdateScheduledTask = function (task) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Scheduler/UpdateTask',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(task),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.UpdatePassword = function (task) {
        return $http({
            method: 'POST',
            url: baseUrl + 'User/UpdatePassword',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(task),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.UploadFiles = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/FileUpload',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity

            },
            data: data
        });
    };

    dataFactory.GetProfilePictureInfo = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetProfilePictureInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: loginmodel,
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.UploadImage = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/UploadImage',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined

            },
            data: data,
            transformRequest: angular.identity
        });
    };

    dataFactory.GetListOfDocuments = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetAllFilesForUser',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: loginmodel,
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetFileToDownload = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetFileToDownload',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: loginmodel,
            contentType: 'application/json;',
            responseType: 'arraybuffer'
        });
    };
    dataFactory.GetDocumentsForAdmin = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Admin/GetListOfDocuments',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: loginmodel,
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.CheckIfTsExists = function (TimeTracker) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/CheckIfAdminTsExists',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(TimeTracker),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetBackOfficeMailList = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetBackOfficeMailList',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.inertbkoffemail = function (input) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/InsertBackOffEmail',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(input),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetTimeSheets = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetTimeSheets',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.UpdateTimeStatus = function (timemodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/ApproveorReject',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(timemodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetEmailBody = function (titles) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetEmailBody',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(titles),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AdminSendEmail = function (obj) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Admin/SendEmail',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(obj),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.Getmgrtoconsultant = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/Getmgrtoconsultant',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetManagersList = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'Common/GetManagersList',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetRolesList = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetRoles',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetProfileData = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetProfileData',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetProfileDataHr = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Common/GetProfileData',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.UpdateProfile = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/UpdateProfile',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.Editmgrtoconsultant = function (mgrToConsultantInfo) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/Editmgrtoconsultant',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(mgrToConsultantInfo),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.InsertContactInfo = function (cModel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/InsertContactInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(cModel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.UpdateProfileInfo = function (lgnmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/UpdateProfileInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(lgnmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.InsertOrUpdateIdentityInfo = function (IdentificationModel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/InsertOrUpdateIdentityInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(IdentificationModel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.InsertEmpFrmExpInfo = function (EmployeeWorkExpModel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/InsertEmpFrmExpInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(EmployeeWorkExpModel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.InsertAddressInfo = function (aModel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/InsertAddressInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(aModel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.LookUpData = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/LookUpData',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetIdleValues = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetValues',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetDocDDValues = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetDocDDValues',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetAcctDonutInfobyPP = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/GetAcctDonutInfobyPP',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetAcctDonutInfo = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/GetAcctDonutInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetEmployeByMonth = function () {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetEmployeByMonth',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.forgotpw = function (forgotpwmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/ForgotPw',
            data: angular.toJson(forgotpwmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.ChangePassword = function (changePasswordpwmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Account/ChangePassword',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(changePasswordpwmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetCountriesData = function () {
        return $http({
            method: 'GET',
            url: 'app/factory/countries.js',
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetStatesList = function () {
        return $http({
            method: 'GET',
            url: 'app/factory/states.json',
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.vendorsStub = function () {
        return $http({
            method: 'GET',
            url: 'app/factory/vendors.json',
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetTimeSheetsForAccounts = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/GetTimeSheetsForAccounts',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetCTSFile = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/GetCTSFile',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            responseType: 'arraybuffer'
        });
    };

    dataFactory.GetClients = function (prfId) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetClients',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(prfId),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AcctsAppOrReject = function (tsData) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/AcctsAppOrReject',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(tsData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.MgrAppOrReject = function (tsData) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/MgrAppOrReject',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(tsData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetUsersByManagerId = function (tsData) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/GetUsersByManagerId',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(tsData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetCTSSubtRanges = function (tsData) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Employee/GetCTSSubtRanges',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(tsData),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.InsertCTSReq = function (fdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Ttracker/InsertCTS',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity

            },
            data: fdata
        });
    };

    dataFactory.GetPresLookup = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Predash/GetPresLookup',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetStartsByDates = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Predash/GetStartsByDates',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.PlacmentsByVendor = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Predash/PlacmentsByVendor',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.w2Users = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Predash/W2UsersDisplayNames',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.PlacmentsByClients = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Predash/PlacmentsByClients',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.TotalActiveConslByPayRateRange = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Predash/TotalActiveConslByPayRateRange',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddTitle = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/AddTitle',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetPayRaiseInfo = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetPayRaiseInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.xreflkup = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/xreflkup',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetClientInfoByClientId = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/GetClientInfoByClientId',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetVendorInfoByVendorId = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/GetVendorInfoByVendorId',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.addvendorActInfo = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/addvendorActInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.editvendorActInfo = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/editvendorActInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.editclient = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/updateclient',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.updateclientaddress = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/updateClientAddress',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.addclientaddress = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/addclientaddress',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.editvendor = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/updatevendor',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.updatevendoraddress = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/updatevendoraddress',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.addvendoraddress = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/addvendoraddress',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetVendorRatingById = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/GetVendorRatingById',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.CreateOrUpdateRating = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/CreateOrUpdateRating',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddTitleMrkter = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/AddTitle',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetTitleDD = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetTitleDD',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetTitleDDMrkter = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetTitleDD',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetWrkAuthDD = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetWrkAuthDD',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetWorkAuthHistroyById = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/GetWorkAuthHistroyById',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.InsertWorkAuth = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/InsertWorkAuth',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity

            },
            data: data
        });
    };
    dataFactory.AddWorkAuth = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/AddWorkAuth',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.ProjCodesByPrfid = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'hrDashboard/ProjCodesByPrfid',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetEmailCountDetails = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MassEmail/GetEmailCountDetails',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.MassEmail = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MassEmail/sendemail',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetMrkterLookUp = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetMrkterLookUp',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetHotListConsl = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetHotListConsl',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetConsls = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetConsls',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetConslsEmails = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetConslsEmails',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.addorupdateIcalendar = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/addorupdateIcalendar',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetIcalendar = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetIcalendar',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.addInterview = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/AddInterview',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.UpdateInterviewStatus = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/UpdateEventInterviewStatus',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.UpdateFinalInterviewStatus = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/UpdateFinalInterviewStatus',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    // dataFactory.GetInterviews = function (rdata) {
    //     return $http({
    //         method: 'POST',
    //         url: baseUrl + 'MrkterDashBrd/GetInterviews',
    //         headers: {
    //             'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
    //         },
    //         data: angular.toJson(rdata),
    //         contentType: 'application/json; charset=UTF-8',
    //         dataType: 'json'
    //     });
    // };

    dataFactory.GetInterviews = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetInterviews',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.Interviewlookup = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/Interviewlookup',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.updateConsultant = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/UpdateConslStatus',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.updateConslsHotList = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/UpdateConslInfo',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.addConsl = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/addConsl',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AddSkillSet = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/AddSkillSet',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.addSubmissions = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/addSub',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.getSubmissions = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/getsub',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.updateSub = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/updatesub',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetDocDD = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetDocDD',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.InsertDocDD = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/InsertDocDD',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.Getfileurl = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/Getfileurl',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json;',
            responseType: 'arraybuffer'
        });
    };
    dataFactory.getAgreementDocs = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/GetVendorDocsurl',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json;',
            responseType: 'arraybuffer'
        });
    };
    dataFactory.InvalidEmails = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MassEmail/InvalidEmails',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json;',
            dataType: 'json'
        });
    };

    dataFactory.UploadDocument = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/UploadDocument',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity
            },
            data: data
        });
    };
    dataFactory.UploadVendorDocument = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'ClientXref/UploadVendorDocument',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity

            },
            data: data
        });
    };
    dataFactory.UploadResume = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/UploadResume',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity
            },
            data: data
        });
    };
    dataFactory.DownloadResume = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/DownloadResume',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            responseType: 'arraybuffer'
        });
    };
    dataFactory.UploadToDB = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MassEmail/UploadToDB',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.getsubforadmin = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'AdminMrkter/getsubforadmin',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.IMrkplonboard = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/IMrkplonboard',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetPlacmentDetailsById = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetPlacmentDetailsById',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetallPlacDetails = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetallPlacDetails',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetPlacmentDetailsById = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetPlacmentDetailsById',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    //Api for getallplacedinterviewdetails
    dataFactory.GetAllPlacedIntviewDetailsByMarketerId = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetAllPlacedIntviewDetailsByMarketerId',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.GetPlacedIntviewDetails = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetPlacedIntviewDetails',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.UpdatePriority = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/UpdatePriority',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.UpdateMarkIdForInvid = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/UpdateMarkIdForInvid',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    //job posting
    dataFactory.JobPosting = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Job/JP',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.GetJobs = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Job/GJP',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.AppliedConsByJobId = function (loginmodel) {
        return $http({
            method: 'POST',
            url: baseUrl + '/Job/AppliedConsByJobId',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(loginmodel),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.applyJob = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Job/JA',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity

            },
            data: data
        });
    };
    dataFactory.removeJA = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Job/RAJ',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.removeJP = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Job/RJP',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.updateJStatus = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Job/UJS',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };
    dataFactory.updateComments = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Job/UJComments',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
        });
    };

    dataFactory.JPDownloadResume = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Job/DownloadResume',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8',
            responseType: 'arraybuffer'
        });
    };
    dataFactory.GetInvActivityByConslid = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetInvActivityByConslid',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json; charset=UTF-8'
        });
    };
    dataFactory.cres = function (rdata) {
        return $http({
            method: 'POST',
            url: 'http://localhost:3000/CrRes',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Accept": "*/*"
            },
            data: angular.toJson(rdata)
        });
    };
    dataFactory.getAccsTok = function (rdata) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Dice/GetTokenForDice',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(rdata),
            contentType: 'application/json;'
        });
    };

    dataFactory.GetDiceProfiles = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Dice/ProfileSearch',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json;',
            dataType: 'json'
        });
    };
    dataFactory.GetProfileById = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Dice/GetProfileById',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json;',
            dataType: 'json'
        });
    };
    dataFactory.GetDiceHitCount = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Dice/GetDiceHitCount',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json;',
            dataType: 'json'
        });
    };
    dataFactory.diceProfileDownload = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'Dice/DownloadResume',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))

            },
            data: angular.toJson(data),
            contentType: 'application/json; charset=UTF-8',
            responseType: 'arraybuffer'
        });
    };
    dataFactory.GetContactsList = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MassEmail/GetMarketerContactFilesByLoginid',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json;',
            dataType: 'json'
        });
    };
    dataFactory.GetContactListData = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MassEmail/GetMarketerContactsByContactId',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json;',
            dataType: 'json'
        });
    };
    dataFactory.DelContactList = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/DelContactList',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json;',
            dataType: 'json'
        });
    };
    dataFactory.GetConslByConslId = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MrkterDashBrd/GetConslByConslId',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token'))
            },
            data: angular.toJson(data),
            contentType: 'application/json;',
            dataType: 'json'
        });
    };

    dataFactory.UploadContactsList = function (data) {
        return $http({
            method: 'POST',
            url: baseUrl + 'MassEmail/InsertMarketerContacts',
            headers: {
                'Authorization': 'Bearer ' + angular.fromJson(localStorage.getItem('token')),
                'Content-Type': undefined,
                'transformRequest': angular.identity

            },
            data: data
        });
    };
    dataFactory.Getconsldocs = function (data) {
        return $http({
            method: "POST",
            url: baseUrl + "MrkterDashBrd/Getconsldocs",
            headers: {
                Authorization: "Bearer " + angular.fromJson(localStorage.getItem("token"))
            },
            data: angular.toJson(data),
            contentType: "application/json;",
            dataType: "json"
        });
    };

    return dataFactory;
});


[{
  "CountryName": "Bangladesh",
  "CtyCode": "BD",
  "CtyID": 2
}, {
  "CountryName": "Belgium",
  "CtyCode": "BE",
  "CtyID": 3
}, {
  "CountryName": "Burkina Faso",
  "CtyCode": "BF",
  "CtyID": 4
}, {
  "CountryName": "Bulgaria",
  "CtyCode": "BG",
  "CtyID": 5
}, {
  "CountryName": "Bosnia and Herzegovina",
  "CtyCode": "BA",
  "CtyID": 6
}, {
  "CountryName": "Barbados",
  "CtyCode": "BB",
  "CtyID": 7
}, {
  "CountryName": "Wallis and Futuna",
  "CtyCode": "WF",
  "CtyID": 8
}, {
  "CountryName": "Saint Barthelemy",
  "CtyCode": "BL",
  "CtyID": 9
}, {
  "CountryName": "Bermuda",
  "CtyCode": "BM",
  "CtyID": 10
}, {
  "CountryName": "Brunei",
  "CtyCode": "BN",
  "CtyID": 11
}, {
  "CountryName": "Bolivia",
  "CtyCode": "BO",
  "CtyID": 12
}, {
  "CountryName": "Bahrain",
  "CtyCode": "BH",
  "CtyID": 13
}, {
  "CountryName": "Burundi",
  "CtyCode": "BI",
  "CtyID": 14
}, {
  "CountryName": "Benin",
  "CtyCode": "BJ",
  "CtyID": 15
}, {
  "CountryName": "Bhutan",
  "CtyCode": "BT",
  "CtyID": 16
}, {
  "CountryName": "Jamaica",
  "CtyCode": "JM",
  "CtyID": 17
}, {
  "CountryName": "Bouvet Island",
  "CtyCode": "BV",
  "CtyID": 18
}, {
  "CountryName": "Botswana",
  "CtyCode": "BW",
  "CtyID": 19
}, {
  "CountryName": "Samoa",
  "CtyCode": "WS",
  "CtyID": 20
}, {
  "CountryName": "Bonaire, Saint Eustatius and Saba ",
  "CtyCode": "BQ",
  "CtyID": 21
}, {
  "CountryName": "Brazil",
  "CtyCode": "BR",
  "CtyID": 22
}, {
  "CountryName": "Bahamas",
  "CtyCode": "BS",
  "CtyID": 23
}, {
  "CountryName": "Jersey",
  "CtyCode": "JE",
  "CtyID": 24
}, {
  "CountryName": "Belarus",
  "CtyCode": "BY",
  "CtyID": 25
}, {
  "CountryName": "Belize",
  "CtyCode": "BZ",
  "CtyID": 26
}, {
  "CountryName": "Russia",
  "CtyCode": "RU",
  "CtyID": 27
}, {
  "CountryName": "Rwanda",
  "CtyCode": "RW",
  "CtyID": 28
}, {
  "CountryName": "Serbia",
  "CtyCode": "RS",
  "CtyID": 29
}, {
  "CountryName": "East Timor",
  "CtyCode": "TL",
  "CtyID": 30
}, {
  "CountryName": "Reunion",
  "CtyCode": "RE",
  "CtyID": 31
}, {
  "CountryName": "Turkmenistan",
  "CtyCode": "TM",
  "CtyID": 32
}, {
  "CountryName": "Tajikistan",
  "CtyCode": "TJ",
  "CtyID": 33
}, {
  "CountryName": "Romania",
  "CtyCode": "RO",
  "CtyID": 34
}, {
  "CountryName": "Tokelau",
  "CtyCode": "TK",
  "CtyID": 35
}, {
  "CountryName": "Guinea-Bissau",
  "CtyCode": "GW",
  "CtyID": 36
}, {
  "CountryName": "Guam",
  "CtyCode": "GU",
  "CtyID": 37
}, {
  "CountryName": "Guatemala",
  "CtyCode": "GT",
  "CtyID": 38
}, {
  "CountryName": "South Georgia and the South Sandwich Islands",
  "CtyCode": "GS",
  "CtyID": 39
}, {
  "CountryName": "Greece",
  "CtyCode": "GR",
  "CtyID": 40
}, {
  "CountryName": "Equatorial Guinea",
  "CtyCode": "GQ",
  "CtyID": 41
}, {
  "CountryName": "Guadeloupe",
  "CtyCode": "GP",
  "CtyID": 42
}, {
  "CountryName": "Japan",
  "CtyCode": "JP",
  "CtyID": 43
}, {
  "CountryName": "Guyana",
  "CtyCode": "GY",
  "CtyID": 44
}, {
  "CountryName": "Guernsey",
  "CtyCode": "GG",
  "CtyID": 45
}, {
  "CountryName": "French Guiana",
  "CtyCode": "GF",
  "CtyID": 46
}, {
  "CountryName": "Georgia",
  "CtyCode": "GE",
  "CtyID": 47
}, {
  "CountryName": "Grenada",
  "CtyCode": "GD",
  "CtyID": 48
}, {
  "CountryName": "United Kingdom",
  "CtyCode": "GB",
  "CtyID": 49
}, {
  "CountryName": "Gabon",
  "CtyCode": "GA",
  "CtyID": 50
}, {
  "CountryName": "El Salvador",
  "CtyCode": "SV",
  "CtyID": 51
}, {
  "CountryName": "Guinea",
  "CtyCode": "GN",
  "CtyID": 52
}, {
  "CountryName": "Gambia",
  "CtyCode": "GM",
  "CtyID": 53
}, {
  "CountryName": "Greenland",
  "CtyCode": "GL",
  "CtyID": 54
}, {
  "CountryName": "Gibraltar",
  "CtyCode": "GI",
  "CtyID": 55
}, {
  "CountryName": "Ghana",
  "CtyCode": "GH",
  "CtyID": 56
}, {
  "CountryName": "Oman",
  "CtyCode": "OM",
  "CtyID": 57
}, {
  "CountryName": "Tunisia",
  "CtyCode": "TN",
  "CtyID": 58
}, {
  "CountryName": "Jordan",
  "CtyCode": "JO",
  "CtyID": 59
}, {
  "CountryName": "Croatia",
  "CtyCode": "HR",
  "CtyID": 60
}, {
  "CountryName": "Haiti",
  "CtyCode": "HT",
  "CtyID": 61
}, {
  "CountryName": "Hungary",
  "CtyCode": "HU",
  "CtyID": 62
}, {
  "CountryName": "Hong Kong",
  "CtyCode": "HK",
  "CtyID": 63
}, {
  "CountryName": "Honduras",
  "CtyCode": "HN",
  "CtyID": 64
}, {
  "CountryName": "Heard Island and McDonald Islands",
  "CtyCode": "HM",
  "CtyID": 65
}, {
  "CountryName": "Venezuela",
  "CtyCode": "VE",
  "CtyID": 66
}, {
  "CountryName": "Puerto Rico",
  "CtyCode": "PR",
  "CtyID": 67
}, {
  "CountryName": "Palestinian Territory",
  "CtyCode": "PS",
  "CtyID": 68
}, {
  "CountryName": "Palau",
  "CtyCode": "PW",
  "CtyID": 69
}, {
  "CountryName": "Portugal",
  "CtyCode": "PT",
  "CtyID": 70
}, {
  "CountryName": "Svalbard and Jan Mayen",
  "CtyCode": "SJ",
  "CtyID": 71
}, {
  "CountryName": "Paraguay",
  "CtyCode": "PY",
  "CtyID": 72
}, {
  "CountryName": "Iraq",
  "CtyCode": "IQ",
  "CtyID": 73
}, {
  "CountryName": "Panama",
  "CtyCode": "PA",
  "CtyID": 74
}, {
  "CountryName": "French Polynesia",
  "CtyCode": "PF",
  "CtyID": 75
}, {
  "CountryName": "Papua New Guinea",
  "CtyCode": "PG",
  "CtyID": 76
}, {
  "CountryName": "Peru",
  "CtyCode": "PE",
  "CtyID": 77
}, {
  "CountryName": "Pakistan",
  "CtyCode": "PK",
  "CtyID": 78
}, {
  "CountryName": "Philippines",
  "CtyCode": "PH",
  "CtyID": 79
}, {
  "CountryName": "Pitcairn",
  "CtyCode": "PN",
  "CtyID": 80
}, {
  "CountryName": "Poland",
  "CtyCode": "PL",
  "CtyID": 81
}, {
  "CountryName": "Saint Pierre and Miquelon",
  "CtyCode": "PM",
  "CtyID": 82
}, {
  "CountryName": "Zambia",
  "CtyCode": "ZM",
  "CtyID": 83
}, {
  "CountryName": "Western Sahara",
  "CtyCode": "EH",
  "CtyID": 84
}, {
  "CountryName": "Estonia",
  "CtyCode": "EE",
  "CtyID": 85
}, {
  "CountryName": "Egypt",
  "CtyCode": "EG",
  "CtyID": 86
}, {
  "CountryName": "South Africa",
  "CtyCode": "ZA",
  "CtyID": 87
}, {
  "CountryName": "Ecuador",
  "CtyCode": "EC",
  "CtyID": 88
}, {
  "CountryName": "Italy",
  "CtyCode": "IT",
  "CtyID": 89
}, {
  "CountryName": "Vietnam",
  "CtyCode": "VN",
  "CtyID": 90
}, {
  "CountryName": "Solomon Islands",
  "CtyCode": "SB",
  "CtyID": 91
}, {
  "CountryName": "Ethiopia",
  "CtyCode": "ET",
  "CtyID": 92
}, {
  "CountryName": "Somalia",
  "CtyCode": "SO",
  "CtyID": 93
}, {
  "CountryName": "Zimbabwe",
  "CtyCode": "ZW",
  "CtyID": 94
}, {
  "CountryName": "Saudi Arabia",
  "CtyCode": "SA",
  "CtyID": 95
}, {
  "CountryName": "Spain",
  "CtyCode": "ES",
  "CtyID": 96
}, {
  "CountryName": "Eritrea",
  "CtyCode": "ER",
  "CtyID": 97
}, {
  "CountryName": "Montenegro",
  "CtyCode": "ME",
  "CtyID": 98
}, {
  "CountryName": "Moldova",
  "CtyCode": "MD",
  "CtyID": 99
}, {
  "CountryName": "Madagascar",
  "CtyCode": "MG",
  "CtyID": 100
}, {
  "CountryName": "Saint Martin",
  "CtyCode": "MF",
  "CtyID": 101
}, {
  "CountryName": "Morocco",
  "CtyCode": "MA",
  "CtyID": 102
}, {
  "CountryName": "Monaco",
  "CtyCode": "MC",
  "CtyID": 103
}, {
  "CountryName": "Uzbekistan",
  "CtyCode": "UZ",
  "CtyID": 104
}, {
  "CountryName": "Myanmar",
  "CtyCode": "MM",
  "CtyID": 105
}, {
  "CountryName": "Mali",
  "CtyCode": "ML",
  "CtyID": 106
}, {
  "CountryName": "Macao",
  "CtyCode": "MO",
  "CtyID": 107
}, {
  "CountryName": "Mongolia",
  "CtyCode": "MN",
  "CtyID": 108
}, {
  "CountryName": "Marshall Islands",
  "CtyCode": "MH",
  "CtyID": 109
}, {
  "CountryName": "Macedonia",
  "CtyCode": "MK",
  "CtyID": 110
}, {
  "CountryName": "Mauritius",
  "CtyCode": "MU",
  "CtyID": 111
}, {
  "CountryName": "Malta",
  "CtyCode": "MT",
  "CtyID": 112
}, {
  "CountryName": "Malawi",
  "CtyCode": "MW",
  "CtyID": 113
}, {
  "CountryName": "Maldives",
  "CtyCode": "MV",
  "CtyID": 114
}, {
  "CountryName": "Martinique",
  "CtyCode": "MQ",
  "CtyID": 115
}, {
  "CountryName": "Northern Mariana Islands",
  "CtyCode": "MP",
  "CtyID": 116
}, {
  "CountryName": "Montserrat",
  "CtyCode": "MS",
  "CtyID": 117
}, {
  "CountryName": "Mauritania",
  "CtyCode": "MR",
  "CtyID": 118
}, {
  "CountryName": "Isle of Man",
  "CtyCode": "IM",
  "CtyID": 119
}, {
  "CountryName": "Uganda",
  "CtyCode": "UG",
  "CtyID": 120
}, {
  "CountryName": "Tanzania",
  "CtyCode": "TZ",
  "CtyID": 121
}, {
  "CountryName": "Malaysia",
  "CtyCode": "MY",
  "CtyID": 122
}, {
  "CountryName": "Mexico",
  "CtyCode": "MX",
  "CtyID": 123
}, {
  "CountryName": "Israel",
  "CtyCode": "IL",
  "CtyID": 124
}, {
  "CountryName": "France",
  "CtyCode": "FR",
  "CtyID": 125
}, {
  "CountryName": "British Indian Ocean Territory",
  "CtyCode": "IO",
  "CtyID": 126
}, {
  "CountryName": "Saint Helena",
  "CtyCode": "SH",
  "CtyID": 127
}, {
  "CountryName": "Finland",
  "CtyCode": "FI",
  "CtyID": 128
}, {
  "CountryName": "Fiji",
  "CtyCode": "FJ",
  "CtyID": 129
}, {
  "CountryName": "Falkland Islands",
  "CtyCode": "FK",
  "CtyID": 130
}, {
  "CountryName": "Micronesia",
  "CtyCode": "FM",
  "CtyID": 131
}, {
  "CountryName": "Faroe Islands",
  "CtyCode": "FO",
  "CtyID": 132
}, {
  "CountryName": "Nicaragua",
  "CtyCode": "NI",
  "CtyID": 133
}, {
  "CountryName": "Netherlands",
  "CtyCode": "NL",
  "CtyID": 134
}, {
  "CountryName": "Norway",
  "CtyCode": "NO",
  "CtyID": 135
}, {
  "CountryName": "Namibia",
  "CtyCode": "NA",
  "CtyID": 136
}, {
  "CountryName": "Vanuatu",
  "CtyCode": "VU",
  "CtyID": 137
}, {
  "CountryName": "New Caledonia",
  "CtyCode": "NC",
  "CtyID": 138
}, {
  "CountryName": "Niger",
  "CtyCode": "NE",
  "CtyID": 139
}, {
  "CountryName": "Norfolk Island",
  "CtyCode": "NF",
  "CtyID": 140
}, {
  "CountryName": "Nigeria",
  "CtyCode": "NG",
  "CtyID": 141
}, {
  "CountryName": "New Zealand",
  "CtyCode": "NZ",
  "CtyID": 142
}, {
  "CountryName": "Nepal",
  "CtyCode": "NP",
  "CtyID": 143
}, {
  "CountryName": "Nauru",
  "CtyCode": "NR",
  "CtyID": 144
}, {
  "CountryName": "Niue",
  "CtyCode": "NU",
  "CtyID": 145
}, {
  "CountryName": "Cook Islands",
  "CtyCode": "CK",
  "CtyID": 146
}, {
  "CountryName": "Kosovo",
  "CtyCode": "XK",
  "CtyID": 147
}, {
  "CountryName": "Ivory Coast",
  "CtyCode": "CI",
  "CtyID": 148
}, {
  "CountryName": "Switzerland",
  "CtyCode": "CH",
  "CtyID": 149
}, {
  "CountryName": "Colombia",
  "CtyCode": "CO",
  "CtyID": 150
}, {
  "CountryName": "China",
  "CtyCode": "CN",
  "CtyID": 151
}, {
  "CountryName": "Cameroon",
  "CtyCode": "CM",
  "CtyID": 152
}, {
  "CountryName": "Chile",
  "CtyCode": "CL",
  "CtyID": 153
}, {
  "CountryName": "Cocos Islands",
  "CtyCode": "CC",
  "CtyID": 154
}, {
  "CountryName": "Canada",
  "CtyCode": "CA",
  "CtyID": 155
}, {
  "CountryName": "Republic of the Congo",
  "CtyCode": "CG",
  "CtyID": 156
}, {
  "CountryName": "Central African Republic",
  "CtyCode": "CF",
  "CtyID": 157
}, {
  "CountryName": "Democratic Republic of the Congo",
  "CtyCode": "CD",
  "CtyID": 158
}, {
  "CountryName": "Czech Republic",
  "CtyCode": "CZ",
  "CtyID": 159
}, {
  "CountryName": "Cyprus",
  "CtyCode": "CY",
  "CtyID": 160
}, {
  "CountryName": "Christmas Island",
  "CtyCode": "CX",
  "CtyID": 161
}, {
  "CountryName": "Costa Rica",
  "CtyCode": "CR",
  "CtyID": 162
}, {
  "CountryName": "Curacao",
  "CtyCode": "CW",
  "CtyID": 163
}, {
  "CountryName": "Cape Verde",
  "CtyCode": "CV",
  "CtyID": 164
}, {
  "CountryName": "Cuba",
  "CtyCode": "CU",
  "CtyID": 165
}, {
  "CountryName": "Swaziland",
  "CtyCode": "SZ",
  "CtyID": 166
}, {
  "CountryName": "Syria",
  "CtyCode": "SY",
  "CtyID": 167
}, {
  "CountryName": "Sint Maarten",
  "CtyCode": "SX",
  "CtyID": 168
}, {
  "CountryName": "Kyrgyzstan",
  "CtyCode": "KG",
  "CtyID": 169
}, {
  "CountryName": "Kenya",
  "CtyCode": "KE",
  "CtyID": 170
}, {
  "CountryName": "South Sudan",
  "CtyCode": "SS",
  "CtyID": 171
}, {
  "CountryName": "Suriname",
  "CtyCode": "SR",
  "CtyID": 172
}, {
  "CountryName": "Kiribati",
  "CtyCode": "KI",
  "CtyID": 173
}, {
  "CountryName": "Cambodia",
  "CtyCode": "KH",
  "CtyID": 174
}, {
  "CountryName": "Saint Kitts and Nevis",
  "CtyCode": "KN",
  "CtyID": 175
}, {
  "CountryName": "Comoros",
  "CtyCode": "KM",
  "CtyID": 176
}, {
  "CountryName": "Sao Tome and Principe",
  "CtyCode": "ST",
  "CtyID": 177
}, {
  "CountryName": "Slovakia",
  "CtyCode": "SK",
  "CtyID": 178
}, {
  "CountryName": "South Korea",
  "CtyCode": "KR",
  "CtyID": 179
}, {
  "CountryName": "Slovenia",
  "CtyCode": "SI",
  "CtyID": 180
}, {
  "CountryName": "North Korea",
  "CtyCode": "KP",
  "CtyID": 181
}, {
  "CountryName": "Kuwait",
  "CtyCode": "KW",
  "CtyID": 182
}, {
  "CountryName": "Senegal",
  "CtyCode": "SN",
  "CtyID": 183
}, {
  "CountryName": "San Marino",
  "CtyCode": "SM",
  "CtyID": 184
}, {
  "CountryName": "Sierra Leone",
  "CtyCode": "SL",
  "CtyID": 185
}, {
  "CountryName": "Seychelles",
  "CtyCode": "SC",
  "CtyID": 186
}, {
  "CountryName": "Kazakhstan",
  "CtyCode": "KZ",
  "CtyID": 187
}, {
  "CountryName": "Cayman Islands",
  "CtyCode": "KY",
  "CtyID": 188
}, {
  "CountryName": "Singapore",
  "CtyCode": "SG",
  "CtyID": 189
}, {
  "CountryName": "Sweden",
  "CtyCode": "SE",
  "CtyID": 190
}, {
  "CountryName": "Sudan",
  "CtyCode": "SD",
  "CtyID": 191
}, {
  "CountryName": "Dominican Republic",
  "CtyCode": "DO",
  "CtyID": 192
}, {
  "CountryName": "Dominica",
  "CtyCode": "DM",
  "CtyID": 193
}, {
  "CountryName": "Djibouti",
  "CtyCode": "DJ",
  "CtyID": 194
}, {
  "CountryName": "Denmark",
  "CtyCode": "DK",
  "CtyID": 195
}, {
  "CountryName": "British Virgin Islands",
  "CtyCode": "VG",
  "CtyID": 196
}, {
  "CountryName": "Germany",
  "CtyCode": "DE",
  "CtyID": 197
}, {
  "CountryName": "Yemen",
  "CtyCode": "YE",
  "CtyID": 198
}, {
  "CountryName": "Algeria",
  "CtyCode": "DZ",
  "CtyID": 199
}, {
  "CountryName": "United States",
  "CtyCode": "US",
  "CtyID": 200
}, {
  "CountryName": "Uruguay",
  "CtyCode": "UY",
  "CtyID": 201
}, {
  "CountryName": "Mayotte",
  "CtyCode": "YT",
  "CtyID": 202
}, {
  "CountryName": "United States Minor Outlying Islands",
  "CtyCode": "UM",
  "CtyID": 203
}, {
  "CountryName": "Lebanon",
  "CtyCode": "LB",
  "CtyID": 204
}, {
  "CountryName": "Saint Lucia",
  "CtyCode": "LC",
  "CtyID": 205
}, {
  "CountryName": "Laos",
  "CtyCode": "LA",
  "CtyID": 206
}, {
  "CountryName": "Tuvalu",
  "CtyCode": "TV",
  "CtyID": 207
}, {
  "CountryName": "Taiwan",
  "CtyCode": "TW",
  "CtyID": 208
}, {
  "CountryName": "Trinidad and Tobago",
  "CtyCode": "TT",
  "CtyID": 209
}, {
  "CountryName": "Turkey",
  "CtyCode": "TR",
  "CtyID": 210
}, {
  "CountryName": "Sri Lanka",
  "CtyCode": "LK",
  "CtyID": 211
}, {
  "CountryName": "Liechtenstein",
  "CtyCode": "LI",
  "CtyID": 212
}, {
  "CountryName": "Latvia",
  "CtyCode": "LV",
  "CtyID": 213
}, {
  "CountryName": "Tonga",
  "CtyCode": "TO",
  "CtyID": 214
}, {
  "CountryName": "Lithuania",
  "CtyCode": "LT",
  "CtyID": 215
}, {
  "CountryName": "Luxembourg",
  "CtyCode": "LU",
  "CtyID": 216
}, {
  "CountryName": "Liberia",
  "CtyCode": "LR",
  "CtyID": 217
}, {
  "CountryName": "Lesotho",
  "CtyCode": "LS",
  "CtyID": 218
}, {
  "CountryName": "Thailand",
  "CtyCode": "TH",
  "CtyID": 219
}, {
  "CountryName": "French Southern Territories",
  "CtyCode": "TF",
  "CtyID": 220
}, {
  "CountryName": "Togo",
  "CtyCode": "TG",
  "CtyID": 221
}, {
  "CountryName": "Chad",
  "CtyCode": "TD",
  "CtyID": 222
}, {
  "CountryName": "Turks and Caicos Islands",
  "CtyCode": "TC",
  "CtyID": 223
}, {
  "CountryName": "Libya",
  "CtyCode": "LY",
  "CtyID": 224
}, {
  "CountryName": "Vatican",
  "CtyCode": "VA",
  "CtyID": 225
}, {
  "CountryName": "Saint Vincent and the Grenadines",
  "CtyCode": "VC",
  "CtyID": 226
}, {
  "CountryName": "United Arab Emirates",
  "CtyCode": "AE",
  "CtyID": 227
}, {
  "CountryName": "Andorra",
  "CtyCode": "AD",
  "CtyID": 228
}, {
  "CountryName": "Antigua and Barbuda",
  "CtyCode": "AG",
  "CtyID": 229
}, {
  "CountryName": "Afghanistan",
  "CtyCode": "AF",
  "CtyID": 230
}, {
  "CountryName": "Anguilla",
  "CtyCode": "AI",
  "CtyID": 231
}, {
  "CountryName": "U.S. Virgin Islands",
  "CtyCode": "VI",
  "CtyID": 232
}, {
  "CountryName": "Iceland",
  "CtyCode": "IS",
  "CtyID": 233
}, {
  "CountryName": "Iran",
  "CtyCode": "IR",
  "CtyID": 234
}, {
  "CountryName": "Armenia",
  "CtyCode": "AM",
  "CtyID": 235
}, {
  "CountryName": "Albania",
  "CtyCode": "AL",
  "CtyID": 236
}, {
  "CountryName": "Angola",
  "CtyCode": "AO",
  "CtyID": 237
}, {
  "CountryName": "Antarctica",
  "CtyCode": "AQ",
  "CtyID": 238
}, {
  "CountryName": "American Samoa",
  "CtyCode": "AS",
  "CtyID": 239
}, {
  "CountryName": "Argentina",
  "CtyCode": "AR",
  "CtyID": 240
}, {
  "CountryName": "Australia",
  "CtyCode": "AU",
  "CtyID": 241
}, {
  "CountryName": "Austria",
  "CtyCode": "AT",
  "CtyID": 242
}, {
  "CountryName": "Aruba",
  "CtyCode": "AW",
  "CtyID": 243
}, {
  "CountryName": "India",
  "CtyCode": "IN",
  "CtyID": 244
}, {
  "CountryName": "Aland Islands",
  "CtyCode": "AX",
  "CtyID": 245
}, {
  "CountryName": "Azerbaijan",
  "CtyCode": "AZ",
  "CtyID": 246
}, {
  "CountryName": "Ireland",
  "CtyCode": "IE",
  "CtyID": 247
}, {
  "CountryName": "Indonesia",
  "CtyCode": "ID",
  "CtyID": 248
}, {
  "CountryName": "Ukraine",
  "CtyCode": "UA",
  "CtyID": 249
}, {
  "CountryName": "Qatar",
  "CtyCode": "QA",
  "CtyID": 250
}, {
  "CountryName": "Mozambique",
  "CtyCode": "MZ",
  "CtyID": 251
}];


var app = angular.module('app');
app.filter('reverse', function () {
  return function (items) {
    if (!angular.isArray(items)) return false;
    return items.slice().reverse();
  };
});


// REQUIRES:
// moment.js - http://momentjs.com/

// USAGE:
// {{ someDate | moment: [any moment function] : [param1] : [param2] : [param n] 

// EXAMPLES:
// {{ someDate | moment: 'format': 'MMM DD, YYYY' }}
// {{ someDate | moment: 'fromNow' }}

// To call multiple moment functions, you can chain them.
// For example, this converts to UTC and then formats...
// {{ someDate | moment: 'utc' | moment: 'format': 'MMM DD, YYYY' }}
var app = angular.module('app');
app.filter('moment', function () {
  return function (input, momentFn /*, param1, param2, ...param n */) {
    var args = Array.prototype.slice.call(arguments, 2),
        momentObj = moment(input);
    return momentObj[momentFn].apply(momentObj, args);
  };
});
app.filter('formatDateTime', function ($filter) {
  return function (date, format) {
    if (date) {
      return moment(Number(date)).format(format || "DD/MM/YYYY h:mm A");
    } else return "";
  };
});
// app.directive('mdDatepicker', function ($parse) {
// 
//   return {
//       require: 'ngModel',
//       link: function (scope, elem, attr, ngModel) {
//           $parse(attr.ngModel).assign(scope, new Date(_.get(scope, attr.ngModel)));
//       }
//   }
// });


(function () {
  'use strict';

  angular.module('app').run(['$log', '$window', '$rootScope', '$state', function ($log, $window, $rootScope, $state) {
    $log.debug('App run block end');
    $rootScope.$on('$locationChangeStart', function (event, toState, toParams, fromState, fromParams) {
      $("body").css("overflow", "initial");
      moment.updateLocale(moment.locale(), { invalidDate: "n/a" });
      var loggedIn = angular.fromJson(localStorage.getItem("tokenData"));
      if (loggedIn === null) {
        $state.go('signin');
      }
    });
  }]);
})();


(function () {
  'use strict';

  angular.module('app').config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('signin', {
      url: '/',
      views: {
        login: { component: 'signin' }
      }
    }).state('dashboard', {
      url: '/consultant/timesheets',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'dashboard'
        }
      }
    }).state('timesheets', {
      url: '/sales/timesheets',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'dashboard'
        }
      }
    }).state('salesprofile', {
      url: '/sales/profile',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'profile'
        }
      }
    }).state('salesdocuments', {
      url: '/sales/documents',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'documents'
        }
      }
    }).state('profile', {
      url: '/consultant/profile',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'profile'
        }
      }
    }).state('presidentdashboard', {
      url: '/president/dashboard',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'presidentdashboard'
        }
      }
    }).state('w2users', {
      url: '/president/w2users',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'w2users'
        }
      }
    }).state('consByVendor', {
      url: '/president/Consultants-By-Vendor',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'consByVendor'
        }
      }
    }).state('consByClient', {
      url: '/president/Consultants-By-Client',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'consByClient'
        }
      },
      resolve: {
        loadedFiles: function loadedFiles() {
          function loadjscssfile(data) {
            for (var index = 0; index < data.length; index++) {
              var element = data[index];

              if (element.filetype == 'js') {
                // if filename is a external JavaScript file
                var fileref = document.createElement('script');
                fileref.setAttribute('type', 'text/javascript');
                fileref.setAttribute('src', element.filename);
              } else if (element.filetype == 'css') {
                // if filename is an external CSS file
                var fileref = document.createElement('link');
                fileref.setAttribute('rel', 'stylesheet');
                fileref.setAttribute('type', 'text/css');
                fileref.setAttribute('href', element.filename);
              }
              if (typeof fileref !== 'undefined') {
                document.getElementsByTagName('head')[0].appendChild(fileref);
              }
            }
          }
          var filesArray = [{
            filename: 'https://cdn.datatables.net/v/dt/dt-1.10.20/b-1.6.1/b-flash-1.6.1/b-html5-1.6.1/fc-3.3.0/fh-3.1.6/datatables.min.js',
            filetype: 'js'
          }, {
            filename: 'https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css',
            filetype: 'css'
          }];
          loadjscssfile(filesArray);
          return true;
        }
      }
    }).state('accountsdashboard', {
      url: '/accounts/dashboard',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'accountsdashboard'
        }
      }
    }).state('adminDashboard', {
      url: '/admin/dashboard',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'admindashboard'
        }
      }
    }).state('downloadTSAdmin', {
      url: '/admin/download-timesheets',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'downloadTS'
        }
      }
    }).state('notifyUsersAdmin', {
      url: '/admin/notify-users',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'notifyUsers'
        }
      }
    }).state('accountsAdmin', {
      url: '/admin/approve-timesheets',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'accounts'
        }
      },
      resolve: {
        loadedFiles: function loadedFiles() {
          function loadjscssfile(data) {
            for (var index = 0; index < data.length; index++) {
              var element = data[index];

              if (element.filetype == 'js') {
                // if filename is a external JavaScript file
                var fileref = document.createElement('script');
                fileref.setAttribute('type', 'text/javascript');
                fileref.setAttribute('src', element.filename);
              } else if (element.filetype == 'css') {
                // if filename is an external CSS file
                var fileref = document.createElement('link');
                fileref.setAttribute('rel', 'stylesheet');
                fileref.setAttribute('type', 'text/css');
                fileref.setAttribute('href', element.filename);
              }
              if (typeof fileref !== 'undefined') {
                document.getElementsByTagName('head')[0].appendChild(fileref);
              }
            }
          }
          var filesArray = [{
            filename: 'https://cdn.datatables.net/v/dt/dt-1.10.20/b-1.6.1/b-flash-1.6.1/b-html5-1.6.1/fc-3.3.0/fh-3.1.6/datatables.min.js',
            filetype: 'js'
          }, {
            filename: 'https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css',
            filetype: 'css'
          }];
          loadjscssfile(filesArray);
          return true;
        }
      }
    }).state('downloadTS', {
      url: '/accounts/download-timesheets',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'downloadTS'
        }
      }
    }).state('notifyUsers', {
      url: '/accounts/notify-users',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'notifyUsers'
        }
      }
    }).state('accounts', {
      url: '/accounts/approve-timesheets',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'accounts'
        }
      },
      resolve: {
        loadedFiles: function loadedFiles() {
          function loadjscssfile(data) {
            for (var index = 0; index < data.length; index++) {
              var element = data[index];

              if (element.filetype == 'js') {
                // if filename is a external JavaScript file
                var fileref = document.createElement('script');
                fileref.setAttribute('type', 'text/javascript');
                fileref.setAttribute('src', element.filename);
              } else if (element.filetype == 'css') {
                // if filename is an external CSS file
                var fileref = document.createElement('link');
                fileref.setAttribute('rel', 'stylesheet');
                fileref.setAttribute('type', 'text/css');
                fileref.setAttribute('href', element.filename);
              }
              if (typeof fileref !== 'undefined') {
                document.getElementsByTagName('head')[0].appendChild(fileref);
              }
            }
          }
          var filesArray = [{
            filename: 'https://cdn.datatables.net/v/dt/dt-1.10.20/b-1.6.1/b-flash-1.6.1/b-html5-1.6.1/fc-3.3.0/fh-3.1.6/datatables.min.js',
            filetype: 'js'
          }, {
            filename: 'https://cdn.datatables.net/1.10.20/css/jquery.dataTables.min.css',
            filetype: 'css'
          }];
          loadjscssfile(filesArray);
          return true;
        }
      }
    }).state('users', {
      url: '/hr/users',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'admin'
        }
      }
    }).state('adminusers', {
      url: '/admin/users',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'admin'
        }
      }
    }).state('lookups', {
      url: '/admin/lookups',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'lookups'
        }
      }
    }).state('addlookup', {
      url: '/admin/lookups/:method',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'addlookup'
        }
      }
    }).state('hr-dashboard', {
      url: '/hr/hr-dashboard',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'hrdashboard'
        }
      }
    }).state('assignmanager', {
      url: '/hr/assign-manager',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'assignmanager'
        }
      }
    }).state('h1bfiling', {
      url: '/h1bfiling',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'h1bfiling'
        }
      }
    }).state('account', {
      url: '/account',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'account'
        }
      }
    }).state('BulkEmpsDataUpload', {
      url: '/BulkEmpsDataUpload',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'BulkEmpsDataUpload'
        }
      }
    }).state('accountsPayperiod', {
      url: '/accountsPayperiod',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'accountsPayperiod'
        }
      }
    }).state('managerAppTs', {
      url: '/managerAppTs',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'managerAppTs'
        }
      }
    }).state('admincreateuser', {
      url: '/admin/createUser',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'createuser'
        }
      }
    }).state('createuser', {
      url: '/hr/createUser',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'createuser'
        }
      }
    }).state('hr', {
      url: '/hr',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'hr'
        }
      }
    }).state('documents', {
      url: '/consultant/documents',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'documents'
        }
      }
    }).state('marketerdashboard', {
      url: '/sales/marketer-dashboard',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'marketerdashboard'
        }
      }
    }).state('marketer', {
      url: '/sales/interview-scheduler',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'marketer'
        }
      }
    }).state('myInterviews', {
      url: '/sales/my-interviews',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'myInterviews'
        }
      }
    }).state('marketerInterviews', {
      url: '/sales/Marketer-Interviews',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'marketerInterviews'
        }
      }
    }).state('myResources', {
      url: '/sales/My-Resources',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'myResources'
        }
      }
    }).state('placements', {
      url: '/sales/placements',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'placements'
        }
      }
    }).state('newResources', {
      url: '/sales/New-Resources',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'newResources'
        }
      }
    }).state('massMail', {
      url: '/sales/email-blast',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'massMail'
        }
      }
    }).state('submissions', {
      url: '/sales/submission',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'submissions'
        }
      }
    }).state('addSubmission', {
      url: '/sales/add-new-Submission',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'addSubmission'
        }
      }
    }).state('archiveusers', {
      url: '/hr/archive-users',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'archiveusers'
        }
      }
    }).state('adminvendors', {
      url: '/admin/vendors',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'vendors'
        }
      }
    }).state('adminaddvendor', {
      url: '/admin/addvendor',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'addvendor'
        }
      },
      resolve: {
        loadedFiles: function loadedFiles() {
          function loadjscssfile(data) {
            for (var index = 0; index < data.length; index++) {
              var element = data[index];

              if (element.filetype == 'js') {
                // if filename is a external JavaScript file
                var fileref = document.createElement('script');
                fileref.setAttribute('type', 'text/javascript');
                fileref.setAttribute('src', element.filename);
              } else if (element.filetype == 'css') {
                // if filename is an external CSS file
                var fileref = document.createElement('link');
                fileref.setAttribute('rel', 'stylesheet');
                fileref.setAttribute('type', 'text/css');
                fileref.setAttribute('href', element.filename);
              }
              if (typeof fileref !== 'undefined') {
                document.getElementsByTagName('head')[0].appendChild(fileref);
              }
            }
          }
          var filesArray = [{
            filename: '//code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css',
            filetype: 'css'
          }];
          loadjscssfile(filesArray);
          return true;
        }
      }
    }).state('adminvendorDetails', {
      url: '/admin/vendorDetails/:id',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'vendorDetails'
        }
      },
      resolve: {
        loadedFiles: function loadedFiles() {
          function loadjscssfile(data) {
            for (var index = 0; index < data.length; index++) {
              var element = data[index];

              if (element.filetype == 'js') {
                // if filename is a external JavaScript file
                var fileref = document.createElement('script');
                fileref.setAttribute('type', 'text/javascript');
                fileref.setAttribute('src', element.filename);
              } else if (element.filetype == 'css') {
                // if filename is an external CSS file
                var fileref = document.createElement('link');
                fileref.setAttribute('rel', 'stylesheet');
                fileref.setAttribute('type', 'text/css');
                fileref.setAttribute('href', element.filename);
              }
              if (typeof fileref !== 'undefined') {
                document.getElementsByTagName('head')[0].appendChild(fileref);
              }
            }
          }
          var filesArray = [{
            filename: '//code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css',
            filetype: 'css'
          }];
          loadjscssfile(filesArray);
          return true;
        }
      }
    }).state('vendors', {
      url: '/hr/vendors',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'vendors'
        }
      }
    }).state('addvendor', {
      url: '/hr/addvendor',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'addvendor'
        }
      },
      resolve: {
        loadedFiles: function loadedFiles() {
          function loadjscssfile(data) {
            for (var index = 0; index < data.length; index++) {
              var element = data[index];

              if (element.filetype == 'js') {
                // if filename is a external JavaScript file
                var fileref = document.createElement('script');
                fileref.setAttribute('type', 'text/javascript');
                fileref.setAttribute('src', element.filename);
              } else if (element.filetype == 'css') {
                // if filename is an external CSS file
                var fileref = document.createElement('link');
                fileref.setAttribute('rel', 'stylesheet');
                fileref.setAttribute('type', 'text/css');
                fileref.setAttribute('href', element.filename);
              }
              if (typeof fileref !== 'undefined') {
                document.getElementsByTagName('head')[0].appendChild(fileref);
              }
            }
          }
          var filesArray = [{
            filename: '//code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css',
            filetype: 'css'
          }];
          loadjscssfile(filesArray);
          return true;
        }
      }
    }).state('vendorDetails', {
      url: '/hr/vendorDetails/:id',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'vendorDetails'
        }
      },
      resolve: {
        loadedFiles: function loadedFiles() {
          function loadjscssfile(data) {
            for (var index = 0; index < data.length; index++) {
              var element = data[index];

              if (element.filetype == 'js') {
                // if filename is a external JavaScript file
                var fileref = document.createElement('script');
                fileref.setAttribute('type', 'text/javascript');
                fileref.setAttribute('src', element.filename);
              } else if (element.filetype == 'css') {
                // if filename is an external CSS file
                var fileref = document.createElement('link');
                fileref.setAttribute('rel', 'stylesheet');
                fileref.setAttribute('type', 'text/css');
                fileref.setAttribute('href', element.filename);
              }
              if (typeof fileref !== 'undefined') {
                document.getElementsByTagName('head')[0].appendChild(fileref);
              }
            }
          }
          var filesArray = [{
            filename: '//code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css',
            filetype: 'css'
          }];
          loadjscssfile(filesArray);
          return true;
        }
      }
    }).state('ClientsDetails', {
      url: '/hr/clientsDetails?:id',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'clientDetails'
        }
      }
    }).state('clients', {
      url: '/hr/clients',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'clients'
        }
      }
    }).state('AdminClientsDetails', {
      url: '/admin/clientsDetails?:id',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'clientDetails'
        }
      }
    }).state('adminclients', {
      url: '/admin/clients',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'clients'
        }
      }
    }).state('adminpageprojects', {
      url: '/admin/projects?id',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'projects'
        }
      },
      resolve: {
        loadedFiles: function loadedFiles() {
          function loadjscssfile(data) {
            for (var index = 0; index < data.length; index++) {
              var element = data[index];

              if (element.filetype == 'js') {
                // if filename is a external JavaScript file
                var fileref = document.createElement('script');
                fileref.setAttribute('type', 'text/javascript');
                fileref.setAttribute('src', element.filename);
              } else if (element.filetype == 'css') {
                // if filename is an external CSS file
                var fileref = document.createElement('link');
                fileref.setAttribute('rel', 'stylesheet');
                fileref.setAttribute('type', 'text/css');
                fileref.setAttribute('href', element.filename);
              }
              if (typeof fileref !== 'undefined') {
                document.getElementsByTagName('head')[0].appendChild(fileref);
              }
            }
          }
          var filesArray = [{
            filename: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.5.3/jspdf.min.js',
            filetype: 'js'
          }, {
            filename: 'https://unpkg.com/jspdf-autotable',
            filetype: 'js'
          }, {
            filename: 'https://html2canvas.hertzen.com/dist/html2canvas.min.js',
            filetype: 'js'
          }, {
            filename: 'https://bitbucket.org/!api/2.0/snippets/zaidbinkhalid/Me4nAb/f808fac413ecd5fee0e0e6e5cdbc57e2fdc07975/files/html2canvas.js',
            filetype: 'js'
          }, {
            filename: '//code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css',
            filetype: 'css'
          }];
          loadjscssfile(filesArray);
          return true;
        }
      }
    }).state('projects', {
      url: '/hr/projects?id',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'projects'
        }
      },
      resolve: {
        loadedFiles: function loadedFiles() {
          function loadjscssfile(data) {
            for (var index = 0; index < data.length; index++) {
              var element = data[index];

              if (element.filetype == 'js') {
                // if filename is a external JavaScript file
                var fileref = document.createElement('script');
                fileref.setAttribute('type', 'text/javascript');
                fileref.setAttribute('src', element.filename);
              } else if (element.filetype == 'css') {
                // if filename is an external CSS file
                var fileref = document.createElement('link');
                fileref.setAttribute('rel', 'stylesheet');
                fileref.setAttribute('type', 'text/css');
                fileref.setAttribute('href', element.filename);
              }
              if (typeof fileref !== 'undefined') {
                document.getElementsByTagName('head')[0].appendChild(fileref);
              }
            }
          }
          var filesArray = [{
            filename: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.5.3/jspdf.min.js',
            filetype: 'js'
          }, {
            filename: 'https://unpkg.com/jspdf-autotable',
            filetype: 'js'
          }, {
            filename: 'https://html2canvas.hertzen.com/dist/html2canvas.min.js',
            filetype: 'js'
          }, {
            filename: 'https://bitbucket.org/!api/2.0/snippets/zaidbinkhalid/Me4nAb/f808fac413ecd5fee0e0e6e5cdbc57e2fdc07975/files/html2canvas.js',
            filetype: 'js'
          }, {
            filename: '//code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css',
            filetype: 'css'
          }];
          loadjscssfile(filesArray);
          return true;
        }
      }
    }).state('payRise', {
      url: '/hr/payRise',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'payRise'
        }
      },
      resolve: {
        loadedFiles: function loadedFiles() {
          function loadjscssfile(data) {
            for (var index = 0; index < data.length; index++) {
              var element = data[index];

              if (element.filetype == 'js') {
                // if filename is a external JavaScript file
                var fileref = document.createElement('script');
                fileref.setAttribute('type', 'text/javascript');
                fileref.setAttribute('src', element.filename);
              } else if (element.filetype == 'css') {
                // if filename is an external CSS file
                var fileref = document.createElement('link');
                fileref.setAttribute('rel', 'stylesheet');
                fileref.setAttribute('type', 'text/css');
                fileref.setAttribute('href', element.filename);
              }
              if (typeof fileref !== 'undefined') {
                document.getElementsByTagName('head')[0].appendChild(fileref);
              }
            }
          }
          var filesArray = [{
            filename: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.5.3/jspdf.min.js',
            filetype: 'js'
          }, {
            filename: 'https://unpkg.com/jspdf-autotable',
            filetype: 'js'
          }, {
            filename: 'https://cdnjs.cloudflare.com/ajax/libs/mark.js/8.11.1/jquery.mark.es6.min.js',
            filetype: 'js'
          }];
          loadjscssfile(filesArray);
          return true;
        }
      }
    }).state('talentSearch', {
      url: '/sales/Talent-Search',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'talentSearch'
        }
      },
      resolve: {
        loadedFiles: function loadedFiles() {
          function loadjscssfile(data) {
            for (var index = 0; index < data.length; index++) {
              var element = data[index];

              if (element.filetype == 'js') {
                // if filename is a external JavaScript file
                var fileref = document.createElement('script');
                fileref.setAttribute('type', 'text/javascript');
                fileref.setAttribute('src', element.filename);
              } else if (element.filetype == 'css') {
                // if filename is an external CSS file
                var fileref = document.createElement('link');
                fileref.setAttribute('rel', 'stylesheet');
                fileref.setAttribute('type', 'text/css');
                fileref.setAttribute('href', element.filename);
              }
              if (typeof fileref !== 'undefined') {
                document.getElementsByTagName('head')[0].appendChild(fileref);
              }
            }
          }
          var filesArray = [{
            filename: 'https://cdnjs.cloudflare.com/ajax/libs/mark.js/8.11.1/jquery.mark.es6.min.js',
            filetype: 'js'
          }];
          loadjscssfile(filesArray);
          return true;
        }
      }
    }).state('internalDb', {
      url: '/sales/Internal-Database',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'internalDb'
        }
      }
    }).state('jobposting', {
      url: '/sales/Job-Posting',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'jobposting'
        }
      }
    }).state('timesheetDetailsExport', {
      url: '/timesheetDetailsExport',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'timesheetDetailsExport'
        }
      }
    }).state('tsSubmit', {
      url: '/consultant/tsSubmit',
      views: {
        sidebar: { component: 'sidebar' },
        inlayout: {
          component: 'tsSubmit'
        }
      }
    });
    $urlRouterProvider.otherwise('/');
  }
})();


(function () {
  'use strict';

  angular.module('app').config(configBlock);

  /** @ngInject */
  function configBlock($locationProvider, $logProvider) {
    $locationProvider.html5Mode(true).hashPrefix('!');
    angular.lowercase = angular.$$lowercase;
    $logProvider.debugEnabled(true);
  }
})();


angular.module('app').run(['$templateCache', function($templateCache) {$templateCache.put('app/components/admin/admin.component.html','<div class=container-fluid><ci-spinner class=loginLoader ng-if=!loginLoader></ci-spinner><div class=row ng-show=loginLoader><div class="col-sm-12 col-xl-12 col-lg-12"><div class="usersTable table-responsive"><div class=d-flex><div class="w-100 d-flex justify-content-end p-2"><input type=text placeholder=Search.. ng-model=searchData ng-keyup=search(searchData) class=form-control></div></div><div id=usersList></div></div></div></div></div>');
$templateCache.put('app/components/login/forgotPwdForm.html','<md-dialog aria-label="Forgot Password"><form ng-cloak><md-dialog-content><div class=md-dialog-content><p ng-hide=resOkBtn>Ensure your details for verification.</p><div class="alert alert-info" role=alert ng-if="message !== undefined">{{message}}</div><div class=form-group ng-hide=resOkBtn><label for=staticEmail class="col-sm-12 col-form-label">UserName</label><div class=col-sm-12><input type=text ng-model=fwd.UserName class=form-control id=userEmail placeholder=email@example.com></div></div><div class=form-group ng-hide=resOkBtn><label for=inputPassword class="col-sm-12 col-form-label">Last four of SSN</label><div class=col-sm-12><input type=text placeholder=XXXX class="masked form-control" pattern=\\d{4} data-valid-example=0000 ng-model=fwd.Fourssn id=Fourssn></div></div></div></md-dialog-content><md-dialog-actions layout=row layout-align="end center"><span flex></span><md-button ng-click=cancel() ng-if="!resOkBtn && !resMsg">Cancel</md-button><md-button ng-click=cancel() class="btn btn-primary" ng-if=resOkBtn>Close</md-button><md-button ng-click=fwdSubmit(fwd) class=md-primary ng-hide=resOkBtn>Submit</md-button><ci-spinner ng-if=resMsg></ci-spinner></md-dialog-actions></form></md-dialog><script src=https://s3-us-west-2.amazonaws.com/s.cdpn.io/3/masking-input.js data-autoinit=true></script>');
$templateCache.put('app/components/login/login.html','<div class="login-page h-100"><div class=loginBoxLeft></div><div class="login-box-wrapper auth0-box"><h2 class=loginHeading>Texperts<span>HRM</span></h2><div class="login-box p-2"><md-content class="col text-center" ng-if=authenticated><ci-spinner class=loginLoader></ci-spinner></md-content><md-content class="col text-center" ng-if=!authenticated><h4>Welcome</h4><!-- <small>Enter your details below here</small> --><form name=loginForm layout=column ng-submit="loginForm.$valid && login(user)"><div class="alert alert-danger" ng-if=invalidCredentials>Invalid Credentials</div><input ng-model=user.username placeholder=name@domain.com type=email required name=username ng-pattern=/^.+@.+\\..+$/ > <input ng-model=user.password placeholder=password type=password required name=password autocomplete=new-password><div class="d-flex justify-content-between"><md-button class="cc-button m-0" type=submit>Sign in</md-button><span class=forgot-password ng-click=forgotPassword($event)>Forgot Password</span></div></form></md-content></div></div></div>');
$templateCache.put('app/components/sidebar/changePwdForm.html','<md-dialog aria-label="Forgot Password" style="width: 480px;"><form name=passwordForm ng-submit="passwordForm.$valid && chngPwdSubmit(ChangePassword)" class=ChangePasswordForm><md-dialog-content><div class=md-dialog-content><p>Ensure your details for verification.</p><p>{{message}}</p><div class=form-group><label for=staticEmail class="col-sm-12 col-form-label">Old Password</label><div class=col-sm-12><input type=password ng-model=ChangePassword.OldPassword class=form-control required id=OldPassword placeholder="Old Password"></div></div><div class=form-group><label for=staticEmail class="col-sm-12 col-form-label">New Password</label><div class=col-sm-12><input type=password name=NewPassword ng-model=ChangePassword.NewPassword required class=form-control id=NewPassword placeholder="New Password" password-strength=ChangePassword.NewPassword ng-class=strength ng-pattern="/^(?=.*[A-Z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{8,20}$/"> <span class=help-inline ng-show="passwordForm.NewPassword.$valid && passwordForm.NewPassword.$dirty" ng-class=strength>This password is {{strength}} !</span><div ng-messages=passwordForm.NewPassword.$error><div ng-message=pattern>Password should be atleast 8 characters long and should contain one number,one character and one special character</div><div ng-message=required>Password should be atleast 8 characters long and should contain one number,one character and one special character</div></div></div></div><div class=form-group><label for=staticEmail class="col-sm-12 col-form-label">Confirm Password</label><div class=col-sm-12><input type=password name=ConfirmPassword ng-model=ChangePassword.ConfirmPassword required compare-to=ChangePassword.NewPassword class=form-control id=ConfirmPassword placeholder="Confirm Password"> <span class=help-inline ng-show="passwordForm.ConfirmPassword.$invalid && passwordForm.ConfirmPassword.$dirty">This password do not match!</span></div></div></div></md-dialog-content><md-dialog-actions layout=row layout-align="end center"><md-button ng-click=cancel()>Cancel</md-button><md-button type=submit class=md-primary ng-disabled="strength !== \'strong\'" ng-if="!chaningPass && !passwordForm.ConfirmPassword.$invalid">Submit</md-button><ci-spinner ng-if=chaningPass class=mt-1></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/sidebar/sidebar.html','<nav class="menuBar navbar navbar-icon-top navbar-expand-lg navbar-dark consultant" ng-class="isMobile?\'mobile\':\'\'" style="background-color: rgb(60, 29, 12) !important;" ng-if="curl[1] === \'consultant\'"><a class=navbar-brand href="">Texperts <span style="font-weight: 700;color: #E64A19;">HRM</span> </a><button class=navbar-toggler type=button data-toggle=collapse data-target=#navbarSupportedContent aria-controls=navbarSupportedContent aria-expanded=false aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div class="collapse navbar-collapse" id=navbarSupportedContent><ul class="navbar-nav mr-auto menu"><!-- <li class="nav-item dropdown pointer"\r\n                ng-class="curl[2] === \'timesheets\'?\'active\':\'\'">\r\n                <a class="nav-link dropdown-toggle" href="" id="navbarDropdown" role="button" data-toggle="dropdown"\r\n                    aria-haspopup="true" aria-expanded="false">\r\n                    <i class="fas fa-user-tie">\r\n                    </i>\r\n                    Timesheets\r\n                </a>\r\n                <div class="dropdown-menu p-0" aria-labelledby="navbarDropdown">\r\n                    <a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref="dashboard()">New Timesheet</a>\r\n                    <a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref="dashboard()">Submitted Timesheets</a>\r\n                </div>\r\n            </li> --><li class=nav-item ng-class="curl[2] === \'timesheets\'?\'active\':\'\'"><a class=nav-link ui-sref=dashboard()><i class="fas fa-user-tie"></i> Timesheets</a></li><li class=nav-item ng-class="curl[2] === \'profile\'?\'active\':\'\'"><a class=nav-link ui-sref=profile()><i class="fas fa-address-card"></i> Profile</a></li><li class=nav-item ng-class="curl[2] === \'documents\'?\'active\':\'\'"><a class=nav-link ui-sref=documents()><i class="fas fa-file-alt"></i> Documents</a></li></ul><ul class=navbar-nav><li class="nav-item dropdown dropleft"><a class="nav-link dropdown-toggle pointer d-flex flex-column" id=myAccDRPDWN role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fas fa-user-circle"></i> <strong>{{tokenData.firstname}}</strong></a><div class=dropdown-menu aria-labelledby=myAccDRPDWN><h4 class="text-primary pl-1" style="font-size: 15px; font-weight:bolder;" ng-if=isPresident>Go to</h4><a class=dropdown-item ui-sref=presidentdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">President</a> <a class=dropdown-item ui-sref=dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Consultant</a> <a class=dropdown-item ui-sref=hr-dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">HR</a> <a class=dropdown-item ui-sref=accountsdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Accounts</a> <a class=dropdown-item ui-sref=marketerdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Sales</a><div class=dropdown-divider ng-if=isPresident></div><button class=dropdown-item type=button ng-click=changePasswordView($event)>Change Password</button> <button class=dropdown-item type=button ng-click=logout()>Logout</button></div></li></ul></div></nav><nav class="menuBar navbar navbar-icon-top navbar-expand-lg navbar-dark bg-dark president" ng-class="isMobile?\'mobile\':\'\'" ng-if="curl[1] === \'president\'"><a class=navbar-brand ui-sref=presidentdashboard()>Texperts <span style="font-weight: 700;color: #E64A19;">HRM</span> </a><button class=navbar-toggler type=button data-toggle=collapse data-target=#navbarSupportedContent aria-controls=navbarSupportedContent aria-expanded=false aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div class="collapse navbar-collapse" id=navbarSupportedContent><ul class="navbar-nav mr-auto menu"><li class=nav-item ng-class="curl[2] === \'dashboard\'?\'active\':\'\'"><a class=nav-link ui-sref=presidentdashboard()><i class="fas fa-th"></i> Dashboard</a></li><li class=nav-item ng-class="curl[2] === \'w2users\'?\'active\':\'\'"><a class=nav-link ui-sref=w2users()><i class="fas fa-user-tie"></i> W2Users</a></li><li class=nav-item ng-class="curl[2] === \'Consultants-By-Vendor\'?\'active\':\'\'"><a class=nav-link ui-sref=consByVendor()><i class="fas fa-users"></i> Vendor Placements</a></li><li class=nav-item ng-class="curl[2] === \'Consultants-By-Client\'?\'active\':\'\'"><a class=nav-link ui-sref=consByClient()><i class="fas fa-user-plus"></i> Client Placements</a></li></ul><ul class=navbar-nav><li class="nav-item dropdown dropleft"><a class="nav-link dropdown-toggle d-flex flex-column" href="" id=myAccDRPDWN role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fas fa-user-circle"></i> <strong>{{tokenData.firstname}}</strong></a><div class=dropdown-menu aria-labelledby=myAccDRPDWN><h4 class="text-primary pl-1" style="font-size: 15px; font-weight:bolder;" ng-if=isPresident>Go to</h4><a class=dropdown-item ui-sref=presidentdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">President</a> <a class=dropdown-item ui-sref=dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Consultant</a> <a class=dropdown-item ui-sref=hr-dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">HR</a> <a class=dropdown-item ui-sref=accountsdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Accounts</a> <a class=dropdown-item ui-sref=marketerdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Sales</a><div class=dropdown-divider ng-if=isPresident></div><button class=dropdown-item type=button ng-click=changePasswordView($event)>Change Password</button> <button class=dropdown-item type=button ng-click=logout()>Logout</button></div></li></ul></div></nav><nav class="menuBar navbar navbar-icon-top navbar-expand-lg navbar-dark bg-dark accounts" ng-class="isMobile?\'mobile\':\'\'" ng-if="curl[1] === \'accounts\'"><a class=navbar-brand ui-sref=accountsdashboard()>Texperts <span style="font-weight: 700;color: #E64A19;">HRM</span> </a><button class=navbar-toggler type=button data-toggle=collapse data-target=#navbarSupportedContent aria-controls=navbarSupportedContent aria-expanded=false aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div class="collapse navbar-collapse" id=navbarSupportedContent><ul class="navbar-nav mr-auto menu"><li class=nav-item ng-class="curl[2] === \'dashboard\'?\'active\':\'\'"><a class=nav-link ui-sref=accountsdashboard()><i class="fas fa-th"></i> Dashboard</a></li><li class=nav-item ng-class="curl[2] === \'download-timesheets\'?\'active\':\'\'"><a class=nav-link ui-sref=downloadTS()><i class="fas fa-user-clock"></i> Download Timesheets</a></li><li class=nav-item ng-class="curl[2] === \'notify-users\'?\'active\':\'\'"><a class=nav-link ui-sref=notifyUsers()><i class="fas fa-user-clock"></i> Notify Users</a></li><li class=nav-item ng-class="curl[2] === \'approve-timesheets\'?\'active\':\'\'"><a class=nav-link ui-sref=accounts()><i class="fas fa-user-clock"></i> Approve Timesheets</a></li></ul><ul class=navbar-nav><li class="nav-item dropdown dropleft"><a class="nav-link dropdown-toggle d-flex flex-column" href="" id=myAccDRPDWN role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fas fa-user-circle"></i> <strong>{{tokenData.firstname}}</strong></a><div class=dropdown-menu aria-labelledby=myAccDRPDWN><h4 class="text-primary pl-1" style="font-size: 15px; font-weight:bolder;" ng-if=isPresident>Go to</h4><a class=dropdown-item ui-sref=presidentdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">President</a> <a class=dropdown-item ui-sref=dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Consultant</a> <a class=dropdown-item ui-sref=hr-dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">HR</a> <a class=dropdown-item ui-sref=accountsdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Accounts</a> <a class=dropdown-item ui-sref=marketerdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Sales</a><div class=dropdown-divider ng-if=isPresident></div><button class=dropdown-item type=button ng-click=changePasswordView($event)>Change Password</button> <button class=dropdown-item type=button ng-click=logout()>Logout</button></div></li></ul></div></nav><nav class="menuBar navbar navbar-icon-top navbar-expand-lg navbar-dark bg-dark hr" ng-class="isMobile?\'mobile\':\'\'" ng-if="curl[1] === \'hr\'"><a class=navbar-brand ui-sref=hr-dashboard()>Texperts <span style="font-weight: 700;color: #E64A19;">HRM</span> </a><button class=navbar-toggler type=button data-toggle=collapse data-target=#navbarSupportedContent aria-controls=navbarSupportedContent aria-expanded=false aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div class="collapse navbar-collapse" id=navbarSupportedContent><ul class="navbar-nav mr-auto menu"><li class=nav-item ng-class="curl[2] === \'hr-dashboard\'?\'active\':\'\'"><a class=nav-link ui-sref=hr-dashboard()><i class="fas fa-th"></i> Dashboard</a></li><li class="nav-item dropdown pointer" ng-class="curl[2] === \'users\'?\'active\':\'\'"><a class="nav-link dropdown-toggle" href="" id=navbarDropdown role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fas fa-users"></i> Users</a><div class="dropdown-menu p-0" aria-labelledby=navbarDropdown><a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=users()>Projects/Profiles</a> <a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=createuser()>Onboard Consultant</a> <a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=archiveusers()>Archive Consultant</a> <a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=assignmanager()>Assign Manager</a></div></li><!-- <li class="nav-item" ng-class="curl[2] === \'users\'?\'active\':\'\'">\r\n                <a class="nav-link" ui-sref="users()">\r\n                    <i class="fas fa-users">\r\n                        \r\n                    </i>\r\n                    Users\r\n                </a>\r\n            </li>\r\n            <li class="nav-item" ng-class="curl[2] === \'createUser\'?\'active\':\'\'">\r\n                <a class="nav-link" ui-sref="createuser()">\r\n                    <i class="fas fa-user-plus">\r\n                        \r\n                    </i>\r\n                    Onboard Consultant\r\n                </a>\r\n            </li>\r\n            <li class="nav-item" ng-class="curl[2] === \'assign-manager\'?\'active\':\'\'">\r\n                <a class="nav-link" ui-sref="assignmanager()">\r\n                    <i class="fas fa-user-tag">\r\n                        \r\n                    </i>\r\n                    Assign Manager\r\n                </a>\r\n            </li>\r\n            <li class="nav-item" ng-class="curl[2] === \'archive-users\'?\'active\':\'\'">\r\n                <a class="nav-link" ui-sref="archiveusers()">\r\n                    <i class="fas fa-file-archive">\r\n                        \r\n                    </i>\r\n                    Archive Users\r\n                </a>\r\n            </li> --><li class=nav-item ng-class="curl[2] === \'clients\'?\'active\':\'\'"><a class=nav-link ui-sref=clients()><i class="fas fa-user-tie"></i> Clients</a></li><li class=nav-item ng-class="curl[2] === \'vendors\'?\'active\':\'\'"><a class=nav-link ui-sref=vendors()><i class="fas material-icons">recent_actors </i>Vendors</a></li><li class=nav-item ng-class="curl[2] === \'payRise\'?\'active\':\'\'"><a class=nav-link ui-sref=payRise()><i class="fas fa-chart-line"></i> Pay Raise</a></li></ul><ul class=navbar-nav><li class="nav-item dropdown dropleft"><a class="nav-link dropdown-toggle d-flex flex-column" href="" id=myAccDRPDWN role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fas fa-user-circle"></i> <strong>{{tokenData.firstname}} {{tokenData.lastname}}</strong></a><div class=dropdown-menu aria-labelledby=myAccDRPDWN><h4 class="text-primary pl-1" style="font-size: 15px; font-weight:bolder;" ng-if=isPresident>Go to</h4><a class=dropdown-item ui-sref=presidentdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">President</a> <a class=dropdown-item ui-sref=dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Consultant</a> <a class=dropdown-item ui-sref=hr-dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">HR</a> <a class=dropdown-item ui-sref=accountsdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Accounts</a> <a class=dropdown-item ui-sref=marketerdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Sales</a><div class=dropdown-divider ng-if=isPresident></div><button class=dropdown-item type=button ng-click=changePasswordView($event)>Change Password</button> <button class=dropdown-item type=button ng-click=logout()>Logout</button></div></li></ul></div></nav><nav class="menuBar navbar navbar-icon-top navbar-expand-lg navbar-dark bg-dark sales" ng-class="isMobile?\'mobile\':\'\'" ng-class="curl[2] === \'marketer-dashboard\'?\'bringTop\':\'\'" ng-if="curl[1] === \'sales\'"><a class=navbar-brand ui-sref=marketerdashboard()>Texperts <span style="font-weight: 700;color: #E64A19;">HRM</span> </a><button class=navbar-toggler type=button data-toggle=collapse data-target=#navbarSupportedContent aria-controls=navbarSupportedContent aria-expanded=false aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div class="collapse navbar-collapse" id=navbarSupportedContent><ul class="navbar-nav mr-auto menu" ng-if="curl[2] !== \'marketer-dashboard\'"><li class="nav-item pointer" ng-class="curl[2] === \'marketer-dashboard\'?\'active\':\'\'"><a class=nav-link ui-sref=marketerdashboard()><i class="fas fa-home"><!-- <span class="badge badge-danger">11</span> --> </i>Dashboard</a></li><li class="nav-item dropdown pointer" ng-class="curl[2] === \'interview-scheduler\'?\'active\':\'\' || curl[2] === \'my-interviews\'?\'active\':\'\' || curl[2] === \'Marketer-Interviews\'?\'active\':\'\'"><a class="nav-link dropdown-toggle" href="" id=navbarDropdown role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fas fa-user-tie"><!-- <span class="badge badge-primary">11</span> --> </i>Interviews</a><div class="dropdown-menu p-0" aria-labelledby=navbarDropdown><a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=marketer()>Schedular </a><a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=myInterviews()>My Interviews</a> <a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=marketerInterviews() ng-if="role == \'MarketerAdmin\'">Marketer Interviews</a></div></li><li class="nav-item dropdown pointer" style="display: none;" ng-class="curl[2] === \'timesheets\'?\'active\':\'\' || curl[2] === \'profile\'?\'active\':\'\' || curl[2] === \'documents\'?\'active\':\'\'"><a class="nav-link dropdown-toggle" href="" id=navbarDropdown role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fas fa-calendar-alt"><!-- <span class="badge badge-primary">11</span> --> </i>Timesheets</a><div class="dropdown-menu p-0" aria-labelledby=navbarDropdown><a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=timesheets()>Timesheets</a> <a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=salesprofile()>Profile</a> <a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=salesdocuments()>Documents</a></div></li><li class="nav-item dropdown pointer" ng-class="curl[2] === \'New-Resources\'?\'active\':\'\' || curl[2] === \'My-Resources\'?\'active\':\'\'"><a class="nav-link dropdown-toggle" href="" id=navbarDropdown role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fas fa-users"><!-- <span class="badge badge-primary">11</span> --> </i>Consultants</a><div class="dropdown-menu p-0" aria-labelledby=navbarDropdown><a class="dropdown-item pt-3 pb-3 border-bottom pt-3 pb-3 border-bottom" ui-sref=newResources()>Add Consultant</a> <a class="dropdown-item pt-3 pb-3 border-bottom pt-3 pb-3 border-bottom" ui-sref=myResources()>My Resources</a></div></li><li class="nav-item dropdown pointer" ng-class="curl[2] === \'Internal-Database\'?\'active\':\'\' || curl[2] === \'Talent-Search\'?\'active\':\'\'"><a class="nav-link dropdown-toggle" href="" id=navbarDropdown role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fas fa-book-reader"><!-- <span class="badge badge-primary">11</span> --> </i>Talent Search</a><div class="dropdown-menu p-0" aria-labelledby=navbarDropdown><a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=internalDb()>Internal DB</a> <a class="dropdown-item pt-3 pb-3 border-bottom" ui-sref=talentSearch()>Dice Search</a></div></li><!-- <li class="nav-item dropdown pointer"\r\n                ng-class="curl[2] === \'add-new-Submission\'?\'active\':\'\' || curl[2] === \'submission\'?\'active\':\'\'">\r\n                <a class="nav-link dropdown-toggle" href="" id="navbarDropdown" role="button" data-toggle="dropdown"\r\n                    aria-haspopup="true" aria-expanded="false">\r\n                    <i class="fas fa-address-book">\r\n                    </i>\r\n                    Submissions\r\n                </a>\r\n                <div class="dropdown-menu" aria-labelledby="navbarDropdown">\r\n                    <a class="dropdown-item" ui-sref="addSubmission()">Add Submission</a>\r\n                    <a class="dropdown-item" ui-sref="submissions()">View Submission</a>\r\n                </div>\r\n            </li> --><li class="nav-item pointer" ng-class="curl[2] === \'email-blast\'?\'active\':\'\'"><a class=nav-link ui-sref=massMail()><i class="fas fa-mail-bulk"><!-- <span class="badge badge-danger">11</span> --> </i>Bulk Email</a></li><!-- <li class="nav-item pointer" ng-class="curl[2] === \'placements\'?\'active\':\'\'">\r\n                <a class="nav-link" ui-sref="placements()">\r\n                    <i class="fas fa-user-check">\r\n                    </i>\r\n                    Placements\r\n                </a>\r\n            </li> --><li class="nav-item pointer" ng-class="curl[2] === \'Job-Posting\'?\'active\':\'\'"><a class=nav-link ui-sref=jobposting()><i class="fas fa-envelope-open-text"><!-- <span class="badge badge-danger">11</span> --> </i>Job Posting</a></li></ul><div class=w-100 ng-if="curl[2] === \'marketer-dashboard\'"></div><ul class=navbar-nav><li class="nav-item dropdown dropleft"><a class="nav-link dropdown-toggle" href="" id=myAccDRPDWN role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fas fa-user-circle"></i> <b class=text-light>My Account</b></a><div class=dropdown-menu aria-labelledby=myAccDRPDWN><h4 class="text-primary pl-1" style="font-size: 15px; font-weight:bolder;" ng-if=isPresident>Go to</h4><a class=dropdown-item ui-sref=presidentdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">President</a> <a class=dropdown-item ui-sref=dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Consultant</a> <a class=dropdown-item ui-sref=hr-dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">HR</a> <a class=dropdown-item ui-sref=accountsdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Accounts</a> <a class=dropdown-item ui-sref=marketerdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Sales</a><div class=dropdown-divider ng-if=isPresident></div><button class=dropdown-item type=button ng-click=changePasswordView($event)>Change Password</button> <button class=dropdown-item type=button ng-click=logout()>Logout</button></div></li></ul></div></nav><nav class="menuBar navbar navbar-icon-top navbar-expand-lg navbar-dark bg-dark admin" ng-class="isMobile?\'mobile\':\'\'" ng-if="curl[1] === \'admin\'"><a class=navbar-brand href="">Texperts <span style="font-weight: 700;color: #E64A19;">HRM</span> </a><button class=navbar-toggler type=button data-toggle=collapse data-target=#navbarSupportedContent aria-controls=navbarSupportedContent aria-expanded=false aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div class="collapse navbar-collapse" id=navbarSupportedContent><ul class="navbar-nav mr-auto menu"><li class=nav-item ng-class="curl[2] === \'admin-dashboard\'?\'active\':\'\'"><a class=nav-link ui-sref=adminDashboard()><i class="fas fa-th"></i> Dashboard</a></li><li class=nav-item ng-class="curl[2] === \'download-timesheets\'?\'active\':\'\'"><a class=nav-link ui-sref=downloadTSAdmin()><i class="fas fa-user-clock"></i> Download Timesheets</a></li><li class=nav-item ng-class="curl[2] === \'notify-users\'?\'active\':\'\'"><a class=nav-link ui-sref=notifyUsersAdmin()><i class="fas fa-user-clock"></i> Notify Users</a></li><li class=nav-item ng-class="curl[2] === \'approve-timesheets\'?\'active\':\'\'"><a class=nav-link ui-sref=accountsAdmin()><i class="fas fa-user-clock"></i> Approve Timesheets</a></li><li class=nav-item ng-class="curl[2] === \'createUser\'?\'active\':\'\'"><a class=nav-link ui-sref=admincreateuser()><i class="fas fa-file-alt"></i> Create User</a></li><li class=nav-item ng-class="curl[2] === \'users\'?\'active\':\'\'"><a class=nav-link ui-sref=adminusers()><i class="fas fa-users"></i> Users</a></li><li class=nav-item ng-class="curl[2] === \'clients\'?\'active\':\'\'"><a class=nav-link ui-sref=adminclients()><i class="fas fa-user-tie"></i> Clients</a></li><li class=nav-item ng-class="curl[2] === \'vendors\'?\'active\':\'\'"><a class=nav-link ui-sref=adminvendors()><i class="fas material-icons">recent_actors </i>Vendors</a></li><li class=nav-item ng-class="curl[2] === \'lookups\'?\'active\':\'\'"><a class=nav-link ui-sref=lookups()><i class="fas material-icons">recent_actors </i>Lookups</a></li></ul><ul class=navbar-nav><li class="nav-item dropdown dropleft"><a class="nav-link dropdown-toggle pointer d-flex flex-column" id=myAccDRPDWN role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><i class="fas fa-user-circle"></i> <strong>{{tokenData.firstname}}</strong></a><div class=dropdown-menu aria-labelledby=myAccDRPDWN><h4 class="text-primary pl-1" style="font-size: 15px; font-weight:bolder;" ng-if=isPresident>Go to</h4><a class=dropdown-item ui-sref=presidentdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">President</a> <a class=dropdown-item ui-sref=dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Consultant</a> <a class=dropdown-item ui-sref=hr-dashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">HR</a> <a class=dropdown-item ui-sref=accountsdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Accounts</a> <a class=dropdown-item ui-sref=marketerdashboard() ng-if=isPresident style="font-size: 12px;font-weight:bolder;color: lightseagreen;border-bottom: 1px solid #f5f5f5;">Sales</a><div class=dropdown-divider ng-if=isPresident></div><button class=dropdown-item type=button ng-click=changePasswordView($event)>Change Password</button> <button class=dropdown-item type=button ng-click=logout()>Logout</button></div></li></ul></div></nav><!-- \r\n<button type="button" class="btn btn-secondary" data-toggle="tooltip" data-placement="top" title="Tooltip on top"\r\n    onmouseenter="$(this).tooltip(\'show\')">\r\n    Tooltip on top\r\n</button>-->');
$templateCache.put('app/components/accounts/accountsDashboard/accountsDashboard.component.html','<div class=container id=marketer-dashboard><div class="row justify-content-center"><div class=col-8><ul class=row ng-class="isMobile?\'h-100\':\'\'"><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=downloadTS()><img src=../../../../images/downloadTs.png alt=Interviews class=grow><br><span>Download Timesheets</span></li><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=notifyUsers()><img src=../../../../images/notifyusers.png alt=Consultants class=grow><br><span>Notify Users</span></li><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=accounts()><img src=../../../../images/approveTs.png alt="Talent Search" class=grow><br><span>Approve Timesheets</span></li></ul></div></div></div>');
$templateCache.put('app/components/accounts/account/account.component.html','<div class=container-fluid><div class=row><div class=col-lg-6><md-tabs md-dynamic-height md-border-bottom><md-tab label="Action Required" md-on-select=closeopenPanel()><md-content layout=column class="md-padding p-0" layout-padding><i class="material-icons refreshUsers pointer" ng-click=refreshUsers($event) ng-hide=refreshIngUsers>refresh</i><div class=w-100 ng-if=refreshIngUsers><md-progress-circular md-mode=indeterminate class=md-hue-2 md-diameter=20px></md-progress-circular></div><div id=actionRequiredTable></div></md-content></md-tab><md-tab label="Total Employees" md-on-select=closeopenPanel()><md-content layout-padding><div id=TotalEmployeesTable></div></md-content></md-tab></md-tabs></div><div class="col-lg-6 showDetailsPage" ng-if=showDetailsPage><h3 class=pt-2>{{userDetails.FirstName}} {{userDetails.LastName}}</h3><md-content><ci-spinner class=loginLoader ng-if=!getUserData></ci-spinner><div class="md-whiteframe-1dp wrapperBox m-0" ng-if=getUserData><div layout-padding><div class="p-2 d-flex flex-row"><button ng-click="getPrevYearTs(userDetails.LoginId, userDetails.PrfId)" class="btn btn-sm btn-info mr-2">{{prevYear}}</button> <button ng-click="getPresnYearTs(userDetails.LoginId, userDetails.PrfId)" class="btn btn-sm btn-info">{{presentYear}}</button></div><ci-spinner ng-if=yearTsLoader></ci-spinner><table class="table table-hover dataTable" id=tsSTable ng-if=!yearTsLoader><thead><tr><th>#</th><th>Timesheet Period</th><th>Portal Hours</th><th>Uploaded Hours</th><th>Action</th><th>Compare</th></tr></thead><!-- <tbody ng-repeat="ts in Timesheets | filter:search" ng-class="{\'bg-danger\': ts.AccountsAction == \'Rejected\', \'bg-primary\': ts.AccountsAction == \'Approved\'}"> --><tbody ng-repeat="ts in Timesheets" ng-if="ts.tsaction == \'Submitted\'"><tr><td>{{$index+1}}</td><td>{{ts.StartDate | moment: \'format\': \'MMM DD, YYYY\'}} - {{ts.EndDate | moment: \'format\': \'MMM DD, YYYY\'}}</td><td>{{ts.PortalHours}}</td><td>{{ts.UploadedHours}}</td><td><span ng-if="ts.tsaction == \'Submitted\'" style="display: none;">{{ts.tsaction}}</span> <i class="material-icons text-primary pointer" ng-click=approveTs(ts) ng-hide="ts.tsprocessing " ng-if="ts.IsAccountsProcessed == false">check_circle_outline</i><md-progress-circular ng-if="ts.tsprocessing && ts.IsAccountsProcessed == false" md-mode=indeterminate class=md-hue-2 md-diameter=20px></md-progress-circular><i class="material-icons text-danger pointer" ng-click=RejectBox(ts,$event) ng-hide=ts.tsprocessing ng-if="ts.IsAccountsProcessed === false">highlight_off</i><!-- <span ng-if="ts.IsAccountsProcessed == true">{{ts.AccountsAction}}</span> --> <span ng-if="ts.AccountsAction == \'Approved\'">{{ts.AccountsAction}}</span> <span ng-if="ts.AccountsAction == \'Rejected\'">{{ts.AccountsAction}} <span class=rejectReason><md-tooltip md-direction=top>{{ts.AcctsRejectReason}}</md-tooltip><i class=material-icons>info</i></span></span></td><td ng-click=compareTs(ts)><i class="material-icons text-info pointer">compare</i></td></tr><tr ng-if=ts.showRejectBox class=RejectBox><td colspan=6><div class="d-flex w-100 col"><input type=text ng-model=rejectReason placeholder="Type your timesheet rejection reason.." class="flex-grow-1 p-1" style="width: auto;" required><md-button class="md-raised md-primary" ng-click="rejectReason!==undefined&&rejectReason!==null&&rejectTs(rejectReason)">Reject</md-button><md-button ng-click=hideRejectBox(ts)>Cancel</md-button></div></td></tr></tbody></table></div></div></md-content></div><div class="col-lg-6 showDetailsPage" ng-if=showUserTsPeriods><h3 class=pt-2>{{userDetails.DisplayName}}</h3><md-content ng-if=TimePeriodRangeData><form class="d-flex flex-row" ng-submit=TimePeriodRange(DateRange)><p class="m-0 pt-3 pl-3">Select Time Period to get Timesheets.</p><md-datepicker aria-required=true required ng-model=DateRange.tsFromDate md-placeholder="Enter From Date" class="ml-2 mr-2" md-open-on-focus md-max-date=maxDate></md-datepicker><md-datepicker aria-required=true required ng-model=DateRange.tsToDate md-placeholder="Enter To Date" class="ml-2 mr-2" md-open-on-focus md-max-date=maxDate></md-datepicker><md-button class="md-raised md-primary" type=submit>Submit</md-button></form><!-- <ci-spinner class="loginLoader" ng-if="timePeriodTimesheetsLoader"></ci-spinner> --><div class="md-whiteframe-1dp wrapperBox m-0" ng-if=tsTable><table class="table table-hover pointer" id=TimesheetsTable><thead><tr><th>#</th><th>Timesheet Period</th><th>Portal Hours</th><th>Uploaded Hours</th><th>Action</th><th>Compare</th></tr></thead><tbody><tr ng-repeat="ts in timePeriodTimesheets" ng-class="{\'bg-danger\': ts.AccountsAction == \'Rejected\', \'bg-primary\': ts.AccountsAction == \'Approved\'}"><td>{{$index+1}}</td><td>{{ts.StartDate | moment: \'format\': \'MMM DD, YYYY\'}} - {{ts.EndDate | moment: \'format\': \'MMM DD, YYYY\'}}</td><td>{{ts.PortalHours}}</td><td>{{ts.UploadedHours}}</td><!-- <td ng-if="ts.tsprocessing">\r\n                                                                            <ci-spinner class="loginLoader"> </ci-spinner></td> --><td><span ng-if="ts.IsAccountsProcessed == false && ts.IsManagerProcessed === false">Pending at Accounts</span> <span ng-if="ts.IsAccountsProcessed == true && ts.IsManagerProcessed === false">Pending at Manager</span><!-- <i class="material-icons text-primary" ng-click="approveTs(ts)" ng-if="ts.IsAccountsProcessed == false">check_circle_outline</i>\r\n                                                            <i class="material-icons text-danger" ng-click="showRejectionDialog(ts,$event)" ng-if="ts.IsAccountsProcessed === false">highlight_off</i> --><!-- <span ng-if="ts.IsAccountsProcessed == true">{{ts.AccountsAction}}</span> --> <span ng-if="ts.AccountsAction == \'Approved\'">{{ts.AccountsAction}}</span> <span ng-if="ts.AccountsAction == \'Rejected\'">{{ts.AccountsAction}} <span class=rejectReason><md-tooltip md-direction=top>{{ts.AcctsRejectReason}}</md-tooltip><i class=material-icons>info</i></span></span></td><td ng-click=compareTs(ts)><i class="material-icons text-info pointer">compare</i></td></tr></tbody></table></div></md-content></div></div></div>');
$templateCache.put('app/components/accounts/account/compareTs.html','<md-dialog aria-label="Rejection Reason" class="w-100 h-100"><form ng-cloak class=h-100><md-toolbar><div class=md-toolbar-tools><h2>Compare</h2><span flex></span><!-- <md-button class="md-icon-button" ng-click="cancel()">\n                    <md-icon md-svg-src="img/icons/ic_close_24px.svg" aria-label="Close dialog"></md-icon>\n                </md-button> --></div></md-toolbar><md-dialog-content style="overflow:hidden; height: 100%;"><div class="md-dialog-content d-lg-flex flex-lg-row flex-sm-column h-100"><div class=col-lg-4><h4>Texperts Timesheet</h4><div><div class="d-flex flex-row"><p class=mr-4><label><strong>Name</strong></label> <label>{{ tsData.DisplayName }}</label></p><p><label><strong>Timesheet Period</strong></label> <label>{{ tsData.Range }}</label></p></div><table class="table table-hover"><tr><th>Date</th><th>Hours</th></tr><tr ng-repeat="info in tsData.timeinfo"><td class=p-2>{{ info.Date }}/{{ info.Day }}</td><td class=p-2>{{ info.Hours }}</td></tr></table><p><label>Total Hours</label> <label>{{ tsData.PortalHours }}</label></p></div></div><div class=col-lg-8><h4>Client Timesheet</h4><!-- <div>{{tsData.FileName}}</div> --><!-- <pdfjs-viewer src="{{ pdf.src }}"></pdfjs-viewer> --><!-- <pdfjs-viewer src="{{clientTimesheetDoc}}"></pdfjs-viewer> --><!-- <ng-pdf template-url="/partials/viewer.html" scale=1></ng-pdf> --><!-- <object width="400" height="500" type="application/pdf" data="{{clientTimesheetDoc}}" id="pdf_content">\n                        <p>Insert your error message here, if the PDF cannot be displayed.</p>\n                      </object> --><ci-spinner ng-if=!ctsfileload></ci-spinner><h5 ng-if=notAdmittedCtsMsg class="text-center text-warning mt-4 pt-4">Client Timesheet Not Applicable.</h5><!-- <img ng-if="ctsfileload && !notAdmittedCtsMsg" ng-pdf-object ng-src="data:application/pdf;base64,{{ctsData}}" alt="Client Timesheet" style="width: inherit;"> --> <img id=ctsImgViewWrapper style="width: inherit;"><!-- <div ng-if="ctsfileload && !notAdmittedCtsMsg" ng-pdf-object url="data:application/pdf;base64,{{ctsData}}"></div> --><!-- <object ng-if="ctsfileload && !notAdmittedCtsMsg" data="data:application/pdf;base64,{{ctsData}}" type="application/pdf" width="100%" height="100%">\n                        <p><b>Example fallback content</b>: This browser does not support PDFs. Please download the PDF to view it: <a href="/pdf/sample-3pp.pdf">Download PDF</a>.</p>\n                     </object> --><!-- <embed ng-if="ctsfileload && !notAdmittedCtsMsg" src="data:application/pdf;base64,{{ctsData}}" type="application/pdf" width="100%" height="100%"> --><!-- <ng-pdf ng-if="ctsfileload && !notAdmittedCtsMsg" template-url="{{pdfUrl}}"></ng-pdf> --><!-- <ng-pdf ng-if="ctsfileload && !notAdmittedCtsMsg" template-url="{{pdfUrl}}"></ng-pdf> --><iframe id=ctsViewFile frameborder=0 width=100% height=100%></iframe><!-- <iframe id="xlsFileViewer" src="" width="600" height="780" style="border: none;"></iframe> --><!-- <div id="pdfpdf"></div> --></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel()>Cancel</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/accounts/account/showRejectionDialogController.html','<md-dialog aria-label="Rejection Reason"><form ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>Rejection Reason</h2><span flex></span><!-- <md-button class="md-icon-button" ng-click="cancel()">\n                    <md-icon md-svg-src="img/icons/ic_close_24px.svg" aria-label="Close dialog"></md-icon>\n                </md-button> --></div></md-toolbar><md-dialog-content><div class=md-dialog-content><md-input-container class=md-block flex-gt-sm><label>Rejection Reason</label> <textarea name="" cols=30 rows=10 ng-model=rejectReason></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=rejectTs(rejectReason)>Reject</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/accounts/accountsPayperiod/accountsPayperiod.component.html','<div class=container-fluid><md-content class="admin-container main-container outletContainer adminController md-padding" flex layout-xs=row layout=column ng-if=!loginLoader><ci-spinner class=loginLoader></ci-spinner></md-content><md-content class="admin-container main-container p-0 outletContainer adminController md-padding h-100" flex layout-xs=row layout=column ng-if=loginLoader><div flex layout=row class=h-100><div class="wrapper ng-table col p-0 md-whiteframe-4dp h-100 showUsers" ng-class="openPanel ? \'showHalf col-lg-4\' : \'\'"><div class=payPeriodSelect></div><div class=usersTable ng-class="toggleShowUsers ? \'oh\' : \'\'"><table class="table table-hover"><thead><tr><th colspan=5><div class="d-flex flex-row"><label for=searchSort class="pr-5 pt-2">Search</label> <input type=text ng-model=searchUsers.$ class=col></div></th></tr><tr><th>#</th><th ng-show=!openPanel>Name</th><th>Username</th><th>Employee Id</th><th>Role</th></tr></thead><tbody><tr ng-repeat="row in usersList | filter:searchUsers" ng-click=showUserDetails(row)><td>{{$index+1}}</td><td ng-show=!openPanel>{{row.DisplayName}}</td><td>{{row.UserName}}</td><td>{{row.EmpId}}</td><td>{{row.RoleId}}</td></tr></tbody></table></div><div class=toggleShowUsersOverlay ng-if=toggleShowUsers></div><div class=toggleShowUsers ng-show=showDetailsPage ng-class="toggleShowUsers ? \'toggleShowUsersOverlay\' : \'\'" ng-click=toggleShowUsersev()><!-- <span ng-if="toggleShowUsers">&gt;</span>\r\n                        <span ng-if="!toggleShowUsers">&lt;</span> --></div></div><div class="col showDetailsPage" ng-if=showDetailsPage ng-class="openPanel ? \'showHalf offset-lg-4 pl-1 pr-1 pt-2\' : \'\'"><h3 class=pt-2>{{userDetails.DisplayName}}</h3><md-content><ci-spinner class=loginLoader ng-if=!getUserData></ci-spinner><div class="md-whiteframe-1dp wrapperBox m-0"><div layout-padding><div class="d-flex flex-row"><div><button type=button class="btn btn-outline-secondary btn-sm mr-1" ng-click="filter(\'All\')">View All</button><!-- <button type="button" class="btn btn-outline-primary btn-sm mr-1" ng-click="filter(\'Submitted\')">Submitted</button> --> <button type=button class="btn btn-outline-info btn-sm mr-1" ng-click="filter(\'Approved\')">Approved</button> <button type=button class="btn btn-outline-danger btn-sm mr-1" ng-click="filter(\'Rejected\')">Rejected</button></div><div><md-select placeholder="Assign to user" ng-model=month md-on-open=loadMonths() md-on-close=payPeriod(month) style="min-width: 200px;"><md-option ng-value=month.id ng-repeat="month in months">{{month.name}}</md-option></md-select>{{month}}</div></div><table class="table table-hover"><thead><tr><th>#</th><th>Timesheet Period</th><th>Portal Hours</th><th>Uploaded Hours</th><th>Action</th><th>Compare</th></tr></thead><tbody><tr ng-repeat="ts in Timesheets | filter:search" ng-class="{\'bg-danger\': ts.AccountsAction == \'Rejected\', \'bg-primary\': ts.AccountsAction == \'Approved\'}"><td>{{$index+1}}</td><td>{{ts.StartDate | moment: \'format\': \'MMM DD, YYYY\'}} - {{ts.EndDate | moment: \'format\': \'MMM DD, YYYY\'}}</td><td>{{ts.PortalHours}}</td><td>{{ts.UploadedHours}}</td><!-- <td ng-if="tsprocessing">\r\n                                                    <ci-spinner class="loginLoader"> </ci-spinner></td> --><td><i class="material-icons text-primary" ng-click=approveTs(ts) ng-if="ts.IsAccountsProcessed == false">check_circle_outline</i> <i class="material-icons text-danger" ng-click=showRejectionDialog(ts,$event) ng-if="ts.IsAccountsProcessed === false">highlight_off</i> <span ng-if="ts.IsAccountsProcessed == true">{{ts.AccountsAction}}</span></td><td ng-click=compareTs(ts)><i class="material-icons text-info">compare</i></td></tr></tbody></table></div></div></md-content></div></div></md-content></div>');
$templateCache.put('app/components/accounts/downloadTS/downloadTS.component.html','<div class=container-fluid><div class=row><div class=col-12><form name=dwnAllTs ng-submit="dwnAllTs.$valid && dwnAllTsSubmit(dwnAllTsData)" ng-if=userDataLoaded class="card mt-3"><div class="card-header d-flex align-items-center"><h3>Download Timesheets</h3><div class="form-inline ml-3"><label for="">Payroll Month</label> <select class="form-control form-control-sm ml-1" required ng-model=dwnAllTsData.PayrollMonth><option ng-repeat="state in vm.months" ng-value=state>{{state}}</option></select></div><div class="form-inline ml-3"><label for="">Payroll year</label> <select class="form-control form-control-sm ml-1" required ng-model=dwnAllTsData.Year><option ng-repeat="year in vm.payrollYear" ng-value=year>{{year}}</option></select></div><button type=submit class="btn btn-primary btn-sm ml-3">Submit</button></div><div class=card-body><ci-spinner ng-if="!dwnAllUsersDataLoad && dwnAllUsersDataOpened"></ci-spinner><ci-spinner ng-if=!exportxlsTableVisible></ci-spinner><div class="table table-responsive mb-4" style="visibility: hidden; transition: all 0.2s ease-in-out;" ng-if=dwnAllUsersDataLoad id=exportxlsTableVisible><table id=exportxlsTable class="display nowrap table"><thead><tr><th>#</th><th>Display Name</th><th ng-repeat="weekinfo in dwnAllUsersData[0].weekendinginfo track by $index" ng-class="{weekColor{{$index}} : dwnAllUsersData[0].weekendinginfo.length>0}">{{weekinfo.enddate | moment: \'format\': \'MM/DD/YYYY\'}}</th><th class=totalMTSHead>Total MTS Hours</th><th ng-repeat="payrollMonthDate in dwnAllUsersData[0].timeinfo track by $index">{{payrollMonthDate.Date}}</th><!-- <th ng-repeat="payrollMonthDate in payrollMonthDates track by $index">{{payrollMonthDate}}</th> --></tr></thead><tbody><tr ng-repeat="userData in dwnAllUsersData track by $index"><th scope=row>{{$index+1}}</th><td>{{userData.FirstName}} {{userData.LastName}}</td><td class=text-center ng-repeat="weekinfo in userData.weekendinginfo track by $index" ng-class="{weekColor{{$index}} : userData.weekendinginfo.length>0}">{{weekinfo.CTSHours}}</td><td class="text-center totalMTSbody">{{userData.TotalHours}}</td><td class=text-center ng-repeat="timeinfo in userData.timeinfo">{{timeinfo.hours}}</td></tr></tbody></table></div></div></form></div></div></div>');
$templateCache.put('app/components/accounts/notifyUsers/notifyUsers.component.html','<div class="container-fluid p-0"><md-content><md-card><md-card-header><md-card-header-text><div class="d-flex justify-content-between"><span class=md-title>Notify Users To Submit Pending Timesheets.</span> <button class="btn btn-primary btn-sm notifyBtn" ng-click=notifyUsers(userPendingTs) ng-if=usersloaded><i class="fas fa-envelope mr-2"></i>Notify <span>{{userPendingTs.users.length}}</span> Pending Users</button></div></md-card-header-text></md-card-header><md-card-content class="p-0 notifyTable"><!-- <canvas id="bar" class="chart chart-bar" chart-data="monthdata" chart-labels="monthlabels" chart-series="series" chart-options="chartOptionsMonthly"></canvas> --><md-tabs md-dynamic-height md-border-bottom md-selected=NotifyUsersselectedIndex class=pendingUsersList><md-tab ng-repeat="ptr in pendingTrange" label="{{ptr | moment: \'format\': \'MM/DD/YYYY\'}}" md-on-select="onTabSelected(NotifyUsersselectedIndex, ptr)"><ci-spinner ng-if=!usersloaded></ci-spinner><md-content class="md-padding d-flex flex-row flex-wrap" ng-if=usersloaded><div class=table-responsive><table class="table notifyUsersTable"><thead><tr><th scope=col>#</th><th scope=col>Name</th><th scope=col>Username</th><th scope=col class=text-center>MTS</th><th scope=col class=text-center>CTS</th><th scope=col class=text-center>Notify</th></tr></thead><tbody><tr ng-repeat="pendingUsers in userPendingTs.users track by $index"><th scope=row>{{$index+1}}</th><td>{{pendingUsers.FristName}} {{pendingUsers.LastName}}</td><td>{{pendingUsers.Username}}</td><td class=text-center><img src=images/tick.png alt="" style="height: 20px;" ng-if=pendingUsers.isMTSSubmitted> <img src=images/cross.png alt="" style="height: 20px;" ng-if=!pendingUsers.isMTSSubmitted></td><td class=text-center><img src=images/tick.png alt="" style="height: 20px;" ng-if=pendingUsers.isCTSSubmitted> <img src=images/cross.png alt="" style="height: 20px;" ng-if=!pendingUsers.isCTSSubmitted></td><td><span class="text-primary pointer font-weight-bolder" ng-click="notifyUser(pendingUsers, userPendingTs.range)">Send Email</span></td></tr></tbody></table></div></md-content></md-tab></md-tabs></md-card-content></md-card></md-content></div>');
$templateCache.put('app/components/accounts/notifyUsers/notifyUsersEmailDialog.html','<md-dialog aria-label="Notify Users" flex=70><form class=sendEmailDialog ng-cloak name=acctsemailnoti ng-submit="acctsemailnoti.$valid && sendNotifyEmail(mailer)"><md-toolbar><div class=md-toolbar-tools><h2>Notify Users for <span class=text-warning>{{users.range | moment: \'format\': \'MM/DD/YYYY\'}}</span> period.</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=recipients>Recipients</label> <textarea multiple-email-validator class=form-control id=recipients rows=3 ng-model=mailer.Recipient readonly></textarea></div><div class="form-group col"><label for=subject>Subject<sup>*</sup></label> <input type=text class=form-control ng-model=mailer.Subject name=subject placeholder=Subject id=subject required></div><div class="form-group col"><label for=message>Message<sup>*</sup></label> <textarea class="form-control messagebody" id=message rows=3 ng-model=mailer.Body required></textarea></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/admin/adminDashboard/adminDashboard.component.html','<div class=container id=marketer-dashboard><div class="row justify-content-center"><div class=col-8><ul class=row ng-class="isMobile?\'h-100\':\'\'"><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=downloadTSAdmin()><img src=../../../../images/downloadTs.png alt=Interviews class=grow><br><span>Download Timesheets</span></li><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=notifyUsersAdmin()><img src=../../../../images/notifyusers.png alt=Consultants class=grow><br><span>Notify Users</span></li><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=accountsAdmin()><img src=../../../../images/approveTs.png alt="Talent Search" class=grow><br><span>Approve Timesheets</span></li></ul></div></div></div>');
$templateCache.put('app/components/consultant/dashboard/dashboard.html','<div class=container-fluid style="background-color: #ece6e2;"><texperts-loader ng-style="{\'height\':\'{{innerHeight}}\'}" ng-if=!ShowTimeTracker></texperts-loader><div class=row ng-show=ShowTimeTracker><div ng-show=ShowTimeTracker ng-class="isMobile ? \'col-12\' : \'col-lg-5\' " class=p-2><md-card class="ml-1 mr-1"><md-card-header class=p-0><md-card-header-text><span class="md-title p-3">Timesheets</span></md-card-header-text></md-card-header><md-tabs md-border-bottom><md-tab label=New><md-content class="p-0 h-100"><form novalidate name=tTrackerForm layout=column ng-submit="tTrackerForm.$valid && timesheetSubmit(PortalTsClient, fromDate, toDate)" ng-show=!showTimetrackerPage><md-card-content class="p-0 pt-3" layout=column><md-input-container class="mb-0 p-4 col-lg-10"><label>Select Client</label><md-select ng-model=PortalTsClient required ng-change=TsSelectedClient(PortalTsClient)><md-option><em>None</em></md-option><md-option ng-repeat="client in ClientsList" ng-value=client.ClientId>{{client.ClientName}}</md-option></md-select></md-input-container><div class="flex-lg-row flex-sm-column d-lg-flex pl-4 pr-4" ng-if="PortalTsClient !== null && PortalTsClient !== \'None\' && PortalTsClient !== undefined"><md-input-container><label>From date</label><md-datepicker ng-model=fromDate ng-change=checkfromDate(fromDate) md-open-on-focus name=fromDate md-min-date=selectedClient.StartDate md-max-date=selectedClient.EndDate md-date-filter=onlyWeekendsPredicate class=w-100 required></md-datepicker><div ng-messages=tTrackerForm.fromDate.$error><div ng-message=valid>Use a valid date format</div><div ng-message=mindate>Choose a date on or after {{minDate | date:"shortDate"}}</div><div ng-message=minDate>Choose a date on or before {{minDate | date:"shortDate"}}</div></div></md-input-container><md-input-container><label>To date</label><!-- <span ng-model="toDate">{{toDate | moment: \'format\': \'MMM DD, YYYY\' }}</span> --><md-datepicker ng-model=toDate name=toDate md-min-date=minToDate md-max-date=maxToDate class=w-100 ng-disabled=true></md-datepicker><div ng-messages=tTrackerForm.toDate.$error required><div ng-message=valid>Use a valid date format</div><div ng-message=mindate>Choose a date on or after {{minDate | date:"shortDate"}}</div><div ng-message=maxdate>Choose a date on or before {{maxDate | date:"shortDate"}}</div></div></md-input-container></div><div flex></div></md-card-content><md-card-footer ng-if=!showTimetrackerPage><div class="alert alert-error m-0" role=alert ng-if="tsRange && notInBetweenExp">Timesheet for <strong>{{selectedRange}}</strong>, is not in between client experience.</div><div class="alert alert-warning m-0" role=alert ng-if="tsRange && selectedRange !== undefined && !notInBetweenExp">Timesheet for <strong>{{selectedRange}}</strong>, has already been submitted.</div><div class="alert alert-error m-0" role=alert ng-if="tsRange && beforeJoiningDate && !notInBetweenExp"><strong>Selected Date</strong> is before your joining date.</div><div class="alert alert-error m-0" role=alert ng-if="tsRange && afterPresentDate && !notInBetweenExp">You are in current Period and can submit timesheet on or after friday.</div><md-button class=cc-button type=submit ng-show=tTrackerForm.$valid ng-if="!tsRange && PortalTsClient !== null && PortalTsClient !== \'None\' && PortalTsClient !== undefined">Submit</md-button></md-card-footer><ci-spinner ng-if=showTimetrackerloader></ci-spinner></form></md-content></md-tab><md-tab label=Submitted><md-content class=p-0><div class="p-2 d-flex flex-row hide"><a ng-click=getPrevYearTs(2019) class="pointer pr-3 text-warning underline">{{prevYear}}</a> <a ng-click=getPresnYearTs() class="pointer text-warning underline">{{presentYear}}</a></div><ci-spinner ng-if=!showSubmittedTsExport></ci-spinner><div class=scrollTable ng-if=!yearTsLoader><table class="table table-hover w-100 SubmittedTimesheets" id=SubmittedMts><thead><tr><th>Time</th><th>Status</th><th>Total Hours</th></tr></thead><tbody><tr ng-repeat="submittedTsitem in SubmittedTsS" ng-click="openSubTs(submittedTsitem.UniqueTSId, submittedTsitem.submitedRange)" ng-class="{\'bg-danger\': submittedTsitem.ManagerAction == \'Rejected\', \'bg-danger\': submittedTsitem.AccountsAction == \'Rejected\', \'bg-primary\': submittedTsitem.ManagerAction == \'Approved\'}"><td>{{submittedTsitem.submitedRange}}</td><td>{{submittedTsitem.Status}}</td><td>{{submittedTsitem.TotalHours}}</td></tr></tbody></table><!-- <p ng-if="SubmittedTsS.length == 0" class="p-3">No Timesheets are\r\n                                        submitted.</p> --></div></md-content></md-tab></md-tabs></md-card></div><div ng-show=ShowDocuments ng-class="isMobile ? \'col-12\' : \'col-lg-5\' " class=p-2><md-card><md-card-header class=p-0><md-card-header-text><span class="md-title p-3" ng-if=clientTsSubmisson>Client Timesheets</span></md-card-header-text></md-card-header><md-tabs md-border-bottom md-selected=selectedCtsIndex><md-tab label=New md-on-select=newCts()><md-content class="p-0 h-100"><div class="d-flex flex-row pl-2 pr-2 pt-1"><a ng-click=selectCtsRanges(2019) class="pointer pr-3 btn btn-sm" ng-class="selectCtsRangesYear === 2019?\'btn-secondary text-white\':\'\'">2019</a> <a ng-click=selectCtsRanges(2020) class="pointer btn btn-sm" ng-class="selectCtsRangesYear === 2020?\'btn-secondary text-white\':\'\'">2020</a> <a ng-click=selectCtsRanges(2021) class="pointer btn btn-sm" ng-class="selectCtsRangesYear === 2021?\'btn-secondary text-white\':\'\'">2021</a></div><ci-spinner class=loginLoader ng-if=ctsUploadLoader></ci-spinner><form name=cts novalidate ng-submit="cts.$valid && ctsFileUpload(cts, selClient)" ng-if=!ctsUploadLoader><div class="ml-2 pt-2">Showing client timesheets for year <span class="badge badge-pill badge-info">{{selectCtsRangesYear}}</span></div><md-card-content class="p-2 pt-3" layout=column><div class="d-flex flex-row"><md-input-container flex class=mb-0><label>Select Time Period</label><md-select ng-model=cts.TimesheetPeriod required ng-change=selCtsRange(cts) md-on-open=ctsRanges()><md-select-header><ci-spinner ng-if=drpPreload></ci-spinner><h5 class=pl-3 ng-if="!drpPreload && PendingCtsTs.length === 0">No pending timesheets.</h5></md-select-header><md-option value={{null}} ng-if="PendingCtsTs.length>0"><em>None</em></md-option><md-option ng-repeat="tpts in PendingCtsTs" ng-value=tpts.UniqueTSId>{{tpts.submitedRange}}</md-option></md-select></md-input-container><md-input-container flex class=mb-0><label ng-hide="cts.TimesheetPeriod !== \'None\'">Select Client</label><md-select ng-model=selClient required aria-disabled=true disabled><md-option><em>None</em></md-option><md-option ng-repeat="client in ClientsList" ng-value=client.ClientId>{{client.ClientName}}</md-option></md-select></md-input-container></div><div class="d-flex flex-row"><md-input-container class="mb-0 w-100 col"><label>Total Hours</label> <input ng-model=cts.TotalHours type=number required min=0></md-input-container><div class=col layout=column><p class=mb-0>Which file type you want to upload?</p><md-radio-group ng-model=cts.FileType flex layout=row layout-align="start center" ng-change=clearUpload()><md-radio-button value=image>Image</md-radio-button><md-radio-button value=pdf>Pdf</md-radio-button><!-- <md-radio-button value="xls">Excel</md-radio-button> --></md-radio-group></div></div><div><div ng-if="cts.FileType == \'image\'"><div ng-if="files.length === 0"><p>Maximum you can upload 3 image files.</p><input type=file ng-file-model=files accept=image/JPG,image/PNG multiple id=imageUpload class="profilePicUploadBtn none" custom-on-change="fileUploaded(\'img\',cts)"> <label for=imageUpload class="ml-3 uploadBtn">Select files <i class="fa fa-cloud-upload"></i></label></div><div class=d-flex ng-if="files.length > 0"><p ng-repeat="file in files" class=w-100>{{file.name}}</p><i class="material-icons col pointer" ng-click=clearUpload()>cancel</i></div></div><div ng-if="cts.FileType == \'pdf\'"><div ng-if="files.length === 0"><p>Maximum you can upload 1 pdf file. If you have multiplemerge and upload.</p><input type=file ng-file-model=files accept=application/pdf id=pdfUpload class="profilePicUploadBtn none" custom-on-change="fileUploaded(\'pdf\',cts)"> <label for=pdfUpload class="ml-3 uploadBtn">Select file <i class="fa fa-cloud-upload"></i></label></div><div class=d-flex ng-if="files.length > 0"><p ng-repeat="file in files" class="w-100 col">{{file.name}}</p><i class="material-icons col pointer" ng-click=clearUpload()>cancel</i></div></div><!-- <input type="file" ng-file-model="files" accept="image/*,application/pdf" multiple />\r\n                                            <button type="button" ng-click="upload()">Upload</button>\r\n                                            <p ng-repeat="file in files">\r\n                                                {{files.length}}\r\n                                              </p> --></div>{{ctsFile.name}}{{ctsFile}}<div ng-if="ctsFile.name !== undefined" class="d-flex flex-row"><p flex>{{ctsFile.name}}</p><i class=material-icons ng-click=clearUpload()>cancel</i></div></md-card-content><md-card-footer class=p-1><ci-spinner class=loginLoader ng-if=ctsUploadLoader></ci-spinner><!-- <md-button ng-click="selectedCtsIndex = 0">Back</md-button> --> <button class="btn btn-sm btn-primary" type=submit ng-if="!ctsUploadLoader && cts.TimesheetPeriod !== \'None\' && cts.TimesheetPeriod !== undefined && files.length > 0 && cts.TotalHours !== undefined">Submit</button></md-card-footer></form></md-content></md-tab><md-tab label=Submitted md-on-select=loadSubmittedCTS()><md-content><ci-spinner ng-if=GetCTSSubtRangesLoader></ci-spinner><!-- <p ng-if="SubmittedRanges.length === 0 ">No Pending Timesheets for submission.</p> --><table class="table table-hover w-100 SubmittedTimesheets" id=SubmittedCts ng-if=!GetCTSSubtRangesLoader><thead><tr><th>Time</th><th>Hours</th><!-- <th>Download</th> --></tr></thead><tbody><!-- <tr ng-repeat="tpts in CtsSubmitted" ng-click="clientRangeSubmisson(tpts)"> --><tr ng-repeat="tpts in CtsSubmitted |  orderBy: reverse:true track by $index"><td>{{tpts.Range}}</td><td>{{tpts.TotalHours}}</td><!-- <td ng-click="downloadCts(tpts)">Download</td> --></tr></tbody></table></md-content></md-tab></md-tabs></md-card></div><div ng-class="isMobile ? \'col-12\' : \'col-lg-2\' " style=overflow:hidden; class=p-2><md-card class="ml-1 mr-1 profileCard mb-0"><md-card-header layout=row layout-align="center center" class=profileImgFallback><i class=material-icons ng-if=!profilePicUploaded>account_circle</i> <label for=AvatarUpload ng-if=!profilePicUploaded>Click here to upload your profile picture</label> <label for=AvatarUpload ng-if=profilePicUploaded class=profilePicEdit>Edit</label> <input type=file class=hide ng-file-model=AvatarUpload id=AvatarUpload custom-on-change=AvatarUploadfunc(AvatarUpload) accept=image/JPG,image/PNG><!-- <img ng-src="data:image/jpg;base64,{{picFile.Pic}}" class="profilePicture" alt="" ng-if="profilePicUploaded"> --><div style="background-image:url(\'data:application/pdf;base64,{{picFile}}\')" class=profilePicture alt="" ng-if=profilePicUploaded for=AvatarUpload></div></md-card-header><md-card-content layout=column n ui-sref=profile() class=pointer><label class="h6 pointer text-white">{{tokenData.displayname}}</label> <label class="h6 text-white pointer">{{tokenData.email}}</label><!-- <label class="h6 text-white">{{tokenData.CompanyName}}</label> --></md-card-content></md-card></div></div><div class=row><div class="col-12 p-1"><md-card ng-show=ShowDocuments class=mt-0><md-card-header><md-card-header-text><span class=md-title>Working Hours</span></md-card-header-text></md-card-header><md-card-content style="height: 320px;"><canvas id=bar class="chart chart-bar" chart-data=data chart-labels=labels chart-series=series chart-options=chartOptions chart-colors=colors></canvas></md-card-content></md-card></div></div></div>');
$templateCache.put('app/components/consultant/documents/documents.html','<div class=container-fluid><texperts-loader ng-style="{\'height\':\'{{innerHeight}}\'}" ng-if=loginLoader></texperts-loader><md-card ng-if=!loginLoader><md-card-title><md-card-title-text><span class="md-headline text-dark">Documents</span></md-card-title-text></md-card-title><md-card-content><form name=profileForm ng-submit="profileForm.$valid && saveProfile(user)" class="UserProfile p-0" autocomplete=off novalidate><div ng-if=!loginLoader autocomplete=off><ul class=list-group><li class="list-group-item list-group-item-action d-flex justify-content-between col-sm-12" ng-repeat="document in docTypes track by $index"><div class=col-sm-4><h6 class=mb-0>{{ document.DocType }}</h6></div><div class=col-sm-5><div ng-repeat="documentDa in documentsList track by $index" ng-if="documentDa.DocID == document.DocID"><a ng-click=downloadFile(documentDa) href="" class=docDownloadLink>{{documentDa.FileName}}</a></div></div><div class=col-sm-3><input autocomplete=off type=file file-model={{document.docModel}} id={{document.docModel}} custom-on-change=uploadFile(document,document.docModel) class=col accept="image/JPG,image/PNG, application/pdf" ng-class="isMobile ? \'\' : \'none\'"><!-- <label for="{{document.docModel}}" class="custom-file-upload"\r\n                                    ng-if="!document.spinStart && !isMobile" ng-class="isMobile ? \'hide\' : \'none\'">\r\n                                    <i class="fa fa-cloud-upload"></i>\r\n                                </label> --><ci-spinner ng-if=document.spinStart></ci-spinner><span ng-show=docsForm.document.docValue.$error.required>All Documents are required.</span> <span ng-show=docsForm.document.docValue.$error.maxsize>Files must not exceed 5000 KB</span></div></li></ul></div></form></md-card-content></md-card></div>');
$templateCache.put('app/components/consultant/profile/add-experience-dialog copy.html','<md-dialog aria-label="Add Experience" class=add-experience ng-class="isMobile ? \'mobile\' : \'\'"><form novalidate ng-submit="expf.$valid && answer(exp)" name=expf><md-toolbar><div class=md-toolbar-tools><h2>Add Experience</h2><span flex></span><!-- <md-button class="md-icon-button" ng-click="cancel()">\n                    <md-icon md-svg-src="img/icons/ic_close_24px.svg" aria-label="Close dialog"></md-icon>\n                </md-button> --></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div layout-gt-sm=column layout-padding><md-input-container><label>Company Name</label> <input ng-model=exp.PayrollCompany required></md-input-container><md-input-container><label>End Client</label> <input ng-model=exp.ClientName required></md-input-container><md-input-container><label>Client Address</label> <input ng-model=exp.ClientAddress required></md-input-container><md-input-container><label>Title</label> <input ng-model=exp.Title required></md-input-container><div layout=row><md-checkbox ng-model=exp.isCurrent aria-label="Certify Compliance" ng-change=checkPrevEmp(exp.isCurrent)>Is this is your current Project</md-checkbox></div><div layout-gt-sm=row><md-input-container flex-gt-sm=50 flex-sm=100><label>Joining Date</label><md-datepicker flex=100 ng-model=exp.StartDate md-min-date=PrevStartDate required md-open-on-focus md-max-date=maxDate md-hide-icons=calendar></md-datepicker></md-input-container><md-input-container flex-gt-sm=50 flex-sm=100 ng-if=!exp.isCurrent><label>Last Working Date</label><md-datepicker flex=100 ng-model=exp.EndDate ng-required=!exp.isCurrent md-open-on-focus md-min-date=exp.StartDate md-max-date=maxDate md-hide-icons=calendar></md-datepicker></md-input-container><md-input-container ng-if=exp.isCurrent flex-gt-sm=50 flex-sm=100><label>Enter Date</label><!-- <input ng-model="exp.isCurrent" type="checkbox" required ng-change="currentEmpChange()"> --><md-datepicker ng-model=exp.PrevEndDate ng-required=exp.isCurrent md-open-on-focus md-min-date=PrevStartDate md-max-date=exp.StartDate md-hide-icons=calendar></md-datepicker><p ng-if=exp.isCurrent class=md-caption flex-sm=100>Update project End Date of previous client {{prevEmp.ClientName}}</p></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=cancel()>Cancel</md-button><md-button type=submit>Submit</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/consultant/profile/add-experience-dialog.html','<md-dialog aria-label="Add Experience" class=add-experience ng-class="isMobile ? \'mobile\' : \'\'"><form novalidate ng-submit="expf.$valid && answer(exp)" name=expf><md-toolbar><div class=md-toolbar-tools><h2>Add Experience</h2><span flex></span><!-- <md-button class="md-icon-button" ng-click="cancel()">\n                    <md-icon md-svg-src="img/icons/ic_close_24px.svg" aria-label="Close dialog"></md-icon>\n                </md-button> --></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div layout-gt-sm=column layout-padding><md-input-container><label>Company Name</label> <input ng-model=exp.PayrollCompany required></md-input-container><md-input-container><label>End Client</label> <input ng-model=exp.ClientName required></md-input-container><md-input-container><label>Client Address</label> <input ng-model=exp.ClientAddress required></md-input-container><md-input-container><label>Title</label> <input ng-model=exp.Title required></md-input-container><div layout=row><md-checkbox ng-model=exp.isCurrent aria-label="Certify Compliance" ng-change=checkPrevEmp(exp.isCurrent)>Is this is your current Project</md-checkbox></div><div layout-gt-sm=row><md-input-container flex-gt-sm=50 flex-sm=100><label>Joining Date</label><md-datepicker flex=100 ng-model=exp.StartDate md-min-date=PrevStartDate required md-open-on-focus md-max-date=maxDate md-hide-icons=calendar></md-datepicker></md-input-container><md-input-container flex-gt-sm=50 flex-sm=100 ng-if=!exp.isCurrent><label>Last Working Date</label><md-datepicker flex=100 ng-model=exp.EndDate ng-required=!exp.isCurrent md-open-on-focus md-min-date=exp.StartDate md-max-date=maxDate md-hide-icons=calendar></md-datepicker></md-input-container><md-input-container ng-if=exp.isCurrent flex-gt-sm=50 flex-sm=100><label>Enter Date</label><!-- <input ng-model="exp.isCurrent" type="checkbox" required ng-change="currentEmpChange()"> --><md-datepicker ng-model=exp.PrevEndDate ng-required=exp.isCurrent md-open-on-focus md-min-date=PrevStartDate md-max-date=exp.StartDate md-hide-icons=calendar></md-datepicker><p ng-if=exp.isCurrent class=md-caption flex-sm=100>Update project End Date of previous client {{prevEmp.ClientName}}</p></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=cancel()>Cancel</md-button><md-button type=submit>Submit</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/consultant/profile/ChangeCurrentEmployer.html','<md-dialog aria-label="Add Experience" class=add-experience><form novalidate ng-submit=answer(userData) name=expf><md-toolbar><div class=md-toolbar-tools><h2>Change Current Employer</h2><span flex></span><!-- <md-button class="md-icon-button" ng-click="cancel()">\n                    <md-icon md-svg-src="img/icons/ic_close_24px.svg" aria-label="Close dialog"></md-icon>\n                </md-button> --></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div layout-gt-sm=column layout-padding><table class="table mt-5"><thead><tr><td>Company Name</td><td>Client Name</td><td>Current Project</td></tr></thead><tbody><tr ng-repeat="workExp in userData.workexpmodel track by $index"><td>{{workExp.PayrollCompany}}</td><td>{{workExp.ClientName}}</td><td class=text-center><input autocomplete=off name=isCurrent type=checkbox id=$index ng-click=currentChecked($index) ng-model=workExp.isCurrent></td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=cancel()>Cancel</md-button><md-button type=submit>Submit</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/consultant/profile/profile.html','<div class=container-fluid><texperts-loader ng-style="{\'height\':\'{{innerHeight}}\'}" ng-if=loginLoader></texperts-loader><md-card ng-if=!loginLoader><md-tabs md-dynamic-height md-border-bottom md-selected=selectedIndex><md-tab label=Profile md-on-select=tabSelected() md-on-deselect=tabDeSelected(selectedIndex)><ci-spinner ng-if=profileTabchangeLoader></ci-spinner><md-content class="md-padding pt-0" ng-if=!profileTabchangeLoader><form name=profileForm ng-submit="profileForm.$valid && saveProfile(user)" class="UserProfile p-0" autocomplete=off novalidate><div class="p-0 w-100" layout=row layout-align="end center"><md-button ng-click=editProfile() class="md-primary cc-button" ng-if="inactive && !savingProfile">Edit</md-button></div><div ng-class="{\'mt-3\': !inactive}" layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-4><label>Name</label> <input autocomplete=off ng-model=user.DisplayName required ng-disabled=true only-letters-input></md-input-container><md-input-container class=col-lg-4><label>Email</label> <input autocomplete=off ng-model=user.email required type=email ng-disabled=true></md-input-container><md-input-container class=col-lg-4><label>SSN</label> <input autocomplete=off ng-model=user.SSN required ng-disabled=true type=text only-numbers-input minlength=9></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-4><label>Date of Birth</label><md-datepicker ng-disabled=inactive ng-model=user.DOB md-open-on-focus ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive}" required md-max-date=maxDate md-hide-icons=calendar></md-datepicker><!-- <input autocomplete="off"  ng-model="user.DOB" ng-disabled="inactive" value="{{ user.DOB | moment: \'format\': \'MMM DD, YYYY\' }}"> --></md-input-container><md-input-container class=col-lg-4><label>Martial Status</label><md-select ng-model=user.MartialStatus ng-disabled=inactive><md-option><em>None</em></md-option><md-option ng-repeat="status in MartialStatus" ng-value=status.id>{{status.name}}</md-option></md-select></md-input-container><md-input-container class=col-lg-4><label>Mobile</label> <input autocomplete=off ng-model=user.cell name=mobile ng-disabled=inactive md-minlength=10 md-maxlength=20 type=text><div ng-messages=profileForm.mobile.$error><div ng-message=required>This is too Long.</div></div></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-4><label>Landline</label> <input autocomplete=off ng-model=user.landphone name=landphone ng-disabled=inactive only-numbers-input md-maxlength=10><div ng-messages=profileForm.landphone.$error><div ng-message=required>This is too Long.</div></div></md-input-container></div><div layout=row layout-align="end center"><md-button ng-click=cancelEdit() class="md-primary cc-button" ng-if="!inactive && !savingProfile">Cancel</md-button><md-button type=submit class="md-primary cc-button" ng-if="!inactive && !savingProfile">Save</md-button><ci-spinner ng-if=savingProfile></ci-spinner></div></form></md-content></md-tab><md-tab label=Address md-on-select=tabSelected() md-on-deselect=tabDeSelected(selectedIndex)><ci-spinner ng-if=profileTabchangeLoader></ci-spinner><md-content class="md-padding pt-0" ng-if=!profileTabchangeLoader><form name=AddressForm ng-submit="AddressForm.$valid && saveProfile(user)" class="UserProfile p-0" autocomplete=off novalidate><div class="p-0 w-100" layout=row layout-align="end center"><md-button ng-click=editProfile() class="md-primary cc-button" ng-if="inactive && !savingProfile">Edit</md-button></div><h4 class=mt-3>US Mailing Address</h4><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-6><label>Street Address</label> <input autocomplete=off ng-model=user.resstreetaddr ng-disabled=inactive></md-input-container><md-input-container class=col-lg-6><label>House No</label> <input autocomplete=off ng-model=user.reshousenumber ng-disabled=inactive></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-6><label>City</label> <input autocomplete=off ng-model=user.rescity ng-disabled=inactive only-letters-input></md-input-container><md-input-container class=col-lg-6><label>State</label> <input autocomplete=off ng-model=user.restate ng-disabled=inactive only-letters-input></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-6><label>Zip Code</label> <input autocomplete=off ng-model=user.reszipcode ng-disabled=inactive only-numbers-input md-maxlength=8></md-input-container><md-input-container class=col-lg-6><label>Country</label><md-select ng-model=user.rescountryid ng-disabled=inactive><md-option><em>None</em></md-option><md-option ng-repeat="countrie in countries" ng-value=countrie.CtyID>{{countrie.CountryName}}</md-option></md-select><!-- <input autocomplete="off"  ng-model="user.rescountryid" ng-disabled="inactive"> --></md-input-container></div><h4>Foreign Mailing Address</h4><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-6><label>Street Address</label> <input autocomplete=off ng-model=user.permstreetaddr ng-disabled=inactive></md-input-container><md-input-container class=col-lg-6><label>House No</label> <input autocomplete=off ng-model=user.permhousenumber ng-disabled=inactive></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-6><label>City</label> <input autocomplete=off ng-model=user.permcity ng-disabled=inactive only-letters-input></md-input-container><md-input-container class=col-lg-6><label>State</label> <input autocomplete=off ng-model=user.permstate ng-disabled=inactive only-letters-input></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-6><label>Zip Code</label> <input autocomplete=off ng-model=user.permzipcode ng-disabled=inactive only-numbers-input md-maxlength=8></md-input-container><md-input-container class=col-lg-6><label>Country</label><md-select ng-model=user.permcountryid ng-disabled=inactive><md-option><em>None</em></md-option><md-option ng-repeat="pcountrie in countries" ng-value=pcountrie.CtyID>{{pcountrie.CountryName}}</md-option></md-select><!-- <input autocomplete="off"  ng-model="user.permcountryid" ng-disabled="inactive"> --></md-input-container></div><div layout=row layout-align="end center"><md-button ng-click=cancelEdit() class="md-primary cc-button" ng-if="!inactive && !savingProfile">Cancel</md-button><md-button type=submit class="md-primary cc-button" ng-if="!inactive && !savingProfile">Save</md-button><ci-spinner ng-if=savingProfile></ci-spinner></div></form></md-content></md-tab><md-tab label=Education md-on-select=tabSelected() md-on-deselect=tabDeSelected(selectedIndex)><ci-spinner ng-if=profileTabchangeLoader></ci-spinner><md-content class="md-padding pt-0" ng-if=!profileTabchangeLoader><form name=EducationForm ng-submit="EducationForm.$valid && saveProfile(user)" class="UserProfile p-0" autocomplete=off novalidate><div class="p-0 w-100" layout=row layout-align="end center"><md-button ng-click=editProfile() class="md-primary cc-button" ng-if="inactive && !savingProfile">Edit</md-button></div><h4 class=mt-3>Bachelors</h4><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-4><label>Bachelors Course</label> <input autocomplete=off ng-model=user.edumodel.BachelorsMajor ng-disabled=inactive only-letters-input></md-input-container><md-input-container class=col-lg-4><label>University Name</label> <input autocomplete=off ng-model=user.edumodel.BunivName ng-disabled=inactive only-letters-input></md-input-container><md-input-container class=col-lg-4><label>Graduation Date</label><!-- <input autocomplete="off"  ng-model="user.edumodel.BachelorsGradDate" ng-disabled="inactive"> --><md-datepicker ng-disabled=inactive ng-model=user.edumodel.BachelorsGradDate ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive \n                                        }" md-open-on-focus md-max-date=maxDate md-hide-icons=calendar></md-datepicker></md-input-container></div><h4>Masters</h4><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-4><label>Masters Course</label> <input autocomplete=off ng-model=user.edumodel.MastersMajor ng-disabled=inactive only-letters-input></md-input-container><md-input-container class=col-lg-4><label>University Name</label> <input autocomplete=off ng-model=user.edumodel.Munivname ng-disabled=inactive only-letters-input></md-input-container><md-input-container class=col-lg-4><label>Graduation Date</label><!-- <input autocomplete="off"  ng-model="user.edumodel.MastersGradDate" ng-disabled="inactive"> --><md-datepicker ng-disabled=inactive ng-model=user.edumodel.MastersGradDate md-open-on-focus md-min-date=user.edumodel.BachelorsGradDate md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive \n                                            }"></md-datepicker></md-input-container></div><div layout-gt-sm=row layout-padding ng-if=user.edumodel.IsPHD><h4>PHD</h4><md-input-container class=col-lg-4><label>University Name</label> <input autocomplete=off ng-model=user.edumodel.phdunivname ng-disabled=inactive></md-input-container></div><div layout=row layout-align="end center"><md-button ng-click=cancelEdit() class="md-primary cc-button" ng-if="!inactive && !savingProfile">Cancel</md-button><md-button type=submit class="md-primary cc-button" ng-if="!inactive && !savingProfile">Save</md-button><ci-spinner ng-if=savingProfile></ci-spinner></div></form></md-content></md-tab><md-tab label=Identification md-on-select=tabSelected() md-on-deselect=tabDeSelected(selectedIndex)><ci-spinner ng-if=profileTabchangeLoader></ci-spinner><md-content class="md-padding pt-0" ng-if=!profileTabchangeLoader><form name=IdentificationForm ng-submit="IdentificationForm.$valid && saveProfile(user)" class="UserProfile p-0" autocomplete=off novalidate><div class="p-0 w-100" layout=row layout-align="end center"><md-button ng-click=editProfile() class="md-primary cc-button" ng-if="inactive && !savingProfile">Edit</md-button></div><div layout-gt-sm=row layout-sm=column layout-md=column class=mt-3><md-input-container class=col-lg-4><label>State ID</label> <input autocomplete=off ng-model=user.identymodel.StateId ng-disabled=inactive ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false md-maxlength=30></md-input-container><md-input-container class=col-lg-4><label>Date of Origin</label><!-- <input autocomplete="off"  ng-model="user.identymodel.StateIdIssueDate" ng-disabled="inactive"> --><md-datepicker ng-disabled=inactive ng-model=user.identymodel.StateIdIssueDate md-open-on-focus md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive \n                                            }"></md-datepicker></md-input-container><md-input-container class=col-lg-4><label>Date of Expiry</label><!-- <input autocomplete="off"  ng-model="user.identymodel.StateIdExpDate" ng-disabled="inactive"> --><md-datepicker ng-disabled=inactive md-min-date=user.identymodel.StateIdIssueDate ng-model=user.identymodel.StateIdExpDate md-open-on-focus md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-4><label>Driving License No</label> <input autocomplete=off ng-model=user.identymodel.DLId ng-disabled=inactive ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false md-maxlength=30></md-input-container><md-input-container class=col-lg-4><label>Date of Origin</label><!-- <input autocomplete="off"  ng-model="user.identymodel.DLIssueDate" ng-disabled="inactive"> --><md-datepicker ng-disabled=inactive ng-model=user.identymodel.DLIssueDate md-open-on-focus md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container><md-input-container class=col-lg-4><label>Date of Expiry</label><!-- <input autocomplete="off"  ng-model="user.identymodel.DLExpDate" ng-disabled="inactive"> --><md-datepicker ng-disabled=inactive md-min-date=user.identymodel.DLIssueDate ng-model=user.identymodel.DLExpDate md-open-on-focus md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-4><label>Passport No</label> <input autocomplete=off ng-model=user.identymodel.PassportNumber ng-disabled=inactive ng-pattern=/^[a-zA-Z0-9]*$/ ng-trim=false md-maxlength=30></md-input-container><md-input-container class=col-lg-4><label>Date of Origin</label><!-- <input autocomplete="off"  ng-model="user.identymodel.PIssueDate" ng-disabled="inactive"> --><md-datepicker ng-disabled=inactive ng-model=user.identymodel.PIssueDate md-open-on-focus md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container><md-input-container class=col-lg-4><label>Date of Expiry</label><!-- <input autocomplete="off"  ng-model="user.identymodel.PExpDate" ng-disabled="inactive"> --><md-datepicker ng-disabled=inactive md-min-date=user.identymodel.PIssueDate ng-model=user.identymodel.PExpDate md-open-on-focus md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container></div><div layout=row layout-align="end center"><md-button ng-click=cancelEdit() class="md-primary cc-button" ng-if="!inactive && !savingProfile">Cancel</md-button><md-button type=submit class="md-primary cc-button" ng-if="!inactive && !savingProfile">Save</md-button><ci-spinner ng-if=savingProfile></ci-spinner></div></form></md-content></md-tab><md-tab label="Primary Contact" md-on-select=tabSelected() md-on-deselect=tabDeSelected(selectedIndex)><ci-spinner ng-if=profileTabchangeLoader></ci-spinner><md-content class="md-padding pt-0" ng-if=!profileTabchangeLoader><form name=PrimaryContactForm ng-submit="PrimaryContactForm.$valid && saveProfile(user)" class="UserProfile p-0" autocomplete=off novalidate><div class="p-0 w-100" layout=row layout-align="end center"><md-button ng-click=editProfile() class="md-primary cc-button" ng-if="inactive && !savingProfile">Edit</md-button></div><div layout-gt-sm=row layout-sm=column layout-md=column class=mt-5><md-input-container class=col-lg-4><label>Firstname</label> <input autocomplete=off ng-model=user.primarycontact.FirstName ng-disabled=inactive only-letters-input></md-input-container><md-input-container class=col-lg-4><label>Middlename</label> <input autocomplete=off ng-model=user.primarycontact.MiddleName ng-disabled=inactive only-letters-input></md-input-container><md-input-container class=col-lg-4><label>Lastname</label> <input autocomplete=off ng-model=user.primarycontact.LastName ng-disabled=inactive only-letters-input></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-4><label>Mobile Number</label> <input autocomplete=off ng-model=user.primarycontact.pcell type=text ng-disabled=inactive name=primmobile md-maxlength=20><div ng-messages=profileForm.primmobile.$error><div ng-message=required>This is too Long.</div></div></md-input-container><md-input-container class=col-lg-4><label>Relation</label> <input autocomplete=off ng-model=user.primarycontact.Relation type=text ng-disabled=inactive name=primmobile md-maxlength=20 only-letters-input><div ng-messages=profileForm.primmobile.$error></div></md-input-container></div><div layout=row layout-align="end center"><md-button ng-click=cancelEdit() class="md-primary cc-button" ng-if="!inactive && !savingProfile">Cancel</md-button><md-button type=submit class="md-primary cc-button" ng-if="!inactive && !savingProfile">Save</md-button><ci-spinner ng-if=savingProfile></ci-spinner></div></form></md-content></md-tab><md-tab label=Experience md-on-select=tabSelected() md-on-deselect=tabDeSelected(selectedIndex)><ci-spinner ng-if=profileTabchangeLoader></ci-spinner><md-content class="md-padding pt-0" ng-if=!profileTabchangeLoader><form name=ExperienceForm ng-submit="ExperienceForm.$valid && saveProfile(user)" class="UserProfile p-0" autocomplete=off novalidate><div class="p-0 w-100" layout=row layout-align="end center"><md-button ng-click=editProfile() class="md-primary cc-button" ng-if="inactive && !savingProfile">Edit</md-button></div><div class="table-responsive mt-5 experience"><table class=table><thead><tr><td>Company Name</td><td>Client Name</td><td>Company Address</td><td>Start Date</td><td>End Date</td><td>Title</td><td>Current Project</td></tr></thead><tbody><tr ng-repeat="workExp in user.workexpmodel track by $index"><td>{{workExp.PayrollCompany}}</td><td>{{workExp.ClientName}}</td><td>{{workExp.ClientAddress}}</td><td><span ng-if=inactive>{{workExp.StartDate | moment: \'format\': \'MMM DD, YYYY\'}}</span><md-input-container class=col ng-if=!inactive><label>Start Date</label><md-datepicker ng-disabled=inactive required ng-model=user.workexpmodel[$index].StartDate md-open-on-focus md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container></td><td ng-if="workExp.EndDate !== undefined && workExp.isCurrent !== true"><span ng-if=inactive>{{workExp.EndDate | moment: \'format\': \'MMM DD, YYYY\'}}</span><md-input-container class=col ng-if=!inactive><label>End Date</label><md-datepicker ng-disabled=inactive required ng-model=user.workexpmodel[$index].EndDate md-open-on-focus md-min-date=user.workexpmodel[$index].StartDate md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container></td><td ng-if="workExp.EndDate == undefined || workExp.isCurrent == true"></td><td>{{workExp.Title}}</td><td class=text-center><!-- <input autocomplete="off"  type="checkbox" ng-model="workExp.isCurrent" > --> <!-- <input type="radio" name="isCurrent" ng-model="user.workexpmodel[$index].isCurrent" ng-if="!inactive" ng-change="user.workexpmodel[$index].EndDate === undefined"> --> <i class=material-icons ng-if=workExp.isCurrent style="color: blue;">check_circle_outline</i> <i class=material-icons ng-if="workExp.CompanyId == undefined" style="color: red;" ng-click=PopExp(workExp)>cancel</i></td></tr></tbody></table></div><mb-button class="btn btn-primary m-2" ng-click=showAdvanced($event) ng-show=!inactive>Add Experience</mb-button><div layout=row layout-align="end center"><md-button ng-click=cancelEdit() class="md-primary cc-button" ng-if="!inactive && !savingProfile">Cancel</md-button><md-button type=submit class="md-primary cc-button" ng-if="!inactive && !savingProfile">Save</md-button><ci-spinner ng-if=savingProfile></ci-spinner></div></form></md-content></md-tab><md-tab label=Visa md-on-deselect=tabDeSelected()><ci-spinner ng-if=profileTabchangeLoader></ci-spinner><md-content class="md-padding pt-0" ng-if=!profileTabchangeLoader><form name=VisaForm ng-submit="VisaForm.$valid && saveProfile(user)" class="UserProfile p-0" autocomplete=off novalidate><div class="p-0 w-100" layout=row layout-align="end center"><md-button ng-click=editProfile() class="md-primary cc-button" ng-if="inactive && !savingProfile">Edit</md-button></div><div class="d-flex flex-column mt-5"><label for="">What is Your Current Work Authorization?</label><md-radio-group ng-model=workAuthType ng-change=workAuthTypeChanged(workAuthType) ng-disabled=inactive layout=row><md-radio-button value=USC>US Citizen</md-radio-button><md-radio-button value=GC>Green Card Holder</md-radio-button><md-radio-button value=Other>Other</md-radio-button></md-radio-group></div><div class="d-flex flex-column mt-5" ng-if="workAuthType === \'USC\'"><label>Your Current Work Authorization is: <b>{{user.visamodel.CurrentWorkAuth}}</b></label></div><div class="d-flex flex-column mt-5" ng-if="workAuthType === \'GC\'"><label>Your Current Work Authorization is: <b>{{user.visamodel.CurrentWorkAuth}}</b></label><h5>Specify your <b>GC</b> Start & End Date.</h5><div class=d-flex><md-input-container class=col-lg-3><label>GC Start Date</label><md-datepicker ng-disabled=inactive required ng-model=user.visamodel.GCApprovalDate md-open-on-focus md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container><md-input-container class=col-lg-3><label>GC End Date</label><md-datepicker ng-disabled=inactive required ng-model=user.visamodel.GCEndDate md-min-date=user.visamodel.labourappliedDate md-open-on-focus md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container></div></div><div class="d-flex flex-column mt-5" ng-if="workAuthType === \'Other\'"><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-3><label>Current Visa Status</label> <input autocomplete=off ng-model=user.visamodel.CurrentVisaStatus ng-disabled=inactive only-alpha-numeric></md-input-container><md-input-container class=col-lg-3><label>Current Visa Start Date</label><md-datepicker ng-disabled=inactive required ng-model=user.visamodel.CurrentVisaStartDate md-open-on-focus md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container><md-input-container class=col-lg-3><label>Current Visa EndDate</label><md-datepicker ng-disabled=inactive required ng-model=user.visamodel.CurrentVisaEndDate md-open-on-focus md-min-date=user.visamodel.CurrentVisaStartDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container><md-input-container class=col-lg-3><label>Current Work Auth</label><md-select ng-model=user.visamodel.CurrentWorkAuth ng-disabled=inactive required><md-option><em>None</em></md-option><md-option ng-repeat="workAuthType in workAuthTypes" ng-value=workAuthType>{{workAuthType}}</md-option></md-select><!-- <input autocomplete="off" ng-model="user.visamodel.CurrentWorkAuth"\n                                                ng-disabled="inactive" only-alpha-numeric required> --></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-3><label>Current Work Auth Start Date</label><md-datepicker ng-disabled=inactive required ng-model=user.visamodel.CurrentWorkAuthStartDate md-min-date=user.visamodel.CurrentVisaStartDate md-max-date=user.visamodel.CurrentVisaEndDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container><md-input-container class=col-lg-3><label>Current Work Auth End Date</label><md-datepicker ng-disabled=inactive required ng-model=user.visamodel.CurrentWorkAuthEndDate md-open-on-focus md-min-date=user.visamodel.CurrentVisaStartDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container><md-input-container class=col-lg-3><label>I94</label> <input autocomplete=off ng-model=user.visamodel.I94 ng-disabled=inactive only-alpha-numeric></md-input-container><div class=col-lg-3><label>GC Applied</label><md-radio-group ng-model=user.visamodel.GCApplied class="d-flex flex-row" ng-disabled=inactive><md-radio-button value=true class="md-primary mr-2">Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></md-radio-group><!-- <md-select ng-model="user.visamodel.GCApplied" ng-disabled="inactive" required>\n                                                        <md-option>\n                                                            <em>None</em>\n                                                        </md-option>\n                                                        <md-option ng-repeat="appliedValue in appliedValues" ng-value="appliedValue.value">\n                                                            {{appliedValue.name}}\n                                                        </md-option>\n                                                    </md-select> --></div></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-3><label>GC Stage</label> <input autocomplete=off ng-model=user.visamodel.GcStage ng-disabled=inactive only-alpha-numeric></md-input-container><md-input-container class=col-lg-3><label>Labour Applied Date</label><md-datepicker ng-disabled=inactive required ng-model=user.visamodel.labourappliedDate md-open-on-focus md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container><md-input-container class=col-lg-3><label>Labour Approve Date</label><md-datepicker ng-disabled=inactive required ng-model=user.visamodel.labourapproveDate md-min-date=user.visamodel.labourappliedDate md-open-on-focus md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container><md-input-container class=col-lg-3><label>I40 Applied Date</label><md-datepicker ng-disabled=inactive required ng-model=user.visamodel.I40AppliedDate md-min-date=user.visamodel.labourapproveDate md-open-on-focus md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container></div><div layout-gt-sm=row layout-sm=column layout-md=column><md-input-container class=col-lg-4><label>I40 Approved Date</label><md-datepicker ng-disabled=inactive required ng-model=user.visamodel.I40ApprovedDate md-min-date=user.visamodel.I40AppliedDate md-open-on-focus md-max-date=maxDate md-hide-icons=calendar ng-class="{\'disabled\':inactive, \'notdisabled\':!inactive }"></md-datepicker></md-input-container><md-input-container class=col-lg-4><label>GC Comments</label> <input autocomplete=off ng-model=user.visamodel.GCComments ng-disabled=inactive></md-input-container></div></div><div layout=row layout-align="end center"><md-button ng-click=cancelEdit() class="md-primary cc-button" ng-if="!inactive && !savingProfile">Cancel</md-button><md-button type=submit class="md-primary cc-button" ng-if="!inactive && !savingProfile">Save</md-button><ci-spinner ng-if=savingProfile></ci-spinner></div></form></md-content></md-tab></md-tabs></md-card></div>');
$templateCache.put('app/components/consultant/tsSubmit/tsSubmit.html','<div class=container-fluid><div class="d-flex flex-wrap p-2 col-lg-8"><div ng-show=ShowTimeTracker class="p-0 m-0 col"><md-card class=m-0><md-card-header><md-card-header-text><span class="md-title pl-3">Time Tracker</span></md-card-header-text></md-card-header><md-card-content ng-if=showTimetrackerPage class=ShowTimeTracker><form name=tsSubmit ng-cloak ng-if=!timesheetSubSuccess novalidate ng-submit="tsSubmit.$valid && SaveTimesheet(timeTrackerDetails)"><div class="d-lg-flex flex-md-row flex-sm-column p-0"><p class="d-flex flex-row col p-0"><label class="mr-4 col-lg-6">Company Name</label> <label class="text-success col-lg-6">{{tokenData.CompanyName}}</label></p><p class="d-flex flex-row col p-0"><label class="mr-4 col-lg-6">End Client</label> <label class="text-success col-lg-6">{{endClient.ClientName}}</label></p></div><div class="d-lg-flex flex-md-row flex-sm-column"><p class="d-flex flex-row col p-0"><label class="mr-4 col-lg-6">Start Date</label> <label class="text-success col-lg-6">{{timeTrackerDetails.StartDate}}</label></p><p class="d-flex flex-row col p-0"><label class="mr-4 col-lg-6">End Date</label> <label class="text-success col-lg-6">{{timeTrackerDetails.EndDate}}</label></p></div><div class="d-lg-flex flex-md-row flex-sm-column"><p class="d-flex flex-row col p-0"><label class="mr-4 col-lg-6">Total Hours</label> <label class="text-success col-lg-6">{{timeTrackerDetails.TotalHours}}</label></p><p class="d-flex flex-row col p-0"></p></div><ul class=hourstable ng-if=isMobile ng-class="isMobile?\'mobile\':\'\'"><li ng-repeat="timeInfo in timeTrackerDetails.timeInfos track by $index" ng-class="{\'disabledRow\': timeInfo.Day == \'Sat\' || timeInfo.Day == \'Sun\'}"><div class=text-center><span>Day: </span><span ng-model=timeTrackerDetails.timeInfos[$index].Date>{{timeInfo.Day}}-{{timeInfo.month}}/{{timeInfo.Date}}</span></div><div class=text-center><input type=number ng-change=updateHours(timeTrackerDetails.timeInfos[$index].Hours) class=hoursInput ng-model=timeTrackerDetails.timeInfos[$index].Hours min=0 max=24 value=0></div></li></ul><table class="hourstable table table-hover" ng-if=!isMobile><tr><th>Day:</th><td ng-repeat="timeInfo in timeTrackerDetails.timeInfos track by $index" ng-class="{\'disabledRow\': timeInfo.Day == \'Sat\' || timeInfo.Day == \'Sun\'}" ng-model=timeTrackerDetails.timeInfos[$index].Date>{{timeInfo.Day}}-{{timeInfo.month}}/{{timeInfo.Date}}</td></tr><tr><th>Hours:</th><td ng-repeat="timeInfo in timeTrackerDetails.timeInfos track by $index" ng-class="{\'disabledRow\': timeInfo.Day == \'Sat\' || timeInfo.Day == \'Sun\'}"><input type=number ng-change=updateHours(timeTrackerDetails.timeInfos[$index].Hours) class=hoursInput ng-model=timeTrackerDetails.timeInfos[$index].Hours min=0 max=24 value=0 ng-disabled=timeInfo.disabled></td></tr></table><label>Please select the below check box to Submit the Timesheet</label><div layout=row><md-checkbox ng-model=timesheet.certify aria-label="Certify Compliance" ng-change=checkAll(check)><p>I certify that, in compliance of Texperts-Inc Timesheet Policy, I have provided complete &amp; accurate data in the timesheet submission.<br><br>I understand that submitting inaccurate timesheet will result in rejection of my timesheet.</p></md-checkbox><!-- <input type="checkbox" name="iAgree" ng-change="checkAll(check)" class="minimal mr-2 certifyCheck" required ng-model="timesheet.certify"> --></div><div ng-if="tsSubmit.iAgree.$invalid && tsSubmit.$submitted"><div class="alert alert-warning">You have to Certify the Texperts Compliance.</div></div><div class="col-lg-12 text-right d-flex flex-row"><md-button ng-click=cancelTimesheet()>Cancel</md-button><button type=submit class="md-raised btn btn-outline-primary" ng-if="timesheet.certify && !submittedTimesheetLoader">Submit Timesheet</button><md-button ng-if=submittedTimesheetLoader><ci-spinner class="loginLoader mo-margin"></ci-spinner></md-button></div></form><h4 ng-if=timesheetSubSuccess>Timesheet Successfully Submitted.</h4></md-card-content></md-card></div></div></div>');
$templateCache.put('app/components/hr/addVendor/addVendor.html','<div class=container-fluid><div class=row><div class=col-12><ci-spinner ng-if=addVendorLoader></ci-spinner><form name=myform ng-submit="myform.$valid && addVendor(newVendor)" ng-if=!addVendorLoader class="card mt-2 p-3"><h3>Add New Vendor</h3><div class=row><div class="col-6 pr-1"><h4 class=text-primary>Identity/Payment details</h4><div class="col-12 d-flex align-items-start"><div class="col-4 px-0"><div class="form-group col px-1 mb-1"><label for=VendorName>Vendor Name</label> <input type=text only-letters-input class="form-control form-control-sm" name=VendorName placeholder="Vendor Name" ng-model=newVendor.VendorName required name=VendorName> <small class=text-danger ng-show=myform.VendorName.$dirty&&myform.VendorName.$error.required>This field is required</small></div><div class="form-group col px-1 mb-1"><label for=InvMethod>Inv Method</label> <select class="form-control form-control-sm" placeholder="Inv Method" ng-model=newVendor.InvMethod required name=InvMethod><option ng-value=lookup.InvoiceMethodId ng-repeat="lookup in lookups.lstInvType | orderBy: \'Type\'">{{lookup.Type}}</option></select> <small class=text-danger ng-show=myform.InvMethod.$dirty&&myform.InvMethod.$error.required>This field is required</small></div></div><div class="col-4 px-0"><div class="form-group col px-1 mb-1"><label for=FedId>Fedaral Id</label> <input type=text only-numbers-input class="form-control form-control-sm" placeholder="Fedaral Id" ng-model=newVendor.FedId maxlength=9></div><div class="form-group col px-1 mb-1"><label for=InvoiceTerm>Invoice Term</label> <select class="form-control form-control-sm" placeholder="Invoice Term" ng-model=newVendor.InvoiceTerm required name=InvoiceTerm><option ng-value=lookup.InvTermId ng-repeat="lookup in lookups.lstInvTerm | orderBy: \'Term\'">{{lookup.Term}}</option></select> <small class=text-danger ng-show=myform.InvoiceTerm.$dirty&&myform.InvoiceTerm.$error.required>This field is required</small></div></div><div class="col-4 px-0"><div class="form-group col px-1 mb-1"><label for=Fax>Fax</label> <input type=text only-numbers-input class="form-control form-control-sm" placeholder=Fax ng-model=newVendor.Fax maxlength=10></div><div class="form-group col px-1 mb-1"><label for=PayTerm>Pay Term</label><!-- <input type="text" only-numbers-input class="form-control form-control-sm" placeholder="Pay Term"\r\n                  ng-model="newVendor.PayTerm" required name="PayTerm"> --> <select class="form-control form-control-sm" ng-model=newVendor.PayTerm required name=PayTerm><option ng-repeat="lookup in lookups.lstPayTerm | orderBy: \'Term\'" ng-value=lookup.PayTermId ng-if="lookup.Term !== 1001 && lookup.Term !== 1002">{{lookup.Term}}</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1001">Pay When Paid</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1002">As Per Payment Schedule</option></select> <small class=text-danger ng-show=myform.PayTerm.$dirty&&myform.PayTerm.$error.required>This field is required</small></div></div></div><h4 class=text-primary>Primary Contact details</h4><div class="col-12 d-flex align-items-start"><div class="col-4 px-0"><div class="form-group col px-1 mb-1"><label>Name</label> <input type=text only-letters-input class="form-control form-control-sm" name=VendorFullName placeholder=Fullname ng-model=newVendor.VendorContactFullName required> <small class=text-danger ng-show=myform.VendorFullName.$dirty&&myform.VendorFullName.$error.required>This field is required</small></div></div><div class="col-4 px-0"><div class="form-group col px-1 mb-1"><label>Email</label> <input type=text class="form-control form-control-sm" placeholder=Email ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ ng-model=newVendor.PrimaryEmail name=primaryEmail required> <small class=text-danger ng-show=myform.primaryEmail.$dirty&&myform.primaryEmail.$error.required>This field is required</small> <small class=text-danger ng-show=myform.primaryEmail.$error.pattern>Invalid Email</small></div></div><div class="col-4 px-0"><div class="form-group col px-1 mb-1"><label for=Fax>Contact number</label> <input type=text only-numbers-input class="form-control form-control-sm" placeholder=Phone ng-model=newVendor.VendorContactCell minlength=7 maxlength=20 required name=phone> <small class=text-danger ng-show=myform.phone.$dirty&&myform.phone.$error.required>This field is required</small></div></div></div><h4 class=text-primary>Addendum</h4><div class="col-12 d-flex align-items-start"><div class="form-group col-4 px-1 mb-0"><label for=AddendaInPlace>In Place</label><div class="d-flex align-items-center"><input type=radio class=mr-2 ng-model=newVendor.AddendaInPlace name=AddendaInPlace required ng-value=true> Yes <input type=radio class="mr-2 ml-2" ng-model=newVendor.AddendaInPlace name=AddendaInPlace required ng-value=false> No</div></div><div class="form-group col-4 px-1 mb-0"><label for=AddendaPointsCovered>Points Covered</label><div class="d-flex align-items-center"><input type=radio class=mr-2 name=AddendaPointsCovered ng-model=newVendor.AddendaPointsCovered required ng-value=true> Yes <input type=radio class="mr-2 ml-2" name=AddendaPointsCovered ng-model=newVendor.AddendaPointsCovered required ng-value=false> No</div></div><div class="form-group col-4 px-1 mb-0"><label for=AddendaSigDate>Sign Date</label> <input class="form-control form-control-sm datepicker" ng-model=newVendor.AddendaSigDate ng-required="newVendor.AddendaInPlace==\'true\'" name=AddendaSigDate> <small class=text-danger ng-show=myform.AddendaSigDate.$dirty&&myform.AddendaSigDate.$error.required>This field is required</small></div></div><h4 class=text-primary>Contract</h4><div class="col-12 d-flex align-items-start"><div class="form-group col-4 px-1 mb-0"><label for=ContractInPlace>In Place</label><div class="d-flex align-items-center"><input type=radio class=mr-2 ng-model=newVendor.ContractInPlace required name=ContractInPlace ng-value=true> Yes <input type=radio class="mr-2 ml-2" ng-model=newVendor.ContractInPlace required name=ContractInPlace ng-value=false> No</div></div><div class="form-group col-4 px-1 mb-0"><label for=ContractSignedDate>Sign Date</label> <input type=text class="form-control form-control-sm datepicker" placeholder="Contract Signed Date" ng-model=newVendor.ContractSignedDate ng-required=newVendor.ContractInPlace name=ContractSignedDate> <small class=text-danger ng-show=myform.ContractSignedDate.$dirty&&myform.ContractSignedDate.$error.required>This field is required</small></div></div><h4 class=text-primary>Instructions</h4><div class="col-12 align-self-start"><div class="form-group col px-1 mb-1"><textarea class="form-control form-control-sm" placeholder=Instructions ng-model=newVendor.Instructions></textarea></div></div></div><div class="col-6 pl-1"><h4 class=text-primary>Address details</h4><div class="col-12 row pl-4"><div class="form-group col-4 px-1 mb-0"><label for=Street>Street</label> <input type=text class="form-control form-control-sm" placeholder=Street ng-model=newVendor.VendorAddressInfo[0].Street required name=Street> <small class=text-danger ng-show=myform.Street.$dirty&&myform.Street.$error.required>This field is required</small></div><div class="form-group col-4 px-1 mb-0"><label for=City>City</label> <input type=text only-letters-input class="form-control form-control-sm" placeholder=City ng-model=newVendor.VendorAddressInfo[0].City required name=City> <small class=text-danger ng-show=myform.City.$dirty&&myform.City.$error.required>This field is required</small></div><div class="form-group col-4 px-1 mb-0"><label for=State>State</label> <select class="form-control form-control-sm" required ng-model=newVendor.VendorAddressInfo[0].State name=State><option value="">Choose...</option><option ng-repeat="state in states" value={{state.abbreviation}}>{{state.abbreviation}}</option></select> <small class=text-danger ng-show=myform.State.$dirty&&myform.State.$error.required>This field is required</small></div><div class="form-group col-4 px-1 mb-0"><label for=Country>Country</label><!-- <input type="text" only-letters-input class="form-control form-control-sm" placeholder="Country"\r\n                ng-model="newVendor.VendorAddressInfo[0].Country" required name="Country"> --> <select class="form-control form-control-sm mr-1" required name=Country ng-model=newVendor.VendorAddressInfo[0].Country><option value="">Choose...</option><option value=USA>USA</option></select> <small class=text-danger ng-show=myform.Country.$dirty&&myform.Country.$error.required>This field is required</small></div><div class="form-group col-4 px-1 mb-0"><label for=Zipcode>Zip code</label> <input type=text only-numbers-input class="form-control form-control-sm" placeholder="Zip code" ng-model=newVendor.VendorAddressInfo[0].Zipcode required name=Zipcode> <small class=text-danger ng-show=myform.Zipcode.$dirty&&myform.Zipcode.$error.required>This field is required</small></div></div><h4 class=text-primary>Add Contacts</h4><div class=col-12><table class="table table-dark mt-3" ng-if=!ViewContsLoader><thead><tr><th>Designation</th><th>Contact Person</th><th>Email</th><th>Phone Number/Extn</th></tr></thead><tbody><tr ng-repeat="VenCont in newVendor.VendorAddressInfo[0].VendorAcctInfo track by $index"><td><span ng-if=!VenCont.editable>{{VenCont.Designation}}</span> <select class="form-control form-control-sm rounded-0 border border-dark" required alt="Select a Designation" ng-model=VenCont.Designation ng-if=VenCont.editable><option value="">Select Designation...</option><option ng-repeat="lookup in lookups.lstAcctType" ng-value=lookup.DesgId>{{lookup.Type}}</option></select></td><td><span ng-if=!VenCont.editable>{{VenCont.ContactName}}</span> <input type=text ng-if=VenCont.editable class="form-control form-control-sm rounded-0 border border-dark" placeholder=Name ng-model=VenCont.ContactName required name=ConatctName{{$index}}> <small class=text-danger ng-show=myform.ContactName{{$index}}.$dirty&&myform.ContactName{{$index}}.$error.required>This field is required</small></td><td><span ng-if=!VenCont.editable>{{VenCont.AcctEmail}}</span> <input type=text ng-if=VenCont.editable class="form-control form-control-sm rounded-0 border border-dark" placeholder=Email ng-model=VenCont.AcctEmail required name=AcctEmail{{$index}} ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ > <small class=text-danger ng-show=myform.AcctEmail{{$index}}.$dirty&&myform.AcctEmail{{$index}}.$error.required>This field is required</small> <small class=text-danger ng-show=myform.AcctEmail{{$index}}.$error.pattern>Invalid Email</small></td><td><span ng-if=!VenCont.editable>{{VenCont.PhoneNumber}}</span><div class=d-flex><input type=text only-numbers-input ng-if=VenCont.editable class="form-control form-control-sm rounded-0 border border-dark" placeholder="Phone Number" ng-model=VenCont.PhoneNumber required minlength=7 maxlength=20 name=PhoneNumber{{$index}}> <input type=text class="form-control form-control-sm rounded-0 border border-dark" placeholder=Extn ng-model=VenCont.Extn style=width:50px;></div><small class=text-danger ng-show=myform.PhoneNumber{{$index}}.$dirty&&myform.PhoneNumber{{$index}}.$error.required>This field is required</small></td></tr></tbody></table><div class="alert alert-info" ng-if="">Email & Phone number should not be empty.</div></div><!-- <h4 class="text-primary">Agreements</h4>\r\n            <div class="col-12">\r\n              <table class="mt-3 w-100 table">\r\n                <thead class="table-dark">\r\n                  <tr>\r\n                    <th>#</th>\r\n                    <th>Document Type</th>\r\n                    <th>Upload</th>\r\n                  </tr>\r\n                </thead>\r\n                <tbody>\r\n                  <tr>\r\n                    <td>1</td>\r\n                    <td>{{lookups.lstVdocType[0].Type}}</td>\r\n                    <td>\r\n                      {{files[0].name}}\r\n                      <label ng-if="!files[0]" for="file" class="text-primary col-4 d-flex p-0 float-left text-left align-items-center pt-1 ml-3 mb-0 pointer" data-toggle="tooltip" data-placement="top" title="Select File"><i class="fas fa-upload mr-1"></i>Select File\r\n                      <input type="file" id="file" accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf" name="file" onchange="angular.element(this).scope().getFileDetails(this,1)" required class="col-4" style="display: none;"></label>\r\n                      </td>\r\n                  </tr>\r\n                  <tr>\r\n                    <td>2</td>\r\n                    <td>{{lookups.lstVdocType[1].Type}}</td>\r\n                    <td>\r\n                      {{files[1].name}}\r\n                      <label ng-if="!files[1]" for="file" class="text-primary col-4 d-flex p-0 float-left text-left align-items-center pt-1 ml-3 mb-0 pointer" data-toggle="tooltip" data-placement="top" title="Select File"><i class="fas fa-upload mr-1"></i>Select File\r\n                      <input type="file" id="file" accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf" name="file" onchange="angular.element(this).scope().getFileDetails(this,2)" required class="col-4" style="display: none;"></label>\r\n                      </td>\r\n                  </tr>\r\n                </tbody>\r\n              </table>\r\n            </div> --></div></div><div class="d-flex justify-content-end"><button class="btn btn-sm btn-default" ui-sref=adminvendors() type=button ng-if="tokenData.newRole==\'Admin\'">Cancel</button> <button class="btn btn-sm btn-default" ui-sref=vendors() type=button ng-if="tokenData.newRole==\'HR\'">Cancel</button> <button type=submit class="btn btn-primary" ng-dblclick="return false" ng-disabled="newVendor.VendorAddressInfo[0].VendorAcctInfo[0].Designation === null||\r\n          newVendor.VendorAddressInfo[0].VendorAcctInfo[0].ContactName === null||\r\n          newVendor.VendorAddressInfo[0].VendorAcctInfo[0].AcctEmail === null||\r\n          newVendor.VendorAddressInfo[0].VendorAcctInfo[0].PhoneNumber === null">Submit</button></div><div class="alert alert-danger col-3" ng-if="myform.$invalid && myform.$dirty">Please fix errors above</div></form></div></div></div><div class="modal fade text-warning" id=invalidFileTypeAlertDiv tabindex=-1 role=dialog aria-labelledby=exampleModalCenterTitle aria-hidden=true><div class="modal-dialog modal-dialog-centered" role=document><div class="modal-content bg-danger"><div class=modal-body><h3>Invalid Filetype</h3>Only MsWord and PDF file types are allowed.</div><div class="modal-footer p-0 border-warning"><button type=button class="btn btn-warning" data-dismiss=modal>Ok</button></div></div></div></div>');
$templateCache.put('app/components/hr/clientDetails/clientDetails.html','<div class="container-fluid p-0"><div class=d-flex><div class="d-flex align-items-center justify-content-center w-100 p-0 heightCanBe" ng-show=!ClientData><ci-spinner class=loginLoader></ci-spinner></div><div class="col-12 p-0" ng-show=ClientData><div class="d-flex flex-column"><div class="col-sm-12 col-md-8 col-lg-8"><div class="d-flex align-items-center" ng-show=!ClientData.editClientName><h2 class=float-left ng-click=editClient($index,ClientData)>{{ClientData.ClientName}}</h2><i class="fas fa-pen ml-2 pt-0 text-primary pointer" ng-click=editClient($index,ClientData)></i></div><div class="pt-3 d-flex align-items-center" ng-if=ClientData.editClientName><input type=text ng-model=ClientData.ClientName placeholder={{ClientData.ClientName}} required minlength=2 class="form-control form-control-lg" ng-class="editableErr?\'border border-danger\':\'\'"> <span class=text-success>{{errorMsg}}</span> <button class="btn btn-lg btn-default ml-2"><i class="fas fa-times text-danger pointer" ng-click=editClientCancel($index,ClientData)></i></button> <button class="btn btn-lg btn-primary ml-2"><i class="fas fa-check text-success pointer" ng-click=editClientSub(ClientData.ClientName,ClientData.ClientId,$index)></i></button></div></div><div class="col-sm-12 col-md-6 col-lg-8"><div class="d-flex flex-column mt-5"><form><table class="table table-dark"><thead><tr><th>Street</th><th>City</th><th>State</th><th>Country</th><th>Zip Code</th><th>Action</th><th>Previously added address</th></tr></thead><tbody><tr ng-repeat="ClientAdd in ClientData.ClientAddress track by $index"><td><span ng-show=!ClientAdd.editable>{{ClientAdd.Street}}</span> <input type=text class="form-control form-control-sm mr-1" id=inputAddress ng-show=ClientAdd.editable placeholder="1234 Main St" ng-required=ClientAdd.editable ng-model=ClientAdd.Street></td><td><span ng-show=!ClientAdd.editable>{{ClientAdd.City}}</span> <input type=text class="form-control form-control-sm mr-1" id=inputCity ng-required=ClientAdd.editable only-letters-input ng-show=ClientAdd.editable placeholder=City ng-model=ClientAdd.City></td><td><span ng-show=!ClientAdd.editable>{{ClientAdd.State}}</span> <select id=inputState class="form-control form-control-sm mr-1" ng-required=ClientAdd.editable ng-show=ClientAdd.editable ng-model=ClientAdd.State><option value="">Choose...</option><option ng-repeat="state in states" value={{state.abbreviation}}>{{state.abbreviation}}</option></select></td><td><span ng-show=!ClientAdd.editable>{{ClientAdd.Country}}</span> <select class="form-control form-control-sm mr-1" ng-required=ClientAdd.editable ng-show=ClientAdd.editable ng-model=ClientAdd.Country><option value="">Choose...</option><option value=USA>USA</option></select></td><td><span ng-show=!ClientAdd.editable>{{ClientAdd.Zipcode}}</span> <input type=text class="form-control form-control-sm mr-3" id=inputZip ng-required=ClientAdd.editable only-numbers-input ng-show=ClientAdd.editable placeholder=Zipcode ng-model=ClientAdd.Zipcode></td><td><span class="pointer text-warning" ng-show=!ClientAdd.editable style="font-size: 14px;font-weight: 600;font-family: sans-serif;text-decoration: underline;font-variant: common-ligatures;" ng-click=editClientAddr($index,ClientAdd)>edit</span> <span class=pointer ng-show=ClientAdd.editable ng-click=editNewClientCancel($index)><i class="fas fa-times text-danger pt-2"></i> </span><button ng-show=ClientAdd.editable class=btnAsIcon type=button ng-click=editClientAddrSub(ClientAdd,$index)><i class="fas fa-check text-success pointer pt-2"></i></button></td><td>{{ClientAdd.PrevAddr}}</td></tr><tr><td colspan=7 class=text-right><button type=button class="btn btn-sm btn-success mr-3" ng-disabled=isEdit ng-click=addNewAddr()>Add New Address</button></td></tr></tbody></table></form></div></div></div></div></div></div><div class="modal fade" id=AllFieldsRequired tabindex=-1 role=dialog aria-labelledby=exampleModalLabel aria-hidden=true><div class=modal-dialog><div class="modal-content border-0"><div class="modal-body d-flex justify-content-between bg-danger"><h3>All Fields are Required.</h3><button type=button class="btn btn-light" data-dismiss=modal>OK</button></div></div></div></div><style>.clientListActive {\r\n    border-left: 4px solid #453;\r\n  }</style>');
$templateCache.put('app/components/hr/ArchiveUsers/ArchiveUsers.html','<div class=container-fluid><div class=d-flex><div class="col-sm-12 col-lg-6 pt-4"><div class="d-flex flex-lg-row flex-sm-column"><div class="mt-4 pt-4 col-10"><md-input-container class="w-100 pt-4 pl-4"><label>Select User to Archive.</label><md-select ng-model=selectedUser md-on-close=clearSearchTerm() data-md-container-class=selectdemoSelectHeader multiple><md-select-header class=demo-select-header><input ng-model=searchTerm type=search id=UsersSearch placeholder="Search for a user.." class="demo-header-searchbox md-text"></md-select-header><md-optgroup label=Users><md-option ng-value=user.LoginId ng-repeat="user in InActiveUsers |\r\n                                                        filter:{FullName:searchTerm}">{{user.FullName}}</md-option></md-optgroup></md-select></md-input-container></div><div class="mt-4 pt-4 col-2"><button class="btn btn-primary mt-4" ng-click=ArchiveSelected(selectedUser) ng-disabled="selectedUser === undefined" style=margin:auto; ng-show=!ArchivingLoader>Archive</button><ci-spinner ng-if=ArchivingLoader></ci-spinner></div></div></div><div class="col-sm-12 col-lg-6 pt-4"><div class=card><div class=card-header>Archived Users</div><ci-spinner ng-if=tabLoad></ci-spinner><div class=card-body ng-if=!tabLoad><div class="table table-responsive"><table class=table id=ArchTable><thead><tr><td>#</td><td>Name</td><td>Email</td><td>Action</td></tr></thead><tbody><tr ng-repeat="user in ArchivedUsers track by $index"><td>{{$index+1}}</td><td>{{user.DisplayName}}</td><td>{{user.UserName}}</td><td class=p-0><md-button type=submit class="m-0 text-info" ng-click=UnArchiveUser(user) style=text-transform:capitalize;>Unarchive</md-button></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/components/hr/clients/clients.html','<div class="container-fluid p-0"><div class=d-flex><div class="d-flex align-items-center justify-content-center w-100 p-0 heightCanBe" ng-show=pageLoading><ci-spinner class=loginLoader></ci-spinner></div><div class="col-12 p-0" ng-show=!pageLoading><div class="d-flex flex-lg-row flex-sm-column"><div class="card w-100 rounded-0 border-right border-top-0 border-left-0"><div class="card-body heightCanBe" ng-if=NoClients><div class="alert alert-info m-4">No Clients found. <a class="text-primary pointer" ng-click=addNewClient()><u>Click here</u></a> to add new Client.</div></div><div class="card-body heightCanBe" ng-if=!NoClients><div class=d-flex><input type=text ng-model=searchText placeholder="Search a Client.." class="form-control mr-1 col"> <button class="btn btn-sm btn-success" ng-click=addNewClient()>Add New</button></div><ul id=og-grid class="og-grid d-flex flex-wrap"><li ng-repeat="Client in Clients | filter:searchText track by $index"><a href="" class="item p-3 h4 border pointer" ui-sref=ClientsDetails({id:Client.ClientId}) ng-if="role === \'HR\'"><span class=col-3>{{Client.ClientName}}</span> </a><a href="" class="item p-3 h4 border pointer" ui-sref=AdminClientsDetails({id:Client.ClientId}) ng-if="role === \'Admin\'"><span class=col-3>{{Client.ClientName}}</span></a></li></ul></div></div></div></div><div style="position: absolute; margin: auto;left: 0; right: 0;top:90;" class="col-sm-12 col-md-4 col-lg-4 col-xl-3 p-0 addNewClientWrapper" ng-show=addNewClientShow><div class="card w-100 rounded-0"><div class="card-header bg-light rounded-0 pb-0"><h4 class="card-title font-weight-bolder">Add New Client</h4></div><div class="card-body heightCanBe" style="overflow: auto;"><form name=addClientForm ng-submit=addClient(addClientForm,ACdata)><div class=form-group><label for=cname>Client Name<sup>*</sup></label> <input type=text class="form-control form-control-sm" id=cname required ng-model=ACdata.cname alpha-num-space></div><div class=form-group><label for=inputAddress>Street<sup>*</sup></label> <input type=text class="form-control form-control-sm" id=inputAddress placeholder="1234 Main St" required ng-model=ACdata.inputAddress></div><div class=form-group><label for=inputCity>City<sup>*</sup></label> <input type=text class="form-control form-control-sm" id=inputCity required only-letters-input ng-model=ACdata.inputCity></div><div class=form-group><label for=inputState>State<sup>*</sup></label> <select id=inputState class="form-control form-control-sm" required ng-model=ACdata.inputState><option selected>Choose...</option><option ng-repeat="state in states" value={{state.abbreviation}}>{{state.abbreviation}}</option></select></div><div class=form-group><label for=inputZip>Country<sup>*</sup></label> <input type=text class="form-control form-control-sm" required only-letters-input ng-model=ACdata.inputCountry></div><div class=form-group><label for=inputZip>Zip<sup>*</sup></label> <input type=text class="form-control form-control-sm" only-numbers-input required ng-model=ACdata.inputZip></div><button type=button class="btn btn-default" ng-click=addNewClientCancel()>Cancel</button> <button type=submit class="btn btn-primary">Submit</button></form></div></div></div></div></div>');
$templateCache.put('app/components/hr/Getmgrtoconsultant/Getmgrtoconsultant.html','<div class=container-fluid><md-content class="md-padding p-0 w-100" flex layout-xs=row layout=column ng-if=!userDataLoaded><ci-spinner class=loginLoader></ci-spinner></md-content><div class="row mt-3 mb-3"><div class=col-6><div class="card p-2"><div class=form-inline><input type=text class="form-control col bg-light" placeholder=Search ng-model=searchData ng-keyup=search(searchData)> <i class="fa fa-times text-danger" style="position: absolute;right: 20px;" ng-click=clearSearchTerm() ng-if=searchData></i></div><div id=GetmgrtoconsultantTable></div></div></div></div></div><div class="modal fade" id=showManagerAssPage data-backdrop=static data-keyboard=false tabindex=-1 role=dialog aria-labelledby=staticBackdropLabel aria-hidden=true><div class="modal-dialog modal-lg"><form class=modal-content name=changeManagerForm ng-submit="changeManagerForm.$valid && changeManager(conData)"><div class=modal-header><h5 class=modal-title id=staticBackdropLabel>Assign Manager</h5><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body><div class=d-flex><h4 class="font-weight-bold col-4">Consultant :</h4><h4 class=col-8>{{conData.ConsultantName}}</h4></div><div class=d-flex><h4 class="font-weight-bold col-4">Reporting To :</h4><h4 class=col-8>{{conData.ManagerName}}</h4></div><div class=d-flex><h4 class="font-weight-bold col-4">Change Manager To :</h4><div class=col-8><select required ng-model=changedMgr class="form-control form-control-sm"><option value="">Select Manager</option><option value={{manager.ManagerId}} ng-repeat="manager in ManagersList" class="d-flex flex-row"><span class=col-sm-6>{{manager.ManagerName}}</span> - <span class=col-sm-6>Role: {{manager.Title}}</span></option></select></div></div></div><div class=modal-footer><button type=button class="btn btn-secondary" data-dismiss=modal>Close</button> <button type=submit class="btn btn-info" ng-if=!changeManagerLoader>Update</button><ci-spinner class="small mr-2" ng-if=changeManagerLoader></ci-spinner></div></form></div></div>');
$templateCache.put('app/components/hr/createUser/addTitleDialog.html','<md-dialog aria-label="Add Title" flex=70><form ng-cloak class=sendEmailDialog name=addTitleform ng-submit="addTitleform.$valid && addTitleSubmit(data)"><md-toolbar><div class="md-toolbar-tools pointer"><h2>Add Title</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=TitleName>Title Name *</label> <input type=text class=form-control ng-model=data.Title name=Title placeholder="Title Name" id=TitleName required></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/hr/createUser/addVendorDialog.html','<md-dialog aria-label="Add Vendor" flex=70><form ng-cloak class=sendEmailDialog name=addVendorform ng-submit="addVendorform.$valid && addVendorData(addVendor)"><md-toolbar><div class=md-toolbar-tools><h2>Add Vendor</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=subject>Vendor Name *</label> <input type=text class=form-control ng-model=addVendor.VendorName name=subject placeholder=Subject required></div><div class="form-group col"><label for=message>Vendor Address *</label> <textarea class=form-control id=message rows=3 ng-model=addVendor.VendorAddress required></textarea></div><p class=text-danger>All fields marked with * are required</p></div><div class="form-group col"><label for=subject>PayTerm *</label> <input type=text class=form-control ng-model=addVendor.PayTerm name=PayTerm placeholder="Pay Term" required></div><div class="form-group col"><label for=subject>Vendor Contact Cell *</label> <input type=number minlength=10 maxlength=14 class=form-control ng-model=addVendor.VendorContactCell name=VendorContactCell placeholder="Vendor Contact Cell" required></div><div class="form-group col"><label for=subject>Emergency Contact Number</label> <input type=number maxlength=14 class=form-control ng-model=addVendor.EmergencyContactNumber name=EmergencyContactNumber placeholder="Emergency Contact Number"></div><div class="form-group col"><label for=subject>Vendor Contact Fullname *</label> <input type=text class=form-control ng-model=addVendor.VendorContactFullName name=VendorContactFullName placeholder="Vendor Contact Fullname" required></div><div class="form-group col"><label for=subject>Primary Email *</label> <input type=email class=form-control ng-model=addVendor.PrimaryEmail name=PrimaryEmail placeholder="Primary Email" required></div><div class="form-group col"><label for=subject>Invoice Term *</label> <input type=number class=form-control ng-model=addVendor.InvoiceTerm name=InvoiceTerm placeholder="Invoice Term" required></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/hr/createUser/createUser.html','<div class=container-fluid><ci-spinner ng-if=!loginLoader></ci-spinner><div class=row ng-if=loginLoader><div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" ng-if=showForm><div class="card mt-2 p-3"><form name=multiStepForm ng-submit="multiStepForm.$valid && createUserReq(newUserData)" class="form-validation createUserForm" role=form><div class=d-flex><h3 class="text-left float-left font-weight-bolder border-bottom border-info">Onboard Consultant</h3></div><div class="form-row float-none"><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>UserName</label> <input type=email required ng-model=newUserData.UserName class="form-control form-control-sm" placeholder=name@domain.com ng-keyup=checkUsername(newUserData.UserName)><p class=text-danger ng-if=userExists>User already exists.</p></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>FirstName</label> <input required ng-model=newUserData.FirstName only-letters-input class="form-control form-control-sm" ng-disabled=userExists></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-1"><label>MiddleName</label> <input ng-model=newUserData.MiddleName class="form-control form-control-sm" only-letters-input ng-disabled=userExists></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>LastName</label> <input required ng-model=newUserData.LastName class="form-control form-control-sm" only-letters-input ng-disabled=userExists></div><div class="col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>Date of Birth</label> <input type=text class="form-control form-control-sm datepicker" id=Dob ng-model=newUserData.Dob required name=Dob ng-disabled=userExists></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>Contact Number</label> <input required ng-model=newUserData.Cell type=text class="form-control form-control-sm" ng-disabled=userExists only-numbers-input></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>Employee SSN</label> <input required ng-model=newUserData.SSN type=text class="form-control form-control-sm" ng-disabled=userExists only-numbers-input minlength=9 maxlength=9> <small>(*Enter Valid 9 digits SSN.)</small></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-3"><label>Title</label><div class=input-group><div class=custom-file><select ng-model=newUserData.title required class="form-control form-control-sm rounded-left rounded-0 border-right-0"><option ng-repeat="item in titles | orderBy:\'Title\'" filter:searchtitle ng-value={{item}}>{{item.Title}}</option></select></div><div class=input-group-append><button class="btn btn-primary btn-sm border-white" type=button ng-click=addTitle()>Add</button></div></div></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>Employer Name</label> <input required ng-model=newUserData.EmployerName class="form-control form-control-sm"></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>Employment Date</label> <input type=text class="form-control form-control-sm datepicker" id=EmployedSince ng-model=newUserData.EmployedSince required name=EmployedSince ng-disabled=userExists></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>Project Start Date</label> <input type=text class="form-control form-control-sm datepicker" id=ProjectAssignedDate ng-model=newUserData.ProjectAssignedDate required name=ProjectAssignedDate ng-disabled=userExists></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>Bill Rate</label> <input type=number min=0 step=0.01 class="form-control form-control-sm" ng-model=newUserData.BillRate name=cmsperhr placeholder=00.00 id=cmsperhr required></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>Pay Term</label> <select ng-model=newUserData.PayTerm class="form-control form-control-sm" required><option ng-repeat="lookup in lookups.lstPayTerm | orderBy: \'Term\'" ng-value=lookup.PayTermId ng-if="lookup.Term !== 1001 && lookup.Term !== 1002">{{lookup.Term}}</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1001">Pay When Paid</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1002">As Per Payment Schedule</option></select></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>Invoice Term</label> <select ng-model=newUserData.InvTerm class="form-control form-control-sm" required><option ng-value=lookup ng-repeat="lookup in lookups.lstInvTerm">{{lookup.Term}}</option></select></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2" ng-if="tokenData.role !== \'Admin\'"><label>Manager Name</label> <select ng-model=newUserData.ManagerId required class="form-control form-control-sm"><option ng-repeat="manager in ManagersList | orderBy:\'ManagerName\'" ng-value=manager>{{manager.ManagerName}}</option></select></div><hr class=hr-line><div class="d-flex flex-column w-100"><div class=d-flex><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-3"><label>End Client</label> <select ng-model=newUserData.selectedClient class="form-control form-control-sm" ng-change=selectedClientAddr(newUserData.selectedClient.ClientId) required><option ng-repeat="item in vm.endClients | orderBy:\'ClientName\'" ng-value={{item}}>{{item.ClientName}}</option></select></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-3"><label>Client Address</label> <select ng-model=newUserData.EndCLientAddress class="form-control form-control-sm" required><option ng-repeat="item in selectedClientAddresses | orderBy:\'Address\' track by $index" ng-value={{item}}>{{item.Street}}, {{item.City}}, {{item.State}}, {{item.Zipcode}}, {{item.Country}}</option></select></div></div><div class=d-flex><p class=text-warning>If Client is not found Go to Clients page and add new Client.</p></div><div class=d-flex><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-3"><label>Vendor</label> <select ng-model=newUserData.selectedVendor class="form-control form-control-sm" ng-change=selectedVendor(newUserData.selectedVendor.VendorId) required><option ng-repeat="item in vm.VendorInfo | orderBy:\'VendorName\'" ng-value={{item}}>{{item.VendorName}}</option></select></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-3"><label>Vendor Address</label> <select ng-model=newUserData.VendorAddress class="form-control form-control-sm" ng-change=selectedVendorAddr(newUserData.VendorAddress) required><option ng-repeat="item in selectedVendorAddresses | orderBy:\'Address\' track by $index" ng-value={{item}}>{{item.Street}}, {{item.City}}, {{item.State}}, {{item.Zipcode}}</option></select></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-3"><label>Vendor Contact</label> <select ng-model=newUserData.VendorAddressMap class="form-control form-control-sm" required><option ng-repeat="item in selectedAddrCont | orderBy:\'Address\' track by $index" ng-value=item>{{item.ContactName}}</option></select></div></div><div class=d-flex><p class=text-warning>If Vendor is not found Go to Vendorsw page and add new Vendor.</p></div></div><hr class=hr-line><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>Reference</label> <input required ng-model=newUserData.RefName class="form-control form-control-sm"></div><!-- <div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2">\r\n                            <label>Recruiter</label>\r\n                            <input required ng-model="newUserData.recruiter" class="form-control form-control-sm">\r\n                        </div> --><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-2"><label>Marketer</label><div class=input-group><div class=custom-file><select ng-model=newUserData.MarketerId class="form-control form-control-sm" required><option ng-repeat="item in vm.marketerInfo | orderBy:\'MarkterName\'" ng-value=item>{{item.MarkterName}}</option></select></div><div class=input-group-append><button class="btn btn-primary btn-sm border-white" type=button ng-click=vm.addmarketer()>Add</button></div></div></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-1"><label>Role</label> <select ng-model=newUserData.role required class="form-control form-control-sm" ng-change=roleChanged(createUserData.Role)><option ng-repeat="role in roles | orderBy:\'RoleType\'" ng-value=role.RoleType>{{role.RoleType}}</option></select></div><!-- <div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-3" ng-if="tokenData.role !== \'HR\'">\r\n                            <label class="mb-2">Approve Timesheets?</label>\r\n                            <div class="d-flex">\r\n                                <div class="d-flex align-items-center">\r\n                                    <input type="radio" ng-model="newUserData.IsEmployee" ng-value="true">\r\n                                    <label class="ml-2 pt-1">Yes</label>\r\n                                </div>\r\n                                <div class="d-flex align-items-center ml-4">\r\n                                    <input type="radio" ng-model="newUserData.IsEmployee" ng-value="false">\r\n                                    <label class="ml-2 pt-1">No</label>\r\n                                </div>\r\n                            </div>\r\n                        </div> --><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-3"><label class=mb-2>Is back office employee?</label><div class=d-flex><div class="d-flex align-items-center"><input type=radio ng-model=newUserData.IsBackOfficeEmp ng-value=true> <label class="ml-2 pt-1">Yes</label></div><div class="d-flex align-items-center ml-4"><input type=radio ng-model=newUserData.IsBackOfficeEmp ng-value=false> <label class="ml-2 pt-1">No</label></div></div></div></div><div class=summary ng-if=hideAlways><h3>Summary</h3><p>Username: {{newUserData.UserName}}</p><p>First name: {{newUserData.FirstName}}</p><p>Middle name: {{newUserData.MiddleName}}</p><p>Last name: {{newUserData.LastName}}</p><p>Date of Birth: {{newUserData.Dob | moment: \'format\': \'MM/DD/YYYY\'}}</p><p>Phone Number: {{newUserData.Cell}}</p><p>Employee SSN: {{newUserData.SSN}}</p><hr><p>Title: {{newUserData.selectedTitle.Title}}</p><p>Employer Name: {{newUserData.EmployerName}}</p><p>Joining Date: {{newUserData.EmployedSince | moment: \'format\': \'MM/DD/YYYY\'}}</p><p>Bill Rate: {{newUserData.BillRate}}</p><hr><p>End Client: {{newUserData.selectedClient.ClientName}}</p><p>Client Address: {{newUserData.EndCLientAddress.Street}},{{newUserData.EndCLientAddress.City}},{{newUserData.EndCLientAddress.State}},{{newUserData.EndCLientAddress.Zipcode}}</p><p>Vendor: {{newUserData.selectedVendor.VendorName}}</p><p>Vendor Address: {{newUserData.VendorAddress.Street}},{{newUserData.VendorAddress.City}},{{newUserData.VendorAddress.State}},{{newUserData.VendorAddress.Zipcode}}</p><p>Vendor Contact: {{newUserData.VendorAddressMap.ContactName}}</p><p>Invoice Schedule: {{newUserData.InvTerm.Term}}</p><p>Pay Term: {{newUserData.PayTerm.Term}}</p><p>Marketer: {{newUserData.MarketerId.MarkterEmailAddr}}</p><p>Reffered By: {{newUserData.RefName}}</p><hr><p>Project Assigned Date: {{newUserData.ProjectAssignedDate | moment: \'format\': \'MM/DD/YYYY\'}}</p><p>Role: {{newUserData.role}}</p><p>Manager Name: {{newUserData.ManagerId.ManagerName}}</p><!-- <p>Can Approve Timesheets: {{newUserData.IsEmployee?\'Yes\':\'No\'}}</p> --><p>Is back office employee: {{newUserData.IsBackOfficeEmp?\'Yes\':\'No\'}}</p></div><button type=submit class="btn btn-primary" ng-show=!ffsub>Submit</button><!-- <button type="submit" class="btn btn-warning" ng-if="!ffsub">Submit</button> --><ci-spinner ng-if=ffsub></ci-spinner></form></div></div><div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center"><div ng-if=successPage><div class=success-wrap><h2 class=confirmation-text>On boarded Successfully.</h2><p>Do you want to onboard another consultant?<br>if so, click below button</p><div><button type=button class="btn btn-success" ng-click=createAnother()>Create Another</button></div></div></div><div class="modal fade" id=errorPage data-backdrop=static data-keyboard=false tabindex=-1 aria-labelledby=staticBackdropLabel aria-hidden=true><div class="modal-dialog bg-danger"><div class="modal-content bg-danger"><div class=modal-body><div class=error-wrap><!-- <h2 class="confirmation-text">oops..! Something went wrong.</h2>\r\n                                <p>Please refresh your browser and try again.</p>\r\n                                <p><strong>*If problem persists again. Please contact support at <a\r\n                                            href="emailto:support@tekinsta-inc.com">support@tekinsta-inc.com</a></strong>\r\n                                </p>\r\n                                <div><button type="button" class="btn btn-danger" ng-click="reload()">Try\r\n                                        again</button>\r\n                                </div> --><h3 class=text-white>{{errorPageMsg}}</h3></div></div><div class=modal-footer><button type=button class="btn btn-secondary" data-dismiss=modal>Ok</button></div></div></div></div></div></div></div>');
$templateCache.put('app/components/hr/createUser/createUserDialog.html','<md-dialog aria-label="Add Client" flex=70><form ng-cloak class=sendEmailDialog name=addClientform ng-submit="addClientform.$valid && addClientData(addClient)"><md-toolbar><div class=md-toolbar-tools><h2>Add Client</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=subject>Client Name *</label> <input type=text class=form-control ng-model=addClient.ClientName name=subject placeholder=Subject id=subject required></div><div class="form-group col"><label for=message>Client Address *</label> <textarea class="form-control messagebody" id=message rows=3 ng-model=addClient.ClientAddress required></textarea></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/hr/createUser/newClientAddressDialog.html','<md-dialog aria-label="Add Client" flex=70><form ng-cloak class=sendEmailDialog name=addClientform ng-submit="addClientform.$valid && addClientAddrsData(addClient)"><md-toolbar><div class=md-toolbar-tools><h2>Add Client</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column>{{selectedClient}}<div class="form-group col"><label for=message>Client Address *</label> <textarea class="form-control messagebody" id=message rows=3 ng-model=addClient.ClientAddress required></textarea></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/hr/createUser/newMarketeerDialog.html','<md-dialog aria-label="Add Client" flex=70><form class=sendEmailDialog name=addClientform ng-submit="addClientform.$valid && addMarketerData(addMarketeer)"><md-toolbar><div class=md-toolbar-tools><h2>Add Marketeer</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=MarkterName>Markter Name *</label> <input type=text class=form-control ng-model=addMarketeer.MarkterName name=MarkterName only-letters-input placeholder="Markter Name" id=MarkterName required></div><div class="form-group col"><label for=MarkterEmailAddr>Markter Email Address *</label> <input type=text class=form-control ng-model=addMarketeer.MarkterEmailAddr name=MarkterEmailAddr ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ placeholder="Markter Email" id=MarkterEmailAddr ng-blur=checkMarketer(addMarketeer.MarkterEmailAddr) required> <small class=text-danger ng-show=addClientform.MarkterEmailAddr.$error.pattern>Invalid Email</small><p class=text-danger ng-if=marketerExists>Marketer already exists.</p></div><div class="form-group col"><label for=message>Commssions per hour *</label> <input type=number step=.01 class=form-control ng-model=addMarketeer.cmsperhr name=cmsperhr placeholder=00.00 id=cmsperhr required><!-- <textarea class="form-control messagebody" id="message" rows="3" ng-model="addMarketeer.cmsperhr" required></textarea> --></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/hr/createUser/newVendorAddressDialog.html','<md-dialog aria-label="Add Vendor" flex=70><form ng-cloak class=sendEmailDialog name=addVendorform ng-submit="addVendorform.$valid && addVendorAddrsData(addVendor)"><md-toolbar><div class=md-toolbar-tools><h2>Add Vendor</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=message>Vendor Address *</label> <textarea class="form-control messagebody" id=message rows=3 ng-model=addVendor.VendorAddress required></textarea></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/hr/h1bfiling/h1bfiling.html','<div class=container-fluid><md-content class="admin-container main-container p-0 outletContainer w-100 adminController md-padding"><div layout=column><div class=container-fluid><div class=row><div class="col-sm-4 pt-4"><div class=card><div class=card-header>H1B Filing Users</div><div class=card-body><form name=h1busers ng-submit="h1busers.$valid && SelectedH1busers(Selected.PrfIds)"><table class=table id=h1bTable><thead><tr><td>#</td><td><input type=checkbox ng-model=selectedAll ng-click=selectAll()></td><td>Name</td><td>Email</td></tr></thead><tbody><tr ng-repeat="user in users track by $index"><td>{{$index+1}}</td><!-- <td><input type="checkbox" checklist-model="Selected.PrfIds"\r\n                                                            checklist-value="user.PrfId" ng-checked="user.Selected"></td> --><td>{{user.FirstName}} {{user.LastName}}</td><td>{{user.UserName}}</td></tr></tbody></table><button type=submit class="md-primary md-raised">Submit</button></form></div></div></div></div></div></div></md-content></div>');
$templateCache.put('app/components/hr/hrDashboard/editProjectEnddate.html','<div class=row><form name=ProjectDetailsForm ng-submit="ProjectDetailsForm.$valid && ProjectDetailsSubmit(ProjectDetailsForm)" layout=row layout-sm=column layout-align="center center" layout-wrap><md-input-container flex><label>End Date</label><md-datepicker ng-model=ProjectDetails.ProjectEndDate md-open-on-focus required md-hide-icons=calendar md-max-date=maxDate md-min-date=ProjectDetailsForm.ProjectStartDate></md-datepicker></md-input-container><md-checkbox ng-model=ProjectDetailsForm.ProjectCompleted aria-label="Project Completed">Project Completed</md-checkbox><md-button class="md-fab md-mini md-primary" aria-label=Submit><i class=material-icons>done</i></md-button></form></div>');
$templateCache.put('app/components/hr/hrDashboard/fileViewer.html','<md-dialog aria-label="Rejection Reason" class=w-100><form ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>Viewer</h2><span flex></span><!-- <md-button class="md-icon-button" ng-click="cancel()">\n                    <md-icon md-svg-src="img/icons/ic_close_24px.svg" aria-label="Close dialog"></md-icon>\n                </md-button> --></div></md-toolbar><md-dialog-content><div class="md-dialog-content d-lg-flex flex-lg-row flex-sm-column"><div class=col-lg-12 style=min-height:500px><ci-spinner ng-if=startLoader></ci-spinner><img id=ctsImgViewWrapper style="width: inherit;"><iframe id=ctsViewFile frameborder=0 width=100% height=100%></iframe></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel()>Close</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/hr/hrDashboard/hrDashboard.html','<div class="container-fluid p-0"><md-card><md-card-content class="p-0 notifyTable"><md-tabs md-dynamic-height md-border-bottom md-selected=selectedIndex class=pendingUsersList><md-tab label="Visa\'s Expiring" md-on-select=userwithvisaexpiryLoad()><ci-spinner ng-if=!usersloaded></ci-spinner><div class=d-flex><div class="col-2 align-items-center"><button class="btn btn-sm btn-light rounded-pill shadow-sm mt-2" ng-click=notifyUsers(expiringUsersVisa) ng-if=usersloaded>Notify <span class="badge badge-warning">{{expiringUsersVisa.length}}</span> Pending Users</button></div><div class="bg-white w-100 d-flex justify-content-end p-2"><input type=text placeholder=Search.. ng-model=searchData ng-keyup=search(searchData) class=form-control><md-menu md-position-mode="target-right target" class=pt-2><md-button aria-label="Open demo menu" class="md-icon-button md-button-no-height" ng-click=$mdMenu.open($event)><i class="material-icons pointer zoom">more_vert</i></md-button><md-menu-content width=4><md-menu-item ng-repeat="item in groupByObj"><md-button ng-click=hotListGroupBy(item.value)><div layout=row flex><p flex>{{item.name}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></div><md-content class="md-padding d-flex flex-row flex-wrap" ng-show=usersloaded><div id=expiringUsersVisa></div></md-content></md-tab><md-tab label="Incomplete Profiles" md-on-select=usersmissingprfdataLoad()><ci-spinner ng-if=!usersloaded></ci-spinner><!-- <md-button class="md-raised md-primary notifyBtn" ng-click="notifyUsers(incompleteProfileData)"\r\n                                            ng-if="usersloaded">Notify <span>{{incompleteProfileData.length}}</span> Pending\r\n                                            Users</md-button> --><md-content class="md-padding d-flex flex-row flex-wrap" ng-if=usersloaded id=usersmissingprfd><div class=table-responsive><table ng-class="{\'table-responsive\':isMobile}" class=table id=usersmissingprfdataLoad><thead><tr><th scope=col>#</th><th scope=col>Name</th><th scope=col>Username</th><th>Current Work Authorization</th><th>Start date</th><th>End date</th><th>Document</th><th>Update</th></tr></thead><tbody><tr ng-repeat="prfData in incompleteProfileData track by $index"><th scope=row>{{$index+1}}</th><td>{{prfData.DisplayName}}</td><td>{{prfData.UserName}}</td><!-- <td ng-click="notifyUser(prfData)">\r\n                                                                Send Email\r\n                                                            </td> --><td><md-select ng-model=prfData.workAuthType placeholder="Select WorkAuth Type" md-container-class=dropdownCustom class=m-0 ng-disabled="vm.uploadedFile !== undefined"><md-option value={{workAuthType.WrkAuth}} ng-repeat="workAuthType in workAuthTypes">{{workAuthType.WrkAuth}}</md-option><md-optgroup label="Add WorkAuth" class="fix pointer" ng-click=newworkAuthType()></md-optgroup></md-select></td><td><md-datepicker aria-required=true ng-model=prfData.WorkAuthStartDate md-placeholder="Select From Date" class="ml-2 mr-2" md-open-on-focus md-max-date=maxDate md-hide-icons=calendar ng-disabled="vm.uploadedFile !== undefined"></md-datepicker></td><td><md-datepicker aria-required=true ng-model=prfData.WorkAuthEndDate md-placeholder="Select End Date" class="ml-2 mr-2" md-open-on-focus md-max-date=maxDate md-min-date=prfData.WorkAuthStartDate md-hide-icons=calendar ng-disabled="vm.uploadedFile !== undefined"></md-datepicker></td><td><!-- <input type="file" ng-model="prfData.File"> --><!-- <input type="file" ng-file-model="files" accept="image/JPG,image/PNG"\r\n                                                                    multiple id="imageUpload" class="profilePicUploadBtn none"\r\n                                                                    custom-on-change="fileUploaded()">\r\n                                                                <label for="imageUpload" class="ml-3 uploadBtn">\r\n                                                                    Select files\r\n                                                                    <i class="fa fa-cloud-upload"></i>\r\n                                                                </label> --><!-- <p class="m-0 p-0">{{prfData.file.name}}</p> --> <input autocomplete=off type=file file-model=prfDataFile id=prfDataFile class="profilePicUploadBtn col" accept="image/JPG,image/PNG, application/pdf" ng-class="isMobile ? \'\' : \'none\'" custom-on-change="fileDat(prfData,prfDataFile, $event)"> <label for=prfDataFile class="btn btn-info btn-sm" ng-show="prfData.workAuthType !== null && prfData.WorkAuthStartDate !== null && prfData.WorkAuthEndDate !== null && vm.uploadedFile === undefined">Upload</label><p class="p-0 m-0" ng-if="prfData.workAuthType !== null && prfData.WorkAuthStartDate !== null && prfData.WorkAuthEndDate !== null && vm.uploadedFile !== undefined">{{vm.uploadedFile.name}} <i class=material-icons ng-click=clearUpload()>cancel</i></p></td><td><button type=button ng-if="prfData.workAuthType !== null && prfData.WorkAuthStartDate !== null && prfData.WorkAuthEndDate !== null && vm.uploadedFile !== undefined" class="btn btn-primary btn-sm" ng-click=UpdateWorkAuthRec(prfData)>Update</button></td></tr></tbody></table></div></md-content></md-tab><md-tab label="Users By Work Auth" md-on-select=LoadWorkAuthList()><!-- <texperts-loader ng-style="{\'height\':\'{{windowHeight}}\'}"></texperts-loader> md-on-select="LoadUsersByWorkAuth(WAuth)"--><div class=row><div class=col-lg-2><ul class="list-group p-2"><li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center pointer WAuths" ng-repeat="WAuth in WAuthList track by $index" ng-class="$index == 0?\'active\':\'\'" ng-click=LoadUsersByWorkAuth(WAuth)><b>{{WAuth.WorkAuth}}</b> <span class="badge badge-warning badge-pill">{{WAuth.Count}}</span></li></ul></div><div class=col-lg-10><div class=d-flex><h4 class="col-2 pt-3">Users By {{selectedWorkAuth.WorkAuth}} - {{selectedWorkAuth.Count}}</h4><div class="bg-white w-100 d-flex justify-content-end p-2"><input type=text placeholder=Search.. ng-model=searchData ng-keyup=searchUsersByWorkAuthTb(searchData) class=form-control><md-menu md-position-mode="target-right target" class=pt-2><md-button aria-label="Open demo menu" class="md-icon-button md-button-no-height" ng-click=$mdMenu.open($event)><i class="material-icons pointer zoom">more_vert</i></md-button><md-menu-content width=4><md-menu-item ng-repeat="item in usersByWorkAuthGrouping"><md-button ng-click=UsersByWorkAuthTbGroupBy(item.value)><div layout=row flex><p flex>{{item.name}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=p-0><div id=WorkAuthUsers></div></div></div></div><!-- <md-tabs md-dynamic-height md-border-bottom md-selected="WAuthIndex" class="UsersByWorkAuth">\r\n                        <md-tab label="" \r\n                            ng-repeat="WAuth in WAuthList track by $index">\r\n                            <ci-spinner ng-if="!WorkAuthUsersLoaded"></ci-spinner>\r\n                            <md-tab-label><div ng-click="LoadUsersByWorkAuth(WAuth)">{{WAuth.WorkAuth}} <span>{{WAuth.Count}}</span> </div></md-tab-label>\r\n                            <md-tab-body>\r\n                                <div class="d-flex">\r\n                                    <div class="bg-white w-100 d-flex justify-content-end p-2">\r\n                                        <input type="text" placeholder="Search.." ng-model="searchData"\r\n                                            ng-keyup="searchUsersByWorkAuthTb(searchData)" class="form-control">\r\n                                        <md-menu md-position-mode="target-right target" class="pt-2">\r\n                                            <md-button aria-label="Open demo menu"\r\n                                                class="md-icon-button md-button-no-height"\r\n                                                ng-click="$mdMenu.open($event)">\r\n                                                <i class="material-icons pointer zoom">\r\n                                                    more_vert</i>\r\n                                            </md-button>\r\n                                            <md-menu-content width="4">\r\n                                                <md-menu-item ng-repeat="item in usersByWorkAuthGrouping">\r\n                                                    <md-button ng-click="UsersByWorkAuthTbGroupBy(item.value)">\r\n                                                        <div layout="row" flex>\r\n                                                            <p flex>{{item.name}}</p>\r\n                                                        </div>\r\n                                                    </md-button>\r\n                                                </md-menu-item>\r\n                                            </md-menu-content>\r\n                                        </md-menu>\r\n                                    </div>\r\n                                </div>\r\n                                <div class="p-2">\r\n                                    <div id="WorkAuthUsers"></div>\r\n                                </div>\r\n                            </md-tab-body>\r\n                        </md-tab>\r\n                    </md-tabs> --></md-tab><md-tab label="Add Work Auth" md-on-select=usersUploadWorkAuths()><ci-spinner ng-if=!usersloaded></ci-spinner><!-- <md-button class="md-raised md-primary notifyBtn" ng-click="notifyUsers(incompleteProfileData)"\r\n                                            ng-if="usersloaded">Notify <span>{{incompleteProfileData.length}}</span> Pending\r\n                                            Users</md-button> --><md-content class="md-padding d-flex flex-column" ng-if=usersloaded><div class="mt-4 pt-4 col-12"><md-input-container class="w-100 pt-4 pl-4"><label>Select User</label><md-select ng-model=selectedUser md-on-close=clearSearchTerm() data-md-container-class=selectdemoSelectHeader ng-change=selectedUserToArch(selectedUser)><md-select-header class=demo-select-header><input ng-model=searchTerm type=search id=UsersSearch placeholder="Search for a user.." class="demo-header-searchbox md-text" ng-keydown=$event.stopPropagation()></md-select-header><md-optgroup label=Users><md-option ng-value=user ng-repeat="user in AllUsers |\r\n                                                        filter:{FullName:searchTerm}">{{user.FullName}}</md-option></md-optgroup></md-select></md-input-container></div><div class=row ng-if=showAddngHis><div class="col-lg-6 pointer"><div class=card><div class="card-header d-flex justify-content-between"><div>{{selectedUser.FullName}} Work Auth History</div><button class="btn btn-success btn-sm" ng-click=newWaChange()>Add</button></div><ci-spinner ng-if=loadingHis></ci-spinner><div ng-if=!loadingHis><table ng-class="{\'table-responsive\':isMobile}" class="table UserWAHistory"><thead><tr><th>#</th><th>Auth Type</th><th>Start Date</th><th>End Date</th><th>Uploaded Date</th><th>Document</th></tr></thead><tbody><tr ng-repeat="user in UserWAHistory track by $index"><td>{{$index+1}}</td><td>{{user.WaType}}</td><td>{{user.WrkAuthStartDate | moment: \'format\': \'MMM DD, YYYY\'}}</td><td>{{user.WrkAuthEndDate | moment: \'format\': \'MMM DD, YYYY\'}}</td><td>{{user.CreateDate | moment: \'format\': \'MMM DD, YYYY\'}}</td><td ng-click=downloadWorkAuth(user) class="p-0 pt-1 text-center"><i class=material-icons>remove_red_eye</i></td></tr></tbody></table></div></div></div><div class=col-lg-6 ng-if=newWa><form ng-cloak name=newWASubForm id=newWASubForm novalidate ng-submit="newWASubForm.$valid && newWASub(selectedUser)"><div class=card><div class="card-header d-flex justify-content-between">{{selectedUser.FullName}} Work Auth History</div><div class="card-body bg-white"><md-input-container><label>Work Authorization Type</label><md-select ng-model=ctrl.WrkAuthId required><md-option><em>None</em></md-option><md-option ng-repeat="WAType in workAuthTypes" ng-value=WAType.WrkAuthId>{{WAType.WrkAuth}}</md-option></md-select></md-input-container><md-datepicker ng-model=ctrl.WrkAuthStartDate md-placeholder="Enter date" md-open-on-focus required></md-datepicker><md-datepicker ng-model=ctrl.WrkAuthEndDate md-placeholder="Enter date" md-open-on-focus md-min-date=ctrl.WrkAuthStartDate required></md-datepicker><div layout=row n class=mt-4><label class="ml-3 uploadBtn" for=fileToUpload>Upload Work Auth <i class="fa fa-cloud-upload"></i></label> <input type=file id=fileToUpload required onchange="angular.element(this).scope().setFiles(this) && fileUploadChangeEv()" class="pt-2 mt-2" style="visibility: hidden;" accept=image/JPG,image/PNG,application/pdf multiple> (*Supported Formats: jpg, png, pdf)</div><div class="alert alert-danger" ng-if=invalidFileTypes>File type is Invalid. Please choose correct file types.</div><div class=row><div ng-repeat="file in files" class=col>{{file.name}}</div><i class="material-icons pointer" ng-click=removeFile() ng-if="files.length>0" style="font-size: 15px;\r\n                                                                    line-height: 31px;\r\n                                                                    color: red;\r\n                                                                    margin-left: 10px;vertical-align: middle;">close</i></div></div><div class="card-footer text-muted"><button class="btn btn-primary" type=submit ng-show=!addWaLoader ng-disabled="files.length < 1">Submit</button><ci-spinner ng-if=addWaLoader></ci-spinner></div></div></form></div></div></md-content></md-tab><md-tab label="Work Auth History" md-on-select=usersUploadWorkAuths()><ci-spinner ng-if=!usersloaded></ci-spinner><div class="d-flex flex-column" ng-if=usersloaded><div class=d-flex><div class="col-4 pl-0"><div class=d-flex><div class="bg-white w-100 d-flex justify-content-end p-2"><input type=text placeholder=Search.. ng-model=searchData ng-keyup=searchAllUsersTb(searchData) class=form-control></div></div><div id=AllUsers></div></div><div class=col-8><div class=card ng-if=showHis><div class="card-header d-flex justify-content-between"><h5>{{selectedUser.FullName}} Work Auth History</h5></div><div id=UserWAHistory></div></div></div></div></div></md-tab></md-tabs></md-card-content></md-card></div>');
$templateCache.put('app/components/hr/hrDashboard/hrDashboardEmailDialogController.html','<md-dialog aria-label="Notify Users" flex=70><form ng-cloak class=sendEmailDialog name=hremailnoti ng-submit="hremailnoti.$valid && sendNotifyEmail(mailer)"><md-toolbar><div class=md-toolbar-tools><h2>Notify Users for <span class=text-warning>{{users.range | moment: \'format\': \'MM/DD/YYYY\'}}</span> period.</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=recipients>Recipients</label> <textarea multiple-email-validator class=form-control id=recipients rows=3 ng-model=mailer.Recipient readonly></textarea></div><div class="form-group col"><label for=subject>Subject</label> <input type=text class=form-control ng-model=mailer.Subject name=subject placeholder=Subject id=subject required></div><div class="form-group col"><label for=message>Message</label> <textarea class="form-control messagebody" id=message rows=3 ng-model=mailer.Body required></textarea></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/hr/hrDashboard/newworkAuthDialog.html','<md-dialog aria-label="Add Vendor" flex=70><form ng-cloak class=sendEmailDialog name=addWorkAuthform ng-submit="addWorkAuthform.$valid && addworkAuthData(workAuth)"><md-toolbar><div class=md-toolbar-tools><h2>Add Work Auth</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=message>New Work Auth *</label> <input type=text ng-model=workAuth placeholder="Enter Work Auth Type."></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/hr/hrDashboard/showProjectsOfUserlDialog.html','<div layout=column style=min-height:480px; class=projectsByUserDialog><div class="d-flex flex-grow"><div layout=column layout-align="space-between left" class="dark-bg p-4 col-sm-3"><div class=text-center><svg xmlns=http://www.w3.org/2000/svg x=0px y=0px width=100 height=100 viewbox="0 0 224 224" style=fill:#000000;><g transform=""><g fill=none fill-rule=nonzero stroke=none stroke-width=1 stroke-linecap=butt stroke-linejoin=miter stroke-miterlimit=10 stroke-dasharray="" stroke-dashoffset=0 font-family=none font-weight=none font-size=none text-anchor=none style="mix-blend-mode: normal"><path d=M0,224v-224h224v224z fill=none></path><path d="M112,218.4c-58.7631,0 -106.4,-47.6369 -106.4,-106.4v0c0,-58.7631 47.6369,-106.4 106.4,-106.4h0c58.7631,0 106.4,47.6369 106.4,106.4v0c0,58.7631 -47.6369,106.4 -106.4,106.4z" fill=#ecf0f1></path><g id=original-icon fill=#3498db><path d="M112,16.2078c-52.87455,0 -95.8272,42.95265 -95.8272,95.8272c0,52.87456 42.95265,95.8272 95.8272,95.8272c52.87455,0 95.8272,-42.95264 95.8272,-95.8272c0,-52.87455 -42.95265,-95.8272 -95.8272,-95.8272zM112,24.5406c48.37117,0 87.4944,39.12323 87.4944,87.4944c0,23.88471 -9.56606,45.48894 -25.04723,61.26724c-7.62361,-5.59681 -16.91655,-8.40492 -24.78683,-11.20534c-4.43251,-1.57719 -8.41784,-3.14013 -11.3274,-4.8825c-2.78652,-1.66869 -4.33399,-3.38352 -5.15104,-5.35447c-0.38268,-4.77828 -0.30517,-8.62509 -0.27667,-13.16647c0.50477,-0.5027 1.15233,-0.85589 1.66819,-1.46475c1.21654,-1.43587 2.45519,-3.18066 3.63746,-5.1429c2.02732,-3.36479 3.50251,-7.48035 4.32915,-11.6529c1.2623,-0.64345 2.61075,-0.7827 3.63746,-2.09134c1.8956,-2.41612 3.17525,-5.8163 3.74325,-10.55434c0.50368,-4.18327 -0.84413,-7.06047 -2.57958,-9.26861c1.86699,-6.10303 4.17847,-15.8087 3.39334,-25.85284c-0.43194,-5.52592 -1.82242,-11.08815 -5.16731,-15.71352c-3.19341,-4.41588 -8.37803,-7.59012 -15.01369,-8.73967c-4.21455,-4.78501 -10.90939,-7.03894 -18.91155,-7.03894h-0.04068h-0.03255c-17.92695,0.32912 -29.49366,7.74884 -34.44604,19.06616c-4.70924,10.76172 -3.69686,24.15928 -0.31736,38.10791c-1.81666,2.20829 -3.23974,5.1404 -2.72606,9.4395c0.57015,4.73643 1.84906,8.13802 3.74325,10.55434c1.02595,1.30875 2.37457,1.44752 3.63746,2.09134c0.82651,4.1693 2.302,8.27927 4.32915,11.64476c1.18227,1.96282 2.41965,3.70585 3.63746,5.1429c0.51599,0.60888 1.16283,0.96989 1.66819,1.47289c0.02708,4.539 0.10405,8.38431 -0.27667,13.16647c-0.81546,1.9637 -2.36087,3.67943 -5.1429,5.35447c-2.90495,1.74906 -6.8855,3.32068 -11.31113,4.90692c-7.86196,2.81788 -17.14968,5.64615 -24.79496,11.1972c-15.49066,-15.77972 -25.0635,-37.39052 -25.0635,-61.28352c0,-48.37117 39.12323,-87.4944 87.4944,-87.4944zM111.6745,49.51459c7.68337,0.00792 12.51755,2.28281 13.84189,4.60583l1.01718,1.78211l2.02624,0.27667c5.23374,0.72723 8.158,2.75823 10.25325,5.65556c2.09525,2.89734 3.25807,6.94085 3.61305,11.48202c0.70995,9.08232 -1.8899,19.80732 -3.53981,24.77055l-1.04974,3.14922l2.83998,1.72515c-0.2889,-0.17591 1.33527,0.7855 0.96836,3.83276c-0.44443,3.70726 -1.39179,5.59555 -2.02624,6.40421c-0.63445,0.80867 -0.90604,0.70538 -0.83816,0.69983l-3.43402,0.28482l-0.36619,3.42588c-0.31427,2.94342 -1.96977,6.95826 -3.906,10.17187c-0.96812,1.60681 -1.99813,3.03817 -2.8644,4.06062c-0.86627,1.02244 -1.78881,1.65572 -1.44034,1.47288l-2.22967,1.16366v2.52263c0,5.51765 -0.22479,10.02974 0.35805,16.45403l0.04883,0.55335l0.1953,0.5208c1.63961,4.41238 5.06208,7.52546 8.91056,9.8301c3.84847,2.30464 8.26371,3.97046 12.81656,5.59046c7.5035,2.66991 15.32537,5.29739 21.2877,9.1791c-15.19189,12.72469 -34.76007,20.40071 -56.15689,20.40071c-21.38854,0 -40.9512,-7.66859 -56.14061,-20.38444c5.99619,-3.85944 13.82971,-6.49434 21.32025,-9.1791c4.54984,-1.63075 8.95352,-3.30365 12.79215,-5.61487c3.83863,-2.31123 7.24886,-5.42378 8.88615,-9.82196l0.1953,-0.5208l0.04883,-0.55335c0.57807,-6.41933 0.35805,-10.93226 0.35805,-16.45403v-2.52263l-2.22967,-1.1718c0.34894,0.18253 -0.57378,-0.45033 -1.44034,-1.47288c-0.86656,-1.02256 -1.89629,-2.44521 -2.8644,-4.05248c-1.93623,-3.21454 -3.59185,-7.23257 -3.906,-10.17187l-0.36619,-3.42588l-3.43402,-0.28482c0.06437,0.00542 -0.2044,0.10866 -0.83816,-0.69983c-0.63377,-0.80847 -1.57979,-2.69535 -2.02624,-6.40421c-0.36419,-3.04789 1.27821,-4.02103 0.96836,-3.83276l2.64468,-1.60309l-0.77306,-3.00274c-3.585,-13.7979 -4.12712,-26.35243 -0.43942,-34.77967c3.68405,-8.41892 11.06379,-13.76022 26.91885,-14.0616z"></path></g><path d="" fill=none></path><path d="" fill=none></path></g></g></svg><h4>{{userData.LstProjCodes[0].FirstName}} {{userData.LstProjCodes[0].LastName}}</h4></div><h5>Projects</h5><md-list style="height: 220px;overflow: auto;"><md-list-item ng-repeat="project in userData.LstProjCodes track by $index" ng-click=setProjectDetails(project)><i class=material-icons>play_arrow</i> {{project.ProjectID}}</md-list-item></md-list><div ng-if=!newProject><md-button class=md-fab ng-click=newProjectemethod(newProject)><md-icon class=material-icons>add</md-icon></md-button>Add New Project</div><div ng-if=newProject><md-button class="md-fab md-primary md-hue-2" ng-click=newProjectemethod(newProject)><md-icon class=material-icons>clear</md-icon></md-button>Cancel</div></div><div layout=column class="p-4 col-sm-9" ng-show=!newProject><div><ul class="d-flex flex-row flex-wrap p-0"><li class="col-sm-6 row mb-2"><span class=col-sm-6>Markter Name : </span>{{ProjectDetails.MarkterName}}</li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Refered By : </span>{{ProjectDetails.ReferedBy}}</li></ul></div><div><h4>Project Details</h4><hr><ul class="d-flex flex-row flex-wrap p-0"><li class="col-sm-6 row mb-2"><span class=col-sm-6>Hourly Rate :</span><div ng-if=!ngShowhide2>${{ProjectDetails.HourlyRate}}</div><span class="pointer pl-2" ng-if="ProjectDetails.ProjectEndDate === null || ProjectDetails.ProjectEndDate === undefined" ng-click=ngShowhidemethod2(ngShowhide2)>Edit</span> <span class="pointer pl-2" ng-click=payRateHistoryReq(ProjectDetails.ProjectID)>History</span></li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Project Start Date : </span>{{ProjectDetails.ProjectStartDate | moment: \'format\': \'MMM DD YYYY\'}}</li><li class="col-sm-6 row mb-2" ng-if="ProjectDetails.ProjectEndDate !== null && ProjectDetails.ProjectEndDate !== undefined"><span class=col-sm-6>Project End Date : </span>{{ProjectDetails.ProjectEndDate | moment: \'format\': \'MMM DD YYYY\'}}</li><li class="col-sm-6 row mb-2" ng-if="ProjectDetails.ProjectEndDate === null || ProjectDetails.ProjectEndDate === undefined"><span class=col-sm-6>Project End Date : </span><span class=pointer ng-click=ngShowhidemethod(ngShowhide)>Assign Project End Date</span></li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Total Days : </span>{{ProjectDetails.TotalDays}}</li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Months By Days : </span>{{ProjectDetails.MonthsByDays}}</li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Full Months : </span>{{ProjectDetails.FullMonths}}</li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Client Name : </span>{{ProjectDetails.ClientName}}</li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Client Address : </span>{{ProjectDetails.ClientAddress}}</li></ul></div><div><h4>Vendor Details</h4><hr><ul class="d-flex flex-row flex-wrap p-0"><li class="col-sm-6 row mb-2"><span class=col-sm-6>Vendor Name : </span>{{ProjectDetails.VendorCompanyName}}</li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Vendor Pay Term : </span>{{ProjectDetails.VendorPayTerm}} days</li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Vendor Address :</span><p class="col-sm-6 p-0 m-0">{{ProjectDetails.VendorCompanyAddress}}</p></li></ul></div><ci-spinner ng-if="payRateHistory === undefined && payRateHistoryspinner"></ci-spinner><div ng-if=payRateHistoryData><h4>Pay Rate History</h4><hr><div class="table-responsive mb-4 pb-4"><table class=table><thead><tr><th>#</th><th>Client</th><th>Vendor</th><th>Start Date</th><th>End Date</th><th>Net Pay</th></tr></thead><tbody><tr ng-repeat="payrate in payRateHistory track by $index"><td>{{$index+1}}</td><td>{{payrate.ClientName}}</td><td>{{payrate.VendorName}}</td><td>{{payrate.ProjStartDate | moment: \'format\': \'MMM DD, YYYY\'}}</td><td>{{payrate.ProjEndDate | moment: \'format\': \'MMM DD, YYYY\'}}</td><td>{{payrate.NetPay}}</td></tr></tbody></table></div></div><md-button class="md-primary md-raised closeBtn" ng-click=cancel()>Close</md-button></div><div layout=column class="p-4 col-sm-9 bg-white" ng-show=newProject><!-- <ci-spinner ng-if="!dataLoaded"></ci-spinner> --><form name=newProjectDetailsForm ng-submit="newProjectDetailsForm.$valid && newProjectDetailsSubmit(newProjectDetails,selectedClient,ClientAddress,selectedVendor,VendorAddress)"><ci-spinner ng-if=!dataLoaded></ci-spinner><div><ul class="d-flex flex-row flex-wrap"><li class="col-sm-6 row mb-2"><span class=col-sm-6>Marketer Name :</span><md-select ng-model=newProjectDetails.Marketer md-container-class=dropdownCustom class="col-sm-6 m-0 p-0"><md-option ng-repeat="item in Marketers" ng-value=item>{{item.MarkterName}} - {{item.MarkterEmailAddr}}</md-option><md-optgroup label="Add Marketer" ng-click=addmarketer(addMarketerShow) class="fix pointer"></md-optgroup></md-select></li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Reffered By : </span><input type=text ng-model=newProjectDetails.RefByNAME class="col-sm-6 m-0 pl-0"></li></ul></div><div><h4>Project Details</h4><ul class="d-flex flex-row flex-wrap"><li class="col-sm-6 row mb-2"><span class=col-sm-6>Client Name :</span><md-select ng-model=selectedClient md-container-class=dropdownCustom class="col-sm-6 m-0 p-0" ng-change=selectedClientAddr(selectedClient)><md-option ng-repeat="item in Clients track by $index" ng-value={{item.ClientId}}>{{item.ClientName}}</md-option><md-optgroup label="Add Client" ng-click=newClient(addClientShow) class=fix></md-optgroup></md-select></li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Client Address :</span><md-select ng-model=ClientAddress class="col-sm-6 m-0 p-0" md-container-class=dropdownCustom ng-disabled="selectedClient === undefined"><md-option ng-repeat="item in selectedClientAddresses track by $index" ng-value={{item.AddrId}}>{{item.Address}}</md-option><md-optgroup label="Add Client Address" ng-click="newClientAddress(addClientAddrShow, selectedClient)" class=fix></md-optgroup></md-select></li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Project Start Date :</span><div class="col-sm-6 p-0"><md-datepicker ng-model=newProjectDetails.StartDate md-placeholder="Enter Start Date" md-open-on-focus md-hide-icons=calendar class="col-sm-6 m-0 p-0"></md-datepicker></div></li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Project End Date :</span><div class="col-sm-6 p-0"><md-datepicker ng-model=newProjectDetails.EndDate md-placeholder="Enter End Date" md-open-on-focus md-hide-icons=calendar class="col-sm-6 m-0 pl-0"></md-datepicker></div></li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Hourly Rate : </span><input type=number ng-model=newProjectDetails.BillRate class="col-sm-6 m-0 pl-0"></li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Title :</span><md-select ng-model=newProjectDetails.title md-container-class=dropdownCustom class="col-sm-6 m-0 p-0"><md-option ng-repeat="item in titles" ng-value={{item.TitleId}}>{{item.Title}}</md-option><md-optgroup label="Add Title" ng-click=addTitle(addTitleShow) class=fix></md-optgroup></md-select></li></ul></div><div><h4>Vendor Details</h4><ul class="d-flex flex-row flex-wrap"><li class="col-sm-6 row mb-2"><span class=col-sm-6>Vendor Name :</span><md-select ng-model=selectedVendor md-container-class=dropdownCustom class="col-sm-6 m-0 p-0" ng-change=selectedVendorAddr(selectedVendor)><md-option ng-repeat="item in Vendors" ng-value=item.VendorId>{{item.VendorName}}</md-option><md-optgroup label="Add Vendor" ng-click=newvendor(addVendorShow) class=fix></md-optgroup></md-select></li><li class="col-sm-6 row mb-2"><span class=col-sm-6>Vendor Address :</span><md-select ng-model=VendorAddress md-container-class=dropdownCustom class="col-sm-6 m-0 p-0" ng-disabled="selectedVendor === undefined"><md-option ng-repeat="item in selectedVendorAddresses track by $index" ng-value=item.AddrId>{{item.Address}}</md-option><md-optgroup label="Add Vendor Address" ng-click="newVendorAddress(addVendorAddressShow, selectedVendor)" class=fix></md-optgroup></md-select></li></ul></div><md-button class="md-primary md-raised" type=submit ng-show=!projectCreateMessage>Submit</md-button><ci-spinner ng-show=projectCreateStart></ci-spinner><div class="alert alert-info" ng-if=projectCreateMessage>Projected Created Successfully.</div></form></div></div><div class=overlay-custom ng-show=ngShowhide></div><div class=overlay-custom ng-show=ngShowhide2></div><div class=overlay-custom ng-show=addClientShow></div><div class=overlay-custom ng-show=addVendorShow></div><div class=overlay-custom ng-show=addClientAddrShow></div><div class=overlay-custom ng-show=addMarketerShow></div><div class=overlay-custom ng-show=addTitleShow></div><div class=ccDialg><div class=modal-custom ng-show=ngShowhide2><h2 class=p-4>Update Hourly Rate</h2><form name=ProjectDetailsHrsRateForm ng-submit="ProjectDetailsHrsRateForm.$valid && ProjectDetailsHrsRate(ProjectDetails)" class="form-column p-4" layout=column><md-input-container flex><label>Hourly Rate</label> <input ng-model=ProjectDetails.HourlyRate type=number></md-input-container><md-input-container flex><label>Last Rate End Date</label><md-datepicker ng-model=ProjectDetails.PrevProjEndDate md-placeholder="Last Rate End Date" md-open-on-focus ng-change=endForStartDate(ProjectDetails.PrevProjEndDate) md-hide-icons=calendar class="col-sm-6 m-0 p-0"></md-datepicker></md-input-container><md-input-container flex><label>New Rate Start Date</label><md-datepicker ng-model=ProjectDetails.NewProjStartDate md-placeholder="New Rate Start Date" md-open-on-focus md-min-date=minStartdate md-hide-icons=calendar class="col-sm-6 m-0 p-0" ng-disabled="ProjectDetails.PrevProjEndDate === undefined"></md-datepicker></md-input-container><md-input-container flex><md-button class="md-raised md-primary" aria-label=Submit type=submit ng-show=!notifier>Submit</md-button><md-button class=md-raised ng-click=ngShowhidemethod2(ngShowhide2) aria-label=Submit>Cancel</md-button></md-input-container><ci-spinner ng-show="notifier && !HrsRateEditReq"></ci-spinner><div class="alert alert-info" ng-if=HrsRateEditReq>Hourly Rate Updated Successfully.</div></form></div></div><div class=ccDialg><div class="row modal-custom" ng-show=ngShowhide><form name=ProjectDetailsSubmitForm ng-submit="ProjectDetailsSubmitForm.$valid && ProjectDetailsSubmit(ProjectEnd)" layout=column class="form-column p-4"><md-input-container flex><label>End Date</label><md-datepicker ng-model=ProjectEnd.ProjectEndDate md-open-on-focus required md-hide-icons=calendar md-max-date=maxDate></md-datepicker></md-input-container><md-input-container flex><md-checkbox ng-model=ProjectEnd.ProjectCompleted aria-label="Project Completed">Project Completed</md-checkbox></md-input-container><md-input-container flex><md-button class="md-raised md-primary" type=submit aria-label=Submit ng-if=!notifier>Submit</md-button><md-button class=md-raised ng-click=ngShowhidemethod(ngShowhide) aria-label=Submit>Cancel</md-button></md-input-container><ci-spinner ng-if="notifier && !projectEndDateReq"></ci-spinner><div class="alert alert-info" ng-if=projectEndDateReq>Project End Updated Successfully.</div></form></div></div><div class=ccDialg><div class=modal-custom ng-show=addClientShow style=padding:20px;><h2>Add Client</h2><form class=form-column name=addClientform ng-submit="addClientform.$valid && addClientData(addClient)"><div class="form-group col"><label for=subject>Client Name *</label> <input type=text class=form-control ng-model=addClient.ClientName name=subject placeholder=Subject required></div><div class="form-group col"><label for=message>Client Address *</label> <textarea class="form-control messagebody" rows=3 ng-model=addClient.ClientAddress required></textarea></div><p class=text-danger>All fields marked with * are required</p><md-button ng-click=newClient(addClientShow) ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if="notifier && !afterAddedClient"></ci-spinner><div class="alert alert-info" ng-if=afterAddedClient>Client added Successfully, Please select from the list.</div></form></div></div><div class=ccDialg><div class=modal-custom ng-show=addClientAddrShow style=padding:20px;><h2>Add Client Address</h2><form class=form-column name=" addClientAddrform" ng-submit="addClientAddrform.$valid && addClientAddrsData(addClient)"><div class="form-group col"><label for=message>Client Address *</label> <textarea class="form-control messagebody" rows=3 ng-model=addClient.ClientAddress required></textarea></div><p class=text-danger>All fields marked with * are required</p><md-button ng-click=newClientAddress(addClientAddrShow) ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if="notifier && !afterAddedClientAddr"></ci-spinner><div class="alert alert-info" ng-if=afterAddedClientAddr>Client Address added Successfully, Please select from the list.</div></form></div></div><div class=ccDialg><div class=modal-custom ng-show=addVendorShow style=padding:20px;><h2>Add Vendor</h2><form class=form-column name=addVendorform ng-submit="addVendorform.$valid && addVendorData(addVendor)"><div class="form-group col"><label for=subject>Vendor Name *</label> <input type=text class=form-control ng-model=addVendor.VendorName name=subject placeholder=Subject required></div><div class="form-group col"><label for=message>Vendor Address *</label> <textarea class=form-control rows=3 ng-model=addVendor.VendorAddress required></textarea></div><div class=row><div class="form-group col"><label for=subject>PayTerm *</label> <input type=text class=form-control ng-model=addVendor.PayTerm name=PayTerm placeholder="Pay Term" required></div><div class="form-group col"><label for=subject>Vendor Contact Fullname *</label> <input type=text class=form-control ng-model=addVendor.VendorContactFullName name=VendorContactFullName placeholder="Vendor Contact Fullname" required></div></div><div class=row><div class="form-group col"><label for=subject>Vendor Contact Cell *</label> <input type=number minlength=10 maxlength=14 class=form-control ng-model=addVendor.VendorContactCell name=VendorContactCell placeholder="Vendor Contact Cell" required></div><div class="form-group col"><label for=subject>Emergency Contact Number *</label> <input type=number maxlength=14 class=form-control ng-model=addVendor.EmergencyContactNumber name=EmergencyContactNumber placeholder="Emergency Contact Number"></div></div><div class=row><div class="form-group col"><label for=subject>Primary Email *</label> <input type=email class=form-control ng-model=addVendor.PrimaryEmail name=PrimaryEmail placeholder="Primary Email" required></div><div class="form-group col"><label for=subject>Invoice Term *</label> <input type=number class=form-control ng-model=addVendor.InvoiceTerm name=InvoiceTerm placeholder="Invoice Term" required></div></div><p class=text-danger>All fields marked with * are required</p><md-button ng-click=newvendor(addVendorShow) ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if="notifier && !afterAddedVendor"></ci-spinner><div class="alert alert-info" ng-if=afterAddedVendor>Vendor added Successfully, Please select from the list.</div></form></div></div><div class=ccDialg><div class=modal-custom ng-show=addVendorAddressShow style=padding:20px;><h2>Add Vendor Address</h2><form class=form-column name=addVendorAddrs ng-submit="addVendorAddrs.$valid && addVendorAddrsData(vendorAddrs)"><div class="form-group col"><label for=message>Vendor Address *</label> <textarea class="form-control messagebody" rows=3 ng-model=vendorAddrs.VendorAddress required></textarea></div><p class=text-danger>All fields marked with * are required</p><md-button ng-click=newVendorAddress(addVendorAddressShow) ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if="notifier && !afterAddedVendorAddr"></ci-spinner><div class="alert alert-info" ng-if=afterAddedVendorAddr>Vendor Address added Successfully, Please select from the list.</div></form></div></div><div class=ccDialg><div class=modal-custom ng-show=addMarketerShow style=padding:20px;><h2>Add Marketer</h2><form class=form-column name=addMarketerform ng-submit="addMarketerform.$valid && addMarketerData(addMarketeer)"><div class="form-group col"><label for=MarkterName>Markter Name *</label> <input type=text class=form-control ng-model=addMarketeer.MarkterName name=MarkterName placeholder="Markter Name" id=MarkterName required></div><div class="form-group col"><label for=MarkterEmailAddr>Markter Email Address *</label> <input type=text class=form-control ng-model=addMarketeer.MarkterEmailAddr name=MarkterEmailAddr placeholder="Markter Email" id=MarkterEmailAddr required></div><div class="form-group col"><label for=message>Commssions per hour *</label> <input type=number step=.01 class=form-control ng-model=addMarketeer.cmsperhr name=cmsperhr placeholder=00.00 id=cmsperhr required><!-- <textarea class="form-control messagebody" rows="3" ng-model="addMarketeer.cmsperhr" required></textarea> --></div><p class=text-danger>All fields marked with * are required</p><md-button ng-click=addmarketer(addMarketerShow) ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if="notifier && !afterAddedMarketer"></ci-spinner><div class="alert alert-info" ng-if=afterAddedMarketer>Marketer added Successfully, Please select from the list.</div></form></div></div><div class=ccDialg><div class=modal-custom ng-show=addTitleShow style=padding:20px;><h2>Add Title</h2><form ng-cloak class=sendEmailDialog name=addTitleform ng-submit="addTitleform.$valid && addTitleSubmit(data)"><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=TitleName>Title Name *</label> <input type=text class=form-control ng-model=data.Title name=Title placeholder="Title Name" id=TitleName required></div><p class=text-danger>All fields marked with * are required</p></div></div><md-button ng-click=addTitle(addTitleShow) ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if="notifier && !afterAddedTitle"></ci-spinner><div class="alert alert-info" ng-if=afterAddedTitle>Title added Successfully, Please select from the list.</div></form></div></div></div>');
$templateCache.put('app/components/hr/managerAppTs/managerAppTs.html','<div class=container-fluid><md-content class="admin-container main-container outletContainer adminController md-padding" flex layout-xs=row layout=column ng-if=!loginLoader><ci-spinner class=loginLoader></ci-spinner></md-content><md-content layout-xs=row ng-if=loginLoader><div flex layout=row class=h-100><div class="wrapper ng-table col p-0 md-whiteframe-4dp h-100 showUsers" ng-class="openPanel ? \'showHalf col-lg-4\' : \'\'"><div class="usersTable p-4" ng-class="toggleShowUsers ? \'oh\' : \'\'"><table class="table table-hover" id=usersTable><thead><tr><th>#</th><th>Name</th><th>Email</th></tr></thead><tbody><tr ng-repeat="row in usersList" ng-click=showUserDetails(row)><td>{{$index+1}}</td><td>{{row.DisplayName}}</td><td>{{row.Email}}</td></tr></tbody></table></div><div class=toggleShowUsersOverlay ng-if=toggleShowUsers></div><div class=toggleShowUsers ng-show=showDetailsPage ng-class="toggleShowUsers ? \'toggleShowUsersOverlay\' : \'\'" ng-click=toggleShowUsersev()><!-- <span ng-if="toggleShowUsers">&gt;</span>\r\n                        <span ng-if="!toggleShowUsers">&lt;</span> --></div></div><div class="col showDetailsPage" ng-if=showDetailsPage ng-class="openPanel ? \'showHalf offset-lg-4 offset-sm-0 pl-5\' : \'\'"><div hide-gt-sm style="position: fixed; right: 18px; top: 136px; font-size: 15px; z-index: 9999;" ng-click=closeUserDetails()><span style="background-color: #ccc;\r\n                                padding: 5px;\r\n                                border-bottom-left-radius: 6px;\r\n                                border-bottom-right-radius: 6px;\r\n                                box-shadow: 0px 0px 3px #0000004f;\r\n                                border: 1px solid #b5b5b5;\r\n                                border-top: 0px;">Back</span></div><h3 class=pt-2>{{userDetails.DisplayName}}<div class=w-100></div><small>{{userDetails.Email}}</small></h3><md-content><ci-spinner class=loginLoader ng-if=!getUserData></ci-spinner><div class="md-whiteframe-1dp wrapperBox m-0" ng-if=getUserData><div layout-padding><div colspan=5 class=w-100 layout=row layout-align="space-between center"><div class="p-2 d-flex flex-row"><a ng-click=getPrevYearTs(userDetails.loginid) class="pointer pr-3 text-warning underline">{{prevYear}}</a> <a ng-click=getPresnYearTs(userDetails.loginid) class="pointer text-warning underline">{{presentYear}}</a></div><div class="d-flex flex-row"><button type=button class="btn btn-outline-secondary btn-sm mr-1" ng-click="filter(\'All\')">View All</button> <button type=button class="btn btn-outline-primary btn-sm mr-1" ng-click="filter(\'Submitted\')">Submitted</button> <button type=button class="btn btn-outline-info btn-sm mr-1" ng-click="filter(\'Approved\')">Approved</button> <button type=button class="btn btn-outline-danger btn-sm mr-1" ng-click="filter(\'Rejected\')">Rejected</button></div></div><ci-spinner class=loginLoader ng-if=yearTsLoader></ci-spinner><table class="table table-hover" ng-if=!yearTsLoader><thead><tr><th>#</th><th>Timesheet Period</th><th>PortalHours</th><th>Accounts Action</th><th>Manager Action</th></tr></thead><tbody ng-repeat="ts in Timesheets | filter:{tsaction:search}" ng-if="ts.AccountsAction !== null && ts.IsAccountsProcessed !== false && ts.AccountsAction !== \'Rejected\'" ng-class="{\'bg-danger\': ts.ManagerAction == \'Rejected\', \'bg-primary\': ts.ManagerAction == \'Approved\'}"><!-- <tr ng-repeat="ts in Timesheets" ng-if="ts.ManagerAction == null"> bg-danger--><tr><td>{{$index+1}}</td><td>{{ts.StartDate | moment: \'format\': \'MMM DD, YYYY\'}} - {{ts.EndDate | moment: \'format\': \'MMM DD, YYYY\'}}</td><td>{{ts.PortalHours}}</td><td>Accounts {{ts.AccountsAction}} <span ng-if="ts.AccountsAction == \'Rejected\'" class=rejectReason><md-tooltip md-direction=top>{{ts.AcctsRejectReason}}</md-tooltip><i class=material-icons>info</i></span></td><td><span ng-if="ts.tsaction == \'Submitted\'" style="display: none;">{{ts.tsaction}}</span> <i class="material-icons text-primary" ng-click=approveTs(ts) ng-hide=ts.tsprocessing ng-if="ts.ManagerAction == null || ts.ManagerAction == \'\'">check_circle_outline</i><md-progress-circular ng-if="ts.tsprocessing && ts.ManagerAction == null" md-mode=indeterminate class=md-hue-2 md-diameter=20px></md-progress-circular><i class="material-icons text-danger" ng-click=RejectBox(ts,$event) ng-hide=ts.tsprocessing ng-if="ts.ManagerAction === null || ts.ManagerAction == \'\'">highlight_off</i> <span ng-if="ts.ManagerAction == \'Approved\'">{{ts.ManagerAction}}</span> <span ng-if="ts.ManagerAction == \'Rejected\'">{{ts.ManagerAction}} <span ng-if="ts.ManagerAction == \'Rejected\'" class=rejectReason><md-tooltip md-direction=top>{{ts.MgrRejectReason}}</md-tooltip><i class=material-icons>info</i></span></span></td></tr><tr ng-if=ts.showRejectBox class=RejectBox><td colspan=6><div class="d-flex w-100 col"><input type=text ng-model=rejectReason placeholder="Type your timesheet rejection reason.." class="flex-grow-1 p-1" style="width: auto;"><md-button class="md-raised md-primary" ng-click=rejectTs(rejectReason)>Reject</md-button><md-button ng-click=hideRejectBox(ts)>Cancel</md-button></div></td></tr></tbody></table></div></div></md-content></div></div></md-content></div>');
$templateCache.put('app/components/hr/payRise/payRise.html','<div class=container-fluid><div class="d-flex flex-column justify-content-center"><div class=col><div class=card><div class=card-body><div class="d-flex justify-content-center"><h2 class="mr-2 text-center">Texperts Inc</h2><h2 class="mr-3 text-center text-info">Pay Rise Schedule</h2></div><form name=filtForm ng-submit=filtFormSub(filtForm.$valid)><div class="d-flex justify-content-center"><div class="form-check form-check-inline"><input class=form-check-input type=radio name=byPayPeriod id=exampleRadios1 value=byPayPeriod ng-model=PRType ng-change=clearData()> <label class="form-check-label font-weight-bold" for=exampleRadios1>Pay Period</label></div><div class="form-check form-check-inline"><input class=form-check-input type=radio name=byConsultant id=exampleRadios2 value=byConsultant ng-model=PRType ng-change=clearData()> <label class="form-check-label font-weight-bold" for=exampleRadios2>Consultant</label></div><div class="form-check form-check-inline"><input class="form-check-input font-weight-bold" type=radio name=all id=exampleRadios3 value=all checked ng-model=PRType ng-change=clearData()> <label class="form-check-label font-weight-bold" for=exampleRadios3>Full Report</label></div></div><div class="d-flex justify-content-center mt-1"><div class="form-check form-inline" ng-show="PRType === \'byConsultant\'"><label class="form-label pr-2 font-weight-bold">Select Consultant</label> <select class=form-control ng-model=scon ng-required="PRType === \'byConsultant\'"><option value={{consultant}} ng-repeat="consultant in consultantList track by $index">{{consultant}}</option></select></div></div><div class="d-flex justify-content-center mt-3" ng-show="PRType === \'byPayPeriod\'"><div class="form-check form-inline"><label class="form-label pr-2 font-weight-bold">Select Year</label> <select class=form-control ng-model=syear ng-required="PRType === \'byPayPeriod\'"><option value={{year}} ng-repeat="year in years track by $index">{{year}}</option></select></div><div class="form-check form-inline"><label class="form-label pr-2 font-weight-bold">Select Month</label> <select class=form-control ng-model=smonth ng-required="PRType === \'byPayPeriod\'"><option value={{month}} ng-repeat="month in months track by $index">{{month}}</option></select></div></div><div class=text-center><button class="btn btn-sm btn-info mt-2" ng-click=GeneratePDF(PRType,scon,syear,smonth) ng-disabled=!filtForm.$valid>Generate Report</button><p ng-if=!filtForm.$valid class="text-danger mb-0 mr-5 pr-5 pt-3">Please fill all the required fields.</p></div></form></div></div></div><div class="col payrisedataTabl"><div id=reportsTable ng-show=showTabl></div><div class="d-flex justify-content-end"><button class="btn btn-sm btn-success mt-2" ng-click=downloadPDF() ng-show="viewDownloadBtn && showTabl">Download PDF</button></div></div></div></div>');
$templateCache.put('app/components/hr/Projects/projects.html','<div class=container-fluid><ci-spinner class=loginLoader ng-if=loginLoader></ci-spinner><div class="d-flex bg-white heightCanBe border" style="margin-top: 15px; overflow: auto;" ng-show=!loginLoader><div class="col-sm-3 col-lg-3 border-right"><div class=heightCanBe><div><div class="text-center pt-2 pb-3"><h2>{{userData.LstProjCodes[0].FirstName}} {{userData.LstProjCodes[0].LastName}}</h2></div><div class="d-flex justify-content-between align-items-center"><h5>Projects</h5><button class="btn btn-sm btn-success rounded-circle" ng-click=newProjectemethod(newProject,userData) ng-disabled=newProject><i class="fa fa-plus"></i></button></div><md-list style="overflow: auto;" class=ListHeightCanBe><md-list-item ng-repeat="project in userData.LstProjCodes" ng-click="setProjectDetails(project, $index)" ng-class="{selectedProj: selectedProj===$index}"><i class=material-icons>play_arrow</i><md-truncate flex>{{project.ClientName}}</md-truncate></md-list-item></md-list></div></div></div><div class="col-sm-9 col-lg-9 col-md-9 pt-2"><div ng-show=!newProject><div ng-if="ProjectDetails !== null"><div class="d-flex justify-content-between mb-2 align-items-center"><div class="d-flex align-items-center justify-content-center"><h2 class="mb-1 text-primary">{{ProjectDetails.ClientName}}</h2><p class="text secondary pt-3 ml-2 mr-2">({{ProjectDetails.Title}})</p><i class="fa fa-pen ml-2 text-primary pointer" ng-click=editProjCode(ProjectDetails) ng-if="ProjectDetails.AcctDesg!==null && !editProjCodeLoader"></i><ci-spinner class=small ng-if=editProjCodeLoader></ci-spinner></div><button class="btn btn-sm btn-success mt-2" ng-click=generateAdvice(ProjectDetails.ProjectID)>Generate Billing Advice</button></div><div ng-if=!ProjEditable><div><table cellpadding=3 border=1 class=w-100><thead><tr><td colspan=10 class="bg-info text-white font-weight-bolder">Project Details</td></tr><tr class="bg-dark text-white"><th>Rate</th><th>Start Date</th><th>End Date</th><th>Total Days</th><th>Months by Days</th><th>Full Months</th><th>Pay Term</th><th>Invoice Schedule</th><th>Marketer</th><th>Referer</th></tr></thead><tbody><tr><td class="d-flex border-0"><div ng-if=!ngShowhide2>${{ProjectDetails.HourlyRate}}</div><span class="pointer pl-2 text-primary" ng-if="ProjectDetails.ProjectEndDate === null || ProjectDetails.ProjectEndDate === undefined" ng-click=ngShowhidemethod2(ProjectDetails)><u>Edit</u></span> <span class="pointer pl-2 text-primary" ng-click=payRateHistoryReq(ProjectDetails.ProjectID) ng-if="ProjectDetails.AcctDesg!==null"><u>History</u></span></td><td>{{ProjectDetails.ProjectStartDate | moment: \'format\': \'MM/DD/YYYY\'}}</td><td><span ng-if="ProjectDetails.ProjectEndDate !== null && ProjectDetails.ProjectEndDate !== undefined">{{ProjectDetails.ProjectEndDate | moment: \'format\': \'MM/DD/YYYY\'}} </span><span class="pointer text-primary" ng-click=ngShowhidemethod(ProjectDetails) ng-if="ProjectDetails.ProjectEndDate === null && ProjectDetails.AcctDesg!==null"><u>Assign Project End Date</u></span></td><td>{{ProjectDetails.TotalDays}}</td><td>{{ProjectDetails.MonthsByDays}}</td><td>{{ProjectDetails.FullMonths}}</td><td><span ng-if="ProjectDetails.PayTermValue !==1001 && ProjectDetails.PayTermValue !==1002">{{ProjectDetails.PayTermValue}}</span> <span ng-if="ProjectDetails.PayTermValue ===1001">Pay When Paid</span> <span ng-if="ProjectDetails.PayTermValue ===1002">As per Payment Schedule</span><!-- {{ProjectDetails.PayTermValue}} --></td><td>{{ProjectDetails.InvoiceTermValue}}</td><td>{{ProjectDetails.MarkterName}}</td><td>{{ProjectDetails.ReferedBy}}</td></tr></tbody></table></div><ci-spinner ng-if="payRateHistory === undefined && payRateHistoryspinner"></ci-spinner><div ng-if=payRateHistoryData><div class=mt-4><table cellpadding=3 border=1 class=w-100><thead><tr><th colspan=6 class="bg-info text-white font-weight-bolder">Pay Rate History</th></tr><tr class="bg-dark text-white"><th>#</th><th>Client</th><th>Vendor</th><th>Start Date</th><th>End Date</th><th>Net Pay</th></tr></thead><tbody><tr ng-repeat="payrate in payRateHistory track by $index"><td>{{$index+1}}</td><td>{{payrate.ClientName}}</td><td>{{payrate.VendorName}}</td><td>{{payrate.ProjStartDate | moment: \'format\':\'MM/DD/YYYY\'}}</td><td><span ng-if="payrate.ProjEndDate !== null">{{payrate.ProjEndDate | moment: \'format\': \'MM/DD/YYYY\'}}</span> <span ng-if="payrate.ProjEndDate === null"></span></td><td>{{payrate.NetPay}}</td></tr></tbody></table></div></div><div><table cellpadding=3 border=1 class="w-100 mt-4"><thead><tr><td colspan=7 class="bg-info text-white font-weight-bolder">Client/Vendor Details</td></tr><tr class="bg-dark text-white"><th></th><th>Name</th><th>Street</th><th>City</th><th>State</th><th>Zip Code</th><th>Country</th></tr></thead><tbody><tr><td class="bg-dark text-white">Client</td><td><a href="" ui-sref=ClientsDetails({id:ProjectDetails.ClientId})><u>{{ProjectDetails.ClientName}}</u></a></td><td>{{ProjectDetails.Clientstreetaddress}}</td><td>{{ProjectDetails.ClientCity}}</td><td>{{ProjectDetails.ClientState}}</td><td>{{ProjectDetails.Clientzipcode}}</td><td>{{ProjectDetails.ClientCountry}}</td></tr><tr><td class="bg-dark text-white">Vendor</td><td><a href="" ui-sref=vendorDetails({id:ProjectDetails.VendorId})><u>{{ProjectDetails.VendorCompanyName}}</u></a></td><td>{{ProjectDetails.VendorStreetAddress}}</td><td>{{ProjectDetails.VendorCompanyCity}}</td><td>{{ProjectDetails.VendorState}}</td><td>{{ProjectDetails.VendorZipcode}}</td><td>{{ProjectDetails.VendorCountry}}</td></tr></tbody></table></div><!-- <div class="card mt-3" ng-if="ProjectDetails.AcctDesg===null"> --><div class="card mt-3" ng-if="ProjectDetails.AcctDesg===null"><div class=card-header>Update missing details</div><div class=card-body><ci-spinner ng-show=!contactsReady></ci-spinner><form name=updateInvoicingContact class=col-6 ng-show=contactsReady ng-submit="updateInvoicingContact.$valid && updateInvoicingContactSub(updateInvCon,selectedProjIndex)"><div class=row><div class="form-group col-6"><label for=Street>Invoicing Contact</label> <select class="form-control form-control-sm" required alt="Select a Designation" ng-model=updateInvCon.VendorAddrMapId><option value="">Select Contact...</option><option ng-repeat="item in contacts" ng-value=item.VendorAddrMapId>{{item.DesignationValue}}--{{item.ContactName}}</option></select></div><div class="form-group col-6"><label for=Street>Pay Term</label> <select class="form-control form-control-sm" required alt="Select a Designation" ng-model=updateInvCon.PayTermId><option ng-repeat="lookup in lookups.lstPayTerm | orderBy: \'Term\'" ng-value=lookup.PayTermId ng-if="lookup.Term !== 1001 && lookup.Term !== 1002">{{lookup.Term}}</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1001">Pay When Paid</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1002">As Per Payment Schedule</option></select></div></div><button class="btn btn-primary btn-sm" ng-if=!updateInvoicingContactSubLoader>Submit</button><ci-spinner ng-if=updateInvoicingContactSubLoader></ci-spinner></form></div></div><div ng-if="ProjectDetails.AcctDesg!==null"><table cellpadding=3 border=1 class="w-100 mt-4"><thead><tr><td colspan=7 class="bg-info text-white font-weight-bolder">Invocing contact details</td></tr><tr class="bg-dark text-white"><th>Designation</th><th>Name</th><th>Email</th><th>Phone</th></tr></thead><tbody><tr><td>{{ProjectDetails.DesignationValue}}</td><td>{{ProjectDetails.AcctContactName}}</td><td>{{ProjectDetails.AcctEmail}}</td><td>{{ProjectDetails.AcctPhoneNumber}}</td></tr></tbody></table></div><div class="row mt-3" ng-if="ProjectDetails.AcctDesg!==null"><div class="col-6 border-right"><h3>All Purchase Orders.</h3><table border=1 cellpadding=5 cellspacing=0 class="w-100 mt-2 mb-2"><thead class="bg-dark text-white"><tr><th style="width: 40px;">#</th><th>File</th><th>Created on</th></tr></thead><tbody><tr ng-repeat="file in POS track by $index"><td>{{$index+1}}</td><td><ci-spinner class=small ng-if=file.fileDownloadReq></ci-spinner><a ng-if=!file.fileDownloadReq ui-sref="" ng-click=GetPOByProjId(file)>{{file.FileUrl}}</a></td><td>{{file.CreateDate | moment: \'format\': \'MM/DD/YYYY--HH:MM\'}}</td></tr></tbody></table></div><div class=col-6><h3>Upload Purchase Order.</h3><form name=POForm ng-submit="files.length>0 && POFormSub()"><input type=file id=file accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf" name=file onchange=angular.element(this).scope().getFileDetails(this,1,POForm) class="col-12 mt-3 border p-3"><table border=1 cellpadding=5 cellspacing=0 class="w-100 mt-2 mb-2" ng-show=files.length><thead class="bg-dark text-white"><tr><th style="width: 40px;">#</th><th>File</th><th>Delete</th></tr></thead><tbody><tr ng-repeat="file in files track by $index"><td>{{$index+1}}</td><td>{{file.name}}</td><td><button class="btn btn-sm btn-danger" type=button ng-click=removeFilePO($index)>X</button></td></tr></tbody></table><div class="alert alert-warning alert-sm mt-2" ng-if="files.length<1">Please Select File.</div><button class="btn btn-sm btn-primary mt-3" type=submit ng-if=!POFormSubLoader>Submit</button><ci-spinner ng-if=POFormSubLoader></ci-spinner></form></div></div></div><form ng-show=ProjEditable class="card p-4" name=ProjEditableFname ng-submit="ProjEditableFname.$valid && ProjEditableSub(ProjectDetailsData)"><div><h4 class="font-weight-bolder text-primary">Project Details</h4><div class="d-flex flex-row flex-wrap"><div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-2"><label>Project Start Date :</label> <input type=text class="form-control datepicker" id=ProjectStartDate ng-model=ProjectDetailsData.ProjectStartDate required name=ProjectStartDate></div><div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-2"><label>Title :</label> <select ng-model=ProjectDetailsData.TitleId class=form-control id=TitleId><option ng-repeat="item in titles" ng-value=item.TitleId>{{item.Title}}</option><!-- <md-optgroup label="Add Title" ng-click="addTitle()" class="fix pointer">\r\n                                    </md-optgroup> --></select></div><div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-2"><label>Marketer Name :</label> <select ng-model=ProjectDetailsData.MarkterId class=form-control id=MarkterId><option ng-repeat="item in Marketers" ng-value=item.MarketerId>{{item.MarkterName}} - {{item.MarkterEmailAddr}}</option><!-- <md-optgroup label="Add Marketer" ng-click="addmarketer(addMarketerShow)"\r\n                                        class="fix pointer">\r\n                                    </md-optgroup> --></select></div><div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-2"><label>Reffered By :</label> <input type=text ng-model=ProjectDetailsData.ReferedBy only-letters-input class=form-control></div><div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-2"><label>Invoice Schedule :</label> <select class=form-control ng-model=ProjectDetailsData.InvTermId><option ng-repeat="lookup in lookups.lstInvTerm" ng-value=lookup.InvTermId>{{lookup.Term}}</option></select></div><div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-2"><label>Pay Term :</label> <select class=form-control ng-model=ProjectDetailsData.VendorPayTerm><option ng-repeat="lookup in lookups.lstPayTerm | orderBy: \'Term\'" ng-value=lookup.PayTermId ng-if="lookup.Term !== 1001 && lookup.Term !== 1002">{{lookup.Term}}</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1001">Pay When Paid</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1002">As Per Payment Schedule</option></select></div></div></div><div><h4 class="font-weight-bolder text-primary">Client Details</h4><div class="d-flex flex-row flex-wrap"><div class="col-sm-12 c0l-md-6 col-lg-4 col-xl-4 mb-2"><label>Client Name :</label> <select ng-model=ProjectDetailsData.ClientId class=form-control ng-change=getClientAddr(ProjectDetailsData.ClientId)><option></option><option ng-repeat="item in Clients track by $index" ng-value=item.ClientId>{{item.ClientName}}</option></select></div><div class="col-sm-12 c0l-md-6 col-lg-4 col-xl-4 mb-2"><label>Client Address :</label> <select required ng-model=ProjectDetailsData.ClientAddrId class=form-control><option value=""></option><option ng-repeat="item in selectedClientAddresses track by $index" ng-value=item.AddrId>{{item.Street}}, {{item.City}}, {{item.State}}, {{item.Zipcode}}, {{item.Country}}</option></select></div></div></div><div><h4 class="font-weight-bolder text-primary">Vendor Details</h4><div class="d-flex flex-row flex-wrap"><div class="col-sm-12 c0l-md-6 col-lg-4 col-xl-4 mb-2"><label>Vendor Name :</label> <select ng-model=ProjectDetailsData.VendorId class=form-control ng-change=getVendorAddr(ProjectDetailsData.VendorId) id=VendorId><option ng-repeat="item in Vendors" ng-value=item.VendorId>{{item.VendorName}}</option></select></div><div class="col-sm-12 c0l-md-6 col-lg-4 col-xl-4 mb-2"><label>Vendor Address :</label> <select required ng-model=ProjectDetailsData.VendorAddrId class=form-control ng-change=getVendContacts(ProjectDetailsData.VendorAddrId) id=VendorAddrId><option ng-repeat="item in selectedVendorAddresses track by $index" ng-value=item.AddrId>{{item.Street}}, {{item.City}}, {{item.State}}, {{item.Zipcode}}, {{item.Country}}</option></select></div><div class="col-sm-12 c0l-md-6 col-lg-4 col-xl-4 mb-2"><label>Invoicing Contact :</label> <select required ng-model=ProjectDetailsData.VendAddrMapId class=form-control><option></option><option ng-repeat="item in VendContacts track by $index" ng-value=item.VendorAddrMapId>{{item.DesignationValue}}--{{item.ContactName}}</option></select></div></div></div><div><button class="btn btn-sm btn-default" type=button ng-click=editProjCodeCancel()>Cancel</button> <button class="btn btn-sm btn-primary" type=submit>Save</button></div></form></div><div ng-if="ProjectDetails === null">No Projects</div></div><div ng-if=newProject><ci-spinner ng-if=!dataLoaded></ci-spinner><form name=newProjectDetailsForm ng-if=dataLoaded class="card p-3" id=newProjectDetailsForm ng-submit="newProjectDetailsForm.$valid && newProjectDetailsSubmit(newProjectDetails)"><div><h2>ADD NEW PROJECT</h2></div><div><h4 class="font-weight-bolder text-primary">Project Details</h4><div class="d-flex flex-row flex-wrap"><div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"><label>Project Start Date :</label><div class="col-sm-6 p-0"><md-datepicker required ng-model=newProjectDetails.StartDate required md-placeholder="Enter Start Date" md-open-on-focus md-hide-icons=calendar></md-datepicker></div></div><div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"><label>Project End Date :</label><div class="col-sm-6 p-0"><md-datepicker ng-model=newProjectDetails.EndDate md-placeholder="Enter End Date" md-open-on-focus md-hide-icons=calendar class="col-sm-6 m-0 pl-0"></md-datepicker></div></div><div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"><label>Hourly Rate :</label> <input type=number step=0.1 required ng-model=newProjectDetails.BillRate class="form-control form-control-sm"></div><div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"><label>Title :</label> <select required ng-model=newProjectDetails.Title class="form-control form-control-sm"><option ng-repeat="item in titles" ng-value=item>{{item.Title}}</option></select></div><div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"><label>Marketer Name :</label> <select required ng-model=newProjectDetails.Markter class="form-control form-control-sm"><option ng-repeat="item in Marketers" ng-value=item>{{item.MarkterName}} - {{item.MarkterEmailAddr}}</option><!-- <md-optgroup label="Add Marketer" ng-click="addmarketer(addMarketerShow)"\r\n                                    class="fix pointer">\r\n                                </md-optgroup> --></select></div><div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"><label>Reffered By :</label> <input type=text required ng-model=newProjectDetails.RefByNAME only-letters-input class="form-control form-control-sm"></div><div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"><label>Invoice Schedule :</label> <select class="form-control form-control-sm" required ng-model=newProjectDetails.VendorModel.InvoiceTerm><option ng-repeat="lookup in lookups.lstInvTerm" ng-value=lookup.InvTermId>{{lookup.Term}}</option></select></div><div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"><label>Pay Term :</label> <select class="form-control form-control-sm" required ng-model=newProjectDetails.VendorModel.PayTerm><option ng-repeat="lookup in lookups.lstPayTerm | orderBy: \'Term\'" ng-value=lookup.PayTermId ng-if="lookup.Term !== 1001 && lookup.Term !== 1002">{{lookup.Term}}</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1001">Pay When Paid</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1002">As Per Payment Schedule</option></select></div></div></div><div><h4 class="font-weight-bolder text-primary">Client Details</h4><div class="d-flex flex-row flex-wrap"><div class="col-sm-12 c0l-md-6 col-lg-4 col-xl-4 mb-2"><label>Client Name :</label> <select required ng-model=newProjectDetails.ClientModel.Client class="form-control form-control-sm" ng-change=getClientAddr(newProjectDetails.ClientModel.Client.ClientId)><option ng-repeat="item in Clients track by $index" ng-value=item>{{item.ClientName}}</option></select></div><div class="col-sm-12 c0l-md-6 col-lg-4 col-xl-4 mb-2"><label>Client Address :</label> <select required ng-model=newProjectDetails.ClientModel.ClientAddressInfo[0].Addr class="form-control form-control-sm"><option ng-repeat="item in selectedClientAddresses track by $index" ng-value=item>{{item.Street}}, {{item.City}}, {{item.State}}, {{item.Zipcode}}, {{item.Country}}</option></select></div></div></div><div><h4 class="font-weight-bolder text-primary">Vendor Details</h4><div class="d-flex flex-row flex-wrap"><div class="col-sm-12 c0l-md-6 col-lg-4 col-xl-4 mb-2"><label>Vendor Name :</label> <select required ng-model=newProjectDetails.VendorModel.Vendor class="form-control form-control-sm" ng-change=getVendorAddr(newProjectDetails.VendorModel.Vendor.VendorId)><option ng-repeat="item in Vendors" ng-value=item>{{item.VendorName}}</option></select></div><div class="col-sm-12 c0l-md-6 col-lg-4 col-xl-4 mb-2"><label>Vendor Address :</label> <select ng-model=newProjectDetails.VendorModel.VendorAddressInfo[0].Addr class="form-control form-control-sm" ng-change=getVendContacts(newProjectDetails.VendorModel.VendorAddressInfo[0].Addr.AddrId) required><option ng-repeat="item in selectedVendorAddresses track by $index" ng-value=item>{{item.Street}}, {{item.City}}, {{item.State}}, {{item.Zipcode}}, {{item.Country}}</option></select></div><div class="col-sm-12 c0l-md-6 col-lg-4 col-xl-4 mb-2"><label>Invoicing Contact :</label> <select required ng-model=newProjectDetails.VendorModel.VendorAddressInfo[0].VendorAcctInfo[0].VendorAddrMapId class="form-control form-control-sm" ng-disabled="selectedVendorContacts.length>0"><option ng-repeat="item in VendContacts track by $index" ng-value=item.VendorAddrMapId>{{item.DesignationValue}}--{{item.ContactName}}</option></select></div></div></div><div class=pt-3><button class="btn-default btn btn-sm" type=button ng-show=!projectCreateStart ng-click=newProjectemethodCancel(newProject,userData)>Cancel</button> <button class="btn-primary btn btn-sm" type=submit ng-disabled=!newProjectDetailsForm.$valid ng-show=!projectCreateStart>Submit</button><ci-spinner ng-show=projectCreateStart></ci-spinner></div><div class="alert alert-info" ng-show=projectCreateMessage>Project Created Successfully.</div></form></div></div></div></div><div class="modal fade" id=ProjectCreatedSuccesfully tabindex=-1 role=dialog data-backdrop=static aria-labelledby=exampleModalCenterTitle aria-hidden=true><div class="modal-dialog modal-dialog-centered" role=document><div class=modal-content><div class=modal-body><h3 class=text-primary>Project Created Succesfully</h3></div><div class="modal-footer p-0"><button type=button class="btn btn-default" data-dismiss=modal>Ok</button></div></div></div></div><div class="modal fade" id=BillRateUpdatedSuccesfully tabindex=-1 data-backdrop=static role=dialog aria-labelledby=exampleModalCenterTitle aria-hidden=true><div class="modal-dialog modal-dialog-centered" role=document><div class=modal-content><div class=modal-body><h3 class=text-primary>Bill Rate Updated Succesfully</h3></div><div class="modal-footer p-0"><button type=button class="btn btn-default" data-dismiss=modal>Ok</button></div></div></div></div><div class="modal fade" id=ProjectUpdatedSuccesfully tabindex=-1 data-backdrop=static role=dialog aria-labelledby=exampleModalCenterTitle aria-hidden=true><div class="modal-dialog modal-dialog-centered" role=document><div class=modal-content><div class=modal-body><h3 class=text-primary>Project Updated Succesfully</h3></div><div class="modal-footer p-0"><button type=button class="btn btn-default" data-dismiss=modal>Ok</button></div></div></div></div><div class="modal fade text-white" id=draftSavedAlert tabindex=-1 data-backdrop=static role=dialog aria-labelledby=exampleModalCenterTitle aria-hidden=true><div class="modal-dialog modal-dialog-centered" role=document><div class="modal-content bg-success"><div class=modal-body><h3>Saved successfully</h3>The form data has been saved. Saved data will be autofilled when you come back.</div><div class="modal-footer p-0 border-success"><button type=button class="btn btn-default text-white" data-dismiss=modal>Ok</button></div></div></div></div><div class="modal fade" id=updateHourlyRate tabindex=-1 data-backdrop=static role=dialog aria-labelledby=exampleModalCenterTitle aria-hidden=true><div class="modal-dialog modal-dialog-centered" role=document><form name=ProjectDetailsHrsRateForm ng-submit="ProjectDetailsHrsRateForm.$valid && ProjectDetailsHrsRate(billRateUpdateData)" class=modal-content><div class=modal-body><h2 class=p-4>Update Hourly Rate</h2><div class="col-12 d-flex align-items-center"><label class=col-5>Hourly Rate</label> <input ng-model=billRateUpdateData.HourlyRate class="form-control col-7" type=number step=0.1></div><div class="col-12 d-flex align-items-center mt-3"><label class=col-5>Last Rate End Date</label><md-datepicker ng-model=billRateUpdateData.PrevProjEndDate md-placeholder="Select Date" md-open-on-focus ng-change=endForStartDate(ProjectDetails.PrevProjEndDate) md-hide-icons=calendar class=col-7 required md-min-date=ProjectDetails.ProjectStartDate></md-datepicker></div><div class="col-12 d-flex align-items-center mt-3"><label class=col-5>New Rate Start Date</label><md-datepicker ng-model=billRateUpdateData.NewProjStartDate md-placeholder="Select Date" md-open-on-focus md-min-date=billRateUpdateData.PrevProjEndDate md-hide-icons=calendar class=col-7 required></md-datepicker></div><div class="col-12 d-flex align-items-center"></div><ci-spinner ng-if="notifier && !HrsRateEditReq"></ci-spinner><div class="alert alert-info" ng-if=HrsRateEditReq>Hourly Rate Updated Successfully.</div></div><div class="modal-footer p-0 border-success"><button class="btn btn-default btn-sm" data-dismiss=modal aria-label=cancel>Cancel</button> <button class="btn btn-primary btn-sm" aria-label=Submit type=submit ng-if=!notifier>Submit</button></div></form></div></div><div class="modal fade" id=assignProEndDate tabindex=-1 data-backdrop=static role=dialog aria-labelledby=exampleModalCenterTitle aria-hidden=true><div class="modal-dialog modal-dialog-centered" role=document><form name=ProjectDetailsSubmitForm ng-submit="ProjectDetailsSubmitForm.$valid && ProjectDetailsSubmit(ProjectEnd,ProjectDetails)" class=modal-content><div class=modal-body><div class=row><div class="col-12 d-flex align-items-center mb-2 mt-2"><label>End Date</label><md-datepicker ng-model=ProjectEnd.ProjectEndDate md-open-on-focus required md-hide-icons=calendar md-min-date=minEndate></md-datepicker></div><div class="col-12 d-flex align-items-center"><md-checkbox ng-model=ProjectEnd.ProjectCompleted aria-label="Project Completed">Project Completed</md-checkbox></div></div></div><div class="modal-footer p-0 border-success"><div class="col-12 d-flex align-items-center"><button class="btn btn-sm btn-default mr-2" data-dismiss=modal aria-label=Submit>Cancel</button> <button class="btn btn-sm btn-primary" type=submit aria-label=Submit ng-if=!notifier>Submit</button></div><ci-spinner ng-if="notifier && !projectEndDateReq"></ci-spinner><div class="alert alert-info" ng-if=projectEndDateReq>Project End Updated Successfully.</div></div></form></div></div><div class="modal fade" id=PDFDwLoader tabindex=-1 data-backdrop=static style="z-index: 1051;"><div class="modal-dialog modal-dialog-centered justify-content-center" role=document><ci-spinner></ci-spinner></div></div><div class="modal fade w-100" id=adviceDataModal style="overflow: auto;"><div class=modal-dialog style="max-width: 65%; width:100%;" role=document><div class="modal-content p-4"><button class="btn btn-danger btn-sm" ng-click=downloadInvoice(adviceData)>Download PDF</button>{{PDFDwLoader}}<div class="modal-body p-3"><div class=mt-2 id=advice><header class=text-center><img src="data:image/png;base64,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" style="height: 120px;"><div class="h3 w-100">MARKETING - BILLING ADVICE NOTICE</div></header><div class="mb-2 bg-light border border-dark"><div class="p-1 bg-dark text-white font-weight-bolder h4 w-100">EMPLOYEE INFORMATION</div><div class=row><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Consultant Name:</div>{{adviceData.FirstName}} {{adviceData.LastName}}</div><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">SSN(Last 4 digits):</div>{{adviceData.SSN}}</div></div><div class=row><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Payroll Company:</div>Texperts Inc.</div><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Mobile Number:</div>{{adviceData.Pcell}}</div></div><div class=row><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Email:</div>{{adviceData.UserName}}</div></div></div><div class="mb-2 bg-light border border-dark"><div class="p-1 bg-dark text-white font-weight-bolder h4 w-100">END CLIENT INFORMATION</div><div class=row><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">End Client:</div>{{adviceData.ClientName}}</div><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Managers Name:</div></div></div><div class=row><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Telephone Number:</div></div></div><div class=row><div class=col-xl-12><table border=1 cellpadding=3 class="w-100 border-0"><thead><tr class=bg-info><th colspan=4>Address</th></tr></thead><thead><tr class="bg-dark text-white"><th>STREET</th><th>CITY</th><th>STATE</th><th>ZIPCODE</th></tr></thead><tbody><tr><td>{{adviceData.Clientstreetaddress}}</td><td>{{adviceData.ClientCity}}</td><td>{{adviceData.ClientState}}</td><td>{{adviceData.Clientzipcode}}</td></tr></tbody></table></div></div></div><div class="mb-2 bg-light border border-dark"><div class="p-1 bg-dark text-white font-weight-bolder h4 w-100">MID CLIENT INFORMATION</div><div class=row><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">MID Client:</div>{{adviceData.VendorCompanyName}}</div><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Contact Name:</div>{{adviceData.PrimaryVendorContactName}}</div><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Contact Email:</div>{{adviceData.PrimaryVendorEmail}}</div><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Telephone Number:</div>{{adviceData.PrimaryVendorContactCell}}</div><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Contract In Place:</div><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACDklEQVRIS92VvUtCYRTGn6tSYDUlQbdJesfQra0kCklsi9rahMboL8j+gmgM2tqKtsKQIrStLXF8palXCJsqwahunHPyUnk/cmjpjtfnnN/5eq4W/vix/jg//jGgks06NL5MuRzYZZjOM5iC7Hye12NOT30hv9H1ADgol4MqFADHgd7fhzk764GwbnFRdJYlulKpR+cNyGah1taAtzcJPjiAOT93gzn5woJoHAeIRkVTLocDSqXjYnxnb8uem4NaWRFIJAJ9eAhTqfDY7EwGanUVeH+X5EdHMJeXaG+ub+dyy8Wvp++5AxcyMwO1tAS8vkqM9SmnqumJxaBPTmCurjyTc4if0VzI9DTU/Dzw8iLj6IIGBqAvLmCur32TBwLoxy5kdmMDaLdlXPREo0A8jurubmDyUAAJaKGzU1PAwwPQ6QhgcBAYHUW1Xg/1SaiJ7IkJqJER4OnpewfDw9CPjzB3d4EQXwCfYjIJlUgAz89yMbGYdEBLj0SAoSHoVgvm9tYX4u9kpaDGxiQ5LdQYrpbPlLqybVk8Qe7vYbT2hHgbLZWSBK2WJG82uUq6cwKwT6i78XGBJBJSQK0WbjQeTToNNTnJl6O15uq+msg9YepSKb4o3WjA3NyEA9zgdJrvnqrycqirS6XYgJS8byfTOLyCuubsQoJ0gU6mwJ/flp/OJ0iQ7h//Zfp9BPt9/wEUgC4o4wzseAAAAABJRU5ErkJggg==" ng-if=!adviceData.ContractInPlace> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABi0lEQVQ4T6WSsWvCQBTG3+UvcHBw0EUcRHTSIYNDTgUHFxdbigi2g9ChQ7cWWgi0g1MXh1KhVCjSoX+BGj3BJYOjiEM2HUQcdHIRX8kTA7EprTXLu+O+73df7j0GR37sSD/8C5D6TCmwAUU71dSDAWRGEGZy7URjBwGUD0VhwEQ6nYZGowHiTPwdEH+PkzmTycB6vSZAr9DbAuRXWQUJuvq53nV6VPlNptjZbBZWqxVJTIB+oW8B0ZcompVtGO9f9m2Q2HNMQQlFLpeD5XJJ5mazaWkJEKlEMJ/PQ71eBwTkg6sBQcKVMMU2z2azGZlbrZZNQ4DgUxCTyST4fD6o1WoADDipEUSxWITxeEzbdrtNZ6PrkZWSAP6yHxOJBIkCgQBUq1Val0olMAyD1p1OBySUuHFr2H6RAN4HL0XlfHtxKBSiOhwOqQohKPbkfvLtka058Kgec7osyK4bphkk4FN16tgh2yC579w2yM48f5w7mqlz+3133bgUhoxGFRnyRXnxo9kRsA/8bf8Fs8OcEVFvG7UAAAAASUVORK5CYII=" ng-if=adviceData.ContractInPlace><!-- {{adviceData.ContractInPlace}} --></div><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Contract Signed Date:</div><span ng-if="adviceData.ContractSigDate!==null">{{adviceData.ContractSigDate | moment: \'format\': \'MM/DD/YYYY\'}}</span> <span ng-if="adviceData.ContractSigDate===null">n/a</span></div><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Addendum In Place:</div><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACDklEQVRIS92VvUtCYRTGn6tSYDUlQbdJesfQra0kCklsi9rahMboL8j+gmgM2tqKtsKQIrStLXF8palXCJsqwahunHPyUnk/cmjpjtfnnN/5eq4W/vix/jg//jGgks06NL5MuRzYZZjOM5iC7Hye12NOT30hv9H1ADgol4MqFADHgd7fhzk764GwbnFRdJYlulKpR+cNyGah1taAtzcJPjiAOT93gzn5woJoHAeIRkVTLocDSqXjYnxnb8uem4NaWRFIJAJ9eAhTqfDY7EwGanUVeH+X5EdHMJeXaG+ub+dyy8Wvp++5AxcyMwO1tAS8vkqM9SmnqumJxaBPTmCurjyTc4if0VzI9DTU/Dzw8iLj6IIGBqAvLmCur32TBwLoxy5kdmMDaLdlXPREo0A8jurubmDyUAAJaKGzU1PAwwPQ6QhgcBAYHUW1Xg/1SaiJ7IkJqJER4OnpewfDw9CPjzB3d4EQXwCfYjIJlUgAz89yMbGYdEBLj0SAoSHoVgvm9tYX4u9kpaDGxiQ5LdQYrpbPlLqybVk8Qe7vYbT2hHgbLZWSBK2WJG82uUq6cwKwT6i78XGBJBJSQK0WbjQeTToNNTnJl6O15uq+msg9YepSKb4o3WjA3NyEA9zgdJrvnqrycqirS6XYgJS8byfTOLyCuubsQoJ0gU6mwJ/flp/OJ0iQ7h//Zfp9BPt9/wEUgC4o4wzseAAAAABJRU5ErkJggg==" ng-if=!adviceData.AddInPlace> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABi0lEQVQ4T6WSsWvCQBTG3+UvcHBw0EUcRHTSIYNDTgUHFxdbigi2g9ChQ7cWWgi0g1MXh1KhVCjSoX+BGj3BJYOjiEM2HUQcdHIRX8kTA7EprTXLu+O+73df7j0GR37sSD/8C5D6TCmwAUU71dSDAWRGEGZy7URjBwGUD0VhwEQ6nYZGowHiTPwdEH+PkzmTycB6vSZAr9DbAuRXWQUJuvq53nV6VPlNptjZbBZWqxVJTIB+oW8B0ZcompVtGO9f9m2Q2HNMQQlFLpeD5XJJ5mazaWkJEKlEMJ/PQ71eBwTkg6sBQcKVMMU2z2azGZlbrZZNQ4DgUxCTyST4fD6o1WoADDipEUSxWITxeEzbdrtNZ6PrkZWSAP6yHxOJBIkCgQBUq1Val0olMAyD1p1OBySUuHFr2H6RAN4HL0XlfHtxKBSiOhwOqQohKPbkfvLtka058Kgec7osyK4bphkk4FN16tgh2yC579w2yM48f5w7mqlz+3133bgUhoxGFRnyRXnxo9kRsA/8bf8Fs8OcEVFvG7UAAAAASUVORK5CYII=" ng-if=adviceData.AddInPlace></div><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Addendum Signed Date:</div><span ng-if="adviceData.AddSIgDate!==null">{{adviceData.AddSIgDate | moment: \'format\': \'MM/DD/YYYY\'}}</span> <span ng-if="adviceData.AddSIgDate===null">n/a</span></div><div class="col-xl-6 d-flex"><div class="text-info font-weight-bolder col-6">Addendum In Points Covered:</div><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACDklEQVRIS92VvUtCYRTGn6tSYDUlQbdJesfQra0kCklsi9rahMboL8j+gmgM2tqKtsKQIrStLXF8palXCJsqwahunHPyUnk/cmjpjtfnnN/5eq4W/vix/jg//jGgks06NL5MuRzYZZjOM5iC7Hye12NOT30hv9H1ADgol4MqFADHgd7fhzk764GwbnFRdJYlulKpR+cNyGah1taAtzcJPjiAOT93gzn5woJoHAeIRkVTLocDSqXjYnxnb8uem4NaWRFIJAJ9eAhTqfDY7EwGanUVeH+X5EdHMJeXaG+ub+dyy8Wvp++5AxcyMwO1tAS8vkqM9SmnqumJxaBPTmCurjyTc4if0VzI9DTU/Dzw8iLj6IIGBqAvLmCur32TBwLoxy5kdmMDaLdlXPREo0A8jurubmDyUAAJaKGzU1PAwwPQ6QhgcBAYHUW1Xg/1SaiJ7IkJqJER4OnpewfDw9CPjzB3d4EQXwCfYjIJlUgAz89yMbGYdEBLj0SAoSHoVgvm9tYX4u9kpaDGxiQ5LdQYrpbPlLqybVk8Qe7vYbT2hHgbLZWSBK2WJG82uUq6cwKwT6i78XGBJBJSQK0WbjQeTToNNTnJl6O15uq+msg9YepSKb4o3WjA3NyEA9zgdJrvnqrycqirS6XYgJS8byfTOLyCuubsQoJ0gU6mwJ/flp/OJ0iQ7h//Zfp9BPt9/wEUgC4o4wzseAAAAABJRU5ErkJggg==" ng-if=!adviceData.AddPointsCovered> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABi0lEQVQ4T6WSsWvCQBTG3+UvcHBw0EUcRHTSIYNDTgUHFxdbigi2g9ChQ7cWWgi0g1MXh1KhVCjSoX+BGj3BJYOjiEM2HUQcdHIRX8kTA7EprTXLu+O+73df7j0GR37sSD/8C5D6TCmwAUU71dSDAWRGEGZy7URjBwGUD0VhwEQ6nYZGowHiTPwdEH+PkzmTycB6vSZAr9DbAuRXWQUJuvq53nV6VPlNptjZbBZWqxVJTIB+oW8B0ZcompVtGO9f9m2Q2HNMQQlFLpeD5XJJ5mazaWkJEKlEMJ/PQ71eBwTkg6sBQcKVMMU2z2azGZlbrZZNQ4DgUxCTyST4fD6o1WoADDipEUSxWITxeEzbdrtNZ6PrkZWSAP6yHxOJBIkCgQBUq1Val0olMAyD1p1OBySUuHFr2H6RAN4HL0XlfHtxKBSiOhwOqQohKPbkfvLtka058Kgec7osyK4bphkk4FN16tgh2yC579w2yM48f5w7mqlz+3133bgUhoxGFRnyRXnxo9kRsA/8bf8Fs8OcEVFvG7UAAAAASUVORK5CYII=" ng-if=adviceData.AddPointsCovered></div></div><div class=row><div class=col-xl-12><table border=1 cellpadding=3 class="w-100 border-0"><thead><tr class=bg-info><th colspan=4>Address</th></tr></thead><thead><tr class="bg-dark text-white"><th>STREET</th><th>CITY</th><th>STATE</th><th>ZIPCODE</th></tr></thead><tbody><tr><td>{{adviceData.VendorStreetAddress}}</td><td>{{adviceData.VendorCompanyCity}}</td><td>{{adviceData.VendorState}}</td><td>{{adviceData.VendorZipcode}}</td></tr></tbody></table></div></div></div><div class="mb-2 bg-light border border-dark"><div class="p-1 bg-dark text-white font-weight-bolder h4 w-100 mb-0">BILLING INFORMATION</div><div class=row><div class=col-xl-12><table class="w-100 border-0" border=1 cellpadding=3><thead><tr class=bg-info><th colspan=8 class="text-white text-center">A/P Contact</th></tr><tr class="bg-dark text-white"><th>Person</th><th>Designation</th><th>Email</th><th>Phone</th><th>Rate</th><th>Pay Term</th><th>Cycle</th><th>Project Start Date</th></tr></thead><tbody><tr><td>{{adviceData.AcctContactName}}</td><td>{{adviceData.AcctDesg}}</td><td>{{adviceData.AcctEmail}}</td><td>{{adviceData.AcctPhoneNumber}}</td><td>{{adviceData.HourlyRate}}</td><td><span ng-if="adviceData.VendorPayTerm !==1001 && adviceData.VendorPayTerm !==1002">{{adviceData.VendorPayTerm}}</span> <span ng-if="adviceData.VendorPayTerm ===1001">Pay When Paid</span> <span ng-if="adviceData.VendorPayTerm ===1002">As per Payment Schedule</span></td><td>{{adviceData.InvTermId}}</td><td><span ng-if="adviceData.ProjectStartDate!==null">{{adviceData.ProjectStartDate | moment: \'format\': \'MM/DD/YYYY\'}}</span> <span ng-if="adviceData.ProjectStartDate===null">n/a</span></td></tr></tbody></table></div></div></div><p>Invoicing Method: {{adviceData.InvMethod}}</p><p>Other Instructions:</p></div></div><div class="modal-footer p-0"><button type=button class="btn btn-default" data-dismiss=modal>Ok</button></div></div></div></div><div class="modal fade text-warning" id=invalidFileTypeAlertDiv tabindex=-1 role=dialog aria-labelledby=exampleModalCenterTitle aria-hidden=true><div class="modal-dialog modal-dialog-centered" role=document><div class="modal-content bg-danger"><div class=modal-body><h3>Invalid Filetype</h3>Only MsWord and PDF file types are allowed.</div><div class="modal-footer p-0 border-warning"><button type=button class="btn btn-warning" data-dismiss=modal>Ok</button></div></div></div></div>');
$templateCache.put('app/components/hr/vendorDetails/vendorDetails.html','<div class=container-fluid><div class=d-flex><div class="d-flex align-items-center justify-content-center w-100 p-0 heightCanBe" ng-if=pageLoader><ci-spinner class=loginLoader></ci-spinner></div><div class="heightCanBe col-12" ng-if=!pageLoader><form name=vendorDetailsForm ng-submit="vendorDetailsForm.$valid && editVendorSub(vendorData,Vendor.VendorId,$index)" novalidate><div class="d-flex justify-content-between"><h3 ng-if=!vendorData.editable class="text-left text-primary d-flex align-items-center pt-3 pb-3">{{vendorData.VendorName}}<i class="fas fa-pen ml-2 text-secondary pointer mt-1" style="font-size: 13px;" ng-click=editVendor($index,vendorData)></i></h3><!-- <div class="d-flex align-items-center">\r\n          <span class="font-weight-bolder">Rate Vendor: </span>\r\n        <span class="user-rating" ng-if="ratingShow">\r\n          <input type="radio" name="rating" ng-value="5" ng-model="rating" ng-change="addUpdRating(rating)"><span class="star"></span>\r\n          \r\n              <input type="radio" name="rating" ng-value="4" ng-model="rating" ng-change="addUpdRating(rating)"><span class="star"></span>\r\n          \r\n              <input type="radio" name="rating" ng-value="3" ng-model="rating" ng-change="addUpdRating(rating)"><span class="star"></span>\r\n          \r\n              <input type="radio" name="rating" ng-value="2" ng-model="rating" ng-change="addUpdRating(rating)"><span class="star"></span>\r\n          \r\n              <input type="radio" name="rating" ng-5value="1" ng-model="rating" ng-change="addUpdRating(rating)"><span class="star"></span>\r\n          </span>\r\n        </div> --></div><div class="d-flex align-items-center mt-4" ng-if=vendorData.editable><label class="m-0 pr-2 pt-3 pb-3 font-weight-bolder">Vendor Name</label> <input type=text ng-model=vendorData.VendorName placeholder={{vendorData.VendorName}} alpha-num-space required minlength=2 class="form-control col-6" ng-class="editableErr?\'border border-danger\':\'\'"> <span class=text-success>{{errorMsg}}</span> <button type=button class="btn btn-default ml-2" ng-click=editVendorCancel($index,Vendor) ng-disabled="vendorData.VendorName===undefined" ng-if=!editVendorSubLoader><i class="fas fa-times text-danger pointer" ng-if=vendorData.editable></i></button> <button type=submit class="btn btn-primary ml-2" ng-disabled="vendorData.VendorName===undefined" ng-if=!editVendorSubLoader><i class="fas fa-check pointer text-white"></i></button><ci-spinner ng-if=editVendorSubLoader class=small></ci-spinner><div class="alert alert-danger" ng-if="vendorData.VendorName===undefined">Vendor name is required.</div></div><div class=row><div class="col-xl-12 col-lg-12 col-md-12 col-sm-12"><div class=table-responsive><table border=1 cellpadding=3 cellspacing=0 style="background-color: whitesmoke;border-color: #343a40;" class=w-100><thead style="background-color: #343a40;color: white;"><tr><th colspan=13 class="text-white bg-dark font-weight-bolder"><div class="d-flex justify-content-between"><span>Vendor Details</span> <span class=text-warning><u>Note: Payment term varies for each consultant.</u></span></div></th></tr><tr><th colspan=5 class="text-center bg-info">Contact Details</th><th colspan=3 class="text-center infoShade1">Addendum</th><th colspan=2 class="text-center infoShade2">Contract</th><th colspan=3 class="text-center infoShade3">Invoice & Payment</th></tr><tr><th class="text-center bg-info">Name</th><th class="text-center bg-info">Email</th><th class="text-center bg-info">Contact</th><th class="text-center bg-info">Fed Id</th><th class="text-center bg-info">Fax</th><th class="text-center infoShade1">In Place</th><th class="text-center infoShade1">Points Covered</th><th class="text-center infoShade1">Sign Date</th><th class="text-center infoShade2">In Place</th><th class="text-center infoShade2">Signed Date</th><th class="text-center infoShade3">Method</th><th class="text-center infoShade3">Schedule</th><th class="text-center bg-warning">Term</th></tr></thead><tbody><tr><td><span ng-show=!vendorData.editable>{{vendorData.VendorContactFullName}}</span> <input type=text class="form-control form-control-sm" ng-model=vendorData.VendorContactFullName size=5 placeholder="" ng-show=vendorData.editable required name=VendorContactFullName> <small ng-if=vendorDetailsForm.VendorContactFullName.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td><span ng-show=!vendorData.editable>{{vendorData.PrimaryEmail}}</span> <input type=text class="form-control form-control-sm" ng-model=vendorData.PrimaryEmail size=5 placeholder="" ng-show=vendorData.editable required name=PrimaryEmail> <small ng-if=vendorDetailsForm.PrimaryEmail.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td><span ng-show=!vendorData.editable>{{vendorData.VendorContactCell}}</span> <input type=text class="form-control form-control-sm" ng-model=vendorData.VendorContactCell size=5 placeholder="" ng-show=vendorData.editable required name=VendorContactCell> <small ng-if=vendorDetailsForm.VendorContactCell.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td><span ng-show=!vendorData.editable>{{vendorData.FedId}}</span> <input type=text only-numbers-input class="form-control form-control-sm" ng-model=vendorData.FedId size=5 placeholder="" ng-show=vendorData.editable maxlength=9 name=FedId> <small ng-if=vendorDetailsForm.FedId.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td><span ng-show=!vendorData.editable>{{vendorData.Fax}}</span> <input type=text only-numbers-input class="form-control form-control-sm" ng-model=vendorData.Fax size=6 placeholder="" ng-show=vendorData.editable maxlength=10 name=Fax> <small ng-if=vendorDetailsForm.Fax.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td class=text-center><span ng-show="!vendorData.editable&&vendorData.AddendaInPlace!==null"><span ng-if=vendorData.AddendaInPlace><i class="fas fa-check text-success"></i></span> <span ng-if=!vendorData.AddendaInPlace><i class="fas fa-times text-danger"></i></span></span><div class="form-group d-flex mb-0 align-items-center" ng-show=vendorData.editable><input type=radio id=AddendaInPlace name=AddendaInPlace ng-model=vendorData.AddendaInPlace ng-value=true ng-show=vendorData.editable><span class="mr-2 pl-1 pt-1">Yes</span> <input type=radio id=AddendaInPlace name=AddendaInPlace ng-model=vendorData.AddendaInPlace ng-value=false ng-show=vendorData.editable><span class="pl-1 pt-1">No</span></div><small ng-if=vendorDetailsForm.AddendaInPlace.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td class=text-center><span ng-show="!vendorData.editable&&vendorData.AddendaPointsCovered!==null"><span ng-if=vendorData.AddendaPointsCovered><i class="fas fa-check text-success"></i></span> <span ng-if=!vendorData.AddendaPointsCovered><i class="fas fa-times text-danger"></i></span></span><div class="form-group d-flex mb-0 align-items-center" ng-show=vendorData.editable><input type=radio id=AddendaPointsCovered name=AddendaPointsCovered ng-model=vendorData.AddendaPointsCovered ng-value=true ng-show=vendorData.editable><span class="mr-2 pl-1 pt-1">Yes</span> <input type=radio id=AddendaPointsCovered name=AddendaPointsCovered ng-model=vendorData.AddendaPointsCovered ng-value=false ng-show=vendorData.editable><span class="pl-1 pt-1">No</span></div><small ng-if=vendorDetailsForm.AddendaPointsCovered.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td class=text-center><span ng-show=!vendorData.editable ng-if="vendorData.AddendaSigDate!==null">{{vendorData.AddendaSigDate | moment: \'format\': \'MM/DD/YYYY\'}}</span> <span ng-show=!vendorData.editable ng-if="vendorData.AddendaSigDate===null"></span> <input class="form-control form-control-sm datepicker" size=6 ng-model=vendorData.AddendaSigDate ng-show=vendorData.editable id=dateFormat name=AddendaSigDate> <small ng-if=vendorDetailsForm.AddendaSigDate.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td class=text-center><span ng-show="!vendorData.editable&&vendorData.ContractInPlace!==null"><span ng-if=vendorData.ContractInPlace><i class="fas fa-check text-success"></i></span> <span ng-if=!vendorData.ContractInPlace><i class="fas fa-times text-danger"></i></span></span><div class="form-group d-flex mb-0 align-items-center" ng-show=vendorData.editable><input type=radio id=ContractInPlace name=ContractInPlace ng-model=vendorData.ContractInPlace ng-value=true ng-show=vendorData.editable><span class="mr-2 pl-1 pt-1">Yes</span> <input type=radio id=ContractInPlace name=ContractInPlace ng-model=vendorData.ContractInPlace ng-value=false ng-show=vendorData.editable><span class="pl-1 pt-1">No</span></div><small ng-if=vendorDetailsForm.ContractInPlace.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td class=text-center><span ng-show=!vendorData.editable ng-if="vendorData.ContractSignedDate!==null">{{vendorData.ContractSignedDate | moment: \'format\': \'MM/DD/YYYY\'}}</span> <span ng-show=!vendorData.editable ng-if="vendorData.ContractSignedDate===null"></span> <input class="form-control form-control-sm datepicker" size=6 ng-model=vendorData.ContractSignedDate placeholder="" ng-show=vendorData.editable name=ContractSignedDate> <small ng-if=vendorDetailsForm.ContractSignedDate.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td class=text-center><span ng-show=!vendorData.editable>{{vendorData.InvMethodValue}}</span> <select id=InvMethod class="form-control form-control-sm" ng-show=vendorData.editable ng-model=vendorData.InvMethod required name=InvMethod><option ng-value=lookup.InvoiceMethodId ng-repeat="lookup in lookups.lstInvType">{{lookup.Type}}</option></select> <small ng-if=vendorDetailsForm.InvMethod.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td class=text-center><span ng-show=!vendorData.editable>{{vendorData.InvoiceTermValue}}</span> <select id=InvoiceTerm class="form-control form-control-sm" ng-show=vendorData.editable ng-model=vendorData.InvoiceTerm required name=InvoiceTerm><option ng-value=lookup.InvTermId ng-repeat="lookup in lookups.lstInvTerm">{{lookup.Term}}</option></select> <small ng-if=vendorDetailsForm.InvoiceTerm.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td><td class=text-center><span ng-show=!vendorData.editable ng-if="vendorData.PayTermValue !==1001 && vendorData.PayTermValue !==1002">{{vendorData.PayTermValue}}</span> <span ng-show=!vendorData.editable ng-if="vendorData.PayTermValue ===1001">Pay When Paid</span> <span ng-show=!vendorData.editable ng-if="vendorData.PayTermValue ===1002">As per Payment Schedule</span> <select id=PayTerm class="form-control form-control-sm" ng-model=vendorData.PayTerm ng-show=vendorData.editable required name=PayTerm><option ng-repeat="lookup in lookups.lstPayTerm | orderBy: \'Term\'" ng-value=lookup.PayTermId ng-if="lookup.Term !== 1001 && lookup.Term !== 1002">{{lookup.Term}}</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1001">Pay When Paid</option><option ng-repeat="lookup in lookups.lstPayTerm" ng-value=lookup.PayTermId ng-if="lookup.Term === 1002">As Per Payment Schedule</option></select> <small ng-if=vendorDetailsForm.PayTerm.$invalid&&vendorDetailsForm.$submitted class=text-danger>* required</small></td></tr></tbody></table></div></div><div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 row"><div class=col><label class="text-info font-weight-bolder">Instructions:</label><p ng-show=!vendorData.editable style="overflow: auto;max-height: 60px;">{{vendorData.Instructions}}</p><textarea ng-model=vendorData.Instructions ng-show=vendorData.editable class=form-control></textarea></div></div></div></form><div class=d-flex><div class="col-5 p-0 mt-3"><div class=card><div class="card-header d-flex justify-content-between align-items-center"><h4>Addresses</h4><button type=button class="btn btn-primary btn-sm rounded-circle" ng-show=!showAddNewAddrForm data-toggle=tooltip data-placement=top title="Add New Address" ng-click=addnewAddrForm()><i class="fas fa-plus"></i></button></div><div class=card-body><table width=100% border=1 cellpadding=4 cellspacing=0><thead class="bg-info text-white font-weight-bold"><tr><td>Street</td><td>City</td><td>State</td><td>Country</td><td>Zipcode</td><td>Edit</td><td>Contacts</td></tr></thead><tbody><tr ng-repeat="VendorAdd in vendorData.VendorAddressInfo track by $index"><td>{{VendorAdd.Street}}</td><td>{{VendorAdd.City}}</td><td>{{VendorAdd.State}}</td><td>{{VendorAdd.Country}}</td><td>{{VendorAdd.Zipcode}}</td><td><i class="fas fa-pen ml-2 text-success pointer" style="font-size: 13px;" ng-click=editVendorAddr($index,VendorAdd)></i></td><td><i class="fas fa-eye ml-2 text-info pointer" style="font-size: 18px;" ng-click="getVenConts(VendorAdd, $index)"></i></td></tr></tbody></table><ci-spinner ng-if=showAddNewAddrFormLaoder></ci-spinner><form name=newVendorAddrForm ng-submit=editVendorAddrSub(newVendorAddrForm,UVendorAdd) ng-if=showAddNewAddrForm><div><p class=font-weight-bold ng-if=UVendorAdd.AddrId>Edit Vendor Address</p><p class=font-weight-bold ng-if=!UVendorAdd.AddrId>Add New Vendor Address</p><div class="w-100 d-flex flex-column bg-dark text-white p-1" ng-if="UVendorAdd.AddrId&&UVendorAdd.PrevAddr!==null&&UVendorAdd.PrevAddr!==\'\'"><small class=text-warning>FYI: Previously address was saved as below for this vendor.</small> {{UVendorAdd.PrevAddr}}</div><div class="form-group row"><label class="col-sm-2 col-form-label">Street</label><div class=col-sm-10><input type=text class="form-control form-control-sm" placeholder="1234 Main St" required ng-model=UVendorAdd.Street></div></div><div class="form-group row"><label class="col-sm-2 col-form-label">City</label><div class=col-sm-10><input type=text only-letters-input class="form-control form-control-sm" required placeholder=City ng-model=UVendorAdd.City></div></div><div class="form-group row"><label class="col-sm-2 col-form-label">State</label><div class=col-sm-10><select class="form-control form-control-sm" required ng-model=UVendorAdd.State><option value="">Choose...</option><option ng-repeat="state in states" value={{state.abbreviation}}>{{state.abbreviation}}</option></select></div></div><div class="form-group row"><label class="col-sm-2 col-form-label">Country</label><div class=col-sm-10><!-- <input type="text" only-letters-input class="form-control form-control-sm" required placeholder="Country"\r\n                        ng-model="UVendorAdd.Country"> --> <select class="form-control form-control-sm mr-1" required name=Country ng-model=UVendorAdd.Country><option value="">Choose...</option><option value=USA>USA</option></select></div></div><div class="form-group row"><label class="col-sm-2 col-form-label">Zipcode</label><div class=col-sm-10><input type=text only-numbers-input class="form-control form-control-sm" required placeholder=Zipcode ng-model=UVendorAdd.Zipcode maxlength=5></div></div><div class="form-group row"><button type=button class="btn btn-default btn-sm" ng-click=addnewAddrFormCancel(newVendorAddrForm) ng-show=!editVendorAddrSubLoader>Cancel</button> <button type=submit class="btn btn-primary btn-sm" ng-show=!editVendorAddrSubLoader>Submit</button><div class="text-center w-100"><ci-spinner ng-show=editVendorAddrSubLoader></ci-spinner></div></div></div></form></div></div></div><div class="col-7 mt-3" ng-if=ViewConts><div class=card><div class=card-header><div class="d-flex justify-content-between"><h4>Contacts</h4><button class="btn btn-success btn-sm" ng-click=AddNewVendorAct() data-toggle=tooltip data-placement=top title="Add New Contact">Add New</button></div></div><div class=card-body><div class="d-flex justify-content-center" ng-if=ViewContsLoader><ci-spinner></ci-spinner></div><form name=contactsForm ng-if="!ViewContsLoader && !AddNewVendorActShow"><table class="table table-dark mt-3"><thead><tr><th>#</th><th>Designation</th><th>Contact Person</th><th>Email</th><th>Phone Number/Extn</th><th>Action</th></tr></thead><tbody><tr ng-repeat="VenCont in vendorData.VendorAddressInfo[selectedVendorAddrIndex].VendorAcctInfo track by $index"><td>{{$index+1}}</td><td><span ng-if=!VenCont.editable>{{VenCont.DesignationValue}}</span> <select class="form-control form-control-sm rounded-0 border border-dark" required alt="Select a Designation" ng-model=VenCont.Designation ng-if=VenCont.editable><option value="">Select Designation...</option><option ng-repeat="lookup in lookups.lstAcctType" ng-value=lookup.DesgId>{{lookup.Type}}</option></select></td><td><span ng-if=!VenCont.editable>{{VenCont.ContactName}}</span> <input type=text only-letters-input ng-if=VenCont.editable required class="form-control form-control-sm rounded-0 border border-dark" placeholder=Name ng-model=VenCont.ContactName></td><td><span ng-if=!VenCont.editable>{{VenCont.AcctEmail}}</span> <input type=text ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ ng-if=VenCont.editable required class="form-control form-control-sm rounded-0 border" name=AcctEmail{{$index}} placeholder=Email ng-model=VenCont.AcctEmail ng-class="contactsForm.AcctEmail{{$index}}.$error.pattern?\'border-danger\':\'\'"> <small class=text-danger ng-show=contactsForm.AcctEmail{{$index}}.$error.pattern>Invalid Email</small></td><td><span ng-if=!VenCont.editable>{{VenCont.PhoneNumber}}</span><div class="d-flex border-0"><input type=text ng-if=VenCont.editable required only-numbers-input class="form-control form-control-sm rounded-0 border border-dark" name=PhoneNumber{{$index}} placeholder="Phone Number" ng-model=VenCont.PhoneNumber> <input type=text ng-if=VenCont.editable only-numbers-input class="form-control form-control-sm rounded-0 border border-dark" placeholder=Extn ng-model=VenCont.Extn style=width:50px;></div><small class=text-danger ng-show=contactsForm.PhoneNumber{{$index}}.$error.pattern>Invalid Phone Number</small> <small class=text-danger ng-show=contactsForm.PhoneNumber{{$index}}.$error.minlength>Invalid Phone Number</small> <small class=text-danger ng-show=contactsForm.PhoneNumber{{$index}}.$error.maxlength>Invalid Phone Number</small></td><td><i class="fas fa-pen mr-2 text-danger pointer" ng-click=editvendorAct($index,VenCont) ng-if=!VenCont.editable></i><div class="d-inline-flex pt-2" ng-show=VenCont.editable><i class="fas fa-times mr-2 text-danger pointer" ng-click=editvendorActCancel($index,VenCont) ng-if=VenCont.editable></i> <button type=submit class="btn btn-default m-0 p-0" style="top: -6px;position: relative;" ng-click="contactsForm.$valid && vendorActInfoSub(VenCont)"><i class="fas fa-check mr-2 text-success pointer"></i></button></div></td></tr></tbody></table></form><form name=newVendorActForm ng-submit=newVendorActSub(newVendorActForm,newVendorAct) ng-if=AddNewVendorActShow><div class="card p-3 mt-1"><div class="form-group row"><label class="col-sm-2 col-form-label">Designation</label><div class=col-sm-10><select class="form-control form-control-sm" required alt="Select a Designation" ng-model=newVendorAct.Designation><option value="">Select Designation...</option><option ng-repeat="lookup in lookups.lstAcctType" ng-value=lookup.DesgId>{{lookup.Type}}</option></select></div></div><div class="form-group row"><label class="col-sm-2 col-form-label">Contact Name</label><div class=col-sm-10><input type=text only-letters-input class="form-control form-control-sm" placeholder=Name ng-model=newVendorAct.ContactName required></div></div><div class="form-group row"><label class="col-sm-2 col-form-label">Contact Email</label><div class=col-sm-10><input type=email class="form-control form-control-sm" placeholder=Email ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ ng-model=newVendorAct.AcctEmail required></div></div><div class="form-group row"><label class="col-sm-2 col-form-label">Phone</label><div class="col-sm-10 d-flex"><input type=text only-numbers-input class="form-control form-control-sm" placeholder="Phone Number" ng-model=newVendorAct.PhoneNumber required maxlength=20> <input type=text class="form-control form-control-sm rounded-0" placeholder=Extn ng-model=newVendorAct.Extn style=width:50px;></div></div><div class="form-group row"><button type=button class="btn btn-default btn-sm" ng-click=newVendorActCancel()>Cancel</button> <button type=submit class="btn btn-primary btn-sm">Submit</button></div></div></form></div></div></div></div><div class=bg-white><table class="mt-3 w-100" border=1 cellpadding=3><thead class=table-dark><tr><th>#</th><th>Doc Type</th><th>Upload</th><th>Created</th></tr></thead><tbody><tr ng-repeat="doc in vendorData.VendorDocumentModel track by $index"><td>{{$index+1}}</td><td>{{doc.DocName}}</td><td><a href="" ng-click=getDoc(doc)>{{doc.DocUrl}}</a></td><td>{{doc.UploadDate | moment:\'format\':"MM/DD/YYYY"}}</td></tr></tbody><tfoot><tr><td colspan=4><div class="d-flex align-items-center" ng-if=!uploadLoader><select ng-model=selectedDocType class="ml-2 col-3 form-control form-control-sm" ng-change=selDocChange()><option ng-value=item.Id ng-repeat="item in lookups.lstVdocType">{{item.Type}}</option></select> <label for=file class="text-primary d-flex p-0 float-left text-left align-items-center pt-1 ml-3 pointer" data-toggle=tooltip data-placement=top title="Select File"><i class="fas fa-upload mr-1"></i>Select File <input type=file id=file accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf" onchange=angular.element(this).scope().getFileDetails(this) required class=col-4 style="display: none;"></label> <span class="float-left ml-4 text-primary">{{files[0].name}}</span><!-- <span class="mr-1">{{files[0].name}}</span> --><div class="alert alert-danger p-1" ng-if="(a===undefined||null) && files===undefined">Please select Document Type and upload file.</div><div class="alert alert-danger p-1" ng-if="(selectedDocType===undefined||null) && files!==undefined">Please select Document Type.</div><div class="alert alert-danger p-1" ng-if="(files===undefined||files.length==0)&&selectedDocType!==undefined">Please upload file.</div><button class="btn btn-sm btn-primary ml-4" type=button ng-click=uploadDoc(selectedDocType) ng-if="files.length>0 && (selectedDocType!==undefined||null)">Upload</button></div><ci-spinner class=small ng-if=uploadLoader></ci-spinner></td></tr></tfoot></table></div></div></div></div><div class="modal fade text-warning" id=invalidFileTypeAlertDiv tabindex=-1 role=dialog aria-labelledby=exampleModalCenterTitle aria-hidden=true><div class="modal-dialog modal-dialog-centered" role=document><div class="modal-content bg-danger"><div class=modal-body><h3>Invalid Filetype</h3>Only MsWord and PDF file types are allowed.</div><div class="modal-footer p-0 border-warning"><button type=button class="btn btn-warning" data-dismiss=modal>Ok</button></div></div></div></div><div class="modal fade" id=nofileErrModal><div class=modal-dialog><div class=modal-content><div class=modal-header><h5 class=modal-title id=exampleModalLabel>Modal title</h5><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body>...</div><div class=modal-footer><button type=button class="btn btn-secondary" data-dismiss=modal>Close</button> <button type=button class="btn btn-primary">Save changes</button></div></div></div></div>');
$templateCache.put('app/components/hr/vendors/vendors.html','<div class="container-fluid p-0"><div class=d-flex><div class="d-flex align-items-center justify-content-center w-100 p-0 heightCanBe" ng-show=pageLoading><ci-spinner class=loginLoader></ci-spinner></div><div class="col-12 p-0" ng-show=!pageLoading><div class="d-flex flex-lg-row flex-sm-column"><div class="card bg-white w-100 rounded-0 border-right border-top-0 border-left-0"><div class=card-body ng-if=NoVendors><div class="alert alert-info m-4">No Vendors found. <a ui-sref=adminaddvendor ng-if="role === \'Admin\'"><u>Click here</u></a><a ui-sref=adminaddvendor ng-if="role === \'HR\'"><u>Click here</u></a> to add new Client.</div></div><div class=card-body ng-if=!NoVendors><div class=d-flex><input type=text ng-model=searchText placeholder="Search a Vendor.." class="form-control mr-1 col"> <button class="btn btn-sm btn-success" ui-sref=addvendor ng-if="role === \'HR\'">Add New</button> <button class="btn btn-sm btn-success" ui-sref=adminaddvendor ng-if="role === \'Admin\'">Add New</button></div><ul id=og-grid class="og-grid d-flex flex-wrap"><li ng-repeat="Vendor in Vendors | filter:searchText track by $index" ng-class="Vendor.showControls?\'viewWrap og-expanded\':\'\'"><a href="" class="item p-3 h4 border pointer" ui-sref=vendorDetails({id:Vendor.VendorId}) ng-if="role === \'HR\'"><span class=col-3>{{Vendor.VendorName}}</span> </a><a href="" class="item p-3 h4 border pointer" ui-sref=adminvendorDetails({id:Vendor.VendorId}) ng-if="role === \'Admin\'"><span class=col-3>{{Vendor.VendorName}}</span></a></li></ul></div></div></div></div></div></div><div class="likePage heightCanBe" ng-show=addNewVendorShow><form class="card h-100" name=myform ng-submit="myform.$valid && addVendor(newVendor)" novalidate><div class=card-header>Add New Vendor</div><div class="card-body row" style="overflow: auto;"><div class="col-6 pr-1"><h4 class=text-primary>Identity/Payment details</h4><div class="col-12 d-flex align-items-start"><div class="col-4 px-0"><div class="form-group col px-1 mb-0"><label for=VendorName>Vendor Name</label> <input type=text class="form-control form-control-sm" name=VendorName placeholder="Vendor Name" ng-model=newVendor.VendorName required> <span class=error ng-show="myform.newVendor.VendorName.$invalid && myform.newVendor.VendorName.$touched && myform.newVendor.VendorName.$error.required">Enter Vendor Name</span></div><div class="form-group col px-1 mb-0"><label for=InvMethod>Inv Method</label> <select class="form-control form-control-sm" placeholder="Inv Method" ng-model=newVendor.InvMethod required><option value=1>Fax</option><option value=2>Email</option><option value=1>Mail</option></select></div></div><div class="col-4 px-0"><div class="form-group col px-1 mb-0"><label for=FedId>Fedaral Id</label> <input type=number class="form-control form-control-sm" placeholder="Fedaral Id" ng-model=newVendor.FedId pattern=^\\d{9}$> <span class=error ng-show="myform.newFedId.FedId.$invalid && myform.newFedId.FedId.$touched && myform.newFedId.FedId.$error.pattern">Enter Fax Number</span></div><div class="form-group col px-1 mb-0"><label for=InvoiceTerm>Invoice Term</label> <select class="form-control form-control-sm" placeholder="Invoice Term" ng-model=newVendor.InvoiceTerm required><option value=1>Weekly</option><option value=2>Bi-Weekly</option><option value=3>Monthly</option><option value=4>Bi-Monthly</option><option value=5>Half-yearly</option><option value=6>Yearly</option></select></div></div><div class="col-4 px-0"><div class="form-group col px-1 mb-0"><label for=Fax>Fax</label> <input type=number class="form-control form-control-sm" placeholder=Fax ng-model=newVendor.Fax pattern=^[0][1-9]\\d{9}$|^[1-9]\\d{9}$> <span class=error ng-show="myform.newFax.Fax.$invalid && myform.newFax.Fax.$touched && myform.newFax.Fax.$error.pattern">Enter Fax Number</span></div><div class="form-group col px-1 mb-0"><label for=PayTerm>Pay Term</label> <input type=text class="form-control form-control-sm" placeholder="Pay Term" ng-model=newVendor.PayTerm required></div></div></div><h4 class=text-primary>Addenda</h4><div class="col-12 d-flex align-items-start"><div class="form-group col-4 px-1 mb-0"><label for=AddendaInPlace>In Place</label><div class="d-flex align-items-center"><input type=radio class=mr-2 placeholder="Addenda In Place" ng-model=newVendor.AddendaInPlace required ng-value=true> Yes <input type=radio class="mr-2 ml-2" placeholder="Addenda In Place" ng-model=newVendor.AddendaInPlace required ng-value=false> No</div></div><div class="form-group col-4 px-1 mb-0"><label for=AddendaPointsCovered>Points Covered</label><div class="d-flex align-items-center"><input type=radio class=mr-2 placeholder="Addenda Points Covered" ng-model=newVendor.AddendaPointsCovered required ng-value=true> Yes <input type=radio class="mr-2 ml-2" placeholder="Addenda Points Covered" ng-model=newVendor.AddendaPointsCovered required ng-value=false> No</div></div><div class="form-group col-4 px-1 mb-0"><label for=AddendaSigDate>Sign Date</label> <input type=date class="form-control form-control-sm" placeholder="Addenda SigDate" ng-model=newVendor.AddendaSigDate required></div></div><h4 class=text-primary>Contract</h4><div class="col-12 d-flex align-items-start"><div class="form-group col-4 px-1 mb-0"><label for=ContractInPlace>In Place</label><div class="d-flex align-items-center"><input type=radio class=mr-2 ng-model=newVendor.ContractInPlace required ng-value=true> Yes <input type=radio class="mr-2 ml-2" ng-model=newVendor.ContractInPlace required ng-value=false> No</div></div><div class="form-group col-4 px-1 mb-0"><label for=ContractSignedDate>Sign Date</label> <input type=date class="form-control form-control-sm" placeholder="Contract Signed Date" ng-model=newVendor.ContractSignedDate required></div></div><h4 class=text-primary>Instructions</h4><div class="col-12 align-self-start"><div class="form-group col px-1 mb-0"><textarea class="form-control form-control-sm" placeholder=Instructions ng-model=newVendor.Instructions></textarea></div></div></div><div class="col-6 pl-1"><h4 class=text-primary>Address details</h4><div class="col-12 row pl-2"><div class="form-group col-4 px-1 mb-0"><label for=Street>Street</label> <input type=text class="form-control form-control-sm" placeholder=Street ng-model=newVendor.VendorAddressInfo[0].Street required></div><div class="form-group col-4 px-1 mb-0"><label for=City>City</label> <input type=text class="form-control form-control-sm" placeholder=City ng-model=newVendor.VendorAddressInfo[0].City required></div><div class="form-group col-4 px-1 mb-0"><label for=State>State</label> <select class="form-control form-control-sm" required ng-model=newVendor.VendorAddressInfo[0].State><option value="">Choose...</option><option ng-repeat="state in states" value={{state.abbreviation}}>{{state.abbreviation}}</option></select></div><div class="form-group col-4 px-1 mb-0"><label for=Country>Country</label><!-- <input type="text" class="form-control form-control-sm" placeholder="Country" ng-model="newVendor.VendorAddressInfo[0].Country"\r\n            required="required"> --> <select class="form-control form-control-sm mr-1" required name=Country ng-model=newVendor.VendorAddressInfo[0].Country><option value="">Choose...</option><option value=USA>USA</option></select></div><div class="form-group col-4 px-1 mb-0"><label for=Zipcode>Zip code</label> <input type=number class="form-control form-control-sm" placeholder="Zip code" ng-model=newVendor.VendorAddressInfo[0].Zipcode required pattern=^[0-9]{5}$> <span class=error ng-show="myform.newZipCode.Zipcode.$invalid && myform.newZipCode.Zipcode.$touched && myform.newZipCode.Zipcode.$error.pattern">Enter valid phone number</span></div></div><h4 class=text-primary>Add Contacts</h4><div class=col-12><table class="table table-dark mt-3" ng-if=!ViewContsLoader><thead><tr><th>Designation</th><th>Contact Person</th><th>Email</th><th>Phone Number</th><th>Action</th></tr></thead><tbody><tr ng-repeat="VenCont in newVendor.VendorAddressInfo[0].VendorAcctInfo track by $index"><td><span ng-if=!VenCont.editable>{{VenCont.Designation}}</span> <select class="form-control form-control-sm rounded-0 border border-dark" required alt="Select a Designation" ng-model=VenCont.Designation ng-if=VenCont.editable><option value="">Select Designation...</option><option ng-repeat="lookup in lookups.lstAcctType" ng-value=lookup.DesgId>{{lookup.Type}}</option></select></td><td><span ng-if=!VenCont.editable>{{VenCont.ContactName}}</span> <input type=text ng-if=VenCont.editable class="form-control form-control-sm rounded-0 border border-dark" placeholder=Name ng-model=VenCont.ContactName></td><td><span ng-if=!VenCont.editable>{{VenCont.AcctEmail}}</span> <input type=text ng-if=VenCont.editable class="form-control form-control-sm rounded-0 border border-dark" placeholder=Email ng-model=VenCont.AcctEmail></td><td><span ng-if=!VenCont.editable>{{VenCont.PhoneNumber}}</span> <input type=text ng-if=VenCont.editable only-numbers-input class="form-control form-control-sm rounded-0 border border-dark" placeholder="Phone Number" ng-model=VenCont.PhoneNumber> <input type=text ng-if=VenCont.editable class="form-control form-control-sm rounded-0 border border-dark" placeholder="Phone Number" ng-model=VenCont.Extn></td><td><i class="fa fa-times mr-2 text-danger pointer" ng-click=editvendorActCancel($index,VenCont) ng-if=VenCont.editable></i></td></tr><tr><td colspan=6><button class="btn btn-sm btn-success" type=button ng-click=newContact()>Add New Contact</button></td></tr></tbody></table><div class="alert alert-info" ng-if="">Email & Phone number should not be empty.</div></div></div></div><div class=card-footer><button class="btn btn-default">Cancel</button> <button ng-disabled=myform.$invalid name=submit type=submit class="btn btn-success">Submit</button></div></form><style>.vendorListActive {\r\n      border-left: 4px solid #453;\r\n    }\r\n\r\n    input.ng-invalid.ng-touched {\r\n      border: 2px solid red;\r\n    }\r\n\r\n    .error {\r\n      color: red;\r\n    }</style></div>');
$templateCache.put('app/components/president/consByClient/consByClient.html','<div class="container-fluid mb-5"><div layout="column pb-5"><div class="card mt-4 col-12 p-0"><div class=card-header><div class="d-flex justify-content-between align-items-center"><h4 class="col-6 pt-3">Placements By Clients <span class="badge badge-pill badge-primary ml-3">{{clientPlacements.length}}</span></h4><input type=text ng-model=search class=form-control placeholder="Search Placements By Clients"></div></div><div class=card-body><ul class="d-flex flex-wrap p-0 m-0"><li class="p-3 border pointer d-flex align-items-center" ng-repeat="placement in clientPlacements | filter : search track by $index" ng-click=viewClientList(placement) style="max-width: 300px; min-width: 300px;position: relative;min-height: 85px;" ng-mouseenter="hovering=true" ng-mouseleave="hovering=false" ng-class="{\'border\':$index === clientPlacements.length-1, \'border-top border-left\':$index !== clientPlacements.length-1, \'bg-light text-primary\':hovering}"><h6>{{placement.ClientName}}</h6><div style="position: absolute;bottom: 5px; right: 5px;" class="d-flex align-items-center"><span class="badge badge-pill badge-secondary mr-2">{{placement.PlacementCount}}</span></div></li></ul><!-- <table class="table" id="clientPlacements">\r\n                    <thead>\r\n                        <tr>\r\n                            <td>Vendor</td>\r\n                            <td>Count</td>\r\n                            <td>View</td>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr ng-repeat="placement in clientPlacements">\r\n                            <td>{{placement.ClientName}}</td>\r\n                            <td><span class="badge badge-pill badge-success">{{placement.PlacementCount}}</span>\r\n                            </td>\r\n                            <td><i class="material-icons pointer" ng-click="viewClientList(placement)">list</i>\r\n                            </td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table> --></div></div></div></div>');
$templateCache.put('app/components/president/consByClient/viewConsbyClients.html','<md-dialog aria-label="Vendor Consultants Details" flex=80><md-toolbar><div class=md-toolbar-tools><span class="badge badge-pill badge-light">{{user.VendorName}}</span> Consultants Details <span class="badge badge-pill badge-primary ml-2">{{user.PlacementCount}}</span></div></md-toolbar><md-dialog-content class=m-4><div class=table><table id=clientConsList class=w-100><thead><tr><th style="width: 20px;">#</th><th>Employee Name</th></tr></thead><tbody><tr ng-repeat="user in user.lstConslDetails track by $index"><td style="width: 20px;">{{$index+1}}</td><td>{{user.EmployeeDisplayName}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel()>Close</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/components/president/consByVendor/consByVendor.html','<div class="container-fluid mb-5"><div layout="column pb-5"><div class="card mt-4 col p-0"><div class=card-header><div class="d-flex justify-content-between align-items-center"><h4 class="col-6 pt-3">Placements By Vendor<span class="badge badge-pill badge-primary ml-3">{{vendorPlacements.length}}</span></h4><input type=text ng-model=search class=form-control placeholder="Search Vendor"></div></div><div class=card-body><ul class="d-flex flex-wrap p-0 m-0"><li class="p-3 border pointer d-flex align-items-center" ng-repeat="placement in vendorPlacements | filter : search  track by $index" ng-click=viewVendorList(placement) style="max-width: 300px; min-width: 300px;position: relative;min-height: 85px;" ng-mouseenter="hovering=true" ng-mouseleave="hovering=false" ng-class="{\'border\':$index === vendorPlacements.length-1, \'border-top border-left\':$index !== vendorPlacements.length-1, \'bg-light text-primary\':hovering}"><h6>{{placement.VendorName}}</h6><div style="position: absolute;bottom: 5px; right: 5px;" class="d-flex align-items-center"><span class="badge badge-pill badge-secondary mr-2">{{placement.PlacementCount}}</span></div></li></ul></div></div></div></div>');
$templateCache.put('app/components/president/consByVendor/viewVendorList.html','<md-dialog aria-label="Vendor Consultants Details" flex=80><md-toolbar><div class=md-toolbar-tools><h4>Consultants in <span class="badge badge-pill badge-success">{{user.VendorName}}</span> <span class="badge badge-pill badge-primary">{{user.PlacementCount}}</span></h4></div></md-toolbar><md-dialog-content class=m-4><div class="table table-responsive"><table id=vendorConsList class=w-100><thead><tr><th style="width: 20px;">#</th><th>Employee Name</th><th>Client</th></tr></thead><tbody><tr ng-repeat="user in user.lstConslDetails track by $index"><td style="width: 20px;">{{$index+1}}</td><td>{{user.EmployeeDisplayName}}</td><td>{{user.ClientName}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel()>Close</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/components/president/dashboard/president.html','<div class="container-fluid pb-5" style="background: rgb(114,154,180); background: linear-gradient(90deg, rgba(224, 234, 241,\r\n    0.7469362745098039) 0%, rgb(234, 238,  243) 50%, rgba(224, 234, 240, 0.7497373949579832) 100%)" ;><div layout="column pb-5"><div class=container-fluid><div class=row><div class="col-sm-1 pt-4" ng-if=!isMobile></div><div class="col-sm-2 col-md-6 col-lg-2 pt-4"><div class="card text-white m-1" style="background-color: #4c5d7b;"><div class="card-body text-center p-1" layout=column><h3 show-gt-md hide-gt-sm hide-xs>W2</h3><h6 show-sm hide-gt-md>W2</h6><p class=display-4>{{counts.ActiveUsers}}</p></div></div></div><div class="col-sm-2 col-md-6 col-lg-2 pt-4"><div class="card text-white m-1" style="background-color: #285092;"><div class="card-body text-center p-1"><h3 show-gt-md hide-gt-sm hide-xs>Inactive</h3><h6 show-sm hide-gt-md>Inactive</h6><p class=display-4>{{counts.InactiveUsers}}</p></div></div></div><div class="col-sm-2 col-md-6 col-lg-2 pt-4"><div class="card text-white m-1" style="background-color: #3c62a7;"><div class="card-body text-center p-1"><h3 show-gt-md hide-gt-sm hide-xs>Vendors</h3><h6 show-sm hide-gt-md>Vendors</h6><p class=display-4>{{counts.ActiveVendors}}</p></div></div></div><div class="col-sm-2 col-md-6 col-lg-2 pt-4"><div class="card text-white m-1" style="background-color: #81a7ea;"><div class="card-body text-center p-1"><h3 show-gt-md hide-gt-sm hide-xs>Clients</h3><h6 show-sm hide-gt-md>Clients</h6><p class=display-4>{{counts.ActiveClients}}</p></div></div></div><!-- <div class="col-sm-2 col-md-6 col-lg-2 pt-4">\r\n                    <div class="card text-white m-1" style="background-color: #5d96ff;">\r\n                        <div class="card-body text-center p-1">\r\n                            <h3 show-gt-md hide-gt-sm hide-xs>Backoffice</h3>\r\n                            <h6 show-sm hide-gt-md>Backoffice</h6>\r\n                            <p class="display-4">{{counts.BackOfficeEmployees}}</p>\r\n                        </div>\r\n                    </div>\r\n                </div> --><div class="col-sm-1 pt-4" ng-if=!isMobile></div></div><div class="row justify-content-md-center"><div class="col-sm-8 pt-4"><div class=card><div class=card-header>Active Conslutants By Pay Rate Range</div><div class=card-body><canvas id=bar class="chart chart-bar" chart-data=ActiveConslByPayRateRangedata chart-labels=ActiveConslByPayRateRangelabels chart-click=onClick></canvas></div><!-- <div class="card-footer text-muted">\r\n                                2 days ago\r\n                            </div> --></div></div></div></div></div></div>');
$templateCache.put('app/components/sales/inDB/inDB.component.html','<div class="container-fluid p-0"><md-content><nav class="navbar navbar-expand-lg navbar-light bg-light"><button class=navbar-toggler type=button data-toggle=collapse data-target=#navbarNavAltMarkup aria-controls=navbarNavAltMarkup aria-expanded=false aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div class="collapse navbar-collapse" id=navbarNavAltMarkup><div class="navbar-nav d-flex align-items-center"><button type=button class="btn btn-sm btn-primary ml-3 font-weight-normal" disabled ui-sref=internalDb()>Internal DB</button> <button type=button class="btn btn-sm btn-danger ml-3 font-weight-normal" ui-sref=talentSearch()>Search Dice</button></div><div flex></div><div class="d-flex justify-content-end p-0"><button type=button class="btn btn-outline-danger d-flex text-dark mr-2" ng-click="allConsGroupBy(\'\')"><span style="font-weight: normal; color: #000;">Clear</span> <i class="material-icons text-danger" style="font-size: 14px; padding-left: 4px;line-height: 19px;">close</i></button> <input type=text placeholder="Search Internal DB" ng-model=searchData ng-keyup=allConsSearch(searchData) class="form-control col-sm-6" style="min-width: 480px;"><md-menu md-position-mode="target-right target"><md-button aria-label="Group By" class="md-icon-button md-button-no-height" ng-click=$mdMenu.open($event)><i class="material-icons pointer zoom pt-1">more_vert</i></md-button><md-menu-content width=4><md-menu-item ng-repeat="item in groupByObj"><md-button ng-click=allConsGroupBy(item.value)><div layout=row flex><p flex>{{item.name}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></nav><div class="container-fluid h-100"><ci-spinner class=loginLoader ng-if=preloader></ci-spinner><div id=allCons-table ng-show=!preloader></div></div></md-content></div>');
$templateCache.put('app/components/president/w2users/w2users.html','<div class="container-fluid mb-5"><div layout="column pb-5"><div class="card mt-4 col p-0"><div class=card-header><div class="d-flex justify-content-between align-items-center"><h4 class="col-6 pt-3">W2 Users <span class="badge badge-pill badge-primary ml-3">{{w2UsersList.length}}</span></h4><input type=text ng-model=search class=form-control placeholder="Search W2 users"></div></div><div class=card-body><ul class="d-flex flex-wrap p-0 m-0"><li class="p-3 border pointer d-flex align-items-center" ng-repeat="user in w2UsersList | filter : search track by $index" style="max-width: 300px; min-width: 300px;position: relative;min-height: 85px;" ng-mouseenter="hovering=true" ng-mouseleave="hovering=false" ng-class="{\'border\':$index === vendorPlacements.length-1, \'border-top border-left\':$index !== vendorPlacements.length-1, \'bg-light text-primary\':hovering}"><h6>{{user}}</h6></li></ul></div></div></div></div>');
$templateCache.put('app/components/sales/dashboard/Marketer.dashboard.html','<div class=container id=marketer-dashboard><div class="row justify-content-center"><div class=col-8><ul class=row ng-class="isMobile?\'h-100\':\'\'"><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=marketer()><img src=../../../../images/extra3.png alt=Interviews class=grow><br><span>Interviews</span></li><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=myResources()><img src=../../../../images/extra2.png alt=Consultants class=grow><br><span>Consultants</span></li><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=talentSearch()><img src=../../../../images/talentSearch.png alt="Talent Search" class=grow><br><span>Talent Search</span></li><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=massMail()><img src=../../../../images/massEmail.png alt="Bulk Email" class=grow><br><span>Bulk email</span></li><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=jobposting()><img src=../../../../images/jobPostings.png alt="Job Posting" class=grow><br><span>Job Posting</span></li><li class="col-lg-4 col-sm-2 col-md-4 col-xs-2" ui-sref=timesheets()><img src=../../../../images/interviewScheduler.png alt="Job Posting" class=grow><br><span>Timesheets</span></li></ul></div></div><div class="text-center row justify-content-center"><div class=col-8><blockquote class=brooks>{{quote.quote}}</blockquote><span>{{quote.author}}</span></div></div></div>');
$templateCache.put('app/components/sales/jobpostings/addCommentsDialog.html','<md-dialog aria-label="Add Comments"><form name=addCommentsFormName ng-submit="addCommentsFormName.$valid && addComments(comments, \'type\')"><md-toolbar><div class=md-toolbar-tools><h2>Add Notes</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class="material-icons text-danger pl-1 pr-1" style="font-weight: 400;">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-group><label for=comments>Add Notes to Job Applicant {{appName}} - {{JobId}}</label> <textarea class=form-control id=comments rows=3 ng-model=comments required></textarea></div></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=cancel()>Cancel</md-button><md-button type=submit>Submit</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/sales/jobpostings/JobPostings.tpl.html','<div class=container-fluid><div class=row><div class=col-12><md-tabs md-dynamic-height md-border-bottom md-selected=JPSelectedTab class=p-0><md-tab label="Active Jobs"><div class=row ng-hide=addPosting><div class="mt-2 col-sm-12 col-md-7 col-lg-7"><table class="table table-hover noSort" id=ActiveJobs><thead><tr><th class=p-1>#</th><th class=p-1>Job Id</th><th class=p-1 style="width: 130px;">Position</th><th class=p-1 style="width: 160px;">Client</th><th class=p-1>Location</th><th class=p-1>Interview</th><th class=p-1>Duration</th><th class=p-1>Rate</th><th class=p-1>W2 Rate</th><th class="p-1 text-center" style="width: 95px;">Actions</th></tr></thead><tbody><tr ng-repeat="job in ActiveJobs | filter:query track by $index"><td class="pl-0 p-1">{{$index+1}}</td><td class="pl-0 p-1" style=width:65px><div class=d-flex><!-- <button data-tippy-content="{{job.JApplyModel.Comments[0].comment}}" class="tippyButton"> --> <button data-template=d{{$index}} class=tippyButton><img src=../../../images/comments.png alt=Comments ng-click="addJAComment(job,\'jobid\')"></button> <span>{{job.JIDModel.JobId}}</span></div><div style="display: none;"><div id=d{{$index}}><div class="d-flex flex-column" ng-repeat="comment in job.JApplyModel.Comments" style=min-width:280px;padding:10px;><div class=d-flex><span class=text-muted>{{comment.author }} &nbsp;| &nbsp;</span> <span class=text-muted>&nbsp;{{ comment.time | moment: \'format\': \'MM/DD/YYYY\'}}</span></div><p class=text-left>{{comment.comment}}</p><hr class=m-1></div></div></div></td><td class="pl-0 p-1" style=width:100px><span class="badge badge-pill badge-secondary ml-2">{{job.AppCount}}</span>{{job.skill.Skill}}</td><td class="pl-0 p-1 tippyButton" data-tippy-content={{job.client.ClientName}}>{{job.client.ClientName | limitTo:12}}{{job.client.ClientName.length > 12 ? \'...\' : \'\'}}</td><td class="pl-0 p-1 text-center">{{job.Location}}</td><td class="pl-0 p-1">{{job.InterviewMode.IValue}}</td><td class="pl-0 p-1">{{job.Duration}} (m)</td><td class="pl-0 p-1">${{job.Rate}}</td><td class="pl-0 p-1">${{job.W2Rate}}</td><td class="pl-0 p-1 text-center d-flex" style=width:95px;><a href="" ng-click="postingDetailsToggle(job, $index)" data-tippy-content="Add Consultants to Job" class=tippyButton><i class="material-icons-outlined pl-1 pr-1 text-primary">person_add</i></a> <a href="" ng-click="updateJobStatus(job,0, $index)" id=createnapply data-tippy-content="Deactivate Job" ng-if="tokenData.newRole === \'MarketerAdmin\'" class=tippyButton><i class="material-icons text-danger pl-1 pr-1" style="font-weight: 400;">remove_circle_outline</i></a> <a href="" ng-click=removeJPosting(job,$index) id=createnapply data-tippy-content="Delete Job Posting" ng-if="tokenData.newRole === \'MarketerAdmin\'" class=tippyButton><i class="material-icons text-danger pl-1 pr-1" style="font-weight: 400;">delete_forever</i></a> <a href="" ng-click="jobView(job, $index)" data-tippy-content="View Applicants/Job Description" class=tippyButton><i class="material-icons pl-1 pr-1">arrow_forward_ios</i></a></td></tr></tbody></table><!-- <pre>{{selection|json}}</pre> --><div id=quickapply style="display: none;"><div class=card><div class="card-header text-dark"><h5 class=card-title>Select Consultants to apply job.</h5></div><div class="card-body p-1 justify-content-start d-flex flex-column"><input type=text class="form-control mb-1"><hr class=m-1><div id=vertical-container><div ng-repeat="item in consultantsJP track by $index" class="repeated-item text-left" flex><label class="text-dark text-left text-capitalize" ng-click=toggleSelection(item)><input type=checkbox ng-checked="selection.indexOf(item) > -1"> {{item.FirstName}} {{item.LastName}} | {{item.Email}} | {{item.Skillset}}</label></div></div></div><div class="card-footer text-muted d-flex justify-content-end"><button class="btn btn-sm btn-primary">Apply</button></div></div></div><!-- <md-list class="sidebarNav">\r\n        <ul class="list-group">\r\n          <li class="list-group-item pointer" ng-repeat="job in jobs" ng-click="jobView(job)">{{job.position}}</li>\r\n        </ul>\r\n      </md-list> --></div><div class="postingDetails col-sm-12 col-md-5 col-lg-5 pl-0"><nav class="navbar navbar-expand-lg navbar-light bg-dark"><button class=navbar-toggler type=button data-toggle=collapse data-target=#navbarTogglerDemo01 aria-controls=navbarTogglerDemo01 aria-expanded=false aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div class="collapse navbar-collapse" id=navbarTogglerDemo01><ul class="navbar-nav ml-auto mt-2 mt-lg-0"><li class="nav-item mr-2"><button class="btn btn-primary btn-sm my-2 my-sm-0" ng-click="addPosting = !addPostingBtn">Add Job Posting <span class=sr-only>(current)</span></button></li><li class=nav-item><button class="btn btn-primary btn-sm my-2 my-sm-0" ui-sref=newResources()>Add Consultant</button></li></ul></div></nav><div ng-show=postingDetailsShow><div class="d-flex justify-content-between"><h5><span class="badge badge-pill badge-primary">{{selectedJob.JIDModel.JobId}}</span>{{selectedJob.position}}</h5><span>Posted: {{selectedJob.Marketer.MarkterName}} | {{selectedJob.CreateDate}}</span></div><h5 class=text-primary>Job Description</h5><div class=d-flex layout=column style="height: 420px; overflow:auto;"><div ng-bind-html=selectedJob.Description></div></div><h5 class="text-primary mt-2">Applications</h5><table class=table id=applicaations><thead class=thead-dark><tr><th>#</th><th>Name</th><th>Phone</th><th>Recruited By</th><th>Applied On</th><th style="width: 180px;;">Actions</th></tr></thead><tbody><tr ng-repeat="jobapplication in jobApplications.gjpmodel.lstJPModel track by $index"><td class=p-1>{{$index+1}}</td><td class=p-1>{{jobapplication.consl.FirstName}} {{jobapplication.consl.LastName}}</td><td class=p-1>{{jobapplication.consl.PhoneNumber}}</td><td class=p-1>{{jobapplication.marketer.MarkterName}}</td><td class=p-1>{{jobapplication.CreateDate}}</td><td class="p-1 text-center" style=width:90px;><i class="fa fa-cloud pointer applicantsTippy" data-tippy-content="Download Resume" ng-click="downloadResum(jobapplication.JApplyModel.ConslId, jobapplication.JApplyModel.ResumeUrl,jobapplication)"></i> <button data-template=g{{$index}} class=applicantsTippy style="background: none;\r\n                        border: 0px;\r\n                        width: 21px;\r\n                        padding: 0px;"><img src=../../../images/comments.png alt=Comments ng-click="addJAComment(jobapplication,\'jappid\')" class=pointer style="background: none;border: 0px;width: 14px;padding: 0px;vertical-align: initial;margin-left: 4px;"></button> <i class="material-icons pl-1 pr-1 text-danger pointer applicantsTippy" style="font-weight: bolder;" data-tippy-content="Remove Consultant" ng-click="removeJApplication(jobapplication, $index)">delete_forever</i> <button class="btn btn-sm btn-success" ng-click=activity(selectedJob.JIDModel.JobId,selectedJob.Position,jobapplication.JApplyModel.ConslId)>View Activity</button><div style="display: none;"><div id=g{{$index}}><div class="d-flex flex-column" ng-repeat="comment in jobapplication.JApplyModel.Comments track by $index" style=min-width:280px;padding:10px;><div class=d-flex><span class=text-muted>{{comment.author }} &nbsp;| &nbsp;</span> <span class=text-muted>&nbsp;{{ comment.time | moment: \'format\': \'MM/DD/YYYY\'}}</span></div><p class=text-left>{{comment.comment}}</p><hr></div></div></div></td></tr></tbody></table><div class="alert alert-warning" ng-if="jobApplications.length === 0">No Application\'s Added yet.</div><div class="w-100 d-flex justify-content-between" style="position: relative;min-height: 25px;"></div></div></div></div></md-tab><md-tab label="Expired Jobs"><md-content class="p-2 col"><div class=d-flex><div class="d-flex postingDetailsShow" ng-class="postingDetailsShow ? \'mt-2 col-sm-12 col-md-7 col-lg-7\':\'col-sm-12\'"><table class="table table-hover mt-1 JPtable noSort bg-white"><thead class=thead-dark><tr><th class=p-1>#</th><th class=p-1>Job Id</th><th class=p-1>Position</th><th class=p-1 style="width: 180px;">Client</th><th class=p-1>Location</th><th class=p-1>Interview</th><th class=p-1>Duration</th><th class=p-1>Rate</th><th class=p-1>W2 Rate</th><th class=p-1>Actions</th></tr></thead><tbody><tr ng-repeat="job in ExpiredJobs | filter:query track by $index"><td class="pl-0 p-1">{{$index+1}}</td><td class="pl-0 p-1" style=width:65px><div class=d-flex><!-- <button data-tippy-content="{{job.JApplyModel.Comments[0].comment}}" class="tippyButton"> --> <button data-template=d{{$index}} class=tippyButton><img src=../../../images/comments.png alt=Comments ng-click="addJAComment(job,\'jobid\')"></button> <span>{{job.JIDModel.JobId}}</span></div><div style="display: none;"><div class="d-flex flex-column" ng-repeat="comment in job.JApplyModel.Comments" style=min-width:280px;padding:10px;><div id=d{{$index}}><div class=d-flex><span class=text-muted>{{comment.author }} &nbsp;| &nbsp;</span> <span class=text-muted>&nbsp;{{ comment.time | moment: \'format\': \'MM/DD/YYYY\'}}</span></div><p class=text-left>{{comment.comment}}</p><hr></div></div></div></td><td class="pl-0 p-1" style=width:100px><span class="badge badge-pill badge-secondary ml-2">{{job.AppCount}}</span> {{job.skill.Skill}}</td><td class="pl-0 p-1 ActionsTippy" style=width:100px data-tippy-content={{job.client.ClientName}}>{{job.client.ClientName | limitTo:15}}{{job.client.ClientName.length > 15 ? \'...\' : \'\'}}</td><td class="pl-0 p-1 text-center">{{job.Location}}</td><td class="pl-0 p-1">{{job.InterviewMode.IValue}}</td><td class="pl-0 p-1">{{job.Duration}} (m)</td><td class="pl-0 p-1">${{job.Rate}}</td><td class="pl-0 p-1">${{job.W2Rate}}</td><td class="pl-0 p-1"><button class="btn btn-success btn-sm" ng-click="updateJobStatus(job,1, $index)">Activate</button> <button class="btn btn-danger btn-sm" ng-click="jobView(job, $index)">Applicants</button></td></tr></tbody></table></div><div class="postingDetails expired col-sm-12 col-md-5 col-lg-5" ng-show=postingDetailsShow><div class="d-flex justify-content-between"><h5><span class="badge badge-pill badge-danger">{{selectedJob.JIDModel.JobId}}</span>{{selectedJob.position}}</h5><span>Posted: {{selectedJob.Marketer.MarkterName}} | {{selectedJob.CreateDate}}</span></div><h5 class=text-primary>Job Description</h5><div class=d-flex layout=column style="height: 420px; overflow:auto;"><div ng-bind-html=selectedJob.Description></div></div><h5 class="text-primary mt-2">Applications</h5><table class="table bg-white table-hover" id=applicaations><thead class=thead-dark><tr><th>#</th><th>Name</th><th>Phone</th><th>Recruited By</th><th>Applied On</th><th style="width: 180px;;">Actions</th></tr></thead><tbody><tr ng-repeat="jobapplication in jobApplications.gjpmodel.lstJPModel track by $index"><td class=p-1>{{$index+1}}</td><td class=p-1>{{jobapplication.consl.FirstName}} {{jobapplication.consl.LastName}}</td><td class=p-1>{{jobapplication.consl.PhoneNumber}}</td><td class=p-1>{{jobapplication.marketer.MarkterName}}</td><td class=p-1>{{jobapplication.CreateDate}}</td><td class="p-1 text-center" style=width:90px;><i class="fa fa-cloud-download pointer applicantsTippy" data-tippy-content="Download Resume" ng-click="downloadResum(jobapplication.JApplyModel.ConslId, jobapplication.JApplyModel.ResumeUrl,jobapplication)"></i> <button data-template=g{{$index}} class=applicantsTippy style="background: none;\r\n                            border: 0px;\r\n                            width: 21px;\r\n                            padding: 0px;"><img src=../../../images/comments.png alt=Comments ng-click="addJAComment(jobapplication,\'jappid\')" class=pointer style="background: none;border: 0px;width: 14px;padding: 0px;vertical-align: initial;margin-left: 4px;"></button> <i class="material-icons pl-1 pr-1 text-danger pointer applicantsTippy" style="font-weight: bolder;" data-tippy-content="Remove Consultant" ng-click="removeJApplication(jobapplication, $index)">delete_forever</i> <button class="btn btn-sm btn-success" ng-click=activity(selectedJob.JIDModel.JobId,selectedJob.Position,jobapplication.JApplyModel.ConslId)>View Activity</button><div style="display: none;"><div id=g{{$index}}><div class="d-flex flex-column" ng-repeat="comment in jobapplication.JApplyModel.Comments track by $index" style=min-width:280px;padding:10px;><div class=d-flex><span class=text-muted>{{comment.author }} &nbsp;| &nbsp;</span> <span class=text-muted>&nbsp;{{ comment.time | moment: \'format\': \'MM/DD/YYYY\'}}</span></div><p class=text-left>{{comment.comment}}</p><hr></div></div></div></td></tr></tbody></table><div class="alert alert-warning" ng-if="jobApplications.length === 0">No Application\'s Added yet.</div><div class="w-100 d-flex justify-content-between" style="position: relative;min-height: 25px;"></div></div></div></md-content></md-tab></md-tabs></div></div><div class="applyConsultant col-sm-12 col-md-5 col-lg-5" ng-show=applyConsultantView style="width: 48%;"><form name=applyJobForm ng-submit="applyJobForm.$valid && applyJobSub(selectedJobId, applyJob)"><div class="form-group row"><label for=inputPosition class="col-sm-4 col-form-label">Consultants</label><div class="col-sm-8 input-group"><select placeholder="Skill Set" required ng-model=applyJob.ConslId class=custom-select><option ng-repeat="item in consultantsJP" ng-value=item.ConslId class=optGroup>{{ item.FirstName }} {{ item.LastName }}</option></select></div></div><div class="form-group row"><label for=inputPosition class="col-sm-4 col-form-label">Upload Resume</label><div class="col-sm-8 input-group"><input type=file id=file name=file onchange=angular.element(this).scope().getFileDetails(this) required></div></div><div class="form-group row"><label for=inputPosition class="col-sm-4 col-form-label">Notes</label><div class="col-sm-8 input-group"><input type=text ng-model=applyJob.Comments class=form-control></div></div><div class="form-group row"><label for=inputPosition class="col-sm-4 col-form-label">Recruiter</label><div class="col-sm-8 input-group"><select placeholder="Skill Set" required ng-model=applyJob.CreatorId class=custom-select><option ng-value=marketer.loginid ng-repeat="marketer in marketers track by $index">{{marketer.MarkterName}}</option></select></div></div><div class="form-group row"><button type=submit class="btn- btn-sm btn-primary">Submit</button></div><ci-spinner ng-show=applyJobSubProcessing></ci-spinner></form></div><div class="p-2 newJobPosting" ng-show=addPosting><div class="d-flex justify-content-between" ng-show=addPosting><h4>New Job Posting</h4><button class="btn btn-sm" ng-click=cancelAddPosting()><i class="material-icons pointer">close</i></button></div><form name=newJobPostingname ng-submit="newJobPostingname.$valid && newJobPostingFormSub(newJobPosting)" class=d-flex><div class="col-sm-12 col-md-6 col-lg-6"><div class="form-group row"><label for=inputPosition class="col-sm-4 col-form-label">Position</label><div class="col-sm-8 input-group"><!-- <input type="text" class="form-control" id="inputPosition" placeholder="Position"\r\n              ng-model="newJobPosting.position"> --> <select placeholder="Skill Set" required ng-model=newJobPosting.Position class=custom-select required><option ng-repeat="item in skills" ng-value=item.SkillId class=optGroup>{{ item.Skill }}</option></select><div class=input-group-append><button class="btn btn-primary p-1" type=button ng-click=newSkill()><small>New Skill</small></button></div></div></div><div class="form-group row"><label for=JobLocation class="col-sm-4 col-form-label">Job Location</label><div class=col-sm-8><!-- <input type="text" class="form-control" id="JobLocation" placeholder="Job Location"\r\n              ng-model="newJobPosting.JobLocation"> --> <select required ng-model=newJobPosting.Location class=form-control><option ng-value=state.abbreviation ng-repeat="state in states">{{state.abbreviation}}</option></select></div></div><div class="form-group row"><label for=JobDuration class="col-sm-4 col-form-label">Job Duration(in months)</label><div class=col-sm-8><input type=number class=form-control id=JobDuration min=0 placeholder="Job Duration (in months)" required ng-model=newJobPosting.Duration></div></div><div class="form-group row"><label for=InterviewMode class="col-sm-4 col-form-label">Interview Mode</label><div class=col-sm-8><select ng-model=newJobPosting.JIDModel.InvModeId required id=InterviewMode class=form-control><option ng-repeat="modeOfInterview in InterviewModes" ng-value=modeOfInterview.IKey>{{modeOfInterview.IValue}}</option></select></div></div><div class="form-group row"><label for=ClientId class="col-sm-4 col-form-label">Client</label><div class="col-sm-8 input-group"><!-- <input type="text" class="form-control" id="inputPosition" placeholder="Position"\r\n                  ng-model="newJobPosting.position"> --> <select placeholder=Client required ng-model=newJobPosting.JIDModel.ClientId class=custom-select id=ClientId><option ng-repeat="item in Clients" ng-value={{item.ClientId}}>{{item.ClientName}}</option></select><div class=input-group-append><button class="btn btn-primary p-1" type=button ng-click=newClient() style="width: 90px;"><small>Add Client</small></button></div></div></div><div class="form-group row"><label for=InterviewMode class="col-sm-4 col-form-label">Vendor</label><div class="col-sm-8 input-group"><!-- <input type="text" class="form-control" id="inputPosition" placeholder="Position"\r\n              ng-model="newJobPosting.position"> --> <select placeholder=Vendor required ng-model=newJobPosting.JIDModel.VendorId class=custom-select id=VendorId><option ng-repeat="item in Vendors" ng-value=item.VendorId>{{item.VendorName}}</option></select><div class=input-group-append><button class="btn btn-primary p-1" type=button ng-click=newVendor() style="width: 90px;"><small>Add Vendor</small></button></div></div><!-- <div class="col-sm-8">\r\n            <input type="text" class="form-control" id="VendorId" placeholder="VendorId"\r\n              ng-model="newJobPosting.JIDModel.VendorId">\r\n          </div> --></div><div class="form-group row"><label for=Rate class="col-sm-4 col-form-label">Hourly Rate</label><div class=col-sm-8><input type=number min=0 class=form-control id=Rate placeholder=Rate ng-model=newJobPosting.Rate></div></div><div class="form-group row"><label for=W2Rate class="col-sm-4 col-form-label">W2 Rate</label><div class=col-sm-8><input type=number min=0 class=form-control id=W2Rate placeholder="W2 Rate" ng-model=newJobPosting.W2Rate></div></div><div class="form-group row"><label for=Client class="col-sm-4 col-form-label">Recruiter</label><div class=col-sm-8><!-- <input type="text" class="form-control" id="Client" placeholder="Client" ng-model="newJobPosting.Client"> --> <select name=recruiterId ng-model=newJobPosting.JIDModel.CreatorId class=form-control required><option ng-value=marketer.loginid ng-repeat="marketer in marketers track by $index">{{marketer.MarkterName}}</option></select></div></div></div><div class="col-sm-12 col-md-6 col-lg-6"><div class=form-group><label for=inputPosition class="col-sm-4 col-form-label">Job Description</label><div class=col-sm-12><!-- <minieditor ng-model="newJobPosting.Description" options="{height:\'220\'}" class="jobDescriptionWrapper">\r\n            </minieditor> --><div text-angular=text-angular name=htmlcontent ng-model=newJobPosting.Description></div></div></div><div class=form-group><label for=inputPosition class="col-sm-4 col-form-label">Notes</label><div class=col-sm-8><textarea ng-model=newJobPosting.Comments class=form-control rows=3></textarea></div></div><div class="form-group pl-2 d-flex justify-content-end"><button type=button class="btn btn-sm" ng-click=cancelAddPosting()>Cancel</button> <button type=submit class="btn btn-sm btn-primary ml-2">Submit</button></div></div></form></div></div><prevent-actionloader ng-if=topLoader></prevent-actionloader>');
$templateCache.put('app/components/sales/jobpostings/viewActivity.html','<md-dialog aria-label="Add Comments" class="w-100 h-100" style="max-width: 95%;max-height: 90%;"><form name=addCommentsFormName ng-submit="addCommentsFormName.$valid && addComments(comments, \'type\')" class=h-100><md-toolbar><div class=md-toolbar-tools>{{ConActivity[0].title}} Activity <span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content class=h-100><div class="md-dialog-content h-100"><div class=d-flex><div class="col-sm-12 col-md-8 col-lg-8"><!-- <table class="table table-hover">\n                            <thead class="thead-dark">\n                                <tr>\n                                    <th style="width: 15px;">#</th>\n                                    <th>Client</th>\n                                    <th>vendor</th>\n                                    <th>Interview Date</th>\n                                    <th>Round</th>\n                                    <th>Status</th>\n                                    <th>Comments</th>\n                                    <th>Resume</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr class="pointer" ng-repeat="con in ConActivity track by $index"\n                                    ng-click="moreConInfo(con)">\n                                    <td>{{$index+1}}</td>\n                                    <td>{{con.Client}}</td>\n                                    <td>{{con.VendorId}}</td>\n                                    <td>{{con.start | moment: \'format\': \'MM/DD/YYYY\'}}</td>\n                                    <td>{{con.levelOfInterview}}</td>\n                                    <td>{{con.status}}</td>\n                                    <td class="pointer"><i class="material-icons pointer zoom text-success"\n                                            style="font-size: 18px;">remove_red_eye</i></td>\n                                    <td><i class="fa fa-cloud-download pointer applicantsTippy text-primary mr-2"\n                                            ng-click="downloadResum(con.InterviewId, con.DocUrl)"\n                                            data-tippy-content="Download Resume"></i></td>\n                                </tr>\n                            </tbody>\n                        </table> --><ci-spinner ng-if=dataLoader></ci-spinner><div class="alert alert-info" ng-if="ConActivity.length === 0 && !dataLoader">No Interviews Found</div><ul id=myUL ng-if=!dataLoader><li ng-repeat="client in ConActivity" class=p-1><span class=caret>{{client.Client}}</span><ul class=nested><li ng-repeat="InvId in client.Invs" class=p-1><span class=caret>{{InvId.InterviewId}}</span><ul class="nested p-1"><li><table class="table table-hover table-bordered"><thead class=thead-dark><tr><th style="width: 15px;">#</th><th>Client</th><th>vendor</th><th>Interview Date</th><th>Round</th><th>Status</th><th>Comments</th><th>Resume</th></tr></thead><tbody><tr ng-repeat="con in InvId.InvDetails track by $index"><td>{{$index+1}}</td><td>{{con.Client}}</td><td>{{con.VendorId}}</td><td>{{con.start | moment: \'format\': \'MM/DD/YYYY\'}}</td><td>{{con.levelOfInterview}}</td><td>{{con.status}}</td><td class=pointer><i ng-click=moreConInfo(con) class="material-icons pointer zoom text-success" style="font-size: 18px;">remove_red_eye</i></td><td><div ng-if=downloadResumLoader class="spinner-border text-info" style="width: 15px; height: 15px;" role=status><span class=sr-only>Loading...</span></div><i ng-if=!downloadResumLoader class="fa fa-download pointer applicantsTippy text-primary mr-2" ng-click="downloadResum(con.InterviewId, con.DocUrl)" data-tippy-content="Download Resume"></i></td></tr></tbody></table></li></ul></li></ul></li></ul></div><div class="col-sm-12 col-md-4 col-lg-4"><div class=d-flex><span class="badge badge-pill badge-primary">{{SelectedCon.InterviewId}}</span></div><div class="d-flex justify-content-between mb-3" ng-if="SelectedCon.comments.length>0"><h4>Comments</h4></div><ul class=list-group><li class=list-group-item ng-repeat="SelectedConComment in SelectedCon.comments"><div class="d-flex flex-column"><div class=d-flex><small>{{SelectedConComment.time | moment: \'format\': \'MM/DD/YYYY\'}}</small> <span class=m-auto></span> <small>{{SelectedConComment.author}}</small></div><p>{{SelectedConComment.comment}}</p></div></li></ul></div></div></div></md-dialog-content></form></md-dialog>');
$templateCache.put('app/components/sales/jobpostings/viewDoc.html','<md-dialog aria-label="Add Comments" class="w-100 h-100" style="max-width: 95%;max-height: 90%;"><form name=addCommentsFormName ng-submit="addCommentsFormName.$valid && addComments(comments, \'type\')" class=h-100><md-toolbar><div class=md-toolbar-tools><h2>Consultant Resume</h2></div></md-toolbar><md-dialog-content class=h-100><div class="md-dialog-content h-100"><iframe src={{url}} width=100% height=100%></iframe></div></md-dialog-content></form></md-dialog>');
$templateCache.put('app/components/sales/Marketer/addSkill.Dialog.html','<md-dialog aria-label="Add Skill"><form class=sendEmailDialog name=addSkillform ng-submit="addSkillform.$valid && addSkillData(newSkillName)"><md-toolbar><div class=md-toolbar-tools><h2>Add Skill</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=subject>Skill Name *</label> <input type=text class=form-control ng-model=newSkillName name=Skill placeholder="New Skill" required></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/sales/Marketer/interviewDetails.html','<md-dialog class="interviewDetails h-100"><ci-spinner ng-if=interviewDetailsLoader></ci-spinner><form ng-cloak ng-submit=updateInterview(editable) class=h-100 ng-if=!interviewDetailsLoader><md-dialog-content class=h-100><div class="md-dialog-content p-0"><md-tabs md-dynamic-height md-border-bottom class="md-background md-hue-3" md-selected=selectedInterview><md-tab label="{{ interview.levelOfInterview }}" ng-repeat="interview in mergedInterviews | orderBy:\'$index\':true track by $index" md-on-select=interviewLvlSelected(interview) ng-disabled="editMode && interview.status !== \'New\'"><div class="d-flex flex-column pl-4 pr-4 pt-2" style="padding-bottom:52px !important;"><div class=row><div class=col-12><h4 class="d-flex text-info align-self-center">{{ interview.title }} <span class="text-muted pt-1 ml-2 mt-1" style="font-size: 14px;">Interview Details & Scheduled by</span><span class="badge badge-pill badge-info ml-1">{{ interview.marketer }}</span></h4></div></div><div class=row><div class=col-12><button class="btn btn-outline-secondary btn-sm" ng-click=marketerEdit() type=button ng-if="tokenData.newRole == \'MarketerAdmin\' && !marketerEditView" ng-if="canEdit && !editMode">Marketed By: {{ interview.marketer }}</button><div class="d-flex align-items-start p-2 ml-4 mt-4 mr-4 mb-1" ng-if=" marketerEditView"><select ng-model=selInteviw.MarkterId class=form-control><option></option><option ng-value=marketer.loginid ng-repeat="marketer in marketers">{{marketer.MarkterName}}</option></select> <button class="btn text-success" type=button><i class="material-icons pointer text-success font-weight-bold" style="font-size: 16px;" ng-click="UpdateMarketerEdit(selInteviw.MarkterId, selInteviw.InterviewId, selInteviw)">done</i></button> <button class="btn text-danger" type=button><i class="material-icons pointer text-danger font-weight-bold" style="font-size: 16px;" ng-click=CancelMarketerEdit()>clear</i></button></div><button class="btn btn-outline-secondary btn-sm" type=button ng-click=editEvent(selInteviw) ng-if="canEdit && !editMode">edit</button><ul class="m-0 p-0" ng-if=!editMode><li class=row><div class="col-sm-6 strong-text">Interview Start Date & Time</div><div class=col-sm-6>{{ interview.start | moment: "format":"MMM DD, YYYY @ hh:mm" }}</div></li><li class=row><div class="col-sm-6 strong-text">Interview End Date & Time</div><div class=col-sm-6>{{ interview.end | moment: "format":"hh:mm" }}</div></li><li class=row><div class="col-sm-6 strong-text">Mode of Interview</div><div class=col-sm-6>{{ interview.modeOfInterview }}</div></li><li class=row><div class="col-sm-6 strong-text">Level of Interview</div><div class=col-sm-6>{{ interview.levelOfInterview }}</div></li><li class=row><div class="col-sm-6 strong-text">Client</div><div class=col-sm-6>{{ interview.Client }}</div></li><li class=row><div class="col-sm-6 strong-text">Vendor</div><div class=col-sm-6>{{ interview.VendorId }}</div></li><li class=row><div class="col-sm-6 strong-text">Meeting URL</div><div class=col-sm-6><a ng-href=" {{ interview.url }}" target=_blank ng-if="interview.url !== null">{{ interview.url }}</a> <span ng-if="interview.url === null">n/a</span></div></li></ul><div class="editInterviewWrap d-flex flex-wrap" ng-if="editMode && interview.edit"><div class=col-sm-6><md-input-container class="md-input-has-placeholder w-100"><label for="">Interview Start Date & Time</label> <input mdc-datetime-picker="" date=true time=true type=text id=datetimestart placeholder="Start Date and Time" show-todays-date="" minutes=true min-date=todayDate auto-ok=false short-time=true ng-model=editable.StartDate class=md-input format="MM/DD/YYYY, hh:mm a" required></md-input-container></div><div class=col-sm-6><md-input-container class="md-input-has-placeholder w-100"><label for="">Interview End Date & Time</label> <input mdc-datetime-picker="" date=true time=true type=text id=datetimeend placeholder="Start Date and Time" show-todays-date="" minutes=true min-date=editable.StartDate auto-ok=false short-time=true ng-model=editable.EndDate class=md-input format="MM/DD/YYYY, hh:mm a" required></md-input-container></div><div class=col-sm-6><md-input-container mb-0 mt-0 class=w-100><label>Mode of Interview</label><md-select ng-model=editable.modeOfInterview required><md-option ng-repeat="modeOfInterview in InterviewModes" ng-value=modeOfInterview.IKey>{{ modeOfInterview.IValue }}</md-option></md-select></md-input-container></div><div class=col-sm-6><md-input-container mb-0 mt-0 class=w-100><label>Level of Interview</label><md-select ng-model=editable.levelOfInterview required><md-option ng-repeat="levelOfInterview in InterviewLevels" ng-value=levelOfInterview.IKey>{{ levelOfInterview.IValue }}</md-option></md-select></md-input-container></div><div class=col><md-input-container mb-0 mt-0 class=w-100><label>Meeting Url</label> <input type=text ng-model=editable.url></md-input-container></div></div><div ng-if="editMode && interview.edit"><md-button ng-click=" cancelEdit()">Cancel</md-button><ci-spinner ng-if=updateInterViewLoader></ci-spinner><button type=submit class="btn btn-sm btn-primary" ng-show=!updateInterViewLoader>Submit</button></div></div><div class="status-wrap d-flex p-2 align-self-start" ng-hide="editMode && interview.edit"><h6 class="text-secondary pt-1 w-auto" ng-if="interview.status !== \'New\'">Status: <span class="badge badge-warning">{{ interview.status }}</span></h6><div class=marketerAdminAccess ng-if="tokenData.newRole == \'MarketerAdmin\' && interview.status !== \'New\' && interview.status !== \'Confirmed\'"><div class="d-flex align-self-start" ng-if="interview.status !== \'Confirmed\'"><h4 class="mr-3 ml-3 pt-1">Reupdate:</h4><button type=button class="btn btn-primary mr-3 btn-sm" ng-click="statusUpdate(\'1\',interview,selInteviw)">Reprogress</button></div></div><div ng-if="interview.status !== \'New\' && interview.status !== \'No Show Up\' && interview.status !== \'Rejected\' && interview.status !== \'Placed\' && mergedInterviews.length === $index+1" class="ml-4 d-flex align-self-start"><button type=button class="btn btn-danger mr-3 btn-sm" ng-click="statusUpdate(\'2\',interview,selInteviw)">Rejected</button> <button type=button class="btn btn-success mr-3 btn-sm" ng-click="statusUpdate(\'4\',interview,selInteviw)">Placed</button> <button type=button class="btn btn-warning mr-3 btn-sm" ng-click="statusUpdate(\'6\',interview,selInteviw)" ng-if="interview.status !== \'Rejected\' && interview.status !== \'Placed\'">No Show Up</button></div><div class=d-flex ng-if="interview.status === \'New\' && mergedInterviews.length === $index+1"><h4 class="mr-3 text-secondary">Status:</h4><button type=button class="btn btn-primary mr-3 btn-sm" ng-click="statusUpdate(\'1\',interview,selInteviw)">Confirmed</button> <button type=button class="btn btn-danger mr-3 btn-sm" ng-click="statusUpdate(\'2\',interview,selInteviw)">Rejected</button> <button type=button class="btn btn-info mr-3 btn-sm" ng-click="statusUpdate(\'4\',interview,selInteviw)" ng-if="interview.status !== \'Rejected\' && interview.status !== \'Placed\'">Placed</button> <button type=button class="btn btn-warning mr-3 btn-sm" ng-click="statusUpdate(\'6\',interview,selInteviw)" ng-if="interview.status !== \'Rejected\' && interview.status !== \'Placed\'">No Show Up</button></div></div></div></div></md-tab></md-tabs></div><div class="container comments-wrap" ng-if=!editMode><h4 class="text-left text-primary">Interview Updates</h4><div class=card-wrap><div class="card m-1" ng-repeat=" comment in selInteviw.comments track by $index" ng-if="comment.author !== undefined"><div class=card-body><div class=row><div class=col-md-12><p layout=row class=mb-1><a class=float-left href=#><strong>{{ comment.author }}</strong></a> <em class="text-secondary text-left ml-4">{{ comment.time | moment: "format":"MM DD, YYYY" }} | </em><em class="text-secondary text-left ml-4">{{ comment.time | moment: "format":"HH:MM" }}</em></p><div class=clearfix></div><p>{{ comment.comment }}</p></div></div></div></div></div><div class="commentsForm w-100 d-flex align-items-center"><textarea name="" class="w-100 mb-2 mt-2 mr-2 form-control" id=newComment placeholder="Post your Interview updates" ng-model=newComment></textarea> <button class="btn btn-primary" type=button ng-click="addComment(newComment, selInteviw)" ng-if=!addCommentLoader>Post</button><ci-spinner ng-if=addCommentLoader></ci-spinner></div></div></md-dialog-content><md-dialog-actions layout=column layout-align="start center"><div layout=row layout-align="space-between center" class=w-100><div><i class="material-icons pointer text-danger" ng-click=remove(selInteviw) ng-if=canEdit data-toggle=tooltip data-placement=top title="Delete This Interview">delete </i><i class="material-icons pointer text-danger" ng-click=DellAll(selInteviw) ng-if=canEdit data-toggle=tooltip data-placement=top title="Delete All Interviews">delete_forever</i></div><md-button ng-click="downloadResum(selInteviw.InterviewId, ResumeUrl)" ng-if="selInteviw.DocUrl!== null"><i class="fa fa-download"></i> Resume</md-button><button ng-click=hide() class="btn btn-sm btn-secondary" type=button>Close</button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/sales/Marketer/Marketer.component.html','<div class=container-fluid id=main-container><div class=row><div class="col-lg-6 col-md-12 col-sm-12 p-2"><!-- <h4 class="p-2">Interview Schedular</h4> --><div class=calender-wrapper><div class="d-flex m-1"><input type=text ng-model=search class=form-control my-enter=interviewFilter(search)> <button class="btn btn-primary btn-sm mx-1" ng-click=interviewFilter(search) ng-disabled=!search>Search</button> <button class="btn btn-light btn-sm mx-1" ng-click="clearFilter(\'\',search)" ng-if=search><span class="text-danger mx-1">x</span>Clear</button></div><div id=calendar class=p-2></div></div></div><div class="col-lg-6 col-md-12 col-sm-12"><div class="w-100 d-flex justify-content-center p-2"><!-- <h4 class="col-2 p-0 pt-2">Hot List</h4> --> <input type=text placeholder=Search.. ng-model=searchData ng-keyup=allhotListSearch(searchData) class=form-control></div><div id=hotListTable></div></div></div><!-- <md-button class="md-primary md-raised fixAddBtn" aria-label="Eat cake" ng-click="toggleRight()">\r\n                    <md-icon md-svg-src=" ../images/baseline-add-24px.svg"> </md-icon>\r\n                    Schedule Interview\r\n                </md-button> --><div class="modal fade" id=addNewInterview><div class="modal-dialog modal-xl modal-dialog-centered" role=document><div class="modal-content border-0"><div class="modal-body p-0"><form name=addNewInterview layout=column class=fixSidebarAddEv ng-submit="addNewInterview.$valid && addEvent(user)"><div layout=column class=fixSidebarAddEvContent><md-radio-group ng-model=recurringInterview layout=row class="bg-info text-white p-4 justify-content-center" ng-change=changeIntType()><md-radio-button value=no ng-click=changeIntType()><h3>New Interview</h3></md-radio-button><md-radio-button value=yes ng-click=changeIntType()><h3>New Round</h3></md-radio-button></md-radio-group><div ng-show="recurringInterview !== undefined" class="bg-dark text-white p-2"><md-autocomplete id=rInt md-no-cache=true md-selected-item=user.con md-search-text=searchText md-items="item in vm.querySearch(searchText)" md-item-text=item.title md-min-length=0 md-menu-class=autocomplete-standard-template md-menu-container-class=standard-container md-mode=standard placeholder="Pick a Consultant to create another round of interview" ng-if="recurringInterview ==\'yes\'" md-selected-item-change=vm.selectedInterviewType(user)><md-item-template layout=" column"><div class=item-title><p md-highlight-text=searchText md-highlight-flags=^i>{{item.title}} --( {{item._def.extendedProps.marketer}} )</p></div><div class=row><div class=col-6><span class="item-desc w-100">Client: {{item.extendedProps.Client}}</span> <span class=item-desc>Vendor: {{item.extendedProps.VendorId}}</span></div><div class=col-6><span class=item-desc>{{item.start | moment:\'format\':\'MMM/DD/YY @ HH:MM\'}} {{item.end | moment:\'format\':\'MMM/DD/YY @ HH:MM\'}}</span></div></div><!-- <hr class="m-1"> --></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete><md-autocomplete id=nInt md-no-cache=true md-selected-item=user.con md-search-text=searchText md-items="item in vm.qryhotlist(searchText)" md-item-text=item.FullName md-min-length=0 md-menu-class=autocomplete-standard-template md-menu-container-class=standard-container md-mode=standard placeholder="Pick a Consultant to create new interview" ng-if="recurringInterview ==\'no\'" md-selected-item-change=vm.newIntChange(user)><md-item-template layout=" column"><span class=item-title><span md-highlight-text=searchText md-highlight-flags=^i>{{item.FullName}}</span></span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><div class="h-100 p-3" ng-show="recurringInterview !== undefined" style="min-height: 550px;"><div ng-if="user.con !== null && vm.updatePreviousStatus"><div class="p-3 ml-3 mr-3 status-wrap"><div layout=column><h5 class="text-white pl-4 pr-4">Previous round of interview was created on <span class="badge badge-info">{{vm.previousIntData.CreateDate | moment:\'format\':\'MMM DD, YYYY\'}}</span> and scheduled on <span class="badge badge-info">{{vm.previousIntData.start | moment:\'format\':\'MMM DD, YYYY\'}},</span> So please update the Interview status of <span class="badge badge-info">{{vm.previousIntData.levelOfInterview}}</span> round to create another round of Interview.</h5><hr><div layout=row><h4 class="mr-3 text-white">Update Status:</h4><button type=button class="btn btn-success mr-3" ng-click="vm.UpdateStatus(\'1\',vm.previousIntData)">Confirmed</button> <button type=button class="btn btn-danger mr-3" ng-click="vm.UpdateStatus(\'2\',vm.previousIntData)">Rejected</button></div></div></div></div><div ng-show="user.con !== null && !vm.updatePreviousStatus" layout=column><div class=d-flex><md-input-container class="col-6 mb-0"><input mdc-datetime-picker="" date=true time=true type=text id=datetimeauto placeholder="Start Date and Time" show-todays-date="" minutes=true min-date=todayDate auto-ok=false short-time=true ng-model=user.startDate class=md-input format="MM/DD/YYYY, hh:mm a" required></md-input-container><md-input-container class="col-6 mb-0"><!-- <label>Interview Date & End Time</label> --> <input mdc-datetime-picker="" date=true time=true placeholder="End Date and Time" minutes=true min-date=user.startDate type=text id=time short-time=true ng-model=user.endDate class=md-input format="MM/DD/YYYY, hh:mm a" required></md-input-container></div><div class="d-flex flex-wrap"><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-4"><label for=inputPosition class=col-form-label>Select Skills</label><div class="col input-group"><select required ng-model=user.SkillId class=custom-select required><option ng-repeat="item in skills | orderBy:Skill" ng-value=item.SkillId>{{ item.Skill }}</option></select><div class=input-group-append><button class="btn btn-primary p-1" type=button ng-click=newSkill()><small>Add New</small></button></div></div></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-4"><label for=inputPosition class=col-form-label>Select Client</label><div class="col input-group"><select required ng-model=user.ClientId class=custom-select required ng-change=selectedClientAddr(chaninConData.ClientId) ng-required="recurringInterview ==\'no\'" ng-disabled="recurringInterview ==\'yes\'"><option ng-repeat="item in Clients | orderBy:ClientName track by $index" ng-value=item.ClientId>{{item.ClientName}}</option></select><div class=input-group-append><button class="btn btn-primary p-1" type=button ng-click=newClient(addClientShow)><small>Add New</small></button></div></div></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-4"><label for=inputPosition class=col-form-label>Select Vendor</label><div class="col input-group"><select required ng-model=user.PVId class=custom-select required ng-change=selectedVendorAddr(chaninConData.PVId) ng-required="recurringInterview ==\'no\'" ng-disabled="recurringInterview ==\'yes\'"><option ng-repeat="item in Vendors | orderBy:VendorName" ng-value=item.vendorModel.VendorId>{{item.vendorModel.VendorName}}</option></select><div class=input-group-append><button class="btn btn-primary p-1" type=button ng-click=newVendor(addVendorShow)><small>Add New</small></button></div></div></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-4"><label for=inputPosition class=col-form-label>Mode of Interview</label><div class="col input-group"><select required ng-model=user.modeOfInterview class=custom-select required><option ng-repeat="modeOfInterview in vm.InterviewModes" ng-value=modeOfInterview.IKey>{{modeOfInterview.IValue}}</option></select></div></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-4"><label for=inputPosition class=col-form-label>Level of Interview</label><div class="col input-group"><select required ng-model=user.levelOfInterview class=custom-select required><option ng-repeat="levelOfInterview in vm.InterviewLevels" ng-value=levelOfInterview.IKey>{{levelOfInterview.IValue}}</option></select></div></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-4"><label for=inputPosition class=col-form-label>Meeting Url</label><div class="col input-group"><input type=text ng-model=user.url class=form-control></div></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-4"><label for=inputPosition class=col-form-label>Comments</label><div class="col input-group"><textarea class=form-control ng-model=user.comments></textarea></div></div><div class="form-group col-sm-12 col-md-6 col-lg-4 col-xl-4"><label for=inputPosition class=col-form-label>By</label><div class="col input-group"><select required ng-model=user.marketer class=custom-select required><option ng-repeat="marketer in marketers" ng-value=marketer.loginid>{{marketer.MarkterName}}</option></select></div></div></div><div layout=row class=mt-4 ng-if="recurringInterview ==\'no\'"><label class="ml-3 uploadBtn" for=fileToUpload>Upload Resume<sup class=text-danger>*</sup> <i class="fa fa-cloud-upload"></i></label> <span style="line-height: 32px;margin-left: 10px;color: dimgrey;text-shadow: 1px 1px 1px #ffffff;">{{files[0].name}} </span><i class="material-icons pointer" ng-click=removeFile() ng-if="files.length>0" style="font-size: 15px; line-height: 31px; color: red; margin-left: 10px;">close</i> <input type=file id=fileToUpload onchange="angular.element(this).scope().setFiles(this) && fileUploadChangeEv()" class="pt-2 mt-2" style="visibility: hidden;"></div><div class=row><div class=col>All fields marked with (*) are required.</div></div><div class=d-flex><button type=submit class="btn btn-primary" ng-if="!addConLoader && EnableBtn">Submit</button><ci-spinner ng-if=addConLoader></ci-spinner></div></div></div></div></form><div class="ccDialg addClientShow" ng-if=addClientShow><div class="modal-custom h-100" style=padding:20px;><h2>Add Client</h2><form class=form-column name=addClientform ng-submit="addClientform.$valid && addClientData(addClient)"><div class="form-group col"><label>Client Name *</label> <input type=text class=form-control ng-model=addClient.ClientName name=subject placeholder="Client Name" required></div><md-button ng-click=CanceladdClientShow() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier ng-hide=matched>Submit</md-button><ci-spinner ng-if="notifier && !afterAddedClient"></ci-spinner><div class="alert alert-info" ng-if=matched>Client Already Exists. Cancel and select from the list.</div><div class="alert alert-info" ng-if=afterAddedClient>Client added Successfully, Please select from the list.</div><p class=text-danger>All fields marked with * are required</p></form></div></div><div class="ccDialg addVendorShow" ng-if=addVendorShow><div class="modal-custom h-100 p-2" style="overflow-y: auto;"><h2 class=m-0>Add Vendor</h2><form class=form-column name=addVendorform ng-submit="addVendorform.$valid && addVendorData(addVendor)"><div class="form-group col"><label>Name *</label> <input type=text class=form-control ng-model=addVendor.VendorName name=VendorName placeholder="Vendor Name" required></div><p class=text-danger>All fields marked with * are required</p><md-button ng-click=CanceladdVendorShow(addVendorShow) ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner><div class="alert alert-info" ng-if=afterAddedVendor>Vendor added Successfully, Please select from the list.</div></form></div></div></div></div></div></div><div class="modal fade" id=addSkillModal tabindex=-1 role=dialog aria-labelledby=addSkillModal aria-hidden=true><div class="modal-dialog modal-dialog-centered" role=document><form class=modal-content name=addSkillform ng-submit="addSkillform.$valid && addSkillData(newSkillName)"><div class="modal-header bg-info p-2"><h5 class=modal-title id=exampleModalLongTitle>Add New Skill</h5><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body><div class="form-group col"><label for=subject>Skill Name *</label> <input type=text class=form-control ng-model=newSkillName name=Skill placeholder="New Skill" required></div></div><div class="modal-footer bg-info p-2"><button type=button class="btn btn-sm btn-secondary" data-dismiss=modal ng-if=!notifier>Close</button> <button type=Submit class="btn btn-sm btn-light text-primary" ng-if=!notifier>Submit</button><ci-spinner ng-if=notifier></ci-spinner></div></form></div></div><div class="modal fade" tabindex=-1 id=consDetails><div class="modal-dialog modal-xl" style="max-width: 98%;"><div class=modal-content><div class=modal-header><h5 class=modal-title>{{conslDetails.FirstName}} {{conslDetails.LastName}}</h5><p class="ml-2 text-primary font-weight-bold">({{conslDetails.Skillset}})</p><span>{{conslDetails.Experience}}</span> <span>{{conslDetails.CurrentLocation}}</span> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class="modal-body d-flex"><form class="d-flex flex-column col-6"><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">Email<div class="col-sm-8 font-weight-normal">: {{conslDetails.Email}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">DOB<div class="col-sm-8 font-weight-normal">: {{conslDetails.DOB}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">Phone<div class="col-sm-8 font-weight-normal">: {{conslDetails.PhoneNumber}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">SSN<div class="col-sm-8 font-weight-normal">: {{conslDetails.SSN}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">VisaType<div class="col-sm-8 font-weight-normal">: {{conslDetails.VisaType}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">VisaType<div class="col-sm-8 font-weight-normal">: {{conslDetails.VisaStatus}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">SkypeId<div class="col-sm-8 font-weight-normal">: {{conslDetails.SkypeId}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">USEntryDate<div class="col-sm-8 font-weight-normal">: {{conslDetails.USEntryDate}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">RecruiterName<div class="col-sm-8 font-weight-normal">: {{conslDetails.RecruiterName}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">ReferBy<div class="col-sm-8 font-weight-normal">: {{conslDetails.ReferBy}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">GK<div class="col-sm-8 font-weight-normal">: {{conslDetails.GK}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">GKMoveInDate<div class="col-sm-8 font-weight-normal">: {{conslDetails.GKMoveInDate}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">ExpectedRate<div class="col-sm-8 font-weight-normal">: {{conslDetails.ExpectedRate}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">CreateDate<div class="col-sm-8 font-weight-normal">: {{conslDetails.CreateDate}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">Experienced<div class="col-sm-8 font-weight-normal">: {{conslDetails.Exp}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">Education<div class="col-sm-8 font-weight-normal">: {{conslDetails.EducationLevel}}</div></div><div class="form-group row col-xl-4 col-lg-4 col-md-6 col-sm-12 font-weight-bold">University<div class="col-sm-8 font-weight-normal">: {{conslDetails.UnivName}}</div></div></form><div class=col-6><h4 class=p-4>Consultant Documents</h4><div style="overflow-y: auto;min-height: 400px;"><dl ng-repeat="conDoc in conDocs track by $index" class=d-flex><dt class=mr-2>File:</dt><dd ng-click=getFile(ConData,conDoc.DocName) class="pointer text-primary"><u>{{conDoc.DocName}}</u></dd></dl></div></div></div><div class=modal-footer><button type=button class="btn btn-secondary" data-dismiss=modal>Close</button> <button type=button class="btn btn-primary">Save changes</button></div></div></div></div><prevent-actionloader ng-if=topLoader></prevent-actionloader></div>');
$templateCache.put('app/components/sales/massMail/massMail.component.html','<div class=container-fluid><md-content id=bulkEmailWrap><div layout=column ng-if=vm.stopSpinner><div class=container-fluid><texperts-loader></texperts-loader></div></div><div layout=column ng-if=!hasLimit style="position: absolute;bottom: 0;top: -1px;left: 0;right: 0;z-index: 9999;background-color: rgba(165, 42, 42, 0.8);\r\n            color: white;\r\n            text-shadow: 0px 1px 10px #000;"><div class="container-fluid m-4 p-4"><h2 class="m-4 p-4">You reached your monthly limit.</h2></div></div><div layout=column ng-show=hasLimit><div class=container-fluid><div class=row><div class="col-sm-7 pr-0"><div class=card><form name=bulkEmail ng-submit="bulkEmail.$valid && bulkEmailSubmit(mailer, $event)"><div class=card-body><div class=form-column ng-show=!vm.sendingInProcess><div class="form-group col"><label for=Sender>From<sup>*</sup></label> <input type=text class="form-control form-control-sm" ng-model=mailer.Sender name=Sender placeholder="Sender Email *" id=Sender required></div><div class="form-group col"><label for=recipients>To<sup>*</sup></label><div class="row emailToBox"><span class="badge badge-secondary countInfoTo">{{ mailer.lstRecpEmail.length }}</span><div class="d-flex flex-row flex-wrap"><div class="chip m-1" ng-repeat="contact in mailer.lstRecpEmail track by $index">{{ contact.FirstName }} {{ contact.LastName }} <em>&lt;{{ contact.Email }}&gt; </em><span class=closebtn ng-click=vm.removeEmail($index)>&times;</span></div></div></div></div><div class="form-group col" style="margin-top: 38px;"><label for=subject>Subject<sup>*</sup></label> <input type=text class="form-control form-control-sm" ng-model=mailer.Subject name=subject placeholder=Subject id=subject required></div><div class="form-group col"><label for=message>Message<sup>*</sup></label><!-- <minieditor\r\n                        ng-model="mailer.Body"\r\n                        options="{height:\'280\'}"\r\n                      >\r\n                      </minieditor> --><div text-angular=text-angular name=htmlcontent ng-model=mailer.Body></div><!-- <text-angular ng-model="mailer.Body"></text-angular> --><!-- <input name="body" ng-model="mailer.Body" type="hidden">\r\n                      <div id="scrolling-container">\r\n                        <div id="quill-container">\r\n                          Hello @@DisplayName\r\n                          </div>\r\n                          </div> --></div><p class=text-danger>All fields marked with * are required</p></div><div class=form-column ng-show=vm.sendingInProcess><ci-spinner ng-show=vm.stopSpinner></ci-spinner><div class="alert alert-info" ng-show=vm.showNotif>Email Sent Successufully.</div><div ng-show=vm.showNotif>Page will automatically redirects...</div></div></div><div class="card-footer text-muted text-right"><button class="btn btn-primary" type=submit ng-show=!vm.showNotif>Send</button></div></form><div style="position: absolute;top: 188px;left: 3%;width: 94%;" ng-show=!vm.sendingInProcess><form name=addEmail class=d-flex ng-submit="addEmail.$valid && newEmailAcMethod(newEmailAc)"><input type=text placeholder=Firstname ng-model=newEmailAc.FirstName class="form-control form-control-sm col m-2" required> <input type=text placeholder=Lastname ng-model=newEmailAc.LastName class="form-control form-control-sm col m-2" required> <input type=email placeholder=Email ng-model=newEmailAc.Email class="form-control form-control-sm col m-2" required> <button type=submit class="btn btn-primary col m-2">Add</button></form></div></div></div><div class="col-sm-5 pl-0"><div class="col-sm-12 h-100 pt-2" style="background-color: rgb(204, 226, 255);"><div class="d-flex justify-content-between"><div><button type=button class="btn btn-primary btn-sm" ng-show="viewContactListView && !ListUploadingView" ng-click=addToToList()>&lt;&lt;Add</button> <button type=button class="btn btn-sm btn-secondary ml-1" ng-show="viewContactListView && !ListUploadingView" ng-click=viewList()>Back</button> <button class="btn btn-sm btn-info ml-1" ng-show="viewContactListView && !ListUploadingView" ng-click=download()><i class="fa fa-download"></i></button></div><div><span class="badge badge-pill badge-warning">Quota: {{ UserLimits.EmailsUsed }}/{{ UserLimits.LimitPerMonth }}</span><!-- <span class="ml-3"><a href="images/bulkEmailUpload-XLXStencil.xlsx"><b>Click\r\n                                                    here</b></a> to download Excel Document stencil.</span> --> <button type=button class="btn btn-success btn-sm" ng-click=addList()>Add Contacts</button></div></div><div class="addContactsList pt-3" ng-if=ListUploadingView><form name=contactListAddFN ng-submit="contactListAddFN.$valid && contactListAddFS(ListData)"><div class=form-group><label for=tagAs>Upload excel file.</label> <input type=file class="form-control form-control-sm" id=tagAs onchange=angular.element(this).scope().getFileDetails(this) required> <small id=passwordHelpBlock class="form-text text-muted">Your contacts list should be as same as the stencil provided <a href="https://github.com/texperts/scripts/blob/master/bulkEmailUpload-XLXStencil.xlsx?raw=true">here</a>.</small></div><button class="btn btn-primary" type=button ng-click=cancelUploading()>Cancel</button> <button class="btn btn-primary" type=submit ng-if=!vm.stopSpinner>Submit</button><ci-spinner ng-show=vm.stopSpinner></ci-spinner></form></div><div ng-if=!viewContactListView><ul class="list-group mt-2"><li class="list-group-item list-group-item-action d-flex justify-content-between" ng-repeat="contactList in ContactsList track by $index"><span class="pointer w-100" ng-click=viewContactList(contactList.McontactId)>{{ contactList.FileName }}</span><div><md-progress-circular ng-if=contactList.delSheetLoader md-mode=indeterminate class=md-hue-2 md-diameter=20px></md-progress-circular><button class="btn btn-small text-danger p-0" ng-if=!contactList.delSheetLoader type=button ng-click="delContSheet(contactList, $index)">x</button></div></li></ul></div><div class=viewContactListView ng-if="viewContactListView && !ListUploadingView"><div id=contacts-table class=mt-3></div></div></div></div></div></div></div></md-content></div><style>.ta-scroll-window > .ta-bind {\r\n    max-height: 460px;\r\n}</style><div class="modal fade" id=delContSheetConfirm tabindex=-1 role=dialog aria-labelledby=exampleModalLabel aria-hidden=true><div class=modal-dialog><div class=modal-content><div class=modal-body>Are you sure you want to delete the file?</div><div class=modal-footer><button type=button class="btn btn-secondary" data-dismiss=modal>No</button> <button type=button class="btn btn-primary" ng-click=delContSheetSubmit()>Yes</button></div></div></div></div><prevent-actionloader ng-if=topLoader></prevent-actionloader>');
$templateCache.put('app/components/sales/marketerInterviews/marketerInterviews.component.html','<div class=container-fluid><texperts-loader ng-if=!pageLoaded></texperts-loader><div class="d-flex mt-5 justify-content-center" ng-if=yearUpdate><div class=mt-4><div class="card p-4"><div class="card-body p-4"><div class=dropdown><button class="btn btn-secondary dropdown-toggle" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false>Select Year</button><div class=dropdown-menu aria-labelledby=dropdownMenuButton><a class=dropdown-item ng-click="getinterviewdetails(\'2019\')">2019</a> <a class=dropdown-item ng-click="getinterviewdetails(\'2020\')">2020</a></div></div></div></div></div></div><div class="d-flex mt-5 justify-content-center p-5" ng-if=!marketerDataLoaded><ci-spinner></ci-spinner></div><div class="row mt-2" ng-if="individualInterviews.length>0 && !yearUpdate && pageLoaded"><div class=col-sm-2 ng-if=marketerDataLoaded><ul class="list-group list-group-flush"><li class="list-group-item pointer" ng-repeat="interviews in individualInterviews track by $index" ng-click=selectedMarketer($index,interviews) ng-class="{active: $index == selected}">{{interviews.marketerFullName}}</li></ul></div><div class="col-sm-10 col-md-10 col-lg-10" ng-if=marketerDataLoaded><div class="headerMenuWrap col d-flex justify-content-between"><div class="d-flex align-items-center"><button class="btn btn-sm btn-primary mr-2" ng-click=changeYear()>Change Year</button><h4 class="mr-4 pt-2">Snapshot of year {{SelectedYear}}</h4><div class="d-flex pt-1"><h5 class=mr-2><span class="badge badge-pill badge-danger">Rejected <span class="badge badge-pill badge-warning">{{Rejected.length}}</span></span></h5><h5 class=mr-2><span class="badge badge-pill badge-success">In Progress <span class="badge badge-pill badge-warning">{{InProgress.length}}</span></span></h5><h5 class=mr-2><span class="badge badge-pill badge-primary">Placed <span class="badge badge-pill badge-warning">{{Placed.length}}</span></span></h5></div><h6 class="font-weight-bold pt-2">/ <span class="badge badge-pill badge-info">{{Rejected.length+InProgress.length+Placed.length}}</span></h6></div><h4 class="pt-2 ml-4 pl-4">Success Rate: <span class="badge badge-pill badge-info">{{Placed.length/(Rejected.length+Placed.length)*100}}%</span></h4></div><div class=d-flex><ul class="m-0 d-flex flex-wrap marketerCharts w-100"><li ng-repeat="marketerData in selectedMarketerData track by $index" class="col-sm-4 p-2"><div class=d-flex><div class="d-flex flex-column col-sm-2 monthStats p-0"><ul class="m-0 p-0"><li class=bg-danger><span class=text-white>Rejected</span> <span class="text-warning display-4">{{marketerData.statusData[0]}}</span></li><li class=bg-success><span class=text-white>In Progress</span> <span class="text-warning display-4">{{marketerData.statusData[1]}}</span></li><li class=bg-primary><span class=text-white>Placed</span> <span class="text-warning display-4">{{marketerData.statusData[2]}}</span></li></ul></div><div class=col-sm-10><h4 class=text-center><span class="badge badge-pill badge-warning mr-3">{{marketerData.statusData[0]+marketerData.statusData[1]+marketerData.statusData[2]}}</span> in {{marketerData.MonthName}}</h4><canvas id=bar class="chart chart-bar" chart-data=marketerData.statusData chart-labels=labels chart-type=type chart-options=options legends=true></canvas><div class=text-right><button class="btn btn-primary" ng-click=viewMarketerInterviews(marketerData)>View Interviews</button></div></div></div></li></ul></div><div class="d-flex p-4 showAllInterviews" ng-show=showAllInterviews><div class="col-sm-12 pl-0 pr-0"><div id=byMarketerId></div></div></div></div></div></div>');
$templateCache.put('app/components/sales/myInterviewStats/myInterviewStats.component.html','<div class="container-fluid p-0"><md-content><div class="d-flex align-items-center justify-content-between headerMenuWrap pl-4 pt-1 pb-2" style="min-height: 47px;"><div class="d-flex col-5 align-items-center"><select ng-model=SelectedYear class="custom-select custom-select-sm bg-secondary text-white mt-1" style="width: auto;" ng-change=getinterviewdetails(SelectedYear)><option>Select Year</option><option value=2019>2019</option><option value=2020>2020</option></select><div class="d-flex ml-2 mr-2 mt-1"><h5 class="mr-1 pt-2">Snapshot of year {{SelectedYear}}</h5></div></div><div class="d-flex pt-1"><h4 class=mr-2><span class="badge badge-pill badge-danger">Rejected <span class="badge badge-pill badge-warning">{{Rejected.length}}</span></span></h4><h4 class=mr-2><span class="badge badge-pill badge-success">In Progress <span class="badge badge-pill badge-warning">{{New.length}}</span></span></h4><h4 class=mr-2><span class="badge badge-pill badge-primary">Placed <span class="badge badge-pill badge-warning">{{Placed.length}}</span></span></h4></div><!-- <h4 class="font-weight-bold pt-1">\r\n                <span\r\n                    class="badge badge-pill badge-info">{{Rejected.length-1+New.length-1+Placed.length-1}}/12={{Placed.length/12}}</span>\r\n            </h4> --><!-- <canvas id="myChart" width="100" height="60"></canvas> --></div><md-content class="p-2 h-100"><div class=d-flex ng-show=showAllInterviews><div class="col-sm-12 pl-0 pr-0"><div id=byMarketerId></div></div></div></md-content></md-content></div><prevent-actionloader ng-if=topLoader></prevent-actionloader>');
$templateCache.put('app/components/sales/myResources/editHotListDialog.html','<md-dialog aria-label="Edit Hot List User" class=EditSubmissionDialog style="width: 75%;"><form ng-cloak name=editHotl ng-submit="editHotl.$valid && editeditHotlSubmit(hotLuData)"><md-toolbar><div class=md-toolbar-tools><h2>Edit Hot List User</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><md-icon md-svg-src=images/baseline-close-24px.svg aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div layout=row layout-xs=column><div class="form-group col-lg-5 col-sm-12"><label for=Email class="col-lg-4 col-sm-12 col-form-label">Email</label><div class="col-lg-8 col-sm-12"><!-- <input id="Email" name="Email" placeholder="Email" type="email" class="form-control"\r\n                                required="required" ng-model="hotLuData.Email"> --> <input type=email name=Email required ng-model=hotLuData.Email class=form-control placeholder=name@domain.com ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ ng-keyup=checkEmail(hotLuData.Email)> <span style=color:Red , ng-show=editHotl.Email.$dirty&&editHotl.Email.$error.pattern>Please Enter Valid Email</span><p class=text-danger ng-if=userExists>{{existedUser}}</p></div></div><div class="form-group col-lg-8 p-0 col-sm-12 d-flex"><div class="col-lg-6 col-sm-12 p-0"><label for=GKMoveInDate class="col-lg-4 col-sm-12 col-form-label">Date Of Birth</label><div class="col-lg-8 col-sm-12 pl-0"><md-datepicker ng-model=hotLuData.DOB md-placeholder="Select Date" class="ml-2 mr-2" md-open-on-focus md-hide-icons=calendar></md-datepicker></div></div><div class="col-lg-6 col-sm-12 p-0"><label class="col-lg-4 col-sm-12 col-form-label">US Entry Date</label><div class="col-lg-8 col-sm-12 pl-0"><md-datepicker ng-model=hotLuData.USEntryDate md-placeholder="Select Date" class="ml-2 mr-2" md-open-on-focus md-hide-icons=calendar></md-datepicker></div></div></div></div><div layout=row layout-xs=column><div class="form-group col-lg-6 col-sm-12"><label for=VisaStatus class="col-lg-4 col-sm-12 col-form-label">Visa Status</label><div class="col-lg-8 col-sm-12"><select id=select name=select class="custom-select pointer" ng-model=hotLuData.VisaStatus><option ng-value=visaState.VisaId ng-repeat="visaState in visaStatus track by $index" ng-if=visaState.Visa>{{visaState.Visa}}</option></select></div></div><div class="form-group col-lg-6 col-sm-12"><label for=SkillId class="col-lg-4 col-sm-12 col-form-label">Skills Set</label><div class="col-lg-8 col-sm-12"><md-select ng-model=hotLuData.Skillset md-container-class=newresource class="m-0 p-0 skillsDrop"><md-option ng-repeat="item in skills" ng-value=item.SkillId>{{item.Skill}}</md-option><md-optgroup label="Add Skill" ng-click=newSkill() class="fix pointer"></md-optgroup></md-select></div></div></div><div layout=row layout-xs=column><div class="form-group col-lg-6 col-sm-12"><label for="Preferred Location" class="col-lg-4 col-sm-12 col-form-label">Prefer Location</label><div class="col-lg-8 col-sm-12"><input placeholder=City type=text class="form-control mr-1" ng-model=hotLuData.PrefLocation></div></div><div class="form-group col-lg-6 col-sm-12"><label for=GK class="col-lg-4 col-sm-12 col-form-label">GH</label><div class="col-lg-8 col-sm-12 pl-0"><div class="custom-control custom-checkbox custom-control-inline"><md-radio-group ng-model=hotLuData.GK layout=row layout-xs=column><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></md-radio-group></div></div></div></div><div layout=row layout-xs=column><div class="form-group col-lg-6 col-sm-12"><label class=col-12>Is User Experienced</label><div class="col-12 pl-0"><div class="custom-control custom-checkbox custom-control-inline"><md-radio-group ng-model=hotLuData.Exp layout=row layout-xs=column><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></md-radio-group></div></div></div><div class="form-group col-lg-6 col-sm-12"><label for=PhoneNumber class="col-lg-4 col-sm-12 col-form-label">Phone Number</label><div class="col-lg-8 col-sm-12 pl-0"><input id=PhoneNumber name=PhoneNumber placeholder="Phone Number" type=text class=form-control ng-model=hotLuData.PhoneNumber></div></div></div><div layout=row layout-xs=column><div class="form-group col-lg-6 col-sm-12"><label for=SkillId class="col-lg-4 col-sm-12 col-form-label">Recruiter</label><div class="col-lg-8 col-sm-12"><md-select ng-model=hotLuData.marketer md-container-class=newresource class="m-0 p-0 skillsDrop"><md-option ng-repeat="item in marketers" ng-value=item.loginid>{{item.MarkterName}}</md-option></md-select></div></div><div class="form-group col-lg-6 col-sm-12"><label for=ExpectedRate class="col-lg-4 col-sm-12 col-form-label">Minimum Pay Rate</label><div class="col-lg-8 col-sm-12 pl-0"><input id=ExpectedRate name=ExpectedRate placeholder="Expected Rate" type=text class=form-control ng-model=hotLuData.ExpectedRate></div></div></div></div></md-dialog-content><md-dialog-actions layout=row layout-xs=column><md-button type=submit class="md-primary md-raised" ng-show=!editeditHotlSubmitLoader ng-disabled=userExists>Submit</md-button><ci-spinner ng-show=editeditHotlSubmitLoader></ci-spinner></md-dialog-actions></form><div class="p-4 viewSkillAdd" ng-if=viewSkillAdd><form ng-cloak class=sendEmailDialog name=addSkillform ng-submit="addSkillform.$valid && addSkillData(newAddSkill)"><h2>Add Skill</h2><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=subject>Skill Name *</label> <input type=text class=form-control ng-model=newAddSkill name=Skill placeholder="New Skill" required></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row layout-xs=column><md-button ng-click=viewSkillAddClose() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></div></md-dialog>');
$templateCache.put('app/components/sales/myResources/myResources.component.html','<div class=container-fluid><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label="Hot List" md-on-select=getHotList()><md-content><div class="bg-white w-100 d-flex justify-content-end p-2"><input type=text placeholder=Search.. ng-model=searchData ng-keyup=allhotListSearch(searchData) class=form-control><md-menu md-position-mode="target-right target"><md-button aria-label="Open demo menu" class="md-icon-button md-button-no-height" ng-click=$mdMenu.open($event)><i class="material-icons pointer zoom">more_vert</i></md-button><md-menu-content width=4><md-menu-item ng-repeat="item in groupByObj"><md-button ng-click=hotListGroupBy(item.value)><div layout=row flex><p flex>{{item.name}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div><ci-spinner ng-if=preloader></ci-spinner><div id=hoList-table></div></md-content></md-tab><md-tab label=Consultants md-on-select=getConsultants()><md-content class="md-padding p-0"><div class="bg-white w-100 d-flex justify-content-end p-2"><input type=text placeholder=Search.. ng-model=searchData ng-keyup=allConsSearch(searchData) class=form-control><md-menu md-position-mode="target-right target"><md-button aria-label="Group By" class="md-icon-button md-button-no-height" ng-click=$mdMenu.open($event)><i class="material-icons pointer zoom">more_vert</i></md-button><md-menu-content width=4><md-menu-item ng-repeat="item in groupByObj"><md-button ng-click=allConsGroupBy(item.value)><div layout=row flex><p flex>{{item.name}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div><ci-spinner ng-if=topLoader></ci-spinner><div id=allCons-table></div></md-content></md-tab></md-tabs></md-content><div class="modal fade" id=addNewPlacement data-backdrop=static data-keyboard=false tabindex=-1 role=dialog aria-labelledby=staticBackdropLabel aria-hidden=true><div class=modal-dialog><div class=modal-content><div class=modal-header><h5 class=modal-title id=staticBackdropLabel>Why consultant is getting moved from HOTLIST</h5><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body><form name=addNewInterview layout=column ng-submit="addNewInterview.$valid && addPlacement(chaninConData)" class=p-2><md-input-container class="mb-0 mt-0"><md-switch ng-model=projectConfirmed aria-label="Project Confirmed">Is consultant project confirmed?</md-switch></md-input-container><div ng-if=projectConfirmed layout=column><md-input-container flex class=mb-0><label>Title</label><md-select ng-model=chaninConData.TitleId md-container-class=dropdownCustom required><md-option ng-repeat="item in titles" ng-value={{item.TitleId}}>{{item.Title}}</md-option><md-optgroup label="Add Title" ng-click=addTitle() class="fix pointer"></md-optgroup></md-select></md-input-container><md-input-container class=mb-0><label>Client</label><md-select ng-model=chaninConData.ClientId md-container-class=dropdownCustom ng-change=selectedClientAddr(chaninConData.ClientId) required><md-option ng-repeat="item in Clients track by $index" ng-value={{item.ClientId}}>{{item.ClientName}}</md-option><md-optgroup label="Add Client" ng-click=newClient(addClientShow) class="fix pointer"></md-optgroup></md-select></md-input-container><md-input-container class=mb-0><label>Vendor Name</label><md-select ng-model=chaninConData.PVId md-container-class=dropdownCustom ng-change=selectedVendorAddr(chaninConData.PVId) required><md-option ng-repeat="item in Vendors" ng-value=item.vendorModel.VendorId>{{item.vendorModel.VendorName}}</md-option><md-optgroup label="Add Vendor" ng-click=newvendor(addVendorShow) class="fix pointer"></md-optgroup></md-select></md-input-container><md-input-container class=mb-0><label>Mid Vendor Name</label><md-select ng-model=chaninConData.MVId md-container-class=dropdownCustom ng-change=selectedMidVendor(chaninConData.MVId) required><md-option ng-repeat="miditem in MidVendors" ng-value=miditem.vendorModel.VendorId>{{miditem.vendorModel.VendorName}}</md-option><md-optgroup label="Add Vendor" ng-click=newvendor(addVendorShow) class="fix pointer"></md-optgroup></md-select></md-input-container><md-input-container class=mb-0><label>Project Start Date</label><md-datepicker ng-model=chaninConData.StartDate required md-hide-icons=calendar md-open-on-focus></md-datepicker></md-input-container><md-input-container class=mb-0><label>Rate</label> <input type=text ng-model=chaninConData.Rate only-input-numbers required></md-input-container><md-input-container class=mb-0><label>Comments</label> <textarea ng-model=chaninConData.Comments></textarea></md-input-container></div><div class=d-flex><button type=submit class="btn btn-primary ml-2" ng-show="addNewPlacementLoader === false">Submit</button><ci-spinner ng-if=addNewPlacementLoader></ci-spinner></div></form><div class=AddTitle ng-class="addTitleShow ? \'show\':\'hide\'"><div class=modal-custom style=padding:20px;><form ng-cloak name=addTitleform ng-submit="addTitleform.$valid && addTitleSubmit(data)"><h2>Add Title</h2><div class=form-column><div class="form-group col"><label for=TitleName>Title Name *</label> <input type=text class=form-control ng-model=data.Title name=Title placeholder="Title Name" id=TitleName required></div><p class=text-danger>All fields marked with * are required</p></div><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></form></div></div><div class=ccDialg ng-class="addClientShow ? \'show\':\'hide\'"><div class=modal-custom ng-show=addClientShow style=padding:20px;><h2>Add Client</h2><form class=form-column name=addClientform ng-submit="addClientform.$valid && addClientData(addClient)"><div class="form-group col"><label for=subject>Client Name *</label> <input type=text class=form-control ng-model=addClient.ClientName name=subject placeholder=Subject required></div><p class=text-danger>All fields marked with * are required</p><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if="notifier && !afterAddedClient"></ci-spinner><div class="alert alert-info" ng-if=afterAddedClient>Client added Successfully, Please select from the list.</div></form></div></div><div class=addVendorShow ng-class="addVendorShow ? \'show\':\'hide\'"><div class=modal-custom ng-show=addVendorShow style=padding:20px;><h2>Add Vendor</h2><form class=form-column name=addVendorform ng-submit="addVendorform.$valid && addVendorData(addVendor)"><div class="form-group col"><label for=subject>Vendor Name *</label> <input type=text class=form-control ng-model=addVendor.VendorName name=subject placeholder="Vendor Name" required></div><p class=text-danger>All fields marked with * are required</p><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if="notifier && !afterAddedVendor"></ci-spinner><div class="alert alert-info" ng-if=afterAddedVendor>Vendor added Successfully, Please select from the list.</div></form></div></div></div></div></div></div></div>');
$templateCache.put('app/components/sales/myResources/viewDocDialog.html','<style>md-dialog.EditSubmissionDialog {\r\n    max-width: 94%;\r\n    max-height: 100% !important;\r\n    height: 94%;\r\n    border: 10px solid #ccc;\r\n    box-shadow: inset 0px 0px 9px #343a40;\r\n}</style><md-dialog aria-label="Edit Hot List User" class=EditSubmissionDialog><md-dialog-content class=h-100><div class="md-dialog-content p-0 h-100"><div class="d-flex h-100"><div class="form-group col-lg-6 col-md-6 col-sm-12 bg-dark mb-0 p-0"><h3 class="text-white font-weight-bold p-4">Consultant Details</h3><dl class="row text-light m-0 consDetails"><dt class="col-sm-3 text-success">Name</dt><dd class=col-sm-9>{{ConData.FirstName}} {{ConData.LastName}}</dd><hr><dt class="col-sm-3 text-success">Email</dt><dd class=col-sm-9>{{ConData.Email}}</dd><hr><dt class="col-sm-3 text-success">Phone Number</dt><dd class=col-sm-9>{{ConData.PhoneNumber}}</dd><hr><dt class="col-sm-3 text-success">DOB</dt><dd class=col-sm-9><span ng-show="ConData.DOB === null">n/a</span> <span ng-show="ConData.DOB !== null">{{ConData.DOB | moment: \'format\':\'MMM DD, YYYY\'}}</span></dd><hr><dt class="col-sm-3 text-success">Visa Status</dt><dd class=col-sm-9>{{ConData.VisaType}}</dd><hr><dt class="col-sm-3 text-success">Skill</dt><dd class=col-sm-9>{{ConData.Skillset}}</dd><hr><dt class="col-sm-3 text-success">Prefered Location</dt><dd class=col-sm-9>{{ConData.PrefLocation}}</dd><hr><dt class="col-sm-3 text-success">GH</dt><dd class=col-sm-9>{{ConData.GK}}</dd><hr><dt class="col-sm-3 text-success">GKMoveInDate</dt><dd class=col-sm-9><span ng-show="ConData.GKMoveInDate === null">n/a</span> <span ng-show="ConData.GKMoveInDate !== null">{{ConData.GKMoveInDate | moment: \'format\':\'MMM DD, YYYY\'}}</span></dd><hr><dt class="col-sm-3 text-success">Active</dt><dd class=col-sm-9>{{ConData.Active}}</dd><hr><dt class="col-sm-3 text-success">Experienced</dt><dd class=col-sm-9>{{ConData.Exp}}</dd><hr><dt class="col-sm-3 text-success">Education</dt><dd class=col-sm-9>{{ConData.EducationLevel}}</dd><hr><dt class="col-sm-3 text-success">University</dt><dd class=col-sm-9>{{ConData.UnivName}}</dd><hr><dt class="col-sm-3 text-success">SkypeId</dt><dd class=col-sm-9>{{ConData.SkypeId}}</dd><hr><dt class="col-sm-3 text-success">PassportNumber</dt><dd class=col-sm-9>{{ConData.PassportNumber}}</dd><hr><dt class="col-sm-3 text-success">Minimum Pay Rate</dt><dd class=col-sm-9>{{ConData.ExpectedRate}}</dd><hr><dt class="col-sm-3 text-success">US Entry Date</dt><dd class=col-sm-9>{{ConData.USEntryDate}}</dd><hr><dt class="col-sm-3 text-success">Refer By</dt><dd class=col-sm-9>{{ConData.ReferBy}}</dd></dl></div><div class="form-group col-lg-6 col-md-6 col-sm-12 mb-0"><h4 class=p-4>Consultant Documents</h4><div style="overflow-y: auto;min-height: 400px;"><ci-spinner ng-if=GetconsldocsLoader></ci-spinner><dl ng-repeat="conDoc in conDocs track by $index" class=d-flex><dt class=mr-2>File:</dt><dd ng-click=getFile(ConData,conDoc.DocName) class="pointer text-primary"><u>{{conDoc.DocName}}</u></dd></dl></div><div class=container><form name=docUpload ng-submit="docUpload.$valid && uploadFiles(selDocId)"><div class="form-group row"><label for=SkillId class="col-4 col-form-label">Document Type</label><div class=col-8><md-select ng-model=selDocId md-container-class=newresource class="m-0 p-0 skillsDrop" required><md-option ng-repeat="item in docDDs track by $index" ng-value=item.DocId>{{item.DocName}}</md-option><md-optgroup label="Add Doc Type" ng-click=addDoc() class="fix pointer"></md-optgroup></md-select></div></div><div class="form-group row bg-light"><label for=SkillId class="col-4 col-form-label">Upload Documents</label><div class=col-8>Upload Documents for {{User}} <input type=file id=file name=file multiple onchange=angular.element(this).scope().getFileDetails(this) required> <input type=Submit ng-click="" value=Upload ng-show=!uploadActivated class="btn btn-primary"><md-progress-circular ng-show=uploadActivated class=md-hue-2 md-diameter=20px></md-progress-circular></div></div></form></div></div></div><md-button class="md-fab dialogCloseBtnFancy" aria-label="Eat cake" ng-click=cancel()><md-icon md-svg-src=images/baseline-close-24px.svg aria-label="Close dialog"></md-icon></md-button></div><div class="p-4 viewSkillAdd pointer" ng-show=viewDocAdd><form ng-cloak class=sendEmailDialog name=addSkillform ng-submit="addSkillform.$valid && addDocData(newDocDD)"><h2>Add Document Type</h2><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=subject>Doc Name *</label> <input type=text class=form-control ng-model=newDocDD name=Skill placeholder="New Document Type" required></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=viewDocAddClose() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></div></md-dialog-content></md-dialog>');
$templateCache.put('app/components/sales/newResources/addDoc.Dialog.html','<md-dialog aria-label="Add Skill" flex=70><form ng-cloak class=sendEmailDialog name=addSkillform ng-submit="addSkillform.$valid && addDocData(newDocDD)"><md-toolbar><div class=md-toolbar-tools><h2>Add Document Type</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=subject>Doc Name *</label> <input type=text class=form-control ng-model=newDocDD name=Skill placeholder="New Document Type" required></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/sales/newResources/addSkill.Dialog.html','<md-dialog aria-label="Add Skill" flex=70><form ng-cloak class=sendEmailDialog name=addSkillform ng-submit="addSkillform.$valid && addSkillData(newSkill)"><md-toolbar><div class=md-toolbar-tools><h2>Add Skill</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><i class=material-icons aria-label="Close dialog">close</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=subject>Skill Name *</label> <input type=text class=form-control ng-model=newSkill name=Skill placeholder="New Skill" required></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=cancel() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/sales/newResources/newResources.component.html','<div class=container-fluid><div class=row><div class=col-12><form name=newConsultantForm ng-show=!showForm ng-submit="newConsultantForm.$valid && createConsutant(newConsultantData)" class=newresource><div class=card><div class="card-body d-flex flex-wrap mt-3 p-3"><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label for=exampleInputEmail1>Email address</label> <input class="form-control form-control-sm" type=email required ng-model=newConsultantData.Email placeholder=name@domain.com ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ ng-keyup=checkEmail(newConsultantData.Email)> <small class="form-text text-danger" ng-show=newConsultantForm.email.$dirty&&newConsultantForm.email.$error.pattern>Please Enter Valid Email</small> <small class="form-text text-danger" ng-if=userExists>{{existedUser}}</small></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>First name</label> <input class="form-control form-control-sm" required only-letters-input ng-model=newConsultantData.FirstName name=FirstName ng-disabled=userExists></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>Middle name</label> <input class="form-control form-control-sm" ng-model=newConsultantData.MiddleName only-letters-input name=MiddleName ng-disabled=userExists></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>Last Name</label> <input class="form-control form-control-sm" required only-letters-input ng-model=newConsultantData.LastName name=LastName ng-disabled=userExists><div ng-messages=newConsultantData.consultantEmail.$error role=alert><div ng-message-exp="[\'\', \'minlength\', \'maxlength\', \'pattern\']">Your email must be between 10 and 100 characters long and look like an e-mail address.</div></div></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><md-input-container class=md-block flex-gt-sm><md-datepicker required ng-model=newConsultantData.DOB name=dateField md-open-on-focus md-placeholder="Date of Birth" ng-disabled=userExists></md-datepicker></md-input-container></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>Social Security Number</label> <input class="form-control form-control-sm" name=social required only-numbers-input ng-model=newConsultantData.SSN format=(xxx)-xx-9999 maxlength=9><div class=hint ng-if=showHints>###-##-####</div></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>Phone Number</label> <input class="form-control form-control-sm" name=phone required ng-model=newConsultantData.PhoneNumber mask=(999)999-1234 only-numbers-input minlength=10 maxlength=20></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>Alternate Number</label> <input class="form-control form-control-sm" name=phone ng-model=newConsultantData.OtherPhoneNumber only-numbers-input minlength=10 maxlength=20></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>Skype Id</label> <input class="form-control form-control-sm" required alpha-num ng-model=newConsultantData.SkypeId></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><md-select placeholder="Skill Set" required ng-model=newConsultantData.SkillId md-on-open=loadUsers() style="min-width: 200px;" md-container-class=dropdownCustom><md-option ng-repeat="item in skills" ng-value=item.SkillId>{{ item.Skill }}</md-option><md-optgroup label="Add Skill" ng-click=newSkill() class="fix pointer"></md-optgroup></md-select><div class="alert alert-danger" ng-show=formIsValid>All fields marked with (<b>*</b>) are mandatory.</div></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>Minimum Pay Rate</label> <input class="form-control form-control-sm" required ng-model=newConsultantData.ExpectedRate type=number></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>Address</label> <input class="form-control form-control-sm" required ng-model=newConsultantData.AddrInfo.Street></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>City</label> <input class="form-control form-control-sm" required only-letters-input ng-model=newConsultantData.AddrInfo.City></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>State</label> <select class="form-control form-control-sm" required ng-model=newConsultantData.AddrInfo.State name=State><option value="">Choose...</option><option ng-repeat="state in states" value={{state.abbreviation}}>{{state.abbreviation}}</option></select><!-- <input class="form-control form-control-sm" required only-letters-input\r\n                                    ng-model="newConsultantData.AddrInfo.State" /> --></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>Postal Code</label> <input class="form-control form-control-sm" name=postalCode only-numbers-input ng-model=newConsultantData.AddrInfo.Zipcode placeholder=12345></div></div><div class="col-12 d-flex"><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><md-radio-group ng-model=newConsultantData.ListOfEdu><div class=row><div class="col-12 d-flex align-items-center justify-content-start"><h3>Education<sup class=text-muted>*</sup></h3><md-checkbox ng-model=newConsultantData.ListOfEdu[0].Type aria-label="Checkbox 1" ng-true-value="\'Bachelors\'" ng-false-value="\'\'" ng-required=!newConsultantData.ListOfEdu[1].Type class="mb-0 ml-3">Bachelors</md-checkbox><md-checkbox ng-model=newConsultantData.ListOfEdu[1].Type aria-label="Checkbox 1" ng-true-value="\'Masters\'" ng-false-value="\'\'" ng-required=!newConsultantData.ListOfEdu[0].Type class="mb-0 ml-3">Masters</md-checkbox></div></div></md-radio-group></div></div></div><div class="col-12 d-flex"><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3" ng-show="newConsultantData.ListOfEdu[0].Type == \'Bachelors\'"><div class=form-group><label>University Name</label> <input class="form-control form-control-sm" only-letters-input ng-required=newConsultantData.ListOfEdu[0].Type ng-model=newConsultantData.ListOfEdu[0].UniversityName></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3" ng-show="newConsultantData.ListOfEdu[0].Type == \'Bachelors\'"><div class=form-group><label>Specialization</label> <input class="form-control form-control-sm" only-letters-input ng-required=newConsultantData.ListOfEdu[0].Type ng-model=newConsultantData.ListOfEdu[0].Major ng-model=newConsultantData.ListOfEdu[0].UniversityName></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3" ng-show="newConsultantData.ListOfEdu[0].Type == \'Bachelors\'"><div class=form-group><md-input-container><md-datepicker aria-=true ng-model=newConsultantData.ListOfEdu[0].YearOfCompletion md-open-on-focus md-hide-icons=calendar md-placeholder="Passed Out Year" class="ml-2 mr-2" md-open-on-focus ng-required=newConsultantData.ListOfEdu[0].Type></md-datepicker></md-input-container></div><input class="form-control form-control-sm" type=text style="visibility: hidden" value=Bachelors ng-model=newConsultantData.ListOfEdu[0].Type></div></div><div class="col-12 d-flex"><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3" ng-show="newConsultantData.ListOfEdu[1].Type == \'Masters\'"><div class=form-group><label>University Name</label> <input class="form-control form-control-sm" only-letters-input ng-model=newConsultantData.ListOfEdu[1].UniversityName ng-required=newConsultantData.ListOfEdu[1].Type></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3" ng-show="newConsultantData.ListOfEdu[1].Type == \'Masters\'"><div class=form-group><label>Specialization</label> <input class="form-control form-control-sm" only-letters-input ng-model=newConsultantData.ListOfEdu[1].Major ng-required=newConsultantData.ListOfEdu[1].Type></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3" ng-show="newConsultantData.ListOfEdu[1].Type == \'Masters\'"><div class=form-group><md-input-container><md-datepicker aria-=true ng-required=newConsultantData.ListOfEdu[1].Type ng-model=newConsultantData.ListOfEdu[1].YearOfCompletion md-open-on-focus md-hide-icons=calendar md-placeholder="Passed Out Year" class="ml-2 mr-2" md-open-on-focus></md-datepicker></md-input-container></div><input class="form-control form-control-sm" type=text style="visibility: hidden" value=Masters ng-model=newConsultantData.ListOfEdu[1].Type></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>Priority</label> <select required ng-model=newConsultantData.priority ng-disabled=userExists class="form-control form-control-sm"><option ng-repeat="Prioritie in Priorities" ng-value=Prioritie.id>{{ Prioritie.value }}</option></select></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><md-select placeholder="Visa Status" required ng-model=newConsultantData.VisaStatus md-on-open=loadUsers() style="min-width: 200px;" ng-disabled=userExists><md-option ng-value=visaState.VisaId ng-repeat="visaState in visaStatus track by $index" ng-if=visaState.Visa>{{ visaState.Visa }}</md-option></md-select></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><label>Passport Number</label> <input class="form-control form-control-sm" name=phone alpha-num ng-model=newConsultantData.PassportNumber></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><md-radio-group required ng-model=newConsultantData.Exp><div flex layout=row layout-padding layout-align="start center"><div flex style=max-width:200px;>Experienced User?</div><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></div></md-radio-group></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><md-radio-group required ng-model=newConsultantData.GK><div flex layout=row layout-padding layout-align="start center"><div flex style=max-width:200px;>Residing in GH?</div><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></div></md-radio-group></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3" ng-if="newConsultantData.GK !== \'false\'"><div class=form-group><md-input-container class=md-block flex-gt-sm><md-datepicker aria-=true ng-required="newConsultantData.GK == \'true\'" ng-model=newConsultantData.GKMoveInDate md-open-on-focus ng-class="newConsultantData.GK !== \'true\'?\'disabled\':\'\'" ng-disabled="newConsultantData.GK !== \'true\'" md-placeholder="GH Move In Date" class="ml-2 mr-2" md-open-on-focus></md-datepicker></md-input-container></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><md-radio-group required ng-model=newConsultantData.relocate><div flex layout=row layout-padding layout-align="start center"><div flex style=max-width:200px;>Prefer to relocate?</div><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></div></md-radio-group></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3" ng-if="newConsultantData.relocate == \'false\'"><div class=form-group><label>What are Preferred Locations?</label> <input class="form-control form-control-sm" required ng-model=newConsultantData.PrefLocation ng-required="newConsultantData.relocate == \'false\'"></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><div flex style=max-width:200px;>Recruited by</div><!-- <input class="form-control form-control-sm" required ng-model="newConsultantData.Recuriterid" readonly /> --><md-select ng-model=newConsultantData.Recuriterid required><md-option ng-value=marketer.loginid ng-repeat="marketer in marketers">{{marketer.MarkterName}}</md-option></md-select></div></div><div class="col-sm-12 col-md-2 col-lg-4 col-xl-3"><div class=form-group><md-input-container><md-datepicker aria-=true ng-model=newConsultantData.USEntryDate md-open-on-focus md-placeholder="US Entry Date" class="ml-2 mr-2" md-open-on-focus></md-datepicker></md-input-container></div></div></div><div class=card-footer><div class="alert alert-danger" ng-if=newConsultantForm.$invalid&&newConsultantForm.$dirty&&newConsultantForm.$touched>All fields marked with (*) are Required.</div><div class=row><ci-spinner ng-if=addConsLoader></ci-spinner><md-button type=submit ng-show=!addConsLoader ng-disabled=newConsultantForm.$invalid class="md-raised md-primary">Submit</md-button></div></div></div></form><ci-spinner ng-if=addConsLoader></ci-spinner><div class=hide id=success><div class=success-wrap><p class="alert alert-info">Consultant added successfully....</p><div><div class=container><form name=docsForm ng-submit="docsForm.$valid && uploadFiles(selDocId)"><div class="form-group row"><label for=SkillId class="col-4 col-form-label">Document Type</label><div class=col-8><md-select required ng-model=selDocId name=selDocId md-container-class=newresource class="m-0 p-0 skillsDrop" required ng-change=selDocIdChange(selDocId)><md-option ng-repeat="item in docDDs" ng-value=item.DocId>{{item.DocName}}</md-option><md-optgroup label="Add Doc Type" ng-click=addDoc() class=fix></md-optgroup></md-select><div ng-messages=docsForm.selDocId.$error><div ng-message=required class=text-danger>This is required!</div></div></div></div><div class="form-group row"><label for=SkillId class="col-4 col-form-label">Upload Documents</label><div class=col-8>Upload Documents for {{USer}} <input class="form-control form-control-sm" type=file id=file name=file multiple onchange=angular.element(this).scope().getFileDetails(this) required> <input class="form-control form-control-sm" type=submit value=Upload class="btn btn-primary btn-small" ng-disabled="selDocId === undefined"><!--ADD A PROGRESS BAR ELEMENT.--><p><progress id=pro value=0></progress></p></div></div></form></div><button class="btn btn-primary" type=button ng-click=addnewConsultantForm()>Add New Consultant</button> <button class="btn btn-primary" type=button ui-sref=myResources()>Goto Consultants</button></div></div></div><div class=hide id=error><div class=error-wrap><h2 class=confirmation-text>Error</h2><p>There was an error when attempting to submit your request.<br>Please try again later.</p><p><strong>*This will always error until a web service URL is set.*</strong></p><div><button type=button class="btn btn-danger" ng-click=reset()>Try again</button></div></div></div></div></div></div><jobpostings></jobpostings>');
$templateCache.put('app/components/sales/newResources/newResources.directive.html','<md-card class=col-sm-12 style="width: max-content;"><ul id=progressbar><li ng-class="{active: vm.stage0}">Personal Details</li><li ng-class="{active: vm.stage1}">Contact Details</li><li ng-class="{active: vm.stage2}">Educational Details</li><li ng-class="{active: vm.stage3}">Passport Details</li><li ng-class="{active: vm.stage4}">Relocation Details</li></ul><div class=animate-switch-container ng-switch on=stage ng-class="{forward: direction, backward:!direction}"><form name=newConsultantForm ng-submit="newConsultantForm.$valid && createConsutant(newConsultantData)" class=newresource><div class=animate-switch ng-switch-default><!-- <div class="animate-switch" ng-switch-when="stage1"> --><div class=row><div class=col-md-12><!-- <h4 class="m-4 pb-1">Personal Details</h4> --><div layout=column><md-input-container class=md-block flex-gt-sm><label>Email</label> <input type=email name=email required ng-model=newConsultantData.Email placeholder=name@domain.com ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ ng-keyup=checkEmail(newConsultantData.Email)> <span style=color:Red ng-show=newConsultantForm.email.$dirty&&newConsultantForm.email.$error.pattern>Please Enter Valid Email</span><p class=text-danger ng-if=userExists>{{existedUser}}</p></md-input-container><md-input-container class=md-block flex-gt-sm ng-hide=userExists><label>First name</label> <input required ng-model=newConsultantData.FirstName name=FirstName ng-disabled=userExists><div ng-messages=newConsultantData.consultantEmail.$error role=alert><div ng-message-exp="[\'\', \'minlength\', \'maxlength\', \'pattern\']">Your email must be between 10 and 100 characters long and look like an e-mail address.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm ng-hide=userExists><label>Middle name</label> <input ng-model=newConsultantData.MiddleName name=MiddleName ng-disabled=userExists></md-input-container><md-input-container class=md-block flex-gt-sm ng-hide=userExists><label>Last Name</label> <input required ng-model=newConsultantData.LastName name=LastName ng-disabled=userExists><div ng-messages=newConsultantData.consultantEmail.$error role=alert><div ng-message-exp="[\'\', \'minlength\', \'maxlength\', \'pattern\']">Your email must be between 10 and 100 characters long and look like an e-mail address.</div></div></md-input-container><md-input-container class=md-block flex-gt-sm ng-hide=userExists><label>Date of Birth</label><md-datepicker required ng-model=newConsultantData.DOB name=dateField md-open-on-focus md-hide-icons=calendar md-min-date=ctrl.minDate md-max-date=consultantMaxDOB ng-disabled=userExists></md-datepicker></md-input-container><div class="alert alert-danger" ng-show=formIsValid>All fields marked with (<b>*</b>) are mandatory.</div></div><button type=button class="btn btn-primary" ng-click="next(newConsultantForm,\'stage1\')" ng-hide=userExists>Next</button></div></div></div><!-- <div class="animate-switch" ng-switch-default> --><div class=animate-switch ng-switch-when=stage1><div layout=column><md-input-container class=md-block flex-gt-sm><label>Social Security Number</label> <input name=social required ng-model=newConsultantData.SSN masked format=(xxx)-xx-9999><div class=hint ng-if=showHints>###-##-####</div></md-input-container><md-input-container class=md-block flex-gt-sm><label>Phone Number</label> <input name=phone required ng-model=newConsultantData.PhoneNumber mask=(999)999-1234 only-numbers-input minlength=10 maxlength=20></md-input-container><md-input-container class=md-block flex-gt-sm><label>Alternate Number</label> <input name=phone ng-model=newConsultantData.OtherPhoneNumber only-numbers-input minlength=10 maxlength=20></md-input-container><md-input-container class=md-block flex-gt-sm><label>Skype Id</label> <input required ng-model=newConsultantData.SkypeId></md-input-container><md-input-container class=md-block flex-gt-sm><md-select placeholder="Skill Set" required ng-model=newConsultantData.SkillId md-on-open=loadUsers() style="min-width: 200px;"><md-option ng-repeat="item in skills" ng-value=item.SkillId>{{ item.Skill }}</md-option><md-optgroup label="Add Skill" ng-click=newSkill() class="fix pointer"></md-optgroup></md-select><div class="alert alert-danger" ng-show=formIsValid>All fields marked with (<b>*</b>) are mandatory.</div></md-input-container></div><button type=button class="btn btn-info" ng-click="back(\'\')">Back</button> <button type=button class="btn btn-primary" ng-click="next(newConsultantForm,\'stage2\')">Next</button></div><div class=animate-switch ng-switch-when=stage2><!-- <div class="animate-switch" ng-switch-default> --><div layout=column><md-input-container class=md-block flex-gt-sm><label>Expected Rate</label> <input required ng-model=newConsultantData.ExpectedRate type=number></md-input-container><md-radio-group ng-model=newConsultantData.ListOfEdu><div class=row><div flex layout=row layout-padding layout-align="start center"><div flex style=max-width:200px; class=md-title>Education <sup class=text-muted>*</sup></div><md-checkbox ng-model=newConsultantData.ListOfEdu[0].Type aria-label="Checkbox 1" ng-true-value="\'Bachelors\'" ng-false-value="\'\'" ng-required=!newConsultantData.ListOfEdu[1].Type>Bachelors</md-checkbox><md-checkbox ng-model=newConsultantData.ListOfEdu[1].Type aria-label="Checkbox 1" ng-true-value="\'Masters\'" ng-false-value="\'\'" ng-required=!newConsultantData.ListOfEdu[0].Type>Masters</md-checkbox></div></div></md-radio-group><div layout-gt-sm=row ng-show="newConsultantData.ListOfEdu[0].Type == \'Bachelors\'"><md-input-container class=md-block flex-gt-sm><label>University Name</label> <input ng-required=newConsultantData.ListOfEdu[0].Type ng-model=newConsultantData.ListOfEdu[0].UniversityName></md-input-container><md-input-container class=md-block flex-gt-sm><label>Specialization</label> <input ng-required=newConsultantData.ListOfEdu[0].Type ng-model=newConsultantData.ListOfEdu[0].Major ng-model=newConsultantData.ListOfEdu[0].UniversityName></md-input-container><md-input-container class=md-block flex-gt-sm><md-datepicker aria-=true ng-model=newConsultantData.ListOfEdu[0].YearOfCompletion md-open-on-focus md-hide-icons=calendar md-placeholder="Passed Out Year" class="ml-2 mr-2" md-open-on-focus ng-required=newConsultantData.ListOfEdu[0].Type></md-datepicker></md-input-container><input type=text style="visibility: hidden" value=Bachelors ng-model=newConsultantData.ListOfEdu[0].Type></div><!-- Vendor --><div layout-gt-sm=row ng-show="newConsultantData.ListOfEdu[1].Type == \'Masters\'"><md-input-container class=md-block flex-gt-sm><label>University Name</label> <input ng-model=newConsultantData.ListOfEdu[1].UniversityName ng-required=newConsultantData.ListOfEdu[1].Type></md-input-container><md-input-container class=md-block flex-gt-sm><label>Specialization</label> <input ng-model=newConsultantData.ListOfEdu[1].Major ng-required=newConsultantData.ListOfEdu[1].Type></md-input-container><md-input-container class=md-block flex-gt-sm><md-datepicker aria-=true ng-required=newConsultantData.ListOfEdu[1].Type ng-model=newConsultantData.ListOfEdu[1].YearOfCompletion md-open-on-focus md-hide-icons=calendar md-placeholder="Passed Out Year" class="ml-2 mr-2" md-open-on-focus></md-datepicker></md-input-container><input type=text style="visibility: hidden" value=Masters ng-model=newConsultantData.ListOfEdu[1].Type></div><div layout-gt-sm=row><h3>Communication Address</h3><md-input-container class=md-block flex-gt-sm><label>Address</label> <input required ng-model=newConsultantData.AddrInfo.Street></md-input-container><md-input-container class=md-block flex-gt-sm><label>City</label> <input required ng-model=newConsultantData.AddrInfo.City></md-input-container><md-input-container class=md-block flex-gt-sm><label>State</label> <input required ng-model=newConsultantData.AddrInfo.State></md-input-container><md-input-container class=md-block flex-gt-sm><label>Postal Code</label> <input name=postalCode ng-model=newConsultantData.AddrInfo.Zipcode placeholder=12345><!-- <div ng-messages="userForm.postalCode.$error" role="alert" multiple>\r\n                                            <div ng-message="" class="my-message">\r\n                                                You must supply a postal code.\r\n                                            </div>\r\n                                            <div ng-message="pattern" class="my-message">\r\n                                                That doesn\'t look like a valid postal code.\r\n                                            </div>\r\n                                            <div ng-message="md-maxlength" class="my-message">\r\n                                                Don\'t use the long version silly...we don\'t need to be that\r\n                                                specific...\r\n                                            </div>\r\n                                        </div> --></md-input-container></div><div class="alert alert-danger" ng-show=formIsValid>All fields marked with (<b>*</b>) are mandatory.</div></div><button type=button class="btn btn-info" ng-click="back(\'stage1\')">Back</button> <button type=button class="btn btn-primary" ng-click="next(newConsultantForm,\'stage3\')">Next</button></div><div class=animate-switch ng-switch-when=stage3><div layout=column><md-input-container class=md-block flex-gt-sm><label>Priority</label><md-select required ng-model=newConsultantData.priority ng-disabled=userExists><md-option ng-repeat="Prioritie in Priorities" value="{{ Prioritie.id }}">{{ Prioritie.value }}</md-option></md-select></md-input-container><md-input-container class=md-block flex-gt-sm><md-select placeholder="Visa Status" required ng-model=newConsultantData.VisaStatus md-on-open=loadUsers() style="min-width: 200px;" ng-disabled=userExists><md-option ng-value=visaState.VisaId ng-repeat="visaState in visaStatus track by $index" ng-if=visaState.Visa>{{ visaState.Visa }}</md-option></md-select></md-input-container><md-input-container class=md-block flex-gt-sm><label>Passport Number</label><!-- <input\r\n                      name="phone"\r\n                      ng-model="newConsultantData.PassportNumber"\r\n                      ng-pattern="/^[(][0-9]{3}[)] [0-9]{3}-[0-9]{4}$/"\r\n                    /> --> <input name=phone ng-model=newConsultantData.PassportNumber><div class=hint ng-show=showHints>(###) ###-####</div><div ng-messages=userForm.phone.$error ng-hide=showHints><div ng-message=pattern>(###) ###-#### - Please enter a valid phone number.</div></div></md-input-container><div class="alert alert-danger" ng-show=formIsValid>All fields marked with (<b>*</b>) are mandatory.</div></div><button type=button class="btn btn-info mt-4" ng-click="back(\'stage2\')">Back</button> <button type=button class="btn btn-primary mt-4" ng-click="next(newConsultantForm,\'stage4\')">Next</button></div><div class=animate-switch ng-switch-when=stage4><md-input-container class=md-block flex-gt-sm><md-radio-group required ng-model=newConsultantData.Exp><div flex layout=row layout-padding layout-align="start center"><div flex style=max-width:200px;>Experienced User?</div><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></div></md-radio-group></md-input-container><md-input-container class=md-block flex-gt-sm><md-radio-group required ng-model=newConsultantData.GK><div flex layout=row layout-padding layout-align="start center"><div flex style=max-width:200px;>Residing in GH?</div><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></div></md-radio-group></md-input-container><md-input-container class=md-block flex-gt-sm ng-if="newConsultantData.GK !== \'false\'"><md-datepicker aria-=true ng-required="newConsultantData.GK == \'true\'" ng-model=newConsultantData.GKMoveInDate md-open-on-focus ng-class="newConsultantData.GK !== \'true\'?\'disabled\':\'\'" ng-disabled="newConsultantData.GK !== \'true\'" md-hide-icons=calendar md-placeholder="GH Move In Date" class="ml-2 mr-2" md-open-on-focus></md-datepicker></md-input-container><md-input-container class=md-block flex-gt-sm><md-radio-group required ng-model=newConsultantData.relocate><div flex layout=row layout-padding layout-align="start center"><div flex style=max-width:200px;>Prefer to relocate?</div><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></div></md-radio-group></md-input-container><md-input-container class=md-block flex-gt-sm ng-if="newConsultantData.relocate == \'false\'"><label>What are Preferred Locations?</label> <input required ng-model=newConsultantData.PrefLocation ng-required="newConsultantData.relocate == \'false\'"></md-input-container><md-input-container class=md-block flex-gt-sm><div flex style=max-width:200px;>Recruited by</div><!-- <input required ng-model="newConsultantData.Recuriterid" readonly /> --><md-select ng-model=newConsultantData.Recuriterid required><md-option ng-value=marketer.loginid ng-repeat="marketer in marketers">{{marketer.MarkterName}}</md-option></md-select></md-input-container><div class="alert alert-danger" ng-if=newConsultantForm.$invalid>All fields marked with (*) are Required.</div><md-card-actions layout=row layout-align="end center"><button type=button class="btn btn-info" ng-click="back(\'stage3\')" ng-if=!ffsub>Back</button><ci-spinner ng-if=addConsLoader></ci-spinner><md-button type=submit ng-show=!addConsLoader ng-disabled=newConsultantForm.$invalid class="md-raised md-primary">Submit</md-button></md-card-actions><ci-spinner ng-if=ffsub></ci-spinner></div></form><div class=animate-switch ng-switch-when=success><div class=success-wrap><p class="alert alert-info">Consultant added successfully....</p><div><div class=container><form name=docsForm ng-submit="docsForm.$valid && uploadFiles(selDocId)"><div class="form-group row"><label for=SkillId class="col-4 col-form-label">Document Type</label><div class=col-8><md-select required ng-model=selDocId name=selDocId md-container-class=newresource class="m-0 p-0 skillsDrop" required ng-change=selDocIdChange(selDocId)><md-option ng-repeat="item in docDDs" ng-value=item.DocId>{{item.DocName}}</md-option><md-optgroup label="Add Doc Type" ng-click=addDoc() class=fix></md-optgroup></md-select><div ng-messages=docsForm.selDocId.$error><div ng-message=required class=text-danger>This is required!</div></div></div></div><div class="form-group row"><label for=SkillId class="col-4 col-form-label">Upload Documents</label><div class=col-8>Upload Documents for {{USer}} <input type=file id=file name=file multiple onchange=angular.element(this).scope().getFileDetails(this) required> <input type=submit value=Upload class="btn btn-primary btn-small" ng-disabled="selDocId === undefined"><!--ADD A PROGRESS BAR ELEMENT.--><p><progress id=pro value=0></progress></p></div></div></form></div><button class="btn btn-primary" type=button ng-click="next(newConsultantForm,\'Skip\')">Add New Consultant</button> <button class="btn btn-primary" type=button ui-sref=myResources()>Goto Consultants</button></div></div></div><div class=animate-switch ng-switch-when=error><div class=error-wrap><h2 class=confirmation-text>Error</h2><p>There was an error when attempting to submit your request.<br>Please try again later.</p><p><strong>*This will always error until a web service URL is set.*</strong></p><div><button type=button class="btn btn-danger" ng-click=reset()>Try again</button></div></div></div></div></md-card>');
$templateCache.put('app/components/sales/placements/placements.component.html','<div class="container-fluid mt-2"><div class=row><div class=col-lg-12><ci-spinner ng-if=placementsLoader></ci-spinner><div id=placedCons></div><div class=table-responsive ng-if=!placementsLoader></div></div></div></div>');
$templateCache.put('app/components/sales/placements/viewDocDialog.html','<md-dialog aria-label="Edit Hot List User" class=EditSubmissionDialog><div class=md-dialog-content><div class=row><div class="form-group col-lg-6 col-md-6 col-sm-12 bg-dark pb-4"><h4 class="text-primary p-4">Consultant Details</h4><dl class="row text-light m-0 consDetails"><dt class="col-sm-3 text-success">Name</dt><dd class=col-sm-9>{{ConData.EmployeeName}}</dd><hr><dt class="col-sm-3 text-success">Title</dt><dd class=col-sm-9>{{ConData.TitleName}}</dd><hr><dt class="col-sm-3 text-success">Rate</dt><dd class=col-sm-9>{{ConData.Rate}}</dd><hr><dt class="col-sm-3 text-success">Start Date</dt><dd class=col-sm-9><span ng-show="ConData.PStartDate === null">n/a</span> <span ng-show="ConData.PStartDate !== null">{{ConData.PStartDate | moment: \'format\':\'MMM DD, YYYY\'}}</span></dd><hr><dt class="col-sm-3 text-success">Client</dt><dd class=col-sm-9>{{ConData.ClientName}}</dd><hr><dt class="col-sm-3 text-success">Primary Vendor</dt><dd class=col-sm-9>{{ConData.PrimeVendorName}}</dd><hr><dt class="col-sm-3 text-success">Mid Vendor</dt><dd class=col-sm-9>{{ConData.MidVendorName}}</dd><hr><dt class="col-sm-3 text-success">Marketer</dt><dd class=col-sm-9>{{ConData.MarkterName}}</dd><hr><dt class="col-sm-3 text-success">Comments</dt><dd class=col-sm-9>{{ConData.Comments}}</dd></dl></div><div class="form-group col-lg-6 col-md-6 col-sm-12 mb-0"><h4 class=p-4>Consultant Documents</h4><div><dl ng-repeat="conDoc in conDocs track by $index" class=d-flex><dt class=mr-2>File:</dt><dd ng-click=getFile(ConData,conDoc.DocName) class="pointer text-primary"><u>{{conDoc.DocName}}</u></dd></dl></div><div class=container><form name=docUpload ng-submit="docUpload.$valid && uploadFiles(selDocId)"><div class="form-group row"><label for=SkillId class="col-4 col-form-label">Document Type</label><div class=col-8><md-select ng-model=selDocId md-container-class=newresource class="m-0 p-0 skillsDrop" required><md-option ng-repeat="item in docDDs track by $index" ng-value=item.DocId>{{item.DocName}}</md-option><md-optgroup label="Add Doc Type" ng-click=addDoc() class="fix pointer"></md-optgroup></md-select></div></div><div class="form-group row bg-light"><label for=SkillId class="col-4 col-form-label">Upload Documents</label><div class=col-8>Upload Documents for {{User}} <input type=file id=file name=file multiple onchange=angular.element(this).scope().getFileDetails(this) required> <input type=Submit ng-click="" value=Upload ng-show=!uploadActivated class="btn btn-primary"><md-progress-circular ng-show=uploadActivated class=md-hue-2 md-diameter=20px></md-progress-circular><!--ADD A PROGRESS BAR ELEMENT.--><p><progress id=pro value=0></progress></p></div></div></form></div></div></div><md-button class="md-fab dialogCloseBtnFancy" aria-label="Eat cake" ng-click=cancel()><md-icon md-svg-src=images/baseline-close-24px.svg aria-label="Close dialog"></md-icon></md-button></div><div class="p-4 viewSkillAdd" ng-show=viewDocAdd><form ng-cloak class=sendEmailDialog name=addSkillform ng-submit="addSkillform.$valid && addDocData(newDocDD)"><h2>Add Document Type</h2><md-dialog-content><div class=md-dialog-content><div class=form-column><div class="form-group col"><label for=subject>Doc Name *</label> <input type=text class=form-control ng-model=newDocDD name=Skill placeholder="New Document Type" required></div><p class=text-danger>All fields marked with * are required</p></div></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=viewDocAddClose() ng-if=!notifier>Cancel</md-button><md-button type=submit class="md-primary md-raised" ng-if=!notifier>Submit</md-button><ci-spinner ng-if=notifier></ci-spinner></md-dialog-actions></form></div></md-dialog>');
$templateCache.put('app/components/sales/submissionAdd/submissionAdd.component.html','<div class=container-fluid><div class="d-flex flex-column" id=addSubm><h4 class="m-4 pl-1">Add Submission</h4><div class=col-sm-6><form name=newSubmissionForm ng-submit="newSubmissionForm.$valid && newSubmissionFormSubmit(newSubmissionData)" class=addSub><div class="form-group row"><label for=GKMoveInDate class="col-4 col-form-label">Date Of Submission</label><div class="col-8 pl-0"><md-datepicker aria-required=true ng-model=newSubmissionData.SubmittedDate md-placeholder="Select Date" class="ml-2 mr-2" md-open-on-focus></md-datepicker></div></div><div class="form-group row"><label for=SkillId class="col-4 col-form-label">Select Consultant</label><div class=col-8><md-select ng-model=newSubmissionData.ConslId md-container-class="" class="m-0 p-0 skillsDrop" required><md-option ng-repeat="consultant in consultants" ng-value=consultant.ConslId>{{consultant.FirstName}} {{consultant.LastName}}</md-option></md-select></div></div><div class="form-group row"><label for=MiddleName class="col-4 col-form-label">Technology</label><div class=col-8><md-select ng-model=newSubmissionData.SkillId md-container-class=addSub class="m-0 p-0 skillsDrop"><md-option ng-repeat="item in skills" ng-value=item.SkillId>{{item.Skill}}</md-option><md-optgroup label="Add Technology" ng-click=newSkill() class="fix pointer"></md-optgroup></md-select></div></div><div class="form-group row"><label for=VendorName class="col-4 col-form-label">Vendor Name</label><div class=col-8><input id=VendorName name=VendorName placeholder="Vendor Name" type=text class=form-control required ng-model=newSubmissionData.VendorName></div></div><div class="form-group row"><label for=VendorEmail class="col-4 col-form-label">Vendor Email</label><div class=col-8><input id=VendorEmail name=VendorEmail placeholder="Vendor Email" type=email class=form-control required ng-model=newSubmissionData.VendorEmail></div></div><div class="form-group row"><label for=PhoneNumber class="col-4 col-form-label">Vendor Phone Number</label><div class=col-8><input id=PhoneNumber name=PhoneNumber placeholder="Phone Number" type=text class=form-control required ng-model=newSubmissionData.PhoneNumber only-numbers-input minlength=10 maxlength=10></div></div><div class="form-group row"><label for=SubLocation class="col-4 col-form-label">Location</label><div class=col-8><input id=SubLocation placeholder=Location type=text class=form-control required ng-model=newSubmissionData.SubLocation></div></div><div class="form-group row"><label for=Rate class="col-4 col-form-label">Rate</label><div class=col-8><input id=Rate name=Rate placeholder=Rate type=number class=form-control required ng-model=newSubmissionData.Rate></div></div><div class="form-group row"><label for=CurrentLocation class="col-4 col-form-label">Client</label><div class=col-8><input id=CurrentLocation name=CurrentLocation placeholder="Client Name" type=text class=form-control required ng-model=newSubmissionData.Client></div></div><div class="form-group row"><label for=Client class="col-4 col-form-label">Status</label><div class=col-8><select name=select class="custom-select pointer" required ng-model=newSubmissionData.StatusId><option ng-value=status.id ng-repeat="status in statuses track by $index">{{status.status}}</option></select></div></div><div class="form-group row"><label for=VisaStatus class="col-4 col-form-label">Mode Of Interview</label><div class=col-8><select name=select class="custom-select pointer" required ng-model=newSubmissionData.ModeOfInterview><option ng-value=InterviewMode.id ng-repeat="InterviewMode in InterviewModes track by $index">{{InterviewMode.mode}}</option></select></div></div><div class="form-group row"><label for=GKMoveInDate class="col-4 col-form-label">Interview Date</label><div class="col-8 pl-0"><md-datepicker aria-required=true ng-model=newSubmissionData.InterviewDate md-placeholder="Select Date" class="ml-2 mr-2" md-open-on-focus></md-datepicker></div></div><div class="form-group row"><label class=col-4>Is Interview Confirmed</label><div class="col-8 pl-0"><div class="custom-control custom-checkbox custom-control-inline"><md-radio-group ng-model=newSubmissionData.InterviewConfirmed layout=row><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></md-radio-group></div></div></div><div class="form-group row"><label class=col-4>MidVendor Called</label><div class="col-8 pl-0"><div class="custom-control custom-checkbox custom-control-inline"><md-radio-group ng-model=newSubmissionData.MidVendorCalled layout=row><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></md-radio-group></div></div></div><div class="form-group row"><label class=col-4>PrimeVendor Called</label><div class="col-8 pl-0"><div class="custom-control custom-checkbox custom-control-inline"><md-radio-group ng-model=newSubmissionData.PrimeVendorCalled layout=row><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></md-radio-group></div></div></div><div class="form-group row"><label for=Major class="col-4 col-form-label">Remarks</label><div class=col-8><textarea name="" cols=30 rows=2 ng-model=newSubmissionData.Comments class=form-control></textarea></div></div><div class="form-group row"><div class="offset-5 col-7"><button name=submit type=submit class="btn btn-primary" ng-show=!submitLoader>Submit</button><ci-spinner ng-if=submitLoader></ci-spinner></div></div></form></div></div></div>');
$templateCache.put('app/components/sales/submissionDashboard/editsubmissionDialog.html','<md-dialog aria-label="Edit Submission" class=EditSubmissionDialog><form name=editSub ng-submit="editSub.$valid && editSubSubmit(sub)"><md-toolbar><div class=md-toolbar-tools><h2>Edit Submission</h2><span flex></span><md-button class=md-icon-button ng-click=cancel()><md-icon md-svg-src=images/baseline-close-24px.svg aria-label="Close dialog"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div layout=row><md-input-container class=md-block flex-gt-sm><label>Location</label> <input type=text ng-model=sub.SubLocation></md-input-container><md-input-container class=md-block flex-gt-sm><label>Rate</label> <input type=text ng-model=sub.Rate></md-input-container></div><div layout=row><md-input-container class=md-block flex-gt-sm><label>Status</label><md-select name=select required ng-model=sub.StatusId><md-option ng-value=status.id ng-repeat="status in statuses track by $index">{{status.status}}</md-option></md-select></md-input-container><md-input-container class=md-block flex-gt-sm><label>Interview Date</label><md-datepicker aria-required=true ng-model=sub.InterviewDate md-placeholder="Interview Date" md-hide-icons=calendar class="ml-2 mr-2" md-open-on-focus></md-datepicker></md-input-container></div><div layout=row><md-input-container class=md-block flex-gt-sm><label>Interview Mode</label><md-select name=select required ng-model=sub.ModeOfInterview><md-option ng-value=InterviewMode.id ng-repeat="InterviewMode in InterviewModes track by $index">{{InterviewMode.mode}}</md-option></md-select></md-input-container><md-input-container class=md-block flex-gt-sm></md-input-container></div><hr class="mb-4 mt-4"><div layout=row><md-input-container class=md-block flex-gt-sm><md-radio-group ng-model=sub.InterviewConfirmed layout=row class=mb-4><div flex style=max-width:200px;>Interview Confirmed</div><md-radio-button value=true class=md-primary>Yes</md-radio-button><md-radio-button value=false>No</md-radio-button></md-radio-group><!-- <md-radio-group ng-model="sub.MidVendorCalled" layout="row" class="mb-4">\n                            <div flex style="max-width:200px;">Mid Vendor Confirmed</div>\n                            <md-radio-button value="true" class="md-primary">Yes</md-radio-button>\n                            <md-radio-button value="false"> No </md-radio-button>\n                        </md-radio-group>\n                        <md-radio-group ng-model="sub.PrimeVendorCalled" layout="row">\n                            <div flex style="max-width:200px;">Prime Vendor Confirmed</div>\n                            <md-radio-button value="true" class="md-primary">Yes</md-radio-button>\n                            <md-radio-button value="false"> No </md-radio-button>\n                        </md-radio-group> --></md-input-container><md-input-container class=md-block flex-gt-sm><label>Remarks</label> <textarea ng-model=sub.Comments></textarea></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=row><md-button type=submit>Submit</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/sales/submissionDashboard/submissionDashboard.component.html','<div class=container-fluid><md-content><div class=subs><md-content><div layout=row layout-align="space-between center"><md-input-container class="md-icon-float md-block" flex><!-- Use floating label instead of placeholder --> <label>Search</label><md-icon md-svg-src=images/baseline-search-24px.svg class=name></md-icon><input ng-model=searchText type=text></md-input-container><md-button class=md-fab ui-sref="\'addSubmission()\'"><md-icon md-svg-src=images/baseline-add-24px.svg></md-icon></md-button></div><div class=bg-secondary layout=row layout-align="center center"><div class="col-1 h5 p-2 text-white">#</div><div class="col-4 h5 p-2 text-white">Name</div><div class="col-4 h5 p-2 text-white">Email</div><div class="col-3 h5 p-2 text-white">Phone</div></div><div ng-repeat="sub in vm.subs | filter:searchText"><div data-toggle=collapse ng-href=#ts{{sub.conslid}} aria-expanded=false aria-controls={{sub.conslid}} class="bg-white border-bottom pointer" layout=row layout-align="center center"><div class="col-1 p-2">{{$index+1}}</div><div class="col-4 p-2">{{sub.DisplayName}}<span class="badge badge-primary ml-2">{{sub.SubCount}}</span></div><div class="col-4 p-2">{{sub.Email}}</div><div class="col-3 p-2">{{sub.PhoneNumber}}</div></div><div class=collapse id=ts{{sub.conslid}}><div class="card card-body"><div class=table-responsive><table id=consultants class="table table-hover consultants display"><thead><tr><th class="text-left pl-0">#</th><th class="text-left pl-0">Date</th><th class="text-left pl-0">Consultant</th><th class="text-left pl-0">Technology</th><th class="text-left pl-0">Vendor Name</th><th class="text-left pl-0">Vendor Email</th><th class="text-left pl-0">Phone</th><th class="text-left pl-0">Location</th><th class="text-left pl-0">Rate</th><th class="text-left pl-0">Client</th><th class="text-left pl-0">Status</th><th class="text-left pl-0">InterviewDate</th><th class="text-left pl-0">Interview Mode</th><th class="text-left pl-0">Interview Confirmed</th><th class="text-left pl-0">MidVendorCalled</th><th class="text-left pl-0">PrimeVendorCalled</th><th class="text-left pl-0">Remarks</th></tr></thead><tbody><tr ng-repeat="sub in sub.lstsubdashboard track by $index" ng-click=EditSubDashboard(sub) class=pointer><th class=text-left>{{$index+1}}</th><td class=text-left>{{sub.SubmittedDate | moment: \'format\':\'MMM DD, YYYY\' }}</td><td class=text-left>{{sub.ConslFirstName}},{{sub.ConslLastName}}</td><td class=text-left>{{sub.SkillSet}}</td><td class=text-left>{{sub.VendorName}}</td><td class=text-left>{{sub.VendorEmail}}</td><td class=text-left>{{sub.PhoneNumber}}</td><td class=text-left>{{sub.SubLocation}}</td><td class=text-left>{{sub.Rate}}</td><td class=text-left>{{sub.Client}}</td><td class=text-left>{{sub.Status}}</td><td class=text-left><span ng-show="sub.InterviewDate === null">n/a</span> <span ng-show="sub.InterviewDate !== null">{{sub.InterviewDate | moment: \'format\':\'MMM DD, YYYY\'}}</span></td><td class=text-left>{{sub.InterviewText}}</td><td class=text-left><i class="material-icons success-btn" ng-show="sub.InterviewConfirmed === true">done</i> <i class="material-icons success-btn" ng-show="sub.InterviewConfirmed === false">close</i></td><td class=text-left><i class="material-icons success-btn" ng-show="sub.MidVendorCalled === true">done</i><i class="material-icons success-btn" ng-show="sub.MidVendorCalled === false">close</i></td><td class=text-left><i class="material-icons success-btn" ng-show="sub.PrimeVendorCalled === true">done</i><i class="material-icons success-btn" ng-show="sub.PrimeVendorCalled === false">close</i></td><td class=text-left>{{sub.Comments | limitTo: 9}}<md-tooltip md-direction=top ng-if="sub.Comments.length > 9">{{sub.Comments}}</md-tooltip></td></tr></tbody></table></div></div></div></div></md-content></div></md-content></div>');
$templateCache.put('app/components/sales/talentSearch/profileView.html','<md-dialog class="interviewDetails h-100" style="height: 100%; max-width: 90%;"><form ng-cloak class=h-100><md-dialog-content class=h-100>{{profileDetails}}</md-dialog-content><md-dialog-actions layout=column layout-align="start center" class=pb-4><div layout=row layout-align="space-between center" class=w-100><md-button ng-click=hide()>Close</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/components/sales/talentSearch/talentSearch.component.html','<div class="container-fluid p-0"><md-content><!-- <nav class="navbar navbar-expand-lg navbar-light bg-light">\r\n            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"\r\n                aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">\r\n                <span class="navbar-toggler-icon"></span>\r\n            </button>\r\n            <div class="collapse navbar-collapse align-items-start" id="navbarNavAltMarkup">\r\n                <div class="navbar-nav">\r\n                    <a class="btn btn-primary mt-2 font-weight-normal" ui-sref="internalDb()">Search Internal\r\n                        DB</a>\r\n                </div>\r\n                <div class="talentSearch">\r\n                    <div class="basicSearch">\r\n                        <form name="basicSearch" ng-submit="basicSearch.$valid && basicSearchSubmit(searchtext)"\r\n                            novalidate class="d-flex flex-no-wrap flex-row">\r\n                            <div class="w-100 basicsearch-wrap d-flex" ng-class="advSearch ? \'justify-content-end\':\'\'">\r\n                                <div class="d-flex flex-column">\r\n                                    <div class="d-flex">\r\n                                        <input class="form-control form-control-sm m-1" type="text"\r\n                                            placeholder="Keywords: (java, dotnet, php,..)" ng-model="searchtext.q"\r\n                                            ng-required="!advSearch" ng-show="!advSearch">\r\n                                        <input class="form-control form-control-sm m-1" type="text"\r\n                                            placeholder="Exp: (as 9 or [7 to 9])"\r\n                                            ng-model="searchtext.yearsOfExperience" ng-show="!advSearch"\r\n                                            style="width: 350px;">\r\n                                        <input class="form-control form-control-sm m-1" type="text" placeholder="Last active"\r\n                                            ng-model="searchtext.lastActive" ng-show="!advSearch" style="width: 90px;">\r\n                                        <input class="form-control form-control-sm m-1" type="text"\r\n                                            placeholder="Location: as (city, country)" ng-model="searchtext.location"\r\n                                            ng-show="!advSearch">\r\n                                    </div>\r\n                                </div>\r\n                                <button\r\n                                    class="btn btn-sm btn-light d-flex align-items-start rounded-0 justify-content-center"\r\n                                    type="submit" ng-show="!advSearch"\r\n                                    style="border-right: 1px solid #a0a4a8;border-left: 1px solid #a0a4a8;">Search <i\r\n                                        class="material-icons">search</i></button>\r\n                                <button class="btn btn-sm btn-light rounded-0" type="button"\r\n                                    ng-click="advSearch = !advSearch">\r\n                                    <span ng-if="advSearch">Basic Search</span>\r\n                                    <span ng-if="!advSearch">Advanced Search</span>\r\n                                </button>\r\n                            </div>\r\n                        </form>\r\n                    </div>\r\n                    <div class="advancedSearch p-2" ng-show="advSearch">\r\n\r\n                        <form name="advSearchname" ng-submit="advSearchname.$valid && advSearchSubmit(AS)"\r\n                            class="w-100">\r\n                            <h4>Advanced Search</h4>\r\n                            <hr>\r\n                            <div class="d-flex mt-1">\r\n                                <input class="form-control form-control-sm" type="text" placeholder="Keywords" ng-model="AS.q" required>\r\n                            </div>\r\n                            <div class="d-flex mt-1">\r\n                                <input class="form-control form-control-sm  required col-7" type="text"\r\n                                    placeholder="Location (city, state, zip)" ng-model="AS.location" required>\r\n                                <input class="form-control form-control-sm col-2" type="text" placeholder="" ng-model="AS.distance"\r\n                                    required>\r\n                                <select class="form-control form-control-sm col-3" name="" id="" ng-model="AS.distanceUnit" required>\r\n                                    <option value="miles">Miles</option>\r\n                                    <option value="kilometers">Kilometers</option>\r\n                                </select>\r\n                            </div>\r\n                            <div class="d-flex skillsPlaceHolder p-3 mt-1">\r\n                                <div class="addedSkill d-flex" ng-repeat="skill in addedSkill track by $index">\r\n                                    <span>{{skill}}</span>\r\n                                    <i class="material-icons" style="font-size: 16px;padding: 3px;"\r\n                                        ng-click="removeAddedSkill($index)">close</i>\r\n                                </div>\r\n                            </div>\r\n                            <div class="d-flex mt-1">\r\n                                <input class="form-control form-control-sm col-7" type="text" placeholder="Skill" ng-model="value">\r\n                                <input class="form-control form-control-sm col-3" type="text" ng-model="years" placeholder="Years exp">\r\n                                <button type="button" class="btn btn-primary col-2" ng-click="addSkill(value, years)">\r\n                                    <i class="fa fa-plus" aria-hidden="true"></i>\r\n                                    Add\r\n                                </button>\r\n                            </div>\r\n                            <div class="d-flex mt-1">\r\n                                <textarea name="" class="form-control form-control-sm mr-1" id="" cols="30" rows="2"\r\n                                    placeholder="Job Titles" ng-model="AS.jobTitle"></textarea>\r\n                                <textarea name="" class="form-control form-control-sm ml-1" id="" cols="30" rows="2"\r\n                                    placeholder="Companies" ng-model="AS.company"></textarea>\r\n                            </div>\r\n                            <div class="mt-2  mb-1" layout="row" layout-align="end center">\r\n                                <span class="asLink mt-1 mr-4" ng-click="advSearch = !advSearch">Cancel</span>\r\n                                <button class="btn btn-sm btn-dark d-flex align-items-start" type="submit">Search <i\r\n                                        class="material-icons">search</i></button>\r\n                            </div>\r\n                        </form>\r\n                    </div>\r\n                </div>\r\n                <div flex></div>\r\n                <div class="d-flex">\r\n                    <span>Dice: {{diceCount.HitsUsed}}/{{diceCount.LimitPerMonth}}</span>\r\n                </div>\r\n            </div>\r\n        </nav> --><div style="overflow: hidden;" class=container-fluid><div class=row><div class="w-100 d-flex align-items-start py-3"><button type=button class="btn btn-sm btn-primary ml-3 font-weight-normal" ui-sref=internalDb()>Internal DB</button> <button type=button class="btn btn-sm btn-danger ml-3 font-weight-normal" disabled ui-sref=talentSearch()>Search Dice</button></div><div class="col-lg-4 card pt-3 mb-5 pb-5 searchResults" style="overflow: auto;"><form name=advSearchname ng-submit="advSearchname.$valid && basicSearchSubmit(AS,workPermits,sortBy)" class=w-100><div class=input-group><input class="form-control form-control-sm rounded-0" type=text placeholder=Keywords ng-model=AS.q required></div><div class="input-group mt-1"><input class="form-control form-control-sm rounded-0 required col-6" type=text placeholder="Location (city, state, zip)" ng-model=AS.location> <input class="form-control form-control-sm col-3 rounded-0" type=text placeholder=Distance ng-model=AS.distance> <select class="form-control form-control-sm col-3 rounded-0 pr-2" name="" ng-disabled=!AS.location ng-model=AS.distanceUnit required><option value=miles selected>Miles</option><option value=kilometers>Kilometers</option></select></div><div class="d-flex skillsPlaceHolder p-0 mt-1"><div class="addedSkill d-flex" ng-repeat="skill in addedSkill track by $index"><span>{{ skill }}</span> <i class=material-icons style="font-size: 16px;padding: 3px;" ng-click=removeAddedSkill($index)>close</i></div></div><div class=input-group><input class="form-control form-control-sm col-7 rounded-0" type=text placeholder=Skills ng-model=value> <input class="form-control form-control-sm col-4 rounded-0" type=text ng-model=years placeholder="Years exp"> <button type=button class="btn btn-success col-1 p-0 rounded-0" ng-click="addSkill(value, years)"><i class="fa fa-plus" aria-hidden=true></i></button></div><div class="d-flex mt-1"><textarea name="" class="form-control form-control-sm mr-1" cols=30 rows=2 placeholder="Job Titles" ng-model=AS.jobTitleKeyword></textarea> <textarea name="" class="form-control form-control-sm ml-1" cols=30 rows=2 placeholder=Companies ng-model=AS.companyKeyword></textarea></div><h4 class="text-primary font-weight-bold">Filters:</h4><div class=input-group><input class="form-control form-control-sm rounded-0" type=text placeholder="last Active" ng-model=AS.dateLastActive><div class=input-group-append><span class="input-group-text pt-0 pb-0 pl-5 pr-5" id=basic-addon2>Days</span></div></div><h5>Work Permits:</h5><div class="d-flex flex-column customCb ml-5"><div class="form-check mb-2"><input class=form-check-input type=checkbox ng-value=USCitizenship id=defaultCheck1 ng-model=workPermits[0].USCitizenship> <label class=form-check-label for=defaultCheck1>US Citizenship</label></div><div class="form-check mb-2"><input class=form-check-input type=checkbox ng-value=EmploymentAuthDocument id=defaultCheck2 ng-model=workPermits[1].EmploymentAuthDocument> <label class=form-check-label for=defaultCheck2>Employment Auth Document</label></div><div class="form-check mb-2"><input class=form-check-input type=checkbox ng-value=GreenCard id=defaultCheck3 ng-model=workPermits[2].GreenCard> <label class=form-check-label for=defaultCheck3>Green Card</label></div><div class="form-check mb-2"><input class=form-check-input type=checkbox ng-value=HaveH1 id=defaultCheck4 ng-model=workPermits[3].HaveH1> <label class=form-check-label for=defaultCheck4>Have H1</label></div><div class="form-check mb-2"><input class=form-check-input type=checkbox ng-value=NeedH1 id=defaultCheck5 ng-model=workPermits[4].NeedH1> <label class=form-check-label for=defaultCheck5>Need H1</label></div><div class="form-check mb-2"><input class=form-check-input type=checkbox ng-value=TnPermitHolder id=defaultCheck6 ng-model=workPermits[5].TnPermitHolder> <label class=form-check-label for=defaultCheck6>Tn Permit Holder</label></div></div><h5 class=pt-4>Willing To Relocate:</h5><div class="d-flex flex-column customCb ml-5"><div class=form-check><input class=form-check-input type=checkbox value=true id=defaultCheck7 ng-model=AS.willingToRelocate> <label class=form-check-label for=defaultCheck7>Willing To Relocate Anywhere</label></div><!-- <div class="form-check">\r\n                                <input class="form-check-input" type="checkbox" value="WillingToRelocate"\r\n                                    id="defaultCheck8" ng-model="AS.WillingToRelocateToSpecifiedLocations">\r\n                                <label class="form-check-label" for="defaultCheck8">\r\n                                    Willing To Relocate To Specified Location(s)\r\n                                </label>\r\n                            </div> --></div><h5 class=pt-4>Sort By:</h5><div class="d-flex flex-column customCb ml-5"><div class="form-check mb-2"><input class=form-check-input type=radio value=relevancy id=defaultCheck7 ng-model=sortBy> <label class=form-check-label for=defaultCheck7>Relevancy</label></div><div class="form-check mb-2"><input class=form-check-input type=radio value=activityDate id=defaultCheck8 ng-model=sortBy> <label class=form-check-label for=defaultCheck8>Activity Date</label></div><div class=form-check><input class=form-check-input type=radio value=dateResumeLastUpdated id=defaultCheck9 ng-model=sortBy> <label class=form-check-label for=defaultCheck9>Date Resume Last Updated</label></div></div><div class="mt-2 mb-1" layout=row layout-align="end center"><!-- <div class="d-flex justify-content-center mr-2">\r\n                                <input type="checkbox" name="newonly" id="newonly" class="mt-2" ng-model="newonly">\r\n                                <label for="newonly" class="ml-1 pt-2">Without Pulled</label>\r\n                            </div> --> <button class="btn btn-sm btn-dark d-flex align-items-start" type=submit>Search <i class=material-icons style="font-size: 16px;padding-top: 3px;padding-left: 4px;">search</i></button></div></form></div><div class="col-lg-8 searchResults" ng-show="profileData.length>0" style="overflow: auto;"><md-content style="padding-top: 0px;padding-bottom: 60px;" class=profilesList><div class="pDWrap d-flex flex-column" ng-repeat="profile in profileData track by $index" ng-class="profile.isPulled ? \'inDb\':\'\'"><div class="col p-2 d-flex justify-content-between border-bottom"><div class=d-flex><h4 class="text-primary mb-0 mr-4">{{ profile.fullName }}</h4><span class=mt-1>{{profile.experience.history[0].title}}</span></div><div class=d-flex><ul class="p-0 m-0 d-flex"><li ng-repeat="socialProfile in profile.socialProfiles"><img ng-src={{socialProfile.icon_64}} style="height: 24px;"></li></ul></div></div><div class="col p-1 d-flex flex-wrap mt-3"><div class=avatar><img src=../../images/fb_pImg.png class=mr-1 ng-if="profile.imageUrl === undefined" alt="" style="height: 54px;"> <img ng-src="{{ profile.imageUrl }}" class=mr-1 ng-if="profile.imageUrl !== undefined" alt="" style="height: 54px;"></div><div class="d-flex flex-column"><div class=d-flex><div class="mt-1 mb-0"><i class="fa fa-briefcase" aria-hidden=true></i> <span class=text-primary>Prefer:</span> {{ profile.desiredJobTitles[0] }}</div><div class="py-1 ml-2"><span class=text-primary>Likely To Move: </span><i class="fa fa-map-signs"></i>{{ profile.likelyToMove ? "Yes" : "No"}}<progress value="{{ profile.likelyToMoveScore }}" max=100 style="width: 38px;margin: 1px 10px;"></progress></div></div><div class="d-flex flex-wrap"><div class="py-1 col-lg-3 col-md-4 col-sm-6"><span class=text-primary>Location: </span><i class="fa fa-map-marker"></i>{{ profile.locations[0].text }}</div><div class="py-1 col-lg-3 col-md-4 col-sm-6"><span class=text-primary>Experience: </span><i class="fa fa-file-code-o"></i>{{profile.yearsOfExperience === undefined? 0: profile.yearsOfExperience}} /yrs</div><div class="py-1 col-lg-3 col-md-4 col-sm-6"><span class=text-primary>Work Permit: </span><i class="fa fa-cc-visa"></i>{{ profile.workPermitDocuments[0] }}</div><div class="py-1 col-lg-3 col-md-4 col-sm-6"><span class=text-primary>Last Active: </span><i class="fa fa-calendar"></i>{{profile.dateLastActive | moment: "format":"MMM DD, YYYY"}}</div><div class="py-1 col-lg-3 col-md-4 col-sm-6"><span class=text-primary>Resume Last Updated: </span><i class="fa fa-file"></i>{{profile.dateResumeLastUpdated | moment: "format":"MMM DD, YYYY"}}</div><div class="py-1 col-lg-3 col-md-4 col-sm-6"><span class=text-primary>Salary: </span><i class="fa fa-usd"></i>{{ profile.workPreferences[0].annualSalary.min }}/Yr</div></div></div></div><div class="col p-0 text-center"><button class="btn btn-outline-info btn-sm pt-0 pb-0 pl-5 pr-5" type=button data-toggle=collapse data-target=#collapse{{profile.id}} aria-expanded=false aria-controls=collapse{{profile.id}}>View Skills</button><div class=collapse id=collapse{{profile.id}}><div class="skillsWrap col-sm-12 d-flex flex-wrap text-left"><div class="col-sm-3 col-md-4 col-lg-3 pl-1 pr-1 pb-1 pt-0" ng-repeat="skill in profile.skills track by $index"><div class="skill d-flex justify-content-between"><md-truncate flex>{{ skill.skill }}</md-truncate><div>{{ skill.yearsUsed }} yrs {{ skill.lastUsed }}</div></div></div></div></div></div><div class=profileActions><button class="btn-sm btn btn-primary m-0" ng-click="pullDiceProf(profile.id, $index)" ng-if=!profile.isPulled>Pull</button> <button type=button ng-if=profile.isPulled class="btn btn-sm btn-primary" data-toggle=modal ng-click=GetConslByDiceId(profile) data-target=#exampleModal>View</button><!-- <button class="btn-sm btn btn-success m-0"\r\n                                    ng-click="downloadDiceProf(profile.id)" ng-if="isExist">\r\n                                    <i class="fa fa-download"></i>\r\n                                </button> --></div></div></md-content><div class=dicePagination><ul class="m-0 p-0 d-flex"><li ng-repeat="page in [].constructor(pages) | limitTo : 45 track by $index" ng-click="basicSearchSubmit(null,null,null, $index+1)">{{ $index + 1 }}</li></ul></div></div></div></div></md-content><div id=profileDataContainerWrap><div class=backdrop><i class=material-icons>close</i></div><div class=profileDataContainer><div class="profileHeader bg-dark d-flex p-2"><h4 class=text-white>{{ profileDetails.firstName }} {{ profileDetails.lastName }}</h4><div flex></div><div><i class="material-icons text-white pointer" ng-click=downloadResume()>cloud_download</i></div></div><div class="profileSynopsis d-flex flex-wrap"><div class=col-sm-4><div class=d-flex><div>Email:</div><div class="d-flex flex-row"><span ng-repeat="email in profileDetails.email track by $index">{{ email }}</span></div></div></div><div class=col-sm-4>Phone: {{ profileDetails.Phone[0] }}</div><div class=col-sm-4>Current Company: {{ profileDetails.currentCompany }}</div><div class=col-sm-4>Current Title: {{ profileDetails.currentJobTitle }}</div><div class=col-sm-4>Experience: {{ profileDetails.yearsOfExperience }}</div></div><div class=profileResumeContainer><div class=resume ng-bind-html=profileDetails.resume.resumeHtml></div></div></div></div><!-- Modal --><div class="modal fade" id=exampleModal tabindex=-1 role=dialog aria-labelledby=exampleModalLabel aria-hidden=true><div class=modal-dialog role=document><div class=modal-content><div class=modal-header><h5 class=modal-title id=exampleModalLabel>{{profileDataViewed.fullName}}</h5><span>Fetched on: <b>{{profileDetails.CreateDate}}</b></span> <button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button></div><div class=modal-body><div class="d-flex justify-content-between pb-3 border-bottom"><h4>Download Profile</h4><button type=button class="btn btn-primary btn-sm" ng-click=DownloadViewedProfile(profileDetails)>Download Resume</button></div><div class="d-flex flex-wrap"><div class=col-6><h4 class=text-primary>Contact Details</h4><dl><dt>Email</dt><dd>{{profileDetails.Email[0]}}</dd><dd>{{profileDetails.Email[1]}}</dd><dt>Phone</dt><dd>{{profileDetails.PhoneNumber[0]}}</dd><dd>{{profileDetails.PhoneNumber[1]}}</dd><dt>Current Location</dt><dd>{{profileDetails.CurrentLocation[0].text}}</dd><dd><a ng-href="http://maps.google.com/maps?q={{profileDetails.CurrentLocation[0].latitude}},{{profileDetails.CurrentLocation[0].longitude}}" target=_blank>See on google maps</a></dd></dl></div><div class=col-6><h4 class=text-primary>Work Details</h4><dl><dt>Current Company</dt><dd>{{profileDetails.CurrentCompany}}</dd><dt>Work Permit</dt><dd>{{profileDetails.WorkPermit[0]}}</dd><dt>Work Preferences</dt><dd ng-repeat="wp in profileDetails.WorkPreferences[0].employmentType">{{wp}}</dd><dt>Prefer Location</dt><dd>{{profileDetails.PrefLocation[0].text}}</dd></dl></div><div class=col-6><h4 class=text-primary>Experience Details</h4><dl><dt>Current Company</dt><dd>Title: {{profileDetails.Experience.current.title}}</dd><dd>Organisation: {{profileDetails.Experience.current.org}}</dd><dd>Location: {{profileDetails.Experience.current.location}}</dd></dl></div></div></div><div class=modal-footer><button type=button class="btn btn-secondary" data-dismiss=modal>Close</button></div></div></div></div></div><prevent-actionloader ng-if=!topLoader></prevent-actionloader>');}]);